webpackJsonp([35783957827783],{

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ v1.2.4 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	function bisector(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	}
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	function pairs(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	}
	
	function pair(a, b) {
	  return [a, b];
	}
	
	function cross(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function number(x) {
	  return x === null ? NaN : +x;
	}
	
	function variance(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	}
	
	function deviation(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	}
	
	function extent(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	}
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function identity(x) {
	  return x;
	}
	
	function range(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	}
	
	var e10 = Math.sqrt(50),
	    e5 = Math.sqrt(10),
	    e2 = Math.sqrt(2);
	
	function ticks(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	}
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	function sturges(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	}
	
	function histogram() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	}
	
	function quantile(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	}
	
	function freedmanDiaconis(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	}
	
	function scott(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	}
	
	function max(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	}
	
	function mean(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	}
	
	function median(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	}
	
	function merge(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	}
	
	function min(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	}
	
	function permute(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	}
	
	function scan(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	}
	
	function shuffle(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	}
	
	function sum(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	}
	
	function transpose(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	}
	
	function length(d) {
	  return d.length;
	}
	
	function zip() {
	  return transpose(arguments);
	}
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ v1.0.7 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	function nest() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	}
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	function keys(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	}
	
	function values(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	}
	
	function entries(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	}
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ v1.2.3 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function define(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	}
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*",
	    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
	    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
	    reHex3 = /^#([0-9a-f]{3})$/,
	    reHex6 = /^#([0-9a-f]{6})$/,
	    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
	    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
	    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
	    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
	    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
	    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: function() {
	    return this.rgb().hex();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: function() {
	    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://beta.observablehq.com/@mbostock/lab-and-rgb
	var K = 18,
	    Xn = 0.96422,
	    Yn = 1,
	    Zn = 0.82521,
	    t0 = 4 / 29,
	    t1 = 6 / 29,
	    t2 = 3 * t1 * t1,
	    t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861,
	    B = +1.78277,
	    C = -0.29227,
	    D = -0.90649,
	    E = +1.97294,
	    ED = E * D,
	    EB = E * B,
	    BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.lch = lch;
	exports.gray = gray;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ v1.3.2 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	function formatDecimal(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	}
	
	function exponent(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	}
	
	function formatGroup(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	}
	
	function formatNumerals(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	}
	
	// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
	var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	  var match;
	  this.fill = match[1] || " ";
	  this.align = match[2] || ">";
	  this.sign = match[3] || "-";
	  this.symbol = match[4] || "";
	  this.zero = !!match[5];
	  this.width = match[6] && +match[6];
	  this.comma = !!match[7];
	  this.precision = match[8] && +match[8].slice(1);
	  this.trim = !!match[9];
	  this.type = match[10] || "";
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + (this.trim ? "~" : "")
	      + this.type;
	};
	
	// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
	function formatTrim(s) {
	  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (s[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      default: if (i0 > 0) { if (!+s[i]) break out; i0 = 0; } break;
	    }
	  }
	  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
	}
	
	var prefixExponent;
	
	function formatPrefixAuto(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	}
	
	function formatRounded(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	}
	
	var formatTypes = {
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	function identity(x) {
	  return x;
	}
	
	var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	function formatLocale(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        trim = specifier.trim,
	        type = specifier.type;
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // The "" type, and any invalid type, is an alias for ".12~g".
	    else if (!formatTypes[type]) precision == null && (precision = 12), trim = true, type = "g";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? 6
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // Trim insignificant zeros.
	        if (trim) value = formatTrim(value);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	}
	
	var locale;
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	function precisionFixed(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	}
	
	function precisionPrefix(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	}
	
	function precisionRound(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	}
	
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ v1.3.2 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(693)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	function basis$1(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function basisClosed(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb = (function rgbGamma(y) {
	  var color = gamma(y);
	
	  function rgb(start, end) {
	    var r = color((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color(start.g, end.g),
	        b = color(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb.gamma = rgbGamma;
	
	  return rgb;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color;
	    for (i = 0; i < n; ++i) {
	      color = d3Color.rgb(colors[i]);
	      r[i] = color.r || 0;
	      g[i] = color.g || 0;
	      b[i] = color.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color.opacity = 1;
	    return function(t) {
	      color.r = r(t);
	      color.g = g(t);
	      color.b = b(t);
	      return color + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	function array(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	}
	
	function date(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	}
	
	function number(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	}
	
	function object(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	}
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
	    reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	function string(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	}
	
	function value(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
	      : b instanceof d3Color.color ? rgb
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	}
	
	function discrete(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	function hue$1(a, b) {
	  var i = hue(+a, +b);
	  return function(t) {
	    var x = i(t);
	    return x - 360 * Math.floor(x / 360);
	  };
	}
	
	function round(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	}
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	function decompose(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	}
	
	var cssNode,
	    cssRoot,
	    cssView,
	    svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2,
	    rho2 = 2,
	    rho4 = 4,
	    epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	function zoom(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	}
	
	function hsl(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$1 = hsl(hue);
	var hslLong = hsl(nogamma);
	
	function lab(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$1 = hcl(hue);
	var hclLong = hcl(nogamma);
	
	function cubehelix(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix.gamma = cubehelixGamma;
	
	    return cubehelix;
	  })(1);
	}
	
	var cubehelix$1 = cubehelix(hue);
	var cubehelixLong = cubehelix(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	function quantize(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	}
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateDiscrete = discrete;
	exports.interpolateHue = hue$1;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$1;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab;
	exports.interpolateHcl = hcl$1;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$1;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ v1.0.7 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var pi = Math.PI,
	    tau = 2 * pi,
	    epsilon = 1e-6,
	    tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon));
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ v2.2.2 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(692), __webpack_require__(691), __webpack_require__(695), __webpack_require__(694), __webpack_require__(363), __webpack_require__(699)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-collection', 'd3-array', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Collection,d3Array,d3Interpolate,d3Format,d3Time,d3TimeFormat) { 'use strict';
	
	function initRange(domain, range) {
	  switch (arguments.length) {
	    case 0: break;
	    case 1: this.range(domain); break;
	    default: this.range(range).domain(domain); break;
	  }
	  return this;
	}
	
	function initInterpolator(domain, interpolator) {
	  switch (arguments.length) {
	    case 0: break;
	    case 1: this.interpolator(domain); break;
	    default: this.interpolator(interpolator).domain(domain); break;
	  }
	  return this;
	}
	
	var array = Array.prototype;
	
	var map = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal() {
	  var index = d3Collection.map(),
	      domain = [],
	      range = [],
	      unknown = implicit;
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range[(i - 1) % range.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), scale) : range.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal(domain, range).unknown(unknown);
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range[1] < range[0],
	        start = range[reverse - 0],
	        stop = range[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band(domain(), range)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return initRange.apply(rescale(), arguments);
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band.apply(null, arguments).paddingInner(1));
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function number(x) {
	  return +x;
	}
	
	var unit = [0, 1];
	
	function identity(x) {
	  return x;
	}
	
	function normalize(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(isNaN(b) ? NaN : 0.5);
	}
	
	function clamper(domain) {
	  var a = domain[0], b = domain[domain.length - 1], t;
	  if (a > b) t = a, a = b, b = t;
	  return function(x) { return Math.max(a, Math.min(b, x)); };
	}
	
	// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
	function bimap(domain, range, interpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
	  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
	  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range, interpolate) {
	  var j = Math.min(domain.length, range.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range = range.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = normalize(domain[i], domain[i + 1]);
	    r[i] = interpolate(range[i], range[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp())
	      .unknown(source.unknown());
	}
	
	function transformer() {
	  var domain = unit,
	      range = unit,
	      interpolate = d3Interpolate.interpolate,
	      transform,
	      untransform,
	      unknown,
	      clamp = identity,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
	  }
	
	  scale.invert = function(y) {
	    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), d3Interpolate.interpolateNumber)))(y)));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map.call(_, number), clamp === identity || (clamp = clamper(domain)), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range = slice.call(_), interpolate = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = _ ? clamper(domain) : identity, scale) : clamp !== identity;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate = _, rescale()) : interpolate;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t, u) {
	    transform = t, untransform = u;
	    return rescale();
	  };
	}
	
	function continuous(transform, untransform) {
	  return transformer()(transform, untransform);
	}
	
	function tickFormat(start, stop, count, specifier) {
	  var step = d3Array.tickStep(start, stop, count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	}
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    var d = domain();
	    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(identity, identity);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return linearish(scale);
	}
	
	function identity$1(domain) {
	  var unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map.call(_, number), scale) : domain.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return identity$1(domain).unknown(unknown);
	  };
	
	  domain = arguments.length ? map.call(domain, number) : [0, 1];
	
	  return linearish(scale);
	}
	
	function nice(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	}
	
	function transformLog(x) {
	  return Math.log(x);
	}
	
	function transformExp(x) {
	  return Math.exp(x);
	}
	
	function transformLogn(x) {
	  return -Math.log(-x);
	}
	
	function transformExpn(x) {
	  return -Math.exp(-x);
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function loggish(transform) {
	  var scale = transform(transformLog, transformExp),
	      domain = scale.domain,
	      base = 10,
	      logs,
	      pows;
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) {
	      logs = reflect(logs), pows = reflect(pows);
	      transform(transformLogn, transformExpn);
	    } else {
	      transform(transformLog, transformExp);
	    }
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  return scale;
	}
	
	function log() {
	  var scale = loggish(transformer()).domain([1, 10]);
	
	  scale.copy = function() {
	    return copy(scale, log()).base(scale.base());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function transformSymlog(c) {
	  return function(x) {
	    return Math.sign(x) * Math.log1p(Math.abs(x / c));
	  };
	}
	
	function transformSymexp(c) {
	  return function(x) {
	    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
	  };
	}
	
	function symlogish(transform) {
	  var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
	
	  scale.constant = function(_) {
	    return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
	  };
	
	  return linearish(scale);
	}
	
	function symlog() {
	  var scale = symlogish(transformer());
	
	  scale.copy = function() {
	    return copy(scale, symlog()).constant(scale.constant());
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	function transformPow(exponent) {
	  return function(x) {
	    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	  };
	}
	
	function transformSqrt(x) {
	  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
	}
	
	function transformSquare(x) {
	  return x < 0 ? -x * x : x * x;
	}
	
	function powish(transform) {
	  var scale = transform(identity, identity),
	      exponent = 1;
	
	  function rescale() {
	    return exponent === 1 ? transform(identity, identity)
	        : exponent === 0.5 ? transform(transformSqrt, transformSquare)
	        : transform(transformPow(exponent), transformPow(1 / exponent));
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, rescale()) : exponent;
	  };
	
	  return linearish(scale);
	}
	
	function pow() {
	  var scale = powish(transformer());
	
	  scale.copy = function() {
	    return copy(scale, pow()).exponent(scale.exponent());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function sqrt() {
	  return pow.apply(null, arguments).exponent(0.5);
	}
	
	function quantile() {
	  var domain = [],
	      range = [],
	      thresholds = [],
	      unknown;
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : range[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile()
	        .domain(domain)
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range = [0, 1],
	      unknown;
	
	  function scale(x) {
	    return x <= x ? range[d3Array.bisect(domain, x, 0, n)] : unknown;
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range = slice.call(_)).length - 1, rescale()) : range.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : scale;
	  };
	
	  scale.thresholds = function() {
	    return domain.slice();
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(linearish(scale), arguments);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range = [0, 1],
	      unknown,
	      n = 1;
	
	  function scale(x) {
	    return x <= x ? range[d3Array.bisect(domain, x, 0, n)] : unknown;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	var durationSecond = 1000,
	    durationMinute = durationSecond * 60,
	    durationHour = durationMinute * 60,
	    durationDay = durationHour * 24,
	    durationWeek = durationDay * 7,
	    durationMonth = durationDay * 30,
	    durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
	  var scale = continuous(identity, identity),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format(".%L"),
	      formatSecond = format(":%S"),
	      formatMinute = format("%I:%M"),
	      formatHour = format("%I %p"),
	      formatDay = format("%a %d"),
	      formatWeek = format("%b %d"),
	      formatMonth = format("%B"),
	      formatYear = format("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = Math.max(d3Array.tickStep(start, stop, interval), 1);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
	  };
	
	  return scale;
	}
	
	function time() {
	  return initRange.apply(calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
	}
	
	function utcTime() {
	  return initRange.apply(calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]), arguments);
	}
	
	function transformer$1() {
	  var x0 = 0,
	      x1 = 1,
	      t0,
	      t1,
	      k10,
	      transform,
	      interpolator = identity,
	      clamp = false,
	      unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t) {
	    transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
	    return scale;
	  };
	}
	
	function copy$1(source, target) {
	  return target
	      .domain(source.domain())
	      .interpolator(source.interpolator())
	      .clamp(source.clamp())
	      .unknown(source.unknown());
	}
	
	function sequential() {
	  var scale = linearish(transformer$1()(identity));
	
	  scale.copy = function() {
	    return copy$1(scale, sequential());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialLog() {
	  var scale = loggish(transformer$1()).domain([1, 10]);
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialLog()).base(scale.base());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialSymlog() {
	  var scale = symlogish(transformer$1());
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialSymlog()).constant(scale.constant());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialPow() {
	  var scale = powish(transformer$1());
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialPow()).exponent(scale.exponent());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialSqrt() {
	  return sequentialPow.apply(null, arguments).exponent(0.5);
	}
	
	function sequentialQuantile() {
	  var domain = [],
	      interpolator = identity;
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return interpolator((d3Array.bisect(domain, x) - 1) / (domain.length - 1));
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return scale;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequentialQuantile(interpolator).domain(domain);
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function transformer$2() {
	  var x0 = 0,
	      x1 = 0.5,
	      x2 = 1,
	      t0,
	      t1,
	      t2,
	      k10,
	      k21,
	      interpolator = identity,
	      transform,
	      clamp = false,
	      unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (x < t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), t2 = transform(x2 = +_[2]), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), scale) : [x0, x1, x2];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t) {
	    transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1);
	    return scale;
	  };
	}
	
	function diverging() {
	  var scale = linearish(transformer$2()(identity));
	
	  scale.copy = function() {
	    return copy$1(scale, diverging());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingLog() {
	  var scale = loggish(transformer$2()).domain([0.1, 1, 10]);
	
	  scale.copy = function() {
	    return copy$1(scale, divergingLog()).base(scale.base());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingSymlog() {
	  var scale = symlogish(transformer$2());
	
	  scale.copy = function() {
	    return copy$1(scale, divergingSymlog()).constant(scale.constant());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingPow() {
	  var scale = powish(transformer$2());
	
	  scale.copy = function() {
	    return copy$1(scale, divergingPow()).exponent(scale.exponent());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingSqrt() {
	  return divergingPow.apply(null, arguments).exponent(0.5);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity$1;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleSymlog = symlog;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.scaleSequential = sequential;
	exports.scaleSequentialLog = sequentialLog;
	exports.scaleSequentialPow = sequentialPow;
	exports.scaleSequentialSqrt = sequentialSqrt;
	exports.scaleSequentialSymlog = sequentialSymlog;
	exports.scaleSequentialQuantile = sequentialQuantile;
	exports.scaleDiverging = diverging;
	exports.scaleDivergingLog = divergingLog;
	exports.scaleDivergingPow = divergingPow;
	exports.scaleDivergingSqrt = divergingSqrt;
	exports.scaleDivergingSymlog = divergingSymlog;
	exports.tickFormat = tickFormat;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ v1.3.4 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(696)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	function constant(x) {
	  return function constant() {
	    return x;
	  };
	}
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = y32 * x10 - x32 * y10;
	  if (t * t < epsilon) return;
	  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	function arc() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00),
	            oc;
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
	          var ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	}
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	function curveLinear(context) {
	  return new Linear(context);
	}
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	function line() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	}
	
	function area() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function identity(d) {
	  return d;
	}
	
	function pie() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	}
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	function lineRadial$1() {
	  return lineRadial(line().curve(curveRadialLinear));
	}
	
	function areaRadial() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	}
	
	function pointRadial(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	}
	
	var slice = Array.prototype.slice;
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$$1 = x,
	      y$$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$$1.apply(this, (argv[0] = s, argv)), +y$$1.apply(this, argv), +x$$1.apply(this, (argv[0] = t, argv)), +y$$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), link) : x$$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), link) : y$$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = pointRadial(x0, y0),
	      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
	      p2 = pointRadial(x1, y0),
	      p3 = pointRadial(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3),
	    tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810,
	    kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10),
	    kx = Math.sin(tau / 10) * kr,
	    ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5,
	    s = Math.sqrt(3) / 2,
	    k = 1 / Math.sqrt(12),
	    a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	function symbol() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	}
	
	function noop() {}
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basis(context) {
	  return new Basis(context);
	}
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisClosed(context) {
	  return new BasisClosed(context);
	}
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisOpen(context) {
	  return new BasisOpen(context);
	}
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal$$1(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal$$1.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal$$1;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal$$1(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal$$1.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal$$1;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom$$1(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom$$1.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom$$1;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom$$1(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom$$1.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom$$1;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	function linearClosed(context) {
	  return new LinearClosed(context);
	}
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	function natural(context) {
	  return new Natural(context);
	}
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	function step(context) {
	  return new Step(context, 0.5);
	}
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	function none(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	}
	
	function none$1(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	}
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	function stack() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	}
	
	function expand(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	}
	
	function diverging(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = yp;
	      }
	    }
	  }
	}
	
	function silhouette(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	}
	
	function wiggle(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	}
	
	function appearance(series) {
	  var peaks = series.map(peak);
	  return none$1(series).sort(function(a, b) { return peaks[a] - peaks[b]; });
	}
	
	function peak(series) {
	  var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
	  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
	  return j;
	}
	
	function ascending(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	}
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	function descending$1(series) {
	  return ascending(series).reverse();
	}
	
	function insideOut(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = appearance(series),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	}
	
	function reverse(series) {
	  return none$1(series).reverse();
	}
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.areaRadial = areaRadial;
	exports.radialArea = areaRadial;
	exports.lineRadial = lineRadial$1;
	exports.radialLine = lineRadial$1;
	exports.pointRadial = pointRadial;
	exports.linkHorizontal = linkHorizontal;
	exports.linkVertical = linkVertical;
	exports.linkRadial = linkRadial;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAppearance = appearance;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ v2.1.3 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(363)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newYear(d.y)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = newDate(newYear(d.y)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"},
	    numberRe = /^\s*\d+/, // note: ignores next directive
	    percentRe = /^%/,
	    requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekNumberISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ v1.0.10 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date,
	    t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(105);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(127);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(126);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(213);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(212);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	    parse: __webpack_require__(84),
	    stringify: __webpack_require__(85)
	};


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	var attrRE = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g;
	var voidElements = __webpack_require__(101);
	
	module.exports = function (tag) {
	    var i = 0;
	    var key;
	    var expectingValueAfterEquals = true;
	    var res = {
	        type: 'tag',
	        name: '',
	        voidElement: false,
	        attrs: {},
	        children: []
	    };
	
	    tag.replace(attrRE, function (match) {
	        if (match === '=') {
	            expectingValueAfterEquals = true;
	            i++;
	            return;
	        }
	
	        if (!expectingValueAfterEquals) {
	            if (key) {
	                res.attrs[key] = key; // boolean attribute
	            }
	            key=match;
	        } else {
	            if (i === 0) {
	                if (voidElements[match] || tag.charAt(tag.length - 2) === '/') {
	                    res.voidElement = true;
	                }
	                res.name = match;
	            } else {
	                res.attrs[key] = match.replace(/^['"]|['"]$/g, '');
	                key=undefined;
	            }
	        }
	        i++;
	        expectingValueAfterEquals = false;
	    });
	
	    return res;
	};


/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	/*jshint -W030 */
	var tagRE = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>)/g;
	var parseTag = __webpack_require__(83);
	// re-used obj for quick lookups of components
	var empty = Object.create ? Object.create(null) : {};
	// common logic for pushing a child node onto a list
	function pushTextNode(list, html, level, start, ignoreWhitespace) {
	    // calculate correct end of the content slice in case there's
	    // no tag after the text node.
	    var end = html.indexOf('<', start);
	    var content = html.slice(start, end === -1 ? undefined : end);
	    // if a node is nothing but whitespace, collapse it as the spec states:
	    // https://www.w3.org/TR/html4/struct/text.html#h-9.1
	    if (/^\s*$/.test(content)) {
	        content = ' ';
	    }
	    // don't add whitespace-only text nodes if they would be trailing text nodes
	    // or if they would be leading whitespace-only text nodes:
	    //  * end > -1 indicates this is not a trailing text node
	    //  * leading node is when level is -1 and list has length 0
	    if ((!ignoreWhitespace && end > -1 && level + list.length >= 0) || content !== ' ') {
	        list.push({
	            type: 'text',
	            content: content
	        });
	    }
	}
	
	module.exports = function parse(html, options) {
	    options || (options = {});
	    options.components || (options.components = empty);
	    var result = [];
	    var current;
	    var level = -1;
	    var arr = [];
	    var byTag = {};
	    var inComponent = false;
	
	    html.replace(tagRE, function (tag, index) {
	        if (inComponent) {
	            if (tag !== ('</' + current.name + '>')) {
	                return;
	            } else {
	                inComponent = false;
	            }
	        }
	
	        var isOpen = tag.charAt(1) !== '/';
	        var isComment = tag.indexOf('<!--') === 0;
	        var start = index + tag.length;
	        var nextChar = html.charAt(start);
	        var parent;
	
	        if (isOpen && !isComment) {
	            level++;
	
	            current = parseTag(tag);
	            if (current.type === 'tag' && options.components[current.name]) {
	                current.type = 'component';
	                inComponent = true;
	            }
	
	            if (!current.voidElement && !inComponent && nextChar && nextChar !== '<') {
	                pushTextNode(current.children, html, level, start, options.ignoreWhitespace);
	            }
	
	            byTag[current.tagName] = current;
	
	            // if we're at root, push new base node
	            if (level === 0) {
	                result.push(current);
	            }
	
	            parent = arr[level - 1];
	
	            if (parent) {
	                parent.children.push(current);
	            }
	
	            arr[level] = current;
	        }
	
	        if (isComment || !isOpen || current.voidElement) {
	            if (!isComment) {
	                level--;
	            }
	            if (!inComponent && nextChar !== '<' && nextChar) {
	                // trailing text node
	                // if we're at the root, push a base text node. otherwise add as
	                // a child to the current node.
	                parent = level === -1 ? result : arr[level].children;
	                pushTextNode(parent, html, level, start, options.ignoreWhitespace);
	            }
	        }
	    });
	
	    // If the "html" passed isn't actually html, add it as a text node.
	    if (!result.length && html.length) {
	        pushTextNode(result, html, 0, 0, options.ignoreWhitespace);
	    }
	
	    return result;
	};


/***/ }),

/***/ 85:
/***/ (function(module, exports) {

	function attrString(attrs) {
	    var buff = [];
	    for (var key in attrs) {
	        buff.push(key + '="' + attrs[key] + '"');
	    }
	    if (!buff.length) {
	        return '';
	    }
	    return ' ' + buff.join(' ');
	}
	
	function stringify(buff, doc) {
	    switch (doc.type) {
	    case 'text':
	        return buff + doc.content;
	    case 'tag':
	        buff += '<' + doc.name + (doc.attrs ? attrString(doc.attrs) : '') + (doc.voidElement ? '/>' : '>');
	        if (doc.voidElement) {
	            return buff;
	        }
	        return buff + doc.children.reduce(stringify, '') + '</' + doc.name + '>';
	    }
	}
	
	module.exports = function (doc) {
	    return doc.reduce(function (token, rootEl) {
	        return token + stringify('', rootEl);
	    }, '');
	};


/***/ }),

/***/ 257:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var cookie = {
	  create: function create(name, value, minutes, domain) {
	    var expires = void 0;
	    if (minutes) {
	      var date = new Date();
	      date.setTime(date.getTime() + minutes * 60 * 1000);
	      expires = '; expires=' + date.toGMTString();
	    } else expires = '';
	    domain = domain ? 'domain=' + domain + ';' : '';
	    document.cookie = name + '=' + value + expires + ';' + domain + 'path=/';
	  },
	
	  read: function read(name) {
	    var nameEQ = name + '=';
	    var ca = document.cookie.split(';');
	    for (var i = 0; i < ca.length; i++) {
	      var c = ca[i];
	      while (c.charAt(0) === ' ') {
	        c = c.substring(1, c.length);
	      }if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	    }
	    return null;
	  },
	
	  remove: function remove(name) {
	    this.create(name, '', -1);
	  }
	};
	
	exports.default = {
	  name: 'cookie',
	
	  lookup: function lookup(options) {
	    var found = void 0;
	
	    if (options.lookupCookie && typeof document !== 'undefined') {
	      var c = cookie.read(options.lookupCookie);
	      if (c) found = c;
	    }
	
	    return found;
	  },
	  cacheUserLanguage: function cacheUserLanguage(lng, options) {
	    if (options.lookupCookie && typeof document !== 'undefined') {
	      cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain);
	    }
	  }
	};

/***/ }),

/***/ 258:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'htmlTag',
	
	  lookup: function lookup(options) {
	    var found = void 0;
	    var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
	
	    if (htmlTag && typeof htmlTag.getAttribute === 'function') {
	      found = htmlTag.getAttribute('lang');
	    }
	
	    return found;
	  }
	};

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var hasLocalStorageSupport = void 0;
	try {
	  hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
	  var testKey = 'i18next.translate.boo';
	  window.localStorage.setItem(testKey, 'foo');
	  window.localStorage.removeItem(testKey);
	} catch (e) {
	  hasLocalStorageSupport = false;
	}
	
	exports.default = {
	  name: 'localStorage',
	
	  lookup: function lookup(options) {
	    var found = void 0;
	
	    if (options.lookupLocalStorage && hasLocalStorageSupport) {
	      var lng = window.localStorage.getItem(options.lookupLocalStorage);
	      if (lng) found = lng;
	    }
	
	    return found;
	  },
	  cacheUserLanguage: function cacheUserLanguage(lng, options) {
	    if (options.lookupLocalStorage && hasLocalStorageSupport) {
	      window.localStorage.setItem(options.lookupLocalStorage, lng);
	    }
	  }
	};

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'navigator',
	
	  lookup: function lookup(options) {
	    var found = [];
	
	    if (typeof navigator !== 'undefined') {
	      if (navigator.languages) {
	        // chrome only; not an array, so can't use .push.apply instead of iterating
	        for (var i = 0; i < navigator.languages.length; i++) {
	          found.push(navigator.languages[i]);
	        }
	      }
	      if (navigator.userLanguage) {
	        found.push(navigator.userLanguage);
	      }
	      if (navigator.language) {
	        found.push(navigator.language);
	      }
	    }
	
	    return found.length > 0 ? found : undefined;
	  }
	};

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'path',
	
	  lookup: function lookup(options) {
	    var found = void 0;
	    if (typeof window !== 'undefined') {
	      var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
	      if (language instanceof Array) {
	        if (typeof options.lookupFromPathIndex === 'number') {
	          if (typeof language[options.lookupFromPathIndex] !== 'string') {
	            return undefined;
	          }
	          found = language[options.lookupFromPathIndex].replace('/', '');
	        } else {
	          found = language[0].replace('/', '');
	        }
	      }
	    }
	    return found;
	  }
	};

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'querystring',
	
	  lookup: function lookup(options) {
	    var found = void 0;
	
	    if (typeof window !== 'undefined') {
	      var query = window.location.search.substring(1);
	      var params = query.split('&');
	      for (var i = 0; i < params.length; i++) {
	        var pos = params[i].indexOf('=');
	        if (pos > 0) {
	          var key = params[i].substring(0, pos);
	          if (key === options.lookupQuerystring) {
	            found = params[i].substring(pos + 1);
	          }
	        }
	      }
	    }
	
	    return found;
	  }
	};

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'subdomain',
	
	  lookup: function lookup(options) {
	    var found = void 0;
	    if (typeof window !== 'undefined') {
	      var language = window.location.href.match(/(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/gi);
	      if (language instanceof Array) {
	        if (typeof options.lookupFromSubdomainIndex === 'number') {
	          found = language[options.lookupFromSubdomainIndex].replace('http://', '').replace('https://', '').replace('.', '');
	        } else {
	          found = language[0].replace('http://', '').replace('https://', '').replace('.', '');
	        }
	      }
	    }
	    return found;
	  }
	};

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(265);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _cookie = __webpack_require__(257);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _querystring = __webpack_require__(262);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _localStorage = __webpack_require__(259);
	
	var _localStorage2 = _interopRequireDefault(_localStorage);
	
	var _navigator = __webpack_require__(260);
	
	var _navigator2 = _interopRequireDefault(_navigator);
	
	var _htmlTag = __webpack_require__(258);
	
	var _htmlTag2 = _interopRequireDefault(_htmlTag);
	
	var _path = __webpack_require__(261);
	
	var _path2 = _interopRequireDefault(_path);
	
	var _subdomain = __webpack_require__(263);
	
	var _subdomain2 = _interopRequireDefault(_subdomain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function getDefaults() {
	  return {
	    order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
	    lookupQuerystring: 'lng',
	    lookupCookie: 'i18next',
	    lookupLocalStorage: 'i18nextLng',
	
	    // cache user language
	    caches: ['localStorage'],
	    excludeCacheFor: ['cimode']
	    //cookieMinutes: 10,
	    //cookieDomain: 'myDomain'
	  };
	}
	
	var Browser = function () {
	  function Browser(services) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Browser);
	
	    this.type = 'languageDetector';
	    this.detectors = {};
	
	    this.init(services, options);
	  }
	
	  _createClass(Browser, [{
	    key: 'init',
	    value: function init(services) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      this.services = services;
	      this.options = utils.defaults(options, this.options || {}, getDefaults());
	
	      // backwards compatibility
	      if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
	
	      this.i18nOptions = i18nOptions;
	
	      this.addDetector(_cookie2.default);
	      this.addDetector(_querystring2.default);
	      this.addDetector(_localStorage2.default);
	      this.addDetector(_navigator2.default);
	      this.addDetector(_htmlTag2.default);
	      this.addDetector(_path2.default);
	      this.addDetector(_subdomain2.default);
	    }
	  }, {
	    key: 'addDetector',
	    value: function addDetector(detector) {
	      this.detectors[detector.name] = detector;
	    }
	  }, {
	    key: 'detect',
	    value: function detect(detectionOrder) {
	      var _this = this;
	
	      if (!detectionOrder) detectionOrder = this.options.order;
	
	      var detected = [];
	      detectionOrder.forEach(function (detectorName) {
	        if (_this.detectors[detectorName]) {
	          var lookup = _this.detectors[detectorName].lookup(_this.options);
	          if (lookup && typeof lookup === 'string') lookup = [lookup];
	          if (lookup) detected = detected.concat(lookup);
	        }
	      });
	
	      var found = void 0;
	      detected.forEach(function (lng) {
	        if (found) return;
	        var cleanedLng = _this.services.languageUtils.formatLanguageCode(lng);
	        if (_this.services.languageUtils.isWhitelisted(cleanedLng)) found = cleanedLng;
	      });
	
	      if (!found) {
	        var fallbacks = this.i18nOptions.fallbackLng;
	        if (typeof fallbacks === 'string') fallbacks = [fallbacks];
	        if (!fallbacks) fallbacks = [];
	
	        if (Object.prototype.toString.apply(fallbacks) === '[object Array]') {
	          found = fallbacks[0];
	        } else {
	          found = fallbacks[0] || fallbacks.default && fallbacks.default[0];
	        }
	      };
	
	      return found;
	    }
	  }, {
	    key: 'cacheUserLanguage',
	    value: function cacheUserLanguage(lng, caches) {
	      var _this2 = this;
	
	      if (!caches) caches = this.options.caches;
	      if (!caches) return;
	      if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
	      caches.forEach(function (cacheName) {
	        if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
	      });
	    }
	  }]);
	
	  return Browser;
	}();
	
	Browser.type = 'languageDetector';
	
	exports.default = Browser;

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaults = defaults;
	exports.extend = extend;
	var arr = [];
	var each = arr.forEach;
	var slice = arr.slice;
	
	function defaults(obj) {
	  each.call(slice.call(arguments, 1), function (source) {
	    if (source) {
	      for (var prop in source) {
	        if (obj[prop] === undefined) obj[prop] = source[prop];
	      }
	    }
	  });
	  return obj;
	}
	
	function extend(obj) {
	  each.call(slice.call(arguments, 1), function (source) {
	    if (source) {
	      for (var prop in source) {
	        obj[prop] = source[prop];
	      }
	    }
	  });
	  return obj;
	}

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(264).default;


/***/ }),

/***/ 267:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function addQueryString(url, params) {
	  if (params && (typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
	    var queryString = '',
	        e = encodeURIComponent;
	
	    // Must encode data
	    for (var paramName in params) {
	      queryString += '&' + e(paramName) + '=' + e(params[paramName]);
	    }
	
	    if (!queryString) {
	      return url;
	    }
	
	    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
	  }
	
	  return url;
	}
	
	// https://gist.github.com/Xeoncross/7663273
	function ajax(url, options, callback, data, cache) {
	
	  if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
	    if (!cache) {
	      data['_t'] = new Date();
	    }
	    // URL encoded form data must be in querystring format
	    data = addQueryString('', data).slice(1);
	  }
	
	  if (options.queryStringParams) {
	    url = addQueryString(url, options.queryStringParams);
	  }
	
	  try {
	    var x;
	    if (XMLHttpRequest) {
	      x = new XMLHttpRequest();
	    } else {
	      x = new ActiveXObject('MSXML2.XMLHTTP.3.0');
	    }
	    x.open(data ? 'POST' : 'GET', url, 1);
	    if (!options.crossDomain) {
	      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	    }
	    x.withCredentials = !!options.withCredentials;
	    if (data) {
	      x.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	    }
	    if (x.overrideMimeType) {
	      x.overrideMimeType("application/json");
	    }
	    var h = options.customHeaders;
	    if (h) {
	      for (var i in h) {
	        x.setRequestHeader(i, h[i]);
	      }
	    }
	    x.onreadystatechange = function () {
	      x.readyState > 3 && callback && callback(x.responseText, x);
	    };
	    x.send(data);
	  } catch (e) {
	    console && console.log(e);
	  }
	}
	
	exports.default = ajax;

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(269);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _ajax = __webpack_require__(267);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function getDefaults() {
	  return {
	    loadPath: '/locales/{{lng}}/{{ns}}.json',
	    addPath: '/locales/add/{{lng}}/{{ns}}',
	    allowMultiLoading: false,
	    parse: JSON.parse,
	    crossDomain: false,
	    ajax: _ajax2.default
	  };
	}
	
	var Backend = function () {
	  function Backend(services) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Backend);
	
	    this.init(services, options);
	
	    this.type = 'backend';
	  }
	
	  _createClass(Backend, [{
	    key: 'init',
	    value: function init(services) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this.services = services;
	      this.options = utils.defaults(options, this.options || {}, getDefaults());
	    }
	  }, {
	    key: 'readMulti',
	    value: function readMulti(languages, namespaces, callback) {
	      var loadPath = this.options.loadPath;
	      if (typeof this.options.loadPath === 'function') {
	        loadPath = this.options.loadPath(languages, namespaces);
	      }
	
	      var url = this.services.interpolator.interpolate(loadPath, { lng: languages.join('+'), ns: namespaces.join('+') });
	
	      this.loadUrl(url, callback);
	    }
	  }, {
	    key: 'read',
	    value: function read(language, namespace, callback) {
	      var loadPath = this.options.loadPath;
	      if (typeof this.options.loadPath === 'function') {
	        loadPath = this.options.loadPath([language], [namespace]);
	      }
	
	      var url = this.services.interpolator.interpolate(loadPath, { lng: language, ns: namespace });
	
	      this.loadUrl(url, callback);
	    }
	  }, {
	    key: 'loadUrl',
	    value: function loadUrl(url, callback) {
	      var _this = this;
	
	      this.options.ajax(url, this.options, function (data, xhr) {
	        if (xhr.status >= 500 && xhr.status < 600) return callback('failed loading ' + url, true /* retry */);
	        if (xhr.status >= 400 && xhr.status < 500) return callback('failed loading ' + url, false /* no retry */);
	
	        var ret = void 0,
	            err = void 0;
	        try {
	          ret = _this.options.parse(data, url);
	        } catch (e) {
	          err = 'failed parsing ' + url + ' to json';
	        }
	        if (err) return callback(err, false);
	        callback(null, ret);
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create(languages, namespace, key, fallbackValue) {
	      var _this2 = this;
	
	      if (typeof languages === 'string') languages = [languages];
	
	      var payload = {};
	      payload[key] = fallbackValue || '';
	
	      languages.forEach(function (lng) {
	        var url = _this2.services.interpolator.interpolate(_this2.options.addPath, { lng: lng, ns: namespace });
	
	        _this2.options.ajax(url, _this2.options, function (data, xhr) {
	          //const statusCode = xhr.status.toString();
	          // TODO: if statusCode === 4xx do log
	        }, payload);
	      });
	    }
	  }]);
	
	  return Backend;
	}();
	
	Backend.type = 'backend';
	
	exports.default = Backend;

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaults = defaults;
	exports.extend = extend;
	var arr = [];
	var each = arr.forEach;
	var slice = arr.slice;
	
	function defaults(obj) {
	  each.call(slice.call(arguments, 1), function (source) {
	    if (source) {
	      for (var prop in source) {
	        if (obj[prop] === undefined) obj[prop] = source[prop];
	      }
	    }
	  });
	  return obj;
	}
	
	function extend(obj) {
	  each.call(slice.call(arguments, 1), function (source) {
	    if (source) {
	      for (var prop in source) {
	        obj[prop] = source[prop];
	      }
	    }
	  });
	  return obj;
	}

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(268).default;


/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _utils = __webpack_require__(62);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _logger = __webpack_require__(36);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(61);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	function remove(arr, what) {
	  var found = arr.indexOf(what);
	
	  while (found !== -1) {
	    arr.splice(found, 1);
	    found = arr.indexOf(what);
	  }
	}
	
	var Connector = function (_EventEmitter) {
	  _inherits(Connector, _EventEmitter);
	
	  function Connector(backend, store, services) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    _classCallCheck(this, Connector);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.backend = backend;
	    _this.store = store;
	    _this.languageUtils = services.languageUtils;
	    _this.options = options;
	    _this.logger = _logger2.default.create('backendConnector');
	
	    _this.state = {};
	    _this.queue = [];
	
	    if (_this.backend && _this.backend.init) {
	      _this.backend.init(services, options.backend, options);
	    }
	    return _this;
	  }
	
	  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, options, callback) {
	    var _this2 = this;
	
	    // find what needs to be loaded
	    var toLoad = [];
	    var pending = [];
	    var toLoadLanguages = [];
	    var toLoadNamespaces = [];
	
	    languages.forEach(function (lng) {
	      var hasAllNamespaces = true;
	
	      namespaces.forEach(function (ns) {
	        var name = lng + '|' + ns;
	
	        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
	          _this2.state[name] = 2; // loaded
	        } else if (_this2.state[name] < 0) {
	          // nothing to do for err
	        } else if (_this2.state[name] === 1) {
	          if (pending.indexOf(name) < 0) pending.push(name);
	        } else {
	          _this2.state[name] = 1; // pending
	
	          hasAllNamespaces = false;
	
	          if (pending.indexOf(name) < 0) pending.push(name);
	          if (toLoad.indexOf(name) < 0) toLoad.push(name);
	          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
	        }
	      });
	
	      if (!hasAllNamespaces) toLoadLanguages.push(lng);
	    });
	
	    if (toLoad.length || pending.length) {
	      this.queue.push({
	        pending: pending,
	        loaded: {},
	        errors: [],
	        callback: callback
	      });
	    }
	
	    return {
	      toLoad: toLoad,
	      pending: pending,
	      toLoadLanguages: toLoadLanguages,
	      toLoadNamespaces: toLoadNamespaces
	    };
	  };
	
	  Connector.prototype.loaded = function loaded(name, err, data) {
	    var _name$split = name.split('|'),
	        _name$split2 = _slicedToArray(_name$split, 2),
	        lng = _name$split2[0],
	        ns = _name$split2[1];
	
	    if (err) this.emit('failedLoading', lng, ns, err);
	
	    if (data) {
	      this.store.addResourceBundle(lng, ns, data);
	    }
	
	    // set loaded
	    this.state[name] = err ? -1 : 2;
	
	    // consolidated loading done in this run - only emit once for a loaded namespace
	    var loaded = {};
	
	    // callback if ready
	    this.queue.forEach(function (q) {
	      utils.pushPath(q.loaded, [lng], ns);
	      remove(q.pending, name);
	
	      if (err) q.errors.push(err);
	
	      if (q.pending.length === 0 && !q.done) {
	        // only do once per loaded -> this.emit('loaded', q.loaded);
	        Object.keys(q.loaded).forEach(function (l) {
	          if (!loaded[l]) loaded[l] = [];
	          if (q.loaded[l].length) {
	            q.loaded[l].forEach(function (ns) {
	              if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
	            });
	          }
	        });
	
	        /* eslint no-param-reassign: 0 */
	        q.done = true;
	        if (q.errors.length) {
	          q.callback(q.errors);
	        } else {
	          q.callback();
	        }
	      }
	    });
	
	    // emit consolidated loaded event
	    this.emit('loaded', loaded);
	
	    // remove done load requests
	    this.queue = this.queue.filter(function (q) {
	      return !q.done;
	    });
	  };
	
	  Connector.prototype.read = function read(lng, ns, fcName) {
	    var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	    var _this3 = this;
	
	    var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
	    var callback = arguments[5];
	
	    if (!lng.length) return callback(null, {}); // noting to load
	
	    return this.backend[fcName](lng, ns, function (err, data) {
	      if (err && data /* = retryFlag */ && tried < 5) {
	        setTimeout(function () {
	          _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
	        }, wait);
	        return;
	      }
	      callback(err, data);
	    });
	  };
	
	  /* eslint consistent-return: 0 */
	
	
	  Connector.prototype.prepareLoading = function prepareLoading(languages, namespaces) {
	    var _this4 = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (!this.backend) {
	      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
	      return callback && callback();
	    }
	
	    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
	    if (typeof namespaces === 'string') namespaces = [namespaces];
	
	    var toLoad = this.queueLoad(languages, namespaces, options, callback);
	    if (!toLoad.toLoad.length) {
	      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
	      return null; // pendings will trigger callback
	    }
	
	    toLoad.toLoad.forEach(function (name) {
	      _this4.loadOne(name);
	    });
	  };
	
	  Connector.prototype.load = function load(languages, namespaces, callback) {
	    this.prepareLoading(languages, namespaces, {}, callback);
	  };
	
	  Connector.prototype.reload = function reload(languages, namespaces, callback) {
	    this.prepareLoading(languages, namespaces, { reload: true }, callback);
	  };
	
	  Connector.prototype.loadOne = function loadOne(name) {
	    var _this5 = this;
	
	    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    var _name$split3 = name.split('|'),
	        _name$split4 = _slicedToArray(_name$split3, 2),
	        lng = _name$split4[0],
	        ns = _name$split4[1];
	
	    this.read(lng, ns, 'read', null, null, function (err, data) {
	      if (err) _this5.logger.warn(prefix + 'loading namespace ' + ns + ' for language ' + lng + ' failed', err);
	      if (!err && data) _this5.logger.log(prefix + 'loaded namespace ' + ns + ' for language ' + lng, data);
	
	      _this5.loaded(name, err, data);
	    });
	  };
	
	  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
	    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
	    if (this.backend && this.backend.create) {
	      this.backend.create(languages, namespace, key, fallbackValue, null /* unused callback */, _extends({}, options, { isUpdate: isUpdate }));
	    }
	
	    // write to store to avoid resending
	    if (!languages || !languages[0]) return;
	    this.store.addResource(languages[0], namespace, key, fallbackValue);
	  };
	
	  return Connector;
	}(_EventEmitter3.default);
	
	exports.default = Connector;

/***/ }),

/***/ 61:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventEmitter = function () {
	  function EventEmitter() {
	    _classCallCheck(this, EventEmitter);
	
	    this.observers = {};
	  }
	
	  EventEmitter.prototype.on = function on(events, listener) {
	    var _this = this;
	
	    events.split(' ').forEach(function (event) {
	      _this.observers[event] = _this.observers[event] || [];
	      _this.observers[event].push(listener);
	    });
	    return this;
	  };
	
	  EventEmitter.prototype.off = function off(event, listener) {
	    var _this2 = this;
	
	    if (!this.observers[event]) {
	      return;
	    }
	
	    this.observers[event].forEach(function () {
	      if (!listener) {
	        delete _this2.observers[event];
	      } else {
	        var index = _this2.observers[event].indexOf(listener);
	        if (index > -1) {
	          _this2.observers[event].splice(index, 1);
	        }
	      }
	    });
	  };
	
	  EventEmitter.prototype.emit = function emit(event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (this.observers[event]) {
	      var cloned = [].concat(this.observers[event]);
	      cloned.forEach(function (observer) {
	        observer.apply(undefined, args);
	      });
	    }
	
	    if (this.observers['*']) {
	      var _cloned = [].concat(this.observers['*']);
	      _cloned.forEach(function (observer) {
	        observer.apply(observer, [event].concat(args));
	      });
	    }
	  };
	
	  return EventEmitter;
	}();
	
	exports.default = EventEmitter;

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(62);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _logger = __webpack_require__(36);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Interpolator = function () {
	  function Interpolator() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Interpolator);
	
	    this.logger = _logger2.default.create('interpolator');
	
	    this.init(options, true);
	  }
	
	  /* eslint no-param-reassign: 0 */
	
	
	  Interpolator.prototype.init = function init() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var reset = arguments[1];
	
	    if (reset) {
	      this.options = options;
	      this.format = options.interpolation && options.interpolation.format || function (value) {
	        return value;
	      };
	    }
	    if (!options.interpolation) options.interpolation = { escapeValue: true };
	
	    var iOpts = options.interpolation;
	
	    this.escape = iOpts.escape !== undefined ? iOpts.escape : utils.escape;
	    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
	    this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
	
	    this.prefix = iOpts.prefix ? utils.regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
	    this.suffix = iOpts.suffix ? utils.regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
	
	    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
	
	    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
	    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
	
	    this.nestingPrefix = iOpts.nestingPrefix ? utils.regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || utils.regexEscape('$t(');
	    this.nestingSuffix = iOpts.nestingSuffix ? utils.regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || utils.regexEscape(')');
	
	    this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
	
	    // the regexp
	    this.resetRegExp();
	  };
	
	  Interpolator.prototype.reset = function reset() {
	    if (this.options) this.init(this.options);
	  };
	
	  Interpolator.prototype.resetRegExp = function resetRegExp() {
	    // the regexp
	    var regexpStr = this.prefix + '(.+?)' + this.suffix;
	    this.regexp = new RegExp(regexpStr, 'g');
	
	    var regexpUnescapeStr = '' + this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
	    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
	
	    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
	    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
	  };
	
	  Interpolator.prototype.interpolate = function interpolate(str, data, lng, options) {
	    var _this = this;
	
	    var match = void 0;
	    var value = void 0;
	    var replaces = void 0;
	
	    function regexSafe(val) {
	      return val.replace(/\$/g, '$$$$');
	    }
	
	    var handleFormat = function handleFormat(key) {
	      if (key.indexOf(_this.formatSeparator) < 0) return utils.getPath(data, key);
	
	      var p = key.split(_this.formatSeparator);
	      var k = p.shift().trim();
	      var f = p.join(_this.formatSeparator).trim();
	
	      return _this.format(utils.getPath(data, k), f, lng);
	    };
	
	    this.resetRegExp();
	
	    var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
	
	    replaces = 0;
	    // unescape if has unescapePrefix/Suffix
	    /* eslint no-cond-assign: 0 */
	    while (match = this.regexpUnescape.exec(str)) {
	      value = handleFormat(match[1].trim());
	      str = str.replace(match[0], value);
	      this.regexpUnescape.lastIndex = 0;
	      replaces++;
	      if (replaces >= this.maxReplaces) {
	        break;
	      }
	    }
	
	    replaces = 0;
	    // regular escape on demand
	    while (match = this.regexp.exec(str)) {
	      value = handleFormat(match[1].trim());
	      if (value === undefined) {
	        if (typeof missingInterpolationHandler === 'function') {
	          var temp = missingInterpolationHandler(str, match);
	          value = typeof temp === 'string' ? temp : '';
	        } else {
	          this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
	          value = '';
	        }
	      } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
	        value = utils.makeString(value);
	      }
	      value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
	      str = str.replace(match[0], value);
	      this.regexp.lastIndex = 0;
	      replaces++;
	      if (replaces >= this.maxReplaces) {
	        break;
	      }
	    }
	    return str;
	  };
	
	  Interpolator.prototype.nest = function nest(str, fc) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var match = void 0;
	    var value = void 0;
	
	    var clonedOptions = _extends({}, options);
	    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup
	
	    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
	    function handleHasOptions(key, inheritedOptions) {
	      if (key.indexOf(',') < 0) return key;
	
	      var p = key.split(',');
	      key = p.shift();
	      var optionsString = p.join(',');
	      optionsString = this.interpolate(optionsString, clonedOptions);
	      optionsString = optionsString.replace(/'/g, '"');
	
	      try {
	        clonedOptions = JSON.parse(optionsString);
	
	        if (inheritedOptions) clonedOptions = _extends({}, inheritedOptions, clonedOptions);
	      } catch (e) {
	        this.logger.error('failed parsing options string in nesting for key ' + key, e);
	      }
	
	      return key;
	    }
	
	    // regular escape on demand
	    while (match = this.nestingRegexp.exec(str)) {
	      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
	
	      // is only the nesting key (key1 = '$(key2)') return the value without stringify
	      if (value && match[0] === str && typeof value !== 'string') return value;
	
	      // no string to include or empty
	      if (typeof value !== 'string') value = utils.makeString(value);
	      if (!value) {
	        this.logger.warn('missed to resolve ' + match[1] + ' for nesting ' + str);
	        value = '';
	      }
	      // Nested keys should not be escaped by default #854
	      // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
	      str = str.replace(match[0], value);
	      this.regexp.lastIndex = 0;
	    }
	    return str;
	  };
	
	  return Interpolator;
	}();
	
	exports.default = Interpolator;

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _logger = __webpack_require__(36);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function capitalize(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	var LanguageUtil = function () {
	  function LanguageUtil(options) {
	    _classCallCheck(this, LanguageUtil);
	
	    this.options = options;
	
	    this.whitelist = this.options.whitelist || false;
	    this.logger = _logger2.default.create('languageUtils');
	  }
	
	  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
	    if (!code || code.indexOf('-') < 0) return null;
	
	    var p = code.split('-');
	    if (p.length === 2) return null;
	    p.pop();
	    return this.formatLanguageCode(p.join('-'));
	  };
	
	  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
	    if (!code || code.indexOf('-') < 0) return code;
	
	    var p = code.split('-');
	    return this.formatLanguageCode(p[0]);
	  };
	
	  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
	    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
	    if (typeof code === 'string' && code.indexOf('-') > -1) {
	      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
	      var p = code.split('-');
	
	      if (this.options.lowerCaseLng) {
	        p = p.map(function (part) {
	          return part.toLowerCase();
	        });
	      } else if (p.length === 2) {
	        p[0] = p[0].toLowerCase();
	        p[1] = p[1].toUpperCase();
	
	        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
	      } else if (p.length === 3) {
	        p[0] = p[0].toLowerCase();
	
	        // if lenght 2 guess it's a country
	        if (p[1].length === 2) p[1] = p[1].toUpperCase();
	        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
	
	        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
	        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
	      }
	
	      return p.join('-');
	    }
	
	    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
	  };
	
	  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code) {
	    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
	      code = this.getLanguagePartFromCode(code);
	    }
	    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
	  };
	
	  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
	    if (!fallbacks) return [];
	    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
	    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
	
	    if (!code) return fallbacks.default || [];
	
	    // asume we have an object defining fallbacks
	    var found = fallbacks[code];
	    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
	    if (!found) found = fallbacks[this.formatLanguageCode(code)];
	    if (!found) found = fallbacks.default;
	
	    return found || [];
	  };
	
	  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
	    var _this = this;
	
	    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
	
	    var codes = [];
	    var addCode = function addCode(c) {
	      if (!c) return;
	      if (_this.isWhitelisted(c)) {
	        codes.push(c);
	      } else {
	        _this.logger.warn('rejecting non-whitelisted language code: ' + c);
	      }
	    };
	
	    if (typeof code === 'string' && code.indexOf('-') > -1) {
	      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
	      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
	      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
	    } else if (typeof code === 'string') {
	      addCode(this.formatLanguageCode(code));
	    }
	
	    fallbackCodes.forEach(function (fc) {
	      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
	    });
	
	    return codes;
	  };
	
	  return LanguageUtil;
	}();
	
	exports.default = LanguageUtil;

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _logger = __webpack_require__(36);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
	/* eslint-disable */
	var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];
	
	var _rulesPluralsTypes = {
	  1: function _(n) {
	    return Number(n > 1);
	  },
	  2: function _(n) {
	    return Number(n != 1);
	  },
	  3: function _(n) {
	    return 0;
	  },
	  4: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  5: function _(n) {
	    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
	  },
	  6: function _(n) {
	    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
	  },
	  7: function _(n) {
	    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  8: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
	  },
	  9: function _(n) {
	    return Number(n >= 2);
	  },
	  10: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
	  },
	  11: function _(n) {
	    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
	  },
	  12: function _(n) {
	    return Number(n % 10 != 1 || n % 100 == 11);
	  },
	  13: function _(n) {
	    return Number(n !== 0);
	  },
	  14: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
	  },
	  15: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  16: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
	  },
	  17: function _(n) {
	    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
	  },
	  18: function _(n) {
	    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
	  },
	  19: function _(n) {
	    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
	  },
	  20: function _(n) {
	    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
	  },
	  21: function _(n) {
	    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
	  },
	  22: function _(n) {
	    return Number(n === 1 ? 0 : n === 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
	  }
	};
	/* eslint-enable */
	
	function createRules() {
	  var rules = {};
	  sets.forEach(function (set) {
	    set.lngs.forEach(function (l) {
	      rules[l] = {
	        numbers: set.nr,
	        plurals: _rulesPluralsTypes[set.fc]
	      };
	    });
	  });
	  return rules;
	}
	
	var PluralResolver = function () {
	  function PluralResolver(languageUtils) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, PluralResolver);
	
	    this.languageUtils = languageUtils;
	    this.options = options;
	
	    this.logger = _logger2.default.create('pluralResolver');
	
	    this.rules = createRules();
	  }
	
	  PluralResolver.prototype.addRule = function addRule(lng, obj) {
	    this.rules[lng] = obj;
	  };
	
	  PluralResolver.prototype.getRule = function getRule(code) {
	    return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
	  };
	
	  PluralResolver.prototype.needsPlural = function needsPlural(code) {
	    var rule = this.getRule(code);
	
	    return rule && rule.numbers.length > 1;
	  };
	
	  PluralResolver.prototype.getPluralFormsOfKey = function getPluralFormsOfKey(code, key) {
	    var _this = this;
	
	    var ret = [];
	
	    var rule = this.getRule(code);
	
	    if (!rule) return ret;
	
	    rule.numbers.forEach(function (n) {
	      var suffix = _this.getSuffix(code, n);
	      ret.push('' + key + suffix);
	    });
	
	    return ret;
	  };
	
	  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
	    var _this2 = this;
	
	    var rule = this.getRule(code);
	
	    if (rule) {
	      // if (rule.numbers.length === 1) return ''; // only singular
	
	      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
	      var suffix = rule.numbers[idx];
	
	      // special treatment for lngs only having singular and plural
	      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
	        if (suffix === 2) {
	          suffix = 'plural';
	        } else if (suffix === 1) {
	          suffix = '';
	        }
	      }
	
	      var returnSuffix = function returnSuffix() {
	        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
	      };
	
	      // COMPATIBILITY JSON
	      // v1
	      if (this.options.compatibilityJSON === 'v1') {
	        if (suffix === 1) return '';
	        if (typeof suffix === 'number') return '_plural_' + suffix.toString();
	        return returnSuffix();
	      } else if ( /* v2 */this.options.compatibilityJSON === 'v2' && rule.numbers.length === 2 && rule.numbers[0] === 1) {
	        return returnSuffix();
	      } else if ( /* v3 - gettext index */this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
	        return returnSuffix();
	      }
	      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
	    }
	
	    this.logger.warn('no plural rule found for: ' + code);
	    return '';
	  };
	
	  return PluralResolver;
	}();
	
	exports.default = PluralResolver;

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _EventEmitter2 = __webpack_require__(61);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	var _utils = __webpack_require__(62);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var ResourceStore = function (_EventEmitter) {
	  _inherits(ResourceStore, _EventEmitter);
	
	  function ResourceStore(data) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };
	
	    _classCallCheck(this, ResourceStore);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.data = data || {};
	    _this.options = options;
	    if (_this.options.keySeparator === undefined) {
	      _this.options.keySeparator = '.';
	    }
	    return _this;
	  }
	
	  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
	    if (this.options.ns.indexOf(ns) < 0) {
	      this.options.ns.push(ns);
	    }
	  };
	
	  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
	    var index = this.options.ns.indexOf(ns);
	    if (index > -1) {
	      this.options.ns.splice(index, 1);
	    }
	  };
	
	  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
	
	    var path = [lng, ns];
	    if (key && typeof key !== 'string') path = path.concat(key);
	    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
	
	    if (lng.indexOf('.') > -1) {
	      path = lng.split('.');
	    }
	
	    return utils.getPath(this.data, path);
	  };
	
	  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
	    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };
	
	    var keySeparator = this.options.keySeparator;
	    if (keySeparator === undefined) keySeparator = '.';
	
	    var path = [lng, ns];
	    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
	
	    if (lng.indexOf('.') > -1) {
	      path = lng.split('.');
	      value = ns;
	      ns = path[1];
	    }
	
	    this.addNamespaces(ns);
	
	    utils.setPath(this.data, path, value);
	
	    if (!options.silent) this.emit('added', lng, ns, key, value);
	  };
	
	  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { silent: false };
	
	    /* eslint no-restricted-syntax: 0 */
	    for (var m in resources) {
	      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
	    }
	    if (!options.silent) this.emit('added', lng, ns, resources);
	  };
	
	  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
	    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : { silent: false };
	
	    var path = [lng, ns];
	    if (lng.indexOf('.') > -1) {
	      path = lng.split('.');
	      deep = resources;
	      resources = ns;
	      ns = path[1];
	    }
	
	    this.addNamespaces(ns);
	
	    var pack = utils.getPath(this.data, path) || {};
	
	    if (deep) {
	      utils.deepExtend(pack, resources, overwrite);
	    } else {
	      pack = _extends({}, pack, resources);
	    }
	
	    utils.setPath(this.data, path, pack);
	
	    if (!options.silent) this.emit('added', lng, ns, resources);
	  };
	
	  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
	    if (this.hasResourceBundle(lng, ns)) {
	      delete this.data[lng][ns];
	    }
	    this.removeNamespaces(ns);
	
	    this.emit('removed', lng, ns);
	  };
	
	  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
	    return this.getResource(lng, ns) !== undefined;
	  };
	
	  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
	    if (!ns) ns = this.options.defaultNS;
	
	    // COMPATIBILITY: remove extend in v2.1.0
	    if (this.options.compatibilityAPI === 'v1') return _extends({}, this.getResource(lng, ns));
	
	    return this.getResource(lng, ns);
	  };
	
	  ResourceStore.prototype.getDataByLanguage = function getDataByLanguage(lng) {
	    return this.data[lng];
	  };
	
	  ResourceStore.prototype.toJSON = function toJSON() {
	    return this.data;
	  };
	
	  return ResourceStore;
	}(_EventEmitter3.default);
	
	exports.default = ResourceStore;

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _logger = __webpack_require__(36);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(61);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	var _postProcessor = __webpack_require__(136);
	
	var _postProcessor2 = _interopRequireDefault(_postProcessor);
	
	var _utils = __webpack_require__(62);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Translator = function (_EventEmitter) {
	  _inherits(Translator, _EventEmitter);
	
	  function Translator(services) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Translator);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    utils.copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat'], services, _this);
	
	    _this.options = options;
	    if (_this.options.keySeparator === undefined) {
	      _this.options.keySeparator = '.';
	    }
	
	    _this.logger = _logger2.default.create('translator');
	    return _this;
	  }
	
	  Translator.prototype.changeLanguage = function changeLanguage(lng) {
	    if (lng) this.language = lng;
	  };
	
	  Translator.prototype.exists = function exists(key) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };
	
	    var resolved = this.resolve(key, options);
	    return resolved && resolved.res !== undefined;
	  };
	
	  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
	    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
	    if (nsSeparator === undefined) nsSeparator = ':';
	
	    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
	
	    var namespaces = options.ns || this.options.defaultNS;
	    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
	      var parts = key.split(nsSeparator);
	      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
	      key = parts.join(keySeparator);
	    }
	    if (typeof namespaces === 'string') namespaces = [namespaces];
	
	    return {
	      key: key,
	      namespaces: namespaces
	    };
	  };
	
	  Translator.prototype.translate = function translate(keys, options) {
	    var _this2 = this;
	
	    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object' && this.options.overloadTranslationOptionHandler) {
	      /* eslint prefer-rest-params: 0 */
	      options = this.options.overloadTranslationOptionHandler(arguments);
	    }
	    if (!options) options = {};
	
	    // non valid keys handling
	    if (keys === undefined || keys === null || keys === '') return '';
	    if (typeof keys === 'number') keys = String(keys);
	    if (typeof keys === 'string') keys = [keys];
	
	    // separators
	    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
	
	    // get namespace(s)
	
	    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
	        key = _extractFromKey.key,
	        namespaces = _extractFromKey.namespaces;
	
	    var namespace = namespaces[namespaces.length - 1];
	
	    // return key on CIMode
	    var lng = options.lng || this.language;
	    var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
	    if (lng && lng.toLowerCase() === 'cimode') {
	      if (appendNamespaceToCIMode) {
	        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
	        return namespace + nsSeparator + key;
	      }
	
	      return key;
	    }
	
	    // resolve from store
	    var resolved = this.resolve(keys, options);
	    var res = resolved && resolved.res;
	    var resUsedKey = resolved && resolved.usedKey || key;
	
	    var resType = Object.prototype.toString.apply(res);
	    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
	    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
	
	    // object
	    var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
	    var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
	    if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
	      if (!options.returnObjects && !this.options.returnObjects) {
	        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
	        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
	      }
	
	      // if we got a separator we loop over children - else we just return object as is
	      // as having it set to false means no hierarchy so no lookup for nested values
	      if (keySeparator) {
	        var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy
	
	        /* eslint no-restricted-syntax: 0 */
	        for (var m in res) {
	          if (Object.prototype.hasOwnProperty.call(res, m)) {
	            var deepKey = '' + resUsedKey + keySeparator + m;
	            copy[m] = this.translate(deepKey, _extends({}, options, { joinArrays: false, ns: namespaces }));
	            if (copy[m] === deepKey) copy[m] = res[m]; // if nothing found use orginal value as fallback
	          }
	        }
	        res = copy;
	      }
	    } else if (handleAsObjectInI18nFormat && joinArrays && resType === '[object Array]') {
	      // array special treatment
	      res = res.join(joinArrays);
	      if (res) res = this.extendTranslation(res, keys, options);
	    } else {
	      // string, empty or null
	      var usedDefault = false;
	      var usedKey = false;
	
	      // fallback value
	      if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
	        usedDefault = true;
	
	        if (options.count !== undefined) {
	          var suffix = this.pluralResolver.getSuffix(lng, options.count);
	          res = options['defaultValue' + suffix];
	        }
	        if (!res) res = options.defaultValue;
	      }
	      if (!this.isValidLookup(res)) {
	        usedKey = true;
	        res = key;
	      }
	
	      // save missing
	      var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;
	      if (usedKey || usedDefault || updateMissing) {
	        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);
	
	        var lngs = [];
	        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
	        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
	          for (var i = 0; i < fallbackLngs.length; i++) {
	            lngs.push(fallbackLngs[i]);
	          }
	        } else if (this.options.saveMissingTo === 'all') {
	          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
	        } else {
	          lngs.push(options.lng || this.language);
	        }
	
	        var send = function send(l, k) {
	          if (_this2.options.missingKeyHandler) {
	            _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
	          } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
	            _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
	          }
	          _this2.emit('missingKey', l, namespace, k, res);
	        };
	
	        if (this.options.saveMissing) {
	          var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
	          if (this.options.saveMissingPlurals && needsPluralHandling) {
	            lngs.forEach(function (l) {
	              var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);
	
	              plurals.forEach(function (p) {
	                return send([l], p);
	              });
	            });
	          } else {
	            send(lngs, key);
	          }
	        }
	      }
	
	      // extend
	      res = this.extendTranslation(res, keys, options, resolved);
	
	      // append namespace if still key
	      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;
	
	      // parseMissingKeyHandler
	      if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
	    }
	
	    // return
	    return res;
	  };
	
	  Translator.prototype.extendTranslation = function extendTranslation(res, key, options, resolved) {
	    var _this3 = this;
	
	    if (this.i18nFormat && this.i18nFormat.parse) {
	      res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, { resolved: resolved });
	    } else if (!options.skipInterpolation) {
	      // i18next.parsing
	      if (options.interpolation) this.interpolator.init(_extends({}, options, { interpolation: _extends({}, this.options.interpolation, options.interpolation) }));
	
	      // interpolate
	      var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
	      if (this.options.interpolation.defaultVariables) data = _extends({}, this.options.interpolation.defaultVariables, data);
	      res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
	
	      // nesting
	      if (options.nest !== false) res = this.interpolator.nest(res, function () {
	        return _this3.translate.apply(_this3, arguments);
	      }, options);
	
	      if (options.interpolation) this.interpolator.reset();
	    }
	
	    // post process
	    var postProcess = options.postProcess || this.options.postProcess;
	    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
	
	    if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
	      res = _postProcessor2.default.handle(postProcessorNames, res, key, options, this);
	    }
	
	    return res;
	  };
	
	  Translator.prototype.resolve = function resolve(keys) {
	    var _this4 = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var found = void 0;
	    var usedKey = void 0;
	    var usedLng = void 0;
	    var usedNS = void 0;
	
	    if (typeof keys === 'string') keys = [keys];
	
	    // forEach possible key
	    keys.forEach(function (k) {
	      if (_this4.isValidLookup(found)) return;
	      var extracted = _this4.extractFromKey(k, options);
	      var key = extracted.key;
	      usedKey = key;
	      var namespaces = extracted.namespaces;
	      if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
	
	      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
	      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
	
	      var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
	
	      namespaces.forEach(function (ns) {
	        if (_this4.isValidLookup(found)) return;
	        usedNS = ns;
	
	        codes.forEach(function (code) {
	          if (_this4.isValidLookup(found)) return;
	          usedLng = code;
	
	          var finalKey = key;
	          var finalKeys = [finalKey];
	
	          if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
	            _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
	          } else {
	            var pluralSuffix = void 0;
	            if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
	
	            // fallback for plural if context not found
	            if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
	
	            // get key for context if needed
	            if (needsContextHandling) finalKeys.push(finalKey += '' + _this4.options.contextSeparator + options.context);
	
	            // get key for plural if needed
	            if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
	          }
	
	          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
	          var possibleKey = void 0;
	          /* eslint no-cond-assign: 0 */
	          while (possibleKey = finalKeys.pop()) {
	            if (!_this4.isValidLookup(found)) {
	              found = _this4.getResource(code, ns, possibleKey, options);
	            }
	          }
	        });
	      });
	    });
	
	    return { res: found, usedKey: usedKey, usedLng: usedLng, usedNS: usedNS };
	  };
	
	  Translator.prototype.isValidLookup = function isValidLookup(res) {
	    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
	  };
	
	  Translator.prototype.getResource = function getResource(code, ns, key) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
	    return this.resourceStore.getResource(code, ns, key, options);
	  };
	
	  return Translator;
	}(_EventEmitter3.default);
	
	exports.default = Translator;

/***/ }),

/***/ 277:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.transformOptions = transformOptions;
	function get() {
	  return {
	    debug: false,
	    initImmediate: true,
	
	    ns: ['translation'],
	    defaultNS: ['translation'],
	    fallbackLng: ['dev'],
	    fallbackNS: false, // string or array of namespaces
	
	    whitelist: false, // array with whitelisted languages
	    nonExplicitWhitelist: false,
	    load: 'all', // | currentOnly | languageOnly
	    preload: false, // array with preload languages
	
	    simplifyPluralSuffix: true,
	    keySeparator: '.',
	    nsSeparator: ':',
	    pluralSeparator: '_',
	    contextSeparator: '_',
	
	    saveMissing: false, // enable to send missing values
	    updateMissing: false, // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
	    saveMissingTo: 'fallback', // 'current' || 'all'
	    saveMissingPlurals: true, // will save all forms not only singular key
	    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling
	    missingInterpolationHandler: false, // function(str, match)
	
	    postProcess: false, // string or array of postProcessor names
	    returnNull: true, // allows null value as valid translation
	    returnEmptyString: true, // allows empty string value as valid translation
	    returnObjects: false,
	    joinArrays: false, // or string to join array
	    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
	    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
	    appendNamespaceToMissingKey: false,
	    appendNamespaceToCIMode: false,
	    overloadTranslationOptionHandler: function handle(args) {
	      var ret = {};
	      if (args[1]) ret.defaultValue = args[1];
	      if (args[2]) ret.tDescription = args[2];
	      return ret;
	    },
	    interpolation: {
	      escapeValue: true,
	      format: function format(value, _format, lng) {
	        return value;
	      },
	      prefix: '{{',
	      suffix: '}}',
	      formatSeparator: ',',
	      // prefixEscaped: '{{',
	      // suffixEscaped: '}}',
	      // unescapeSuffix: '',
	      unescapePrefix: '-',
	
	      nestingPrefix: '$t(',
	      nestingSuffix: ')',
	      // nestingPrefixEscaped: '$t(',
	      // nestingSuffixEscaped: ')',
	      // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
	      maxReplaces: 1000 // max replaces to prevent endless loop
	    }
	  };
	}
	
	/* eslint no-param-reassign: 0 */
	exports.get = get;
	function transformOptions(options) {
	  // create namespace object if namespace is passed in as string
	  if (typeof options.ns === 'string') options.ns = [options.ns];
	  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
	  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
	
	  // extend whitelist with cimode
	  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
	    options.whitelist = options.whitelist.concat(['cimode']);
	  }
	
	  return options;
	}

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _logger = __webpack_require__(36);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(61);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	var _ResourceStore = __webpack_require__(275);
	
	var _ResourceStore2 = _interopRequireDefault(_ResourceStore);
	
	var _Translator = __webpack_require__(276);
	
	var _Translator2 = _interopRequireDefault(_Translator);
	
	var _LanguageUtils = __webpack_require__(273);
	
	var _LanguageUtils2 = _interopRequireDefault(_LanguageUtils);
	
	var _PluralResolver = __webpack_require__(274);
	
	var _PluralResolver2 = _interopRequireDefault(_PluralResolver);
	
	var _Interpolator = __webpack_require__(272);
	
	var _Interpolator2 = _interopRequireDefault(_Interpolator);
	
	var _BackendConnector = __webpack_require__(271);
	
	var _BackendConnector2 = _interopRequireDefault(_BackendConnector);
	
	var _defaults2 = __webpack_require__(277);
	
	var _postProcessor = __webpack_require__(136);
	
	var _postProcessor2 = _interopRequireDefault(_postProcessor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	function noop() {}
	
	var I18n = function (_EventEmitter) {
	  _inherits(I18n, _EventEmitter);
	
	  function I18n() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments[1];
	
	    _classCallCheck(this, I18n);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.options = (0, _defaults2.transformOptions)(options);
	    _this.services = {};
	    _this.logger = _logger2.default;
	    _this.modules = { external: [] };
	
	    if (callback && !_this.isInitialized && !options.isClone) {
	      var _ret;
	
	      // https://github.com/i18next/i18next/issues/879
	      if (!_this.options.initImmediate) return _ret = _this.init(options, callback), _possibleConstructorReturn(_this, _ret);
	      setTimeout(function () {
	        _this.init(options, callback);
	      }, 0);
	    }
	    return _this;
	  }
	
	  I18n.prototype.init = function init() {
	    var _this2 = this;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments[1];
	
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    this.options = _extends({}, (0, _defaults2.get)(), this.options, (0, _defaults2.transformOptions)(options));
	
	    this.format = this.options.interpolation.format;
	    if (!callback) callback = noop;
	
	    function createClassOnDemand(ClassOrObject) {
	      if (!ClassOrObject) return null;
	      if (typeof ClassOrObject === 'function') return new ClassOrObject();
	      return ClassOrObject;
	    }
	
	    // init services
	    if (!this.options.isClone) {
	      if (this.modules.logger) {
	        _logger2.default.init(createClassOnDemand(this.modules.logger), this.options);
	      } else {
	        _logger2.default.init(null, this.options);
	      }
	
	      var lu = new _LanguageUtils2.default(this.options);
	      this.store = new _ResourceStore2.default(this.options.resources, this.options);
	
	      var s = this.services;
	      s.logger = _logger2.default;
	      s.resourceStore = this.store;
	      s.languageUtils = lu;
	      s.pluralResolver = new _PluralResolver2.default(lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON, simplifyPluralSuffix: this.options.simplifyPluralSuffix });
	      s.interpolator = new _Interpolator2.default(this.options);
	
	      s.backendConnector = new _BackendConnector2.default(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
	      // pipe events from backendConnector
	      s.backendConnector.on('*', function (event) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        _this2.emit.apply(_this2, [event].concat(args));
	      });
	
	      if (this.modules.languageDetector) {
	        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
	        s.languageDetector.init(s, this.options.detection, this.options);
	      }
	
	      if (this.modules.i18nFormat) {
	        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
	        if (s.i18nFormat.init) s.i18nFormat.init(this);
	      }
	
	      this.translator = new _Translator2.default(this.services, this.options);
	      // pipe events from translator
	      this.translator.on('*', function (event) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	          args[_key2 - 1] = arguments[_key2];
	        }
	
	        _this2.emit.apply(_this2, [event].concat(args));
	      });
	
	      this.modules.external.forEach(function (m) {
	        if (m.init) m.init(_this2);
	      });
	    }
	
	    // append api
	    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
	    storeApi.forEach(function (fcName) {
	      _this2[fcName] = function () {
	        var _store;
	
	        return (_store = _this2.store)[fcName].apply(_store, arguments);
	      };
	    });
	
	    var load = function load() {
	      _this2.changeLanguage(_this2.options.lng, function (err, t) {
	        _this2.isInitialized = true;
	        _this2.logger.log('initialized', _this2.options);
	        _this2.emit('initialized', _this2.options);
	
	        callback(err, t);
	      });
	    };
	
	    if (this.options.resources || !this.options.initImmediate) {
	      load();
	    } else {
	      setTimeout(load, 0);
	    }
	
	    return this;
	  };
	
	  /* eslint consistent-return: 0 */
	
	
	  I18n.prototype.loadResources = function loadResources() {
	    var _this3 = this;
	
	    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	
	    if (!this.options.resources) {
	      if (this.language && this.language.toLowerCase() === 'cimode') return callback(); // avoid loading resources for cimode
	
	      var toLoad = [];
	
	      var append = function append(lng) {
	        if (!lng) return;
	        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
	        lngs.forEach(function (l) {
	          if (toLoad.indexOf(l) < 0) toLoad.push(l);
	        });
	      };
	
	      if (!this.language) {
	        // at least load fallbacks in this case
	        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
	        fallbacks.forEach(function (l) {
	          return append(l);
	        });
	      } else {
	        append(this.language);
	      }
	
	      if (this.options.preload) {
	        this.options.preload.forEach(function (l) {
	          return append(l);
	        });
	      }
	
	      this.services.backendConnector.load(toLoad, this.options.ns, callback);
	    } else {
	      callback(null);
	    }
	  };
	
	  I18n.prototype.reloadResources = function reloadResources(lngs, ns, callback) {
	    if (!lngs) lngs = this.languages;
	    if (!ns) ns = this.options.ns;
	    if (!callback) callback = function callback() {};
	    this.services.backendConnector.reload(lngs, ns, callback);
	  };
	
	  I18n.prototype.use = function use(module) {
	    if (module.type === 'backend') {
	      this.modules.backend = module;
	    }
	
	    if (module.type === 'logger' || module.log && module.warn && module.error) {
	      this.modules.logger = module;
	    }
	
	    if (module.type === 'languageDetector') {
	      this.modules.languageDetector = module;
	    }
	
	    if (module.type === 'i18nFormat') {
	      this.modules.i18nFormat = module;
	    }
	
	    if (module.type === 'postProcessor') {
	      _postProcessor2.default.addPostProcessor(module);
	    }
	
	    if (module.type === '3rdParty') {
	      this.modules.external.push(module);
	    }
	
	    return this;
	  };
	
	  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
	    var _this4 = this;
	
	    var done = function done(err, l) {
	      _this4.translator.changeLanguage(l);
	
	      if (l) {
	        _this4.emit('languageChanged', l);
	        _this4.logger.log('languageChanged', l);
	      }
	
	      if (callback) callback(err, function () {
	        return _this4.t.apply(_this4, arguments);
	      });
	    };
	
	    var setLng = function setLng(l) {
	      if (l) {
	        _this4.language = l;
	        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
	        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
	
	        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
	      }
	
	      _this4.loadResources(function (err) {
	        done(err, l);
	      });
	    };
	
	    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
	      setLng(this.services.languageDetector.detect());
	    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
	      this.services.languageDetector.detect(setLng);
	    } else {
	      setLng(lng);
	    }
	  };
	
	  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
	    var _this5 = this;
	
	    var fixedT = function fixedT(key, opts) {
	      for (var _len3 = arguments.length, rest = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	        rest[_key3 - 2] = arguments[_key3];
	      }
	
	      var options = _extends({}, opts);
	      if ((typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) !== 'object') {
	        options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
	      }
	
	      options.lng = options.lng || fixedT.lng;
	      options.lngs = options.lngs || fixedT.lngs;
	      options.ns = options.ns || fixedT.ns;
	      return _this5.t(key, options);
	    };
	    if (typeof lng === 'string') {
	      fixedT.lng = lng;
	    } else {
	      fixedT.lngs = lng;
	    }
	    fixedT.ns = ns;
	    return fixedT;
	  };
	
	  I18n.prototype.t = function t() {
	    var _translator;
	
	    return this.translator && (_translator = this.translator).translate.apply(_translator, arguments);
	  };
	
	  I18n.prototype.exists = function exists() {
	    var _translator2;
	
	    return this.translator && (_translator2 = this.translator).exists.apply(_translator2, arguments);
	  };
	
	  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
	    this.options.defaultNS = ns;
	  };
	
	  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
	    var _this6 = this;
	
	    if (!this.options.ns) return callback && callback();
	    if (typeof ns === 'string') ns = [ns];
	
	    ns.forEach(function (n) {
	      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
	    });
	
	    this.loadResources(callback);
	  };
	
	  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
	    if (typeof lngs === 'string') lngs = [lngs];
	    var preloaded = this.options.preload || [];
	
	    var newLngs = lngs.filter(function (lng) {
	      return preloaded.indexOf(lng) < 0;
	    });
	    // Exit early if all given languages are already preloaded
	    if (!newLngs.length) return callback();
	
	    this.options.preload = preloaded.concat(newLngs);
	    this.loadResources(callback);
	  };
	
	  I18n.prototype.dir = function dir(lng) {
	    if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
	    if (!lng) return 'rtl';
	
	    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
	
	    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
	  };
	
	  /* eslint class-methods-use-this: 0 */
	
	
	  I18n.prototype.createInstance = function createInstance() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments[1];
	
	    return new I18n(options, callback);
	  };
	
	  I18n.prototype.cloneInstance = function cloneInstance() {
	    var _this7 = this;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	
	    var mergedOptions = _extends({}, this.options, options, { isClone: true });
	    var clone = new I18n(mergedOptions);
	    var membersToCopy = ['store', 'services', 'language'];
	    membersToCopy.forEach(function (m) {
	      clone[m] = _this7[m];
	    });
	    clone.translator = new _Translator2.default(clone.services, clone.options);
	    clone.translator.on('*', function (event) {
	      for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	        args[_key4 - 1] = arguments[_key4];
	      }
	
	      clone.emit.apply(clone, [event].concat(args));
	    });
	    clone.init(mergedOptions, callback);
	    clone.translator.options = clone.options; // sync options
	
	    return clone;
	  };
	
	  return I18n;
	}(_EventEmitter3.default);
	
	exports.default = new I18n();

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.use = exports.t = exports.setDefaultNamespace = exports.on = exports.off = exports.loadResources = exports.loadNamespaces = exports.loadLanguages = exports.init = exports.getFixedT = exports.exists = exports.dir = exports.createInstance = exports.cloneInstance = exports.changeLanguage = undefined;
	
	var _i18next = __webpack_require__(278);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _i18next2.default;
	var changeLanguage = exports.changeLanguage = _i18next2.default.changeLanguage.bind(_i18next2.default);
	var cloneInstance = exports.cloneInstance = _i18next2.default.cloneInstance.bind(_i18next2.default);
	var createInstance = exports.createInstance = _i18next2.default.createInstance.bind(_i18next2.default);
	var dir = exports.dir = _i18next2.default.dir.bind(_i18next2.default);
	var exists = exports.exists = _i18next2.default.exists.bind(_i18next2.default);
	var getFixedT = exports.getFixedT = _i18next2.default.getFixedT.bind(_i18next2.default);
	var init = exports.init = _i18next2.default.init.bind(_i18next2.default);
	var loadLanguages = exports.loadLanguages = _i18next2.default.loadLanguages.bind(_i18next2.default);
	var loadNamespaces = exports.loadNamespaces = _i18next2.default.loadNamespaces.bind(_i18next2.default);
	var loadResources = exports.loadResources = _i18next2.default.loadResources.bind(_i18next2.default);
	var off = exports.off = _i18next2.default.off.bind(_i18next2.default);
	var on = exports.on = _i18next2.default.on.bind(_i18next2.default);
	var setDefaultNamespace = exports.setDefaultNamespace = _i18next2.default.setDefaultNamespace.bind(_i18next2.default);
	var t = exports.t = _i18next2.default.t.bind(_i18next2.default);
	var use = exports.use = _i18next2.default.use.bind(_i18next2.default);

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var consoleLogger = {
	  type: 'logger',
	
	  log: function log(args) {
	    this.output('log', args);
	  },
	  warn: function warn(args) {
	    this.output('warn', args);
	  },
	  error: function error(args) {
	    this.output('error', args);
	  },
	  output: function output(type, args) {
	    var _console;
	
	    /* eslint no-console: 0 */
	    if (console && console[type]) (_console = console)[type].apply(_console, _toConsumableArray(args));
	  }
	};
	
	var Logger = function () {
	  function Logger(concreteLogger) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Logger);
	
	    this.init(concreteLogger, options);
	  }
	
	  Logger.prototype.init = function init(concreteLogger) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    this.prefix = options.prefix || 'i18next:';
	    this.logger = concreteLogger || consoleLogger;
	    this.options = options;
	    this.debug = options.debug;
	  };
	
	  Logger.prototype.setDebug = function setDebug(bool) {
	    this.debug = bool;
	  };
	
	  Logger.prototype.log = function log() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return this.forward(args, 'log', '', true);
	  };
	
	  Logger.prototype.warn = function warn() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return this.forward(args, 'warn', '', true);
	  };
	
	  Logger.prototype.error = function error() {
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return this.forward(args, 'error', '');
	  };
	
	  Logger.prototype.deprecate = function deprecate() {
	    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
	  };
	
	  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
	    if (debugOnly && !this.debug) return null;
	    if (typeof args[0] === 'string') args[0] = '' + prefix + this.prefix + ' ' + args[0];
	    return this.logger[lvl](args);
	  };
	
	  Logger.prototype.create = function create(moduleName) {
	    return new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
	  };
	
	  return Logger;
	}();
	
	exports.default = new Logger();

/***/ }),

/***/ 136:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  processors: {},
	
	  addPostProcessor: function addPostProcessor(module) {
	    this.processors[module.name] = module;
	  },
	  handle: function handle(processors, value, key, options, translator) {
	    var _this = this;
	
	    processors.forEach(function (processor) {
	      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
	    });
	
	    return value;
	  }
	};

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeString = makeString;
	exports.copy = copy;
	exports.setPath = setPath;
	exports.pushPath = pushPath;
	exports.getPath = getPath;
	exports.deepExtend = deepExtend;
	exports.regexEscape = regexEscape;
	exports.escape = escape;
	function makeString(object) {
	  if (object == null) return '';
	  /* eslint prefer-template: 0 */
	  return '' + object;
	}
	
	function copy(a, s, t) {
	  a.forEach(function (m) {
	    if (s[m]) t[m] = s[m];
	  });
	}
	
	function getLastOfPath(object, path, Empty) {
	  function cleanKey(key) {
	    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
	  }
	
	  function canNotTraverseDeeper() {
	    return !object || typeof object === 'string';
	  }
	
	  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
	  while (stack.length > 1) {
	    if (canNotTraverseDeeper()) return {};
	
	    var key = cleanKey(stack.shift());
	    if (!object[key] && Empty) object[key] = new Empty();
	    object = object[key];
	  }
	
	  if (canNotTraverseDeeper()) return {};
	  return {
	    obj: object,
	    k: cleanKey(stack.shift())
	  };
	}
	
	function setPath(object, path, newValue) {
	  var _getLastOfPath = getLastOfPath(object, path, Object),
	      obj = _getLastOfPath.obj,
	      k = _getLastOfPath.k;
	
	  obj[k] = newValue;
	}
	
	function pushPath(object, path, newValue, concat) {
	  var _getLastOfPath2 = getLastOfPath(object, path, Object),
	      obj = _getLastOfPath2.obj,
	      k = _getLastOfPath2.k;
	
	  obj[k] = obj[k] || [];
	  if (concat) obj[k] = obj[k].concat(newValue);
	  if (!concat) obj[k].push(newValue);
	}
	
	function getPath(object, path) {
	  var _getLastOfPath3 = getLastOfPath(object, path),
	      obj = _getLastOfPath3.obj,
	      k = _getLastOfPath3.k;
	
	  if (!obj) return undefined;
	  return obj[k];
	}
	
	function deepExtend(target, source, overwrite) {
	  /* eslint no-restricted-syntax: 0 */
	  for (var prop in source) {
	    if (prop in target) {
	      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
	      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
	        if (overwrite) target[prop] = source[prop];
	      } else {
	        deepExtend(target[prop], source[prop], overwrite);
	      }
	    } else {
	      target[prop] = source[prop];
	    }
	  }
	  return target;
	}
	
	function regexEscape(str) {
	  /* eslint no-useless-escape: 0 */
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	}
	
	/* eslint-disable */
	var _entityMap = {
	  "&": "&amp;",
	  "<": "&lt;",
	  ">": "&gt;",
	  '"': '&quot;',
	  "'": '&#39;',
	  "/": '&#x2F;'
	};
	/* eslint-enable */
	
	function escape(data) {
	  if (typeof data === 'string') {
	    return data.replace(/[&<>"'\/]/g, function (s) {
	      return _entityMap[s];
	    });
	  }
	
	  return data;
	}

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(279).default;


/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;(typeof navigator !== "undefined") && (function(root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return factory(root);
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === "object" && module.exports) {
	        module.exports = factory(root);
	    } else {
	        root.lottie = factory(root);
	        root.bodymovin = root.lottie;
	    }
	}((window || {}), function(window) {
	    "use strict";
	    var svgNS = "http://www.w3.org/2000/svg";
	
	var locationHref = '';
	
	var initialDefaultFrame = -999999;
	
	var subframeEnabled = true;
	var expressionsPlugin;
	var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	var cachedColors = {};
	var bm_rounder = Math.round;
	var bm_rnd;
	var bm_pow = Math.pow;
	var bm_sqrt = Math.sqrt;
	var bm_abs = Math.abs;
	var bm_floor = Math.floor;
	var bm_max = Math.max;
	var bm_min = Math.min;
	var blitter = 10;
	
	var BMMath = {};
	(function(){
	    var propertyNames = Object.getOwnPropertyNames(Math);
	    var i, len = propertyNames.length;
	    for(i=0;i<len;i+=1){
	        BMMath[propertyNames[i]] = Math[propertyNames[i]];
	    }
	}());
	
	function ProjectInterface(){return {};}
	
	BMMath.random = Math.random;
	BMMath.abs = function(val){
	    var tOfVal = typeof val;
	    if(tOfVal === 'object' && val.length){
	        var absArr = createSizedArray(val.length);
	        var i, len = val.length;
	        for(i=0;i<len;i+=1){
	            absArr[i] = Math.abs(val[i]);
	        }
	        return absArr;
	    }
	    return Math.abs(val);
	
	};
	var defaultCurveSegments = 150;
	var degToRads = Math.PI/180;
	var roundCorner = 0.5519;
	
	function roundValues(flag){
	    if(flag){
	        bm_rnd = Math.round;
	    }else{
	        bm_rnd = function(val){
	            return val;
	        };
	    }
	}
	roundValues(false);
	
	function styleDiv(element){
	    element.style.position = 'absolute';
	    element.style.top = 0;
	    element.style.left = 0;
	    element.style.display = 'block';
	    element.style.transformOrigin = element.style.webkitTransformOrigin = '0 0';
	    element.style.backfaceVisibility  = element.style.webkitBackfaceVisibility = 'visible';
	    element.style.transformStyle = element.style.webkitTransformStyle = element.style.mozTransformStyle = "preserve-3d";
	}
	
	function BMEnterFrameEvent(n,c,t,d){
	    this.type = n;
	    this.currentTime = c;
	    this.totalTime = t;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMCompleteEvent(n,d){
	    this.type = n;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMCompleteLoopEvent(n,c,t,d){
	    this.type = n;
	    this.currentLoop = t;
	    this.totalLoops = c;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMSegmentStartEvent(n,f,t){
	    this.type = n;
	    this.firstFrame = f;
	    this.totalFrames = t;
	}
	
	function BMDestroyEvent(n,t){
	    this.type = n;
	    this.target = t;
	}
	
	var createElementID = (function(){
	    var _count = 0;
	    return function createID() {
	        return '__lottie_element_' + ++_count
	    }
	}())
	
	function HSVtoRGB(h, s, v) {
	    var r, g, b, i, f, p, q, t;
	    i = Math.floor(h * 6);
	    f = h * 6 - i;
	    p = v * (1 - s);
	    q = v * (1 - f * s);
	    t = v * (1 - (1 - f) * s);
	    switch (i % 6) {
	        case 0: r = v; g = t; b = p; break;
	        case 1: r = q; g = v; b = p; break;
	        case 2: r = p; g = v; b = t; break;
	        case 3: r = p; g = q; b = v; break;
	        case 4: r = t; g = p; b = v; break;
	        case 5: r = v; g = p; b = q; break;
	    }
	    return [ r,
	        g,
	         b ];
	}
	
	function RGBtoHSV(r, g, b) {
	    var max = Math.max(r, g, b), min = Math.min(r, g, b),
	        d = max - min,
	        h,
	        s = (max === 0 ? 0 : d / max),
	        v = max / 255;
	
	    switch (max) {
	        case min: h = 0; break;
	        case r: h = (g - b) + d * (g < b ? 6: 0); h /= 6 * d; break;
	        case g: h = (b - r) + d * 2; h /= 6 * d; break;
	        case b: h = (r - g) + d * 4; h /= 6 * d; break;
	    }
	
	    return [
	         h,
	         s,
	         v
	    ];
	}
	
	function addSaturationToRGB(color,offset){
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[1] += offset;
	    if (hsv[1] > 1) {
	        hsv[1] = 1;
	    }
	    else if (hsv[1] <= 0) {
	        hsv[1] = 0;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	function addBrightnessToRGB(color,offset){
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[2] += offset;
	    if (hsv[2] > 1) {
	        hsv[2] = 1;
	    }
	    else if (hsv[2] < 0) {
	        hsv[2] = 0;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	function addHueToRGB(color,offset) {
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[0] += offset/360;
	    if (hsv[0] > 1) {
	        hsv[0] -= 1;
	    }
	    else if (hsv[0] < 0) {
	        hsv[0] += 1;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	var rgbToHex = (function(){
	    var colorMap = [];
	    var i;
	    var hex;
	    for(i=0;i<256;i+=1){
	        hex = i.toString(16);
	        colorMap[i] = hex.length == 1 ? '0' + hex : hex;
	    }
	
	    return function(r, g, b) {
	        if(r<0){
	            r = 0;
	        }
	        if(g<0){
	            g = 0;
	        }
	        if(b<0){
	            b = 0;
	        }
	        return '#' + colorMap[r] + colorMap[g] + colorMap[b];
	    };
	}());
	function BaseEvent(){}
	BaseEvent.prototype = {
		triggerEvent: function (eventName, args) {
		    if (this._cbs[eventName]) {
		        var len = this._cbs[eventName].length;
		        for (var i = 0; i < len; i++){
		            this._cbs[eventName][i](args);
		        }
		    }
		},
		addEventListener: function (eventName, callback) {
		    if (!this._cbs[eventName]){
		        this._cbs[eventName] = [];
		    }
		    this._cbs[eventName].push(callback);
	
			return function() {
				this.removeEventListener(eventName, callback);
			}.bind(this);
		},
		removeEventListener: function (eventName,callback){
		    if (!callback){
		        this._cbs[eventName] = null;
		    }else if(this._cbs[eventName]){
		        var i = 0, len = this._cbs[eventName].length;
		        while(i<len){
		            if(this._cbs[eventName][i] === callback){
		                this._cbs[eventName].splice(i,1);
		                i -=1;
		                len -= 1;
		            }
		            i += 1;
		        }
		        if(!this._cbs[eventName].length){
		            this._cbs[eventName] = null;
		        }
		    }
		}
	};
	var createTypedArray = (function(){
		function createRegularArray(type, len){
			var i = 0, arr = [], value;
			switch(type) {
				case 'int16':
				case 'uint8c':
					value = 1;
					break;
				default:
					value = 1.1;
					break;
			}
			for(i = 0; i < len; i += 1) {
				arr.push(value);
			}
			return arr;
		}
		function createTypedArray(type, len){
			if(type === 'float32') {
				return new Float32Array(len);
			} else if(type === 'int16') {
				return new Int16Array(len);
			} else if(type === 'uint8c') {
				return new Uint8ClampedArray(len);
			}
		}
		if(typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
			return createTypedArray;
		} else {
			return createRegularArray;
		}
	}());
	
	function createSizedArray(len) {
		return Array.apply(null,{length:len});
	}
	function createNS(type) {
		//return {appendChild:function(){},setAttribute:function(){},style:{}}
		return document.createElementNS(svgNS, type);
	}
	function createTag(type) {
		//return {appendChild:function(){},setAttribute:function(){},style:{}}
		return document.createElement(type);
	}
	function DynamicPropertyContainer(){};
	DynamicPropertyContainer.prototype = {
		addDynamicProperty: function(prop) {
			if(this.dynamicProperties.indexOf(prop) === -1) {
		        this.dynamicProperties.push(prop);
		        this.container.addDynamicProperty(this);
		    	this._isAnimated = true;
		    }
		},
		iterateDynamicProperties: function(){
		    this._mdf = false;
		    var i, len = this.dynamicProperties.length;
		    for(i=0;i<len;i+=1){
		        this.dynamicProperties[i].getValue();
		        if(this.dynamicProperties[i]._mdf) {
		            this._mdf = true;
		        }
		    }
		},
		initDynamicPropertyContainer: function(container){
		    this.container = container;
		    this.dynamicProperties = [];
		    this._mdf = false;
		    this._isAnimated = false;
		}
	}
	var getBlendMode = (function() {
	
		var blendModeEnums = {
	        1:'multiply',
	        2:'screen',
	        3:'overlay',
	        4:'darken',
	        5:'lighten',
	        6:'color-dodge',
	        7:'color-burn',
	        8:'hard-light',
	        9:'soft-light',
	        10:'difference',
	        11:'exclusion',
	        12:'hue',
	        13:'saturation',
	        14:'color',
	        15:'luminosity'
	    }
	
		return function(mode) {
			return blendModeEnums[mode] || '';
		}
	}())
	/*!
	 Transformation Matrix v2.0
	 (c) Epistemex 2014-2015
	 www.epistemex.com
	 By Ken Fyrstenberg
	 Contributions by leeoniya.
	 License: MIT, header required.
	 */
	
	/**
	 * 2D transformation matrix object initialized with identity matrix.
	 *
	 * The matrix can synchronize a canvas context by supplying the context
	 * as an argument, or later apply current absolute transform to an
	 * existing context.
	 *
	 * All values are handled as floating point values.
	 *
	 * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
	 * @prop {number} a - scale x
	 * @prop {number} b - shear y
	 * @prop {number} c - shear x
	 * @prop {number} d - scale y
	 * @prop {number} e - translate x
	 * @prop {number} f - translate y
	 * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
	 * @constructor
	 */
	
	var Matrix = (function(){
	
	    var _cos = Math.cos;
	    var _sin = Math.sin;
	    var _tan = Math.tan;
	    var _rnd = Math.round;
	
	    function reset(){
	        this.props[0] = 1;
	        this.props[1] = 0;
	        this.props[2] = 0;
	        this.props[3] = 0;
	        this.props[4] = 0;
	        this.props[5] = 1;
	        this.props[6] = 0;
	        this.props[7] = 0;
	        this.props[8] = 0;
	        this.props[9] = 0;
	        this.props[10] = 1;
	        this.props[11] = 0;
	        this.props[12] = 0;
	        this.props[13] = 0;
	        this.props[14] = 0;
	        this.props[15] = 1;
	        return this;
	    }
	
	    function rotate(angle) {
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, -mSin,  0, 0, mSin,  mCos, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1);
	    }
	
	    function rotateX(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin,  mCos, 0, 0, 0, 0, 1);
	    }
	
	    function rotateY(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos,  0,  mSin, 0, 0, 1, 0, 0, -mSin,  0,  mCos, 0, 0, 0, 0, 1);
	    }
	
	    function rotateZ(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, -mSin,  0, 0, mSin,  mCos, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1);
	    }
	
	    function shear(sx,sy){
	        return this._t(1, sy, sx, 1, 0, 0);
	    }
	
	    function skew(ax, ay){
	        return this.shear(_tan(ax), _tan(ay));
	    }
	
	    function skewFromAxis(ax, angle){
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, mSin,  0, 0, -mSin,  mCos, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1)
	            ._t(1, 0,  0, 0, _tan(ax),  1, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1)
	            ._t(mCos, -mSin,  0, 0, mSin,  mCos, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1);
	        //return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
	    }
	
	    function scale(sx, sy, sz) {
	        if(!sz && sz !== 0) {
	            sz = 1;
	        }
	        if(sx === 1 && sy === 1 && sz === 1){
	            return this;
	        }
	        return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
	    }
	
	    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
	        this.props[0] = a;
	        this.props[1] = b;
	        this.props[2] = c;
	        this.props[3] = d;
	        this.props[4] = e;
	        this.props[5] = f;
	        this.props[6] = g;
	        this.props[7] = h;
	        this.props[8] = i;
	        this.props[9] = j;
	        this.props[10] = k;
	        this.props[11] = l;
	        this.props[12] = m;
	        this.props[13] = n;
	        this.props[14] = o;
	        this.props[15] = p;
	        return this;
	    }
	
	    function translate(tx, ty, tz) {
	        tz = tz || 0;
	        if(tx !== 0 || ty !== 0 || tz !== 0){
	            return this._t(1,0,0,0,0,1,0,0,0,0,1,0,tx,ty,tz,1);
	        }
	        return this;
	    }
	
	    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
	
	        var _p = this.props;
	
	        if(a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0){
	            //NOTE: commenting this condition because TurboFan deoptimizes code when present
	            //if(m2 !== 0 || n2 !== 0 || o2 !== 0){
	                _p[12] = _p[12] * a2 + _p[15] * m2;
	                _p[13] = _p[13] * f2 + _p[15] * n2;
	                _p[14] = _p[14] * k2 + _p[15] * o2;
	                _p[15] = _p[15] * p2;
	            //}
	            this._identityCalculated = false;
	            return this;
	        }
	
	        var a1 = _p[0];
	        var b1 = _p[1];
	        var c1 = _p[2];
	        var d1 = _p[3];
	        var e1 = _p[4];
	        var f1 = _p[5];
	        var g1 = _p[6];
	        var h1 = _p[7];
	        var i1 = _p[8];
	        var j1 = _p[9];
	        var k1 = _p[10];
	        var l1 = _p[11];
	        var m1 = _p[12];
	        var n1 = _p[13];
	        var o1 = _p[14];
	        var p1 = _p[15];
	
	        /* matrix order (canvas compatible):
	         * ace
	         * bdf
	         * 001
	         */
	        _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
	        _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2 ;
	        _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2 ;
	        _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2 ;
	
	        _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2 ;
	        _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2 ;
	        _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2 ;
	        _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2 ;
	
	        _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2 ;
	        _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2 ;
	        _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2 ;
	        _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2 ;
	
	        _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2 ;
	        _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2 ;
	        _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2 ;
	        _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2 ;
	
	        this._identityCalculated = false;
	        return this;
	    }
	
	    function isIdentity() {
	        if(!this._identityCalculated){
	            this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
	            this._identityCalculated = true;
	        }
	        return this._identity;
	    }
	
	    function equals(matr){
	        var i = 0;
	        while (i < 16) {
	            if(matr.props[i] !== this.props[i]) {
	                return false;
	            }
	            i+=1;
	        }
	        return true;
	    }
	
	    function clone(matr){
	        var i;
	        for(i=0;i<16;i+=1){
	            matr.props[i] = this.props[i];
	        }
	    }
	
	    function cloneFromProps(props){
	        var i;
	        for(i=0;i<16;i+=1){
	            this.props[i] = props[i];
	        }
	    }
	
	    function applyToPoint(x, y, z) {
	
	        return {
	            x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
	            y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
	            z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
	        };
	        /*return {
	         x: x * me.a + y * me.c + me.e,
	         y: x * me.b + y * me.d + me.f
	         };*/
	    }
	    function applyToX(x, y, z) {
	        return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
	    }
	    function applyToY(x, y, z) {
	        return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
	    }
	    function applyToZ(x, y, z) {
	        return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
	    }
	
	    function inversePoint(pt) {
	        var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
	        var a = this.props[5]/determinant;
	        var b = - this.props[1]/determinant;
	        var c = - this.props[4]/determinant;
	        var d = this.props[0]/determinant;
	        var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12])/determinant;
	        var f = - (this.props[0] * this.props[13] - this.props[1] * this.props[12])/determinant;
	        return [pt[0] * a + pt[1] * c + e, pt[0] * b + pt[1] * d + f, 0];
	    }
	
	    function inversePoints(pts){
	        var i, len = pts.length, retPts = [];
	        for(i=0;i<len;i+=1){
	            retPts[i] = inversePoint(pts[i]);
	        }
	        return retPts;
	    }
	
	    function applyToTriplePoints(pt1, pt2, pt3) {
	        var arr = createTypedArray('float32', 6);
	        if(this.isIdentity()) {
	            arr[0] = pt1[0];
	            arr[1] = pt1[1];
	            arr[2] = pt2[0];
	            arr[3] = pt2[1];
	            arr[4] = pt3[0];
	            arr[5] = pt3[1];
	        } else {
	            var p0 = this.props[0], p1 = this.props[1], p4 = this.props[4], p5 = this.props[5], p12 = this.props[12], p13 = this.props[13];
	            arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
	            arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
	            arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
	            arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
	            arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
	            arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
	        }
	        return arr;
	    }
	
	    function applyToPointArray(x,y,z){
	        var arr;
	        if(this.isIdentity()) {
	            arr = [x,y,z];
	        } else {
	            arr = [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
	        }
	        return arr;
	    }
	
	    function applyToPointStringified(x, y) {
	        if(this.isIdentity()) {
	            return x + ',' + y;
	        }
	        var _p = this.props;
	        return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100+','+ Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
	    }
	
	    function toCSS() {
	        //Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	        /*if(this.isIdentity()) {
	            return '';
	        }*/
	        var i = 0;
	        var props = this.props;
	        var cssValue = 'matrix3d(';
	        var v = 10000;
	        while(i<16){
	            cssValue += _rnd(props[i]*v)/v;
	            cssValue += i === 15 ? ')':',';
	            i += 1;
	        }
	        return cssValue;
	    }
	
	    function roundMatrixProperty(val) {
	        var v = 10000;
	        if((val < 0.000001 && val > 0) || (val > -0.000001 && val < 0)) {
	            return _rnd(val * v) / v;
	        }
	        return val;
	    }
	
	    function to2dCSS() {
	        //Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	        /*if(this.isIdentity()) {
	            return '';
	        }*/
	        var props = this.props;
	        var _a = roundMatrixProperty(props[0]);
	        var _b = roundMatrixProperty(props[1]);
	        var _c = roundMatrixProperty(props[4]);
	        var _d = roundMatrixProperty(props[5]);
	        var _e = roundMatrixProperty(props[12]);
	        var _f = roundMatrixProperty(props[13]);
	        return "matrix(" + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ")";
	    }
	
	    return function(){
	        this.reset = reset;
	        this.rotate = rotate;
	        this.rotateX = rotateX;
	        this.rotateY = rotateY;
	        this.rotateZ = rotateZ;
	        this.skew = skew;
	        this.skewFromAxis = skewFromAxis;
	        this.shear = shear;
	        this.scale = scale;
	        this.setTransform = setTransform;
	        this.translate = translate;
	        this.transform = transform;
	        this.applyToPoint = applyToPoint;
	        this.applyToX = applyToX;
	        this.applyToY = applyToY;
	        this.applyToZ = applyToZ;
	        this.applyToPointArray = applyToPointArray;
	        this.applyToTriplePoints = applyToTriplePoints;
	        this.applyToPointStringified = applyToPointStringified;
	        this.toCSS = toCSS;
	        this.to2dCSS = to2dCSS;
	        this.clone = clone;
	        this.cloneFromProps = cloneFromProps;
	        this.equals = equals;
	        this.inversePoints = inversePoints;
	        this.inversePoint = inversePoint;
	        this._t = this.transform;
	        this.isIdentity = isIdentity;
	        this._identity = true;
	        this._identityCalculated = false;
	
	        this.props = createTypedArray('float32', 16);
	        this.reset();
	    };
	}());
	
	/*
	 Copyright 2014 David Bau.
	
	 Permission is hereby granted, free of charge, to any person obtaining
	 a copy of this software and associated documentation files (the
	 "Software"), to deal in the Software without restriction, including
	 without limitation the rights to use, copy, modify, merge, publish,
	 distribute, sublicense, and/or sell copies of the Software, and to
	 permit persons to whom the Software is furnished to do so, subject to
	 the following conditions:
	
	 The above copyright notice and this permission notice shall be
	 included in all copies or substantial portions of the Software.
	
	 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	 */
	
	(function (pool, math) {
	//
	// The following constants are related to IEEE 754 limits.
	//
	    var global = this,
	        width = 256,        // each RC4 output is 0 <= x < 256
	        chunks = 6,         // at least six RC4 outputs for each double
	        digits = 52,        // there are 52 significant digits in a double
	        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
	        startdenom = math.pow(width, chunks),
	        significance = math.pow(2, digits),
	        overflow = significance * 2,
	        mask = width - 1,
	        nodecrypto;         // node.js crypto module, initialized at the bottom.
	
	//
	// seedrandom()
	// This is the seedrandom function described above.
	//
	    function seedrandom(seed, options, callback) {
	        var key = [];
	        options = (options === true) ? { entropy: true } : (options || {});
	
	        // Flatten the seed string or build one from local entropy if needed.
	        var shortseed = mixkey(flatten(
	            options.entropy ? [seed, tostring(pool)] :
	                (seed === null) ? autoseed() : seed, 3), key);
	
	        // Use the seed to initialize an ARC4 generator.
	        var arc4 = new ARC4(key);
	
	        // This function returns a random double in [0, 1) that contains
	        // randomness in every bit of the mantissa of the IEEE 754 value.
	        var prng = function() {
	            var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
	                d = startdenom,                 //   and denominator d = 2 ^ 48.
	                x = 0;                          //   and no 'extra last byte'.
	            while (n < significance) {          // Fill up all significant digits by
	                n = (n + x) * width;              //   shifting numerator and
	                d *= width;                       //   denominator and generating a
	                x = arc4.g(1);                    //   new least-significant-byte.
	            }
	            while (n >= overflow) {             // To avoid rounding up, before adding
	                n /= 2;                           //   last byte, shift everything
	                d /= 2;                           //   right using integer math until
	                x >>>= 1;                         //   we have exactly the desired bits.
	            }
	            return (n + x) / d;                 // Form the number within [0, 1).
	        };
	
	        prng.int32 = function() { return arc4.g(4) | 0; };
	        prng.quick = function() { return arc4.g(4) / 0x100000000; };
	        prng.double = prng;
	
	        // Mix the randomness into accumulated entropy.
	        mixkey(tostring(arc4.S), pool);
	
	        // Calling convention: what to return as a function of prng, seed, is_math.
	        return (options.pass || callback ||
	        function(prng, seed, is_math_call, state) {
	            if (state) {
	                // Load the arc4 state from the given state if it has an S array.
	                if (state.S) { copy(state, arc4); }
	                // Only provide the .state method if requested via options.state.
	                prng.state = function() { return copy(arc4, {}); };
	            }
	
	            // If called as a method of Math (Math.seedrandom()), mutate
	            // Math.random because that is how seedrandom.js has worked since v1.0.
	            if (is_math_call) { math[rngname] = prng; return seed; }
	
	            // Otherwise, it is a newer calling convention, so return the
	            // prng directly.
	            else return prng;
	        })(
	            prng,
	            shortseed,
	            'global' in options ? options.global : (this == math),
	            options.state);
	    }
	    math['seed' + rngname] = seedrandom;
	
	//
	// ARC4
	//
	// An ARC4 implementation.  The constructor takes a key in the form of
	// an array of at most (width) integers that should be 0 <= x < (width).
	//
	// The g(count) method returns a pseudorandom integer that concatenates
	// the next (count) outputs from ARC4.  Its return value is a number x
	// that is in the range 0 <= x < (width ^ count).
	//
	    function ARC4(key) {
	        var t, keylen = key.length,
	            me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
	
	        // The empty key [] is treated as [0].
	        if (!keylen) { key = [keylen++]; }
	
	        // Set up S using the standard key scheduling algorithm.
	        while (i < width) {
	            s[i] = i++;
	        }
	        for (i = 0; i < width; i++) {
	            s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
	            s[j] = t;
	        }
	
	        // The "g" method returns the next (count) outputs as one number.
	        me.g = function(count) {
	            // Using instance members instead of closure state nearly doubles speed.
	            var t, r = 0,
	                i = me.i, j = me.j, s = me.S;
	            while (count--) {
	                t = s[i = mask & (i + 1)];
	                r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
	            }
	            me.i = i; me.j = j;
	            return r;
	            // For robust unpredictability, the function call below automatically
	            // discards an initial batch of values.  This is called RC4-drop[256].
	            // See http://google.com/search?q=rsa+fluhrer+response&btnI
	        };
	    }
	
	//
	// copy()
	// Copies internal state of ARC4 to or from a plain object.
	//
	    function copy(f, t) {
	        t.i = f.i;
	        t.j = f.j;
	        t.S = f.S.slice();
	        return t;
	    }
	
	//
	// flatten()
	// Converts an object tree to nested arrays of strings.
	//
	    function flatten(obj, depth) {
	        var result = [], typ = (typeof obj), prop;
	        if (depth && typ == 'object') {
	            for (prop in obj) {
	                try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
	            }
	        }
	        return (result.length ? result : typ == 'string' ? obj : obj + '\0');
	    }
	
	//
	// mixkey()
	// Mixes a string seed into a key that is an array of integers, and
	// returns a shortened string seed that is equivalent to the result key.
	//
	    function mixkey(seed, key) {
	        var stringseed = seed + '', smear, j = 0;
	        while (j < stringseed.length) {
	            key[mask & j] =
	                mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
	        }
	        return tostring(key);
	    }
	
	//
	// autoseed()
	// Returns an object for autoseeding, using window.crypto and Node crypto
	// module if available.
	//
	    function autoseed() {
	        try {
	            if (nodecrypto) { return tostring(nodecrypto.randomBytes(width)); }
	            var out = new Uint8Array(width);
	            (global.crypto || global.msCrypto).getRandomValues(out);
	            return tostring(out);
	        } catch (e) {
	            var browser = global.navigator,
	                plugins = browser && browser.plugins;
	            return [+new Date(), global, plugins, global.screen, tostring(pool)];
	        }
	    }
	
	//
	// tostring()
	// Converts an array of charcodes to a string
	//
	    function tostring(a) {
	        return String.fromCharCode.apply(0, a);
	    }
	
	//
	// When seedrandom.js is loaded, we immediately mix a few bits
	// from the built-in RNG into the entropy pool.  Because we do
	// not want to interfere with deterministic PRNG state later,
	// seedrandom will not call math.random on its own again after
	// initialization.
	//
	    mixkey(math.random(), pool);
	
	//
	// Nodejs and AMD support: export the implementation as a module using
	// either convention.
	//
	
	// End anonymous scope, and pass initial values.
	})(
	    [],     // pool: entropy pool starts empty
	    BMMath    // math: package containing random, pow, and seedrandom
	);
	var BezierFactory = (function(){
	    /**
	     * BezierEasing - use bezier curve for transition easing function
	     * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	     *
	     * Credits: is based on Firefox's nsSMILKeySpline.cpp
	     * Usage:
	     * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
	     * spline.get(x) => returns the easing value | x must be in [0, 1] range
	     *
	     */
	
	        var ob = {};
	    ob.getBezierEasing = getBezierEasing;
	    var beziers = {};
	
	    function getBezierEasing(a,b,c,d,nm){
	        var str = nm || ('bez_' + a+'_'+b+'_'+c+'_'+d).replace(/\./g, 'p');
	        if(beziers[str]){
	            return beziers[str];
	        }
	        var bezEasing = new BezierEasing([a,b,c,d]);
	        beziers[str] = bezEasing;
	        return bezEasing;
	    }
	
	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	    var NEWTON_ITERATIONS = 4;
	    var NEWTON_MIN_SLOPE = 0.001;
	    var SUBDIVISION_PRECISION = 0.0000001;
	    var SUBDIVISION_MAX_ITERATIONS = 10;
	
	    var kSplineTableSize = 11;
	    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	    var float32ArraySupported = typeof Float32Array === "function";
	
	    function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	    function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	    function C (aA1)      { return 3.0 * aA1; }
	
	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	    function calcBezier (aT, aA1, aA2) {
	        return ((A(aA1, aA2)*aT + B(aA1, aA2))*aT + C(aA1))*aT;
	    }
	
	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	    function getSlope (aT, aA1, aA2) {
	        return 3.0 * A(aA1, aA2)*aT*aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
	    }
	
	    function binarySubdivide (aX, aA, aB, mX1, mX2) {
	        var currentX, currentT, i = 0;
	        do {
	            currentT = aA + (aB - aA) / 2.0;
	            currentX = calcBezier(currentT, mX1, mX2) - aX;
	            if (currentX > 0.0) {
	                aB = currentT;
	            } else {
	                aA = currentT;
	            }
	        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	        return currentT;
	    }
	
	    function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
	        for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	            var currentSlope = getSlope(aGuessT, mX1, mX2);
	            if (currentSlope === 0.0) return aGuessT;
	            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	            aGuessT -= currentX / currentSlope;
	        }
	        return aGuessT;
	    }
	
	    /**
	     * points is an array of [ mX1, mY1, mX2, mY2 ]
	     */
	    function BezierEasing (points) {
	        this._p = points;
	        this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	        this._precomputed = false;
	
	        this.get = this.get.bind(this);
	    }
	
	    BezierEasing.prototype = {
	
	        get: function (x) {
	            var mX1 = this._p[0],
	                mY1 = this._p[1],
	                mX2 = this._p[2],
	                mY2 = this._p[3];
	            if (!this._precomputed) this._precompute();
	            if (mX1 === mY1 && mX2 === mY2) return x; // linear
	            // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	            if (x === 0) return 0;
	            if (x === 1) return 1;
	            return calcBezier(this._getTForX(x), mY1, mY2);
	        },
	
	        // Private part
	
	        _precompute: function () {
	            var mX1 = this._p[0],
	                mY1 = this._p[1],
	                mX2 = this._p[2],
	                mY2 = this._p[3];
	            this._precomputed = true;
	            if (mX1 !== mY1 || mX2 !== mY2)
	                this._calcSampleValues();
	        },
	
	        _calcSampleValues: function () {
	            var mX1 = this._p[0],
	                mX2 = this._p[2];
	            for (var i = 0; i < kSplineTableSize; ++i) {
	                this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	            }
	        },
	
	        /**
	         * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
	         */
	        _getTForX: function (aX) {
	            var mX1 = this._p[0],
	                mX2 = this._p[2],
	                mSampleValues = this._mSampleValues;
	
	            var intervalStart = 0.0;
	            var currentSample = 1;
	            var lastSample = kSplineTableSize - 1;
	
	            for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
	                intervalStart += kSampleStepSize;
	            }
	            --currentSample;
	
	            // Interpolate to provide an initial guess for t
	            var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample+1] - mSampleValues[currentSample]);
	            var guessForT = intervalStart + dist * kSampleStepSize;
	
	            var initialSlope = getSlope(guessForT, mX1, mX2);
	            if (initialSlope >= NEWTON_MIN_SLOPE) {
	                return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	            } else if (initialSlope === 0.0) {
	                return guessForT;
	            } else {
	                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	            }
	        }
	    };
	
	    return ob;
	
	}());
	(function () {
	    var lastTime = 0;
	    var vendors = ['ms', 'moz', 'webkit', 'o'];
	    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	    }
	    if(!window.requestAnimationFrame)
	        window.requestAnimationFrame = function (callback, element) {
	            var currTime = new Date().getTime();
	            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	            var id = setTimeout(function () {
	                    callback(currTime + timeToCall);
	                },
	                timeToCall);
	            lastTime = currTime + timeToCall;
	            return id;
	        };
	    if(!window.cancelAnimationFrame)
	        window.cancelAnimationFrame = function (id) {
	            clearTimeout(id);
	        };
	}());
	
	function extendPrototype(sources,destination){
	    var i, len = sources.length, sourcePrototype;
	    for (i = 0;i < len;i += 1) {
	        sourcePrototype = sources[i].prototype;
	        for (var attr in sourcePrototype) {
	            if (sourcePrototype.hasOwnProperty(attr)) destination.prototype[attr] = sourcePrototype[attr];
	        }
	    }
	}
	
	function getDescriptor(object, prop) {
	    return Object.getOwnPropertyDescriptor(object, prop);
	}
	
	function createProxyFunction(prototype) {
		function ProxyFunction(){}
		ProxyFunction.prototype = prototype;
		return ProxyFunction;
	}
	function bezFunction(){
	
	    var easingFunctions = [];
	    var math = Math;
	
	    function pointOnLine2D(x1,y1, x2,y2, x3,y3){
	        var det1 = (x1*y2) + (y1*x3) + (x2*y3) - (x3*y2) - (y3*x1) - (x2*y1);
	        return det1 > -0.001 && det1 < 0.001;
	    }
	
	    function pointOnLine3D(x1,y1,z1, x2,y2,z2, x3,y3,z3){
	        if(z1 === 0 && z2 === 0 && z3 === 0) {
	            return pointOnLine2D(x1,y1, x2,y2, x3,y3);
	        }
	        var dist1 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2) + Math.pow(z2 - z1, 2));
	        var dist2 = Math.sqrt(Math.pow(x3 - x1, 2) + Math.pow(y3 - y1, 2) + Math.pow(z3 - z1, 2));
	        var dist3 = Math.sqrt(Math.pow(x3 - x2, 2) + Math.pow(y3 - y2, 2) + Math.pow(z3 - z2, 2));
	        var diffDist;
	        if(dist1 > dist2){
	            if(dist1 > dist3){
	                diffDist = dist1 - dist2 - dist3;
	            } else {
	                diffDist = dist3 - dist2 - dist1;
	            }
	        } else if(dist3 > dist2){
	            diffDist = dist3 - dist2 - dist1;
	        } else {
	            diffDist = dist2 - dist1 - dist3;
	        }
	        return diffDist > -0.0001 && diffDist < 0.0001;
	    }
	
	    var getBezierLength = (function(){
	
	        return function(pt1,pt2,pt3,pt4){
	            var curveSegments = defaultCurveSegments;
	            var k;
	            var i, len;
	            var ptCoord,perc,addedLength = 0;
	            var ptDistance;
	            var point = [],lastPoint = [];
	            var lengthData = bezier_length_pool.newElement();
	            len = pt3.length;
	            for(k=0;k<curveSegments;k+=1){
	                perc = k/(curveSegments-1);
	                ptDistance = 0;
	                for(i=0;i<len;i+=1){
	                    ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*pt3[i]+3*(1-perc)*bm_pow(perc,2)*pt4[i]+bm_pow(perc,3)*pt2[i];
	                    point[i] = ptCoord;
	                    if(lastPoint[i] !== null){
	                        ptDistance += bm_pow(point[i] - lastPoint[i],2);
	                    }
	                    lastPoint[i] = point[i];
	                }
	                if(ptDistance){
	                    ptDistance = bm_sqrt(ptDistance);
	                    addedLength += ptDistance;
	                }
	                lengthData.percents[k] = perc;
	                lengthData.lengths[k] = addedLength;
	            }
	            lengthData.addedLength = addedLength;
	            return lengthData;
	        };
	    }());
	
	    function getSegmentsLength(shapeData) {
	        var segmentsLength = segments_length_pool.newElement();
	        var closed = shapeData.c;
	        var pathV = shapeData.v;
	        var pathO = shapeData.o;
	        var pathI = shapeData.i;
	        var i, len = shapeData._length;
	        var lengths = segmentsLength.lengths;
	        var totalLength = 0;
	        for(i=0;i<len-1;i+=1){
	            lengths[i] = getBezierLength(pathV[i],pathV[i+1],pathO[i],pathI[i+1]);
	            totalLength += lengths[i].addedLength;
	        }
	        if(closed && len){
	            lengths[i] = getBezierLength(pathV[i],pathV[0],pathO[i],pathI[0]);
	            totalLength += lengths[i].addedLength;
	        }
	        segmentsLength.totalLength = totalLength;
	        return segmentsLength;
	    }
	
	    function BezierData(length){
	        this.segmentLength = 0;
	        this.points = new Array(length);
	    }
	
	    function PointData(partial,point){
	        this.partialLength = partial;
	        this.point = point;
	    }
	
	    var buildBezierData = (function(){
	
	        var storedData = {};
	
	        return function (keyData){
	            var pt1 = keyData.s;
	            var pt2 = keyData.e;
	            var pt3 = keyData.to;
	            var pt4 = keyData.ti;
	            var bezierName = (pt1[0]+'_'+pt1[1]+'_'+pt2[0]+'_'+pt2[1]+'_'+pt3[0]+'_'+pt3[1]+'_'+pt4[0]+'_'+pt4[1]).replace(/\./g, 'p');
	            if(storedData[bezierName]){
	                keyData.bezierData = storedData[bezierName];
	                return;
	            }
	            var curveSegments = defaultCurveSegments;
	            var k, i, len;
	            var ptCoord,perc,addedLength = 0;
	            var ptDistance;
	            var point,lastPoint = null;
	            if (pt1.length === 2 && (pt1[0] != pt2[0] || pt1[1] != pt2[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt1[0]+pt3[0],pt1[1]+pt3[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt2[0]+pt4[0],pt2[1]+pt4[1])){
	                curveSegments = 2;
	            }
	            var bezierData = new BezierData(curveSegments);
	            len = pt3.length;
	            for (k = 0; k < curveSegments; k += 1) {
	                point = createSizedArray(len);
	                perc = k / (curveSegments - 1);
	                ptDistance = 0;
	                for (i = 0; i < len; i += 1){
	                    ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*(pt1[i] + pt3[i])+3*(1-perc)*bm_pow(perc,2)*(pt2[i] + pt4[i])+bm_pow(perc,3)*pt2[i];
	                    point[i] = ptCoord;
	                    if(lastPoint !== null){
	                        ptDistance += bm_pow(point[i] - lastPoint[i],2);
	                    }
	                }
	                ptDistance = bm_sqrt(ptDistance);
	                addedLength += ptDistance;
	                bezierData.points[k] = new PointData(ptDistance, point);
	                lastPoint = point;
	            }
	            bezierData.segmentLength = addedLength;
	            keyData.bezierData = bezierData;
	            storedData[bezierName] = bezierData;
	        };
	    }());
	
	    function getDistancePerc(perc,bezierData){
	        var percents = bezierData.percents;
	        var lengths = bezierData.lengths;
	        var len = percents.length;
	        var initPos = bm_floor((len-1)*perc);
	        var lengthPos = perc*bezierData.addedLength;
	        var lPerc = 0;
	        if(initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]){
	            return percents[initPos];
	        }else{
	            var dir = lengths[initPos] > lengthPos ? -1 : 1;
	            var flag = true;
	            while(flag){
	                if(lengths[initPos] <= lengthPos && lengths[initPos+1] > lengthPos){
	                    lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos+1] - lengths[initPos]);
	                    flag = false;
	                }else{
	                    initPos += dir;
	                }
	                if(initPos < 0 || initPos >= len - 1){
	                    //FIX for TypedArrays that don't store floating point values with enough accuracy
	                    if(initPos === len - 1) {
	                        return percents[initPos];
	                    }
	                    flag = false;
	                }
	            }
	            return percents[initPos] + (percents[initPos+1] - percents[initPos])*lPerc;
	        }
	    }
	
	    function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
	        var t1 = getDistancePerc(percent,bezierData);
	        var u0 = 1;
	        var u1 = 1 - t1;
	        var ptX = Math.round((u1*u1*u1* pt1[0] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[0] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[0] + t1*t1*t1* pt2[0])* 1000) / 1000;
	        var ptY = Math.round((u1*u1*u1* pt1[1] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[1] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[1] + t1*t1*t1* pt2[1])* 1000) / 1000;
	        return [ptX, ptY];
	    }
	
	    function getSegmentArray() {
	
	    }
	
	    var bezier_segment_points = createTypedArray('float32', 8);
	
	    function getNewSegment(pt1,pt2,pt3,pt4,startPerc,endPerc, bezierData){
	
	        startPerc = startPerc < 0 ? 0 : startPerc > 1 ? 1 : startPerc;
	        var t0 = getDistancePerc(startPerc,bezierData);
	        endPerc = endPerc > 1 ? 1 : endPerc;
	        var t1 = getDistancePerc(endPerc,bezierData);
	        var i, len = pt1.length;
	        var u0 = 1 - t0;
	        var u1 = 1 - t1;
	        var u0u0u0 = u0*u0*u0;
	        var t0u0u0_3 = t0*u0*u0*3;
	        var t0t0u0_3 = t0*t0*u0*3;
	        var t0t0t0 = t0*t0*t0;
	        //
	        var u0u0u1 = u0*u0*u1;
	        var t0u0u1_3 = t0*u0*u1 + u0*t0*u1 + u0*u0*t1;
	        var t0t0u1_3 = t0*t0*u1 + u0*t0*t1 + t0*u0*t1;
	        var t0t0t1 = t0*t0*t1;
	        //
	        var u0u1u1 = u0*u1*u1;
	        var t0u1u1_3 = t0*u1*u1 + u0*t1*u1 + u0*u1*t1;
	        var t0t1u1_3 = t0*t1*u1 + u0*t1*t1 + t0*u1*t1;
	        var t0t1t1 = t0*t1*t1;
	        //
	        var u1u1u1 = u1*u1*u1;
	        var t1u1u1_3 = t1*u1*u1 + u1*t1*u1 + u1*u1*t1;
	        var t1t1u1_3 = t1*t1*u1 + u1*t1*t1 + t1*u1*t1;
	        var t1t1t1 = t1*t1*t1;
	        for(i=0;i<len;i+=1){
	            bezier_segment_points[i * 4] = Math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000;
	            bezier_segment_points[i * 4 + 1] = Math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000;
	            bezier_segment_points[i * 4 + 2] = Math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000;
	            bezier_segment_points[i * 4 + 3] = Math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000;
	        }
	
	        return bezier_segment_points;
	    }
	
	    return {
	        getSegmentsLength : getSegmentsLength,
	        getNewSegment : getNewSegment,
	        getPointInSegment : getPointInSegment,
	        buildBezierData : buildBezierData,
	        pointOnLine2D : pointOnLine2D,
	        pointOnLine3D : pointOnLine3D
	    };
	}
	
	var bez = bezFunction();
	function dataFunctionManager(){
	
	    //var tCanvasHelper = createTag('canvas').getContext('2d');
	
	    function completeLayers(layers, comps, fontManager){
	        var layerData;
	        var animArray, lastFrame;
	        var i, len = layers.length;
	        var j, jLen, k, kLen;
	        for(i=0;i<len;i+=1){
	            layerData = layers[i];
	            if(!('ks' in layerData) || layerData.completed){
	                continue;
	            }
	            layerData.completed = true;
	            if(layerData.tt){
	                layers[i-1].td = layerData.tt;
	            }
	            animArray = [];
	            lastFrame = -1;
	            if(layerData.hasMask){
	                var maskProps = layerData.masksProperties;
	                jLen = maskProps.length;
	                for(j=0;j<jLen;j+=1){
	                    if(maskProps[j].pt.k.i){
	                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
	                    }else{
	                        kLen = maskProps[j].pt.k.length;
	                        for(k=0;k<kLen;k+=1){
	                            if(maskProps[j].pt.k[k].s){
	                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
	                            }
	                            if(maskProps[j].pt.k[k].e){
	                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
	                            }
	                        }
	                    }
	                }
	            }
	            if(layerData.ty===0){
	                layerData.layers = findCompLayers(layerData.refId, comps);
	                completeLayers(layerData.layers,comps, fontManager);
	            }else if(layerData.ty === 4){
	                completeShapes(layerData.shapes);
	            }else if(layerData.ty == 5){
	                completeText(layerData, fontManager);
	            }
	        }
	    }
	
	    function findCompLayers(id,comps){
	        var i = 0, len = comps.length;
	        while(i<len){
	            if(comps[i].id === id){
	                if(!comps[i].layers.__used) {
	                    comps[i].layers.__used = true;
	                    return comps[i].layers;
	                }
	                return JSON.parse(JSON.stringify(comps[i].layers));
	            }
	            i += 1;
	        }
	    }
	
	    function completeShapes(arr){
	        var i, len = arr.length;
	        var j, jLen;
	        var hasPaths = false;
	        for(i=len-1;i>=0;i-=1){
	            if(arr[i].ty == 'sh'){
	                if(arr[i].ks.k.i){
	                    convertPathsToAbsoluteValues(arr[i].ks.k);
	                }else{
	                    jLen = arr[i].ks.k.length;
	                    for(j=0;j<jLen;j+=1){
	                        if(arr[i].ks.k[j].s){
	                            convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
	                        }
	                        if(arr[i].ks.k[j].e){
	                            convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
	                        }
	                    }
	                }
	                hasPaths = true;
	            }else if(arr[i].ty == 'gr'){
	                completeShapes(arr[i].it);
	            }
	        }
	        /*if(hasPaths){
	            //mx: distance
	            //ss: sensitivity
	            //dc: decay
	            arr.splice(arr.length-1,0,{
	                "ty": "ms",
	                "mx":20,
	                "ss":10,
	                 "dc":0.001,
	                "maxDist":200
	            });
	        }*/
	    }
	
	    function convertPathsToAbsoluteValues(path){
	        var i, len = path.i.length;
	        for(i=0;i<len;i+=1){
	            path.i[i][0] += path.v[i][0];
	            path.i[i][1] += path.v[i][1];
	            path.o[i][0] += path.v[i][0];
	            path.o[i][1] += path.v[i][1];
	        }
	    }
	
	    function checkVersion(minimum,animVersionString){
	        var animVersion = animVersionString ? animVersionString.split('.') : [100,100,100];
	        if(minimum[0]>animVersion[0]){
	            return true;
	        } else if(animVersion[0] > minimum[0]){
	            return false;
	        }
	        if(minimum[1]>animVersion[1]){
	            return true;
	        } else if(animVersion[1] > minimum[1]){
	            return false;
	        }
	        if(minimum[2]>animVersion[2]){
	            return true;
	        } else if(animVersion[2] > minimum[2]){
	            return false;
	        }
	    }
	
	    var checkText = (function(){
	        var minimumVersion = [4,4,14];
	
	        function updateTextLayer(textLayer){
	            var documentData = textLayer.t.d;
	            textLayer.t.d = {
	                k: [
	                    {
	                        s:documentData,
	                        t:0
	                    }
	                ]
	            };
	        }
	
	        function iterateLayers(layers){
	            var i, len = layers.length;
	            for(i=0;i<len;i+=1){
	                if(layers[i].ty === 5){
	                    updateTextLayer(layers[i]);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        };
	    }());
	
	    var checkChars = (function() {
	        var minimumVersion = [4,7,99];
	        return function (animationData){
	            if(animationData.chars && !checkVersion(minimumVersion,animationData.v)){
	                var i, len = animationData.chars.length, j, jLen, k, kLen;
	                var pathData, paths;
	                for(i = 0; i < len; i += 1) {
	                    if(animationData.chars[i].data && animationData.chars[i].data.shapes) {
	                        paths = animationData.chars[i].data.shapes[0].it;
	                        jLen = paths.length;
	
	                        for(j = 0; j < jLen; j += 1) {
	                            pathData = paths[j].ks.k;
	                            if(!pathData.__converted) {
	                                convertPathsToAbsoluteValues(paths[j].ks.k);
	                                pathData.__converted = true;
	                            }
	                        }
	                    }
	                }
	            }
	        };
	    }());
	
	    var checkColors = (function(){
	        var minimumVersion = [4,1,9];
	
	        function iterateShapes(shapes){
	            var i, len = shapes.length;
	            var j, jLen;
	            for(i=0;i<len;i+=1){
	                if(shapes[i].ty === 'gr'){
	                    iterateShapes(shapes[i].it);
	                }else if(shapes[i].ty === 'fl' || shapes[i].ty === 'st'){
	                    if(shapes[i].c.k && shapes[i].c.k[0].i){
	                        jLen = shapes[i].c.k.length;
	                        for(j=0;j<jLen;j+=1){
	                            if(shapes[i].c.k[j].s){
	                                shapes[i].c.k[j].s[0] /= 255;
	                                shapes[i].c.k[j].s[1] /= 255;
	                                shapes[i].c.k[j].s[2] /= 255;
	                                shapes[i].c.k[j].s[3] /= 255;
	                            }
	                            if(shapes[i].c.k[j].e){
	                                shapes[i].c.k[j].e[0] /= 255;
	                                shapes[i].c.k[j].e[1] /= 255;
	                                shapes[i].c.k[j].e[2] /= 255;
	                                shapes[i].c.k[j].e[3] /= 255;
	                            }
	                        }
	                    } else {
	                        shapes[i].c.k[0] /= 255;
	                        shapes[i].c.k[1] /= 255;
	                        shapes[i].c.k[2] /= 255;
	                        shapes[i].c.k[3] /= 255;
	                    }
	                }
	            }
	        }
	
	        function iterateLayers(layers){
	            var i, len = layers.length;
	            for(i=0;i<len;i+=1){
	                if(layers[i].ty === 4){
	                    iterateShapes(layers[i].shapes);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        };
	    }());
	
	    var checkShapes = (function(){
	        var minimumVersion = [4,4,18];
	
	
	
	        function completeShapes(arr){
	            var i, len = arr.length;
	            var j, jLen;
	            var hasPaths = false;
	            for(i=len-1;i>=0;i-=1){
	                if(arr[i].ty == 'sh'){
	                    if(arr[i].ks.k.i){
	                        arr[i].ks.k.c = arr[i].closed;
	                    }else{
	                        jLen = arr[i].ks.k.length;
	                        for(j=0;j<jLen;j+=1){
	                            if(arr[i].ks.k[j].s){
	                                arr[i].ks.k[j].s[0].c = arr[i].closed;
	                            }
	                            if(arr[i].ks.k[j].e){
	                                arr[i].ks.k[j].e[0].c = arr[i].closed;
	                            }
	                        }
	                    }
	                    hasPaths = true;
	                }else if(arr[i].ty == 'gr'){
	                    completeShapes(arr[i].it);
	                }
	            }
	        }
	
	        function iterateLayers(layers){
	            var layerData;
	            var i, len = layers.length;
	            var j, jLen, k, kLen;
	            for(i=0;i<len;i+=1){
	                layerData = layers[i];
	                if(layerData.hasMask){
	                    var maskProps = layerData.masksProperties;
	                    jLen = maskProps.length;
	                    for(j=0;j<jLen;j+=1){
	                        if(maskProps[j].pt.k.i){
	                            maskProps[j].pt.k.c = maskProps[j].cl;
	                        }else{
	                            kLen = maskProps[j].pt.k.length;
	                            for(k=0;k<kLen;k+=1){
	                                if(maskProps[j].pt.k[k].s){
	                                    maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
	                                }
	                                if(maskProps[j].pt.k[k].e){
	                                    maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
	                                }
	                            }
	                        }
	                    }
	                }
	                if(layerData.ty === 4){
	                    completeShapes(layerData.shapes);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        };
	    }());
	
	    function completeData(animationData, fontManager){
	        if(animationData.__complete){
	            return;
	        }
	        checkColors(animationData);
	        checkText(animationData);
	        checkChars(animationData);
	        checkShapes(animationData);
	        completeLayers(animationData.layers, animationData.assets, fontManager);
	        animationData.__complete = true;
	        //blitAnimation(animationData, animationData.assets, fontManager);
	    }
	
	    function completeText(data, fontManager){
	        if(data.t.a.length === 0 && !('m' in data.t.p)){
	            data.singleShape = true;
	        }
	    }
	
	    var moduleOb = {};
	    moduleOb.completeData = completeData;
	
	    return moduleOb;
	}
	
	var dataManager = dataFunctionManager();
	var FontManager = (function(){
	
	    var maxWaitingTime = 5000;
	    var emptyChar = {
	        w: 0,
	        size:0,
	        shapes:[]
	    };
	    var combinedCharacters = [];
	    //Hindi characters
	    combinedCharacters = combinedCharacters.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366
	    , 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379
	    , 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
	
	    function setUpNode(font, family){
	        var parentNode = createTag('span');
	        parentNode.style.fontFamily    = family;
	        var node = createTag('span');
	        // Characters that vary significantly among different fonts
	        node.innerHTML = 'giItT1WQy@!-/#';
	        // Visible - so we can measure it - but not on the screen
	        parentNode.style.position      = 'absolute';
	        parentNode.style.left          = '-10000px';
	        parentNode.style.top           = '-10000px';
	        // Large font size makes even subtle changes obvious
	        parentNode.style.fontSize      = '300px';
	        // Reset any font properties
	        parentNode.style.fontVariant   = 'normal';
	        parentNode.style.fontStyle     = 'normal';
	        parentNode.style.fontWeight    = 'normal';
	        parentNode.style.letterSpacing = '0';
	        parentNode.appendChild(node);
	        document.body.appendChild(parentNode);
	
	        // Remember width with no applied web font
	        var width = node.offsetWidth;
	        node.style.fontFamily = font + ', '+family;
	        return {node:node, w:width, parent:parentNode};
	    }
	
	    function checkLoadedFonts() {
	        var i, len = this.fonts.length;
	        var node, w;
	        var loadedCount = len;
	        for(i=0;i<len; i+= 1){
	            if(this.fonts[i].loaded){
	                loadedCount -= 1;
	                continue;
	            }
	            if(this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0){
	                this.fonts[i].loaded = true;
	            } else{
	                node = this.fonts[i].monoCase.node;
	                w = this.fonts[i].monoCase.w;
	                if(node.offsetWidth !== w){
	                    loadedCount -= 1;
	                    this.fonts[i].loaded = true;
	                }else{
	                    node = this.fonts[i].sansCase.node;
	                    w = this.fonts[i].sansCase.w;
	                    if(node.offsetWidth !== w){
	                        loadedCount -= 1;
	                        this.fonts[i].loaded = true;
	                    }
	                }
	                if(this.fonts[i].loaded){
	                    this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
	                    this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
	                }
	            }
	        }
	
	        if(loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime){
	            setTimeout(this.checkLoadedFonts.bind(this),20);
	        }else{
	            setTimeout(function(){this.isLoaded = true;}.bind(this),0);
	
	        }
	    }
	
	    function createHelper(def, fontData){
	        var tHelper = createNS('text');
	        tHelper.style.fontSize = '100px';
	        //tHelper.style.fontFamily = fontData.fFamily;
	        tHelper.setAttribute('font-family', fontData.fFamily);
	        tHelper.setAttribute('font-style', fontData.fStyle);
	        tHelper.setAttribute('font-weight', fontData.fWeight);
	        tHelper.textContent = '1';
	        if(fontData.fClass){
	            tHelper.style.fontFamily = 'inherit';
	            tHelper.className = fontData.fClass;
	        } else {
	            tHelper.style.fontFamily = fontData.fFamily;
	        }
	        def.appendChild(tHelper);
	        var tCanvasHelper = createTag('canvas').getContext('2d');
	        tCanvasHelper.font = fontData.fWeight + ' ' + fontData.fStyle + ' 100px '+ fontData.fFamily;
	        //tCanvasHelper.font = ' 100px '+ fontData.fFamily;
	        return tHelper;
	    }
	
	    function addFonts(fontData, defs){
	        if(!fontData){
	            this.isLoaded = true;
	            return;
	        }
	        if(this.chars){
	            this.isLoaded = true;
	            this.fonts = fontData.list;
	            return;
	        }
	
	
	        var fontArr = fontData.list;
	        var i, len = fontArr.length;
	        var _pendingFonts = len;
	        for(i=0; i<len; i+= 1){
	            var shouldLoadFont = true;
	            var loadedSelector;
	            var j;
	            fontArr[i].loaded = false;
	            fontArr[i].monoCase = setUpNode(fontArr[i].fFamily,'monospace');
	            fontArr[i].sansCase = setUpNode(fontArr[i].fFamily,'sans-serif');
	            if(!fontArr[i].fPath) {
	                fontArr[i].loaded = true;
	                _pendingFonts -= 1;
	            }else if(fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3){
	                loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="'+ fontArr[i].fFamily +'"], style[f-origin="3"][f-family="'+ fontArr[i].fFamily +'"]');
	
	                if (loadedSelector.length > 0) {
	                    shouldLoadFont = false;
	                }
	
	                if (shouldLoadFont) {
	                    var s = createTag('style');
	                    s.setAttribute('f-forigin', fontArr[i].fOrigin);
	                    s.setAttribute('f-origin', fontArr[i].origin);
	                    s.setAttribute('f-family', fontArr[i].fFamily);
	                    s.type = "text/css";
	                    s.innerHTML = "@font-face {" + "font-family: "+fontArr[i].fFamily+"; font-style: normal; src: url('"+fontArr[i].fPath+"');}";
	                    defs.appendChild(s);
	                }
	            } else if(fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1){
	                loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
	
	                for (j = 0; j < loadedSelector.length; j++) {
	                    if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) {
	                        // Font is already loaded
	                        shouldLoadFont = false;
	                    }
	                }
	
	                if (shouldLoadFont) {
	                    var l = createTag('link');
	                    l.setAttribute('f-forigin', fontArr[i].fOrigin);
	                    l.setAttribute('f-origin', fontArr[i].origin);
	                    l.type = "text/css";
	                    l.rel = "stylesheet";
	                    l.href = fontArr[i].fPath;
	                    document.body.appendChild(l);
	                }
	            } else if(fontArr[i].fOrigin === 't' || fontArr[i].origin === 2){
	                loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
	
	                for (j = 0; j < loadedSelector.length; j++) {
	                    if (fontArr[i].fPath === loadedSelector[j].src) {
	                        // Font is already loaded
	                        shouldLoadFont = false;
	                    }
	                }
	
	                if (shouldLoadFont) {
	                    var sc = createTag('link');
	                    sc.setAttribute('f-forigin', fontArr[i].fOrigin);
	                    sc.setAttribute('f-origin', fontArr[i].origin);
	                    sc.setAttribute('rel','stylesheet');
	                    sc.setAttribute('href',fontArr[i].fPath);
	                    defs.appendChild(sc);
	                }
	            }
	            fontArr[i].helper = createHelper(defs,fontArr[i]);
	            fontArr[i].cache = {};
	            this.fonts.push(fontArr[i]);
	        }
	        if (_pendingFonts === 0) {
	            this.isLoaded = true;
	        } else {
	            //On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
	            //Adding this timeout seems to fix it
	           setTimeout(this.checkLoadedFonts.bind(this), 100);
	        }
	    }
	
	    function addChars(chars){
	        if(!chars){
	            return;
	        }
	        if(!this.chars){
	            this.chars = [];
	        }
	        var i, len = chars.length;
	        var j, jLen = this.chars.length, found;
	        for(i=0;i<len;i+=1){
	            j = 0;
	            found = false;
	            while(j<jLen){
	                if(this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch){
	                    found = true;
	                }
	                j += 1;
	            }
	            if(!found){
	                this.chars.push(chars[i]);
	                jLen += 1;
	            }
	        }
	    }
	
	    function getCharData(char, style, font){
	        var i = 0, len = this.chars.length;
	        while( i < len) {
	            if(this.chars[i].ch === char && this.chars[i].style === style && this.chars[i].fFamily === font){
	                return this.chars[i];
	            }
	            i+= 1;
	        }
	        if(console && console.warn) {
	            console.warn('Missing character from exported characters list: ', char, style, font);
	        }
	        return emptyChar;
	    }
	
	    function measureText(char, fontName, size) {
	        var fontData = this.getFontByName(fontName);
	        var index = char.charCodeAt(0);
	        if(!fontData.cache[index + 1]) {
	            var tHelper = fontData.helper;
	            //Canvas version
	            //fontData.cache[index] = tHelper.measureText(char).width / 100;
	            //SVG version
	            //console.log(tHelper.getBBox().width)
	            if (char === ' ') {
	                tHelper.textContent = '|' + char + '|';
	                var doubleSize = tHelper.getComputedTextLength();
	                tHelper.textContent = '||';
	                var singleSize = tHelper.getComputedTextLength();
	                fontData.cache[index + 1] = (doubleSize - singleSize)/100;
	            } else {
	                tHelper.textContent = char;
	                fontData.cache[index + 1] = (tHelper.getComputedTextLength())/100;
	            }
	        }
	        return fontData.cache[index + 1] * size;
	    }
	
	    function getFontByName(name){
	        var i = 0, len = this.fonts.length;
	        while(i<len){
	            if(this.fonts[i].fName === name) {
	                return this.fonts[i];
	            }
	            i += 1;
	        }
	        return this.fonts[0];
	    }
	
	    function getCombinedCharacterCodes() {
	        return combinedCharacters;
	    }
	
	    function loaded() {
	        return this.isLoaded;
	    }
	
	    var Font = function(){
	        this.fonts = [];
	        this.chars = null;
	        this.typekitLoaded = 0;
	        this.isLoaded = false;
	        this.initTime = Date.now();
	    };
	    //TODO: for now I'm adding these methods to the Class and not the prototype. Think of a better way to implement it. 
	    Font.getCombinedCharacterCodes = getCombinedCharacterCodes;
	
	    Font.prototype.addChars = addChars;
	    Font.prototype.addFonts = addFonts;
	    Font.prototype.getCharData = getCharData;
	    Font.prototype.getFontByName = getFontByName;
	    Font.prototype.measureText = measureText;
	    Font.prototype.checkLoadedFonts = checkLoadedFonts;
	    Font.prototype.loaded = loaded;
	
	    return Font;
	
	}());
	var PropertyFactory = (function(){
	
	    var initFrame = initialDefaultFrame;
	    var math_abs = Math.abs;
	
	    function interpolateValue(frameNum, caching) {
	        var offsetTime = this.offsetTime;
	        var newValue;
	        if (this.propType === 'multidimensional') {
	            newValue = createTypedArray('float32', this.pv.length);
	        }
	        var iterationIndex = caching.lastIndex;
	        var i = iterationIndex;
	        var len = this.keyframes.length - 1, flag = true;
	        var keyData, nextKeyData;
	
	        while (flag) {
	            keyData = this.keyframes[i];
	            nextKeyData = this.keyframes[i + 1];
	            if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime){
	                if(keyData.h){
	                    keyData = nextKeyData;
	                }
	                iterationIndex = 0;
	                break;
	            }
	            if ((nextKeyData.t - offsetTime) > frameNum){
	                iterationIndex = i;
	                break;
	            }
	            if (i < len - 1){
	                i += 1;
	            } else {
	                iterationIndex = 0;
	                flag = false;
	            }
	        }
	
	        var k, kLen, perc, jLen, j, fnc;
	        var nextKeyTime = nextKeyData.t - offsetTime;
	        var keyTime = keyData.t - offsetTime;
	        if (keyData.to) {
	            if (!keyData.bezierData) {
	                bez.buildBezierData(keyData);
	            }
	            var bezierData = keyData.bezierData;
	            if (frameNum >= nextKeyTime || frameNum < keyTime) {
	                var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
	                kLen = bezierData.points[ind].point.length;
	                for (k = 0; k < kLen; k += 1) {
	                    newValue[k] = bezierData.points[ind].point[k];
	                }
	                // caching._lastBezierData = null;
	            } else {
	                if (keyData.__fnct) {
	                    fnc = keyData.__fnct;
	                } else {
	                    fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
	                    keyData.__fnct = fnc;
	                }
	                perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
	                var distanceInLine = bezierData.segmentLength*perc;
	
	                var segmentPerc;
	                var addedLength =  (caching.lastFrame < frameNum && caching._lastBezierData === bezierData) ? caching._lastAddedLength : 0;
	                j =  (caching.lastFrame < frameNum && caching._lastBezierData === bezierData) ? caching._lastPoint : 0;
	                flag = true;
	                jLen = bezierData.points.length;
	                while (flag) {
	                    addedLength += bezierData.points[j].partialLength;
	                    if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
	                        kLen = bezierData.points[j].point.length;
	                        for (k = 0; k < kLen; k += 1) {
	                            newValue[k] = bezierData.points[j].point[k];
	                        }
	                        break;
	                    } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
	                        segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
	                        kLen = bezierData.points[j].point.length;
	                        for (k = 0; k < kLen; k += 1) {
	                            newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
	                        }
	                        break;
	                    }
	                    if (j < jLen - 1){
	                        j += 1;
	                    } else {
	                        flag = false;
	                    }
	                }
	                caching._lastPoint = j;
	                caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
	                caching._lastBezierData = bezierData;
	            }
	        } else {
	            var outX, outY, inX, inY, keyValue;
	            len = keyData.s.length;
	            if (this.sh && keyData.h !== 1) {
	                if (frameNum >= nextKeyTime) {
	                    newValue[0] = keyData.e[0];
	                    newValue[1] = keyData.e[1];
	                    newValue[2] = keyData.e[2];
	                } else if (frameNum <= keyTime) {
	                    newValue[0] = keyData.s[0];
	                    newValue[1] = keyData.s[1];
	                    newValue[2] = keyData.s[2];
	                } else {
	                    var quatStart = createQuaternion(keyData.s);
	                    var quatEnd = createQuaternion(keyData.e);
	                    var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
	                    quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
	                }
	                
	            } else {
	                for(i = 0; i < len; i += 1) {
	                    if (keyData.h !== 1) {
	                        if (frameNum >= nextKeyTime) {
	                            perc = 1;
	                        } else if(frameNum < keyTime) {
	                            perc = 0;
	                        } else {
	                            if(keyData.o.x.constructor === Array) {
	                                if (!keyData.__fnct) {
	                                    keyData.__fnct = [];
	                                }
	                                if (!keyData.__fnct[i]) {
	                                    outX = (typeof keyData.o.x[i] === undefined) ? keyData.o.x[0] : keyData.o.x[i];
	                                    outY = (typeof keyData.o.y[i] === undefined) ? keyData.o.y[0] : keyData.o.y[i];
	                                    inX = (typeof keyData.i.x[i] === undefined) ? keyData.i.x[0] : keyData.i.x[i];
	                                    inY = (typeof keyData.i.y[i] === undefined) ? keyData.i.y[0] : keyData.i.y[i];
	 
	                                    fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
	                                    keyData.__fnct[i] = fnc;
	                                } else {
	                                    fnc = keyData.__fnct[i];
	                                }
	                            } else {
	                                if (!keyData.__fnct) {
	                                    outX = keyData.o.x;
	                                    outY = keyData.o.y;
	                                    inX = keyData.i.x;
	                                    inY = keyData.i.y;
	                                    fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
	                                    keyData.__fnct = fnc;
	                                } else {
	                                    fnc = keyData.__fnct;
	                                }
	                            }
	                            perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime ));
	                        }
	                    }
	
	                    keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (keyData.e[i] - keyData.s[i]) * perc;
	
	                    if (len === 1) {
	                        newValue = keyValue;
	                    } else {
	                        newValue[i] = keyValue;
	                    }
	                }
	            }
	        }
	        caching.lastIndex = iterationIndex;
	        return newValue;
	    }
	
	    //based on @Toji's https://github.com/toji/gl-matrix/
	    function slerp(a, b, t) {
	        var out = [];
	        var ax = a[0], ay = a[1], az = a[2], aw = a[3],
	        bx = b[0], by = b[1], bz = b[2], bw = b[3]
	
	        var omega, cosom, sinom, scale0, scale1;
	
	        cosom = ax * bx + ay * by + az * bz + aw * bw;
	        if (cosom < 0.0) {
	            cosom = -cosom;
	            bx = -bx;
	            by = -by;
	            bz = -bz;
	            bw = -bw;
	        }
	        if ((1.0 - cosom) > 0.000001) {
	            omega = Math.acos(cosom);
	            sinom = Math.sin(omega);
	            scale0 = Math.sin((1.0 - t) * omega) / sinom;
	            scale1 = Math.sin(t * omega) / sinom;
	        } else {
	            scale0 = 1.0 - t;
	            scale1 = t;
	        }
	        out[0] = scale0 * ax + scale1 * bx;
	        out[1] = scale0 * ay + scale1 * by;
	        out[2] = scale0 * az + scale1 * bz;
	        out[3] = scale0 * aw + scale1 * bw;
	
	        return out;
	    }
	
	    function quaternionToEuler(out, quat) {
	        var qx = quat[0];
	        var qy = quat[1];
	        var qz = quat[2];
	        var qw = quat[3];
	        var heading = Math.atan2(2*qy*qw-2*qx*qz , 1 - 2*qy*qy - 2*qz*qz)
	        var attitude = Math.asin(2*qx*qy + 2*qz*qw) 
	        var bank = Math.atan2(2*qx*qw-2*qy*qz , 1 - 2*qx*qx - 2*qz*qz);
	        out[0] = heading/degToRads;
	        out[1] = attitude/degToRads;
	        out[2] = bank/degToRads;
	    }
	
	    function createQuaternion(values) {
	        var heading = values[0] * degToRads;
	        var attitude = values[1] * degToRads;
	        var bank = values[2] * degToRads;
	        var c1 = Math.cos(heading / 2);
	        var c2 = Math.cos(attitude / 2);
	        var c3 = Math.cos(bank / 2);
	        var s1 = Math.sin(heading / 2);
	        var s2 = Math.sin(attitude / 2);
	        var s3 = Math.sin(bank / 2);
	        var w = c1 * c2 * c3 - s1 * s2 * s3;
	        var x = s1 * s2 * c3 + c1 * c2 * s3;
	        var y = s1 * c2 * c3 + c1 * s2 * s3;
	        var z = c1 * s2 * c3 - s1 * c2 * s3;
	
	        return [x,y,z,w];
	    }
	
	    function getValueAtCurrentTime(){
	        var frameNum = this.comp.renderedFrame - this.offsetTime;
	        var initTime = this.keyframes[0].t - this.offsetTime;
	        var endTime = this.keyframes[this.keyframes.length- 1].t-this.offsetTime;
	        if(!(frameNum === this._caching.lastFrame || (this._caching.lastFrame !== initFrame && ((this._caching.lastFrame >= endTime && frameNum >= endTime) || (this._caching.lastFrame < initTime && frameNum < initTime))))){
	            if(this._caching.lastFrame >= frameNum) {
	                this._caching._lastBezierData = null;
	                this._caching.lastIndex = 0;
	            }
	
	            var renderResult = this.interpolateValue(frameNum, this._caching);
	            this.pv = renderResult;
	        }
	        this._caching.lastFrame = frameNum;
	        return this.pv;
	    }
	
	    function setVValue(val) {
	        var multipliedValue;
	        if(this.propType === 'unidimensional') {
	            multipliedValue = val * this.mult;
	            if(math_abs(this.v - multipliedValue) > 0.00001) {
	                this.v = multipliedValue;
	                this._mdf = true;
	            }
	        } else {
	            var i = 0, len = this.v.length;
	            while (i < len) {
	                multipliedValue = val[i] * this.mult;
	                if (math_abs(this.v[i] - multipliedValue) > 0.00001) {
	                    this.v[i] = multipliedValue;
	                    this._mdf = true;
	                }
	                i += 1;
	            }
	        }
	    }
	
	    function processEffectsSequence() {
	        if(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
	            return;
	        }        
	        if(this.lock) {
	            this.setVValue(this.pv);
	            return;
	        }
	        this.lock = true;
	        this._mdf = this._isFirstFrame;
	        var multipliedValue;
	        var i, len = this.effectsSequence.length;
	        var finalValue = this.kf ? this.pv : this.data.k;
	        for(i = 0; i < len; i += 1) {
	            finalValue = this.effectsSequence[i](finalValue);
	        }
	        this.setVValue(finalValue);
	        this._isFirstFrame = false;
	        this.lock = false;
	        this.frameId = this.elem.globalData.frameId;
	    }
	
	    function addEffect(effectFunction) {
	        this.effectsSequence.push(effectFunction);
	        this.container.addDynamicProperty(this);
	    }
	
	    function ValueProperty(elem, data, mult, container){
	        this.propType = 'unidimensional';
	        this.mult = mult || 1;
	        this.data = data;
	        this.v = mult ? data.k * mult : data.k;
	        this.pv = data.k;
	        this._mdf = false;
	        this.elem = elem;
	        this.container = container;
	        this.comp = elem.comp;
	        this.k = false;
	        this.kf = false;
	        this.vel = 0;
	        this.effectsSequence = [];
	        this._isFirstFrame = true;
	        this.getValue = processEffectsSequence;
	        this.setVValue = setVValue;
	        this.addEffect = addEffect;
	    }
	
	    function MultiDimensionalProperty(elem, data, mult, container) {
	        this.propType = 'multidimensional';
	        this.mult = mult || 1;
	        this.data = data;
	        this._mdf = false;
	        this.elem = elem;
	        this.container = container;
	        this.comp = elem.comp;
	        this.k = false;
	        this.kf = false;
	        this.frameId = -1;
	        var i, len = data.k.length;
	        this.v = createTypedArray('float32', len);
	        this.pv = createTypedArray('float32', len);
	        var arr = createTypedArray('float32', len);
	        this.vel = createTypedArray('float32', len);
	        for (i = 0; i < len; i += 1) {
	            this.v[i] = data.k[i] * this.mult;
	            this.pv[i] = data.k[i];
	        }
	        this._isFirstFrame = true;
	        this.effectsSequence = [];
	        this.getValue = processEffectsSequence;
	        this.setVValue = setVValue;
	        this.addEffect = addEffect;
	    }
	
	    function KeyframedValueProperty(elem, data, mult, container) {
	        this.propType = 'unidimensional';
	        this.keyframes = data.k;
	        this.offsetTime = elem.data.st;
	        this.frameId = -1;
	        this._caching = {lastFrame: initFrame, lastIndex: 0, value: 0, _lastBezierData: null};
	        this.k = true;
	        this.kf = true;
	        this.data = data;
	        this.mult = mult || 1;
	        this.elem = elem;
	        this.container = container;
	        this.comp = elem.comp;
	        this.v = initFrame;
	        this.pv = initFrame;
	        this._isFirstFrame = true;
	        this.getValue = processEffectsSequence;
	        this.setVValue = setVValue;
	        this.interpolateValue = interpolateValue;
	        this.effectsSequence = [getValueAtCurrentTime.bind(this)];
	        this.addEffect = addEffect;
	    }
	
	    function KeyframedMultidimensionalProperty(elem, data, mult, container){
	        this.propType = 'multidimensional';
	        var i, len = data.k.length;
	        var s, e,to,ti;
	        for (i = 0; i < len - 1; i += 1) {
	            if (data.k[i].to && data.k[i].s && data.k[i].e) {
	                s = data.k[i].s;
	                e = data.k[i].e;
	                to = data.k[i].to;
	                ti = data.k[i].ti;
	                if((s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],s[0] + to[0],s[1] + to[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],e[0] + ti[0],e[1] + ti[1])) || (s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],s[0] + to[0],s[1] + to[1],s[2] + to[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],e[0] + ti[0],e[1] + ti[1],e[2] + ti[2]))){
	                    data.k[i].to = null;
	                    data.k[i].ti = null;
	                }
	                if(s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
	                    if(s.length === 2 || (s[2] === e[2] && to[2] === 0 && ti[2] === 0)) {
	                        data.k[i].to = null;
	                        data.k[i].ti = null;
	                    }
	                }
	            }
	        }
	        this.effectsSequence = [getValueAtCurrentTime.bind(this)];
	        this.keyframes = data.k;
	        this.offsetTime = elem.data.st;
	        this.k = true;
	        this.kf = true;
	        this._isFirstFrame = true;
	        this.mult = mult || 1;
	        this.elem = elem;
	        this.container = container;
	        this.comp = elem.comp;
	        this.getValue = processEffectsSequence;
	        this.setVValue = setVValue;
	        this.interpolateValue = interpolateValue;
	        this.frameId = -1;
	        var arrLen = data.k[0].s.length;
	        this.v = createTypedArray('float32', arrLen);
	        this.pv = createTypedArray('float32', arrLen);
	        for (i = 0; i < arrLen; i += 1) {
	            this.v[i] = initFrame;
	            this.pv[i] = initFrame;
	        }
	        this._caching={lastFrame:initFrame,lastIndex:0,value:createTypedArray('float32', arrLen)};
	        this.addEffect = addEffect;
	    }
	
	    function getProp(elem,data,type, mult, container) {
	        var p;
	        if(data.a === 0){
	            if(type === 0) {
	                p = new ValueProperty(elem,data,mult, container);
	            } else {
	                p = new MultiDimensionalProperty(elem,data, mult, container);
	            }
	        } else if(data.a === 1){
	            if(type === 0) {
	                p = new KeyframedValueProperty(elem,data,mult, container);
	            } else {
	                p = new KeyframedMultidimensionalProperty(elem,data, mult, container);
	            }
	        } else if(!data.k.length){
	            p = new ValueProperty(elem,data, mult, container);
	        }else if(typeof(data.k[0]) === 'number'){
	            p = new MultiDimensionalProperty(elem,data, mult, container);
	        }else{
	            switch(type){
	                case 0:
	                    p = new KeyframedValueProperty(elem,data,mult, container);
	                    break;
	                case 1:
	                    p = new KeyframedMultidimensionalProperty(elem,data,mult, container);
	                    break;
	            }
	        }
	        if(p.effectsSequence.length){
	            container.addDynamicProperty(p);
	        }
	        return p;
	    }
	
	    var ob = {
	        getProp: getProp
	    };
	    return ob;
	}());
	var TransformPropertyFactory = (function() {
	
	    function applyToMatrix(mat) {
	        var _mdf = this._mdf;
	        this.iterateDynamicProperties();
	        this._mdf = this._mdf || _mdf;
	        if (this.a) {
	            mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	        }
	        if (this.s) {
	            mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	        }
	        if (this.sk) {
	            mat.skewFromAxis(-this.sk.v, this.sa.v);
	        }
	        if (this.r) {
	            mat.rotate(-this.r.v);
	        } else {
	            mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	        }
	        if (this.data.p.s) {
	            if (this.data.p.z) {
	                mat.translate(this.px.v, this.py.v, -this.pz.v);
	            } else {
	                mat.translate(this.px.v, this.py.v, 0);
	            }
	        } else {
	            mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
	        }
	    }
	    function processKeys(forceRender){
	        if (this.elem.globalData.frameId === this.frameId) {
	            return;
	        }
	        if(this._isDirty) {
	            this.precalculateMatrix();
	            this._isDirty = false;
	        }
	
	        this.iterateDynamicProperties();
	
	        if (this._mdf || forceRender) {
	            this.v.cloneFromProps(this.pre.props);
	            if (this.appliedTransformations < 1) {
	                this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	            }
	            if(this.appliedTransformations < 2) {
	                this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	            }
	            if (this.sk && this.appliedTransformations < 3) {
	                this.v.skewFromAxis(-this.sk.v, this.sa.v);
	            }
	            if (this.r && this.appliedTransformations < 4) {
	                this.v.rotate(-this.r.v);
	            } else if (!this.r && this.appliedTransformations < 4){
	                this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	            }
	            if (this.autoOriented) {
	                var v1,v2, frameRate = this.elem.globalData.frameRate;
	                if(this.p && this.p.keyframes && this.p.getValueAtTime) {
	                    if (this.p._caching.lastFrame+this.p.offsetTime <= this.p.keyframes[0].t) {
	                        v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate,0);
	                        v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
	                    } else if(this.p._caching.lastFrame+this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
	                        v1 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t / frameRate), 0);
	                        v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.01) / frameRate, 0);
	                    } else {
	                        v1 = this.p.pv;
	                        v2 = this.p.getValueAtTime((this.p._caching.lastFrame+this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
	                    }
	                } else if(this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
	                    v1 = [];
	                    v2 = [];
	                    var px = this.px, py = this.py, frameRate;
	                    if (px._caching.lastFrame+px.offsetTime <= px.keyframes[0].t) {
	                        v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate,0);
	                        v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate,0);
	                        v2[0] = px.getValueAtTime((px.keyframes[0].t) / frameRate,0);
	                        v2[1] = py.getValueAtTime((py.keyframes[0].t) / frameRate,0);
	                    } else if(px._caching.lastFrame+px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
	                        v1[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t / frameRate),0);
	                        v1[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t / frameRate),0);
	                        v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate,0);
	                        v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate,0);
	                    } else {
	                        v1 = [px.pv, py.pv];
	                        v2[0] = px.getValueAtTime((px._caching.lastFrame+px.offsetTime - 0.01) / frameRate,px.offsetTime);
	                        v2[1] = py.getValueAtTime((py._caching.lastFrame+py.offsetTime - 0.01) / frameRate,py.offsetTime);
	                    }
	                }
	                this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
	            }
	            if(this.data.p.s){
	                if(this.data.p.z) {
	                    this.v.translate(this.px.v, this.py.v, -this.pz.v);
	                } else {
	                    this.v.translate(this.px.v, this.py.v, 0);
	                }
	            }else{
	                this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
	            }
	        }
	        this.frameId = this.elem.globalData.frameId;
	    }
	
	    function precalculateMatrix() {
	        if(!this.a.k) {
	            this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	            this.appliedTransformations = 1;
	        } else {
	            return;
	        }
	        if(!this.s.effectsSequence.length) {
	            this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	            this.appliedTransformations = 2;
	        } else {
	            return;
	        }
	        if(this.sk) {
	            if(!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
	                this.pre.skewFromAxis(-this.sk.v, this.sa.v);
	            this.appliedTransformations = 3;
	            } else {
	                return;
	            }
	        }
	        if (this.r) {
	            if(!this.r.effectsSequence.length) {
	                this.pre.rotate(-this.r.v);
	                this.appliedTransformations = 4;
	            } else {
	                return;
	            }
	        } else if(!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
	            this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	            this.appliedTransformations = 4;
	        }
	    }
	
	    function autoOrient(){
	        //
	        //var prevP = this.getValueAtTime();
	    }
	
	    function addDynamicProperty(prop) {
	        this._addDynamicProperty(prop);
	        this.elem.addDynamicProperty(prop);
	        this._isDirty = true;
	    }
	
	    function TransformProperty(elem,data,container){
	        this.elem = elem;
	        this.frameId = -1;
	        this.propType = 'transform';
	        this.data = data;
	        this.v = new Matrix();
	        //Precalculated matrix with non animated properties
	        this.pre = new Matrix();
	        this.appliedTransformations = 0;
	        this.initDynamicPropertyContainer(container || elem);
	        if(data.p.s){
	            this.px = PropertyFactory.getProp(elem,data.p.x,0,0,this);
	            this.py = PropertyFactory.getProp(elem,data.p.y,0,0,this);
	            if(data.p.z){
	                this.pz = PropertyFactory.getProp(elem,data.p.z,0,0,this);
	            }
	        }else{
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this);
	        }
	        if(data.r) {
	            this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
	        } else if(data.rx) {
	            this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
	            this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
	            this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
	            if(data.or.k[0].ti) {
	                var i, len = data.or.k.length;
	                for(i=0;i<len;i+=1) {
	                    data.or.k[i].to = data.or.k[i].ti = null;
	                }
	            }
	            this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this);
	            //sh Indicates it needs to be capped between -180 and 180
	            this.or.sh = true;
	        }
	        if(data.sk){
	            this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
	            this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
	        }
	        if(data.a) {
	            this.a = PropertyFactory.getProp(elem,data.a,1,0,this);
	        }
	        if(data.s) {
	            this.s = PropertyFactory.getProp(elem,data.s,1,0.01,this);
	        }
	        // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
	        if(data.o){
	            this.o = PropertyFactory.getProp(elem,data.o,0,0.01,elem);
	        } else {
	            this.o = {_mdf:false,v:1};
	        }
	        this._isDirty = true;
	        if(!this.dynamicProperties.length){
	            this.getValue(true);
	        }
	    }
	
	    TransformProperty.prototype = {
	        applyToMatrix: applyToMatrix,
	        getValue: processKeys,
	        precalculateMatrix: precalculateMatrix,
	        autoOrient: autoOrient
	    }
	
	    extendPrototype([DynamicPropertyContainer], TransformProperty);
	    TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
	    TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
	
	    function getTransformProperty(elem,data,container){
	        return new TransformProperty(elem,data,container);
	    }
	
	    return {
	        getTransformProperty: getTransformProperty
	    };
	
	}());
	function ShapePath(){
		this.c = false;
		this._length = 0;
		this._maxLength = 8;
		this.v = createSizedArray(this._maxLength);
		this.o = createSizedArray(this._maxLength);
		this.i = createSizedArray(this._maxLength);
	}
	
	ShapePath.prototype.setPathData = function(closed, len) {
		this.c = closed;
		this.setLength(len);
		var i = 0;
		while(i < len){
			this.v[i] = point_pool.newElement();
			this.o[i] = point_pool.newElement();
			this.i[i] = point_pool.newElement();
			i += 1;
		}
	};
	
	ShapePath.prototype.setLength = function(len) {
		while(this._maxLength < len) {
			this.doubleArrayLength();
		}
		this._length = len;
	};
	
	ShapePath.prototype.doubleArrayLength = function() {
		this.v = this.v.concat(createSizedArray(this._maxLength));
		this.i = this.i.concat(createSizedArray(this._maxLength));
		this.o = this.o.concat(createSizedArray(this._maxLength));
		this._maxLength *= 2;
	};
	
	ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
		var arr;
		this._length = Math.max(this._length, pos + 1);
		if(this._length >= this._maxLength) {
			this.doubleArrayLength();
		}
		switch(type){
			case 'v':
				arr = this.v;
				break;
			case 'i':
				arr = this.i;
				break;
			case 'o':
				arr = this.o;
				break;
		}
		if(!arr[pos] || (arr[pos] && !replace)){
			arr[pos] = point_pool.newElement();
		}
		arr[pos][0] = x;
		arr[pos][1] = y;
	};
	
	ShapePath.prototype.setTripleAt = function(vX,vY,oX,oY,iX,iY,pos, replace) {
		this.setXYAt(vX,vY,'v',pos, replace);
		this.setXYAt(oX,oY,'o',pos, replace);
		this.setXYAt(iX,iY,'i',pos, replace);
	};
	
	ShapePath.prototype.reverse = function() {
		var newPath = new ShapePath();
		newPath.setPathData(this.c, this._length);
		var vertices = this.v, outPoints = this.o, inPoints = this.i;
		var init = 0;
		if (this.c) {
			newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
	        init = 1;
	    }
	    var cnt = this._length - 1;
	    var len = this._length;
	
	    var i;
	    for (i = init; i < len; i += 1) {
	    	newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
	        cnt -= 1;
	    }
	    return newPath;
	};
	var ShapePropertyFactory = (function(){
	
	    var initFrame = -999999;
	
	    function interpolateShape(frameNum, previousValue, caching) {
	        var iterationIndex = caching.lastIndex;
	        var keyPropS,keyPropE,isHold, j, k, jLen, kLen, perc, vertexValue;
	        var kf = this.keyframes;
	        if(frameNum < kf[0].t-this.offsetTime){
	            keyPropS = kf[0].s[0];
	            isHold = true;
	            iterationIndex = 0;
	        }else if(frameNum >= kf[kf.length - 1].t-this.offsetTime){
	            if(kf[kf.length - 2].h === 1){
	                keyPropS = kf[kf.length - 1].s[0];
	            }else{
	                keyPropS = kf[kf.length - 2].e[0];
	            }
	            isHold = true;
	        }else{
	            var i = iterationIndex;
	            var len = kf.length- 1,flag = true,keyData,nextKeyData;
	            while(flag){
	                keyData = kf[i];
	                nextKeyData = kf[i+1];
	                if((nextKeyData.t - this.offsetTime) > frameNum){
	                    break;
	                }
	                if(i < len - 1){
	                    i += 1;
	                }else{
	                    flag = false;
	                }
	            }
	            isHold = keyData.h === 1;
	            iterationIndex = i;
	            if(!isHold){
	                if(frameNum >= nextKeyData.t-this.offsetTime){
	                    perc = 1;
	                }else if(frameNum < keyData.t-this.offsetTime){
	                    perc = 0;
	                }else{
	                    var fnc;
	                    if(keyData.__fnct){
	                        fnc = keyData.__fnct;
	                    }else{
	                        fnc = BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y).get;
	                        keyData.__fnct = fnc;
	                    }
	                    perc = fnc((frameNum-(keyData.t-this.offsetTime))/((nextKeyData.t-this.offsetTime)-(keyData.t-this.offsetTime)));
	                }
	                keyPropE = keyData.e[0];
	            }
	            keyPropS = keyData.s[0];
	        }
	        jLen = previousValue._length;
	        kLen = keyPropS.i[0].length;
	        caching.lastIndex = iterationIndex;
	
	        for(j=0;j<jLen;j+=1){
	            for(k=0;k<kLen;k+=1){
	                vertexValue = isHold ? keyPropS.i[j][k] :  keyPropS.i[j][k]+(keyPropE.i[j][k]-keyPropS.i[j][k])*perc;
	                previousValue.i[j][k] = vertexValue;
	                vertexValue = isHold ? keyPropS.o[j][k] :  keyPropS.o[j][k]+(keyPropE.o[j][k]-keyPropS.o[j][k])*perc;
	                previousValue.o[j][k] = vertexValue;
	                vertexValue = isHold ? keyPropS.v[j][k] :  keyPropS.v[j][k]+(keyPropE.v[j][k]-keyPropS.v[j][k])*perc;
	                previousValue.v[j][k] = vertexValue;
	            }
	        }
	    }
	
	    function interpolateShapeCurrentTime(){
	        var frameNum = this.comp.renderedFrame - this.offsetTime;
	        var initTime = this.keyframes[0].t - this.offsetTime;
	        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
	        var lastFrame = this._caching.lastFrame;
	        if(!(lastFrame !== initFrame && ((lastFrame < initTime && frameNum < initTime) || (lastFrame > endTime && frameNum > endTime)))){
	            ////
	            this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
	            this.interpolateShape(frameNum, this.pv, this._caching);
	            ////
	        }
	        this._caching.lastFrame = frameNum;
	        return this.pv;
	    }
	
	    function resetShape(){
	        this.paths = this.localShapeCollection;
	    }
	
	    function shapesEqual(shape1, shape2) {
	        if(shape1._length !== shape2._length || shape1.c !== shape2.c){
	            return false;
	        }
	        var i, len = shape1._length;
	        for(i = 0; i < len; i += 1) {
	            if(shape1.v[i][0] !== shape2.v[i][0] 
	            || shape1.v[i][1] !== shape2.v[i][1] 
	            || shape1.o[i][0] !== shape2.o[i][0] 
	            || shape1.o[i][1] !== shape2.o[i][1] 
	            || shape1.i[i][0] !== shape2.i[i][0] 
	            || shape1.i[i][1] !== shape2.i[i][1]) {
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function setVValue(newPath) {
	        if(!shapesEqual(this.v, newPath)) {
	            this.v = shape_pool.clone(newPath);
	            this.localShapeCollection.releaseShapes();
	            this.localShapeCollection.addShape(this.v);
	            this._mdf = true;
	            this.paths = this.localShapeCollection;
	        }
	    }
	
	    function processEffectsSequence() {
	        if(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
	            return;
	        }
	        if(this.lock) {
	            this.setVValue(this.pv);
	            return;
	        }
	        this.lock = true;
	        this._mdf = false;
	        var finalValue = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
	        var i, len = this.effectsSequence.length;
	        for(i = 0; i < len; i += 1) {
	            finalValue = this.effectsSequence[i](finalValue);
	        }
	        this.setVValue(finalValue);
	        this.lock = false;
	        this.frameId = this.elem.globalData.frameId;
	    };
	
	    function ShapeProperty(elem, data, type){
	        this.propType = 'shape';
	        this.comp = elem.comp;
	        this.container = elem;
	        this.elem = elem;
	        this.data = data;
	        this.k = false;
	        this.kf = false;
	        this._mdf = false;
	        var pathData = type === 3 ? data.pt.k : data.ks.k;
	        this.v = shape_pool.clone(pathData);
	        this.pv = shape_pool.clone(this.v);
	        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.paths.addShape(this.v);
	        this.reset = resetShape;
	        this.effectsSequence = [];
	    }
	
	    function addEffect(effectFunction) {
	        this.effectsSequence.push(effectFunction);
	        this.container.addDynamicProperty(this);
	    }
	
	    ShapeProperty.prototype.interpolateShape = interpolateShape;
	    ShapeProperty.prototype.getValue = processEffectsSequence;
	    ShapeProperty.prototype.setVValue = setVValue;
	    ShapeProperty.prototype.addEffect = addEffect;
	
	    function KeyframedShapeProperty(elem,data,type){
	        this.propType = 'shape';
	        this.comp = elem.comp;
	        this.elem = elem;
	        this.container = elem;
	        this.offsetTime = elem.data.st;
	        this.keyframes = type === 3 ? data.pt.k : data.ks.k;
	        this.k = true;
	        this.kf = true;
	        var i, len = this.keyframes[0].s[0].i.length;
	        var jLen = this.keyframes[0].s[0].i[0].length;
	        this.v = shape_pool.newElement();
	        this.v.setPathData(this.keyframes[0].s[0].c, len);
	        this.pv = shape_pool.clone(this.v);
	        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.paths.addShape(this.v);
	        this.lastFrame = initFrame;
	        this.reset = resetShape;
	        this._caching = {lastFrame: initFrame, lastIndex: 0};
	        this.effectsSequence = [interpolateShapeCurrentTime.bind(this)];
	    }
	    KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
	    KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
	    KeyframedShapeProperty.prototype.setVValue = setVValue;
	    KeyframedShapeProperty.prototype.addEffect = addEffect;
	
	    var EllShapeProperty = (function(){
	
	        var cPoint = roundCorner;
	
	        function EllShapeProperty(elem,data) {
	            /*this.v = {
	                v: createSizedArray(4),
	                i: createSizedArray(4),
	                o: createSizedArray(4),
	                c: true
	            };*/
	            this.v = shape_pool.newElement();
	            this.v.setPathData(true, 4);
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.paths = this.localShapeCollection;
	            this.localShapeCollection.addShape(this.v);
	            this.d = data.d;
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.frameId = -1;
	            this.initDynamicPropertyContainer(elem);
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this);
	            this.s = PropertyFactory.getProp(elem,data.s,1,0,this);
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.k = false;
	                this.convertEllToPath();
	            }
	        };
	
	        EllShapeProperty.prototype = {
	            reset: resetShape,
	            getValue: function (){
	                if(this.elem.globalData.frameId === this.frameId){
	                    return;
	                }
	                this.frameId = this.elem.globalData.frameId;
	                this.iterateDynamicProperties();
	
	                if(this._mdf){
	                    this.convertEllToPath();
	                }
	            },
	            convertEllToPath: function() {
	                var p0 = this.p.v[0], p1 = this.p.v[1], s0 = this.s.v[0]/2, s1 = this.s.v[1]/2;
	                var _cw = this.d !== 3;
	                var _v = this.v;
	                _v.v[0][0] = p0;
	                _v.v[0][1] = p1 - s1;
	                _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
	                _v.v[1][1] = p1;
	                _v.v[2][0] = p0;
	                _v.v[2][1] = p1 + s1;
	                _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
	                _v.v[3][1] = p1;
	                _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
	                _v.i[0][1] = p1 - s1;
	                _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
	                _v.i[1][1] = p1 - s1 * cPoint;
	                _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
	                _v.i[2][1] = p1 + s1;
	                _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
	                _v.i[3][1] = p1 + s1 * cPoint;
	                _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
	                _v.o[0][1] = p1 - s1;
	                _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
	                _v.o[1][1] = p1 + s1 * cPoint;
	                _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
	                _v.o[2][1] = p1 + s1;
	                _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
	                _v.o[3][1] = p1 - s1 * cPoint;
	            }
	        }
	
	        extendPrototype([DynamicPropertyContainer], EllShapeProperty);
	
	        return EllShapeProperty;
	    }());
	
	    var StarShapeProperty = (function() {
	
	        function StarShapeProperty(elem,data) {
	            this.v = shape_pool.newElement();
	            this.v.setPathData(true, 0);
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.data = data;
	            this.frameId = -1;
	            this.d = data.d;
	            this.initDynamicPropertyContainer(elem);
	            if(data.sy === 1){
	                this.ir = PropertyFactory.getProp(elem,data.ir,0,0,this);
	                this.is = PropertyFactory.getProp(elem,data.is,0,0.01,this);
	                this.convertToPath = this.convertStarToPath;
	            } else {
	                this.convertToPath = this.convertPolygonToPath;
	            }
	            this.pt = PropertyFactory.getProp(elem,data.pt,0,0,this);
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this);
	            this.r = PropertyFactory.getProp(elem,data.r,0,degToRads,this);
	            this.or = PropertyFactory.getProp(elem,data.or,0,0,this);
	            this.os = PropertyFactory.getProp(elem,data.os,0,0.01,this);
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.localShapeCollection.addShape(this.v);
	            this.paths = this.localShapeCollection;
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.k = false;
	                this.convertToPath();
	            }
	        };
	
	        StarShapeProperty.prototype = {
	            reset: resetShape,
	            getValue: function() {
	                if(this.elem.globalData.frameId === this.frameId){
	                    return;
	                }
	                this.frameId = this.elem.globalData.frameId;
	                this.iterateDynamicProperties();
	                if(this._mdf){
	                    this.convertToPath();
	                }
	            },
	            convertStarToPath: function() {
	                var numPts = Math.floor(this.pt.v)*2;
	                var angle = Math.PI*2/numPts;
	                /*this.v.v.length = numPts;
	                this.v.i.length = numPts;
	                this.v.o.length = numPts;*/
	                var longFlag = true;
	                var longRad = this.or.v;
	                var shortRad = this.ir.v;
	                var longRound = this.os.v;
	                var shortRound = this.is.v;
	                var longPerimSegment = 2*Math.PI*longRad/(numPts*2);
	                var shortPerimSegment = 2*Math.PI*shortRad/(numPts*2);
	                var i, rad,roundness,perimSegment, currentAng = -Math.PI/ 2;
	                currentAng += this.r.v;
	                var dir = this.data.d === 3 ? -1 : 1;
	                this.v._length = 0;
	                for(i=0;i<numPts;i+=1){
	                    rad = longFlag ? longRad : shortRad;
	                    roundness = longFlag ? longRound : shortRound;
	                    perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
	                    var x = rad * Math.cos(currentAng);
	                    var y = rad * Math.sin(currentAng);
	                    var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
	                    var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
	                    x +=  + this.p.v[0];
	                    y +=  + this.p.v[1];
	                    this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);
	
	                    /*this.v.v[i] = [x,y];
	                    this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
	                    this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
	                    this.v._length = numPts;*/
	                    longFlag = !longFlag;
	                    currentAng += angle*dir;
	                }
	            },
	            convertPolygonToPath: function() {
	                var numPts = Math.floor(this.pt.v);
	                var angle = Math.PI*2/numPts;
	                var rad = this.or.v;
	                var roundness = this.os.v;
	                var perimSegment = 2*Math.PI*rad/(numPts*4);
	                var i, currentAng = -Math.PI/ 2;
	                var dir = this.data.d === 3 ? -1 : 1;
	                currentAng += this.r.v;
	                this.v._length = 0;
	                for(i=0;i<numPts;i+=1){
	                    var x = rad * Math.cos(currentAng);
	                    var y = rad * Math.sin(currentAng);
	                    var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
	                    var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
	                    x +=  + this.p.v[0];
	                    y +=  + this.p.v[1];
	                    this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);
	                    currentAng += angle*dir;
	                }
	                this.paths.length = 0;
	                this.paths[0] = this.v;
	            }
	
	        }
	        extendPrototype([DynamicPropertyContainer], StarShapeProperty);
	
	        return StarShapeProperty;
	    }());
	
	    var RectShapeProperty = (function() {
	
	         function RectShapeProperty(elem,data) {
	            this.v = shape_pool.newElement();
	            this.v.c = true;
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.localShapeCollection.addShape(this.v);
	            this.paths = this.localShapeCollection;
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.frameId = -1;
	            this.d = data.d;
	            this.initDynamicPropertyContainer(elem);
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this);
	            this.s = PropertyFactory.getProp(elem,data.s,1,0,this);
	            this.r = PropertyFactory.getProp(elem,data.r,0,0,this);
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.k = false;
	                this.convertRectToPath();
	            }
	        };
	
	        RectShapeProperty.prototype = {
	            convertRectToPath: function (){
	                var p0 = this.p.v[0], p1 = this.p.v[1], v0 = this.s.v[0]/2, v1 = this.s.v[1]/2;
	                var round = bm_min(v0,v1,this.r.v);
	                var cPoint = round*(1-roundCorner);
	                this.v._length = 0;
	
	                if(this.d === 2 || this.d === 1) {
	                    this.v.setTripleAt(p0+v0, p1-v1+round,p0+v0, p1-v1+round,p0+v0,p1-v1+cPoint,0, true);
	                    this.v.setTripleAt(p0+v0, p1+v1-round,p0+v0, p1+v1-cPoint,p0+v0, p1+v1-round,1, true);
	                    if(round!== 0){
	                        this.v.setTripleAt(p0+v0-round, p1+v1,p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,2, true);
	                        this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,p0-v0+round,p1+v1,3, true);
	                        this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,4, true);
	                        this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,p0-v0,p1-v1+round,5, true);
	                        this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,6, true);
	                        this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,p0+v0-round,p1-v1,7, true);
	                    } else {
	                        this.v.setTripleAt(p0-v0,p1+v1,p0-v0+cPoint,p1+v1,p0-v0,p1+v1,2);
	                        this.v.setTripleAt(p0-v0,p1-v1,p0-v0,p1-v1+cPoint,p0-v0,p1-v1,3);
	                    }
	                }else{
	                    this.v.setTripleAt(p0+v0,p1-v1+round,p0+v0,p1-v1+cPoint,p0+v0,p1-v1+round,0, true);
	                    if(round!== 0){
	                        this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,1, true);
	                        this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,p0-v0+round,p1-v1,2, true);
	                        this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,3, true);
	                        this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,p0-v0,p1+v1-round,4, true);
	                        this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,5, true);
	                        this.v.setTripleAt(p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,p0+v0-round,p1+v1,6, true);
	                        this.v.setTripleAt(p0+v0,p1+v1-round,p0+v0,p1+v1-round,p0+v0,p1+v1-cPoint,7, true);
	                    } else {
	                        this.v.setTripleAt(p0-v0,p1-v1,p0-v0+cPoint,p1-v1,p0-v0,p1-v1,1, true);
	                        this.v.setTripleAt(p0-v0,p1+v1,p0-v0,p1+v1-cPoint,p0-v0,p1+v1,2, true);
	                        this.v.setTripleAt(p0+v0,p1+v1,p0+v0-cPoint,p1+v1,p0+v0,p1+v1,3, true);
	
	                    }
	                }
	            },
	            getValue: function(frameNum){
	                if(this.elem.globalData.frameId === this.frameId){
	                    return;
	                }
	                this.frameId = this.elem.globalData.frameId;
	                this.iterateDynamicProperties();
	                if(this._mdf){
	                    this.convertRectToPath();
	                }
	
	            },
	            reset: resetShape
	        }
	        extendPrototype([DynamicPropertyContainer], RectShapeProperty);
	
	        return RectShapeProperty;
	    }());
	
	    function getShapeProp(elem,data,type){
	        var prop;
	        if(type === 3 || type === 4){
	            var dataProp = type === 3 ? data.pt : data.ks;
	            var keys = dataProp.k;
	            if(dataProp.a === 1 || keys.length){
	                prop = new KeyframedShapeProperty(elem, data, type);
	            }else{
	                prop = new ShapeProperty(elem, data, type);
	            }
	        }else if(type === 5){
	            prop = new RectShapeProperty(elem, data);
	        }else if(type === 6){
	            prop = new EllShapeProperty(elem, data);
	        }else if(type === 7){
	            prop = new StarShapeProperty(elem, data);
	        }
	        if(prop.k){
	            elem.addDynamicProperty(prop);
	        }
	        return prop;
	    }
	
	    function getConstructorFunction() {
	        return ShapeProperty;
	    }
	
	    function getKeyframedConstructorFunction() {
	        return KeyframedShapeProperty;
	    }
	
	    var ob = {};
	    ob.getShapeProp = getShapeProp;
	    ob.getConstructorFunction = getConstructorFunction;
	    ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
	    return ob;
	}());
	var ShapeModifiers = (function(){
	    var ob = {};
	    var modifiers = {};
	    ob.registerModifier = registerModifier;
	    ob.getModifier = getModifier;
	
	    function registerModifier(nm,factory){
	        if(!modifiers[nm]){
	            modifiers[nm] = factory;
	        }
	    }
	
	    function getModifier(nm,elem, data){
	        return new modifiers[nm](elem, data);
	    }
	
	    return ob;
	}());
	
	function ShapeModifier(){}
	ShapeModifier.prototype.initModifierProperties = function(){};
	ShapeModifier.prototype.addShapeToModifier = function(){};
	ShapeModifier.prototype.addShape = function(data){
	    if(!this.closed){
	        var shapeData = {shape:data.sh, data: data, localShapeCollection:shapeCollection_pool.newShapeCollection()};
	        this.shapes.push(shapeData);
	        this.addShapeToModifier(shapeData);
	        if(this._isAnimated) {
	            data.setAsAnimated();
	        }
	    }
	};
	ShapeModifier.prototype.init = function(elem,data){
	    this.shapes = [];
	    this.elem = elem;
	    this.initDynamicPropertyContainer(elem);
	    this.initModifierProperties(elem,data);
	    this.frameId = initialDefaultFrame;
	    this.closed = false;
	    this.k = false;
	    if(this.dynamicProperties.length){
	        this.k = true;
	    }else{
	        this.getValue(true);
	    }
	};
	ShapeModifier.prototype.processKeys = function(){
	    if(this.elem.globalData.frameId === this.frameId){
	        return;
	    }
	    this.frameId = this.elem.globalData.frameId;
	    this.iterateDynamicProperties();
	};
	
	extendPrototype([DynamicPropertyContainer], ShapeModifier);
	function TrimModifier(){
	}
	extendPrototype([ShapeModifier], TrimModifier);
	TrimModifier.prototype.initModifierProperties = function(elem, data) {
	    this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
	    this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
	    this.sValue = 0;
	    this.eValue = 0;
	    this.getValue = this.processKeys;
	    this.m = data.m;
	    this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
	};
	
	TrimModifier.prototype.addShapeToModifier = function(shapeData){
	    shapeData.pathsData = [];
	};
	
	TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
	    var segments = [];
	    if (e <= 1) {
	        segments.push({
	            s: s,
	            e: e
	        });
	    } else if (s >= 1) {
	        segments.push({
	            s: s - 1,
	            e: e - 1
	        });
	    } else {
	        segments.push({
	            s: s,
	            e: 1
	        });
	        segments.push({
	            s: 0,
	            e: e - 1
	        });
	    }
	    var shapeSegments = [];
	    var i, len = segments.length, segmentOb;
	    for (i = 0; i < len; i += 1) {
	        segmentOb = segments[i];
	        if (segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength) {
	            
	        } else {
	            var shapeS, shapeE;
	            if (segmentOb.s * totalModifierLength <= addedLength) {
	                shapeS = 0;
	            } else {
	                shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
	            }
	            if(segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
	                shapeE = 1;
	            } else {
	                shapeE = ((segmentOb.e * totalModifierLength - addedLength) / shapeLength);
	            }
	            shapeSegments.push([shapeS, shapeE]);
	        }
	    }
	    if (!shapeSegments.length) {
	        shapeSegments.push([0, 0]);
	    }
	    return shapeSegments;
	};
	
	TrimModifier.prototype.releasePathsData = function(pathsData) {
	    var i, len = pathsData.length;
	    for (i = 0; i < len; i += 1) {
	        segments_length_pool.release(pathsData[i]);
	    }
	    pathsData.length = 0;
	    return pathsData;
	};
	
	TrimModifier.prototype.processShapes = function(_isFirstFrame) {
	    var s, e;
	    if (this._mdf || _isFirstFrame) {
	        var o = (this.o.v % 360) / 360;
	        if (o < 0) {
	            o += 1;
	        }
	        s = (this.s.v > 1 ? 1 : this.s.v < 0 ? 0 : this.s.v) + o;
	        e = (this.e.v > 1 ? 1 : this.e.v < 0 ? 0 : this.e.v) + o;
	        if (s === e) {
	
	        }
	        if (s > e) {
	            var _s = s;
	            s = e;
	            e = _s;
	        }
	        s = Math.round(s * 10000) * 0.0001;
	        e = Math.round(e * 10000) * 0.0001;
	        this.sValue = s;
	        this.eValue = e;
	    } else {
	        s = this.sValue;
	        e = this.eValue;
	    }
	    var shapePaths;
	    var i, len = this.shapes.length, j, jLen;
	    var pathsData, pathData, totalShapeLength, totalModifierLength = 0;
	
	    if (e === s) {
	        for (i = 0; i < len; i += 1) {
	            this.shapes[i].localShapeCollection.releaseShapes();
	            this.shapes[i].shape._mdf = true;
	            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
	        }
	    } else if (!((e === 1 && s === 0) || (e===0 && s === 1))){
	        var segments = [], shapeData, localShapeCollection;
	        for (i = 0; i < len; i += 1) {
	            shapeData = this.shapes[i];
	            // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
	            if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) {
	                shapeData.shape.paths = shapeData.localShapeCollection;
	            } else {
	                shapePaths = shapeData.shape.paths;
	                jLen = shapePaths._length;
	                totalShapeLength = 0;
	                if (!shapeData.shape._mdf && shapeData.pathsData.length) {
	                    totalShapeLength = shapeData.totalShapeLength;
	                } else {
	                    pathsData = this.releasePathsData(shapeData.pathsData);
	                    for (j = 0; j < jLen; j += 1) {
	                        pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
	                        pathsData.push(pathData);
	                        totalShapeLength += pathData.totalLength;
	                    }
	                    shapeData.totalShapeLength = totalShapeLength;
	                    shapeData.pathsData = pathsData;
	                }
	
	                totalModifierLength += totalShapeLength;
	                shapeData.shape._mdf = true;
	            }
	        }
	        var shapeS = s, shapeE = e, addedLength = 0, edges;
	        for (i = len - 1; i >= 0; i -= 1) {
	            shapeData = this.shapes[i];
	            if (shapeData.shape._mdf) {
	                localShapeCollection = shapeData.localShapeCollection;
	                localShapeCollection.releaseShapes();
	                //if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
	                if (this.m === 2 && len > 1) {
	                    edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
	                    addedLength += shapeData.totalShapeLength;
	                } else {
	                    edges = [[shapeS, shapeE]];
	                }
	                jLen = edges.length;
	                for (j = 0; j < jLen; j += 1) {
	                    shapeS = edges[j][0];
	                    shapeE = edges[j][1];
	                    segments.length = 0;
	                    if (shapeE <= 1) {
	                        segments.push({
	                            s:shapeData.totalShapeLength * shapeS,
	                            e:shapeData.totalShapeLength * shapeE
	                        });
	                    } else if (shapeS >= 1) {
	                        segments.push({
	                            s:shapeData.totalShapeLength * (shapeS - 1),
	                            e:shapeData.totalShapeLength * (shapeE - 1)
	                        });
	                    } else {
	                        segments.push({
	                            s:shapeData.totalShapeLength * shapeS,
	                            e:shapeData.totalShapeLength
	                        });
	                        segments.push({
	                            s:0,
	                            e:shapeData.totalShapeLength * (shapeE - 1)
	                        });
	                    }
	                    var newShapesData = this.addShapes(shapeData,segments[0]);
	                    if (segments[0].s !== segments[0].e) {
	                        if (segments.length > 1) {
	                            var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
	                            if (lastShapeInCollection.c) {
	                                var lastShape = newShapesData.pop();
	                                this.addPaths(newShapesData, localShapeCollection);
	                                newShapesData = this.addShapes(shapeData, segments[1], lastShape);
	                            } else {
	                                this.addPaths(newShapesData, localShapeCollection);
	                                newShapesData = this.addShapes(shapeData, segments[1]);
	                            }
	                        } 
	                        this.addPaths(newShapesData, localShapeCollection);
	                    }
	                    
	                }
	                shapeData.shape.paths = localShapeCollection;
	            }
	        }
	    } else if (this._mdf) {
	        for (i = 0; i < len; i += 1) {
	            //Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
	            //Don't remove this even if it's losing cached info.
	            this.shapes[i].pathsData.length = 0;
	            this.shapes[i].shape._mdf = true;
	        }
	    }
	};
	
	TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
	    var i, len = newPaths.length;
	    for (i = 0; i < len; i += 1) {
	        localShapeCollection.addShape(newPaths[i]);
	    }
	};
	
	TrimModifier.prototype.addSegment = function(pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
	    shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
	    shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
	    if(newShape){
	        shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
	    }
	    shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
	};
	
	TrimModifier.prototype.addSegmentFromArray = function(points, shapePath, pos, newShape) {
	    shapePath.setXYAt(points[1], points[5], 'o', pos);
	    shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
	    if(newShape){
	        shapePath.setXYAt(points[0], points[4], 'v', pos);
	    }
	    shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
	};
	
	TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath) {
	    var pathsData = shapeData.pathsData;
	    var shapePaths = shapeData.shape.paths.shapes;
	    var i, len = shapeData.shape.paths._length, j, jLen;
	    var addedLength = 0;
	    var currentLengthData,segmentCount;
	    var lengths;
	    var segment;
	    var shapes = [];
	    var initPos;
	    var newShape = true;
	    if (!shapePath) {
	        shapePath = shape_pool.newElement();
	        segmentCount = 0;
	        initPos = 0;
	    } else {
	        segmentCount = shapePath._length;
	        initPos = shapePath._length;
	    }
	    shapes.push(shapePath);
	    for (i = 0; i < len; i += 1) {
	        lengths = pathsData[i].lengths;
	        shapePath.c = shapePaths[i].c;
	        jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
	        for (j = 1; j < jLen; j +=1) {
	            currentLengthData = lengths[j-1];
	            if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
	                addedLength += currentLengthData.addedLength;
	                shapePath.c = false;
	            } else if(addedLength > shapeSegment.e) {
	                shapePath.c = false;
	                break;
	            } else {
	                if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
	                    this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
	                    newShape = false;
	                } else {
	                    segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength)/currentLengthData.addedLength,(shapeSegment.e - addedLength)/currentLengthData.addedLength, lengths[j-1]);
	                    this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
	                    // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
	                    newShape = false;
	                    shapePath.c = false;
	                }
	                addedLength += currentLengthData.addedLength;
	                segmentCount += 1;
	            }
	        }
	        if (shapePaths[i].c && lengths.length) {
	            currentLengthData = lengths[j - 1];
	            if (addedLength <= shapeSegment.e) {
	                var segmentLength = lengths[j - 1].addedLength;
	                if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
	                    this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
	                    newShape = false;
	                } else {
	                    segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
	                    this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
	                    // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
	                    newShape = false;
	                    shapePath.c = false;
	                }
	            } else {
	                shapePath.c = false;
	            }
	            addedLength += currentLengthData.addedLength;
	            segmentCount += 1;
	        }
	        if (shapePath._length) {
	            shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
	            shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1],'o', shapePath._length - 1);
	        }
	        if (addedLength > shapeSegment.e) {
	            break;
	        }
	        if (i < len - 1) {
	            shapePath = shape_pool.newElement();
	            newShape = true;
	            shapes.push(shapePath);
	            segmentCount = 0;
	        }
	    }
	    return shapes;
	};
	
	
	ShapeModifiers.registerModifier('tm', TrimModifier);
	function RoundCornersModifier(){}
	extendPrototype([ShapeModifier],RoundCornersModifier);
	RoundCornersModifier.prototype.initModifierProperties = function(elem,data){
	    this.getValue = this.processKeys;
	    this.rd = PropertyFactory.getProp(elem,data.r,0,null,this);
	    this._isAnimated = !!this.rd.effectsSequence.length;
	};
	
	RoundCornersModifier.prototype.processPath = function(path, round){
	    var cloned_path = shape_pool.newElement();
	    cloned_path.c = path.c;
	    var i, len = path._length;
	    var currentV,currentI,currentO,closerV, newV,newO,newI,distance,newPosPerc,index = 0;
	    var vX,vY,oX,oY,iX,iY;
	    for(i=0;i<len;i+=1){
	        currentV = path.v[i];
	        currentO = path.o[i];
	        currentI = path.i[i];
	        if(currentV[0]===currentO[0] && currentV[1]===currentO[1] && currentV[0]===currentI[0] && currentV[1]===currentI[1]){
	            if((i===0 || i === len - 1) && !path.c){
	                cloned_path.setTripleAt(currentV[0],currentV[1],currentO[0],currentO[1],currentI[0],currentI[1],index);
	                /*cloned_path.v[index] = currentV;
	                cloned_path.o[index] = currentO;
	                cloned_path.i[index] = currentI;*/
	                index += 1;
	            } else {
	                if(i===0){
	                    closerV = path.v[len-1];
	                } else {
	                    closerV = path.v[i-1];
	                }
	                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
	                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
	                vX = iX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
	                vY = iY = currentV[1]-(currentV[1]-closerV[1])*newPosPerc;
	                oX = vX-(vX-currentV[0])*roundCorner;
	                oY = vY-(vY-currentV[1])*roundCorner;
	                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
	                index += 1;
	
	                if(i === len - 1){
	                    closerV = path.v[0];
	                } else {
	                    closerV = path.v[i+1];
	                }
	                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
	                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
	                vX = oX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
	                vY = oY = currentV[1]+(closerV[1]-currentV[1])*newPosPerc;
	                iX = vX-(vX-currentV[0])*roundCorner;
	                iY = vY-(vY-currentV[1])*roundCorner;
	                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
	                index += 1;
	            }
	        } else {
	            cloned_path.setTripleAt(path.v[i][0],path.v[i][1],path.o[i][0],path.o[i][1],path.i[i][0],path.i[i][1],index);
	            index += 1;
	        }
	    }
	    return cloned_path;
	};
	
	RoundCornersModifier.prototype.processShapes = function(_isFirstFrame){
	    var shapePaths;
	    var i, len = this.shapes.length;
	    var j, jLen;
	    var rd = this.rd.v;
	
	    if(rd !== 0){
	        var shapeData, newPaths, localShapeCollection;
	        for(i=0;i<len;i+=1){
	            shapeData = this.shapes[i];
	            newPaths = shapeData.shape.paths;
	            localShapeCollection = shapeData.localShapeCollection;
	            if(!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)){
	                localShapeCollection.releaseShapes();
	                shapeData.shape._mdf = true;
	                shapePaths = shapeData.shape.paths.shapes;
	                jLen = shapeData.shape.paths._length;
	                for(j=0;j<jLen;j+=1){
	                    localShapeCollection.addShape(this.processPath(shapePaths[j],rd));
	                }
	            }
	            shapeData.shape.paths = shapeData.localShapeCollection;
	        }
	
	    }
	    if(!this.dynamicProperties.length){
	        this._mdf = false;
	    }
	};
	
	ShapeModifiers.registerModifier('rd',RoundCornersModifier);
	function RepeaterModifier(){}
	extendPrototype([ShapeModifier], RepeaterModifier);
	
	RepeaterModifier.prototype.initModifierProperties = function(elem,data){
	    this.getValue = this.processKeys;
	    this.c = PropertyFactory.getProp(elem,data.c,0,null,this);
	    this.o = PropertyFactory.getProp(elem,data.o,0,null,this);
	    this.tr = TransformPropertyFactory.getTransformProperty(elem,data.tr,this);
	    this.so = PropertyFactory.getProp(elem,data.tr.so,0,0.01,this);
	    this.eo = PropertyFactory.getProp(elem,data.tr.eo,0,0.01,this);
	    this.data = data;
	    if(!this.dynamicProperties.length){
	        this.getValue(true);
	    }
	    this._isAnimated = !!this.dynamicProperties.length;
	    this.pMatrix = new Matrix();
	    this.rMatrix = new Matrix();
	    this.sMatrix = new Matrix();
	    this.tMatrix = new Matrix();
	    this.matrix = new Matrix();
	};
	
	RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv){
	    var dir = inv ? -1 : 1;
	    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
	    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
	    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
	    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    rMatrix.rotate(-transform.r.v * dir * perc);
	    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    sMatrix.scale(inv ? 1/scaleX : scaleX, inv ? 1/scaleY : scaleY);
	    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	};
	
	RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData) {
	    this.elem = elem;
	    this.arr = arr;
	    this.pos = pos;
	    this.elemsData = elemsData;
	    this._currentCopies = 0;
	    this._elements = [];
	    this._groups = [];
	    this.frameId = -1;
	    this.initDynamicPropertyContainer(elem);
	    this.initModifierProperties(elem,arr[pos]);
	    var cont = 0;
	    while(pos>0){
	        pos -= 1;
	        //this._elements.unshift(arr.splice(pos,1)[0]);
	        this._elements.unshift(arr[pos]);
	        cont += 1;
	    }
	    if(this.dynamicProperties.length){
	        this.k = true;
	    }else{
	        this.getValue(true);
	    }
	};
	
	RepeaterModifier.prototype.resetElements = function(elements){
	    var i, len = elements.length;
	    for(i = 0; i < len; i += 1) {
	        elements[i]._processed = false;
	        if(elements[i].ty === 'gr'){
	            this.resetElements(elements[i].it);
	        }
	    }
	};
	
	RepeaterModifier.prototype.cloneElements = function(elements){
	    var i, len = elements.length;
	    var newElements = JSON.parse(JSON.stringify(elements));
	    this.resetElements(newElements);
	    return newElements;
	};
	
	RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
	    var i, len = elements.length;
	    for(i = 0; i < len; i += 1) {
	        elements[i]._render = renderFlag;
	        if(elements[i].ty === 'gr') {
	            this.changeGroupRender(elements[i].it, renderFlag);
	        }
	    }
	};
	
	RepeaterModifier.prototype.processShapes = function(_isFirstFrame) {
	    var items, itemsTransform, i, dir, cont;
	    if(this._mdf || _isFirstFrame){
	        var copies = Math.ceil(this.c.v);
	        if(this._groups.length < copies){
	            while(this._groups.length < copies){
	                var group = {
	                    it:this.cloneElements(this._elements),
	                    ty:'gr'
	                };
	                group.it.push({"a":{"a":0,"ix":1,"k":[0,0]},"nm":"Transform","o":{"a":0,"ix":7,"k":100},"p":{"a":0,"ix":2,"k":[0,0]},"r":{"a":1,"ix":6,"k":[{s:0,e:0,t:0},{s:0,e:0,t:1}]},"s":{"a":0,"ix":3,"k":[100,100]},"sa":{"a":0,"ix":5,"k":0},"sk":{"a":0,"ix":4,"k":0},"ty":"tr"});
	                
	                this.arr.splice(0,0,group);
	                this._groups.splice(0,0,group);
	                this._currentCopies += 1;
	            }
	            this.elem.reloadShapes();
	        }
	        cont = 0;
	        var renderFlag;
	        for(i = 0; i  <= this._groups.length - 1; i += 1){
	            renderFlag = cont < copies;
	            this._groups[i]._render = renderFlag;
	            this.changeGroupRender(this._groups[i].it, renderFlag);
	            cont += 1;
	        }
	        
	        this._currentCopies = copies;
	        ////
	
	        var offset = this.o.v;
	        var offsetModulo = offset%1;
	        var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
	        var k;
	        var tMat = this.tr.v.props;
	        var pProps = this.pMatrix.props;
	        var rProps = this.rMatrix.props;
	        var sProps = this.sMatrix.props;
	        this.pMatrix.reset();
	        this.rMatrix.reset();
	        this.sMatrix.reset();
	        this.tMatrix.reset();
	        this.matrix.reset();
	        var iteration = 0;
	
	        if(offset > 0) {
	            while(iteration<roundOffset){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	                iteration += 1;
	            }
	            if(offsetModulo){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
	                iteration += offsetModulo;
	            }
	        } else if(offset < 0) {
	            while(iteration>roundOffset){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
	                iteration -= 1;
	            }
	            if(offsetModulo){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, - offsetModulo, true);
	                iteration -= offsetModulo;
	            }
	        }
	        i = this.data.m === 1 ? 0 : this._currentCopies - 1;
	        dir = this.data.m === 1 ? 1 : -1;
	        cont = this._currentCopies;
	        var j, jLen;
	        while(cont){
	            items = this.elemsData[i].it;
	            itemsTransform = items[items.length - 1].transform.mProps.v.props;
	            jLen = itemsTransform.length;
	            items[items.length - 1].transform.mProps._mdf = true;
	            items[items.length - 1].transform.op._mdf = true;
	            items[items.length - 1].transform.op.v = this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
	            if(iteration !== 0){
	                if((i !== 0 && dir === 1) || (i !== this._currentCopies - 1 && dir === -1)){
	                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	                }
	                this.matrix.transform(rProps[0],rProps[1],rProps[2],rProps[3],rProps[4],rProps[5],rProps[6],rProps[7],rProps[8],rProps[9],rProps[10],rProps[11],rProps[12],rProps[13],rProps[14],rProps[15]);
	                this.matrix.transform(sProps[0],sProps[1],sProps[2],sProps[3],sProps[4],sProps[5],sProps[6],sProps[7],sProps[8],sProps[9],sProps[10],sProps[11],sProps[12],sProps[13],sProps[14],sProps[15]);
	                this.matrix.transform(pProps[0],pProps[1],pProps[2],pProps[3],pProps[4],pProps[5],pProps[6],pProps[7],pProps[8],pProps[9],pProps[10],pProps[11],pProps[12],pProps[13],pProps[14],pProps[15]);
	                
	                for(j=0;j<jLen;j+=1) {
	                    itemsTransform[j] = this.matrix.props[j];
	                }
	                this.matrix.reset();
	            } else {
	                this.matrix.reset();
	                for(j=0;j<jLen;j+=1) {
	                    itemsTransform[j] = this.matrix.props[j];
	                }
	            }
	            iteration += 1;
	            cont -= 1;
	            i += dir;
	        }
	    } else {
	        cont = this._currentCopies;
	        i = 0;
	        dir = 1;
	        while(cont){
	            items = this.elemsData[i].it;
	            itemsTransform = items[items.length - 1].transform.mProps.v.props;
	            items[items.length - 1].transform.mProps._mdf = false;
	            items[items.length - 1].transform.op._mdf = false;
	            cont -= 1;
	            i += dir;
	        }
	    }
	};
	
	RepeaterModifier.prototype.addShape = function(){};
	
	ShapeModifiers.registerModifier('rp',RepeaterModifier);
	function ShapeCollection(){
		this._length = 0;
		this._maxLength = 4;
		this.shapes = createSizedArray(this._maxLength);
	}
	
	ShapeCollection.prototype.addShape = function(shapeData){
		if(this._length === this._maxLength){
			this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
			this._maxLength *= 2;
		}
		this.shapes[this._length] = shapeData;
		this._length += 1;
	};
	
	ShapeCollection.prototype.releaseShapes = function(){
		var i;
		for(i = 0; i < this._length; i += 1) {
			shape_pool.release(this.shapes[i]);
		}
		this._length = 0;
	};
	function DashProperty(elem, data, renderer, container) {
	    this.elem = elem;
	    this.frameId = -1;
	    this.dataProps = createSizedArray(data.length);
	    this.renderer = renderer;
	    this.k = false;
	    this.dashStr = '';
	    this.dashArray = createTypedArray('float32',  data.length ? data.length - 1 : 0);
	    this.dashoffset = createTypedArray('float32',  1);
	    this.initDynamicPropertyContainer(container);
	    var i, len = data.length || 0, prop;
	    for(i = 0; i < len; i += 1) {
	        prop = PropertyFactory.getProp(elem,data[i].v,0, 0, this);
	        this.k = prop.k || this.k;
	        this.dataProps[i] = {n:data[i].n,p:prop};
	    }
	    if(!this.k){
	        this.getValue(true);
	    }
	    this._isAnimated = this.k;
	}
	
	DashProperty.prototype.getValue = function(forceRender) {
	    if(this.elem.globalData.frameId === this.frameId && !forceRender){
	        return;
	    }
	    this.frameId = this.elem.globalData.frameId;
	    this.iterateDynamicProperties();
	    this._mdf = this._mdf || forceRender;
	    if (this._mdf) {
	        var i = 0, len = this.dataProps.length;
	        if(this.renderer === 'svg') {
	            this.dashStr = '';
	        }
	        for(i=0;i<len;i+=1){
	            if(this.dataProps[i].n != 'o'){
	                if(this.renderer === 'svg') {
	                    this.dashStr += ' ' + this.dataProps[i].p.v;
	                }else{
	                    this.dashArray[i] = this.dataProps[i].p.v;
	                }
	            }else{
	                this.dashoffset[0] = this.dataProps[i].p.v;
	            }
	        }
	    }
	};
	extendPrototype([DynamicPropertyContainer], DashProperty);
	function GradientProperty(elem,data,container){
	    this.data = data;
	    this.c = createTypedArray('uint8c', data.p*4);
	    var cLength = data.k.k[0].s ? (data.k.k[0].s.length - data.p*4) : data.k.k.length - data.p*4;
	    this.o = createTypedArray('float32', cLength);
	    this._cmdf = false;
	    this._omdf = false;
	    this._collapsable = this.checkCollapsable();
	    this._hasOpacity = cLength;
	    this.initDynamicPropertyContainer(container);
	    this.prop = PropertyFactory.getProp(elem,data.k,1,null,this);
	    this.k = this.prop.k;
	    this.getValue(true);
	}
	
	GradientProperty.prototype.comparePoints = function(values, points) {
	    var i = 0, len = this.o.length/2, diff;
	    while(i < len) {
	        diff = Math.abs(values[i*4] - values[points*4 + i*2]);
	        if(diff > 0.01){
	            return false;
	        }
	        i += 1;
	    }
	    return true;
	};
	
	GradientProperty.prototype.checkCollapsable = function() {
	    if (this.o.length/2 !== this.c.length/4) {
	        return false;
	    }
	    if (this.data.k.k[0].s) {
	        var i = 0, len = this.data.k.k.length;
	        while (i < len) {
	            if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) {
	                return false;
	            }
	            i += 1;
	        }
	    } else if(!this.comparePoints(this.data.k.k, this.data.p)) {
	        return false;
	    }
	    return true;
	};
	
	GradientProperty.prototype.getValue = function(forceRender){
	    this.prop.getValue();
	    this._mdf = false;
	    this._cmdf = false;
	    this._omdf = false;
	    if(this.prop._mdf || forceRender){
	        var i, len = this.data.p*4;
	        var mult, val;
	        for(i=0;i<len;i+=1){
	            mult = i%4 === 0 ? 100 : 255;
	            val = Math.round(this.prop.v[i]*mult);
	            if(this.c[i] !== val){
	                this.c[i] = val;
	                this._cmdf = !forceRender;
	            }
	        }
	        if(this.o.length){
	            len = this.prop.v.length;
	            for(i=this.data.p*4;i<len;i+=1){
	                mult = i%2 === 0 ? 100 : 1;
	                val = i%2 === 0 ?  Math.round(this.prop.v[i]*100):this.prop.v[i];
	                if(this.o[i-this.data.p*4] !== val){
	                    this.o[i-this.data.p*4] = val;
	                    this._omdf = !forceRender;
	                }
	            }
	        }
	        this._mdf = !forceRender;
	    }
	};
	
	extendPrototype([DynamicPropertyContainer], GradientProperty);
	var buildShapeString = function(pathNodes, length, closed, mat) {
		if(length === 0) {
	            return '';
	        }
	        var _o = pathNodes.o;
	        var _i = pathNodes.i;
	        var _v = pathNodes.v;
	        var i, shapeString = " M" + mat.applyToPointStringified(_v[0][0], _v[0][1]);
	        for(i = 1; i < length; i += 1) {
	            shapeString += " C" + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + " " + mat.applyToPointStringified(_i[i][0], _i[i][1]) + " " + mat.applyToPointStringified(_v[i][0], _v[i][1]);
	        }
	        if (closed && length) {
	            shapeString += " C" + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + " " + mat.applyToPointStringified(_i[0][0], _i[0][1]) + " " + mat.applyToPointStringified(_v[0][0], _v[0][1]);
	            shapeString += 'z';
	        }
	        return shapeString;
	}
	var ImagePreloader = (function(){
	
	    var proxyImage = (function(){
	        var canvas = createTag('canvas');
	        canvas.width = 1;
	        canvas.height = 1;
	        var ctx = canvas.getContext('2d');
	        ctx.fillStyle = '#FF0000';
	        ctx.fillRect(0, 0, 1, 1);
	        return canvas;
	    }())
	
	    function imageLoaded(){
	        this.loadedAssets += 1;
	        if(this.loadedAssets === this.totalImages){
	            if(this.imagesLoadedCb) {
	                this.imagesLoadedCb(null);
	            }
	        }
	    }
	
	    function getAssetsPath(assetData, assetsPath, original_path) {
	        var path = '';
	        if (assetData.e) {
	            path = assetData.p;
	        } else if(assetsPath) {
	            var imagePath = assetData.p;
	            if (imagePath.indexOf('images/') !== -1) {
	                imagePath = imagePath.split('/')[1];
	            }
	            path = assetsPath + imagePath;
	        } else {
	            path = original_path;
	            path += assetData.u ? assetData.u : '';
	            path += assetData.p;
	        }
	        return path;
	    }
	
	    function createImageData(assetData) {
	        var path = getAssetsPath(assetData, this.assetsPath, this.path);
	        var img = createTag('img');
	        img.crossOrigin = 'anonymous';
	        img.addEventListener('load', this._imageLoaded.bind(this), false);
	        img.addEventListener('error', function() {
	            ob.img = proxyImage;
	            this._imageLoaded();
	        }.bind(this), false);
	        img.src = path;
	        var ob = {
	            img: img,
	            assetData: assetData
	        }
	        return ob;
	    }
	
	    function loadAssets(assets, cb){
	        this.imagesLoadedCb = cb;
	        var i, len = assets.length;
	        for (i = 0; i < len; i += 1) {
	            if(!assets[i].layers){
	                this.totalImages += 1;
	                this.images.push(this._createImageData(assets[i]));
	            }
	        }
	    }
	
	    function setPath(path){
	        this.path = path || '';
	    }
	
	    function setAssetsPath(path){
	        this.assetsPath = path || '';
	    }
	
	    function getImage(assetData) {
	        var i = 0, len = this.images.length;
	        while (i < len) {
	            if (this.images[i].assetData === assetData) {
	                return this.images[i].img;
	            }
	            i += 1;
	        }
	    }
	
	    function destroy() {
	        this.imagesLoadedCb = null;
	        this.images.length = 0;
	    }
	
	    function loaded() {
	        return this.totalImages === this.loadedAssets;
	    }
	
	    return function ImagePreloader(){
	        this.loadAssets = loadAssets;
	        this.setAssetsPath = setAssetsPath;
	        this.setPath = setPath;
	        this.loaded = loaded;
	        this.destroy = destroy;
	        this.getImage = getImage;
	        this._createImageData = createImageData;
	        this._imageLoaded = imageLoaded;
	        this.assetsPath = '';
	        this.path = '';
	        this.totalImages = 0;
	        this.loadedAssets = 0;
	        this.imagesLoadedCb = null;
	        this.images = [];
	    };
	}());
	var featureSupport = (function(){
		var ob = {
			maskType: true
		};
		if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
		   ob.maskType = false;
		}
		return ob;
	}());
	var filtersFactory = (function(){
		var ob = {};
		ob.createFilter = createFilter;
		ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
	
		function createFilter(filId){
	        	var fil = createNS('filter');
	        	fil.setAttribute('id',filId);
	                fil.setAttribute('filterUnits','objectBoundingBox');
	                fil.setAttribute('x','0%');
	                fil.setAttribute('y','0%');
	                fil.setAttribute('width','100%');
	                fil.setAttribute('height','100%');
	                return fil;
		}
	
		function createAlphaToLuminanceFilter(){
	                var feColorMatrix = createNS('feColorMatrix');
	                feColorMatrix.setAttribute('type','matrix');
	                feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	                feColorMatrix.setAttribute('values','0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
	                return feColorMatrix;
		}
	
		return ob;
	}());
	var assetLoader = (function(){
	
		function formatResponse(xhr) {
			if(xhr.response && typeof xhr.response === 'object') {
				return xhr.response;
			} else if(xhr.response && typeof xhr.response === 'string') {
				return JSON.parse(xhr.response);
			} else if(xhr.responseText) {
				return JSON.parse(xhr.responseText);
			}
		}
	
		function loadAsset(path, callback, errorCallback) {
			var response;
			var xhr = new XMLHttpRequest();
			xhr.open('GET', path, true);
			// set responseType after calling open or IE will break.
			xhr.responseType = "json";
		    xhr.send();
		    xhr.onreadystatechange = function () {
		        if (xhr.readyState == 4) {
		            if(xhr.status == 200){
		            	response = formatResponse(xhr);
		            	callback(response);
		            }else{
		                try{
		            		response = formatResponse(xhr);
		            		callback(response);
		                }catch(err){
		                	if(errorCallback) {
		                		errorCallback(err);
		                	}
		                }
		            }
		        }
		    };
		}
		return {
			load: loadAsset
		}
	}())
	
	function TextAnimatorProperty(textData, renderType, elem){
	    this._isFirstFrame = true;
		this._hasMaskedPath = false;
		this._frameId = -1;
		this._textData = textData;
		this._renderType = renderType;
	    this._elem = elem;
		this._animatorsData = createSizedArray(this._textData.a.length);
		this._pathData = {};
		this._moreOptions = {
			alignment: {}
		};
		this.renderedLetters = [];
	    this.lettersChangedFlag = false;
	    this.initDynamicPropertyContainer(elem);
	
	}
	
	TextAnimatorProperty.prototype.searchProperties = function(){
	    var i, len = this._textData.a.length, animatorProps;
	    var getProp = PropertyFactory.getProp;
	    for(i=0;i<len;i+=1){
	        animatorProps = this._textData.a[i];
	        this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
	    }
	    if(this._textData.p && 'm' in this._textData.p){
	        this._pathData = {
	            f: getProp(this._elem,this._textData.p.f,0,0,this),
	            l: getProp(this._elem,this._textData.p.l,0,0,this),
	            r: this._textData.p.r,
	            m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
	        };
	        this._hasMaskedPath = true;
	    } else {
	        this._hasMaskedPath = false;
	    }
	    this._moreOptions.alignment = getProp(this._elem,this._textData.m.a,1,0,this);
	};
	
	TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag){
	    this.lettersChangedFlag = lettersChangedFlag;
	    if(!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) {
	        return;
	    }
	    this._isFirstFrame = false;
	    var alignment = this._moreOptions.alignment.v;
	    var animators = this._animatorsData;
	    var textData = this._textData;
	    var matrixHelper = this.mHelper;
	    var renderType = this._renderType;
	    var renderedLettersCount = this.renderedLetters.length;
	    var data = this.data;
	    var xPos,yPos;
	    var i, len;
	    var letters = documentData.l, pathInfo, currentLength, currentPoint, segmentLength, flag, pointInd, segmentInd, prevPoint, points, segments, partialLength, totalLength, perc, tanAngle, mask;
	    if(this._hasMaskedPath) {
	        mask = this._pathData.m;
	        if(!this._pathData.n || this._pathData._mdf){
	            var paths = mask.v;
	            if(this._pathData.r){
	                paths = paths.reverse();
	            }
	            // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
	            pathInfo = {
	                tLength: 0,
	                segments: []
	            };
	            len = paths._length - 1;
	            var pathData;
	            totalLength = 0;
	            for (i = 0; i < len; i += 1) {
	                pathData = {
	                    s: paths.v[i],
	                    e: paths.v[i + 1],
	                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
	                    ti: [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]
	                };
	                bez.buildBezierData(pathData);
	                pathInfo.tLength += pathData.bezierData.segmentLength;
	                pathInfo.segments.push(pathData);
	                totalLength += pathData.bezierData.segmentLength;
	            }
	            i = len;
	            if (mask.v.c) {
	                pathData = {
	                    s: paths.v[i],
	                    e: paths.v[0],
	                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
	                    ti: [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]
	                };
	                bez.buildBezierData(pathData);
	                pathInfo.tLength += pathData.bezierData.segmentLength;
	                pathInfo.segments.push(pathData);
	                totalLength += pathData.bezierData.segmentLength;
	            }
	            this._pathData.pi = pathInfo;
	        }
	        pathInfo = this._pathData.pi;
	
	        currentLength = this._pathData.f.v;
	        segmentInd = 0;
	        pointInd = 1;
	        segmentLength = 0;
	        flag = true;
	        segments = pathInfo.segments;
	        if (currentLength < 0 && mask.v.c) {
	            if (pathInfo.tLength < Math.abs(currentLength)) {
	                currentLength = -Math.abs(currentLength) % pathInfo.tLength;
	            }
	            segmentInd = segments.length - 1;
	            points = segments[segmentInd].bezierData.points;
	            pointInd = points.length - 1;
	            while (currentLength < 0) {
	                currentLength += points[pointInd].partialLength;
	                pointInd -= 1;
	                if (pointInd < 0) {
	                    segmentInd -= 1;
	                    points = segments[segmentInd].bezierData.points;
	                    pointInd = points.length - 1;
	                }
	            }
	
	        }
	        points = segments[segmentInd].bezierData.points;
	        prevPoint = points[pointInd - 1];
	        currentPoint = points[pointInd];
	        partialLength = currentPoint.partialLength;
	    }
	
	
	    len = letters.length;
	    xPos = 0;
	    yPos = 0;
	    var yOff = documentData.finalSize * 1.2 * 0.714;
	    var firstLine = true;
	    var animatorProps, animatorSelector;
	    var j, jLen;
	    var letterValue;
	
	    jLen = animators.length;
	    var lastLetter;
	
	    var mult, ind = -1, offf, xPathPos, yPathPos;
	    var initPathPos = currentLength,initSegmentInd = segmentInd, initPointInd = pointInd, currentLine = -1;
	    var elemOpacity;
	    var sc,sw,fc,k;
	    var lineLength = 0;
	    var letterSw, letterSc, letterFc, letterM = '', letterP = this.defaultPropsArray, letterO;
	
	    //
	    if(documentData.j === 2 || documentData.j === 1) {
	        var animatorJustifyOffset = 0;
	        var animatorFirstCharOffset = 0;
	        var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
	        var lastIndex = 0;
	        var isNewLine = true;
	
	        for (i = 0; i < len; i += 1) {
	            if (letters[i].n) {
	                if(animatorJustifyOffset) {
	                    animatorJustifyOffset += animatorFirstCharOffset;
	                }
	                while (lastIndex < i) {
	                    letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
	                    lastIndex += 1;
	                }
	                animatorJustifyOffset = 0;
	                isNewLine = true;
	            } else {
	                for (j = 0; j < jLen; j += 1) {
	                    animatorProps = animators[j].a;
	                    if (animatorProps.t.propType) {
	                        if (isNewLine && documentData.j === 2) {
	                            animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
	                        }
	                        animatorSelector = animators[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	                        if (mult.length) {
	                            animatorJustifyOffset += animatorProps.t.v*mult[0] * justifyOffsetMult;
	                        } else {
	                            animatorJustifyOffset += animatorProps.t.v*mult * justifyOffsetMult;
	                        }
	                    }
	                }
	                isNewLine = false;
	            }
	        }
	        if(animatorJustifyOffset) {
	            animatorJustifyOffset += animatorFirstCharOffset;
	        }
	        while(lastIndex < i) {
	            letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
	            lastIndex += 1;
	        }
	    }
	    //
	
	    for( i = 0; i < len; i += 1) {
	
	        matrixHelper.reset();
	        elemOpacity = 1;
	        if(letters[i].n) {
	            xPos = 0;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            currentLength = initPathPos ;
	            firstLine = false;
	            lineLength = 0;
	            if(this._hasMaskedPath) {
	                segmentInd = initSegmentInd;
	                pointInd = initPointInd;
	                points = segments[segmentInd].bezierData.points;
	                prevPoint = points[pointInd - 1];
	                currentPoint = points[pointInd];
	                partialLength = currentPoint.partialLength;
	                segmentLength = 0;
	            }
	            letterO = letterSw = letterFc = letterM = '';
	            letterP = this.defaultPropsArray;
	        }else{
	            if(this._hasMaskedPath) {
	                if(currentLine !== letters[i].line){
	                    switch(documentData.j){
	                        case 1:
	                            currentLength += totalLength - documentData.lineWidths[letters[i].line];
	                            break;
	                        case 2:
	                            currentLength += (totalLength - documentData.lineWidths[letters[i].line])/2;
	                            break;
	                    }
	                    currentLine = letters[i].line;
	                }
	                if (ind !== letters[i].ind) {
	                    if (letters[ind]) {
	                        currentLength += letters[ind].extra;
	                    }
	                    currentLength += letters[i].an / 2;
	                    ind = letters[i].ind;
	                }
	                currentLength += alignment[0] * letters[i].an / 200;
	                var animatorOffset = 0;
	                for (j = 0; j < jLen; j += 1) {
	                    animatorProps = animators[j].a;
	                    if (animatorProps.p.propType) {
	                        animatorSelector = animators[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                        if(mult.length){
	                            animatorOffset += animatorProps.p.v[0] * mult[0];
	                        } else{
	                            animatorOffset += animatorProps.p.v[0] * mult;
	                        }
	
	                    }
	                    if (animatorProps.a.propType) {
	                        animatorSelector = animators[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                        if(mult.length){
	                            animatorOffset += animatorProps.a.v[0] * mult[0];
	                        } else{
	                            animatorOffset += animatorProps.a.v[0] * mult;
	                        }
	
	                    }
	                }
	                flag = true;
	                while (flag) {
	                    if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
	                        perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
	                        xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
	                        yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
	                        matrixHelper.translate(-alignment[0]*letters[i].an/200, -(alignment[1] * yOff / 100));
	                        flag = false;
	                    } else if (points) {
	                        segmentLength += currentPoint.partialLength;
	                        pointInd += 1;
	                        if (pointInd >= points.length) {
	                            pointInd = 0;
	                            segmentInd += 1;
	                            if (!segments[segmentInd]) {
	                                if (mask.v.c) {
	                                    pointInd = 0;
	                                    segmentInd = 0;
	                                    points = segments[segmentInd].bezierData.points;
	                                } else {
	                                    segmentLength -= currentPoint.partialLength;
	                                    points = null;
	                                }
	                            } else {
	                                points = segments[segmentInd].bezierData.points;
	                            }
	                        }
	                        if (points) {
	                            prevPoint = currentPoint;
	                            currentPoint = points[pointInd];
	                            partialLength = currentPoint.partialLength;
	                        }
	                    }
	                }
	                offf = letters[i].an / 2 - letters[i].add;
	                matrixHelper.translate(-offf, 0, 0);
	            } else {
	                offf = letters[i].an/2 - letters[i].add;
	                matrixHelper.translate(-offf,0,0);
	
	                // Grouping alignment
	                matrixHelper.translate(-alignment[0]*letters[i].an/200, -alignment[1]*yOff/100, 0);
	            }
	
	            lineLength += letters[i].l/2;
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if (animatorProps.t.propType) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    //This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
	                    if(xPos !== 0 || documentData.j !== 0) {
	                        if(this._hasMaskedPath) {
	                            if(mult.length) {
	                                currentLength += animatorProps.t.v*mult[0];
	                            } else {
	                                currentLength += animatorProps.t.v*mult;
	                            }
	                        }else{
	                            if(mult.length) {
	                                xPos += animatorProps.t.v*mult[0];
	                            } else {
	                                xPos += animatorProps.t.v*mult;
	                            }
	                        }
	                    }
	                }
	            }
	            lineLength += letters[i].l/2;
	            if(documentData.strokeWidthAnim) {
	                sw = documentData.sw || 0;
	            }
	            if(documentData.strokeColorAnim) {
	                if(documentData.sc){
	                    sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
	                }else{
	                    sc = [0,0,0];
	                }
	            }
	            if(documentData.fillColorAnim && documentData.fc) {
	                fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
	            }
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if (animatorProps.a.propType) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	
	                    if(mult.length){
	                        matrixHelper.translate(-animatorProps.a.v[0]*mult[0], -animatorProps.a.v[1]*mult[1], animatorProps.a.v[2]*mult[2]);
	                    } else {
	                        matrixHelper.translate(-animatorProps.a.v[0]*mult, -animatorProps.a.v[1]*mult, animatorProps.a.v[2]*mult);
	                    }
	                }
	            }
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if (animatorProps.s.propType) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    if(mult.length){
	                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult[0]),1+((animatorProps.s.v[1]-1)*mult[1]),1);
	                    } else {
	                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult),1+((animatorProps.s.v[1]-1)*mult),1);
	                    }
	                }
	            }
	            for(j=0;j<jLen;j+=1) {
	                animatorProps = animators[j].a;
	                animatorSelector = animators[j].s;
	                mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                if (animatorProps.sk.propType) {
	                    if(mult.length) {
	                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
	                    } else {
	                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
	                    }
	                }
	                if (animatorProps.r.propType) {
	                    if(mult.length) {
	                        matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
	                    } else {
	                        matrixHelper.rotateZ(-animatorProps.r.v * mult);
	                    }
	                }
	                if (animatorProps.ry.propType) {
	
	                    if(mult.length) {
	                        matrixHelper.rotateY(animatorProps.ry.v*mult[1]);
	                    }else{
	                        matrixHelper.rotateY(animatorProps.ry.v*mult);
	                    }
	                }
	                if (animatorProps.rx.propType) {
	                    if(mult.length) {
	                        matrixHelper.rotateX(animatorProps.rx.v*mult[0]);
	                    } else {
	                        matrixHelper.rotateX(animatorProps.rx.v*mult);
	                    }
	                }
	                if (animatorProps.o.propType) {
	                    if(mult.length) {
	                        elemOpacity += ((animatorProps.o.v)*mult[0] - elemOpacity)*mult[0];
	                    } else {
	                        elemOpacity += ((animatorProps.o.v)*mult - elemOpacity)*mult;
	                    }
	                }
	                if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
	                    if(mult.length) {
	                        sw += animatorProps.sw.v*mult[0];
	                    } else {
	                        sw += animatorProps.sw.v*mult;
	                    }
	                }
	                if (documentData.strokeColorAnim && animatorProps.sc.propType) {
	                    for(k=0;k<3;k+=1){
	                        if(mult.length) {
	                            sc[k] = sc[k] + (animatorProps.sc.v[k] - sc[k])*mult[0];
	                        } else {
	                            sc[k] = sc[k] + (animatorProps.sc.v[k] - sc[k])*mult;
	                        }
	                    }
	                }
	                if (documentData.fillColorAnim && documentData.fc) {
	                    if(animatorProps.fc.propType){
	                        for(k=0;k<3;k+=1){
	                            if(mult.length) {
	                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult[0];
	                            } else {
	                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult;
	                            }
	                        }
	                    }
	                    if(animatorProps.fh.propType){
	                        if(mult.length) {
	                            fc = addHueToRGB(fc,animatorProps.fh.v*mult[0]);
	                        } else {
	                            fc = addHueToRGB(fc,animatorProps.fh.v*mult);
	                        }
	                    }
	                    if(animatorProps.fs.propType){
	                        if(mult.length) {
	                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult[0]);
	                        } else {
	                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult);
	                        }
	                    }
	                    if(animatorProps.fb.propType){
	                        if(mult.length) {
	                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult[0]);
	                        } else {
	                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult);
	                        }
	                    }
	                }
	            }
	
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	
	                if (animatorProps.p.propType) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    if(this._hasMaskedPath) {
	                        if(mult.length) {
	                            matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
	                        } else {
	                            matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	                        }
	                    }else{
	                        if(mult.length) {
	                            matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
	                        } else {
	                            matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	                        
	                        }
	                    }
	                }
	            }
	            if(documentData.strokeWidthAnim){
	                letterSw = sw < 0 ? 0 : sw;
	            }
	            if(documentData.strokeColorAnim){
	                letterSc = 'rgb('+Math.round(sc[0]*255)+','+Math.round(sc[1]*255)+','+Math.round(sc[2]*255)+')';
	            }
	            if(documentData.fillColorAnim && documentData.fc){
	                letterFc = 'rgb('+Math.round(fc[0]*255)+','+Math.round(fc[1]*255)+','+Math.round(fc[2]*255)+')';
	            }
	
	            if(this._hasMaskedPath) {
	                matrixHelper.translate(0,-documentData.ls);
	
	                matrixHelper.translate(0, alignment[1]*yOff/100 + yPos,0);
	                if (textData.p.p) {
	                    tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
	                    var rot = Math.atan(tanAngle) * 180 / Math.PI;
	                    if (currentPoint.point[0] < prevPoint.point[0]) {
	                        rot += 180;
	                    }
	                    matrixHelper.rotate(-rot * Math.PI / 180);
	                }
	                matrixHelper.translate(xPathPos, yPathPos, 0);
	                currentLength -= alignment[0]*letters[i].an/200;
	                if(letters[i+1] && ind !== letters[i+1].ind){
	                    currentLength += letters[i].an / 2;
	                    currentLength += documentData.tr/1000*documentData.finalSize;
	                }
	            }else{
	
	                matrixHelper.translate(xPos,yPos,0);
	
	                if(documentData.ps){
	                    //matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
	                    matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
	                }
	                switch(documentData.j){
	                    case 1:
	                        matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]),0,0);
	                        break;
	                    case 2:
	                        matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line])/2,0,0);
	                        break;
	                }
	                matrixHelper.translate(0,-documentData.ls);
	                matrixHelper.translate(offf,0,0);
	                matrixHelper.translate(alignment[0]*letters[i].an/200,alignment[1]*yOff/100,0);
	                xPos += letters[i].l + documentData.tr/1000*documentData.finalSize;
	            }
	            if(renderType === 'html'){
	                letterM = matrixHelper.toCSS();
	            }else if(renderType === 'svg'){
	                letterM = matrixHelper.to2dCSS();
	            }else{
	                letterP = [matrixHelper.props[0],matrixHelper.props[1],matrixHelper.props[2],matrixHelper.props[3],matrixHelper.props[4],matrixHelper.props[5],matrixHelper.props[6],matrixHelper.props[7],matrixHelper.props[8],matrixHelper.props[9],matrixHelper.props[10],matrixHelper.props[11],matrixHelper.props[12],matrixHelper.props[13],matrixHelper.props[14],matrixHelper.props[15]];
	            }
	            letterO = elemOpacity;
	        }
	
	        if(renderedLettersCount <= i) {
	            letterValue = new LetterProps(letterO,letterSw,letterSc,letterFc,letterM,letterP);
	            this.renderedLetters.push(letterValue);
	            renderedLettersCount += 1;
	            this.lettersChangedFlag = true;
	        } else {
	            letterValue = this.renderedLetters[i];
	            this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
	        }
	    }
	};
	
	TextAnimatorProperty.prototype.getValue = function(){
		if(this._elem.globalData.frameId === this._frameId){
	        return;
	    }
	    this._frameId = this._elem.globalData.frameId;
	    this.iterateDynamicProperties();
	};
	
	TextAnimatorProperty.prototype.mHelper = new Matrix();
	TextAnimatorProperty.prototype.defaultPropsArray = [];
	extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
	function TextAnimatorDataProperty(elem, animatorProps, container) {
		var defaultData = {propType:false};
		var getProp = PropertyFactory.getProp;
		var textAnimator_animatables = animatorProps.a;
		this.a = {
			r: textAnimator_animatables.r ? getProp(elem, textAnimator_animatables.r, 0, degToRads, container) : defaultData,
			rx: textAnimator_animatables.rx ? getProp(elem, textAnimator_animatables.rx, 0, degToRads, container) : defaultData,
			ry: textAnimator_animatables.ry ? getProp(elem, textAnimator_animatables.ry, 0, degToRads, container) : defaultData,
			sk: textAnimator_animatables.sk ? getProp(elem, textAnimator_animatables.sk, 0, degToRads, container) : defaultData,
			sa: textAnimator_animatables.sa ? getProp(elem, textAnimator_animatables.sa, 0, degToRads, container) : defaultData,
			s: textAnimator_animatables.s ? getProp(elem, textAnimator_animatables.s, 1, 0.01, container) : defaultData,
			a: textAnimator_animatables.a ? getProp(elem, textAnimator_animatables.a, 1, 0, container) : defaultData,
			o: textAnimator_animatables.o ? getProp(elem, textAnimator_animatables.o, 0, 0.01, container) : defaultData,
			p: textAnimator_animatables.p ? getProp(elem,textAnimator_animatables.p, 1, 0, container) : defaultData,
			sw: textAnimator_animatables.sw ? getProp(elem, textAnimator_animatables.sw, 0, 0, container) : defaultData,
			sc: textAnimator_animatables.sc ? getProp(elem, textAnimator_animatables.sc, 1, 0, container) : defaultData,
			fc: textAnimator_animatables.fc ? getProp(elem, textAnimator_animatables.fc, 1, 0, container) : defaultData,
			fh: textAnimator_animatables.fh ? getProp(elem, textAnimator_animatables.fh, 0, 0, container) : defaultData,
			fs: textAnimator_animatables.fs ? getProp(elem, textAnimator_animatables.fs, 0, 0.01, container) : defaultData,
			fb: textAnimator_animatables.fb ? getProp(elem, textAnimator_animatables.fb, 0, 0.01, container) : defaultData,
			t: textAnimator_animatables.t ? getProp(elem, textAnimator_animatables.t, 0, 0, container) : defaultData
		};
	
		this.s = TextSelectorProp.getTextSelectorProp(elem,animatorProps.s, container);
	    this.s.t = animatorProps.s.t;
	}
	function LetterProps(o, sw, sc, fc, m, p){
	    this.o = o;
	    this.sw = sw;
	    this.sc = sc;
	    this.fc = fc;
	    this.m = m;
	    this.p = p;
	    this._mdf = {
	    	o: true,
	    	sw: !!sw,
	    	sc: !!sc,
	    	fc: !!fc,
	    	m: true,
	    	p: true
	    };
	}
	
	LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
		this._mdf.o = false;
		this._mdf.sw = false;
		this._mdf.sc = false;
		this._mdf.fc = false;
		this._mdf.m = false;
		this._mdf.p = false;
		var updated = false;
	
		if(this.o !== o) {
			this.o = o;
			this._mdf.o = true;
			updated = true;
		}
		if(this.sw !== sw) {
			this.sw = sw;
			this._mdf.sw = true;
			updated = true;
		}
		if(this.sc !== sc) {
			this.sc = sc;
			this._mdf.sc = true;
			updated = true;
		}
		if(this.fc !== fc) {
			this.fc = fc;
			this._mdf.fc = true;
			updated = true;
		}
		if(this.m !== m) {
			this.m = m;
			this._mdf.m = true;
			updated = true;
		}
		if(p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
			this.p = p;
			this._mdf.p = true;
			updated = true;
		}
		return updated;
	};
	function TextProperty(elem, data){
		this._frameId = initialDefaultFrame;
		this.pv = '';
		this.v = '';
		this.kf = false;
		this._isFirstFrame = true;
		this._mdf = false;
	    this.data = data;
		this.elem = elem;
	    this.comp = this.elem.comp;
		this.keysIndex = 0;
	    this.canResize = false;
	    this.minimumFontSize = 1;
	    this.effectsSequence = [];
		this.currentData = {
			ascent: 0,
	        boxWidth: this.defaultBoxWidth,
	        f: '',
	        fStyle: '',
	        fWeight: '',
	        fc: '',
	        j: '',
	        justifyOffset: '',
	        l: [],
	        lh: 0,
	        lineWidths: [],
	        ls: '',
	        of: '',
	        s: '',
	        sc: '',
	        sw: 0,
	        t: 0,
	        tr: 0,
	        sz:0,
	        ps:null,
	        fillColorAnim: false,
	        strokeColorAnim: false,
	        strokeWidthAnim: false,
	        yOffset: 0,
	        finalSize:0,
	        finalText:[],
	        finalLineHeight: 0,
	        __complete: false
	
		};
	    this.copyData(this.currentData, this.data.d.k[0].s);
	
	    if(!this.searchProperty()) {
	        this.completeTextData(this.currentData);
	    }
	}
	
	TextProperty.prototype.defaultBoxWidth = [0,0];
	
	TextProperty.prototype.copyData = function(obj, data) {
	    for(var s in data) {
	        if(data.hasOwnProperty(s)) {
	            obj[s] = data[s];
	        }
	    }
	    return obj;
	}
	
	TextProperty.prototype.setCurrentData = function(data){
	    if(!data.__complete) {
	        this.completeTextData(data);
	    }
	    this.currentData = data;
	    this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
	    this._mdf = true;
	};
	
	TextProperty.prototype.searchProperty = function() {
	    return this.searchKeyframes();
	};
	
	TextProperty.prototype.searchKeyframes = function() {
	    this.kf = this.data.d.k.length > 1;
	    if(this.kf) {
	        this.addEffect(this.getKeyframeValue.bind(this));
	    }
	    return this.kf;
	}
	
	TextProperty.prototype.addEffect = function(effectFunction) {
		this.effectsSequence.push(effectFunction);
	    this.elem.addDynamicProperty(this);
	};
	
	TextProperty.prototype.getValue = function(_finalValue) {
	    if((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) {
	        return;
	    }
	    this.currentData.t = this.data.d.k[this.keysIndex].s.t;
	    var currentValue = this.currentData;
	    var currentIndex = this.keysIndex;
	    if(this.lock) {
	        this.setCurrentData(this.currentData);
	        return;
	    }
	    this.lock = true;
	    this._mdf = false;
	    var multipliedValue;
	    var i, len = this.effectsSequence.length;
	    var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
	    for(i = 0; i < len; i += 1) {
	        //Checking if index changed to prevent creating a new object every time the expression updates.
	        if(currentIndex !== this.keysIndex) {
	            finalValue = this.effectsSequence[i](finalValue, finalValue.t);
	        } else {
	            finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
	        }
	    }
	    if(currentValue !== finalValue) {
	        this.setCurrentData(finalValue);
	    }
	    this.pv = this.v = this.currentData;
	    this.lock = false;
	    this.frameId = this.elem.globalData.frameId;
	}
	
	TextProperty.prototype.getKeyframeValue = function() {
	    var textKeys = this.data.d.k, textDocumentData;
	    var frameNum = this.elem.comp.renderedFrame;
	    var i = 0, len = textKeys.length;
	    while(i <= len - 1) {
	        textDocumentData = textKeys[i].s;
	        if(i === len - 1 || textKeys[i+1].t > frameNum){
	            break;
	        }
	        i += 1;
	    }
	    if(this.keysIndex !== i) {
	        this.keysIndex = i;
	    }
	    return this.data.d.k[this.keysIndex].s;
	};
	
	TextProperty.prototype.buildFinalText = function(text) {
	    var combinedCharacters = FontManager.getCombinedCharacterCodes();
	    var charactersArray = [];
	    var i = 0, len = text.length;
	    while (i < len) {
	        if (combinedCharacters.indexOf(text.charCodeAt(i)) !== -1) {
	            charactersArray[charactersArray.length - 1] += text.charAt(i);
	        } else {
	            charactersArray.push(text.charAt(i));
	        }
	        i += 1;
	    }
	    return charactersArray;
	}
	
	TextProperty.prototype.completeTextData = function(documentData) {
	    documentData.__complete = true;
	    var fontManager = this.elem.globalData.fontManager;
	    var data = this.data;
	    var letters = [];
	    var i, len;
	    var newLineFlag, index = 0, val;
	    var anchorGrouping = data.m.g;
	    var currentSize = 0, currentPos = 0, currentLine = 0, lineWidths = [];
	    var lineWidth = 0;
	    var maxLineWidth = 0;
	    var j, jLen;
	    var fontData = fontManager.getFontByName(documentData.f);
	    var charData, cLength = 0;
	    var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
	
	    var fWeight = 'normal', fStyle = 'normal';
	    len = styles.length;
	    var styleName;
	    for(i=0;i<len;i+=1){
	        styleName = styles[i].toLowerCase();
	        switch(styleName) {
	            case 'italic':
	            fStyle = 'italic';
	            break;
	            case 'bold':
	            fWeight = '700';
	            break;
	            case 'black':
	            fWeight = '900';
	            break;
	            case 'medium':
	            fWeight = '500';
	            break;
	            case 'regular':
	            case 'normal':
	            fWeight = '400';
	            break;
	            case 'light':
	            case 'thin':
	            fWeight = '200';
	            break;
	        }
	    }
	    documentData.fWeight = fontData.fWeight || fWeight;
	    documentData.fStyle = fStyle;
	    len = documentData.t.length;
	    documentData.finalSize = documentData.s;
	    documentData.finalText = this.buildFinalText(documentData.t);
	    documentData.finalLineHeight = documentData.lh;
	    var trackingOffset = documentData.tr/1000*documentData.finalSize;
	    var charCode;
	    if(documentData.sz){
	        var flag = true;
	        var boxWidth = documentData.sz[0];
	        var boxHeight = documentData.sz[1];
	        var currentHeight, finalText;
	        while(flag) {
	            finalText = this.buildFinalText(documentData.t);
	            currentHeight = 0;
	            lineWidth = 0;
	            len = finalText.length;
	            trackingOffset = documentData.tr/1000*documentData.finalSize;
	            var lastSpaceIndex = -1;
	            for(i=0;i<len;i+=1){
	                charCode = finalText[i].charCodeAt(0);
	                newLineFlag = false;
	                if(finalText[i] === ' '){
	                    lastSpaceIndex = i;
	                }else if(charCode === 13 || charCode === 3){
	                    lineWidth = 0;
	                    newLineFlag = true;
	                    currentHeight += documentData.finalLineHeight || documentData.finalSize*1.2;
	                }
	                if(fontManager.chars){
	                    charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
	                    cLength = newLineFlag ? 0 : charData.w*documentData.finalSize/100;
	                }else{
	                    //tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
	                    cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
	                }
	                if(lineWidth + cLength > boxWidth && finalText[i] !== ' '){
	                    if(lastSpaceIndex === -1){
	                        len += 1;
	                    } else {
	                        i = lastSpaceIndex;
	                    }
	                    currentHeight += documentData.finalLineHeight || documentData.finalSize*1.2;
	                    finalText.splice(i, lastSpaceIndex === i ? 1 : 0,"\r");
	                    //finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
	                    lastSpaceIndex = -1;
	                    lineWidth = 0;
	                }else {
	                    lineWidth += cLength;
	                    lineWidth += trackingOffset;
	                }
	            }
	            currentHeight += fontData.ascent*documentData.finalSize/100;
	            if(this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
	                documentData.finalSize -= 1;
	                documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
	            } else {
	                documentData.finalText = finalText;
	                len = documentData.finalText.length;
	                flag = false;
	            }
	        }
	
	    }
	    lineWidth = - trackingOffset;
	    cLength = 0;
	    var uncollapsedSpaces = 0;
	    var currentChar;
	    for (i = 0;i < len ;i += 1) {
	        newLineFlag = false;
	        currentChar = documentData.finalText[i];
	        charCode = currentChar.charCodeAt(0);
	        if (currentChar === ' '){
	            val = '\u00A0';
	        } else if (charCode === 13 || charCode === 3) {
	            uncollapsedSpaces = 0;
	            lineWidths.push(lineWidth);
	            maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	            lineWidth = - 2 * trackingOffset;
	            val = '';
	            newLineFlag = true;
	            currentLine += 1;
	        }else{
	            val = documentData.finalText[i];
	        }
	        if(fontManager.chars){
	            charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
	            cLength = newLineFlag ? 0 : charData.w*documentData.finalSize/100;
	        }else{
	            //var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
	            //tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
	            cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
	        }
	
	        //
	        if(currentChar === ' '){
	            uncollapsedSpaces += cLength + trackingOffset;
	        } else {
	            lineWidth += cLength + trackingOffset + uncollapsedSpaces;
	            uncollapsedSpaces = 0;
	        }
	        letters.push({l:cLength,an:cLength,add:currentSize,n:newLineFlag, anIndexes:[], val: val, line: currentLine, animatorJustifyOffset: 0});
	        if(anchorGrouping == 2){
	            currentSize += cLength;
	            if(val === '' || val === '\u00A0' || i === len - 1){
	                if(val === '' || val === '\u00A0'){
	                    currentSize -= cLength;
	                }
	                while(currentPos<=i){
	                    letters[currentPos].an = currentSize;
	                    letters[currentPos].ind = index;
	                    letters[currentPos].extra = cLength;
	                    currentPos += 1;
	                }
	                index += 1;
	                currentSize = 0;
	            }
	        }else if(anchorGrouping == 3){
	            currentSize += cLength;
	            if(val === '' || i === len - 1){
	                if(val === ''){
	                    currentSize -= cLength;
	                }
	                while(currentPos<=i){
	                    letters[currentPos].an = currentSize;
	                    letters[currentPos].ind = index;
	                    letters[currentPos].extra = cLength;
	                    currentPos += 1;
	                }
	                currentSize = 0;
	                index += 1;
	            }
	        }else{
	            letters[index].ind = index;
	            letters[index].extra = 0;
	            index += 1;
	        }
	    }
	    documentData.l = letters;
	    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	    lineWidths.push(lineWidth);
	    if(documentData.sz){
	        documentData.boxWidth = documentData.sz[0];
	        documentData.justifyOffset = 0;
	    }else{
	        documentData.boxWidth = maxLineWidth;
	        switch(documentData.j){
	            case 1:
	                documentData.justifyOffset = - documentData.boxWidth;
	                break;
	            case 2:
	                documentData.justifyOffset = - documentData.boxWidth/2;
	                break;
	            default:
	                documentData.justifyOffset = 0;
	        }
	    }
	    documentData.lineWidths = lineWidths;
	
	    var animators = data.a, animatorData, letterData;
	    jLen = animators.length;
	    var based, ind, indexes = [];
	    for(j=0;j<jLen;j+=1){
	        animatorData = animators[j];
	        if(animatorData.a.sc){
	            documentData.strokeColorAnim = true;
	        }
	        if(animatorData.a.sw){
	            documentData.strokeWidthAnim = true;
	        }
	        if(animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb){
	            documentData.fillColorAnim = true;
	        }
	        ind = 0;
	        based = animatorData.s.b;
	        for(i=0;i<len;i+=1){
	            letterData = letters[i];
	            letterData.anIndexes[j] = ind;
	            if((based == 1 && letterData.val !== '') || (based == 2 && letterData.val !== '' && letterData.val !== '\u00A0') || (based == 3 && (letterData.n || letterData.val == '\u00A0' || i == len - 1)) || (based == 4 && (letterData.n || i == len - 1))){
	                if(animatorData.s.rn === 1){
	                    indexes.push(ind);
	                }
	                ind += 1;
	            }
	        }
	        data.a[j].s.totalChars = ind;
	        var currentInd = -1, newInd;
	        if(animatorData.s.rn === 1){
	            for(i = 0; i < len; i += 1){
	                letterData = letters[i];
	                if(currentInd != letterData.anIndexes[j]){
	                    currentInd = letterData.anIndexes[j];
	                    newInd = indexes.splice(Math.floor(Math.random()*indexes.length),1)[0];
	                }
	                letterData.anIndexes[j] = newInd;
	            }
	        }
	    }
	    documentData.yOffset = documentData.finalLineHeight || documentData.finalSize*1.2;
	    documentData.ls = documentData.ls || 0;
	    documentData.ascent = fontData.ascent*documentData.finalSize/100;
	};
	
	TextProperty.prototype.updateDocumentData = function(newData, index) {
		index = index === undefined ? this.keysIndex : index;
	    var dData = this.copyData({}, this.data.d.k[index].s);
	    dData = this.copyData(dData, newData);
	    this.data.d.k[index].s = dData;
	    this.recalculate(index);
	    this.elem.addDynamicProperty(this);
	};
	
	TextProperty.prototype.recalculate = function(index) {
	    var dData = this.data.d.k[index].s;
	    dData.__complete = false;
	    this.keysIndex = 0;
	    this._isFirstFrame = true;
	    this.getValue(dData);
	}
	
	TextProperty.prototype.canResizeFont = function(_canResize) {
	    this.canResize = _canResize;
	    this.recalculate(this.keysIndex);
	    this.elem.addDynamicProperty(this);
	};
	
	TextProperty.prototype.setMinimumFontSize = function(_fontValue) {
	    this.minimumFontSize = Math.floor(_fontValue) || 1;
	    this.recalculate(this.keysIndex);
	    this.elem.addDynamicProperty(this);
	};
	
	var TextSelectorProp = (function(){
	    var max = Math.max;
	    var min = Math.min;
	    var floor = Math.floor;
	
	    function TextSelectorProp(elem,data){
	        this._currentTextLength = -1;
	        this.k = false;
	        this.data = data;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.finalS = 0;
	        this.finalE = 0;
	        this.initDynamicPropertyContainer(elem);
	        this.s = PropertyFactory.getProp(elem,data.s || {k:0},0,0,this);
	        if('e' in data){
	            this.e = PropertyFactory.getProp(elem,data.e,0,0,this);
	        }else{
	            this.e = {v:100};
	        }
	        this.o = PropertyFactory.getProp(elem,data.o || {k:0},0,0,this);
	        this.xe = PropertyFactory.getProp(elem,data.xe || {k:0},0,0,this);
	        this.ne = PropertyFactory.getProp(elem,data.ne || {k:0},0,0,this);
	        this.a = PropertyFactory.getProp(elem,data.a,0,0.01,this);
	        if(!this.dynamicProperties.length){
	            this.getValue();
	        }
	    }
	
	    TextSelectorProp.prototype = {
	        getMult: function(ind) {
	            if(this._currentTextLength !== this.elem.textProperty.currentData.l.length) {
	                this.getValue();
	            }
	            //var easer = bez.getEasingCurve(this.ne.v/100,0,1-this.xe.v/100,1);
	            var easer = BezierFactory.getBezierEasing(this.ne.v/100,0,1-this.xe.v/100,1).get;
	            var mult = 0;
	            var s = this.finalS;
	            var e = this.finalE;
	            var type = this.data.sh;
	            if(type == 2){
	                if(e === s){
	                    mult = ind >= e ? 1 : 0;
	                }else{
	                    mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	                }
	                mult = easer(mult);
	            }else if(type == 3){
	                if(e === s){
	                    mult = ind >= e ? 0 : 1;
	                }else{
	                    mult = 1 - max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	                }
	
	                mult = easer(mult);
	            }else if(type == 4){
	                if(e === s){
	                    mult = 0;
	                }else{
	                    mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	                    if(mult<0.5){
	                        mult *= 2;
	                    }else{
	                        mult = 1 - 2*(mult-0.5);
	                    }
	                }
	                mult = easer(mult);
	            }else if(type == 5){
	                if(e === s){
	                    mult = 0;
	                }else{
	                    var tot = e - s;
	                    /*ind += 0.5;
	                    mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind;*/
	                    ind = min(max(0,ind+0.5-s),e-s);
	                    var x = -tot/2+ind;
	                    var a = tot/2;
	                    mult = Math.sqrt(1 - (x*x)/(a*a));
	                }
	                mult = easer(mult);
	            }else if(type == 6){
	                if(e === s){
	                    mult = 0;
	                }else{
	                    ind = min(max(0,ind+0.5-s),e-s);
	                    mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind)/(e-s)))))/2;
	                    /*
	                     ind = Math.min(Math.max(s,ind),e-1);
	                     mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind-s)/(e-1-s)))))/2;
	                     mult = Math.max(mult,(1/(e-1-s))/(e-1-s));*/
	                }
	                mult = easer(mult);
	            }else {
	                if(ind >= floor(s)){
	                    if(ind-s < 0){
	                        mult = 1 - (s - ind);
	                    }else{
	                        mult = max(0,min(e-ind,1));
	                    }
	                }
	                mult = easer(mult);
	            }
	            return mult*this.a.v;
	        },
	        getValue: function(newCharsFlag) {
	            this.iterateDynamicProperties();
	            this._mdf = newCharsFlag || this._mdf;
	            this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
	            if(newCharsFlag && this.data.r === 2) {
	                this.e.v = this._currentTextLength;
	            }
	            var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
	            var o = this.o.v/divisor;
	            var s = this.s.v/divisor + o;
	            var e = (this.e.v/divisor) + o;
	            if(s>e){
	                var _s = s;
	                s = e;
	                e = _s;
	            }
	            this.finalS = s;
	            this.finalE = e;
	        }
	    }
	    extendPrototype([DynamicPropertyContainer], TextSelectorProp);
	
	    function getTextSelectorProp(elem, data,arr) {
	        return new TextSelectorProp(elem, data, arr);
	    }
	
	    return {
	        getTextSelectorProp: getTextSelectorProp
	    };
	}());
	
	    
	var pool_factory = (function() {
		return function(initialLength, _create, _release, _clone) {
	
			var _length = 0;
			var _maxLength = initialLength;
			var pool = createSizedArray(_maxLength);
	
			var ob = {
				newElement: newElement,
				release: release
			};
	
			function newElement(){
				var element;
				if(_length){
					_length -= 1;
					element = pool[_length];
				} else {
					element = _create();
				}
				return element;
			}
	
			function release(element) {
				if(_length === _maxLength) {
					pool = pooling.double(pool);
					_maxLength = _maxLength*2;
				}
				if (_release) {
					_release(element);
				}
				pool[_length] = element;
				_length += 1;
			}
	
			function clone() {
				var clonedElement = newElement();
				return _clone(clonedElement);
			}
	
			return ob;
		};
	}());
	
	var pooling = (function(){
	
		function double(arr){
			return arr.concat(createSizedArray(arr.length));
		}
	
		return {
			double: double
		};
	}());
	var point_pool = (function(){
	
		function create() {
			return createTypedArray('float32', 2);
		}
		return pool_factory(8, create);
	}());
	var shape_pool = (function(){
	
		function create() {
			return new ShapePath();
		}
	
		function release(shapePath) {
			var len = shapePath._length, i;
			for(i = 0; i < len; i += 1) {
				point_pool.release(shapePath.v[i]);
				point_pool.release(shapePath.i[i]);
				point_pool.release(shapePath.o[i]);
				shapePath.v[i] = null;
				shapePath.i[i] = null;
				shapePath.o[i] = null;
			}
			shapePath._length = 0;
			shapePath.c = false;
		}
	
		function clone(shape) {
			var cloned = factory.newElement();
			var i, len = shape._length === undefined ? shape.v.length : shape._length;
			cloned.setLength(len);
			cloned.c = shape.c;
			var pt;
			
			for(i = 0; i < len; i += 1) {
				cloned.setTripleAt(shape.v[i][0],shape.v[i][1],shape.o[i][0],shape.o[i][1],shape.i[i][0],shape.i[i][1], i);
			}
			return cloned;
		}
	
		var factory = pool_factory(4, create, release);
		factory.clone = clone;
	
		return factory;
	}());
	var shapeCollection_pool = (function(){
		var ob = {
			newShapeCollection: newShapeCollection,
			release: release
		};
	
		var _length = 0;
		var _maxLength = 4;
		var pool = createSizedArray(_maxLength);
	
		function newShapeCollection(){
			var shapeCollection;
			if(_length){
				_length -= 1;
				shapeCollection = pool[_length];
			} else {
				shapeCollection = new ShapeCollection();
			}
			return shapeCollection;
		}
	
		function release(shapeCollection) {
			var i, len = shapeCollection._length;
			for(i = 0; i < len; i += 1) {
				shape_pool.release(shapeCollection.shapes[i]);
			}
			shapeCollection._length = 0;
	
			if(_length === _maxLength) {
				pool = pooling.double(pool);
				_maxLength = _maxLength*2;
			}
			pool[_length] = shapeCollection;
			_length += 1;
		}
	
		return ob;
	}());
	var segments_length_pool = (function(){
	
		function create() {
			return {
				lengths: [],
				totalLength: 0
			};
		}
	
		function release(element) {
			var i, len = element.lengths.length;
			for(i=0;i<len;i+=1) {
				bezier_length_pool.release(element.lengths[i]);
			}
			element.lengths.length = 0;
		}
	
		return pool_factory(8, create, release);
	}());
	var bezier_length_pool = (function(){
	
		function create() {
			return {
	            addedLength: 0,
	            percents: createTypedArray('float32', defaultCurveSegments),
	            lengths: createTypedArray('float32', defaultCurveSegments),
	        };
		}
		return pool_factory(8, create);
	}());
	function BaseRenderer(){}
	BaseRenderer.prototype.checkLayers = function(num){
	    var i, len = this.layers.length, data;
	    this.completeLayers = true;
	    for (i = len - 1; i >= 0; i--) {
	        if (!this.elements[i]) {
	            data = this.layers[i];
	            if(data.ip - data.st <= (num - this.layers[i].st) && data.op - data.st > (num - this.layers[i].st))
	            {
	                this.buildItem(i);
	            }
	        }
	        this.completeLayers = this.elements[i] ? this.completeLayers:false;
	    }
	    this.checkPendingElements();
	};
	
	BaseRenderer.prototype.createItem = function(layer){
	    switch(layer.ty){
	        case 2:
	            return this.createImage(layer);
	        case 0:
	            return this.createComp(layer);
	        case 1:
	            return this.createSolid(layer);
	        case 3:
	            return this.createNull(layer);
	        case 4:
	            return this.createShape(layer);
	        case 5:
	            return this.createText(layer);
	        case 13:
	            return this.createCamera(layer);
	    }
	    return this.createNull(layer);
	};
	
	BaseRenderer.prototype.createCamera = function(){
	    throw new Error('You\'re using a 3d camera. Try the html renderer.');
	};
	
	BaseRenderer.prototype.buildAllItems = function(){
	    var i, len = this.layers.length;
	    for(i=0;i<len;i+=1){
	        this.buildItem(i);
	    }
	    this.checkPendingElements();
	};
	
	BaseRenderer.prototype.includeLayers = function(newLayers){
	    this.completeLayers = false;
	    var i, len = newLayers.length;
	    var j, jLen = this.layers.length;
	    for(i=0;i<len;i+=1){
	        j = 0;
	        while(j<jLen){
	            if(this.layers[j].id == newLayers[i].id){
	                this.layers[j] = newLayers[i];
	                break;
	            }
	            j += 1;
	        }
	    }
	};
	
	BaseRenderer.prototype.setProjectInterface = function(pInterface){
	    this.globalData.projectInterface = pInterface;
	};
	
	BaseRenderer.prototype.initItems = function(){
	    if(!this.globalData.progressiveLoad){
	        this.buildAllItems();
	    }
	};
	BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy) {
	    var elements = this.elements;
	    var layers = this.layers;
	    var i=0, len = layers.length;
	    while (i < len) {
	        if (layers[i].ind == parentName) {
	            if (!elements[i] || elements[i] === true) {
	                this.buildItem(i);
	                this.addPendingElement(element);
	            } else {
	                hierarchy.push(elements[i]);
	                elements[i].setAsParent();
	                if(layers[i].parent !== undefined) {
	                    this.buildElementParenting(element, layers[i].parent, hierarchy);
	                } else {
	                    element.setHierarchy(hierarchy);
	                }
	            }
	        }
	        i += 1;
	    }
	};
	
	BaseRenderer.prototype.addPendingElement = function(element){
	    this.pendingElements.push(element);
	};
	
	BaseRenderer.prototype.searchExtraCompositions = function(assets){
	    var i, len = assets.length;
	    for(i=0;i<len;i+=1){
	        if(assets[i].xt){
	            var comp = this.createComp(assets[i]);
	            comp.initExpressions();
	            this.globalData.projectInterface.registerComposition(comp);
	        }
	    }
	};
	
	BaseRenderer.prototype.setupGlobalData = function(animData, fontsContainer) {
	    this.globalData.fontManager = new FontManager();
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.imageLoader = this.animationItem.imagePreloader;
	    this.globalData.frameId = 0;
	    this.globalData.frameRate = animData.fr;
	    this.globalData.nm = animData.nm;
	    this.globalData.compSize = {
	        w: animData.w,
	        h: animData.h
	    }
	}
	function SVGRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.svgElement = createNS('svg');
	    var defs = createNS( 'defs');
	    this.svgElement.appendChild(defs);
	    var maskElement = createNS('g');
	    this.svgElement.appendChild(maskElement);
	    this.layerElement = maskElement;
	    this.renderConfig = {
	        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
	        imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
	        progressiveLoad: (config && config.progressiveLoad) || false,
	        hideOnTransparent: (config && config.hideOnTransparent === false) ? false : true,
	        viewBoxOnly: (config && config.viewBoxOnly) || false,
	        viewBoxSize: (config && config.viewBoxSize) || false,
	        className: (config && config.className) || ''
	    };
	    this.globalData = {
	        _mdf: false,
	        frameNum: -1,
	        defs: defs,
	        renderConfig: this.renderConfig
	    };
	    this.elements = [];
	    this.pendingElements = [];
	    this.destroyed = false;
	    this.rendererType = 'svg';
	
	}
	
	extendPrototype([BaseRenderer],SVGRenderer);
	
	SVGRenderer.prototype.createNull = function (data) {
	    return new NullElement(data,this.globalData,this);
	};
	
	SVGRenderer.prototype.createShape = function (data) {
	    return new SVGShapeElement(data,this.globalData,this);
	};
	
	SVGRenderer.prototype.createText = function (data) {
	    return new SVGTextElement(data,this.globalData,this);
	
	};
	
	SVGRenderer.prototype.createImage = function (data) {
	    return new IImageElement(data,this.globalData,this);
	};
	
	SVGRenderer.prototype.createComp = function (data) {
	    return new SVGCompElement(data,this.globalData,this);
	
	};
	
	SVGRenderer.prototype.createSolid = function (data) {
	    return new ISolidElement(data,this.globalData,this);
	};
	
	SVGRenderer.prototype.configAnimation = function(animData){
	    this.svgElement.setAttribute('xmlns','http://www.w3.org/2000/svg');
	    if(this.renderConfig.viewBoxSize) {
	        this.svgElement.setAttribute('viewBox',this.renderConfig.viewBoxSize);
	    } else {
	        this.svgElement.setAttribute('viewBox','0 0 '+animData.w+' '+animData.h);
	    }
	
	    if(!this.renderConfig.viewBoxOnly) {
	        this.svgElement.setAttribute('width',animData.w);
	        this.svgElement.setAttribute('height',animData.h);
	        this.svgElement.style.width = '100%';
	        this.svgElement.style.height = '100%';
	        this.svgElement.style.transform = 'translate3d(0,0,0)';
	    }
	    if(this.renderConfig.className) {
	        this.svgElement.setAttribute('class', this.renderConfig.className);
	    }
	    this.svgElement.setAttribute('preserveAspectRatio',this.renderConfig.preserveAspectRatio);
	    //this.layerElement.style.transform = 'translate3d(0,0,0)';
	    //this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
	    this.animationItem.wrapper.appendChild(this.svgElement);
	    //Mask animation
	    var defs = this.globalData.defs;
	
	    this.setupGlobalData(animData, defs);
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.data = animData;
	
	    var maskElement = createNS( 'clipPath');
	    var rect = createNS('rect');
	    rect.setAttribute('width',animData.w);
	    rect.setAttribute('height',animData.h);
	    rect.setAttribute('x',0);
	    rect.setAttribute('y',0);
	    var maskId = createElementID();
	    maskElement.setAttribute('id', maskId);
	    maskElement.appendChild(rect);
	    this.layerElement.setAttribute("clip-path", "url(" + locationHref + "#"+maskId+")");
	
	    defs.appendChild(maskElement);
	    this.layers = animData.layers;
	    this.elements = createSizedArray(animData.layers.length);
	};
	
	
	SVGRenderer.prototype.destroy = function () {
	    this.animationItem.wrapper.innerHTML = '';
	    this.layerElement = null;
	    this.globalData.defs = null;
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = 0; i < len; i++) {
	        if(this.elements[i]){
	            this.elements[i].destroy();
	        }
	    }
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	};
	
	SVGRenderer.prototype.updateContainerSize = function () {
	};
	
	SVGRenderer.prototype.buildItem  = function(pos){
	    var elements = this.elements;
	    if(elements[pos] || this.layers[pos].ty == 99){
	        return;
	    }
	    elements[pos] = true;
	    var element = this.createItem(this.layers[pos]);
	
	    elements[pos] = element;
	    if(expressionsPlugin){
	        if(this.layers[pos].ty === 0){
	            this.globalData.projectInterface.registerComposition(element);
	        }
	        element.initExpressions();
	    }
	    this.appendElementInPos(element,pos);
	    if(this.layers[pos].tt){
	        if(!this.elements[pos - 1] || this.elements[pos - 1] === true){
	            this.buildItem(pos - 1);
	            this.addPendingElement(element);
	        } else {
	            element.setMatte(elements[pos - 1].layerId);
	        }
	    }
	};
	
	SVGRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	        if(element.data.tt){
	            var i = 0, len = this.elements.length;
	            while(i<len){
	                if(this.elements[i] === element){
	                    element.setMatte(this.elements[i - 1].layerId);
	                    break;
	                }
	                i += 1;
	            }
	        }
	    }
	};
	
	SVGRenderer.prototype.renderFrame = function(num){
	    if(this.renderedFrame === num || this.destroyed){
	        return;
	    }
	    if(num === null){
	        num = this.renderedFrame;
	    }else{
	        this.renderedFrame = num;
	    }
	    // console.log('-------');
	    // console.log('FRAME ',num);
	    this.globalData.frameNum = num;
	    this.globalData.frameId += 1;
	    this.globalData.projectInterface.currentFrame = num;
	    this.globalData._mdf = false;
	    var i, len = this.layers.length;
	    if(!this.completeLayers){
	        this.checkLayers(num);
	    }
	    for (i = len - 1; i >= 0; i--) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(num - this.layers[i].st);
	        }
	    }
	    if(this.globalData._mdf) {
	        for (i = 0; i < len; i += 1) {
	            if(this.completeLayers || this.elements[i]){
	                this.elements[i].renderFrame();
	            }
	        }
	    }
	};
	
	SVGRenderer.prototype.appendElementInPos = function(element, pos){
	    var newElement = element.getBaseElement();
	    if(!newElement){
	        return;
	    }
	    var i = 0;
	    var nextElement;
	    while(i<pos){
	        if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement()){
	            nextElement = this.elements[i].getBaseElement();
	        }
	        i += 1;
	    }
	    if(nextElement){
	        this.layerElement.insertBefore(newElement, nextElement);
	    } else {
	        this.layerElement.appendChild(newElement);
	    }
	};
	
	SVGRenderer.prototype.hide = function(){
	    this.layerElement.style.display = 'none';
	};
	
	SVGRenderer.prototype.show = function(){
	    this.layerElement.style.display = 'block';
	};
	
	function CanvasRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.renderConfig = {
	        clearCanvas: (config && config.clearCanvas !== undefined) ? config.clearCanvas : true,
	        context: (config && config.context) || null,
	        progressiveLoad: (config && config.progressiveLoad) || false,
	        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
	        imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
	        className: (config && config.className) || ''
	    };
	    this.renderConfig.dpr = (config && config.dpr) || 1;
	    if (this.animationItem.wrapper) {
	        this.renderConfig.dpr = (config && config.dpr) || window.devicePixelRatio || 1;
	    }
	    this.renderedFrame = -1;
	    this.globalData = {
	        frameNum: -1,
	        _mdf: false,
	        renderConfig: this.renderConfig,
	        currentGlobalAlpha: -1
	    };
	    this.contextData = new CVContextData();
	    this.elements = [];
	    this.pendingElements = [];
	    this.transformMat = new Matrix();
	    this.completeLayers = false;
	    this.rendererType = 'canvas';
	}
	extendPrototype([BaseRenderer],CanvasRenderer);
	
	CanvasRenderer.prototype.createShape = function (data) {
	    return new CVShapeElement(data, this.globalData, this);
	};
	
	CanvasRenderer.prototype.createText = function (data) {
	    return new CVTextElement(data, this.globalData, this);
	};
	
	CanvasRenderer.prototype.createImage = function (data) {
	    return new CVImageElement(data, this.globalData, this);
	};
	
	CanvasRenderer.prototype.createComp = function (data) {
	    return new CVCompElement(data, this.globalData, this);
	};
	
	CanvasRenderer.prototype.createSolid = function (data) {
	    return new CVSolidElement(data, this.globalData, this);
	};
	
	CanvasRenderer.prototype.createNull = SVGRenderer.prototype.createNull;
	
	CanvasRenderer.prototype.ctxTransform = function(props){
	    if(props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0){
	        return;
	    }
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.transform(props[0],props[1],props[4],props[5],props[12],props[13]);
	        return;
	    }
	    this.transformMat.cloneFromProps(props);
	    var cProps = this.contextData.cTr.props;
	    this.transformMat.transform(cProps[0],cProps[1],cProps[2],cProps[3],cProps[4],cProps[5],cProps[6],cProps[7],cProps[8],cProps[9],cProps[10],cProps[11],cProps[12],cProps[13],cProps[14],cProps[15]);
	    //this.contextData.cTr.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
	    this.contextData.cTr.cloneFromProps(this.transformMat.props);
	    var trProps = this.contextData.cTr.props;
	    this.canvasContext.setTransform(trProps[0],trProps[1],trProps[4],trProps[5],trProps[12],trProps[13]);
	};
	
	CanvasRenderer.prototype.ctxOpacity = function(op){
	    /*if(op === 1){
	        return;
	    }*/
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
	        this.globalData.currentGlobalAlpha = this.contextData.cO;
	        return;
	    }
	    this.contextData.cO *= op < 0 ? 0 : op;
	    if(this.globalData.currentGlobalAlpha !== this.contextData.cO) {
	        this.canvasContext.globalAlpha = this.contextData.cO;
	        this.globalData.currentGlobalAlpha = this.contextData.cO;
	    }
	};
	
	CanvasRenderer.prototype.reset = function(){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.restore();
	        return;
	    }
	    this.contextData.reset();
	};
	
	CanvasRenderer.prototype.save = function(actionFlag){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.save();
	        return;
	    }
	    if(actionFlag){
	        this.canvasContext.save();
	    }
	    var props = this.contextData.cTr.props;
	    if(this.contextData._length <= this.contextData.cArrPos) {
	        this.contextData.duplicate();
	    }
	    var i, arr = this.contextData.saved[this.contextData.cArrPos];
	    for (i = 0; i < 16; i += 1) {
	        arr[i] = props[i];
	    }
	    this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO;
	    this.contextData.cArrPos += 1;
	};
	
	CanvasRenderer.prototype.restore = function(actionFlag){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.restore();
	        return;
	    }
	    if(actionFlag){
	        this.canvasContext.restore();
	        this.globalData.blendMode = 'source-over';
	    }
	    this.contextData.cArrPos -= 1;
	    var popped = this.contextData.saved[this.contextData.cArrPos];
	    var i,arr = this.contextData.cTr.props;
	    for(i=0;i<16;i+=1){
	        arr[i] = popped[i];
	    }
	    this.canvasContext.setTransform(popped[0],popped[1],popped[4],popped[5],popped[12],popped[13]);
	    popped = this.contextData.savedOp[this.contextData.cArrPos];
	    this.contextData.cO = popped;
	    if(this.globalData.currentGlobalAlpha !== popped) {
	        this.canvasContext.globalAlpha = popped;
	        this.globalData.currentGlobalAlpha = popped;
	    }
	};
	
	CanvasRenderer.prototype.configAnimation = function(animData){
	    if(this.animationItem.wrapper){
	        this.animationItem.container = createTag('canvas');
	        this.animationItem.container.style.width = '100%';
	        this.animationItem.container.style.height = '100%';
	        //this.animationItem.container.style.transform = 'translate3d(0,0,0)';
	        //this.animationItem.container.style.webkitTransform = 'translate3d(0,0,0)';
	        this.animationItem.container.style.transformOrigin = this.animationItem.container.style.mozTransformOrigin = this.animationItem.container.style.webkitTransformOrigin = this.animationItem.container.style['-webkit-transform'] = "0px 0px 0px";
	        this.animationItem.wrapper.appendChild(this.animationItem.container);
	        this.canvasContext = this.animationItem.container.getContext('2d');
	        if(this.renderConfig.className) {
	            this.animationItem.container.setAttribute('class', this.renderConfig.className);
	        }
	    }else{
	        this.canvasContext = this.renderConfig.context;
	    }
	    this.data = animData;
	    this.layers = animData.layers;
	    this.transformCanvas = {
	        w: animData.w,
	        h:animData.h,
	        sx:0,
	        sy:0,
	        tx:0,
	        ty:0
	    };
	    this.setupGlobalData(animData, document.body);
	    this.globalData.canvasContext = this.canvasContext;
	    this.globalData.renderer = this;
	    this.globalData.isDashed = false;
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.globalData.transformCanvas = this.transformCanvas;
	    this.elements = createSizedArray(animData.layers.length);
	
	    this.updateContainerSize();
	};
	
	CanvasRenderer.prototype.updateContainerSize = function () {
	    this.reset();
	    var elementWidth,elementHeight;
	    if(this.animationItem.wrapper && this.animationItem.container){
	        elementWidth = this.animationItem.wrapper.offsetWidth;
	        elementHeight = this.animationItem.wrapper.offsetHeight;
	        this.animationItem.container.setAttribute('width',elementWidth * this.renderConfig.dpr );
	        this.animationItem.container.setAttribute('height',elementHeight * this.renderConfig.dpr);
	    }else{
	        elementWidth = this.canvasContext.canvas.width * this.renderConfig.dpr;
	        elementHeight = this.canvasContext.canvas.height * this.renderConfig.dpr;
	    }
	    var elementRel,animationRel;
	    if(this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1){
	        var par = this.renderConfig.preserveAspectRatio.split(' ');
	        var fillType = par[1] || 'meet';
	        var pos = par[0] || 'xMidYMid';
	        var xPos = pos.substr(0,4);
	        var yPos = pos.substr(4);
	        elementRel = elementWidth/elementHeight;
	        animationRel = this.transformCanvas.w/this.transformCanvas.h;
	        if(animationRel>elementRel && fillType === 'meet' || animationRel<elementRel && fillType === 'slice'){
	            this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	            this.transformCanvas.sy = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	        }else{
	            this.transformCanvas.sx = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
	            this.transformCanvas.sy = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
	        }
	
	        if(xPos === 'xMid' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
	            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))/2*this.renderConfig.dpr;
	        } else if(xPos === 'xMax' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
	            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))*this.renderConfig.dpr;
	        } else {
	            this.transformCanvas.tx = 0;
	        }
	        if(yPos === 'YMid' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
	            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w))/2)*this.renderConfig.dpr;
	        } else if(yPos === 'YMax' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
	            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w)))*this.renderConfig.dpr;
	        } else {
	            this.transformCanvas.ty = 0;
	        }
	
	    }else if(this.renderConfig.preserveAspectRatio == 'none'){
	        this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	        this.transformCanvas.sy = elementHeight/(this.transformCanvas.h/this.renderConfig.dpr);
	        this.transformCanvas.tx = 0;
	        this.transformCanvas.ty = 0;
	    }else{
	        this.transformCanvas.sx = this.renderConfig.dpr;
	        this.transformCanvas.sy = this.renderConfig.dpr;
	        this.transformCanvas.tx = 0;
	        this.transformCanvas.ty = 0;
	    }
	    this.transformCanvas.props = [this.transformCanvas.sx,0,0,0,0,this.transformCanvas.sy,0,0,0,0,1,0,this.transformCanvas.tx,this.transformCanvas.ty,0,1];
	    /*var i, len = this.elements.length;
	    for(i=0;i<len;i+=1){
	        if(this.elements[i] && this.elements[i].data.ty === 0){
	            this.elements[i].resize(this.globalData.transformCanvas);
	        }
	    }*/
	    this.ctxTransform(this.transformCanvas.props);
	    this.canvasContext.beginPath();
	    this.canvasContext.rect(0,0,this.transformCanvas.w,this.transformCanvas.h);
	    this.canvasContext.closePath();
	    this.canvasContext.clip();
	};
	
	CanvasRenderer.prototype.destroy = function () {
	    if(this.renderConfig.clearCanvas) {
	        this.animationItem.wrapper.innerHTML = '';
	    }
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = len - 1; i >= 0; i-=1) {
	        if(this.elements[i]) {
	            this.elements[i].destroy();
	        }
	    }
	    this.elements.length = 0;
	    this.globalData.canvasContext = null;
	    this.animationItem.container = null;
	    this.destroyed = true;
	};
	
	CanvasRenderer.prototype.renderFrame = function(num){
	    if((this.renderedFrame == num && this.renderConfig.clearCanvas === true) || this.destroyed || num === -1){
	        return;
	    }
	    this.renderedFrame = num;
	    this.globalData.frameNum = num - this.animationItem._isFirstFrame;
	    this.globalData.frameId += 1;
	    this.globalData._mdf = !this.renderConfig.clearCanvas;
	    this.globalData.projectInterface.currentFrame = num;
	
	     // console.log('--------');
	     // console.log('NEW: ',num);
	    var i, len = this.layers.length;
	    if(!this.completeLayers){
	        this.checkLayers(num);
	    }
	
	    for (i = 0; i < len; i++) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(num - this.layers[i].st);
	        }
	    }
	    if(this.globalData._mdf) {
	        if(this.renderConfig.clearCanvas === true){
	            this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
	        }else{
	            this.save();
	        }
	        for (i = len - 1; i >= 0; i-=1) {
	            if(this.completeLayers || this.elements[i]){
	                this.elements[i].renderFrame();
	            }
	        }
	        if(this.renderConfig.clearCanvas !== true){
	            this.restore();
	        }
	    }
	};
	
	CanvasRenderer.prototype.buildItem = function(pos){
	    var elements = this.elements;
	    if(elements[pos] || this.layers[pos].ty == 99){
	        return;
	    }
	    var element = this.createItem(this.layers[pos], this,this.globalData);
	    elements[pos] = element;
	    element.initExpressions();
	    /*if(this.layers[pos].ty === 0){
	        element.resize(this.globalData.transformCanvas);
	    }*/
	};
	
	CanvasRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	    }
	};
	
	CanvasRenderer.prototype.hide = function(){
	    this.animationItem.container.style.display = 'none';
	};
	
	CanvasRenderer.prototype.show = function(){
	    this.animationItem.container.style.display = 'block';
	};
	
	function HybridRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.renderConfig = {
	        className: (config && config.className) || '',
	        imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
	        hideOnTransparent: (config && config.hideOnTransparent === false) ? false : true
	    };
	    this.globalData = {
	        _mdf: false,
	        frameNum: -1,
	        renderConfig: this.renderConfig
	    };
	    this.pendingElements = [];
	    this.elements = [];
	    this.threeDElements = [];
	    this.destroyed = false;
	    this.camera = null;
	    this.supports3d = true;
	    this.rendererType = 'html';
	
	}
	
	extendPrototype([BaseRenderer],HybridRenderer);
	
	HybridRenderer.prototype.buildItem = SVGRenderer.prototype.buildItem;
	
	HybridRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	    }
	};
	
	HybridRenderer.prototype.appendElementInPos = function(element, pos){
	    var newDOMElement = element.getBaseElement();
	    if(!newDOMElement){
	        return;
	    }
	    var layer = this.layers[pos];
	    if(!layer.ddd || !this.supports3d){
	        if(this.threeDElements) {
	            this.addTo3dContainer(newDOMElement,pos);
	        } else {
	            var i = 0;
	            var nextDOMElement, nextLayer, tmpDOMElement;
	            while(i<pos){
	                if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement){
	                    nextLayer = this.elements[i];
	                    tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
	                    nextDOMElement = tmpDOMElement || nextDOMElement;
	                }
	                i += 1;
	            }
	            if(nextDOMElement){
	                if(!layer.ddd || !this.supports3d){
	                    this.layerElement.insertBefore(newDOMElement, nextDOMElement);
	                }
	            } else {
	                if(!layer.ddd || !this.supports3d){
	                    this.layerElement.appendChild(newDOMElement);
	                }
	            }
	        }
	        
	    } else {
	        this.addTo3dContainer(newDOMElement,pos);
	    }
	};
	
	HybridRenderer.prototype.createShape = function (data) {
	    if(!this.supports3d){
	        return new SVGShapeElement(data, this.globalData, this);
	    }
	    return new HShapeElement(data, this.globalData, this);
	};
	
	HybridRenderer.prototype.createText = function (data) {
	    if(!this.supports3d){
	        return new SVGTextElement(data, this.globalData, this);
	    }
	    return new HTextElement(data, this.globalData, this);
	};
	
	HybridRenderer.prototype.createCamera = function (data) {
	    this.camera = new HCameraElement(data, this.globalData, this);
	    return this.camera;
	};
	
	HybridRenderer.prototype.createImage = function (data) {
	    if(!this.supports3d){
	        return new IImageElement(data, this.globalData, this);
	    }
	    return new HImageElement(data, this.globalData, this);
	};
	
	HybridRenderer.prototype.createComp = function (data) {
	    if(!this.supports3d){
	        return new SVGCompElement(data, this.globalData, this);
	    }
	    return new HCompElement(data, this.globalData, this);
	
	};
	
	HybridRenderer.prototype.createSolid = function (data) {
	    if(!this.supports3d){
	        return new ISolidElement(data, this.globalData, this);
	    }
	    return new HSolidElement(data, this.globalData, this);
	};
	
	HybridRenderer.prototype.createNull = SVGRenderer.prototype.createNull;
	
	HybridRenderer.prototype.getThreeDContainerByPos = function(pos){
	    var i = 0, len = this.threeDElements.length;
	    while(i<len) {
	        if(this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
	            return this.threeDElements[i].perspectiveElem;
	        }
	        i += 1;
	    }
	};
	
	HybridRenderer.prototype.createThreeDContainer = function(pos, type){
	    var perspectiveElem = createTag('div');
	    styleDiv(perspectiveElem);
	    var container = createTag('div');
	    styleDiv(container);
	    if(type === '3d') {
	        perspectiveElem.style.width = this.globalData.compSize.w+'px';
	        perspectiveElem.style.height = this.globalData.compSize.h+'px';
	        perspectiveElem.style.transformOrigin = perspectiveElem.style.mozTransformOrigin = perspectiveElem.style.webkitTransformOrigin = "50% 50%";
	        container.style.transform = container.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	    }
	    
	    perspectiveElem.appendChild(container);
	    //this.resizerElem.appendChild(perspectiveElem);
	    var threeDContainerData = {
	        container:container,
	        perspectiveElem:perspectiveElem,
	        startPos: pos,
	        endPos: pos,
	        type: type
	    };
	    this.threeDElements.push(threeDContainerData);
	    return threeDContainerData;
	};
	
	HybridRenderer.prototype.build3dContainers = function(){
	    var i, len = this.layers.length;
	    var lastThreeDContainerData;
	    var currentContainer = '';
	    for(i=0;i<len;i+=1){
	        if(this.layers[i].ddd && this.layers[i].ty !== 3){
	            if(currentContainer !== '3d'){
	                currentContainer = '3d';
	                lastThreeDContainerData = this.createThreeDContainer(i,'3d');
	            }
	            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos,i);
	        } else {
	            if(currentContainer !== '2d'){
	                currentContainer = '2d';
	                lastThreeDContainerData = this.createThreeDContainer(i,'2d');
	            }
	            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos,i);
	        }
	    }
	    len = this.threeDElements.length;
	    for(i = len - 1; i >= 0; i --) {
	        this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
	    }
	};
	
	HybridRenderer.prototype.addTo3dContainer = function(elem,pos){
	    var i = 0, len = this.threeDElements.length;
	    while(i<len){
	        if(pos <= this.threeDElements[i].endPos){
	            var j = this.threeDElements[i].startPos;
	            var nextElement;
	            while(j<pos){
	                if(this.elements[j] && this.elements[j].getBaseElement){
	                    nextElement = this.elements[j].getBaseElement();
	                }
	                j += 1;
	            }
	            if(nextElement){
	                this.threeDElements[i].container.insertBefore(elem, nextElement);
	            } else {
	                this.threeDElements[i].container.appendChild(elem);
	            }
	            break;
	        }
	        i += 1;
	    }
	};
	
	HybridRenderer.prototype.configAnimation = function(animData){
	    var resizerElem = createTag('div');
	    var wrapper = this.animationItem.wrapper;
	    resizerElem.style.width = animData.w+'px';
	    resizerElem.style.height = animData.h+'px';
	    this.resizerElem = resizerElem;
	    styleDiv(resizerElem);
	    resizerElem.style.transformStyle = resizerElem.style.webkitTransformStyle = resizerElem.style.mozTransformStyle = "flat";
	    if(this.renderConfig.className) {
	      resizerElem.setAttribute('class', this.renderConfig.className);
	    }
	    wrapper.appendChild(resizerElem);
	
	    resizerElem.style.overflow = 'hidden';
	    var svg = createNS('svg');
	    svg.setAttribute('width','1');
	    svg.setAttribute('height','1');
	    styleDiv(svg);
	    this.resizerElem.appendChild(svg);
	    var defs = createNS('defs');
	    svg.appendChild(defs);
	    this.data = animData;
	    //Mask animation
	    this.setupGlobalData(animData, svg);
	    this.globalData.defs = defs;
	    this.layers = animData.layers;
	    this.layerElement = this.resizerElem;
	    this.build3dContainers();
	    this.updateContainerSize();
	};
	
	HybridRenderer.prototype.destroy = function () {
	    this.animationItem.wrapper.innerHTML = '';
	    this.animationItem.container = null;
	    this.globalData.defs = null;
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = 0; i < len; i++) {
	        this.elements[i].destroy();
	    }
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	};
	
	HybridRenderer.prototype.updateContainerSize = function () {
	    var elementWidth = this.animationItem.wrapper.offsetWidth;
	    var elementHeight = this.animationItem.wrapper.offsetHeight;
	    var elementRel = elementWidth/elementHeight;
	    var animationRel = this.globalData.compSize.w/this.globalData.compSize.h;
	    var sx,sy,tx,ty;
	    if(animationRel>elementRel){
	        sx = elementWidth/(this.globalData.compSize.w);
	        sy = elementWidth/(this.globalData.compSize.w);
	        tx = 0;
	        ty = ((elementHeight-this.globalData.compSize.h*(elementWidth/this.globalData.compSize.w))/2);
	    }else{
	        sx = elementHeight/(this.globalData.compSize.h);
	        sy = elementHeight/(this.globalData.compSize.h);
	        tx = (elementWidth-this.globalData.compSize.w*(elementHeight/this.globalData.compSize.h))/2;
	        ty = 0;
	    }
	    this.resizerElem.style.transform = this.resizerElem.style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,'+sy+',0,0,0,0,1,0,'+tx+','+ty+',0,1)';
	};
	
	HybridRenderer.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
	
	HybridRenderer.prototype.hide = function(){
	    this.resizerElem.style.display = 'none';
	};
	
	HybridRenderer.prototype.show = function(){
	    this.resizerElem.style.display = 'block';
	};
	
	HybridRenderer.prototype.initItems = function(){
	    this.buildAllItems();
	    if(this.camera){
	        this.camera.setup();
	    } else {
	        var cWidth = this.globalData.compSize.w;
	        var cHeight = this.globalData.compSize.h;
	        var i, len = this.threeDElements.length;
	        for(i=0;i<len;i+=1){
	            this.threeDElements[i].perspectiveElem.style.perspective = this.threeDElements[i].perspectiveElem.style.webkitPerspective = Math.sqrt(Math.pow(cWidth,2) + Math.pow(cHeight,2)) + 'px';
	        }
	    }
	};
	
	HybridRenderer.prototype.searchExtraCompositions = function(assets){
	    var i, len = assets.length;
	    var floatingContainer = createTag('div');
	    for(i=0;i<len;i+=1){
	        if(assets[i].xt){
	            var comp = this.createComp(assets[i],floatingContainer,this.globalData.comp,null);
	            comp.initExpressions();
	            this.globalData.projectInterface.registerComposition(comp);
	        }
	    }
	};
	
	function MaskElement(data,element,globalData) {
	    this.data = data;
	    this.element = element;
	    this.globalData = globalData;
	    this.storedData = [];
	    this.masksProperties = this.data.masksProperties || [];
	    this.maskElement = null;
	    var defs = this.globalData.defs;
	    var i, len = this.masksProperties ? this.masksProperties.length : 0;
	    this.viewData = createSizedArray(len);
	    this.solidPath = '';
	
	
	    var path, properties = this.masksProperties;
	    var count = 0;
	    var currentMasks = [];
	    var j, jLen;
	    var layerId = createElementID();
	    var rect, expansor, feMorph,x;
	    var maskType = 'clipPath', maskRef = 'clip-path';
	    for (i = 0; i < len; i++) {
	
	        if((properties[i].mode !== 'a' && properties[i].mode !== 'n')|| properties[i].inv || properties[i].o.k !== 100){
	            maskType = 'mask';
	            maskRef = 'mask';
	        }
	
	        if((properties[i].mode == 's' || properties[i].mode == 'i') && count === 0){
	            rect = createNS( 'rect');
	            rect.setAttribute('fill', '#ffffff');
	            rect.setAttribute('width', this.element.comp.data.w || 0);
	            rect.setAttribute('height', this.element.comp.data.h || 0);
	            currentMasks.push(rect);
	        } else {
	            rect = null;
	        }
	
	        path = createNS( 'path');
	        if(properties[i].mode == 'n') {
	            // TODO move this to a factory or to a constructor
	            this.viewData[i] = {
	                op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.element),
	                prop: ShapePropertyFactory.getShapeProp(this.element,properties[i],3),
	                elem: path,
	                lastPath: ''
	            };
	            defs.appendChild(path);
	            continue;
	        }
	        count += 1;
	
	        path.setAttribute('fill', properties[i].mode === 's' ? '#000000':'#ffffff');
	        path.setAttribute('clip-rule','nonzero');
	        var filterID;
	
	        if (properties[i].x.k !== 0) {
	            maskType = 'mask';
	            maskRef = 'mask';
	            x = PropertyFactory.getProp(this.element,properties[i].x,0,null,this.element);
	            filterID = createElementID();
	            expansor = createNS('filter');
	            expansor.setAttribute('id',filterID);
	            feMorph = createNS('feMorphology');
	            feMorph.setAttribute('operator','dilate');
	            feMorph.setAttribute('in','SourceGraphic');
	            feMorph.setAttribute('radius','0');
	            expansor.appendChild(feMorph);
	            defs.appendChild(expansor);
	            path.setAttribute('stroke', properties[i].mode === 's' ? '#000000':'#ffffff');
	        } else {
	            feMorph = null;
	            x = null;
	        }
	
	        // TODO move this to a factory or to a constructor
	        this.storedData[i] = {
	             elem: path,
	             x: x,
	             expan: feMorph,
	            lastPath: '',
	            lastOperator:'',
	            filterId:filterID,
	            lastRadius:0
	        };
	        if(properties[i].mode == 'i'){
	            jLen = currentMasks.length;
	            var g = createNS('g');
	            for(j=0;j<jLen;j+=1){
	                g.appendChild(currentMasks[j]);
	            }
	            var mask = createNS('mask');
	            mask.setAttribute('mask-type','alpha');
	            mask.setAttribute('id',layerId+'_'+count);
	            mask.appendChild(path);
	            defs.appendChild(mask);
	            g.setAttribute('mask','url(' + locationHref + '#'+layerId+'_'+count+')');
	
	            currentMasks.length = 0;
	            currentMasks.push(g);
	        }else{
	            currentMasks.push(path);
	        }
	        if(properties[i].inv && !this.solidPath){
	            this.solidPath = this.createLayerSolidPath();
	        }
	        // TODO move this to a factory or to a constructor
	        this.viewData[i] = {
	            elem: path,
	            lastPath: '',
	            op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.element),
	            prop:ShapePropertyFactory.getShapeProp(this.element,properties[i],3),
	            invRect: rect
	        };
	        if(!this.viewData[i].prop.k){
	            this.drawPath(properties[i],this.viewData[i].prop.v,this.viewData[i]);
	        }
	    }
	
	    this.maskElement = createNS( maskType);
	
	    len = currentMasks.length;
	    for(i=0;i<len;i+=1){
	        this.maskElement.appendChild(currentMasks[i]);
	    }
	
	    if(count > 0){
	        this.maskElement.setAttribute('id', layerId);
	        this.element.maskedElement.setAttribute(maskRef, "url(" + locationHref + "#" + layerId + ")");
	        defs.appendChild(this.maskElement);
	    }
	    if (this.viewData.length) {
	        this.element.addRenderableComponent(this);
	    }
	
	}
	
	MaskElement.prototype.getMaskProperty = function(pos){
	    return this.viewData[pos].prop;
	};
	
	MaskElement.prototype.renderFrame = function (isFirstFrame) {
	    var finalMat = this.element.finalTransform.mat;
	    var i, len = this.masksProperties.length;
	    for (i = 0; i < len; i++) {
	        if(this.viewData[i].prop._mdf || isFirstFrame){
	            this.drawPath(this.masksProperties[i],this.viewData[i].prop.v,this.viewData[i]);
	        }
	        if(this.viewData[i].op._mdf || isFirstFrame){
	            this.viewData[i].elem.setAttribute('fill-opacity',this.viewData[i].op.v);
	        }
	        if(this.masksProperties[i].mode !== 'n'){
	            if(this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)){
	                this.viewData[i].invRect.setAttribute('x', -finalMat.props[12]);
	                this.viewData[i].invRect.setAttribute('y', -finalMat.props[13]);
	            }
	            if(this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)){
	                var feMorph = this.storedData[i].expan;
	                if(this.storedData[i].x.v < 0){
	                    if(this.storedData[i].lastOperator !== 'erode'){
	                        this.storedData[i].lastOperator = 'erode';
	                        this.storedData[i].elem.setAttribute('filter','url(' + locationHref + '#'+this.storedData[i].filterId+')');
	                    }
	                    feMorph.setAttribute('radius',-this.storedData[i].x.v);
	                }else{
	                    if(this.storedData[i].lastOperator !== 'dilate'){
	                        this.storedData[i].lastOperator = 'dilate';
	                        this.storedData[i].elem.setAttribute('filter',null);
	                    }
	                    this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v*2);
	
	                }
	            }
	        }
	    }
	};
	
	MaskElement.prototype.getMaskelement = function () {
	    return this.maskElement;
	};
	
	MaskElement.prototype.createLayerSolidPath = function(){
	    var path = 'M0,0 ';
	    path += ' h' + this.globalData.compSize.w ;
	    path += ' v' + this.globalData.compSize.h ;
	    path += ' h-' + this.globalData.compSize.w ;
	    path += ' v-' + this.globalData.compSize.h + ' ';
	    return path;
	};
	
	MaskElement.prototype.drawPath = function(pathData,pathNodes,viewData){
	    var pathString = " M"+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    var i, len;
	    len = pathNodes._length;
	    for(i=1;i<len;i+=1){
	        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
	        pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
	    }
	        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    if(pathNodes.c && len > 1){
	        pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    }
	    //pathNodes.__renderedString = pathString;
	
	    if(viewData.lastPath !== pathString){
	        var pathShapeValue = '';
	        if(viewData.elem){
	            if(pathNodes.c){
	                pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
	            }
	            viewData.elem.setAttribute('d',pathShapeValue);
	        }
	        viewData.lastPath = pathString;
	    }
	};
	
	MaskElement.prototype.destroy = function(){
	    this.element = null;
	    this.globalData = null;
	    this.maskElement = null;
	    this.data = null;
	    this.masksProperties = null;
	};
	
	/**
	 * @file 
	 * Handles AE's layer parenting property.
	 *
	 */
	
	function HierarchyElement(){}
	
	HierarchyElement.prototype = {
		/**
	     * @function 
	     * Initializes hierarchy properties
	     *
	     */
		initHierarchy: function() {
			//element's parent list
		    this.hierarchy = [];
		    //if element is parent of another layer _isParent will be true
		    this._isParent = false;
		    this.checkParenting();
		},
		/**
	     * @function 
	     * Sets layer's hierarchy.
	     * @param {array} hierarch
	     * layer's parent list
	     *
	     */ 
		setHierarchy: function(hierarchy){
		    this.hierarchy = hierarchy;
		},
		/**
	     * @function 
	     * Sets layer as parent.
	     *
	     */ 
		setAsParent: function() {
		    this._isParent = true;
		},
		/**
	     * @function 
	     * Searches layer's parenting chain
	     *
	     */ 
		checkParenting: function(){
		    if (this.data.parent !== undefined){
		        this.comp.buildElementParenting(this, this.data.parent, []);
		    }
		}
	};
	/**
	 * @file 
	 * Handles element's layer frame update.
	 * Checks layer in point and out point
	 *
	 */
	
	function FrameElement(){}
	
	FrameElement.prototype = {
	    /**
	     * @function 
	     * Initializes frame related properties.
	     *
	     */
	    initFrame: function(){
	        //set to true when inpoint is rendered
	        this._isFirstFrame = false;
	        //list of animated properties
	        this.dynamicProperties = [];
	        // If layer has been modified in current tick this will be true
	        this._mdf = false;
	    },
	    /**
	     * @function 
	     * Calculates all dynamic values
	     *
	     * @param {number} num
	     * current frame number in Layer's time
	     * @param {boolean} isVisible
	     * if layers is currently in range
	     * 
	     */
	    prepareProperties: function(num, isVisible) {
	        var i, len = this.dynamicProperties.length;
	        for (i = 0;i < len; i += 1) {
	            if (isVisible || (this._isParent && this.dynamicProperties[i].propType === 'transform')) {
	                this.dynamicProperties[i].getValue();
	                if (this.dynamicProperties[i]._mdf) {
	                    this.globalData._mdf = true;
	                    this._mdf = true;
	                }
	            }
	        }
	    },
	    addDynamicProperty: function(prop) {
	        if(this.dynamicProperties.indexOf(prop) === -1) {
	            this.dynamicProperties.push(prop);
	        }
	    }
	};
	function TransformElement(){}
	
	TransformElement.prototype = {
	    initTransform: function() {
	        this.finalTransform = {
	            mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {o:0},
	            _matMdf: false,
	            _opMdf: false,
	            mat: new Matrix()
	        };
	        if (this.data.ao) {
	            this.finalTransform.mProp.autoOriented = true;
	        }
	
	        //TODO: check TYPE 11: Guided elements
	        if (this.data.ty !== 11) {
	            //this.createElements();
	        }
	    },
	    renderTransform: function() {
	
	        this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
	        this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
	
	        if (this.hierarchy) {
	            var mat;
	            var finalMat = this.finalTransform.mat;
	            var i = 0, len = this.hierarchy.length;
	            //Checking if any of the transformation matrices in the hierarchy chain has changed.
	            if (!this.finalTransform._matMdf) {
	                while (i < len) {
	                    if (this.hierarchy[i].finalTransform.mProp._mdf) {
	                        this.finalTransform._matMdf = true;
	                        break;
	                    }
	                    i += 1;
	                }
	            }
	            
	            if (this.finalTransform._matMdf) {
	                mat = this.finalTransform.mProp.v.props;
	                finalMat.cloneFromProps(mat);
	                for (i = 0; i < len; i += 1) {
	                    mat = this.hierarchy[i].finalTransform.mProp.v.props;
	                    finalMat.transform(mat[0], mat[1], mat[2], mat[3], mat[4], mat[5], mat[6], mat[7], mat[8], mat[9], mat[10], mat[11], mat[12], mat[13], mat[14], mat[15]);
	                }
	            }
	        }
	    },
	    globalToLocal: function(pt) {
	        var transforms = [];
	        transforms.push(this.finalTransform);
	        var flag = true;
	        var comp = this.comp;
	        while (flag) {
	            if (comp.finalTransform) {
	                if (comp.data.hasMask) {
	                    transforms.splice(0, 0, comp.finalTransform);
	                }
	                comp = comp.comp;
	            } else {
	                flag = false;
	            }
	        }
	        var i, len = transforms.length,ptNew;
	        for (i = 0; i < len; i += 1) {
	            ptNew = transforms[i].mat.applyToPointArray(0, 0, 0);
	            //ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
	            pt = [pt[0] - ptNew[0], pt[1] - ptNew[1], 0];
	        }
	        return pt;
	    },
	    mHelper: new Matrix()
	};
	function RenderableElement(){
	
	}
	
	RenderableElement.prototype = {
	    initRenderable: function() {
	        //layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
	        this.isInRange = false;
	        //layer's display state
	        this.hidden = false;
	        // If layer's transparency equals 0, it can be hidden
	        this.isTransparent = false;
	        //list of animated components
	        this.renderableComponents = [];
	    },
	    addRenderableComponent: function(component) {
	        if(this.renderableComponents.indexOf(component) === -1) {
	            this.renderableComponents.push(component);
	        }
	    },
	    removeRenderableComponent: function(component) {
	        if(this.renderableComponents.indexOf(component) !== -1) {
	            this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
	        }
	    },
	    prepareRenderableFrame: function(num) {
	        this.checkLayerLimits(num);
	    },
	    checkTransparency: function(){
	        if(this.finalTransform.mProp.o.v <= 0) {
	            if(!this.isTransparent && this.globalData.renderConfig.hideOnTransparent){
	                this.isTransparent = true;
	                this.hide();
	            }
	        } else if(this.isTransparent) {
	            this.isTransparent = false;
	            this.show();
	        }
	    },
	    /**
	     * @function 
	     * Initializes frame related properties.
	     *
	     * @param {number} num
	     * current frame number in Layer's time
	     * 
	     */
	    checkLayerLimits: function(num) {
	        if(this.data.ip - this.data.st <= num && this.data.op - this.data.st > num)
	        {
	            if(this.isInRange !== true){
	                this.globalData._mdf = true;
	                this._mdf = true;
	                this.isInRange = true;
	                this.show();
	            }
	        } else {
	            if(this.isInRange !== false){
	                this.globalData._mdf = true;
	                this.isInRange = false;
	                this.hide();
	            }
	        }
	    },
	    renderRenderable: function() {
	        var i, len = this.renderableComponents.length;
	        for(i = 0; i < len; i += 1) {
	            this.renderableComponents[i].renderFrame(this._isFirstFrame);
	        }
	        /*this.maskManager.renderFrame(this.finalTransform.mat);
	        this.renderableEffectsManager.renderFrame(this._isFirstFrame);*/
	    },
	    sourceRectAtTime: function(){
	        return {
	            top:0,
	            left:0,
	            width:100,
	            height:100
	        };
	    },
	    getLayerSize: function(){
	        if(this.data.ty === 5){
	            return {w:this.data.textData.width,h:this.data.textData.height};
	        }else{
	            return {w:this.data.width,h:this.data.height};
	        }
	    }
	};
	function RenderableDOMElement() {}
	
	(function(){
	    var _prototype = {
	        initElement: function(data,globalData,comp) {
	            this.initFrame();
	            this.initBaseData(data, globalData, comp);
	            this.initTransform(data, globalData, comp);
	            this.initHierarchy();
	            this.initRenderable();
	            this.initRendererElement();
	            this.createContainerElements();
	            this.createRenderableComponents();
	            this.createContent();
	            this.hide();
	        },
	        hide: function(){
	            if (!this.hidden && (!this.isInRange || this.isTransparent)) {
	                var elem = this.baseElement || this.layerElement;
	                elem.style.display = 'none';
	                this.hidden = true;
	            }
	        },
	        show: function(){
	            if (this.isInRange && !this.isTransparent){
	                if (!this.data.hd) {
	                    var elem = this.baseElement || this.layerElement;
	                    elem.style.display = 'block';
	                }
	                this.hidden = false;
	                this._isFirstFrame = true;
	            }
	        },
	        renderFrame: function() {
	            //If it is exported as hidden (data.hd === true) no need to render
	            //If it is not visible no need to render
	            if (this.data.hd || this.hidden) {
	                return;
	            }
	            this.renderTransform();
	            this.renderRenderable();
	            this.renderElement();
	            this.renderInnerContent();
	            if (this._isFirstFrame) {
	                this._isFirstFrame = false;
	            }
	        },
	        renderInnerContent: function() {},
	        prepareFrame: function(num) {
	            this._mdf = false;
	            this.prepareRenderableFrame(num);
	            this.prepareProperties(num, this.isInRange);
	            this.checkTransparency();
	        },
	        destroy: function(){
	            this.innerElem =  null;
	            this.destroyBaseElement();
	        }
	    };
	    extendPrototype([RenderableElement, createProxyFunction(_prototype)], RenderableDOMElement);
	}());
	function ProcessedElement(element, position) {
		this.elem = element;
		this.pos = position;
	}
	function SVGStyleData(data, level) {
		this.data = data;
		this.type = data.ty;
		this.d = '';
		this.lvl = level;
		this._mdf = false;
		this.closed = data.hd === true;
		this.pElem = createNS('path');
		this.msElem = null;
	}
	
	SVGStyleData.prototype.reset = function() {
		this.d = '';
		this._mdf = false;
	};
	function SVGShapeData(transformers, level, shape) {
	    this.caches = [];
	    this.styles = [];
	    this.transformers = transformers;
	    this.lStr = '';
	    this.sh = shape;
	    this.lvl = level;
	    //TODO find if there are some cases where _isAnimated can be false. 
	    // For now, since shapes add up with other shapes. They have to be calculated every time.
	    // One way of finding out is checking if all styles associated to this shape depend only of this shape
	    this._isAnimated = !!shape.k;
	    // TODO: commenting this for now since all shapes are animated
	    var i = 0, len = transformers.length;
	    while(i < len) {
	    	if(transformers[i].mProps.dynamicProperties.length) {
	    		this._isAnimated = true;
	    		break;
	    	}
	    	i += 1;
	    }
	}
	
	SVGShapeData.prototype.setAsAnimated = function() {
	    this._isAnimated = true;
	}
	function SVGTransformData(mProps, op, container) {
		this.transform = {
			mProps: mProps,
			op: op,
			container: container
		};
		this.elements = [];
	    this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
	}
	function SVGStrokeStyleData(elem, data, styleOb){
		this.initDynamicPropertyContainer(elem);
		this.getValue = this.iterateDynamicProperties;
		this.o = PropertyFactory.getProp(elem,data.o,0,0.01,this);
		this.w = PropertyFactory.getProp(elem,data.w,0,null,this);
		this.d = new DashProperty(elem,data.d||{},'svg',this);
		this.c = PropertyFactory.getProp(elem,data.c,1,255,this);
		this.style = styleOb;
	    this._isAnimated = !!this._isAnimated;
	}
	
	extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
	function SVGFillStyleData(elem, data, styleOb){
		this.initDynamicPropertyContainer(elem);
		this.getValue = this.iterateDynamicProperties;
		this.o = PropertyFactory.getProp(elem,data.o,0,0.01,this);
		this.c = PropertyFactory.getProp(elem,data.c,1,255,this);
		this.style = styleOb;
	}
	
	extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
	function SVGGradientFillStyleData(elem, data, styleOb){
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.initGradientData(elem, data, styleOb);
	}
	
	SVGGradientFillStyleData.prototype.initGradientData = function(elem, data, styleOb){
	    this.o = PropertyFactory.getProp(elem,data.o,0,0.01,this);
	    this.s = PropertyFactory.getProp(elem,data.s,1,null,this);
	    this.e = PropertyFactory.getProp(elem,data.e,1,null,this);
	    this.h = PropertyFactory.getProp(elem,data.h||{k:0},0,0.01,this);
	    this.a = PropertyFactory.getProp(elem,data.a||{k:0},0,degToRads,this);
	    this.g = new GradientProperty(elem,data.g,this);
	    this.style = styleOb;
	    this.stops = [];
	    this.setGradientData(styleOb.pElem, data);
	    this.setGradientOpacity(data, styleOb);
	    this._isAnimated = !!this._isAnimated;
	
	};
	
	SVGGradientFillStyleData.prototype.setGradientData = function(pathElement,data){
	
	    var gradientId = createElementID();
	    var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
	    gfill.setAttribute('id',gradientId);
	    gfill.setAttribute('spreadMethod','pad');
	    gfill.setAttribute('gradientUnits','userSpaceOnUse');
	    var stops = [];
	    var stop, j, jLen;
	    jLen = data.g.p*4;
	    for(j=0;j<jLen;j+=4){
	        stop = createNS('stop');
	        gfill.appendChild(stop);
	        stops.push(stop);
	    }
	    pathElement.setAttribute( data.ty === 'gf' ? 'fill':'stroke','url(' + locationHref + '#'+gradientId+')');
	    
	    this.gf = gfill;
	    this.cst = stops;
	};
	
	SVGGradientFillStyleData.prototype.setGradientOpacity = function(data, styleOb){
	    if(this.g._hasOpacity && !this.g._collapsable){
	        var stop, j, jLen;
	        var mask = createNS("mask");
	        var maskElement = createNS( 'path');
	        mask.appendChild(maskElement);
	        var opacityId = createElementID();
	        var maskId = createElementID();
	        mask.setAttribute('id',maskId);
	        var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
	        opFill.setAttribute('id',opacityId);
	        opFill.setAttribute('spreadMethod','pad');
	        opFill.setAttribute('gradientUnits','userSpaceOnUse');
	        jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
	        var stops = this.stops;
	        for(j=data.g.p*4;j<jLen;j+=2){
	            stop = createNS('stop');
	            stop.setAttribute('stop-color','rgb(255,255,255)');
	            opFill.appendChild(stop);
	            stops.push(stop);
	        }
	        maskElement.setAttribute( data.ty === 'gf' ? 'fill':'stroke','url(' + locationHref + '#'+opacityId+')');
	        this.of = opFill;
	        this.ms = mask;
	        this.ost = stops;
	        this.maskId = maskId;
	        styleOb.msElem = maskElement;
	    }
	};
	
	extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
	function SVGGradientStrokeStyleData(elem, data, styleOb){
		this.initDynamicPropertyContainer(elem);
		this.getValue = this.iterateDynamicProperties;
		this.w = PropertyFactory.getProp(elem,data.w,0,null,this);
		this.d = new DashProperty(elem,data.d||{},'svg',this);
	    this.initGradientData(elem, data, styleOb);
	    this._isAnimated = !!this._isAnimated;
	}
	
	extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
	function ShapeGroupData() {
		this.it = [];
	    this.prevViewData = [];
	    this.gr = createNS('g');
	}
	var SVGElementsRenderer = (function() {
		var _identityMatrix = new Matrix();
		var _matrixHelper = new Matrix();
	
		var ob = {
			createRenderFunction: createRenderFunction
		}
	
		function createRenderFunction(data) {
		    var ty = data.ty;
		    switch(data.ty) {
		        case 'fl':
		        return renderFill;
		        case 'gf':
		        return renderGradient;
		        case 'gs':
		        return renderGradientStroke;
		        case 'st':
		        return renderStroke;
		        case 'sh':
		        case 'el':
		        case 'rc':
		        case 'sr':
		        return renderPath;
		        case 'tr':
		        return renderContentTransform;
		    }
		}
	
		function renderContentTransform(styleData, itemData, isFirstFrame) {
		    if(isFirstFrame || itemData.transform.op._mdf){
		        itemData.transform.container.setAttribute('opacity',itemData.transform.op.v);
		    }
		    if(isFirstFrame || itemData.transform.mProps._mdf){
		        itemData.transform.container.setAttribute('transform',itemData.transform.mProps.v.to2dCSS());
		    }
		}
	
		function renderPath(styleData, itemData, isFirstFrame) {
		    var j, jLen,pathStringTransformed,redraw,pathNodes,l, lLen = itemData.styles.length;
		    var lvl = itemData.lvl;
		    var paths, mat, props, iterations, k;
		    for(l=0;l<lLen;l+=1){
		        redraw = itemData.sh._mdf || isFirstFrame;
		        if(itemData.styles[l].lvl < lvl){
		            mat = _matrixHelper.reset();
		            iterations = lvl - itemData.styles[l].lvl;
		            k = itemData.transformers.length-1;
		            while(!redraw && iterations > 0) {
		                redraw = itemData.transformers[k].mProps._mdf || redraw;
		                iterations --;
		                k --;
		            }
		            if(redraw) {
		                iterations = lvl - itemData.styles[l].lvl;
		                k = itemData.transformers.length-1;
		                while(iterations > 0) {
		                    props = itemData.transformers[k].mProps.v.props;
		                    mat.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
		                    iterations --;
		                    k --;
		                }
		            }
		        } else {
		            mat = _identityMatrix;
		        }
		        paths = itemData.sh.paths;
		        jLen = paths._length;
		        if(redraw){
		            pathStringTransformed = '';
		            for(j=0;j<jLen;j+=1){
		                pathNodes = paths.shapes[j];
		                if(pathNodes && pathNodes._length){
		                    pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
		                }
		            }
		            itemData.caches[l] = pathStringTransformed;
		        } else {
		            pathStringTransformed = itemData.caches[l];
		        }
		        itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
		        itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
		    }
		}
	
		function renderFill (styleData,itemData, isFirstFrame){
		    var styleElem = itemData.style;
	
		    if(itemData.c._mdf || isFirstFrame){
		        styleElem.pElem.setAttribute('fill','rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')');
		    }
		    if(itemData.o._mdf || isFirstFrame){
		        styleElem.pElem.setAttribute('fill-opacity',itemData.o.v);
		    }
		};
	
		function renderGradientStroke (styleData, itemData, isFirstFrame) {
		    renderGradient(styleData, itemData, isFirstFrame);
		    renderStroke(styleData, itemData, isFirstFrame);
		}
	
		function renderGradient(styleData, itemData, isFirstFrame) {
		    var gfill = itemData.gf;
		    var hasOpacity = itemData.g._hasOpacity;
		    var pt1 = itemData.s.v, pt2 = itemData.e.v;
	
		    if (itemData.o._mdf || isFirstFrame) {
		        var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
		        itemData.style.pElem.setAttribute(attr, itemData.o.v);
		    }
		    if (itemData.s._mdf || isFirstFrame) {
		        var attr1 = styleData.t === 1 ? 'x1' : 'cx';
		        var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
		        gfill.setAttribute(attr1, pt1[0]);
		        gfill.setAttribute(attr2, pt1[1]);
		        if (hasOpacity && !itemData.g._collapsable) {
		            itemData.of.setAttribute(attr1, pt1[0]);
		            itemData.of.setAttribute(attr2, pt1[1]);
		        }
		    }
		    var stops, i, len, stop;
		    if (itemData.g._cmdf || isFirstFrame) {
		        stops = itemData.cst;
		        var cValues = itemData.g.c;
		        len = stops.length;
		        for (i = 0; i < len; i += 1){
		            stop = stops[i];
		            stop.setAttribute('offset', cValues[i * 4] + '%');
		            stop.setAttribute('stop-color','rgb('+ cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ','+cValues[i * 4 + 3] + ')');
		        }
		    }
		    if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
		        var oValues = itemData.g.o;
		        if(itemData.g._collapsable) {
		            stops = itemData.cst;
		        } else {
		            stops = itemData.ost;
		        }
		        len = stops.length;
		        for (i = 0; i < len; i += 1) {
		            stop = stops[i];
		            if(!itemData.g._collapsable) {
		                stop.setAttribute('offset', oValues[i * 2] + '%');
		            }
		            stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
		        }
		    }
		    if (styleData.t === 1) {
		        if (itemData.e._mdf  || isFirstFrame) {
		            gfill.setAttribute('x2', pt2[0]);
		            gfill.setAttribute('y2', pt2[1]);
		            if (hasOpacity && !itemData.g._collapsable) {
		                itemData.of.setAttribute('x2', pt2[0]);
		                itemData.of.setAttribute('y2', pt2[1]);
		            }
		        }
		    } else {
		        var rad;
		        if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
		            rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
		            gfill.setAttribute('r', rad);
		            if(hasOpacity && !itemData.g._collapsable){
		                itemData.of.setAttribute('r', rad);
		            }
		        }
		        if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
		            if (!rad) {
		                rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
		            }
		            var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
	
		            var percent = itemData.h.v >= 1 ? 0.99 : itemData.h.v <= -1 ? -0.99: itemData.h.v;
		            var dist = rad * percent;
		            var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
		            var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
		            gfill.setAttribute('fx', x);
		            gfill.setAttribute('fy', y);
		            if (hasOpacity && !itemData.g._collapsable) {
		                itemData.of.setAttribute('fx', x);
		                itemData.of.setAttribute('fy', y);
		            }
		        }
		        //gfill.setAttribute('fy','200');
		    }
		};
	
		function renderStroke(styleData, itemData, isFirstFrame) {
		    var styleElem = itemData.style;
		    var d = itemData.d;
		    if (d && (d._mdf || isFirstFrame) && d.dashStr) {
		        styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
		        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
		    }
		    if(itemData.c && (itemData.c._mdf || isFirstFrame)){
		        styleElem.pElem.setAttribute('stroke','rgb(' + bm_floor(itemData.c.v[0]) + ',' + bm_floor(itemData.c.v[1]) + ',' + bm_floor(itemData.c.v[2]) + ')');
		    }
		    if(itemData.o._mdf || isFirstFrame){
		        styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
		    }
		    if(itemData.w._mdf || isFirstFrame){
		        styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
		        if(styleElem.msElem){
		            styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
		        }
		    }
		};
	
		return ob;
	}())
	function ShapeTransformManager() {
		this.sequences = {};
		this.sequenceList = [];
	    this.transform_key_count = 0;
	}
	
	ShapeTransformManager.prototype = {
		addTransformSequence: function(transforms) {
			var i, len = transforms.length;
			var key = '_';
			for(i = 0; i < len; i += 1) {
				key += transforms[i].transform.key + '_';
			}
			var sequence = this.sequences[key];
			if(!sequence) {
				sequence = {
					transforms: [].concat(transforms),
					finalTransform: new Matrix(),
					_mdf: false
				};
				this.sequences[key] = sequence;
				this.sequenceList.push(sequence);
			}
			return sequence;
		},
		processSequence: function(sequence, isFirstFrame) {
			var i = 0, len = sequence.transforms.length, _mdf = isFirstFrame;
			while (i < len && !isFirstFrame) {
				if (sequence.transforms[i].transform.mProps._mdf) {
					_mdf = true;
					break;
				}
				i += 1
			}
			if (_mdf) {
				var props;
				sequence.finalTransform.reset();
				for (i = len - 1; i >= 0; i -= 1) {
			        props = sequence.transforms[i].transform.mProps.v.props;
			        sequence.finalTransform.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
				}
			}
			sequence._mdf = _mdf;
			
		},
		processSequences: function(isFirstFrame) {
			var i, len = this.sequenceList.length;
			for (i = 0; i < len; i += 1) {
				this.processSequence(this.sequenceList[i], isFirstFrame);
			}
	
		},
		getNewKey: function() {
			return '_' + this.transform_key_count++;
		}
	}
	function CVShapeData(element, data, styles, transformsManager) {
	    this.styledShapes = [];
	    this.tr = [0,0,0,0,0,0];
	    var ty = 4;
	    if(data.ty == 'rc'){
	        ty = 5;
	    }else if(data.ty == 'el'){
	        ty = 6;
	    }else if(data.ty == 'sr'){
	        ty = 7;
	    }
	    this.sh = ShapePropertyFactory.getShapeProp(element,data,ty,element);
	    var i , len = styles.length,styledShape;
	    for (i = 0; i < len; i += 1) {
	        if (!styles[i].closed) {
	            styledShape = {
	                transforms: transformsManager.addTransformSequence(styles[i].transforms),
	                trNodes: []
	            }
	            this.styledShapes.push(styledShape);
	            styles[i].elements.push(styledShape);
	        }
	    }
	}
	
	CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
	function BaseElement(){
	}
	
	BaseElement.prototype = {
	    checkMasks: function(){
	        if(!this.data.hasMask){
	            return false;
	        }
	        var i = 0, len = this.data.masksProperties.length;
	        while(i<len) {
	            if((this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false)) {
	                return true;
	            }
	            i += 1;
	        }
	        return false;
	    },
	    initExpressions: function(){
	        this.layerInterface = LayerExpressionInterface(this);
	        if(this.data.hasMask && this.maskManager) {
	            this.layerInterface.registerMaskInterface(this.maskManager);
	        }
	        var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this,this.layerInterface);
	        this.layerInterface.registerEffectsInterface(effectsInterface);
	
	        if(this.data.ty === 0 || this.data.xt){
	            this.compInterface = CompExpressionInterface(this);
	        } else if(this.data.ty === 4){
	            this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData,this.itemsData,this.layerInterface);
	            this.layerInterface.content = this.layerInterface.shapeInterface;
	        } else if(this.data.ty === 5){
	            this.layerInterface.textInterface = TextExpressionInterface(this);
	            this.layerInterface.text = this.layerInterface.textInterface;
	        }
	    },
	    setBlendMode: function(){
	        var blendModeValue = getBlendMode(this.data.bm);
	        var elem = this.baseElement || this.layerElement;
	
	        elem.style['mix-blend-mode'] = blendModeValue;
	    },
	    initBaseData: function(data, globalData, comp){
	        this.globalData = globalData;
	        this.comp = comp;
	        this.data = data;
	        this.layerId = createElementID();
	        
	        //Stretch factor for old animations missing this property.
	        if(!this.data.sr){
	            this.data.sr = 1;
	        }
	        // effects manager
	        this.effectsManager = new EffectsManager(this.data,this,this.dynamicProperties);
	        
	    },
	    getType: function(){
	        return this.type;
	    }
	}
	function NullElement(data,globalData,comp){
	    this.initFrame();
		this.initBaseData(data, globalData, comp);
	    this.initFrame();
	    this.initTransform(data, globalData, comp);
	    this.initHierarchy();
	}
	
	NullElement.prototype.prepareFrame = function(num) {
	    this.prepareProperties(num, true);
	};
	
	NullElement.prototype.renderFrame = function() {
	};
	
	NullElement.prototype.getBaseElement = function() {
		return null;
	};
	
	NullElement.prototype.destroy = function() {
	};
	
	NullElement.prototype.sourceRectAtTime = function() {
	};
	
	NullElement.prototype.hide = function() {
	};
	
	extendPrototype([BaseElement,TransformElement,HierarchyElement,FrameElement], NullElement);
	
	function SVGBaseElement(){
	}
	
	SVGBaseElement.prototype = {
	    initRendererElement: function() {
	        this.layerElement = createNS('g');
	    },
	    createContainerElements: function(){
	        this.matteElement = createNS('g');
	        this.transformedElement = this.layerElement;
	        this.maskedElement = this.layerElement;
	        this._sizeChanged = false;
	        var layerElementParent = null;
	        //If this layer acts as a mask for the following layer
	        var filId, fil, gg;
	        if (this.data.td) {
	            if (this.data.td == 3 || this.data.td == 1) {
	                var masker = createNS('mask');
	                masker.setAttribute('id', this.layerId);
	                masker.setAttribute('mask-type', this.data.td == 3 ? 'luminance' : 'alpha');
	                masker.appendChild(this.layerElement);
	                layerElementParent = masker;
	                this.globalData.defs.appendChild(masker);
	                // This is only for IE and Edge when mask if of type alpha
	                if (!featureSupport.maskType && this.data.td == 1) {
	                    masker.setAttribute('mask-type', 'luminance');
	                    filId = createElementID();
	                    fil = filtersFactory.createFilter(filId);
	                    this.globalData.defs.appendChild(fil);
	                    fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	                    gg = createNS('g');
	                    gg.appendChild(this.layerElement);
	                    layerElementParent = gg;
	                    masker.appendChild(gg);
	                    gg.setAttribute('filter','url(' + locationHref + '#' + filId + ')');
	                }
	            } else if(this.data.td == 2) {
	                var maskGroup = createNS('mask');
	                maskGroup.setAttribute('id', this.layerId);
	                maskGroup.setAttribute('mask-type','alpha');
	                var maskGrouper = createNS('g');
	                maskGroup.appendChild(maskGrouper);
	                filId = createElementID();
	                fil = filtersFactory.createFilter(filId);
	                ////
	
	                var feColorMatrix = createNS('feColorMatrix');
	                feColorMatrix.setAttribute('type', 'matrix');
	                feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
	                feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 -1 1');
	                fil.appendChild(feColorMatrix);
	
	                ////
	                /*var feCTr = createNS('feComponentTransfer');
	                feCTr.setAttribute('in','SourceGraphic');
	                fil.appendChild(feCTr);
	                var feFunc = createNS('feFuncA');
	                feFunc.setAttribute('type','table');
	                feFunc.setAttribute('tableValues','1.0 0.0');
	                feCTr.appendChild(feFunc);*/
	                this.globalData.defs.appendChild(fil);
	                var alphaRect = createNS('rect');
	                alphaRect.setAttribute('width',  this.comp.data.w);
	                alphaRect.setAttribute('height', this.comp.data.h);
	                alphaRect.setAttribute('x','0');
	                alphaRect.setAttribute('y','0');
	                alphaRect.setAttribute('fill','#ffffff');
	                alphaRect.setAttribute('opacity','0');
	                maskGrouper.setAttribute('filter', 'url(' + locationHref + '#'+filId+')');
	                maskGrouper.appendChild(alphaRect);
	                maskGrouper.appendChild(this.layerElement);
	                layerElementParent = maskGrouper;
	                if (!featureSupport.maskType) {
	                    maskGroup.setAttribute('mask-type', 'luminance');
	                    fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	                    gg = createNS('g');
	                    maskGrouper.appendChild(alphaRect);
	                    gg.appendChild(this.layerElement);
	                    layerElementParent = gg;
	                    maskGrouper.appendChild(gg);
	                }
	                this.globalData.defs.appendChild(maskGroup);
	            }
	        } else if (this.data.tt) {
	            this.matteElement.appendChild(this.layerElement);
	            layerElementParent = this.matteElement;
	            this.baseElement = this.matteElement;
	        } else {
	            this.baseElement = this.layerElement;
	        }
	        if (this.data.ln) {
	            this.layerElement.setAttribute('id', this.data.ln);
	        }
	        if (this.data.cl) {
	            this.layerElement.setAttribute('class', this.data.cl);
	        }
	        //Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
	        if (this.data.ty === 0 && !this.data.hd) {
	            var cp = createNS( 'clipPath');
	            var pt = createNS('path');
	            pt.setAttribute('d','M0,0 L' + this.data.w + ',0' + ' L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
	            var clipId = createElementID();
	            cp.setAttribute('id',clipId);
	            cp.appendChild(pt);
	            this.globalData.defs.appendChild(cp);
	
	            if (this.checkMasks()) {
	                var cpGroup = createNS('g');
	                cpGroup.setAttribute('clip-path','url(' + locationHref + '#'+clipId + ')');
	                cpGroup.appendChild(this.layerElement);
	                this.transformedElement = cpGroup;
	                if (layerElementParent) {
	                    layerElementParent.appendChild(this.transformedElement);
	                } else {
	                    this.baseElement = this.transformedElement;
	                }
	            } else {
	                this.layerElement.setAttribute('clip-path','url(' + locationHref + '#'+clipId+')');
	            }
	            
	        }
	        if (this.data.bm !== 0) {
	            this.setBlendMode();
	        }
	
	    },
	    renderElement: function() {
	        if (this.finalTransform._matMdf) {
	            this.transformedElement.setAttribute('transform', this.finalTransform.mat.to2dCSS());
	        }
	        if (this.finalTransform._opMdf) {
	            this.transformedElement.setAttribute('opacity', this.finalTransform.mProp.o.v);
	        }
	    },
	    destroyBaseElement: function() {
	        this.layerElement = null;
	        this.matteElement = null;
	        this.maskManager.destroy();
	    },
	    getBaseElement: function() {
	        if (this.data.hd) {
	            return null;
	        }
	        return this.baseElement;
	    },
	    createRenderableComponents: function() {
	        this.maskManager = new MaskElement(this.data, this, this.globalData);
	        this.renderableEffectsManager = new SVGEffects(this);
	    },
	    setMatte: function(id) {
	        if (!this.matteElement) {
	            return;
	        }
	        this.matteElement.setAttribute("mask", "url(" + locationHref + "#" + id + ")");
	    }
	};
	function IShapeElement(){
	}
	
	IShapeElement.prototype = {
	    addShapeToModifiers: function(data) {
	        var i, len = this.shapeModifiers.length;
	        for(i=0;i<len;i+=1){
	            this.shapeModifiers[i].addShape(data);
	        }
	    },
	    isShapeInAnimatedModifiers: function(data) {
	        var i = 0, len = this.shapeModifiers.length;
	        while(i < len) {
	            if(this.shapeModifiers[i].isAnimatedWithShape(data)) {
	                return true;
	            }
	        }
	        return false;
	    },
	    renderModifiers: function() {
	        if(!this.shapeModifiers.length){
	            return;
	        }
	        var i, len = this.shapes.length;
	        for(i=0;i<len;i+=1){
	            this.shapes[i].sh.reset();
	        }
	
	        len = this.shapeModifiers.length;
	        for(i=len-1;i>=0;i-=1){
	            this.shapeModifiers[i].processShapes(this._isFirstFrame);
	        }
	    },
	    lcEnum: {
	        '1': 'butt',
	        '2': 'round',
	        '3': 'square'
	    },
	    ljEnum: {
	        '1': 'miter',
	        '2': 'round',
	        '3': 'bevel'
	    },
	    searchProcessedElement: function(elem){
	        var elements = this.processedElements;
	        var i = 0, len = elements.length;
	        while (i < len) {
	            if (elements[i].elem === elem) {
	                return elements[i].pos;
	            }
	            i += 1;
	        }
	        return 0;
	    },
	    addProcessedElement: function(elem, pos){
	        var elements = this.processedElements;
	        var i = elements.length;
	        while(i) {
	            i -= 1;
	            if (elements[i].elem === elem) {
	                elements[i].pos = pos;
	                return;
	            }
	        }
	        elements.push(new ProcessedElement(elem, pos));
	    },
	    prepareFrame: function(num) {
	        this.prepareRenderableFrame(num);
	        this.prepareProperties(num, this.isInRange);
	    }
	};
	function ITextElement(){
	}
	
	ITextElement.prototype.initElement = function(data,globalData,comp){
	    this.lettersChangedFlag = true;
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
	    this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
	    this.initTransform(data, globalData, comp);
	    this.initHierarchy();
	    this.initRenderable();
	    this.initRendererElement();
	    this.createContainerElements();
	    this.createRenderableComponents();
	    this.createContent();
	    this.hide();
	    this.textAnimator.searchProperties(this.dynamicProperties);
	};
	
	ITextElement.prototype.prepareFrame = function(num) {
	    this._mdf = false;
	    this.prepareRenderableFrame(num);
	    this.prepareProperties(num, this.isInRange);
	    if(this.textProperty._mdf || this.textProperty._isFirstFrame) {
	        this.buildNewText();
	        this.textProperty._isFirstFrame = false;
	        this.textProperty._mdf = false;
	    }
	};
	
	ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
	    var j,jLen = shapes.length;
	    var k, kLen, pathNodes;
	    var shapeStr = '';
	    for(j=0;j<jLen;j+=1){
	        pathNodes = shapes[j].ks.k;
	        shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
	    }
	    return shapeStr;
	};
	
	ITextElement.prototype.updateDocumentData = function(newData, index) {
	    this.textProperty.updateDocumentData(newData, index);
	};
	
	ITextElement.prototype.canResizeFont = function(_canResize) {
	    this.textProperty.canResizeFont(_canResize);
	};
	
	ITextElement.prototype.setMinimumFontSize = function(_fontSize) {
	    this.textProperty.setMinimumFontSize(_fontSize);
	};
	
	ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
	    if(documentData.ps){
	        matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
	    }
	    matrixHelper.translate(0,-documentData.ls,0);
	    switch(documentData.j){
	        case 1:
	            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]),0,0);
	            break;
	        case 2:
	            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber] )/2,0,0);
	            break;
	    }
	    matrixHelper.translate(xPos, yPos, 0);
	};
	
	
	ITextElement.prototype.buildColor = function(colorData) {
	    return 'rgb(' + Math.round(colorData[0]*255) + ',' + Math.round(colorData[1]*255) + ',' + Math.round(colorData[2]*255) + ')';
	};
	
	ITextElement.prototype.emptyProp = new LetterProps();
	
	ITextElement.prototype.destroy = function(){
	    
	};
	function ICompElement(){}
	
	extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);
	
	ICompElement.prototype.initElement = function(data,globalData,comp) {
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.initTransform(data, globalData, comp);
	    this.initRenderable();
	    this.initHierarchy();
	    this.initRendererElement();
	    this.createContainerElements();
	    this.createRenderableComponents();
	    if(this.data.xt || !globalData.progressiveLoad){
	        this.buildAllItems();
	    }
	    this.hide();
	};
	
	/*ICompElement.prototype.hide = function(){
	    if(!this.hidden){
	        this.hideElement();
	        var i,len = this.elements.length;
	        for( i = 0; i < len; i+=1 ){
	            if(this.elements[i]){
	                this.elements[i].hide();
	            }
	        }
	    }
	};*/
	
	ICompElement.prototype.prepareFrame = function(num){
	    this._mdf = false;
	    this.prepareRenderableFrame(num);
	    this.prepareProperties(num, this.isInRange);
	    if(!this.isInRange && !this.data.xt){
	        return;
	    }
	
	    if (!this.tm._placeholder) {
	        var timeRemapped = this.tm.v;
	        if(timeRemapped === this.data.op){
	            timeRemapped = this.data.op - 1;
	        }
	        this.renderedFrame = timeRemapped;
	    } else {
	        this.renderedFrame = num/this.data.sr;
	    }
	    var i,len = this.elements.length;
	    if(!this.completeLayers){
	        this.checkLayers(this.renderedFrame);
	    }
	    //This iteration needs to be backwards because of how expressions connect between each other
	    for( i = len - 1; i >= 0; i -= 1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
	            if(this.elements[i]._mdf) {
	                this._mdf = true;
	            }
	        }
	    }
	};
	
	ICompElement.prototype.renderInnerContent = function() {
	    var i,len = this.layers.length;
	    for( i = 0; i < len; i += 1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	};
	
	ICompElement.prototype.setElements = function(elems){
	    this.elements = elems;
	};
	
	ICompElement.prototype.getElements = function(){
	    return this.elements;
	};
	
	ICompElement.prototype.destroyElements = function(){
	    var i,len = this.layers.length;
	    for( i = 0; i < len; i+=1 ){
	        if(this.elements[i]){
	            this.elements[i].destroy();
	        }
	    }
	};
	
	ICompElement.prototype.destroy = function(){
	    this.destroyElements();
	    this.destroyBaseElement();
	};
	
	function IImageElement(data,globalData,comp){
	    this.assetData = globalData.getAssetData(data.refId);
	    this.initElement(data,globalData,comp);
	}
	
	extendPrototype([BaseElement,TransformElement,SVGBaseElement,HierarchyElement,FrameElement,RenderableDOMElement], IImageElement);
	
	IImageElement.prototype.createContent = function(){
	
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	
	    this.innerElem = createNS('image');
	    this.innerElem.setAttribute('width',this.assetData.w+"px");
	    this.innerElem.setAttribute('height',this.assetData.h+"px");
	    this.innerElem.setAttribute('preserveAspectRatio',this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
	    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
	    
	    this.layerElement.appendChild(this.innerElem);
	};
	
	function ISolidElement(data,globalData,comp){
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([IImageElement], ISolidElement);
	
	ISolidElement.prototype.createContent = function(){
	
	    var rect = createNS('rect');
	    ////rect.style.width = this.data.sw;
	    ////rect.style.height = this.data.sh;
	    ////rect.style.fill = this.data.sc;
	    rect.setAttribute('width',this.data.sw);
	    rect.setAttribute('height',this.data.sh);
	    rect.setAttribute('fill',this.data.sc);
	    this.layerElement.appendChild(rect);
	};
	function SVGCompElement(data,globalData,comp){
	    this.layers = data.layers;
	    this.supports3d = true;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
	    //this.layerElement = createNS('g');
	    this.initElement(data,globalData,comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this,data.tm,0,globalData.frameRate,this) : {_placeholder:true};
	}
	
	extendPrototype([SVGRenderer, ICompElement, SVGBaseElement], SVGCompElement);
	function SVGTextElement(data,globalData,comp){
	    this.textSpans = [];
	    this.renderType = 'svg';
	    this.initElement(data,globalData,comp);
	}
	
	extendPrototype([BaseElement,TransformElement,SVGBaseElement,HierarchyElement,FrameElement,RenderableDOMElement,ITextElement], SVGTextElement);
	
	SVGTextElement.prototype.createContent = function(){
	
	    if (this.data.singleShape && !this.globalData.fontManager.chars) {
	        this.textContainer = createNS('text');
	    }
	};
	
	SVGTextElement.prototype.buildTextContents = function(textArray) {
	    var i = 0, len = textArray.length;
	    var textContents = [], currentTextContent = '';
	    while (i < len) {
	        if(textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
	            textContents.push(currentTextContent);
	            currentTextContent = '';
	        } else {
	            currentTextContent += textArray[i];
	        }
	        i += 1;
	    }
	    textContents.push(currentTextContent);
	    return textContents;
	}
	
	SVGTextElement.prototype.buildNewText = function(){
	    var i, len;
	
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
	    if(documentData.fc) {
	        this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
	    }else{
	        this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
	    }
	    if(documentData.sc){
	        this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
	        this.layerElement.setAttribute('stroke-width', documentData.sw);
	    }
	    this.layerElement.setAttribute('font-size', documentData.finalSize);
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    if(fontData.fClass){
	        this.layerElement.setAttribute('class',fontData.fClass);
	    } else {
	        this.layerElement.setAttribute('font-family', fontData.fFamily);
	        var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
	        this.layerElement.setAttribute('font-style', fStyle);
	        this.layerElement.setAttribute('font-weight', fWeight);
	    }
	
	    var letters = documentData.l || [];
	    var usesGlyphs = !!this.globalData.fontManager.chars;
	    len = letters.length;
	
	    var tSpan;
	    var matrixHelper = this.mHelper;
	    var shapes, shapeStr = '', singleShape = this.data.singleShape;
	    var xPos = 0, yPos = 0, firstLine = true;
	    var trackingOffset = documentData.tr/1000*documentData.finalSize;
	    if(singleShape && !usesGlyphs && !documentData.sz) {
	        var tElement = this.textContainer;
	        var justify = 'start';
	        switch(documentData.j) {
	            case 1:
	                justify = 'end';
	                break;
	            case 2:
	                justify = 'middle';
	                break;
	        }
	        tElement.setAttribute('text-anchor',justify);
	        tElement.setAttribute('letter-spacing',trackingOffset);
	        var textContent = this.buildTextContents(documentData.finalText);
	        len = textContent.length;
	        yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
	        for ( i = 0; i < len; i += 1) {
	            tSpan = this.textSpans[i] || createNS('tspan');
	            tSpan.textContent = textContent[i];
	            tSpan.setAttribute('x', 0);
	            tSpan.setAttribute('y', yPos);
	            tSpan.style.display = 'inherit';
	            tElement.appendChild(tSpan);
	            this.textSpans[i] = tSpan;
	            yPos += documentData.finalLineHeight;
	        }
	        
	        this.layerElement.appendChild(tElement);
	    } else {
	        var cachedSpansLength = this.textSpans.length;
	        var shapeData, charData;
	        for (i = 0; i < len; i += 1) {
	            if(!usesGlyphs || !singleShape || i === 0){
	                tSpan = cachedSpansLength > i ? this.textSpans[i] : createNS(usesGlyphs?'path':'text');
	                if (cachedSpansLength <= i) {
	                    tSpan.setAttribute('stroke-linecap', 'butt');
	                    tSpan.setAttribute('stroke-linejoin','round');
	                    tSpan.setAttribute('stroke-miterlimit','4');
	                    this.textSpans[i] = tSpan;
	                    this.layerElement.appendChild(tSpan);
	                }
	                tSpan.style.display = 'inherit';
	            }
	            
	            matrixHelper.reset();
	            matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
	            if (singleShape) {
	                if(letters[i].n) {
	                    xPos = -trackingOffset;
	                    yPos += documentData.yOffset;
	                    yPos += firstLine ? 1 : 0;
	                    firstLine = false;
	                }
	                this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	                xPos += letters[i].l || 0;
	                //xPos += letters[i].val === ' ' ? 0 : trackingOffset;
	                xPos += trackingOffset;
	            }
	            if(usesGlyphs) {
	                charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	                shapeData = charData && charData.data || {};
	                shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
	                if(!singleShape){
	                    tSpan.setAttribute('d',this.createPathShape(matrixHelper,shapes));
	                } else {
	                    shapeStr += this.createPathShape(matrixHelper,shapes);
	                }
	            } else {
	                if(singleShape) {
	                    tSpan.setAttribute("transform", "translate(" + matrixHelper.props[12] + "," + matrixHelper.props[13] + ")");
	                }
	                tSpan.textContent = letters[i].val;
	                tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
	            }
	            //
	        }
	        if (singleShape && tSpan) {
	            tSpan.setAttribute('d',shapeStr);
	        }
	    }
	    while (i < this.textSpans.length){
	        this.textSpans[i].style.display = 'none';
	        i += 1;
	    }
	    
	    this._sizeChanged = true;
	};
	
	SVGTextElement.prototype.sourceRectAtTime = function(time){
	    this.prepareFrame(this.comp.renderedFrame - this.data.st);
	    this.renderInnerContent();
	    if(this._sizeChanged){
	        this._sizeChanged = false;
	        var textBox = this.layerElement.getBBox();
	        this.bbox = {
	            top: textBox.y,
	            left: textBox.x,
	            width: textBox.width,
	            height: textBox.height
	        };
	    }
	    return this.bbox;
	};
	
	SVGTextElement.prototype.renderInnerContent = function(){
	
	    if(!this.data.singleShape){
	        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	        if(this.lettersChangedFlag || this.textAnimator.lettersChangedFlag){
	            this._sizeChanged = true;
	            var  i,len;
	            var renderedLetters = this.textAnimator.renderedLetters;
	
	            var letters = this.textProperty.currentData.l;
	
	            len = letters.length;
	            var renderedLetter, textSpan;
	            for(i=0;i<len;i+=1){
	                if(letters[i].n){
	                    continue;
	                }
	                renderedLetter = renderedLetters[i];
	                textSpan = this.textSpans[i];
	                if(renderedLetter._mdf.m) {
	                    textSpan.setAttribute('transform',renderedLetter.m);
	                }
	                if(renderedLetter._mdf.o) {
	                    textSpan.setAttribute('opacity',renderedLetter.o);
	                }
	                if(renderedLetter._mdf.sw){
	                    textSpan.setAttribute('stroke-width',renderedLetter.sw);
	                }
	                if(renderedLetter._mdf.sc){
	                    textSpan.setAttribute('stroke',renderedLetter.sc);
	                }
	                if(renderedLetter._mdf.fc){
	                    textSpan.setAttribute('fill',renderedLetter.fc);
	                }
	            }
	        }
	    }
	};
	function SVGShapeElement(data,globalData,comp){
	    //List of drawable elements
	    this.shapes = [];
	    // Full shape data
	    this.shapesData = data.shapes;
	    //List of styles that will be applied to shapes
	    this.stylesList = [];
	    //List of modifiers that will be applied to shapes
	    this.shapeModifiers = [];
	    //List of items in shape tree
	    this.itemsData = [];
	    //List of items in previous shape tree
	    this.processedElements = [];
	    // List of animated components
	    this.animatedContents = [];
	    this.initElement(data,globalData,comp);
	    //Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	    // List of elements that have been created
	    this.prevViewData = [];
	    //Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	}
	
	extendPrototype([BaseElement,TransformElement,SVGBaseElement,IShapeElement,HierarchyElement,FrameElement,RenderableDOMElement], SVGShapeElement);
	
	SVGShapeElement.prototype.initSecondaryElement = function() {
	};
	
	SVGShapeElement.prototype.identityMatrix = new Matrix();
	
	SVGShapeElement.prototype.buildExpressionInterface = function(){};
	
	SVGShapeElement.prototype.createContent = function(){
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement, 0, [], true);
	    this.filterUniqueShapes();
	};
	
	/*
	This method searches for multiple shapes that affect a single element and one of them is animated
	*/
	SVGShapeElement.prototype.filterUniqueShapes = function(){
	    var i, len = this.shapes.length, shape;
	    var j, jLen = this.stylesList.length;
	    var style, count = 0;
	    var tempShapes = [];
	    var areAnimated = false;
	    for(j = 0; j < jLen; j += 1) {
	        style = this.stylesList[j];
	        areAnimated = false;
	        tempShapes.length = 0;
	        for(i = 0; i < len; i += 1) {
	            shape = this.shapes[i];
	            if(shape.styles.indexOf(style) !== -1) {
	                tempShapes.push(shape);
	                areAnimated = shape._isAnimated || areAnimated;
	            }
	        }
	        if(tempShapes.length > 1 && areAnimated) {
	            this.setShapesAsAnimated(tempShapes);
	        }
	    }
	}
	
	SVGShapeElement.prototype.setShapesAsAnimated = function(shapes){
	    var i, len = shapes.length;
	    for(i = 0; i < len; i += 1) {
	        shapes[i].setAsAnimated();
	    }
	}
	
	SVGShapeElement.prototype.createStyleElement = function(data, level){
	    //TODO: prevent drawing of hidden styles
	    var elementData;
	    var styleOb = new SVGStyleData(data, level);
	
	    var pathElement = styleOb.pElem;
	    if(data.ty === 'st') {
	        elementData = new SVGStrokeStyleData(this, data, styleOb);
	    } else if(data.ty === 'fl') {
	        elementData = new SVGFillStyleData(this, data, styleOb);
	    } else if(data.ty === 'gf' || data.ty === 'gs') {
	        var gradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
	        elementData = new gradientConstructor(this, data, styleOb);
	        this.globalData.defs.appendChild(elementData.gf);
	        if (elementData.maskId) {
	            this.globalData.defs.appendChild(elementData.ms);
	            this.globalData.defs.appendChild(elementData.of);
	            pathElement.setAttribute('mask','url(' + locationHref + '#' + elementData.maskId + ')');
	        }
	    }
	    
	    if(data.ty === 'st' || data.ty === 'gs') {
	        pathElement.setAttribute('stroke-linecap', this.lcEnum[data.lc] || 'round');
	        pathElement.setAttribute('stroke-linejoin',this.ljEnum[data.lj] || 'round');
	        pathElement.setAttribute('fill-opacity','0');
	        if(data.lj === 1) {
	            pathElement.setAttribute('stroke-miterlimit',data.ml);
	        }
	    }
	
	    if(data.r === 2) {
	        pathElement.setAttribute('fill-rule', 'evenodd');
	    }
	
	    if(data.ln){
	        pathElement.setAttribute('id',data.ln);
	    }
	    if(data.cl){
	        pathElement.setAttribute('class',data.cl);
	    }
	    if(data.bm){
	        pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
	    }
	    this.stylesList.push(styleOb);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	};
	
	SVGShapeElement.prototype.createGroupElement = function(data) {
	    var elementData = new ShapeGroupData();
	    if(data.ln){
	        elementData.gr.setAttribute('id',data.ln);
	    }
	    if(data.cl){
	        elementData.gr.setAttribute('class',data.cl);
	    }
	    if(data.bm){
	        elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
	    }
	    return elementData;
	};
	
	SVGShapeElement.prototype.createTransformElement = function(data, container) {
	    var transformProperty = TransformPropertyFactory.getTransformProperty(this,data,this);
	    var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	};
	
	SVGShapeElement.prototype.createShapeElement = function(data, ownTransformers, level) {
	    var ty = 4;
	    if(data.ty === 'rc'){
	        ty = 5;
	    }else if(data.ty === 'el'){
	        ty = 6;
	    }else if(data.ty === 'sr'){
	        ty = 7;
	    }
	    var shapeProperty = ShapePropertyFactory.getShapeProp(this,data,ty,this);
	    var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
	    this.shapes.push(elementData);
	    this.addShapeToModifiers(elementData);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	};
	
	SVGShapeElement.prototype.addToAnimatedContents = function(data, element) {
	    var i = 0, len = this.animatedContents.length;
	    while(i < len) {
	        if(this.animatedContents[i].element === element) {
	            return;
	        }
	        i += 1;
	    }
	    this.animatedContents.push({
	        fn: SVGElementsRenderer.createRenderFunction(data),
	        element: element,
	        data: data
	    });
	};
	
	SVGShapeElement.prototype.setElementStyles = function(elementData){
	    var arr = elementData.styles;
	    var j, jLen = this.stylesList.length;
	    for (j = 0; j < jLen; j += 1) {
	        if (!this.stylesList[j].closed) {
	            arr.push(this.stylesList[j]);
	        }
	    }
	};
	
	SVGShapeElement.prototype.reloadShapes = function(){
	    this._isFirstFrame = true;
	    var i, len = this.itemsData.length;
	    for( i = 0; i < len; i += 1) {
	        this.prevViewData[i] = this.itemsData[i];
	    }
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement, 0, [], true);
	    this.filterUniqueShapes();
	    len = this.dynamicProperties.length;
	    for(i = 0; i < len; i += 1) {
	        this.dynamicProperties[i].getValue();
	    }
	    this.renderModifiers();
	};
	
	SVGShapeElement.prototype.searchShapes = function(arr,itemsData,prevViewData,container, level, transformers, render){
	    var ownTransformers = [].concat(transformers);
	    var i, len = arr.length - 1;
	    var j, jLen;
	    var ownStyles = [], ownModifiers = [], styleOb, currentTransform, modifier, processedPos;
	    for(i=len;i>=0;i-=1){
	        processedPos = this.searchProcessedElement(arr[i]);
	        if(!processedPos){
	            arr[i]._render = render;
	        } else {
	            itemsData[i] = prevViewData[processedPos - 1];
	        }
	        if(arr[i].ty == 'fl' || arr[i].ty == 'st' || arr[i].ty == 'gf' || arr[i].ty == 'gs'){
	            if(!processedPos){
	                itemsData[i] = this.createStyleElement(arr[i], level);
	            } else {
	                itemsData[i].style.closed = false;
	            }
	            if(arr[i]._render){
	                container.appendChild(itemsData[i].style.pElem);
	            }
	            ownStyles.push(itemsData[i].style);
	        }else if(arr[i].ty == 'gr'){
	            if(!processedPos){
	                itemsData[i] = this.createGroupElement(arr[i]);
	            } else {
	                jLen = itemsData[i].it.length;
	                for(j=0;j<jLen;j+=1){
	                    itemsData[i].prevViewData[j] = itemsData[i].it[j];
	                }
	            }
	            this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData,itemsData[i].gr, level + 1, ownTransformers, render);
	            if(arr[i]._render){
	                container.appendChild(itemsData[i].gr);
	            }
	        }else if(arr[i].ty == 'tr'){
	            if(!processedPos){
	                itemsData[i] = this.createTransformElement(arr[i], container);
	            }
	            currentTransform = itemsData[i].transform;
	            ownTransformers.push(currentTransform);
	        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
	            if(!processedPos){
	                itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
	            }
	            this.setElementStyles(itemsData[i]);
	
	        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd' || arr[i].ty == 'ms'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                modifier.init(this,arr[i]);
	                itemsData[i] = modifier;
	                this.shapeModifiers.push(modifier);
	            } else {
	                modifier = itemsData[i];
	                modifier.closed = false;
	            }
	            ownModifiers.push(modifier);
	        }else if(arr[i].ty == 'rp'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                itemsData[i] = modifier;
	                modifier.init(this,arr,i,itemsData);
	                this.shapeModifiers.push(modifier);
	                render = false;
	            }else{
	                modifier = itemsData[i];
	                modifier.closed = true;
	            }
	            ownModifiers.push(modifier);
	        }
	        this.addProcessedElement(arr[i], i + 1);
	    }
	    len = ownStyles.length;
	    for(i=0;i<len;i+=1){
	        ownStyles[i].closed = true;
	    }
	    len = ownModifiers.length;
	    for(i=0;i<len;i+=1){
	        ownModifiers[i].closed = true;
	    }
	};
	
	SVGShapeElement.prototype.renderInnerContent = function() {
	    this.renderModifiers();
	    var i, len = this.stylesList.length;
	    for(i=0;i<len;i+=1){
	        this.stylesList[i].reset();
	    }
	    this.renderShape();
	
	    for (i = 0; i < len; i += 1) {
	        if (this.stylesList[i]._mdf || this._isFirstFrame) {
	            if(this.stylesList[i].msElem){
	                this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
	                //Adding M0 0 fixes same mask bug on all browsers
	                this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
	            }
	            this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
	        }
	    }
	};
	
	SVGShapeElement.prototype.renderShape = function() {
	    var i, len = this.animatedContents.length;
	    var animatedContent;
	    for(i = 0; i < len; i += 1) {
	        animatedContent = this.animatedContents[i];
	        if((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) {
	            animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
	        }
	    }
	}
	
	SVGShapeElement.prototype.destroy = function(){
	    this.destroyBaseElement();
	    this.shapesData = null;
	    this.itemsData = null;
	};
	
	function SVGTintFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
	    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f1');
	    filter.appendChild(feColorMatrix);
	    feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f2');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	    if(filterManager.effectElements[2].p.v !== 100 || filterManager.effectElements[2].p.k){
	        var feMerge = createNS('feMerge');
	        filter.appendChild(feMerge);
	        var feMergeNode;
	        feMergeNode = createNS('feMergeNode');
	        feMergeNode.setAttribute('in','SourceGraphic');
	        feMerge.appendChild(feMergeNode);
	        feMergeNode = createNS('feMergeNode');
	        feMergeNode.setAttribute('in','f2');
	        feMerge.appendChild(feMergeNode);
	    }
	}
	
	SVGTintFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        var colorBlack = this.filterManager.effectElements[0].p.v;
	        var colorWhite = this.filterManager.effectElements[1].p.v;
	        var opacity = this.filterManager.effectElements[2].p.v/100;
	        this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
	    }
	};
	function SVGFillFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	}
	SVGFillFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        var color = this.filterManager.effectElements[2].p.v;
	        var opacity = this.filterManager.effectElements[6].p.v;
	        this.matrixFilter.setAttribute('values','0 0 0 0 '+color[0]+' 0 0 0 0 '+color[1]+' 0 0 0 0 '+color[2]+' 0 0 0 '+opacity+' 0');
	    }
	};
	function SVGStrokeEffect(elem, filterManager){
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.elem = elem;
	    this.paths = [];
	}
	
	SVGStrokeEffect.prototype.initialize = function(){
	
	    var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	    var path,groupPath, i, len;
	    if(this.filterManager.effectElements[1].p.v === 1){
	        len = this.elem.maskManager.masksProperties.length;
	        i = 0;
	    } else {
	        i = this.filterManager.effectElements[0].p.v - 1;
	        len = i + 1;
	    }
	    groupPath = createNS('g'); 
	    groupPath.setAttribute('fill','none');
	    groupPath.setAttribute('stroke-linecap','round');
	    groupPath.setAttribute('stroke-dashoffset',1);
	    for(i;i<len;i+=1){
	        path = createNS('path');
	        groupPath.appendChild(path);
	        this.paths.push({p:path,m:i});
	    }
	    if(this.filterManager.effectElements[10].p.v === 3){
	        var mask = createNS('mask');
	        var id = createElementID();
	        mask.setAttribute('id',id);
	        mask.setAttribute('mask-type','alpha');
	        mask.appendChild(groupPath);
	        this.elem.globalData.defs.appendChild(mask);
	        var g = createNS('g');
	        g.setAttribute('mask','url(' + locationHref + '#'+id+')');
	        while (elemChildren[0]) {
	            g.appendChild(elemChildren[0]);
	        }
	        this.elem.layerElement.appendChild(g);
	        this.masker = mask;
	        groupPath.setAttribute('stroke','#fff');
	    } else if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
	        if(this.filterManager.effectElements[10].p.v === 2){
	            elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	            while(elemChildren.length){
	                this.elem.layerElement.removeChild(elemChildren[0]);
	            }
	        }
	        this.elem.layerElement.appendChild(groupPath);
	        this.elem.layerElement.removeAttribute('mask');
	        groupPath.setAttribute('stroke','#fff');
	    }
	    this.initialized = true;
	    this.pathMasker = groupPath;
	};
	
	SVGStrokeEffect.prototype.renderFrame = function(forceRender){
	    if(!this.initialized){
	        this.initialize();
	    }
	    var i, len = this.paths.length;
	    var mask, path;
	    for(i=0;i<len;i+=1){
	        if(this.paths[i].m === -1) {
	            continue;
	        }
	        mask = this.elem.maskManager.viewData[this.paths[i].m];
	        path = this.paths[i].p;
	        if(forceRender || this.filterManager._mdf || mask.prop._mdf){
	            path.setAttribute('d',mask.lastPath);
	        }
	        if(forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf){
	            var dasharrayValue;
	            if(this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100){
	                var s = Math.min(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
	                var e = Math.max(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
	                var l = path.getTotalLength();
	                dasharrayValue = '0 0 0 ' + l*s + ' ';
	                var lineLength = l*(e-s);
	                var segment = 1+this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
	                var units = Math.floor(lineLength/segment);
	                var j;
	                for(j=0;j<units;j+=1){
	                    dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100 + ' ';
	                }
	                dasharrayValue += '0 ' + l*10 + ' 0 0';
	            } else {
	                dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
	            }
	            path.setAttribute('stroke-dasharray',dasharrayValue);
	        }
	    }
	    if(forceRender || this.filterManager.effectElements[4].p._mdf){
	        this.pathMasker.setAttribute('stroke-width',this.filterManager.effectElements[4].p.v*2);
	    }
	    
	    if(forceRender || this.filterManager.effectElements[6].p._mdf){
	        this.pathMasker.setAttribute('opacity',this.filterManager.effectElements[6].p.v);
	    }
	    if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
	        if(forceRender || this.filterManager.effectElements[3].p._mdf){
	            var color = this.filterManager.effectElements[3].p.v;
	            this.pathMasker.setAttribute('stroke','rgb('+bm_floor(color[0]*255)+','+bm_floor(color[1]*255)+','+bm_floor(color[2]*255)+')');
	        }
	    }
	};
	function SVGTritoneFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
	    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f1');
	    filter.appendChild(feColorMatrix);
	    var feComponentTransfer = createNS('feComponentTransfer');
	    feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	    filter.appendChild(feComponentTransfer);
	    this.matrixFilter = feComponentTransfer;
	    var feFuncR = createNS('feFuncR');
	    feFuncR.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncR);
	    this.feFuncR = feFuncR;
	    var feFuncG = createNS('feFuncG');
	    feFuncG.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncG);
	    this.feFuncG = feFuncG;
	    var feFuncB = createNS('feFuncB');
	    feFuncB.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncB);
	    this.feFuncB = feFuncB;
	}
	
	SVGTritoneFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        var color1 = this.filterManager.effectElements[0].p.v;
	        var color2 = this.filterManager.effectElements[1].p.v;
	        var color3 = this.filterManager.effectElements[2].p.v;
	        var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
	        var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
	        var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
	        this.feFuncR.setAttribute('tableValues', tableR);
	        this.feFuncG.setAttribute('tableValues', tableG);
	        this.feFuncB.setAttribute('tableValues', tableB);
	        //var opacity = this.filterManager.effectElements[2].p.v/100;
	        //this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
	    }
	};
	function SVGProLevelsFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var effectElements = this.filterManager.effectElements;
	    var feComponentTransfer = createNS('feComponentTransfer');
	    var feFuncR, feFuncG, feFuncB;
	    
	    if(effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1){
	        this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
	    }
	    if(effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1){
	        this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
	    }
	    if(effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1){
	        this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	    if(effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1){
	        this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
	    }
	    
	    if(this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA){
	        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	        filter.appendChild(feComponentTransfer);
	        feComponentTransfer = createNS('feComponentTransfer');
	    }
	
	    if(effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1){
	
	        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	        filter.appendChild(feComponentTransfer);
	        this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
	        this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
	        this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	}
	
	SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
	    var feFunc = createNS(type);
	    feFunc.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFunc);
	    return feFunc;
	};
	
	SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
	    var cnt = 0;
	    var segments = 256;
	    var perc;
	    var min = Math.min(inputBlack, inputWhite);
	    var max = Math.max(inputBlack, inputWhite);
	    var table = Array.call(null,{length:segments});
	    var colorValue;
	    var pos = 0;
	    var outputDelta = outputWhite - outputBlack; 
	    var inputDelta = inputWhite - inputBlack; 
	    while(cnt <= 256) {
	        perc = cnt/256;
	        if(perc <= min){
	            colorValue = inputDelta < 0 ? outputWhite : outputBlack;
	        } else if(perc >= max){
	            colorValue = inputDelta < 0 ? outputBlack : outputWhite;
	        } else {
	            colorValue = (outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma));
	        }
	        table[pos++] = colorValue;
	        cnt += 256/(segments-1);
	    }
	    return table.join(' ');
	};
	
	SVGProLevelsFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        var val, cnt, perc, bezier;
	        var effectElements = this.filterManager.effectElements;
	        if(this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)){
	            val = this.getTableValue(effectElements[3].p.v,effectElements[4].p.v,effectElements[5].p.v,effectElements[6].p.v,effectElements[7].p.v);
	            this.feFuncRComposed.setAttribute('tableValues',val);
	            this.feFuncGComposed.setAttribute('tableValues',val);
	            this.feFuncBComposed.setAttribute('tableValues',val);
	        }
	
	
	        if(this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)){
	            val = this.getTableValue(effectElements[10].p.v,effectElements[11].p.v,effectElements[12].p.v,effectElements[13].p.v,effectElements[14].p.v);
	            this.feFuncR.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)){
	            val = this.getTableValue(effectElements[17].p.v,effectElements[18].p.v,effectElements[19].p.v,effectElements[20].p.v,effectElements[21].p.v);
	            this.feFuncG.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)){
	            val = this.getTableValue(effectElements[24].p.v,effectElements[25].p.v,effectElements[26].p.v,effectElements[27].p.v,effectElements[28].p.v);
	            this.feFuncB.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)){
	            val = this.getTableValue(effectElements[31].p.v,effectElements[32].p.v,effectElements[33].p.v,effectElements[34].p.v,effectElements[35].p.v);
	            this.feFuncA.setAttribute('tableValues',val);
	        }
	        
	    }
	};
	function SVGDropShadowEffect(filter, filterManager){
	    filter.setAttribute('x','-100%');
	    filter.setAttribute('y','-100%');
	    filter.setAttribute('width','400%');
	    filter.setAttribute('height','400%');
	    this.filterManager = filterManager;
	
	    var feGaussianBlur = createNS('feGaussianBlur');
	    feGaussianBlur.setAttribute('in','SourceAlpha');
	    feGaussianBlur.setAttribute('result','drop_shadow_1');
	    feGaussianBlur.setAttribute('stdDeviation','0');
	    this.feGaussianBlur = feGaussianBlur;
	    filter.appendChild(feGaussianBlur);
	
	    var feOffset = createNS('feOffset');
	    feOffset.setAttribute('dx','25');
	    feOffset.setAttribute('dy','0');
	    feOffset.setAttribute('in','drop_shadow_1');
	    feOffset.setAttribute('result','drop_shadow_2');
	    this.feOffset = feOffset;
	    filter.appendChild(feOffset);
	    var feFlood = createNS('feFlood');
	    feFlood.setAttribute('flood-color','#00ff00');
	    feFlood.setAttribute('flood-opacity','1');
	    feFlood.setAttribute('result','drop_shadow_3');
	    this.feFlood = feFlood;
	    filter.appendChild(feFlood);
	
	    var feComposite = createNS('feComposite');
	    feComposite.setAttribute('in','drop_shadow_3');
	    feComposite.setAttribute('in2','drop_shadow_2');
	    feComposite.setAttribute('operator','in');
	    feComposite.setAttribute('result','drop_shadow_4');
	    filter.appendChild(feComposite);
	
	
	    var feMerge = createNS('feMerge');
	    filter.appendChild(feMerge);
	    var feMergeNode;
	    feMergeNode = createNS('feMergeNode');
	    feMerge.appendChild(feMergeNode);
	    feMergeNode = createNS('feMergeNode');
	    feMergeNode.setAttribute('in','SourceGraphic');
	    this.feMergeNode = feMergeNode;
	    this.feMerge = feMerge;
	    this.originalNodeAdded = false;
	    feMerge.appendChild(feMergeNode);
	}
	
	SVGDropShadowEffect.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        if(forceRender || this.filterManager.effectElements[4].p._mdf){
	            this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
	        }
	        if(forceRender || this.filterManager.effectElements[0].p._mdf){
	            var col = this.filterManager.effectElements[0].p.v;
	            this.feFlood.setAttribute('flood-color',rgbToHex(Math.round(col[0]*255),Math.round(col[1]*255),Math.round(col[2]*255)));
	        }
	        if(forceRender || this.filterManager.effectElements[1].p._mdf){
	            this.feFlood.setAttribute('flood-opacity',this.filterManager.effectElements[1].p.v/255);
	        }
	        if(forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf){
	            var distance = this.filterManager.effectElements[3].p.v;
	            var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
	            var x = distance * Math.cos(angle);
	            var y = distance * Math.sin(angle);
	            this.feOffset.setAttribute('dx', x);
	            this.feOffset.setAttribute('dy', y);
	        }
	        /*if(forceRender || this.filterManager.effectElements[5].p._mdf){
	            if(this.filterManager.effectElements[5].p.v === 1 && this.originalNodeAdded) {
	                this.feMerge.removeChild(this.feMergeNode);
	                this.originalNodeAdded = false;
	            } else if(this.filterManager.effectElements[5].p.v === 0 && !this.originalNodeAdded) {
	                this.feMerge.appendChild(this.feMergeNode);
	                this.originalNodeAdded = true;
	            }
	        }*/
	    }
	};
	var _svgMatteSymbols = [];
	
	function SVGMatte3Effect(filterElem, filterManager, elem){
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.filterElem = filterElem;
	    this.elem = elem;
	    elem.matteElement = createNS('g');
	    elem.matteElement.appendChild(elem.layerElement);
	    elem.matteElement.appendChild(elem.transformedElement);
	    elem.baseElement = elem.matteElement;
	}
	
	SVGMatte3Effect.prototype.findSymbol = function(mask) {
	    var i = 0, len = _svgMatteSymbols.length;
	    while(i < len) {
	        if(_svgMatteSymbols[i] === mask) {
	            return _svgMatteSymbols[i];
	        }
	        i += 1;
	    }
	    return null;
	};
	
	SVGMatte3Effect.prototype.replaceInParent = function(mask, symbolId) {
	    var parentNode = mask.layerElement.parentNode;
	    if(!parentNode) {
	        return;
	    }
	    var children = parentNode.children;
	    var i = 0, len = children.length;
	    while (i < len) {
	        if (children[i] === mask.layerElement) {
	            break;
	        }
	        i += 1;
	    }
	    var nextChild;
	    if (i <= len - 2) {
	        nextChild = children[i + 1];
	    }
	    var useElem = createNS('use');
	    useElem.setAttribute('href', '#' + symbolId);
	    if(nextChild) {
	        parentNode.insertBefore(useElem, nextChild);
	    } else {
	        parentNode.appendChild(useElem);
	    }
	};
	
	SVGMatte3Effect.prototype.setElementAsMask = function(elem, mask) {
	    if(!this.findSymbol(mask)) {
	        var symbolId = createElementID();
	        var masker = createNS('mask');
	        masker.setAttribute('id', mask.layerId);
	        masker.setAttribute('mask-type', 'alpha');
	        _svgMatteSymbols.push(mask);
	        var defs = elem.globalData.defs;
	        defs.appendChild(masker);
	        var symbol = createNS('symbol');
	        symbol.setAttribute('id', symbolId);
	        this.replaceInParent(mask, symbolId);
	        symbol.appendChild(mask.layerElement);
	        defs.appendChild(symbol);
	        var useElem = createNS('use');
	        useElem.setAttribute('href', '#' + symbolId);
	        masker.appendChild(useElem);
	        mask.data.hd = false;
	        mask.show();
	    }
	    elem.setMatte(mask.layerId);
	};
	
	SVGMatte3Effect.prototype.initialize = function() {
	    var ind = this.filterManager.effectElements[0].p.v;
	    var elements = this.elem.comp.elements;
	    var i = 0, len = elements.length;
	    while (i < len) {
	    	if (elements[i] && elements[i].data.ind === ind) {
	    		this.setElementAsMask(this.elem, elements[i]);
	    	}
	    	i += 1;
	    }
	    this.initialized = true;
	};
	
	SVGMatte3Effect.prototype.renderFrame = function() {
		if(!this.initialized) {
			this.initialize();
		}
	};
	function SVGEffects(elem){
	    var i, len = elem.data.ef ? elem.data.ef.length : 0;
	    var filId = createElementID();
	    var fil = filtersFactory.createFilter(filId);
	    var count = 0;
	    this.filters = [];
	    var filterManager;
	    for(i=0;i<len;i+=1){
	        filterManager = null;
	        if(elem.data.ef[i].ty === 20){
	            count += 1;
	            filterManager = new SVGTintFilter(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 21){
	            count += 1;
	            filterManager = new SVGFillFilter(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 22){
	            filterManager = new SVGStrokeEffect(elem, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 23){
	            count += 1;
	            filterManager = new SVGTritoneFilter(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 24){
	            count += 1;
	            filterManager = new SVGProLevelsFilter(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 25){
	            count += 1;
	            filterManager = new SVGDropShadowEffect(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 28){
	            //count += 1;
	            filterManager = new SVGMatte3Effect(fil, elem.effectsManager.effectElements[i], elem);
	        }
	        if(filterManager) {
	            this.filters.push(filterManager);
	        }
	    }
	    if(count){
	        elem.globalData.defs.appendChild(fil);
	        elem.layerElement.setAttribute('filter','url(' + locationHref + '#'+filId+')');
	    }
	    if (this.filters.length) {
	        elem.addRenderableComponent(this);
	    }
	}
	
	SVGEffects.prototype.renderFrame = function(_isFirstFrame){
	    var i, len = this.filters.length;
	    for(i=0;i<len;i+=1){
	        this.filters[i].renderFrame(_isFirstFrame);
	    }
	};
	function CVContextData() {
		this.saved = [];
	    this.cArrPos = 0;
	    this.cTr = new Matrix();
	    this.cO = 1;
	    var i, len = 15;
	    this.savedOp = createTypedArray('float32', len);
	    for(i=0;i<len;i+=1){
	        this.saved[i] = createTypedArray('float32', 16);
	    }
	    this._length = len;
	}
	
	CVContextData.prototype.duplicate = function() {
		var newLength = this._length * 2;
		var currentSavedOp = this.savedOp;
	    this.savedOp = createTypedArray('float32', newLength);
	    this.savedOp.set(currentSavedOp);
	    var i = 0;
	    for(i = this._length; i < newLength; i += 1) {
	        this.saved[i] = createTypedArray('float32', 16);
	    }
	    this._length = newLength;
	};
	
	CVContextData.prototype.reset = function() {
		this.cArrPos = 0;
		this.cTr.reset();
	    this.cO = 1;
	};
	function CVBaseElement(){
	}
	
	CVBaseElement.prototype = {
	    createElements: function(){},
	    initRendererElement: function(){},
	    createContainerElements: function(){
	        this.canvasContext = this.globalData.canvasContext;
	        this.renderableEffectsManager = new CVEffects(this);
	    },
	    createContent: function(){},
	    setBlendMode: function(){
	        var globalData = this.globalData;
	        if(globalData.blendMode !== this.data.bm) {
	            globalData.blendMode = this.data.bm;
	            var blendModeValue = getBlendMode(this.data.bm);
	            globalData.canvasContext.globalCompositeOperation = blendModeValue;
	        }
	    },
	    createRenderableComponents: function(){
	        this.maskManager = new CVMaskElement(this.data, this);
	    },
	    hideElement: function(){
	        if (!this.hidden && (!this.isInRange || this.isTransparent)) {
	            this.hidden = true;
	        }
	    },
	    showElement: function(){
	        if (this.isInRange && !this.isTransparent){
	            this.hidden = false;
	            this._isFirstFrame = true;
	            this.maskManager._isFirstFrame = true;
	        }
	    },
	    renderFrame: function() {
	        if (this.hidden || this.data.hd) {
	            return;
	        }
	        this.renderTransform();
	        this.renderRenderable();
	        this.setBlendMode();
	        this.globalData.renderer.save();
	        this.globalData.renderer.ctxTransform(this.finalTransform.mat.props);
	        this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v);
	        this.renderInnerContent();
	        this.globalData.renderer.restore();
	        if(this.maskManager.hasMasks) {
	            this.globalData.renderer.restore(true);
	        }
	        if (this._isFirstFrame) {
	            this._isFirstFrame = false;
	        }
	    },
	    destroy: function(){
	        this.canvasContext = null;
	        this.data = null;
	        this.globalData = null;
	        this.maskManager.destroy();
	    },
	    mHelper: new Matrix()
	};
	CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
	CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
	
	function CVImageElement(data, globalData, comp){
	    this.failed = false;
	    this.assetData = globalData.getAssetData(data.refId);
	    this.img = globalData.imageLoader.getImage(this.assetData);
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement);
	
	CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
	CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
	
	CVImageElement.prototype.createContent = function(){
	
	    if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
	        var canvas = createTag('canvas');
	        canvas.width = this.assetData.w;
	        canvas.height = this.assetData.h;
	        var ctx = canvas.getContext('2d');
	
	        var imgW = this.img.width;
	        var imgH = this.img.height;
	        var imgRel = imgW / imgH;
	        var canvasRel = this.assetData.w/this.assetData.h;
	        var widthCrop, heightCrop;
	        var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
	        if((imgRel > canvasRel && par === 'xMidYMid slice') || (imgRel < canvasRel && par !== 'xMidYMid slice')) {
	            heightCrop = imgH;
	            widthCrop = heightCrop*canvasRel;
	        } else {
	            widthCrop = imgW;
	            heightCrop = widthCrop/canvasRel;
	        }
	        ctx.drawImage(this.img,(imgW-widthCrop)/2,(imgH-heightCrop)/2,widthCrop,heightCrop,0,0,this.assetData.w,this.assetData.h);
	        this.img = canvas;
	    }
	
	};
	
	CVImageElement.prototype.renderInnerContent = function(parentMatrix){
	    if (this.failed) {
	        return;
	    }
	    this.canvasContext.drawImage(this.img, 0, 0);
	};
	
	CVImageElement.prototype.destroy = function(){
	    this.img = null;
	};
	function CVCompElement(data, globalData, comp) {
	    this.completeLayers = false;
	    this.layers = data.layers;
	    this.pendingElements = [];
	    this.elements = createSizedArray(this.layers.length);
	    this.initElement(data, globalData, comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this,data.tm,0,globalData.frameRate, this) : {_placeholder:true};
	}
	
	extendPrototype([CanvasRenderer, ICompElement, CVBaseElement], CVCompElement);
	
	CVCompElement.prototype.renderInnerContent = function() {
	    var i,len = this.layers.length;
	    for( i = len - 1; i >= 0; i -= 1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	};
	
	CVCompElement.prototype.destroy = function(){
	    var i,len = this.layers.length;
	    for( i = len - 1; i >= 0; i -= 1 ){
	        if(this.elements[i]) {
	            this.elements[i].destroy();
	        }
	    }
	    this.layers = null;
	    this.elements = null;
	};
	
	function CVMaskElement(data,element){
	    this.data = data;
	    this.element = element;
	    this.masksProperties = this.data.masksProperties || [];
	    this.viewData = createSizedArray(this.masksProperties.length);
	    var i, len = this.masksProperties.length, hasMasks = false;
	    for (i = 0; i < len; i++) {
	        if(this.masksProperties[i].mode !== 'n'){
	            hasMasks = true;
	        }
	        this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element,this.masksProperties[i],3);
	    }
	    this.hasMasks = hasMasks;
	    if(hasMasks) {
	        this.element.addRenderableComponent(this);
	    }
	}
	
	CVMaskElement.prototype.renderFrame = function () {
	    if(!this.hasMasks){
	        return;
	    }
	    var transform = this.element.finalTransform.mat;
	    var ctx = this.element.canvasContext;
	    var i, len = this.masksProperties.length;
	    var pt,pts,data;
	    ctx.beginPath();
	    for (i = 0; i < len; i++) {
	        if(this.masksProperties[i].mode !== 'n'){
	            if (this.masksProperties[i].inv) {
	                ctx.moveTo(0, 0);
	                ctx.lineTo(this.element.globalData.compSize.w, 0);
	                ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
	                ctx.lineTo(0, this.element.globalData.compSize.h);
	                ctx.lineTo(0, 0);
	            }
	            data = this.viewData[i].v;
	            pt = transform.applyToPointArray(data.v[0][0],data.v[0][1],0);
	            ctx.moveTo(pt[0], pt[1]);
	            var j, jLen = data._length;
	            for (j = 1; j < jLen; j++) {
	                pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
	                ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
	            }
	            pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
	            ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
	        }
	    }
	    this.element.globalData.renderer.save(true);
	    ctx.clip();
	};
	
	CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
	
	CVMaskElement.prototype.destroy = function(){
	    this.element = null;
	};
	function CVShapeElement(data, globalData, comp) {
	    this.shapes = [];
	    this.shapesData = data.shapes;
	    this.stylesList = [];
	    this.itemsData = [];
	    this.prevViewData = [];
	    this.shapeModifiers = [];
	    this.processedElements = [];
	    this.transformsManager = new ShapeTransformManager();
	    this.initElement(data, globalData, comp);
	}
	
	extendPrototype([BaseElement,TransformElement,CVBaseElement,IShapeElement,HierarchyElement,FrameElement,RenderableElement], CVShapeElement);
	
	CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
	
	CVShapeElement.prototype.transformHelper = {opacity:1,_opMdf:false};
	
	CVShapeElement.prototype.dashResetter = [];
	
	CVShapeElement.prototype.createContent = function(){
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData, true, []);
	};
	
	CVShapeElement.prototype.createStyleElement = function(data, transforms) {
	    var styleElem = {
	        data: data,
	        type: data.ty,
	        preTransforms: this.transformsManager.addTransformSequence(transforms),
	        transforms: [],
	        elements: [],
	        closed: data.hd === true
	    };
	    var elementData = {};
	    if(data.ty == 'fl' || data.ty == 'st'){
	        elementData.c = PropertyFactory.getProp(this,data.c,1,255,this);
	        if(!elementData.c.k){
	            styleElem.co = 'rgb('+bm_floor(elementData.c.v[0])+','+bm_floor(elementData.c.v[1])+','+bm_floor(elementData.c.v[2])+')';
	        }
	    } else if (data.ty === 'gf' || data.ty === 'gs') {
	        elementData.s = PropertyFactory.getProp(this,data.s,1,null,this);
	        elementData.e = PropertyFactory.getProp(this,data.e,1,null,this);
	        elementData.h = PropertyFactory.getProp(this,data.h||{k:0},0,0.01,this);
	        elementData.a = PropertyFactory.getProp(this,data.a||{k:0},0,degToRads,this);
	        elementData.g = new GradientProperty(this,data.g,this);
	    }
	    elementData.o = PropertyFactory.getProp(this,data.o,0,0.01,this);
	    if(data.ty == 'st' || data.ty == 'gs') {
	        styleElem.lc = this.lcEnum[data.lc] || 'round';
	        styleElem.lj = this.ljEnum[data.lj] || 'round';
	        if(data.lj == 1) {
	            styleElem.ml = data.ml;
	        }
	        elementData.w = PropertyFactory.getProp(this,data.w,0,null,this);
	        if(!elementData.w.k){
	            styleElem.wi = elementData.w.v;
	        }
	        if(data.d){
	            var d = new DashProperty(this,data.d,'canvas');
	            elementData.d = d;
	            if(!elementData.d.k){
	                styleElem.da = elementData.d.dashArray;
	                styleElem.do = elementData.d.dashoffset[0];
	            }
	        }
	    } else {
	        styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
	    }
	    this.stylesList.push(styleElem);
	    elementData.style = styleElem;
	    return elementData;
	};
	
	CVShapeElement.prototype.createGroupElement = function(data) {
	    var elementData = {
	        it: [],
	        prevViewData: []
	    };
	    return elementData;
	};
	
	CVShapeElement.prototype.createTransformElement = function(data) {
	    var elementData = {
	        transform : {
	            opacity: 1,
	            _opMdf:false,
	            key: this.transformsManager.getNewKey(),
	            op: PropertyFactory.getProp(this,data.o,0,0.01,this),
	            mProps: TransformPropertyFactory.getTransformProperty(this,data,this)
	        }
	    };
	    return elementData;
	};
	
	CVShapeElement.prototype.createShapeElement = function(data) {
	    var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
	    
	    this.shapes.push(elementData);
	    this.addShapeToModifiers(elementData);
	    return elementData;
	};
	
	CVShapeElement.prototype.reloadShapes = function() {
	    this._isFirstFrame = true;
	    var i, len = this.itemsData.length;
	    for (i = 0; i < len; i += 1) {
	        this.prevViewData[i] = this.itemsData[i];
	    }
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData, true, []);
	    len = this.dynamicProperties.length;
	    for (i = 0; i < len; i += 1) {
	        this.dynamicProperties[i].getValue();
	    }
	    this.renderModifiers();
	    this.transformsManager.processSequences(this._isFirstFrame);
	};
	
	CVShapeElement.prototype.addTransformToStyleList = function(transform) {
	    var i, len = this.stylesList.length;
	    for (i = 0; i < len; i += 1) {
	        if(!this.stylesList[i].closed) {
	            this.stylesList[i].transforms.push(transform);
	        }
	    }
	}
	
	CVShapeElement.prototype.removeTransformFromStyleList = function() {
	    var i, len = this.stylesList.length;
	    for (i = 0; i < len; i += 1) {
	        if(!this.stylesList[i].closed) {
	            this.stylesList[i].transforms.pop();
	        }
	    }
	}
	
	CVShapeElement.prototype.closeStyles = function(styles) {
	    var i, len = styles.length, j, jLen;
	    for (i = 0; i < len; i += 1) {
	        styles[i].closed = true;
	    }
	}
	
	CVShapeElement.prototype.searchShapes = function(arr,itemsData, prevViewData, shouldRender, transforms){
	    var i, len = arr.length - 1;
	    var j, jLen;
	    var ownStyles = [], ownModifiers = [], processedPos, modifier, currentTransform;
	    var ownTransforms = [].concat(transforms);
	    for(i=len;i>=0;i-=1){
	        processedPos = this.searchProcessedElement(arr[i]);
	        if(!processedPos){
	            arr[i]._shouldRender = shouldRender;
	        } else {
	            itemsData[i] = prevViewData[processedPos - 1];
	        }
	        if(arr[i].ty == 'fl' || arr[i].ty == 'st'|| arr[i].ty == 'gf'|| arr[i].ty == 'gs'){
	            if(!processedPos){
	                itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
	            } else {
	                itemsData[i].style.closed = false;
	            }
	            
	            ownStyles.push(itemsData[i].style);
	        }else if(arr[i].ty == 'gr'){
	            if(!processedPos){
	                itemsData[i] = this.createGroupElement(arr[i]);
	            } else {
	                jLen = itemsData[i].it.length;
	                for(j=0;j<jLen;j+=1){
	                    itemsData[i].prevViewData[j] = itemsData[i].it[j];
	                }
	            }
	            this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData, shouldRender, ownTransforms);
	        }else if(arr[i].ty == 'tr'){
	            if(!processedPos){
	                currentTransform = this.createTransformElement(arr[i]);
	                itemsData[i] = currentTransform;
	            }
	            ownTransforms.push(itemsData[i]);
	            this.addTransformToStyleList(itemsData[i]);
	        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
	            if(!processedPos){
	                itemsData[i] = this.createShapeElement(arr[i]);
	            }
	            
	        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                modifier.init(this,arr[i]);
	                itemsData[i] = modifier;
	                this.shapeModifiers.push(modifier);
	            } else {
	                modifier = itemsData[i];
	                modifier.closed = false;
	            }
	            ownModifiers.push(modifier);
	        } else if(arr[i].ty == 'rp'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                itemsData[i] = modifier;
	                modifier.init(this,arr,i,itemsData);
	                this.shapeModifiers.push(modifier);
	                shouldRender = false;
	            }else{
	                modifier = itemsData[i];
	                modifier.closed = true;
	            }
	            ownModifiers.push(modifier);
	        }
	        this.addProcessedElement(arr[i], i + 1);
	    }
	    this.removeTransformFromStyleList();
	    this.closeStyles(ownStyles);
	    len = ownModifiers.length;
	    for(i=0;i<len;i+=1){
	        ownModifiers[i].closed = true;
	    }
	};
	
	CVShapeElement.prototype.renderInnerContent = function() {
	    this.transformHelper.opacity = 1;
	    this.transformHelper._opMdf = false;
	    this.renderModifiers();
	    this.transformsManager.processSequences(this._isFirstFrame);
	    this.renderShape(this.transformHelper,this.shapesData,this.itemsData,true);
	};
	
	CVShapeElement.prototype.renderShapeTransform = function(parentTransform, groupTransform) {
	    var props, groupMatrix;
	    if(parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
	        groupTransform.opacity = parentTransform.opacity;
	        groupTransform.opacity *= groupTransform.op.v;
	        groupTransform._opMdf = true;
	    }
	};
	
	CVShapeElement.prototype.drawLayer = function() {
	    var i, len = this.stylesList.length;
	    var j, jLen, k, kLen,elems,nodes, renderer = this.globalData.renderer, ctx = this.globalData.canvasContext, type, currentStyle;
	    for(i=0;i<len;i+=1){
	        currentStyle = this.stylesList[i];
	        type = currentStyle.type;
	
	        //Skipping style when
	        //Stroke width equals 0
	        //style should not be rendered (extra unused repeaters)
	        //current opacity equals 0
	        //global opacity equals 0
	        if(((type === 'st' || type === 'gs') && currentStyle.wi === 0) || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0){
	            continue;
	        }
	        renderer.save();
	        elems = currentStyle.elements;
	        if(type === 'st' || type === 'gs'){
	            ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
	            ctx.lineWidth = currentStyle.wi;
	            ctx.lineCap = currentStyle.lc;
	            ctx.lineJoin = currentStyle.lj;
	            ctx.miterLimit = currentStyle.ml || 0;
	        } else {
	            ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
	        }
	        renderer.ctxOpacity(currentStyle.coOp);
	        if(type !== 'st' && type !== 'gs'){
	            ctx.beginPath();
	        }
	        renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
	        jLen = elems.length;
	        for(j=0;j<jLen;j+=1){
	            if(type === 'st' || type === 'gs'){
	                ctx.beginPath();
	                if(currentStyle.da){
	                    ctx.setLineDash(currentStyle.da);
	                    ctx.lineDashOffset = currentStyle.do;
	                }
	            }
	            nodes = elems[j].trNodes;
	            kLen = nodes.length;
	
	            for(k=0;k<kLen;k+=1){
	                if(nodes[k].t == 'm'){
	                    ctx.moveTo(nodes[k].p[0],nodes[k].p[1]);
	                }else if(nodes[k].t == 'c'){
	                    ctx.bezierCurveTo(nodes[k].pts[0],nodes[k].pts[1],nodes[k].pts[2],nodes[k].pts[3],nodes[k].pts[4],nodes[k].pts[5]);
	                }else{
	                    ctx.closePath();
	                }
	            }
	            if(type === 'st' || type === 'gs'){
	                ctx.stroke();
	                if(currentStyle.da){
	                    ctx.setLineDash(this.dashResetter);
	                }
	            }
	        }
	        if(type !== 'st' && type !== 'gs'){
	            ctx.fill(currentStyle.r);
	        }
	        renderer.restore();
	    }
	};
	
	CVShapeElement.prototype.renderShape = function(parentTransform,items,data,isMain){
	    var i, len = items.length - 1;
	    var groupTransform;
	    groupTransform = parentTransform;
	    for(i=len;i>=0;i-=1){
	        if(items[i].ty == 'tr'){
	            groupTransform = data[i].transform;
	            this.renderShapeTransform(parentTransform, groupTransform);
	        }else if(items[i].ty == 'sh' || items[i].ty == 'el' || items[i].ty == 'rc' || items[i].ty == 'sr'){
	            this.renderPath(items[i],data[i]);
	        }else if(items[i].ty == 'fl'){
	            this.renderFill(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'st'){
	            this.renderStroke(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'gf' || items[i].ty == 'gs'){
	            this.renderGradientFill(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'gr'){
	            this.renderShape(groupTransform,items[i].it,data[i].it);
	        }else if(items[i].ty == 'tm'){
	            //
	        }
	    }
	    if(isMain){
	        this.drawLayer();
	    }
	    
	};
	
	CVShapeElement.prototype.renderStyledShape = function(styledShape, shape){
	    if(this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
	        var shapeNodes = styledShape.trNodes;
	        var paths = shape.paths;
	        var i, len, j, jLen = paths._length;
	        shapeNodes.length = 0;
	        var groupTransformMat = styledShape.transforms.finalTransform;
	        for (j = 0; j < jLen; j += 1) {
	            var pathNodes = paths.shapes[j];
	            if(pathNodes && pathNodes.v){
	                len = pathNodes._length;
	                for (i = 1; i < len; i += 1) {
	                    if (i === 1) {
	                        shapeNodes.push({
	                            t: 'm',
	                            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	                        });
	                    }
	                    shapeNodes.push({
	                        t: 'c',
	                        pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
	                    });
	                }
	                if (len === 1) {
	                    shapeNodes.push({
	                        t: 'm',
	                        p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	                    });
	                }
	                if (pathNodes.c && len) {
	                    shapeNodes.push({
	                        t: 'c',
	                        pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
	                    });
	                    shapeNodes.push({
	                        t: 'z'
	                    });
	                }
	            }
	        }
	        styledShape.trNodes = shapeNodes;
	    }
	}
	
	CVShapeElement.prototype.renderPath = function(pathData,itemData){
	    if(pathData.hd !== true && pathData._shouldRender) {
	        var i, len = itemData.styledShapes.length;
	        for (i = 0; i < len; i += 1) {
	            this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
	        }
	    }
	};
	
	CVShapeElement.prototype.renderFill = function(styleData,itemData, groupTransform){
	    var styleElem = itemData.style;
	
	    if (itemData.c._mdf || this._isFirstFrame) {
	        styleElem.co = 'rgb(' 
	        + bm_floor(itemData.c.v[0]) + ',' 
	        + bm_floor(itemData.c.v[1]) + ',' 
	        + bm_floor(itemData.c.v[2]) + ')';
	    }
	    if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
	        styleElem.coOp = itemData.o.v * groupTransform.opacity;
	    }
	};
	
	CVShapeElement.prototype.renderGradientFill = function(styleData,itemData, groupTransform){
	    var styleElem = itemData.style;
	    if(!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || (styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf))) {
	        var ctx = this.globalData.canvasContext;
	        var grd;
	        var pt1 = itemData.s.v, pt2 = itemData.e.v;
	        if (styleData.t === 1) {
	            grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
	        } else {
	            var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
	            var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
	
	            var percent = itemData.h.v >= 1 ? 0.99 : itemData.h.v <= -1 ? -0.99: itemData.h.v;
	            var dist = rad * percent;
	            var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
	            var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
	            var grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
	        }
	
	        var i, len = styleData.g.p;
	        var cValues = itemData.g.c;
	        var opacity = 1;
	
	        for (i = 0; i < len; i += 1){
	            if(itemData.g._hasOpacity && itemData.g._collapsable) {
	                opacity = itemData.g.o[i*2 + 1];
	            }
	            grd.addColorStop(cValues[i * 4] / 100,'rgba('+ cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ','+cValues[i * 4 + 3] + ',' + opacity + ')');
	        }
	        styleElem.grd = grd;
	    }
	    styleElem.coOp = itemData.o.v*groupTransform.opacity;
	    
	};
	
	CVShapeElement.prototype.renderStroke = function(styleData,itemData, groupTransform){
	    var styleElem = itemData.style;
	    var d = itemData.d;
	    if(d && (d._mdf  || this._isFirstFrame)){
	        styleElem.da = d.dashArray;
	        styleElem.do = d.dashoffset[0];
	    }
	    if(itemData.c._mdf || this._isFirstFrame){
	        styleElem.co = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
	    }
	    if(itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame){
	        styleElem.coOp = itemData.o.v*groupTransform.opacity;
	    }
	    if(itemData.w._mdf || this._isFirstFrame){
	        styleElem.wi = itemData.w.v;
	    }
	};
	
	
	CVShapeElement.prototype.destroy = function(){
	    this.shapesData = null;
	    this.globalData = null;
	    this.canvasContext = null;
	    this.stylesList.length = 0;
	    this.itemsData.length = 0;
	};
	
	
	function CVSolidElement(data, globalData, comp) {
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement);
	
	CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
	CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
	
	CVSolidElement.prototype.renderInnerContent = function() {
	    var ctx = this.canvasContext;
	    ctx.fillStyle = this.data.sc;
	    ctx.fillRect(0, 0, this.data.sw, this.data.sh);
	    //
	};
	function CVTextElement(data, globalData, comp){
	    this.textSpans = [];
	    this.yOffset = 0;
	    this.fillColorAnim = false;
	    this.strokeColorAnim = false;
	    this.strokeWidthAnim = false;
	    this.stroke = false;
	    this.fill = false;
	    this.justifyOffset = 0;
	    this.currentRender = null;
	    this.renderType = 'canvas';
	    this.values = {
	        fill: 'rgba(0,0,0,0)',
	        stroke: 'rgba(0,0,0,0)',
	        sWidth: 0,
	        fValue: ''
	    };
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([BaseElement,TransformElement,CVBaseElement,HierarchyElement,FrameElement,RenderableElement,ITextElement], CVTextElement);
	
	CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');
	
	CVTextElement.prototype.buildNewText = function(){
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
	
	    var hasFill = false;
	    if(documentData.fc) {
	        hasFill = true;
	        this.values.fill = this.buildColor(documentData.fc);
	    }else{
	        this.values.fill = 'rgba(0,0,0,0)';
	    }
	    this.fill = hasFill;
	    var hasStroke = false;
	    if(documentData.sc){
	        hasStroke = true;
	        this.values.stroke = this.buildColor(documentData.sc);
	        this.values.sWidth = documentData.sw;
	    }
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    var i, len;
	    var letters = documentData.l;
	    var matrixHelper = this.mHelper;
	    this.stroke = hasStroke;
	    this.values.fValue = documentData.finalSize + 'px '+ this.globalData.fontManager.getFontByName(documentData.f).fFamily;
	    len = documentData.finalText.length;
	    //this.tHelper.font = this.values.fValue;
	    var charData, shapeData, k, kLen, shapes, j, jLen, pathNodes, commands, pathArr, singleShape = this.data.singleShape;
	    var trackingOffset = documentData.tr/1000*documentData.finalSize;
	    var xPos = 0, yPos = 0, firstLine = true;
	    var cnt = 0;
	    for (i = 0; i < len; i += 1) {
	        charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	        shapeData = charData && charData.data || {};
	        matrixHelper.reset();
	        if(singleShape && letters[i].n) {
	            xPos = -trackingOffset;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            firstLine = false;
	        }
	
	        shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
	        jLen = shapes.length;
	        matrixHelper.scale(documentData.finalSize/100,documentData.finalSize/100);
	        if(singleShape){
	            this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	        }
	        commands = createSizedArray(jLen);
	        for(j=0;j<jLen;j+=1){
	            kLen = shapes[j].ks.k.i.length;
	            pathNodes = shapes[j].ks.k;
	            pathArr = [];
	            for(k=1;k<kLen;k+=1){
	                if(k==1){
	                    pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
	                }
	                pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToY(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToX(pathNodes.v[k][0],pathNodes.v[k][1],0),matrixHelper.applyToY(pathNodes.v[k][0],pathNodes.v[k][1],0));
	            }
	            pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToY(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
	            commands[j] = pathArr;
	        }
	        if(singleShape){
	            xPos += letters[i].l;
	            xPos += trackingOffset;
	        }
	        if(this.textSpans[cnt]){
	            this.textSpans[cnt].elem = commands;
	        } else {
	            this.textSpans[cnt] = {elem: commands};
	        }
	        cnt +=1;
	    }
	};
	
	CVTextElement.prototype.renderInnerContent = function(){
	    var ctx = this.canvasContext;
	    var finalMat = this.finalTransform.mat.props;
	    ctx.font = this.values.fValue;
	    ctx.lineCap = 'butt';
	    ctx.lineJoin = 'miter';
	    ctx.miterLimit = 4;
	
	    if(!this.data.singleShape){
	        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	    }
	
	    var  i,len, j, jLen, k, kLen;
	    var renderedLetters = this.textAnimator.renderedLetters;
	
	    var letters = this.textProperty.currentData.l;
	
	    len = letters.length;
	    var renderedLetter;
	    var lastFill = null, lastStroke = null, lastStrokeW = null, commands, pathArr;
	    for(i=0;i<len;i+=1){
	        if(letters[i].n){
	            continue;
	        }
	        renderedLetter = renderedLetters[i];
	        if(renderedLetter){
	            this.globalData.renderer.save();
	            this.globalData.renderer.ctxTransform(renderedLetter.p);
	            this.globalData.renderer.ctxOpacity(renderedLetter.o);
	        }
	        if(this.fill){
	            if(renderedLetter && renderedLetter.fc){
	                if(lastFill !== renderedLetter.fc){
	                    lastFill = renderedLetter.fc;
	                    ctx.fillStyle = renderedLetter.fc;
	                }
	            }else if(lastFill !== this.values.fill){
	                lastFill = this.values.fill;
	                ctx.fillStyle = this.values.fill;
	            }
	            commands = this.textSpans[i].elem;
	            jLen = commands.length;
	            this.globalData.canvasContext.beginPath();
	            for(j=0;j<jLen;j+=1) {
	                pathArr = commands[j];
	                kLen = pathArr.length;
	                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	                for (k = 2; k < kLen; k += 6) {
	                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	                }
	            }
	            this.globalData.canvasContext.closePath();
	            this.globalData.canvasContext.fill();
	            ///ctx.fillText(this.textSpans[i].val,0,0);
	        }
	        if(this.stroke){
	            if(renderedLetter && renderedLetter.sw){
	                if(lastStrokeW !== renderedLetter.sw){
	                    lastStrokeW = renderedLetter.sw;
	                    ctx.lineWidth = renderedLetter.sw;
	                }
	            }else if(lastStrokeW !== this.values.sWidth){
	                lastStrokeW = this.values.sWidth;
	                ctx.lineWidth = this.values.sWidth;
	            }
	            if(renderedLetter && renderedLetter.sc){
	                if(lastStroke !== renderedLetter.sc){
	                    lastStroke = renderedLetter.sc;
	                    ctx.strokeStyle = renderedLetter.sc;
	                }
	            }else if(lastStroke !== this.values.stroke){
	                lastStroke = this.values.stroke;
	                ctx.strokeStyle = this.values.stroke;
	            }
	            commands = this.textSpans[i].elem;
	            jLen = commands.length;
	            this.globalData.canvasContext.beginPath();
	            for(j=0;j<jLen;j+=1) {
	                pathArr = commands[j];
	                kLen = pathArr.length;
	                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	                for (k = 2; k < kLen; k += 6) {
	                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	                }
	            }
	            this.globalData.canvasContext.closePath();
	            this.globalData.canvasContext.stroke();
	            ///ctx.strokeText(letters[i].val,0,0);
	        }
	        if(renderedLetter) {
	            this.globalData.renderer.restore();
	        }
	    }
	};
	function CVEffects() {
	
	}
	CVEffects.prototype.renderFrame = function(){};
	function HBaseElement(data,globalData,comp){}
	HBaseElement.prototype = {
	    checkBlendMode: function(){},
	    initRendererElement: function(){
	        this.baseElement = createTag(this.data.tg || 'div');
	        if(this.data.hasMask) {
	            this.svgElement = createNS('svg');
	            this.layerElement = createNS('g');
	            this.maskedElement = this.layerElement;
	            this.svgElement.appendChild(this.layerElement);
	            this.baseElement.appendChild(this.svgElement);
	        } else {
	            this.layerElement = this.baseElement;
	        }
	        styleDiv(this.baseElement);
	    },
	    createContainerElements: function(){
	        this.renderableEffectsManager = new CVEffects(this);
	        this.transformedElement = this.baseElement;
	        this.maskedElement = this.layerElement;
	        if (this.data.ln) {
	            this.layerElement.setAttribute('id',this.data.ln);
	        }
	        if (this.data.cl) {
	            this.layerElement.setAttribute('class', this.data.cl);
	        }
	        if (this.data.bm !== 0) {
	            this.setBlendMode();
	        }
	    },
	    renderElement: function() {
	        if(this.finalTransform._matMdf){
	            this.transformedElement.style.transform = this.transformedElement.style.webkitTransform = this.finalTransform.mat.toCSS();
	        }
	        if(this.finalTransform._opMdf){
	            this.transformedElement.style.opacity = this.finalTransform.mProp.o.v;
	        }
	    },
	    renderFrame: function() {
	        //If it is exported as hidden (data.hd === true) no need to render
	        //If it is not visible no need to render
	        if (this.data.hd || this.hidden) {
	            return;
	        }
	        this.renderTransform();
	        this.renderRenderable();
	        this.renderElement();
	        this.renderInnerContent();
	        if (this._isFirstFrame) {
	            this._isFirstFrame = false;
	        }
	    },
	    destroy: function(){
	        this.layerElement = null;
	        this.transformedElement = null;
	        if(this.matteElement) {
	            this.matteElement = null;
	        }
	        if(this.maskManager) {
	            this.maskManager.destroy();
	            this.maskManager = null;
	        }
	    },
	    createRenderableComponents: function(){
	        this.maskManager = new MaskElement(this.data, this, this.globalData);
	    },
	    addEffects: function(){
	    },
	    setMatte: function(){}
	};
	HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
	HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
	HBaseElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;
	function HSolidElement(data,globalData,comp){
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([BaseElement,TransformElement,HBaseElement,HierarchyElement,FrameElement,RenderableDOMElement], HSolidElement);
	
	HSolidElement.prototype.createContent = function(){
	    var rect;
	    if(this.data.hasMask){
	        rect = createNS('rect');
	        rect.setAttribute('width',this.data.sw);
	        rect.setAttribute('height',this.data.sh);
	        rect.setAttribute('fill',this.data.sc);
	        this.svgElement.setAttribute('width',this.data.sw);
	        this.svgElement.setAttribute('height',this.data.sh);
	    } else {
	        rect = createTag('div');
	        rect.style.width = this.data.sw + 'px';
	        rect.style.height = this.data.sh + 'px';
	        rect.style.backgroundColor = this.data.sc;
	    }
	    this.layerElement.appendChild(rect);
	};
	
	function HCompElement(data,globalData,comp){
	    this.layers = data.layers;
	    this.supports3d = !data.hasMask;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
	    this.initElement(data,globalData,comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this,data.tm,0,globalData.frameRate,this) : {_placeholder:true};
	}
	
	extendPrototype([HybridRenderer, ICompElement, HBaseElement], HCompElement);
	HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
	
	HCompElement.prototype.createContainerElements = function(){
	    this._createBaseContainerElements();
	    //divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
	    if(this.data.hasMask){
	        this.svgElement.setAttribute('width',this.data.w);
	        this.svgElement.setAttribute('height',this.data.h);
	        this.transformedElement = this.baseElement;
	    } else {
	        this.transformedElement = this.layerElement;
	    }
	};
	
	HCompElement.prototype.addTo3dContainer = function(elem,pos) {
	    var j = 0;
	    var nextElement;
	    while(j<pos){
	        if(this.elements[j] && this.elements[j].getBaseElement){
	            nextElement = this.elements[j].getBaseElement();
	        }
	        j += 1;
	    }
	    if(nextElement){
	        this.layerElement.insertBefore(elem, nextElement);
	    } else {
	        this.layerElement.appendChild(elem);
	    }
	}
	
	function HShapeElement(data,globalData,comp){
	    //List of drawable elements
	    this.shapes = [];
	    // Full shape data
	    this.shapesData = data.shapes;
	    //List of styles that will be applied to shapes
	    this.stylesList = [];
	    //List of modifiers that will be applied to shapes
	    this.shapeModifiers = [];
	    //List of items in shape tree
	    this.itemsData = [];
	    //List of items in previous shape tree
	    this.processedElements = [];
	    // List of animated components
	    this.animatedContents = [];
	    this.shapesContainer = createNS('g');
	    this.initElement(data,globalData,comp);
	    //Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	    // List of elements that have been created
	    this.prevViewData = [];
	    this.currentBBox = {
	        x:999999,
	        y: -999999,
	        h: 0,
	        w: 0
	    };
	}
	extendPrototype([BaseElement,TransformElement,HSolidElement,SVGShapeElement,HBaseElement,HierarchyElement,FrameElement,RenderableElement], HShapeElement);
	HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
	
	HShapeElement.prototype.createContent = function(){
	    var cont;
	    this.baseElement.style.fontSize = 0;
	    if (this.data.hasMask) {
	        this.layerElement.appendChild(this.shapesContainer);
	        cont = this.svgElement;
	    } else {
	        cont = createNS('svg');
	        var size = this.comp.data ? this.comp.data : this.globalData.compSize;
	        cont.setAttribute('width',size.w);
	        cont.setAttribute('height',size.h);
	        cont.appendChild(this.shapesContainer);
	        this.layerElement.appendChild(cont);
	    }
	
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.shapesContainer,0, [], true);
	    this.filterUniqueShapes();
	    this.shapeCont = cont;
	};
	
	HShapeElement.prototype.getTransformedPoint = function(transformers, point) {
	    var i, len = transformers.length;
	    for(i = 0; i < len; i += 1) {
	        point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
	    }
	    return point;
	}
	
	HShapeElement.prototype.calculateShapeBoundingBox = function(item, boundingBox) {
	    var shape = item.sh.v;
	    var transformers = item.transformers;
	    var i, len = shape._length, vPoint, oPoint, nextIPoint, nextVPoint, bounds;
	    if (len <= 1) {
	        return;
	    }
	    for (i = 0; i < len - 1; i += 1) {
	        vPoint = this.getTransformedPoint(transformers, shape.v[i]);
	        oPoint = this.getTransformedPoint(transformers, shape.o[i]);
	        nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
	        nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
	        this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
	    }
	    if(shape.c) {
	        vPoint = this.getTransformedPoint(transformers, shape.v[i]);
	        oPoint = this.getTransformedPoint(transformers, shape.o[i]);
	        nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
	        nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
	        this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
	    }
	}
	
	HShapeElement.prototype.checkBounds = function(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
	    this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
	    var bounds = this.shapeBoundingBox;
	    boundingBox.x = bm_min(bounds.left, boundingBox.x);
	    boundingBox.xMax = bm_max(bounds.right, boundingBox.xMax);
	    boundingBox.y = bm_min(bounds.top, boundingBox.y);
	    boundingBox.yMax = bm_max(bounds.bottom, boundingBox.yMax);
	}
	
	HShapeElement.prototype.shapeBoundingBox = {
	    left:0,
	    right:0,
	    top:0,
	    bottom:0,
	}
	
	HShapeElement.prototype.tempBoundingBox = {
	    x:0,
	    xMax:0,
	    y:0,
	    yMax:0,
	    width:0,
	    height:0
	}
	
	HShapeElement.prototype.getBoundsOfCurve = function(p0, p1, p2, p3) {
	
	    var bounds = [[p0[0],p3[0]], [p0[1],p3[1]]];
	
	    for (var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i) {
	
	      b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
	      a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
	      c = 3 * p1[i] - 3 * p0[i];
	
	      b = b | 0;
	      a = a | 0;
	      c = c | 0;
	
	      if (a === 0) {
	
	        if (b === 0) {
	          continue;
	        }
	
	        t = -c / b;
	
	        if (0 < t && t < 1) {
	          bounds[i].push(this.calculateF(t,p0,p1,p2,p3,i));
	        }
	        continue;
	      }
	
	      b2ac = b * b - 4 * c * a;
	
	      if (b2ac < 0) {
	        continue;
	      }
	
	      t1 = (-b + bm_sqrt(b2ac))/(2 * a);
	      if (0 < t1 && t1 < 1) bounds[i].push(this.calculateF(t1,p0,p1,p2,p3,i));
	
	      t2 = (-b - bm_sqrt(b2ac))/(2 * a);
	      if (0 < t2 && t2 < 1) bounds[i].push(this.calculateF(t2,p0,p1,p2,p3,i));
	
	    }
	
	    this.shapeBoundingBox.left = bm_min.apply(null, bounds[0]);
	    this.shapeBoundingBox.top = bm_min.apply(null, bounds[1]);
	    this.shapeBoundingBox.right = bm_max.apply(null, bounds[0]);
	    this.shapeBoundingBox.bottom = bm_max.apply(null, bounds[1]);
	  };
	
	  HShapeElement.prototype.calculateF = function(t, p0, p1, p2, p3, i) {
	    return bm_pow(1-t, 3) * p0[i]
	        + 3 * bm_pow(1-t, 2) * t * p1[i]
	        + 3 * (1-t) * bm_pow(t, 2) * p2[i]
	        + bm_pow(t, 3) * p3[i];
	  }
	
	HShapeElement.prototype.calculateBoundingBox = function(itemsData, boundingBox) {
	    var i, len = itemsData.length, path;
	    for(i = 0; i < len; i += 1) {
	        if(itemsData[i] && itemsData[i].sh) {
	            this.calculateShapeBoundingBox(itemsData[i], boundingBox)
	        } else if(itemsData[i] && itemsData[i].it) {
	            this.calculateBoundingBox(itemsData[i].it, boundingBox)
	        }
	    }
	}
	
	HShapeElement.prototype.currentBoxContains = function(box) {
	    return this.currentBBox.x <= box.x 
	    && this.currentBBox.y <= box.y 
	    && this.currentBBox.width + this.currentBBox.x >= box.x + box.width
	    && this.currentBBox.height + this.currentBBox.y >= box.y + box.height
	}
	
	HShapeElement.prototype.renderInnerContent = function() {
	    this._renderShapeFrame();
	
	    if(!this.hidden && (this._isFirstFrame || this._mdf)) {
	        var tempBoundingBox = this.tempBoundingBox;
	        var max = 999999;
	        tempBoundingBox.x = max;
	        tempBoundingBox.xMax = -max;
	        tempBoundingBox.y = max;
	        tempBoundingBox.yMax = -max;
	        this.calculateBoundingBox(this.itemsData, tempBoundingBox);
	        tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
	        tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y;
	        //var tempBoundingBox = this.shapeCont.getBBox();
	        if(this.currentBoxContains(tempBoundingBox)) {
	            return;
	        }
	        var changed = false;
	        if(this.currentBBox.w !== tempBoundingBox.width){
	            this.currentBBox.w = tempBoundingBox.width;
	            this.shapeCont.setAttribute('width',tempBoundingBox.width);
	            changed = true;
	        }
	        if(this.currentBBox.h !== tempBoundingBox.height){
	            this.currentBBox.h = tempBoundingBox.height;
	            this.shapeCont.setAttribute('height',tempBoundingBox.height);
	            changed = true;
	        }
	        if(changed  || this.currentBBox.x !== tempBoundingBox.x  || this.currentBBox.y !== tempBoundingBox.y){
	            this.currentBBox.w = tempBoundingBox.width;
	            this.currentBBox.h = tempBoundingBox.height;
	            this.currentBBox.x = tempBoundingBox.x;
	            this.currentBBox.y = tempBoundingBox.y;
	
	            this.shapeCont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
	            this.shapeCont.style.transform = this.shapeCont.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        }
	    }
	
	};
	function HTextElement(data,globalData,comp){
	    this.textSpans = [];
	    this.textPaths = [];
	    this.currentBBox = {
	        x:999999,
	        y: -999999,
	        h: 0,
	        w: 0
	    };
	    this.renderType = 'svg';
	    this.isMasked = false;
	    this.initElement(data,globalData,comp);
	
	}
	extendPrototype([BaseElement,TransformElement,HBaseElement,HierarchyElement,FrameElement,RenderableDOMElement,ITextElement], HTextElement);
	
	HTextElement.prototype.createContent = function(){
	    this.isMasked = this.checkMasks();
	    if(this.isMasked){
	        this.renderType = 'svg';
	        this.compW = this.comp.data.w;
	        this.compH = this.comp.data.h;
	        this.svgElement.setAttribute('width',this.compW);
	        this.svgElement.setAttribute('height',this.compH);
	        var g = createNS('g');
	        this.maskedElement.appendChild(g);
	        this.innerElem = g;
	    } else {
	        this.renderType = 'html';
	        this.innerElem = this.layerElement;
	    }
	
	    this.checkParenting();
	
	};
	
	HTextElement.prototype.buildNewText = function(){
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
	    var innerElemStyle = this.innerElem.style;
	    innerElemStyle.color = innerElemStyle.fill = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
	    if(documentData.sc){
	        innerElemStyle.stroke = this.buildColor(documentData.sc);
	        innerElemStyle.strokeWidth = documentData.sw+'px';
	    }
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    if(!this.globalData.fontManager.chars){
	        innerElemStyle.fontSize = documentData.finalSize+'px';
	        innerElemStyle.lineHeight = documentData.finalSize+'px';
	        if(fontData.fClass){
	            this.innerElem.className = fontData.fClass;
	        } else {
	            innerElemStyle.fontFamily = fontData.fFamily;
	            var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
	            innerElemStyle.fontStyle = fStyle;
	            innerElemStyle.fontWeight = fWeight;
	        }
	    }
	    var i, len;
	
	    var letters = documentData.l;
	    len = letters.length;
	    var tSpan,tParent,tCont;
	    var matrixHelper = this.mHelper;
	    var shapes, shapeStr = '';
	    var cnt = 0;
	    for (i = 0;i < len ;i += 1) {
	        if(this.globalData.fontManager.chars){
	            if(!this.textPaths[cnt]){
	                tSpan = createNS('path');
	                tSpan.setAttribute('stroke-linecap', 'butt');
	                tSpan.setAttribute('stroke-linejoin','round');
	                tSpan.setAttribute('stroke-miterlimit','4');
	            } else {
	                tSpan = this.textPaths[cnt];
	            }
	            if(!this.isMasked){
	                if(this.textSpans[cnt]){
	                    tParent = this.textSpans[cnt];
	                    tCont = tParent.children[0];
	                } else {
	
	                    tParent = createTag('div');
	                    tCont = createNS('svg');
	                    tCont.appendChild(tSpan);
	                    styleDiv(tParent);
	                }
	            }
	        }else{
	            if(!this.isMasked){
	                if(this.textSpans[cnt]){
	                    tParent = this.textSpans[cnt];
	                    tSpan = this.textPaths[cnt];
	                } else {
	                    tParent = createTag('span');
	                    styleDiv(tParent);
	                    tSpan = createTag('span');
	                    styleDiv(tSpan);
	                    tParent.appendChild(tSpan);
	                }
	            } else {
	                tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
	            }
	        }
	        //tSpan.setAttribute('visibility', 'hidden');
	        if(this.globalData.fontManager.chars){
	            var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	            var shapeData;
	            if(charData){
	                shapeData = charData.data;
	            } else {
	                shapeData = null;
	            }
	            matrixHelper.reset();
	            if(shapeData && shapeData.shapes){
	                shapes = shapeData.shapes[0].it;
	                matrixHelper.scale(documentData.finalSize/100,documentData.finalSize/100);
	                shapeStr = this.createPathShape(matrixHelper,shapes);
	                tSpan.setAttribute('d',shapeStr);
	            }
	            if(!this.isMasked){
	                this.innerElem.appendChild(tParent);
	                if(shapeData && shapeData.shapes){
	
	                    //document.body.appendChild is needed to get exact measure of shape
	                    document.body.appendChild(tCont);
	                    var boundingBox = tCont.getBBox();
	                    tCont.setAttribute('width',boundingBox.width + 2);
	                    tCont.setAttribute('height',boundingBox.height + 2);
	                    tCont.setAttribute('viewBox',(boundingBox.x-1)+' '+ (boundingBox.y-1)+' '+ (boundingBox.width+2)+' '+ (boundingBox.height+2));
	                    tCont.style.transform = tCont.style.webkitTransform = 'translate(' + (boundingBox.x-1) + 'px,' + (boundingBox.y-1) + 'px)';
	
	                    letters[i].yOffset = boundingBox.y-1;
	
	                } else{
	                    tCont.setAttribute('width',1);
	                    tCont.setAttribute('height',1);
	                }
	                    tParent.appendChild(tCont);
	            }else{
	                this.innerElem.appendChild(tSpan);
	            }
	        }else{
	            tSpan.textContent = letters[i].val;
	            tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
	            if(!this.isMasked){
	                this.innerElem.appendChild(tParent);
	                //
	                tSpan.style.transform = tSpan.style.webkitTransform = 'translate3d(0,'+ -documentData.finalSize/1.2+'px,0)';
	            } else {
	                this.innerElem.appendChild(tSpan);
	            }
	        }
	        //
	        if(!this.isMasked){
	            this.textSpans[cnt] = tParent;
	        }else{
	            this.textSpans[cnt] = tSpan;
	        }
	        this.textSpans[cnt].style.display = 'block';
	        this.textPaths[cnt] = tSpan;
	        cnt += 1;
	    }
	    while(cnt < this.textSpans.length){
	        this.textSpans[cnt].style.display = 'none';
	        cnt += 1;
	    }
	};
	
	HTextElement.prototype.renderInnerContent = function() {
	
	    if(this.data.singleShape){
	        if(!this._isFirstFrame && !this.lettersChangedFlag){
	            return;
	        } else {
	            // Todo Benchmark if using this is better than getBBox
	             if(this.isMasked && this.finalTransform._matMdf){
	                 this.svgElement.setAttribute('viewBox',-this.finalTransform.mProp.p.v[0]+' '+ -this.finalTransform.mProp.p.v[1]+' '+this.compW+' '+this.compH);
	                this.svgElement.style.transform = this.svgElement.style.webkitTransform = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
	             }
	        }
	    }
	
	    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	    if(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag){
	        return;
	    }
	    var  i,len, count = 0;
	    var renderedLetters = this.textAnimator.renderedLetters;
	
	    var letters = this.textProperty.currentData.l;
	
	    len = letters.length;
	    var renderedLetter, textSpan, textPath;
	    for(i=0;i<len;i+=1){
	        if(letters[i].n){
	            count += 1;
	            continue;
	        }
	        textSpan = this.textSpans[i];
	        textPath = this.textPaths[i];
	        renderedLetter = renderedLetters[count];
	        count += 1;
	        if(renderedLetter._mdf.m) {
	            if(!this.isMasked){
	                textSpan.style.transform = textSpan.style.webkitTransform = renderedLetter.m;
	            }else{
	                textSpan.setAttribute('transform',renderedLetter.m);
	            }
	        }
	        ////textSpan.setAttribute('opacity',renderedLetter.o);
	        textSpan.style.opacity = renderedLetter.o;
	        if(renderedLetter.sw && renderedLetter._mdf.sw){
	            textPath.setAttribute('stroke-width',renderedLetter.sw);
	        }
	        if(renderedLetter.sc && renderedLetter._mdf.sc){
	            textPath.setAttribute('stroke',renderedLetter.sc);
	        }
	        if(renderedLetter.fc && renderedLetter._mdf.fc){
	            textPath.setAttribute('fill',renderedLetter.fc);
	            textPath.style.color = renderedLetter.fc;
	        }
	    }
	
	    if(this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)){
	        var boundingBox = this.innerElem.getBBox();
	
	        if(this.currentBBox.w !== boundingBox.width){
	            this.currentBBox.w = boundingBox.width;
	            this.svgElement.setAttribute('width',boundingBox.width);
	        }
	        if(this.currentBBox.h !== boundingBox.height){
	            this.currentBBox.h = boundingBox.height;
	            this.svgElement.setAttribute('height',boundingBox.height);
	        }
	
	        var margin = 1;
	        if(this.currentBBox.w !== (boundingBox.width + margin*2) || this.currentBBox.h !== (boundingBox.height + margin*2)  || this.currentBBox.x !== (boundingBox.x - margin)  || this.currentBBox.y !== (boundingBox.y - margin)){
	            this.currentBBox.w = boundingBox.width + margin*2;
	            this.currentBBox.h = boundingBox.height + margin*2;
	            this.currentBBox.x = boundingBox.x - margin;
	            this.currentBBox.y = boundingBox.y - margin;
	
	            this.svgElement.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
	            this.svgElement.style.transform = this.svgElement.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        }
	    }
	};
	function HImageElement(data,globalData,comp){
	    this.assetData = globalData.getAssetData(data.refId);
	    this.initElement(data,globalData,comp);
	}
	
	extendPrototype([BaseElement,TransformElement,HBaseElement,HSolidElement,HierarchyElement,FrameElement,RenderableElement], HImageElement);
	
	
	HImageElement.prototype.createContent = function(){
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    var img = new Image();
	
	    if(this.data.hasMask){
	        this.imageElem = createNS('image');
	        this.imageElem.setAttribute('width',this.assetData.w+"px");
	        this.imageElem.setAttribute('height',this.assetData.h+"px");
	        this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
	        this.layerElement.appendChild(this.imageElem);
	        this.baseElement.setAttribute('width',this.assetData.w);
	        this.baseElement.setAttribute('height',this.assetData.h);
	    } else {
	        this.layerElement.appendChild(img);
	    }
	    img.src = assetPath;
	    if(this.data.ln){
	        this.baseElement.setAttribute('id',this.data.ln);
	    }
	};
	function HCameraElement(data,globalData,comp){
	    this.initFrame();
	    this.initBaseData(data,globalData,comp);
	    this.initHierarchy();
	    var getProp = PropertyFactory.getProp;
	    this.pe = getProp(this,data.pe,0,0,this);
	    if(data.ks.p.s){
	        this.px = getProp(this,data.ks.p.x,1,0,this);
	        this.py = getProp(this,data.ks.p.y,1,0,this);
	        this.pz = getProp(this,data.ks.p.z,1,0,this);
	    }else{
	        this.p = getProp(this,data.ks.p,1,0,this);
	    }
	    if(data.ks.a){
	        this.a = getProp(this,data.ks.a,1,0,this);
	    }
	    if(data.ks.or.k.length && data.ks.or.k[0].to){
	        var i,len = data.ks.or.k.length;
	        for(i=0;i<len;i+=1){
	            data.ks.or.k[i].to = null;
	            data.ks.or.k[i].ti = null;
	        }
	    }
	    this.or = getProp(this,data.ks.or,1,degToRads,this);
	    this.or.sh = true;
	    this.rx = getProp(this,data.ks.rx,0,degToRads,this);
	    this.ry = getProp(this,data.ks.ry,0,degToRads,this);
	    this.rz = getProp(this,data.ks.rz,0,degToRads,this);
	    this.mat = new Matrix();
	    this._prevMat = new Matrix();
	    this._isFirstFrame = true;
	}
	extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement);
	
	HCameraElement.prototype.setup = function() {
	    var i, len = this.comp.threeDElements.length, comp;
	    for(i=0;i<len;i+=1){
	        //[perspectiveElem,container]
	        comp = this.comp.threeDElements[i];
	        if(comp.type === '3d') {
	            comp.perspectiveElem.style.perspective = comp.perspectiveElem.style.webkitPerspective = this.pe.v+'px';
	            comp.container.style.transformOrigin = comp.container.style.mozTransformOrigin = comp.container.style.webkitTransformOrigin = "0px 0px 0px";
	            comp.perspectiveElem.style.transform = comp.perspectiveElem.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	        }
	    }
	};
	
	HCameraElement.prototype.createElements = function(){
	};
	
	HCameraElement.prototype.hide = function(){
	};
	
	HCameraElement.prototype.renderFrame = function(){
	    var _mdf = this._isFirstFrame;
	    var i, len;
	    if(this.hierarchy){
	        len = this.hierarchy.length;
	        for(i=0;i<len;i+=1){
	            _mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
	        }
	    }
	    if(_mdf || this.pe._mdf || (this.p && this.p._mdf) || (this.px && (this.px._mdf || this.py._mdf || this.pz._mdf)) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || (this.a && this.a._mdf)) {
	        this.mat.reset();
	
	        if(this.hierarchy){
	            var mat;
	            len = this.hierarchy.length - 1;
	            for (i = len; i >= 0; i -= 1) {
	                /*mat = this.hierarchy[i].finalTransform.mProp.v.props;
	                console.log(mat)
	                this.mat.transform(-mat[0],-mat[1],-mat[2],-mat[3],-mat[4],-mat[5],-mat[6],-mat[7],-mat[8],-mat[9],-mat[10],-mat[11],-mat[12],-mat[13],-mat[14],mat[15]);
	                console.log(this.mat.props)*/
	                var mTransf = this.hierarchy[i].finalTransform.mProp;
	                this.mat.translate(-mTransf.p.v[0],-mTransf.p.v[1],mTransf.p.v[2]);
	                this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
	                this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
	                this.mat.scale(1/mTransf.s.v[0],1/mTransf.s.v[1],1/mTransf.s.v[2]);
	                this.mat.translate(mTransf.a.v[0],mTransf.a.v[1],mTransf.a.v[2]);
	            }
	        }
	
	        if(this.p){
	            this.mat.translate(-this.p.v[0],-this.p.v[1],this.p.v[2]);
	        }else{
	            this.mat.translate(-this.px.v,-this.py.v,this.pz.v);
	        }
	        if(this.a){
	            var diffVector = [this.p.v[0]-this.a.v[0],this.p.v[1]-this.a.v[1],this.p.v[2]-this.a.v[2]];
	            var mag = Math.sqrt(Math.pow(diffVector[0],2)+Math.pow(diffVector[1],2)+Math.pow(diffVector[2],2));
	            //var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
	            var lookDir = [diffVector[0]/mag,diffVector[1]/mag,diffVector[2]/mag];
	            var lookLengthOnXZ = Math.sqrt( lookDir[2]*lookDir[2] + lookDir[0]*lookDir[0] );
	            var m_rotationX = (Math.atan2( lookDir[1], lookLengthOnXZ ));
	            var m_rotationY = (Math.atan2( lookDir[0], -lookDir[2]));
	            this.mat.rotateY(m_rotationY).rotateX(-m_rotationX);
	
	        }
	        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
	        this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
	        this.mat.translate(this.globalData.compSize.w/2,this.globalData.compSize.h/2,0);
	        this.mat.translate(0,0,this.pe.v);
	
	
	        
	
	        var hasMatrixChanged = !this._prevMat.equals(this.mat);
	        if((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
	            len = this.comp.threeDElements.length;
	            var comp;
	            for(i=0;i<len;i+=1){
	                comp = this.comp.threeDElements[i];
	                if(comp.type === '3d') {
	                    if(hasMatrixChanged) {
	                        comp.container.style.transform = comp.container.style.webkitTransform = this.mat.toCSS();
	                    }
	                    if(this.pe._mdf) {
	                        comp.perspectiveElem.style.perspective = comp.perspectiveElem.style.webkitPerspective = this.pe.v+'px';
	                    }
	                }
	            }
	            this.mat.clone(this._prevMat);
	        }
	    }
	    this._isFirstFrame = false;
	};
	
	HCameraElement.prototype.prepareFrame = function(num) {
	    this.prepareProperties(num, true);
	};
	
	HCameraElement.prototype.destroy = function(){
	};
	HCameraElement.prototype.initExpressions = function(){};
	HCameraElement.prototype.getBaseElement = function(){return null;};
	function HEffects() {
	}
	HEffects.prototype.renderFrame = function(){};
	var animationManager = (function(){
	    var moduleOb = {};
	    var registeredAnimations = [];
	    var initTime = 0;
	    var len = 0;
	    var playingAnimationsNum = 0;
	    var _stopped = true;
	    var _isFrozen = false;
	
	    function removeElement(ev){
	        var i = 0;
	        var animItem = ev.target;
	        while(i<len) {
	            if (registeredAnimations[i].animation === animItem) {
	                registeredAnimations.splice(i, 1);
	                i -= 1;
	                len -= 1;
	                if(!animItem.isPaused){
	                    subtractPlayingCount();
	                }
	            }
	            i += 1;
	        }
	    }
	
	    function registerAnimation(element, animationData){
	        if(!element){
	            return null;
	        }
	        var i=0;
	        while(i<len){
	            if(registeredAnimations[i].elem == element && registeredAnimations[i].elem !== null ){
	                return registeredAnimations[i].animation;
	            }
	            i+=1;
	        }
	        var animItem = new AnimationItem();
	        setupAnimation(animItem, element);
	        animItem.setData(element, animationData);
	        return animItem;
	    }
	
	    function getRegisteredAnimations() {
	        var i, len = registeredAnimations.length;
	        var animations = [];
	        for(i = 0; i < len; i += 1) {
	            animations.push(registeredAnimations[i].animation);
	        }
	        return animations;
	    }
	
	    function addPlayingCount(){
	        playingAnimationsNum += 1;
	        activate();
	    }
	
	    function subtractPlayingCount(){
	        playingAnimationsNum -= 1;
	    }
	
	    function setupAnimation(animItem, element){
	        animItem.addEventListener('destroy',removeElement);
	        animItem.addEventListener('_active',addPlayingCount);
	        animItem.addEventListener('_idle',subtractPlayingCount);
	        registeredAnimations.push({elem: element,animation:animItem});
	        len += 1;
	    }
	
	    function loadAnimation(params){
	        var animItem = new AnimationItem();
	        setupAnimation(animItem, null);
	        animItem.setParams(params);
	        return animItem;
	    }
	
	
	    function setSpeed(val,animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.setSpeed(val, animation);
	        }
	    }
	
	    function setDirection(val, animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.setDirection(val, animation);
	        }
	    }
	
	    function play(animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.play(animation);
	        }
	    }
	    function resume(nowTime) {
	        var elapsedTime = nowTime - initTime;
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.advanceTime(elapsedTime);
	        }
	        initTime = nowTime;
	        if(playingAnimationsNum && !_isFrozen) {
	            window.requestAnimationFrame(resume);
	        } else {
	            _stopped = true;
	        }
	    }
	
	    function first(nowTime){
	        initTime = nowTime;
	        window.requestAnimationFrame(resume);
	    }
	
	    function pause(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.pause(animation);
	        }
	    }
	
	    function goToAndStop(value,isFrame,animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.goToAndStop(value,isFrame,animation);
	        }
	    }
	
	    function stop(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.stop(animation);
	        }
	    }
	
	    function togglePause(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.togglePause(animation);
	        }
	    }
	
	    function destroy(animation) {
	        var i;
	        for(i=(len-1);i>=0;i-=1){
	            registeredAnimations[i].animation.destroy(animation);
	        }
	    }
	
	    function searchAnimations(animationData, standalone, renderer){
	        var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')),
	                  [].slice.call(document.getElementsByClassName('bodymovin')));
	        var i, len = animElements.length;
	        for(i=0;i<len;i+=1){
	            if(renderer){
	                animElements[i].setAttribute('data-bm-type',renderer);
	            }
	            registerAnimation(animElements[i], animationData);
	        }
	        if(standalone && len === 0){
	            if(!renderer){
	                renderer = 'svg';
	            }
	            var body = document.getElementsByTagName('body')[0];
	            body.innerHTML = '';
	            var div = createTag('div');
	            div.style.width = '100%';
	            div.style.height = '100%';
	            div.setAttribute('data-bm-type',renderer);
	            body.appendChild(div);
	            registerAnimation(div, animationData);
	        }
	    }
	
	    function resize(){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.resize();
	        }
	    }
	
	    function activate(){
	        if(!_isFrozen && playingAnimationsNum){
	            if(_stopped) {
	                window.requestAnimationFrame(first);
	                _stopped = false;
	            }
	        }
	    }
	
	    function freeze() {
	        _isFrozen = true;
	    }
	
	    function unfreeze() {
	        _isFrozen = false;
	        activate();
	    }
	
	    moduleOb.registerAnimation = registerAnimation;
	    moduleOb.loadAnimation = loadAnimation;
	    moduleOb.setSpeed = setSpeed;
	    moduleOb.setDirection = setDirection;
	    moduleOb.play = play;
	    moduleOb.pause = pause;
	    moduleOb.stop = stop;
	    moduleOb.togglePause = togglePause;
	    moduleOb.searchAnimations = searchAnimations;
	    moduleOb.resize = resize;
	    //moduleOb.start = start;
	    moduleOb.goToAndStop = goToAndStop;
	    moduleOb.destroy = destroy;
	    moduleOb.freeze = freeze;
	    moduleOb.unfreeze = unfreeze;
	    moduleOb.getRegisteredAnimations = getRegisteredAnimations;
	    return moduleOb;
	}());
	
	var AnimationItem = function () {
	    this._cbs = [];
	    this.name = '';
	    this.path = '';
	    this.isLoaded = false;
	    this.currentFrame = 0;
	    this.currentRawFrame = 0;
	    this.totalFrames = 0;
	    this.frameRate = 0;
	    this.frameMult = 0;
	    this.playSpeed = 1;
	    this.playDirection = 1;
	    this.playCount = 0;
	    this.animationData = {};
	    this.assets = [];
	    this.isPaused = true;
	    this.autoplay = false;
	    this.loop = true;
	    this.renderer = null;
	    this.animationID = createElementID();
	    this.assetsPath = '';
	    this.timeCompleted = 0;
	    this.segmentPos = 0;
	    this.subframeEnabled = subframeEnabled;
	    this.segments = [];
	    this._idle = true;
	    this._completedLoop = false;
	    this.projectInterface = ProjectInterface();
	    this.imagePreloader = new ImagePreloader();
	};
	
	extendPrototype([BaseEvent], AnimationItem);
	
	AnimationItem.prototype.setParams = function(params) {
	    if(params.context){
	        this.context = params.context;
	    }
	    if(params.wrapper || params.container){
	        this.wrapper = params.wrapper || params.container;
	    }
	    var animType = params.animType ? params.animType : params.renderer ? params.renderer : 'svg';
	    switch(animType){
	        case 'canvas':
	            this.renderer = new CanvasRenderer(this, params.rendererSettings);
	            break;
	        case 'svg':
	            this.renderer = new SVGRenderer(this, params.rendererSettings);
	            break;
	        default:
	            this.renderer = new HybridRenderer(this, params.rendererSettings);
	            break;
	    }
	    this.renderer.setProjectInterface(this.projectInterface);
	    this.animType = animType;
	
	    if(params.loop === '' || params.loop === null){
	    }else if(params.loop === false){
	        this.loop = false;
	    }else if(params.loop === true){
	        this.loop = true;
	    }else{
	        this.loop = parseInt(params.loop);
	    }
	    this.autoplay = 'autoplay' in params ? params.autoplay : true;
	    this.name = params.name ? params.name :  '';
	    this.autoloadSegments = params.hasOwnProperty('autoloadSegments') ? params.autoloadSegments :  true;
	    this.assetsPath = params.assetsPath;
	    if(params.animationData){
	        this.configAnimation(params.animationData);
	    }else if(params.path){
	        if(params.path.substr(-4) != 'json'){
	            if (params.path.substr(-1, 1) != '/') {
	                params.path += '/';
	            }
	            params.path += 'data.json';
	        }
	
	        if(params.path.lastIndexOf('\\') != -1){
	            this.path = params.path.substr(0,params.path.lastIndexOf('\\')+1);
	        }else{
	            this.path = params.path.substr(0,params.path.lastIndexOf('/')+1);
	        }
	        this.fileName = params.path.substr(params.path.lastIndexOf('/')+1);
	        this.fileName = this.fileName.substr(0,this.fileName.lastIndexOf('.json'));
	
	        assetLoader.load(params.path, this.configAnimation.bind(this), function() {
	            this.trigger('data_failed');
	        }.bind(this));
	    }
	};
	
	AnimationItem.prototype.setData = function (wrapper, animationData) {
	    var params = {
	        wrapper: wrapper,
	        animationData: animationData ? (typeof animationData  === "object") ? animationData : JSON.parse(animationData) : null
	    };
	    var wrapperAttributes = wrapper.attributes;
	
	    params.path = wrapperAttributes.getNamedItem('data-animation-path') ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') ? wrapperAttributes.getNamedItem('data-bm-path').value :  wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
	    params.animType = wrapperAttributes.getNamedItem('data-anim-type') ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') ? wrapperAttributes.getNamedItem('bm-type').value :  wrapperAttributes.getNamedItem('data-bm-renderer') ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : 'canvas';
	
	    var loop = wrapperAttributes.getNamedItem('data-anim-loop') ? wrapperAttributes.getNamedItem('data-anim-loop').value :  wrapperAttributes.getNamedItem('data-bm-loop') ? wrapperAttributes.getNamedItem('data-bm-loop').value :  wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
	    if(loop === ''){
	    }else if(loop === 'false'){
	        params.loop = false;
	    }else if(loop === 'true'){
	        params.loop = true;
	    }else{
	        params.loop = parseInt(loop);
	    }
	    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') ? wrapperAttributes.getNamedItem('data-anim-autoplay').value :  wrapperAttributes.getNamedItem('data-bm-autoplay') ? wrapperAttributes.getNamedItem('data-bm-autoplay').value :  wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
	    params.autoplay = autoplay !== "false";
	
	    params.name = wrapperAttributes.getNamedItem('data-name') ? wrapperAttributes.getNamedItem('data-name').value :  wrapperAttributes.getNamedItem('data-bm-name') ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value :  '';
	    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') ? wrapperAttributes.getNamedItem('data-anim-prerender').value :  wrapperAttributes.getNamedItem('data-bm-prerender') ? wrapperAttributes.getNamedItem('data-bm-prerender').value :  wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
	
	    if(prerender === 'false'){
	        params.prerender = false;
	    }
	    this.setParams(params);
	};
	
	AnimationItem.prototype.includeLayers = function(data) {
	    if(data.op > this.animationData.op){
	        this.animationData.op = data.op;
	        this.totalFrames = Math.floor(data.op - this.animationData.ip);
	    }
	    var layers = this.animationData.layers;
	    var i, len = layers.length;
	    var newLayers = data.layers;
	    var j, jLen = newLayers.length;
	    for(j=0;j<jLen;j+=1){
	        i = 0;
	        while(i<len){
	            if(layers[i].id == newLayers[j].id){
	                layers[i] = newLayers[j];
	                break;
	            }
	            i += 1;
	        }
	    }
	    if(data.chars || data.fonts){
	        this.renderer.globalData.fontManager.addChars(data.chars);
	        this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
	    }
	    if(data.assets){
	        len = data.assets.length;
	        for(i = 0; i < len; i += 1){
	            this.animationData.assets.push(data.assets[i]);
	        }
	    }
	    this.animationData.__complete = false;
	    dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
	    this.renderer.includeLayers(data.layers);
	    if(expressionsPlugin){
	        expressionsPlugin.initExpressions(this);
	    }
	    this.loadNextSegment();
	};
	
	AnimationItem.prototype.loadNextSegment = function() {
	    var segments = this.animationData.segments;
	    if(!segments || segments.length === 0 || !this.autoloadSegments){
	        this.trigger('data_ready');
	        this.timeCompleted = this.totalFrames;
	        return;
	    }
	    var segment = segments.shift();
	    this.timeCompleted = segment.time * this.frameRate;
	    var segmentPath = this.path+this.fileName+'_' + this.segmentPos + '.json';
	    this.segmentPos += 1;
	    assetLoader.load(segmentPath, this.includeLayers.bind(this), function() {
	        this.trigger('data_failed');
	    }.bind(this));
	};
	
	AnimationItem.prototype.loadSegments = function() {
	    var segments = this.animationData.segments;
	    if(!segments) {
	        this.timeCompleted = this.totalFrames;
	    }
	    this.loadNextSegment();
	};
	
	AnimationItem.prototype.imagesLoaded = function() {
	    this.trigger('loaded_images');
	    this.checkLoaded()
	}
	
	AnimationItem.prototype.preloadImages = function() {
	    this.imagePreloader.setAssetsPath(this.assetsPath);
	    this.imagePreloader.setPath(this.path);
	    this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
	}
	
	AnimationItem.prototype.configAnimation = function (animData) {
	    if(!this.renderer){
	        return;
	    }
	    this.animationData = animData;
	    this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
	    this.renderer.configAnimation(animData);
	    if(!animData.assets){
	        animData.assets = [];
	    }
	    this.renderer.searchExtraCompositions(animData.assets);
	
	    this.assets = this.animationData.assets;
	    this.frameRate = this.animationData.fr;
	    this.firstFrame = Math.round(this.animationData.ip);
	    this.frameMult = this.animationData.fr / 1000;
	    this.trigger('config_ready');
	    this.preloadImages();
	    this.loadSegments();
	    this.updaFrameModifier();
	    this.waitForFontsLoaded();
	};
	
	AnimationItem.prototype.waitForFontsLoaded = function(){
	    if(!this.renderer) {
	        return;
	    }
	    if(this.renderer.globalData.fontManager.loaded()){
	        this.checkLoaded();
	    }else{
	        setTimeout(this.waitForFontsLoaded.bind(this),20);
	    }
	}
	
	AnimationItem.prototype.checkLoaded = function () {
	    if (!this.isLoaded && this.renderer.globalData.fontManager.loaded() && (this.imagePreloader.loaded() || this.renderer.rendererType !== 'canvas')) {
	        this.isLoaded = true;
	        dataManager.completeData(this.animationData, this.renderer.globalData.fontManager);
	        if(expressionsPlugin){
	            expressionsPlugin.initExpressions(this);
	        }
	        this.renderer.initItems();
	        setTimeout(function() {
	            this.trigger('DOMLoaded');
	        }.bind(this), 0);
	        this.gotoFrame();
	        if(this.autoplay){
	            this.play();
	        }
	    }
	};
	
	AnimationItem.prototype.resize = function () {
	    this.renderer.updateContainerSize();
	};
	
	AnimationItem.prototype.setSubframe = function(flag){
	    this.subframeEnabled = flag ? true : false;
	};
	
	AnimationItem.prototype.gotoFrame = function () {
	    this.currentFrame = this.subframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame;
	
	    if(this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted){
	        this.currentFrame = this.timeCompleted;
	    }
	    this.trigger('enterFrame');
	    this.renderFrame();
	};
	
	AnimationItem.prototype.renderFrame = function () {
	    if(this.isLoaded === false){
	        return;
	    }
	    this.renderer.renderFrame(this.currentFrame + this.firstFrame);
	};
	
	AnimationItem.prototype.play = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === true){
	        this.isPaused = false;
	        if(this._idle){
	            this._idle = false;
	            this.trigger('_active');
	        }
	    }
	};
	
	AnimationItem.prototype.pause = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === false){
	        this.isPaused = true;
	        this._idle = true;
	        this.trigger('_idle');
	    }
	};
	
	AnimationItem.prototype.togglePause = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === true){
	        this.play();
	    }else{
	        this.pause();
	    }
	};
	
	AnimationItem.prototype.stop = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    this.pause();
	    this.playCount = 0;
	    this._completedLoop = false;
	    this.setCurrentRawFrameValue(0);
	};
	
	AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(isFrame){
	        this.setCurrentRawFrameValue(value);
	    }else{
	        this.setCurrentRawFrameValue(value * this.frameModifier);
	    }
	    this.pause();
	};
	
	AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
	    this.goToAndStop(value, isFrame, name);
	    this.play();
	};
	
	AnimationItem.prototype.advanceTime = function (value) {
	    if (this.isPaused === true || this.isLoaded === false) {
	        return;
	    }
	    var nextValue = this.currentRawFrame + value * this.frameModifier;
	    var _isComplete = false;
	    // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
	    // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
	    if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
	        if (!this.loop || this.playCount === this.loop) {
	            if (!this.checkSegments(nextValue >  this.totalFrames ? nextValue % this.totalFrames : 0)) {
	                _isComplete = true;
	                nextValue = this.totalFrames - 1;
	            }
	        } else if (nextValue >= this.totalFrames) {
	            this.playCount += 1;
	            if (!this.checkSegments(nextValue % this.totalFrames)) {
	                this.setCurrentRawFrameValue(nextValue % this.totalFrames);
	                this._completedLoop = true;
	                this.trigger('loopComplete');
	            }
	        } else {
	            this.setCurrentRawFrameValue(nextValue);
	        }
	    } else if(nextValue < 0) {
	        if (!this.checkSegments(nextValue % this.totalFrames)) {
	            if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
	                this.setCurrentRawFrameValue(this.totalFrames + (nextValue % this.totalFrames));
	                if(!this._completedLoop) {
	                    this._completedLoop = true;
	                } else {
	                    this.trigger('loopComplete');
	                }
	            } else {
	                _isComplete = true;
	                nextValue = 0;
	            }
	        }
	    } else {
	        this.setCurrentRawFrameValue(nextValue);
	    }
	    if (_isComplete) {
	        this.setCurrentRawFrameValue(nextValue);
	        this.pause();
	        this.trigger('complete');
	    }
	};
	
	AnimationItem.prototype.adjustSegment = function(arr, offset){
	    this.playCount = 0;
	    if(arr[1] < arr[0]){
	        if(this.frameModifier > 0){
	            if(this.playSpeed < 0){
	                this.setSpeed(-this.playSpeed);
	            } else {
	                this.setDirection(-1);
	            }
	        }
	        this.timeCompleted = this.totalFrames = arr[0] - arr[1];
	        this.firstFrame = arr[1];
	        this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
	    } else if(arr[1] > arr[0]){
	        if(this.frameModifier < 0){
	            if(this.playSpeed < 0){
	                this.setSpeed(-this.playSpeed);
	            } else {
	                this.setDirection(1);
	            }
	        }
	        this.timeCompleted = this.totalFrames = arr[1] - arr[0];
	        this.firstFrame = arr[0];
	        this.setCurrentRawFrameValue(0.001 + offset);
	    }
	    this.trigger('segmentStart');
	};
	AnimationItem.prototype.setSegment = function (init,end) {
	    var pendingFrame = -1;
	    if(this.isPaused) {
	        if (this.currentRawFrame + this.firstFrame < init) {
	            pendingFrame = init;
	        } else if (this.currentRawFrame + this.firstFrame > end) {
	            pendingFrame = end - init;
	        }
	    }
	
	    this.firstFrame = init;
	    this.timeCompleted = this.totalFrames = end - init;
	    if(pendingFrame !== -1) {
	        this.goToAndStop(pendingFrame,true);
	    }
	};
	
	AnimationItem.prototype.playSegments = function (arr, forceFlag) {
	    if (forceFlag) {
	        this.segments.length = 0;
	    }
	    if (typeof arr[0] === 'object') {
	        var i, len = arr.length;
	        for (i = 0; i < len; i += 1) {
	            this.segments.push(arr[i]);
	        }
	    } else {
	        this.segments.push(arr);
	    }
	    if (this.segments.length) {
	        this.adjustSegment(this.segments.shift(), 0);
	    }
	    if (this.isPaused) {
	        this.play();
	    }
	};
	
	AnimationItem.prototype.resetSegments = function (forceFlag) {
	    this.segments.length = 0;
	    this.segments.push([this.animationData.ip,this.animationData.op]);
	    //this.segments.push([this.animationData.ip*this.frameRate,Math.floor(this.animationData.op - this.animationData.ip+this.animationData.ip*this.frameRate)]);
	    if (forceFlag) {
	        this.checkSegments(0);
	    }
	};
	AnimationItem.prototype.checkSegments = function(offset) {
	    if (this.segments.length) {
	        this.adjustSegment(this.segments.shift(), offset);
	        return true;
	    }
	    return false;
	};
	
	AnimationItem.prototype.destroy = function (name) {
	    if ((name && this.name != name) || !this.renderer) {
	        return;
	    }
	    this.renderer.destroy();
	    this.imagePreloader.destroy();
	    this.trigger('destroy');
	    this._cbs = null;
	    this.onEnterFrame = this.onLoopComplete = this.onComplete = this.onSegmentStart = this.onDestroy = null;
	    this.renderer = null;
	};
	
	AnimationItem.prototype.setCurrentRawFrameValue = function(value){
	    this.currentRawFrame = value;
	    this.gotoFrame();
	};
	
	AnimationItem.prototype.setSpeed = function (val) {
	    this.playSpeed = val;
	    this.updaFrameModifier();
	};
	
	AnimationItem.prototype.setDirection = function (val) {
	    this.playDirection = val < 0 ? -1 : 1;
	    this.updaFrameModifier();
	};
	
	AnimationItem.prototype.updaFrameModifier = function () {
	    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
	};
	
	AnimationItem.prototype.getPath = function () {
	    return this.path;
	};
	
	AnimationItem.prototype.getAssetsPath = function (assetData) {
	    var path = '';
	    if(assetData.e) {
	        path = assetData.p;
	    } else if(this.assetsPath){
	        var imagePath = assetData.p;
	        if(imagePath.indexOf('images/') !== -1){
	            imagePath = imagePath.split('/')[1];
	        }
	        path = this.assetsPath + imagePath;
	    } else {
	        path = this.path;
	        path += assetData.u ? assetData.u : '';
	        path += assetData.p;
	    }
	    return path;
	};
	
	AnimationItem.prototype.getAssetData = function (id) {
	    var i = 0, len = this.assets.length;
	    while (i < len) {
	        if(id == this.assets[i].id){
	            return this.assets[i];
	        }
	        i += 1;
	    }
	};
	
	AnimationItem.prototype.hide = function () {
	    this.renderer.hide();
	};
	
	AnimationItem.prototype.show = function () {
	    this.renderer.show();
	};
	
	AnimationItem.prototype.getDuration = function (isFrame) {
	    return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
	};
	
	AnimationItem.prototype.trigger = function(name){
	    if(this._cbs && this._cbs[name]){
	        switch(name){
	            case 'enterFrame':
	                this.triggerEvent(name,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
	                break;
	            case 'loopComplete':
	                this.triggerEvent(name,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
	                break;
	            case 'complete':
	                this.triggerEvent(name,new BMCompleteEvent(name,this.frameMult));
	                break;
	            case 'segmentStart':
	                this.triggerEvent(name,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
	                break;
	            case 'destroy':
	                this.triggerEvent(name,new BMDestroyEvent(name,this));
	                break;
	            default:
	                this.triggerEvent(name);
	        }
	    }
	    if(name === 'enterFrame' && this.onEnterFrame){
	        this.onEnterFrame.call(this,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
	    }
	    if(name === 'loopComplete' && this.onLoopComplete){
	        this.onLoopComplete.call(this,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
	    }
	    if(name === 'complete' && this.onComplete){
	        this.onComplete.call(this,new BMCompleteEvent(name,this.frameMult));
	    }
	    if(name === 'segmentStart' && this.onSegmentStart){
	        this.onSegmentStart.call(this,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
	    }
	    if(name === 'destroy' && this.onDestroy){
	        this.onDestroy.call(this,new BMDestroyEvent(name,this));
	    }
	};
	
	var Expressions = (function(){
	    var ob = {};
	    ob.initExpressions = initExpressions;
	
	
	    function initExpressions(animation){
	
	    	var stackCount = 0;
	    	var registers = [];
	
	    	function pushExpression() {
				stackCount += 1;
	    	}
	
	    	function popExpression() {
				stackCount -= 1;
				if (stackCount === 0) {
					releaseInstances();
				}
	    	}
	
	    	function registerExpressionProperty(expression) {
	    		if (registers.indexOf(expression) === -1) {
					registers.push(expression)
	    		}
	    	}
	
	    	function releaseInstances() {
	    		var i, len = registers.length;
	    		for (i = 0; i < len; i += 1) {
					registers[i].release();
	    		}
	    		registers.length = 0;
	    	}
	
	        animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
	        animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
	        animation.renderer.globalData.pushExpression = pushExpression;
	        animation.renderer.globalData.popExpression = popExpression;
	        animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
	    }
	   return ob;
	}());
	
	expressionsPlugin = Expressions;
	
	var ExpressionManager = (function(){
	    'use strict';
	    var ob = {};
	    var Math = BMMath;
	    var window = null;
	    var document = null;
	
	    function $bm_isInstanceOfArray(arr) {
	        return arr.constructor === Array || arr.constructor === Float32Array;
	    }
	
	    function isNumerable(tOfV, v) {
	        return tOfV === 'number' || tOfV === 'boolean' || tOfV === 'string' || v instanceof Number;
	    }
	
	    function $bm_neg(a){
	        var tOfA = typeof a;
	        if(tOfA === 'number' || tOfA === 'boolean'  || a instanceof Number ){
	            return -a;
	        }
	        if($bm_isInstanceOfArray(a)){
	            var i, lenA = a.length;
	            var retArr = [];
	            for(i=0;i<lenA;i+=1){
	                retArr[i] = -a[i];
	            }
	            return retArr;
	        }
	    }
	
	    var easeInBez = BezierFactory.getBezierEasing(0.333,0,.833,.833, 'easeIn').get;
	    var easeOutBez = BezierFactory.getBezierEasing(0.167,0.167,.667,1, 'easeOut').get;
	    var easeInOutBez = BezierFactory.getBezierEasing(.33,0,.667,1, 'easeInOut').get;
	
	    function sum(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        if(tOfA === 'string' || tOfB === 'string'){
	            return a + b;
	        }
	        if(isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	            return a + b;
	        }
	        if($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)){
	            a = a.slice(0);
	            a[0] = a[0] + b;
	            return a;
	        }
	        if(isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)){
	            b = b.slice(0);
	            b[0] = a + b[0];
	            return b;
	        }
	        if($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)){
	            
	            var i = 0, lenA = a.length, lenB = b.length;
	            var retArr = [];
	            while(i<lenA || i < lenB){
	                if((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)){
	                    retArr[i] = a[i] + b[i];
	                }else{
	                    retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
	                }
	                i += 1;
	            }
	            return retArr;
	        }
	        return 0;
	    }
	    var add = sum;
	
	    function sub(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        if(isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	            if(tOfA === 'string') {
	                a = parseInt(a);
	            }
	            if(tOfB === 'string') {
	                b = parseInt(b);
	            }
	            return a - b;
	        }
	        if( $bm_isInstanceOfArray(a) && isNumerable(tOfB, b)){
	            a = a.slice(0);
	            a[0] = a[0] - b;
	            return a;
	        }
	        if(isNumerable(tOfA, a) &&  $bm_isInstanceOfArray(b)){
	            b = b.slice(0);
	            b[0] = a - b[0];
	            return b;
	        }
	        if($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)){
	            var i = 0, lenA = a.length, lenB = b.length;
	            var retArr = [];
	            while(i<lenA || i < lenB){
	                if((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)){
	                    retArr[i] = a[i] - b[i];
	                }else{
	                    retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
	                }
	                i += 1;
	            }
	            return retArr;
	        }
	        return 0;
	    }
	
	    function mul(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        var arr;
	        if(isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	            return a * b;
	        }
	
	        var i, len;
	        if($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)){
	            len = a.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a[i] * b;
	            }
	            return arr;
	        }
	        if(isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)){
	            len = b.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a * b[i];
	            }
	            return arr;
	        }
	        return 0;
	    }
	
	    function div(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        var arr;
	        if(isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	            return a / b;
	        }
	        var i, len;
	        if($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)){
	            len = a.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a[i] / b;
	            }
	            return arr;
	        }
	        if(isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)){
	            len = b.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a / b[i];
	            }
	            return arr;
	        }
	        return 0;
	    }
	    function mod(a,b) {
	        if(typeof a === 'string') {
	            a = parseInt(a);
	        }
	        if(typeof b === 'string') {
	            b = parseInt(b);
	        }
	        return a % b;
	    }
	
	    function clamp(num, min, max) {
	        if(min > max){
	            var mm = max;
	            max = min;
	            min = mm;
	        }
	        return Math.min(Math.max(num, min), max);
	    }
	
	    function radiansToDegrees(val) {
	        return val/degToRads;
	    }
	    var radians_to_degrees = radiansToDegrees;
	
	    function degreesToRadians(val) {
	        return val*degToRads;
	    }
	    var degrees_to_radians = radiansToDegrees;
	
	    var helperLengthArray = [0,0,0,0,0,0];
	
	    function length(arr1, arr2) {
	        if (typeof arr1 === 'number' || arr1 instanceof Number) {
	            arr2 = arr2 || 0;
	            return Math.abs(arr1 - arr2);
	        }
	        if(!arr2) {
	            arr2 = helperLengthArray;
	        }
	        var i, len = Math.min(arr1.length, arr2.length);
	        var addedLength = 0;
	        for (i = 0; i < len; i += 1) {
	            addedLength += Math.pow(arr2[i] - arr1[i], 2);
	        }
	        return Math.sqrt(addedLength);
	    }
	
	    function normalize(vec) {
	        return div(vec, length(vec));
	    }
	
	    function rgbToHsl(val) {
	        var r = val[0]; var g = val[1]; var b = val[2];
	        var max = Math.max(r, g, b), min = Math.min(r, g, b);
	        var h, s, l = (max + min) / 2;
	
	        if(max == min){
	            h = s = 0; // achromatic
	        }else{
	            var d = max - min;
	            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	            switch(max){
	                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	                case g: h = (b - r) / d + 2; break;
	                case b: h = (r - g) / d + 4; break;
	            }
	            h /= 6;
	        }
	
	        return [h, s, l,val[3]];
	    }
	
	    function hue2rgb(p, q, t){
	        if(t < 0) t += 1;
	        if(t > 1) t -= 1;
	        if(t < 1/6) return p + (q - p) * 6 * t;
	        if(t < 1/2) return q;
	        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
	        return p;
	    }
	
	    function hslToRgb(val){
	        var h = val[0];
	        var s = val[1];
	        var l = val[2];
	
	        var r, g, b;
	
	        if(s === 0){
	            r = g = b = l; // achromatic
	        }else{
	
	            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	            var p = 2 * l - q;
	            r = hue2rgb(p, q, h + 1/3);
	            g = hue2rgb(p, q, h);
	            b = hue2rgb(p, q, h - 1/3);
	        }
	
	        return [r, g , b, val[3]];
	    }
	
	    function linear(t, tMin, tMax, value1, value2){
	        if(value1 === undefined || value2 === undefined){
	            value1 = tMin;
	            value2 = tMax;
	            tMin = 0;
	            tMax = 1;
	        }
	        if(tMax < tMin) {
	            var _tMin = tMax;
	            tMax = tMin;
	            tMin = _tMin;
	        }
	        if(t <= tMin) {
	            return value1;
	        }else if(t >= tMax){
	            return value2;
	        }
	        var perc = tMax === tMin ? 0 : (t-tMin)/(tMax-tMin);
	        if(!value1.length){
	            return value1 + (value2-value1)*perc;
	        }
	        var i, len = value1.length;
	        var arr = createTypedArray('float32', len);
	        for(i=0;i<len;i+=1){
	            arr[i] = value1[i] + (value2[i]-value1[i])*perc;
	        }
	        return arr;
	    }
	    function random(min,max){
	        if(max === undefined){
	            if(min === undefined){
	                min = 0;
	                max = 1;
	            } else {
	                max = min;
	                min = undefined;
	            }
	        }
	        if(max.length){
	            var i, len = max.length;
	            if(!min){
	                min = createTypedArray('float32', len);
	            }
	            var arr = createTypedArray('float32', len);
	            var rnd = BMMath.random();
	            for(i=0;i<len;i+=1){
	                arr[i] = min[i] + rnd*(max[i]-min[i]);
	            }
	            return arr;
	        }
	        if(min === undefined){
	            min = 0;
	        }
	        var rndm = BMMath.random();
	        return min + rndm*(max-min);
	    }
	
	    function createPath(points, inTangents, outTangents, closed) {
	        var i, len = points.length;
	        var path = shape_pool.newElement();
	        path.setPathData(!!closed, len);
	        var arrPlaceholder = [0,0], inVertexPoint, outVertexPoint;
	        for(i = 0; i < len; i += 1) {
	            inVertexPoint = (inTangents && inTangents[i]) ? inTangents[i] : arrPlaceholder;
	            outVertexPoint = (outTangents && outTangents[i]) ? outTangents[i] : arrPlaceholder;
	            path.setTripleAt(points[i][0],points[i][1],outVertexPoint[0] + points[i][0],outVertexPoint[1] + points[i][1],inVertexPoint[0] + points[i][0],inVertexPoint[1] + points[i][1],i,true);
	        }
	        return path;
	    }
	
	    function initiateExpression(elem,data,property){
	        var val = data.x;
	        var needsVelocity = /velocity(?![\w\d])/.test(val);
	        var _needsRandom = val.indexOf('random') !== -1;
	        var elemType = elem.data.ty;
	        var transform,$bm_transform,content,effect;
	        var thisProperty = property;
	        thisProperty.valueAtTime = thisProperty.getValueAtTime;
	        elem.comp.frameDuration = 1/elem.comp.globalData.frameRate;
	        elem.comp.displayStartTime = 0;
	        var inPoint = elem.data.ip/elem.comp.globalData.frameRate;
	        var outPoint = elem.data.op/elem.comp.globalData.frameRate;
	        var width = elem.data.sw ? elem.data.sw : 0;
	        var height = elem.data.sh ? elem.data.sh : 0;
	        var name = elem.data.nm;
	        var loopIn, loop_in, loopOut, loop_out;
	        var toWorld,fromWorld,fromComp,toComp,fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer,thisComp,mask,valueAtTime,velocityAtTime;
	        var __expression_functions = [];
	        if(data.xf) {
	            var i, len = data.xf.length;
	            for(i = 0; i < len; i += 1) {
	                __expression_functions[i] = eval('(function(){ return ' + data.xf[i] + '}())');
	            }
	        }
	
	        var scoped_bm_rt;
	        var expression_function = eval('[function _expression_function(){' + val+';scoped_bm_rt=$bm_rt}' + ']')[0];
	        var numKeys = property.kf ? data.k.length : 0;
	
	        var active = !this.data || this.data.hd !== true;
	
	        var wiggle = function wiggle(freq,amp){
	            var i,j, len = this.pv.length ? this.pv.length : 1;
	            var addedAmps = createTypedArray('float32', len);
	            freq = 5;
	            var iterations = Math.floor(time*freq);
	            i = 0;
	            j = 0;
	            while(i<iterations){
	                //var rnd = BMMath.random();
	                for(j=0;j<len;j+=1){
	                    addedAmps[j] += -amp + amp*2*BMMath.random();
	                    //addedAmps[j] += -amp + amp*2*rnd;
	                }
	                i += 1;
	            }
	            //var rnd2 = BMMath.random();
	            var periods = time*freq;
	            var perc = periods - Math.floor(periods);
	            var arr = createTypedArray('float32', len);
	            if(len>1){
	                for(j=0;j<len;j+=1){
	                    arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*BMMath.random())*perc;
	                    //arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
	                    //arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
	                }
	                return arr;
	            } else {
	                return this.pv + addedAmps[0] + (-amp + amp*2*BMMath.random())*perc;
	            }
	        }.bind(this);
	
	        if(thisProperty.loopIn) {
	            loopIn = thisProperty.loopIn.bind(thisProperty);
	            loop_in = loopIn;
	        }
	
	        if(thisProperty.loopOut) {
	            loopOut = thisProperty.loopOut.bind(thisProperty);
	            loop_out = loopOut;
	        }
	
	        function loopInDuration(type,duration){
	            return loopIn(type,duration,true);
	        }
	
	        function loopOutDuration(type,duration){
	            return loopOut(type,duration,true);
	        }
	
	        if(this.getValueAtTime) {
	            valueAtTime = this.getValueAtTime.bind(this);
	        }
	
	        if(this.getVelocityAtTime) {
	            velocityAtTime = this.getVelocityAtTime.bind(this);
	        }
	
	        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
	
	        function lookAt(elem1,elem2){
	            var fVec = [elem2[0]-elem1[0],elem2[1]-elem1[1],elem2[2]-elem1[2]];
	            var pitch = Math.atan2(fVec[0],Math.sqrt(fVec[1]*fVec[1]+fVec[2]*fVec[2]))/degToRads;
	            var yaw = -Math.atan2(fVec[1],fVec[2])/degToRads;
	            return [yaw,pitch,0];
	        }
	
	        function easeOut(t, tMin, tMax, val1, val2){
	            return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
	        }
	
	        function easeIn(t, tMin, tMax, val1, val2){
	            return applyEase(easeInBez, t, tMin, tMax, val1, val2);
	        }
	
	        function ease(t, tMin, tMax, val1, val2){
	            return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
	        }
	
	        function applyEase(fn, t, tMin, tMax, val1, val2) {
	            if(val1 === undefined){
	                val1 = tMin;
	                val2 = tMax;
	            } else {
	                t = (t - tMin) / (tMax - tMin);
	            }
	            t = t > 1 ? 1 : t < 0 ? 0 : t;
	            var mult = fn(t);
	            if($bm_isInstanceOfArray(val1)) {
	                var i, len = val1.length;
	                var arr = createTypedArray('float32', len);
	                for (i = 0; i < len; i += 1) {
	                    arr[i] = (val2[i] - val1[i]) * mult + val1[i];
	                }
	                return arr;
	            } else {
	                return (val2 - val1) * mult + val1;
	            }
	        }
	
	        function nearestKey(time){
	            var i, len = data.k.length,index,keyTime;
	            if(!data.k.length || typeof(data.k[0]) === 'number'){
	                index = 0;
	                keyTime = 0;
	            } else {
	                index = -1;
	                time *= elem.comp.globalData.frameRate;
	                if (time < data.k[0].t) {
	                    index = 1;
	                    keyTime = data.k[0].t;
	                } else {
	                    for(i=0;i<len-1;i+=1){
	                        if(time === data.k[i].t){
	                            index = i + 1;
	                            keyTime = data.k[i].t;
	                            break;
	                        }else if(time>data.k[i].t && time<data.k[i+1].t){
	                            if(time-data.k[i].t > data.k[i+1].t - time){
	                                index = i + 2;
	                                keyTime = data.k[i+1].t;
	                            } else {
	                                index = i + 1;
	                                keyTime = data.k[i].t;
	                            }
	                            break;
	                        }
	                    }
	                    if(index === -1){
	                        index = i + 1;
	                        keyTime = data.k[i].t;
	                    }
	                }
	                
	            }
	            var ob = {};
	            ob.index = index;
	            ob.time = keyTime/elem.comp.globalData.frameRate;
	            return ob;
	        }
	
	        function key(ind){
	            var ob, i, len;
	            if(!data.k.length || typeof(data.k[0]) === 'number'){
	                throw new Error('The property has no keyframe at index ' + ind);
	            }
	            ind -= 1;
	            ob = {
	                time: data.k[ind].t/elem.comp.globalData.frameRate
	            };
	            var arr;
	            if(ind === data.k.length - 1 && !data.k[ind].h){
	                arr = data.k[ind-1].e;
	            }else{
	                arr = data.k[ind].s;
	            }
	            len = arr.length;
	            for(i=0;i<len;i+=1){
	                ob[i] = arr[i];
	            }
	            return ob;
	        }
	
	        function framesToTime(frames, fps) { 
	            if (!fps) {
	                fps = elem.comp.globalData.frameRate;
	            }
	            return frames / fps;
	        }
	
	        function timeToFrames(t, fps) {
	            if (!t && t !== 0) {
	                t = time;
	            }
	            if (!fps) {
	                fps = elem.comp.globalData.frameRate;
	            }
	            return t * fps;
	        }
	
	        function seedRandom(seed){
	            BMMath.seedrandom(randSeed + seed);
	        }
	
	        function sourceRectAtTime() {
	            return elem.sourceRectAtTime();
	        }
	
	        function substring(init, end) {
	            if(typeof value === 'string') {
	                if(end === undefined) {
	                return value.substring(init)
	                }
	                return value.substring(init, end)
	            }
	            return '';
	        }
	
	        function substr(init, end) {
	            if(typeof value === 'string') {
	                if(end === undefined) {
	                return value.substr(init)
	                }
	                return value.substr(init, end)
	            }
	            return '';
	        }
	
	        var time, velocity, value, text, textIndex, textTotal, selectorValue;
	        var index = elem.data.ind;
	        var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	        var parent;
	        var randSeed = Math.floor(Math.random()*1000000);
	        var globalData = elem.globalData;
	        function executeExpression(_value) {
	            // globalData.pushExpression();
	            value = _value;
	            if (_needsRandom) {
	                seedRandom(randSeed);
	            }
	            if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') {
	                return value;
	            }
	            if(this.propType === 'textSelector'){
	                textIndex = this.textIndex;
	                textTotal = this.textTotal;
	                selectorValue = this.selectorValue;
	            }
	            if (!thisLayer) {
	                text = elem.layerInterface.text;
	                thisLayer = elem.layerInterface;
	                thisComp = elem.comp.compInterface;
	                toWorld = thisLayer.toWorld.bind(thisLayer);
	                fromWorld = thisLayer.fromWorld.bind(thisLayer);
	                fromComp = thisLayer.fromComp.bind(thisLayer);
	                toComp = thisLayer.toComp.bind(thisLayer);
	                mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
	                fromCompToSurface = fromComp;
	            }
	            if (!transform) {
	                transform = elem.layerInterface("ADBE Transform Group");
	                $bm_transform = transform;
	                if(transform) {
	                    anchorPoint = transform.anchorPoint;
	                    /*position = transform.position;
	                    rotation = transform.rotation;
	                    scale = transform.scale;*/
	                }
	            }
	            
	            if (elemType === 4 && !content) {
	                content = thisLayer("ADBE Root Vectors Group");
	            }
	            if (!effect) {
	                effect = thisLayer(4);
	            }
	            hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	            if (hasParent && !parent) {
	                parent = elem.hierarchy[0].layerInterface;
	            }
	            time = this.comp.renderedFrame/this.comp.globalData.frameRate;
	            if (needsVelocity) {
	                velocity = velocityAtTime(time);
	            }
	            expression_function();
	            this.frameExpressionId = elem.globalData.frameId;
	
	
	            //TODO: Check if it's possible to return on ShapeInterface the .v value
	            if (scoped_bm_rt.propType === "shape") {
	                scoped_bm_rt = scoped_bm_rt.v;
	            }
	            // globalData.popExpression();
	            return scoped_bm_rt;
	        }
	        return executeExpression;
	    }
	
	    ob.initiateExpression = initiateExpression;
	    return ob;
	}());
	(function addPropertyDecorator() {
	
	    function getStaticValueAtTime() {
	        return this.pv;
	    }
	
	    function loopOut(type,duration,durationFlag){
	        if(!this.k || !this.keyframes){
	            return this.pv;
	        }
	        type = type ? type.toLowerCase() : '';
	        var currentFrame = this.comp.renderedFrame;
	        var keyframes = this.keyframes;
	        var lastKeyFrame = keyframes[keyframes.length - 1].t;
	        if(currentFrame<=lastKeyFrame){
	            return this.pv;
	        }else{
	            var cycleDuration, firstKeyFrame;
	            if(!durationFlag){
	                if(!duration || duration > keyframes.length - 1){
	                    duration = keyframes.length - 1;
	                }
	                firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
	                cycleDuration = lastKeyFrame - firstKeyFrame;
	            } else {
	                if(!duration){
	                    cycleDuration = Math.max(0,lastKeyFrame - this.elem.data.ip);
	                } else {
	                    cycleDuration = Math.abs(lastKeyFrame - elem.comp.globalData.frameRate*duration);
	                }
	                firstKeyFrame = lastKeyFrame - cycleDuration;
	            }
	            var i, len, ret;
	            if(type === 'pingpong') {
	                var iterations = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
	                if(iterations % 2 !== 0){
	                    return this.getValueAtTime(((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	                }
	            } else if(type === 'offset'){
	                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	                var repeats = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
	                if(this.pv.length){
	                    ret = new Array(initV.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = (endV[i]-initV[i])*repeats + current[i];
	                    }
	                    return ret;
	                }
	                return (endV-initV)*repeats + current;
	            } else if(type === 'continue'){
	                var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
	                if(this.pv.length){
	                    ret = new Array(lastValue.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = lastValue[i] + (lastValue[i]-nextLastValue[i])*((currentFrame - lastKeyFrame)/ this.comp.globalData.frameRate)/0.0005;
	                    }
	                    return ret;
	                }
	                return lastValue + (lastValue-nextLastValue)*(((currentFrame - lastKeyFrame))/0.001);
	            }
	            return this.getValueAtTime((((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	        }
	    }
	
	    function loopIn(type,duration, durationFlag) {
	        if(!this.k){
	            return this.pv;
	        }
	        type = type ? type.toLowerCase() : '';
	        var currentFrame = this.comp.renderedFrame;
	        var keyframes = this.keyframes;
	        var firstKeyFrame = keyframes[0].t;
	        if(currentFrame>=firstKeyFrame){
	            return this.pv;
	        }else{
	            var cycleDuration, lastKeyFrame;
	            if(!durationFlag){
	                if(!duration || duration > keyframes.length - 1){
	                    duration = keyframes.length - 1;
	                }
	                lastKeyFrame = keyframes[duration].t;
	                cycleDuration = lastKeyFrame - firstKeyFrame;
	            } else {
	                if(!duration){
	                    cycleDuration = Math.max(0,this.elem.data.op - firstKeyFrame);
	                } else {
	                    cycleDuration = Math.abs(elem.comp.globalData.frameRate*duration);
	                }
	                lastKeyFrame = firstKeyFrame + cycleDuration;
	            }
	            var i, len, ret;
	            if(type === 'pingpong') {
	                var iterations = Math.floor((firstKeyFrame - currentFrame)/cycleDuration);
	                if(iterations % 2 === 0){
	                    return this.getValueAtTime((((firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	                }
	            } else if(type === 'offset'){
	                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	                var repeats = Math.floor((firstKeyFrame - currentFrame)/cycleDuration)+1;
	                if(this.pv.length){
	                    ret = new Array(initV.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = current[i]-(endV[i]-initV[i])*repeats;
	                    }
	                    return ret;
	                }
	                return current-(endV-initV)*repeats;
	            } else if(type === 'continue'){
	                var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
	                if(this.pv.length){
	                    ret = new Array(firstValue.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = firstValue[i] + (firstValue[i]-nextFirstValue[i])*(firstKeyFrame - currentFrame)/0.001;
	                    }
	                    return ret;
	                }
	                return firstValue + (firstValue-nextFirstValue)*(firstKeyFrame - currentFrame)/0.001;
	            }
	            return this.getValueAtTime(((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	        }
	    }
	
	    function getValueAtTime(frameNum) {
	        frameNum *= this.elem.globalData.frameRate;
	        frameNum -= this.offsetTime;
	        if(frameNum !== this._cachingAtTime.lastFrame) {
	            this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
	            this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
	            this._cachingAtTime.lastFrame = frameNum;
	        }
	        return this._cachingAtTime.value;
	
	    }
	
	    function getSpeedAtTime(frameNum) {
	        var delta = -0.01;
	        var v1 = this.getValueAtTime(frameNum);
	        var v2 = this.getValueAtTime(frameNum + delta);
	        var speed = 0;
	        if(v1.length){
	            var i;
	            for(i=0;i<v1.length;i+=1){
	                speed += Math.pow(v2[i] - v1[i], 2);
	            }
	            speed = Math.sqrt(speed) * 100;
	        } else {
	            speed = 0;
	        }
	        return speed;
	    }
	
	    function getVelocityAtTime(frameNum) {
	        if(this.vel !== undefined){
	            return this.vel;
	        }
	        var delta = -0.001;
	        //frameNum += this.elem.data.st;
	        var v1 = this.getValueAtTime(frameNum);
	        var v2 = this.getValueAtTime(frameNum + delta);
	        var velocity;
	        if(v1.length){
	            velocity = createTypedArray('float32', v1.length);
	            var i;
	            for(i=0;i<v1.length;i+=1){
	                //removing frameRate
	                //if needed, don't add it here
	                //velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
	                velocity[i] = (v2[i] - v1[i])/delta;
	            }
	        } else {
	            velocity = (v2 - v1)/delta;
	        }
	        return velocity;
	    }
	
	    function setGroupProperty(propertyGroup){
	        this.propertyGroup = propertyGroup;
	    }
	
	    function searchExpressions(elem,data,prop){
	        if(data.x){
	            prop.k = true;
	            prop.x = true;
	            prop.initiateExpression = ExpressionManager.initiateExpression;
	            prop.effectsSequence.push(prop.initiateExpression(elem,data,prop).bind(prop));
	        }
	    }
	
	    function getTransformValueAtTime(time) {
	        console.warn('Transform at time not supported');
	    }
	
	    function getTransformStaticValueAtTime(time) {
	
	    }
	
	    var TextExpressionSelectorProp = (function(){
	
	        function getValueProxy(index,total){
	            this.textIndex = index+1;
	            this.textTotal = total;
	            this.getValue();
	            return this.v;
	        }
	
	        return function TextExpressionSelectorProp(elem,data){
	            this.pv = 1;
	            this.comp = elem.comp;
	            this.elem = elem;
	            this.mult = 0.01;
	            this.propType = 'textSelector';
	            this.textTotal = data.totalChars;
	            this.selectorValue = 100;
	            this.lastValue = [1,1,1];
	            searchExpressions.bind(this)(elem,data,this);
	            this.getMult = getValueProxy;
	            this.getVelocityAtTime = getVelocityAtTime;
	            if(this.kf){
	                this.getValueAtTime = getValueAtTime.bind(this);
	            } else {
	                this.getValueAtTime = getStaticValueAtTime.bind(this);
	            }
	            this.setGroupProperty = setGroupProperty;
	        };
	    }());
	
	    var getTransformProperty = TransformPropertyFactory.getTransformProperty;
	    TransformPropertyFactory.getTransformProperty = function(elem, data, container) {
	        var prop = getTransformProperty(elem, data, container);
	        if(prop.dynamicProperties.length) {
	            prop.getValueAtTime = getTransformValueAtTime.bind(prop);
	        } else {
	            prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
	        }
	        prop.setGroupProperty = setGroupProperty;
	        return prop;
	    };
	
	    var propertyGetProp = PropertyFactory.getProp;
	    PropertyFactory.getProp = function(elem,data,type, mult, container){
	        var prop = propertyGetProp(elem,data,type, mult, container);
	        //prop.getVelocityAtTime = getVelocityAtTime;
	        //prop.loopOut = loopOut;
	        //prop.loopIn = loopIn;
	        if(prop.kf){
	            prop.getValueAtTime = getValueAtTime.bind(prop);
	        } else {
	            prop.getValueAtTime = getStaticValueAtTime.bind(prop);
	        }
	        prop.setGroupProperty = setGroupProperty;
	        prop.loopOut = loopOut;
	        prop.loopIn = loopIn;
	        prop.getVelocityAtTime = getVelocityAtTime.bind(prop);
	        prop.getSpeedAtTime = getSpeedAtTime.bind(prop);
	        prop.numKeys = data.a === 1 ? data.k.length : 0;
	        prop.propertyIndex = data.ix;
	        var value = 0;
	        if(type !== 0) {
	            value = createTypedArray('float32', data.a === 1 ?  data.k[0].s.length : data.k.length);
	        }
	        prop._cachingAtTime = {
	            lastFrame: initialDefaultFrame,
	            lastIndex: 0,
	            value: value
	        };
	        searchExpressions(elem,data,prop);
	        if(prop.k){
	            container.addDynamicProperty(prop);
	        }
	
	        return prop;
	    };
	
	    function getShapeValueAtTime(frameNum) {
	        //For now this caching object is created only when needed instead of creating it when the shape is initialized.
	        if (!this._cachingAtTime) {
	            this._cachingAtTime = {
	                shapeValue: shape_pool.clone(this.pv),
	                lastIndex: 0,
	                lastTime: initialDefaultFrame
	            };
	        }
	        
	        frameNum *= this.elem.globalData.frameRate;
	        frameNum -= this.offsetTime;
	        if(frameNum !== this._cachingAtTime.lastTime) {
	            this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
	            this._cachingAtTime.lastTime = frameNum;
	            this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
	        }
	        return this._cachingAtTime.shapeValue;
	    }
	
	    var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
	    var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
	
	    function ShapeExpressions(){}
	    ShapeExpressions.prototype = {
	        vertices: function(prop, time){
	            if (this.k) {
	                this.getValue();
	            }
	            var shapePath = this.v;
	            if(time !== undefined) {
	                shapePath = this.getValueAtTime(time, 0);
	            }
	            var i, len = shapePath._length;
	            var vertices = shapePath[prop];
	            var points = shapePath.v;
	            var arr = createSizedArray(len);
	            for(i = 0; i < len; i += 1) {
	                if(prop === 'i' || prop === 'o') {
	                    arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]];
	                } else {
	                    arr[i] = [vertices[i][0], vertices[i][1]];
	                }
	                
	            }
	            return arr;
	        },
	        points: function(time){
	            return this.vertices('v', time);
	        },
	        inTangents: function(time){
	            return this.vertices('i', time);
	        },
	        outTangents: function(time){
	            return this.vertices('o', time);
	        },
	        isClosed: function(){
	            return this.v.c;
	        },
	        pointOnPath: function(perc, time){
	            var shapePath = this.v;
	            if(time !== undefined) {
	                shapePath = this.getValueAtTime(time, 0);
	            }
	            if(!this._segmentsLength) {
	                this._segmentsLength = bez.getSegmentsLength(shapePath);
	            }
	
	            var segmentsLength = this._segmentsLength;
	            var lengths = segmentsLength.lengths;
	            var lengthPos = segmentsLength.totalLength * perc;
	            var i = 0, len = lengths.length;
	            var j = 0, jLen;
	            var accumulatedLength = 0, pt;
	            while(i < len) {
	                if(accumulatedLength + lengths[i].addedLength > lengthPos) {
	                    var initIndex = i;
	                    var endIndex = (shapePath.c && i === len - 1) ? 0 : i + 1;
	                    var segmentPerc = (lengthPos - accumulatedLength)/lengths[i].addedLength;
	                    pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
	                    break;
	                } else {
	                    accumulatedLength += lengths[i].addedLength;
	                }
	                i += 1;
	            }
	            if(!pt){
	                pt = shapePath.c ? [shapePath.v[0][0],shapePath.v[0][1]]:[shapePath.v[shapePath._length-1][0],shapePath.v[shapePath._length-1][1]];
	            }
	            return pt;
	        },
	        vectorOnPath: function(perc, time, vectorType){
	            //perc doesn't use triple equality because it can be a Number object as well as a primitive.
	            perc = perc == 1 ? this.v.c ? 0 : 0.999 : perc;
	            var pt1 = this.pointOnPath(perc, time);
	            var pt2 = this.pointOnPath(perc + 0.001, time);
	            var xLength = pt2[0] - pt1[0];
	            var yLength = pt2[1] - pt1[1];
	            var magnitude = Math.sqrt(Math.pow(xLength,2) + Math.pow(yLength,2));
	            var unitVector = vectorType === 'tangent' ? [xLength/magnitude, yLength/magnitude] : [-yLength/magnitude, xLength/magnitude];
	            return unitVector;
	        },
	        tangentOnPath: function(perc, time){
	            return this.vectorOnPath(perc, time, 'tangent');
	        },
	        normalOnPath: function(perc, time){
	            return this.vectorOnPath(perc, time, 'normal');
	        },
	        setGroupProperty: setGroupProperty,
	        getValueAtTime: getStaticValueAtTime
	    };
	    extendPrototype([ShapeExpressions], ShapePropertyConstructorFunction);
	    extendPrototype([ShapeExpressions], KeyframedShapePropertyConstructorFunction);
	    KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
	    KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
	
	    var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
	    ShapePropertyFactory.getShapeProp = function(elem,data,type, arr, trims){
	        var prop = propertyGetShapeProp(elem,data,type, arr, trims);
	        prop.propertyIndex = data.ix;
	        prop.lock = false;
	        if(type === 3){
	            searchExpressions(elem,data.pt,prop);
	        } else if(type === 4){
	            searchExpressions(elem,data.ks,prop);
	        }
	        if(prop.k){
	            elem.addDynamicProperty(prop);
	        }
	        return prop;
	    };
	
	    var propertyGetTextProp = TextSelectorProp.getTextSelectorProp;
	    TextSelectorProp.getTextSelectorProp = function(elem, data,arr){
	        if(data.t === 1){
	            return new TextExpressionSelectorProp(elem, data,arr);
	        } else {
	            return propertyGetTextProp(elem,data,arr);
	        }
	    };
	}());
	(function addDecorator() {
	
	    function searchExpressions(){
	        if(this.data.d.x){
	            this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem,this.data.d,this);
	            this.addEffect(this.getExpressionValue.bind(this));
	            return true;
	        }
	    }
	
	    TextProperty.prototype.getExpressionValue = function(currentValue, text) {
	        var newValue = this.calculateExpression(text);
	        if(currentValue.t !== newValue) {
	            var newData = {};
	            this.copyData(newData, currentValue);
	            newData.t = newValue.toString();
	            newData.__complete = false;
	            return newData;
	        }
	        return currentValue;
	    }
	
	    TextProperty.prototype.searchProperty = function(){
	
	        var isKeyframed = this.searchKeyframes();
	        var hasExpressions = this.searchExpressions();
	        this.kf = isKeyframed || hasExpressions;
	        return this.kf;
	    };
	
	    TextProperty.prototype.searchExpressions = searchExpressions;
	    
	}());
	var ShapeExpressionInterface = (function(){
	
	    function iterateElements(shapes,view, propertyGroup){
	        var arr = [];
	        var i, len = shapes ? shapes.length : 0;
	        for(i=0;i<len;i+=1){
	            if(shapes[i].ty == 'gr'){
	                arr.push(groupInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'fl'){
	                arr.push(fillInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'st'){
	                arr.push(strokeInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'tm'){
	                arr.push(trimInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'tr'){
	                //arr.push(transformInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'el'){
	                arr.push(ellipseInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'sr'){
	                arr.push(starInterfaceFactory(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'sh'){
	                arr.push(pathInterfaceFactory(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rc'){
	                arr.push(rectInterfaceFactory(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rd'){
	                arr.push(roundedInterfaceFactory(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rp'){
	                arr.push(repeaterInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }
	        }
	        return arr;
	    }
	
	    function contentsInterfaceFactory(shape,view, propertyGroup){
	       var interfaces;
	       var interfaceFunction = function _interfaceFunction(value){
	           var i = 0, len = interfaces.length;
	            while(i<len){
	                if(interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value){
	                   return interfaces[i];
	                }
	                i+=1;
	            }
	            if(typeof value === 'number'){
	               return interfaces[value-1];
	            }
	       };
	       interfaceFunction.propertyGroup = function(val){
	           if(val === 1){
	               return interfaceFunction;
	           } else{
	               return propertyGroup(val-1);
	           }
	       };
	       interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
	       interfaceFunction.numProperties = interfaces.length;
	       interfaceFunction.propertyIndex = shape.cix;
	       interfaceFunction._name = shape.nm;
	
	       return interfaceFunction;
	   }
	
	    function groupInterfaceFactory(shape,view, propertyGroup){
	        var interfaceFunction = function _interfaceFunction(value){
	            switch(value){
	                case 'ADBE Vectors Group':
	                case 'Contents':
	                case 2:
	                    return interfaceFunction.content;
	                //Not necessary for now. Keeping them here in case a new case appears
	                //case 'ADBE Vector Transform Group':
	                //case 3:
	                default:
	                    return interfaceFunction.transform;
	            }
	        };
	        interfaceFunction.propertyGroup = function(val){
	            if(val === 1){
	                return interfaceFunction;
	            } else{
	                return propertyGroup(val-1);
	            }
	        };
	        var content = contentsInterfaceFactory(shape,view,interfaceFunction.propertyGroup);
	        var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1],view.it[view.it.length - 1],interfaceFunction.propertyGroup);
	        interfaceFunction.content = content;
	        interfaceFunction.transform = transformInterface;
	        Object.defineProperty(interfaceFunction, '_name', {
	            get: function(){
	                return shape.nm;
	            }
	        });
	        //interfaceFunction.content = interfaceFunction;
	        interfaceFunction.numProperties = shape.np;
	        interfaceFunction.propertyIndex = shape.ix;
	        interfaceFunction.nm = shape.nm;
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function fillInterfaceFactory(shape,view,propertyGroup){
	        function interfaceFunction(val){
	            if(val === 'Color' || val === 'color'){
	                return interfaceFunction.color;
	            } else if(val === 'Opacity' || val === 'opacity'){
	                return interfaceFunction.opacity;
	            }
	        }
	        Object.defineProperties(interfaceFunction, {
	            'color': {
	                get: ExpressionPropertyInterface(view.c)
	            },
	            'opacity': {
	                get: ExpressionPropertyInterface(view.o)
	            },
	            '_name': { value: shape.nm },
	            'mn': { value: shape.mn }
	        });
	
	        view.c.setGroupProperty(propertyGroup);
	        view.o.setGroupProperty(propertyGroup);
	        return interfaceFunction;
	    }
	
	    function strokeInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val === 1){
	                return ob;
	            } else{
	                return propertyGroup(val-1);
	            }
	        }
	        function _dashPropertyGroup(val){
	            if(val === 1){
	                return dashOb;
	            } else{
	                return _propertyGroup(val-1);
	            }
	        }
	        function addPropertyToDashOb(i) {
	            Object.defineProperty(dashOb, shape.d[i].nm, {
	                get: ExpressionPropertyInterface(view.d.dataProps[i].p)
	            });
	        }
	        var i, len = shape.d ? shape.d.length : 0;
	        var dashOb = {};
	        for (i = 0; i < len; i += 1) {
	            addPropertyToDashOb(i);
	            view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
	        }
	
	        function interfaceFunction(val){
	            if(val === 'Color' || val === 'color'){
	                return interfaceFunction.color;
	            } else if(val === 'Opacity' || val === 'opacity'){
	                return interfaceFunction.opacity;
	            } else if(val === 'Stroke Width' || val === 'stroke width'){
	                return interfaceFunction.strokeWidth;
	            }
	        }
	        Object.defineProperties(interfaceFunction, {
	            'color': {
	                get: ExpressionPropertyInterface(view.c)
	            },
	            'opacity': {
	                get: ExpressionPropertyInterface(view.o)
	            },
	            'strokeWidth': {
	                get: ExpressionPropertyInterface(view.w)
	            },
	            'dash': {
	                get: function() {
	                    return dashOb;
	                }
	            },
	            '_name': { value: shape.nm },
	            'mn': { value: shape.mn }
	        });
	
	        view.c.setGroupProperty(_propertyGroup);
	        view.o.setGroupProperty(_propertyGroup);
	        view.w.setGroupProperty(_propertyGroup);
	        return interfaceFunction;
	    }
	
	    function trimInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        interfaceFunction.propertyIndex = shape.ix;
	
	        view.s.setGroupProperty(_propertyGroup);
	        view.e.setGroupProperty(_propertyGroup);
	        view.o.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(val){
	            if(val === shape.e.ix || val === 'End' || val === 'end'){
	                return interfaceFunction.end;
	            }
	            if(val === shape.s.ix){
	                return interfaceFunction.start;
	            }
	            if(val === shape.o.ix){
	                return interfaceFunction.offset;
	            }
	        }
	        interfaceFunction.propertyIndex = shape.ix;
	
	        Object.defineProperties(interfaceFunction, {
	            'start': {
	                get: ExpressionPropertyInterface(view.s)
	            },
	            'end': {
	                get: ExpressionPropertyInterface(view.e)
	            },
	            'offset': {
	                get: ExpressionPropertyInterface(view.o)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function transformInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        view.transform.mProps.o.setGroupProperty(_propertyGroup);
	        view.transform.mProps.p.setGroupProperty(_propertyGroup);
	        view.transform.mProps.a.setGroupProperty(_propertyGroup);
	        view.transform.mProps.s.setGroupProperty(_propertyGroup);
	        view.transform.mProps.r.setGroupProperty(_propertyGroup);
	        if(view.transform.mProps.sk){
	            view.transform.mProps.sk.setGroupProperty(_propertyGroup);
	            view.transform.mProps.sa.setGroupProperty(_propertyGroup);
	        }
	        view.transform.op.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(value){
	            if(shape.a.ix === value || value === 'Anchor Point'){
	                return interfaceFunction.anchorPoint;
	            }
	            if(shape.o.ix === value || value === 'Opacity'){
	                return interfaceFunction.opacity;
	            }
	            if(shape.p.ix === value || value === 'Position'){
	                return interfaceFunction.position;
	            }
	            if(shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation'){
	                return interfaceFunction.rotation;
	            }
	            if(shape.s.ix === value || value === 'Scale'){
	                return interfaceFunction.scale;
	            }
	            if(shape.sk && shape.sk.ix === value || value === 'Skew'){
	                return interfaceFunction.skew;
	            }
	            if(shape.sa && shape.sa.ix === value || value === 'Skew Axis'){
	                return interfaceFunction.skewAxis;
	            }
	
	        }
	        Object.defineProperties(interfaceFunction, {
	            'opacity': {
	                get: ExpressionPropertyInterface(view.transform.mProps.o)
	            },
	            'position': {
	                get: ExpressionPropertyInterface(view.transform.mProps.p)
	            },
	            'anchorPoint': {
	                get: ExpressionPropertyInterface(view.transform.mProps.a)
	            },
	            'scale': {
	                get: ExpressionPropertyInterface(view.transform.mProps.s)
	            },
	            'rotation': {
	                get: ExpressionPropertyInterface(view.transform.mProps.r)
	            },
	            'skew': {
	                get: ExpressionPropertyInterface(view.transform.mProps.sk)
	            },
	            'skewAxis': {
	                get: ExpressionPropertyInterface(view.transform.mProps.sa)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.ty = 'tr';
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function ellipseInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        interfaceFunction.propertyIndex = shape.ix;
	        var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	        prop.s.setGroupProperty(_propertyGroup);
	        prop.p.setGroupProperty(_propertyGroup);
	        function interfaceFunction(value){
	            if(shape.p.ix === value){
	                return interfaceFunction.position;
	            }
	            if(shape.s.ix === value){
	                return interfaceFunction.size;
	            }
	        }
	
	        Object.defineProperties(interfaceFunction, {
	            'size': {
	                get: ExpressionPropertyInterface(prop.s)
	            },
	            'position': {
	                get: ExpressionPropertyInterface(prop.p)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function starInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	        interfaceFunction.propertyIndex = shape.ix;
	        prop.or.setGroupProperty(_propertyGroup);
	        prop.os.setGroupProperty(_propertyGroup);
	        prop.pt.setGroupProperty(_propertyGroup);
	        prop.p.setGroupProperty(_propertyGroup);
	        prop.r.setGroupProperty(_propertyGroup);
	        if(shape.ir){
	            prop.ir.setGroupProperty(_propertyGroup);
	            prop.is.setGroupProperty(_propertyGroup);
	        }
	
	        function interfaceFunction(value){
	            if(shape.p.ix === value){
	                return interfaceFunction.position;
	            }
	            if(shape.r.ix === value){
	                return interfaceFunction.rotation;
	            }
	            if(shape.pt.ix === value){
	                return interfaceFunction.points;
	            }
	            if(shape.or.ix === value || 'ADBE Vector Star Outer Radius' === value){
	                return interfaceFunction.outerRadius;
	            }
	            if(shape.os.ix === value){
	                return interfaceFunction.outerRoundness;
	            }
	            if(shape.ir && (shape.ir.ix === value || 'ADBE Vector Star Inner Radius' === value)){
	                return interfaceFunction.innerRadius;
	            }
	            if(shape.is && shape.is.ix === value){
	                return interfaceFunction.innerRoundness;
	            }
	
	        }
	
	        Object.defineProperties(interfaceFunction, {
	            'position': {
	                get: ExpressionPropertyInterface(prop.p)
	            },
	            'rotation': {
	                get: ExpressionPropertyInterface(prop.r)
	            },
	            'points': {
	                get: ExpressionPropertyInterface(prop.pt)
	            },
	            'outerRadius': {
	                get: ExpressionPropertyInterface(prop.or)
	            },
	            'outerRoundness': {
	                get: ExpressionPropertyInterface(prop.os)
	            },
	            'innerRadius': {
	                get: ExpressionPropertyInterface(prop.ir)
	            },
	            'innerRoundness': {
	                get: ExpressionPropertyInterface(prop.is)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function rectInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	        interfaceFunction.propertyIndex = shape.ix;
	        prop.p.setGroupProperty(_propertyGroup);
	        prop.s.setGroupProperty(_propertyGroup);
	        prop.r.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(value){
	            if(shape.p.ix === value){
	                return interfaceFunction.position;
	            }
	            if(shape.r.ix === value){
	                return interfaceFunction.roundness;
	            }
	            if(shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size'){
	                return interfaceFunction.size;
	            }
	
	        }
	        Object.defineProperties(interfaceFunction, {
	            'position': {
	                get: ExpressionPropertyInterface(prop.p)
	            },
	            'roundness': {
	                get: ExpressionPropertyInterface(prop.r)
	            },
	            'size': {
	                get: ExpressionPropertyInterface(prop.s)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function roundedInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        var prop = view;
	        interfaceFunction.propertyIndex = shape.ix;
	        prop.rd.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(value){
	            if(shape.r.ix === value || 'Round Corners 1' === value){
	                return interfaceFunction.radius;
	            }
	
	        }
	        Object.defineProperties(interfaceFunction, {
	            'radius': {
	                get: ExpressionPropertyInterface(prop.rd)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function repeaterInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        var prop = view;
	        interfaceFunction.propertyIndex = shape.ix;
	        prop.c.setGroupProperty(_propertyGroup);
	        prop.o.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(value){
	            if(shape.c.ix === value || 'Copies' === value){
	                return interfaceFunction.copies;
	            } else if(shape.o.ix === value || 'Offset' === value){
	                return interfaceFunction.offset;
	            }
	
	        }
	        Object.defineProperties(interfaceFunction, {
	            'copies': {
	                get: ExpressionPropertyInterface(prop.c)
	            },
	            'offset': {
	                get: ExpressionPropertyInterface(prop.o)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function pathInterfaceFactory(shape,view,propertyGroup){
	        var prop = view.sh;
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        prop.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(val){
	            if(val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2){
	                return interfaceFunction.path;
	            }
	        }
	        Object.defineProperties(interfaceFunction, {
	            'path': {
	                get: function(){
	                    if(prop.k){
	                        prop.getValue();
	                    }
	                    return prop;
	                }
	            },
	            'shape': {
	                get: function(){
	                    if(prop.k){
	                        prop.getValue();
	                    }
	                    return prop;
	                }
	            },
	            '_name': { value: shape.nm },
	            'ix': { value: shape.ix },
	            'mn': { value: shape.mn }
	        });
	        return interfaceFunction;
	    }
	
	    return function(shapes,view,propertyGroup) {
	        var interfaces;
	        function _interfaceFunction(value){
	            if(typeof value === 'number'){
	                return interfaces[value-1];
	            } else {
	                var i = 0, len = interfaces.length;
	                while(i<len){
	                    if(interfaces[i]._name === value){
	                        return interfaces[i];
	                    }
	                    i+=1;
	                }
	            }
	        }
	        _interfaceFunction.propertyGroup = propertyGroup;
	        interfaces = iterateElements(shapes, view, _interfaceFunction);
	        return _interfaceFunction;
	    };
	}());
	
	var TextExpressionInterface = (function(){
		return function(elem){
	        var _prevValue, _sourceText;
	        function _thisLayerFunction(){
	        }
	        Object.defineProperty(_thisLayerFunction, "sourceText", {
	            get: function(){
	                elem.textProperty.getValue()
	                var stringValue = elem.textProperty.currentData.t;
	                if(stringValue !== _prevValue) {
	                    elem.textProperty.currentData.t = _prevValue;
	                    _sourceText = new String(stringValue);
	                    //If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
	                    _sourceText.value = stringValue ? stringValue : new String(stringValue);
	                }
	                return _sourceText;
	            }
	        });
	        return _thisLayerFunction;
	    };
	}());
	var LayerExpressionInterface = (function (){
	    function toWorld(arr, time){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        var transformMat;
	        if(time) {
	            //Todo implement value at time on transform properties
	            //transformMat = this._elem.finalTransform.mProp.getValueAtTime(time);
	            transformMat = this._elem.finalTransform.mProp;
	        } else {
	            transformMat = this._elem.finalTransform.mProp;
	        }
	        transformMat.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
	        }
	        return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
	    }
	    function fromWorld(arr, time){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        var transformMat;
	        if(time) {
	            //Todo implement value at time on transform properties
	            //transformMat = this._elem.finalTransform.mProp.getValueAtTime(time);
	            transformMat = this._elem.finalTransform.mProp;
	        } else {
	            transformMat = this._elem.finalTransform.mProp;
	        }
	        transformMat.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.inversePoint(arr);
	        }
	        return toWorldMat.inversePoint(arr);
	    }
	    function fromComp(arr){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.inversePoint(arr);
	        }
	        return toWorldMat.inversePoint(arr);
	    }
	
	    function sampleImage() {
	        return [1,1,1,1];
	    }
	
	
	    return function(elem){
	
	        var transformInterface;
	
	        function _registerMaskInterface(maskManager){
	            _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
	        }
	        function _registerEffectsInterface(effects){
	            _thisLayerFunction.effect = effects;
	        }
	
	        function _thisLayerFunction(name){
	            switch(name){
	                case "ADBE Root Vectors Group":
	                case "Contents":
	                case 2:
	                    return _thisLayerFunction.shapeInterface;
	                case 1:
	                case 6:
	                case "Transform":
	                case "transform":
	                case "ADBE Transform Group":
	                    return transformInterface;
	                case 4:
	                case "ADBE Effect Parade":
	                case "effects":
	                case "Effects":
	                    return _thisLayerFunction.effect;
	            }
	        }
	        _thisLayerFunction.toWorld = toWorld;
	        _thisLayerFunction.fromWorld = fromWorld;
	        _thisLayerFunction.toComp = toWorld;
	        _thisLayerFunction.fromComp = fromComp;
	        _thisLayerFunction.sampleImage = sampleImage;
	        _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
	        _thisLayerFunction._elem = elem;
	        transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
	        var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
	        Object.defineProperties(_thisLayerFunction,{
	            hasParent: {
	                get: function(){
	                    return elem.hierarchy.length;
	                }
	            },
	            parent: {
	                get: function(){
	                    return elem.hierarchy[0].layerInterface;
	                }
	            },
	            rotation: getDescriptor(transformInterface, 'rotation'),
	            scale: getDescriptor(transformInterface, 'scale'),
	            position: getDescriptor(transformInterface, 'position'),
	            opacity: getDescriptor(transformInterface, 'opacity'),
	            anchorPoint: anchorPointDescriptor,
	            anchor_point: anchorPointDescriptor,
	            transform: {
	                get: function () {
	                    return transformInterface;
	                }
	            },
	            active: {
	                get: function(){
	                    return elem.isInRange;
	                }
	            }
	        });
	
	        _thisLayerFunction.startTime = elem.data.st;
	        _thisLayerFunction.index = elem.data.ind;
	        _thisLayerFunction.source = elem.data.refId;
	        _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
	        _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
	        _thisLayerFunction.inPoint = elem.data.ip/elem.comp.globalData.frameRate;
	        _thisLayerFunction.outPoint = elem.data.op/elem.comp.globalData.frameRate;
	        _thisLayerFunction._name = elem.data.nm;
	
	        _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
	        _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
	        return _thisLayerFunction;
	    };
	}());
	
	var CompExpressionInterface = (function (){
	    return function(comp){
	        function _thisLayerFunction(name){
	            var i=0, len = comp.layers.length;
	            while(i<len){
	                if(comp.layers[i].nm === name || comp.layers[i].ind === name){
	                    return comp.elements[i].layerInterface;
	                }
	                i += 1;
	            }
	            return null;
	            //return {active:false};
	        }
	        Object.defineProperty(_thisLayerFunction, "_name", { value:comp.data.nm });
	        _thisLayerFunction.layer = _thisLayerFunction;
	        _thisLayerFunction.pixelAspect = 1;
	        _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
	        _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
	        _thisLayerFunction.pixelAspect = 1;
	        _thisLayerFunction.frameDuration = 1/comp.globalData.frameRate;
	        _thisLayerFunction.displayStartTime = 0;
	        _thisLayerFunction.numLayers = comp.layers.length;
	        return _thisLayerFunction;
	    };
	}());
	var TransformExpressionInterface = (function (){
	    return function(transform){
	        function _thisFunction(name){
	            switch(name){
	                case "scale":
	                case "Scale":
	                case "ADBE Scale":
	                case 6:
	                    return _thisFunction.scale;
	                case "rotation":
	                case "Rotation":
	                case "ADBE Rotation":
	                case "ADBE Rotate Z":
	                case 10:
	                    return _thisFunction.rotation;
	                case "ADBE Rotate X":
	                    return _thisFunction.xRotation;
	                case "ADBE Rotate Y":
	                    return _thisFunction.yRotation;
	                case "position":
	                case "Position":
	                case "ADBE Position":
	                case 2:
	                    return _thisFunction.position;
	                case 'ADBE Position_0':
	                    return _thisFunction.xPosition;
	                case 'ADBE Position_1':
	                    return _thisFunction.yPosition;
	                case 'ADBE Position_2':
	                    return _thisFunction.zPosition;
	                case "anchorPoint":
	                case "AnchorPoint":
	                case "Anchor Point":
	                case "ADBE AnchorPoint":
	                case 1:
	                    return _thisFunction.anchorPoint;
	                case "opacity":
	                case "Opacity":
	                case 11:
	                    return _thisFunction.opacity;
	            }
	        }
	
	        Object.defineProperty(_thisFunction, "rotation", {
	            get: ExpressionPropertyInterface(transform.r || transform.rz)
	        });
	
	        Object.defineProperty(_thisFunction, "zRotation", {
	            get: ExpressionPropertyInterface(transform.rz || transform.r)
	        });
	
	        Object.defineProperty(_thisFunction, "xRotation", {
	            get: ExpressionPropertyInterface(transform.rx)
	        });
	
	        Object.defineProperty(_thisFunction, "yRotation", {
	            get: ExpressionPropertyInterface(transform.ry)
	        });
	        Object.defineProperty(_thisFunction, "scale", {
	            get: ExpressionPropertyInterface(transform.s)
	        });
	
	        if(transform.p) {
	            var _transformFactory = ExpressionPropertyInterface(transform.p);
	        }
	        Object.defineProperty(_thisFunction, "position", {
	            get: function () {
	                if(transform.p) {
	                    return _transformFactory();
	                } else {
	                    return [transform.px.v, transform.py.v, transform.pz ? transform.pz.v : 0];
	                }
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "xPosition", {
	            get: ExpressionPropertyInterface(transform.px)
	        });
	
	        Object.defineProperty(_thisFunction, "yPosition", {
	            get: ExpressionPropertyInterface(transform.py)
	        });
	
	        Object.defineProperty(_thisFunction, "zPosition", {
	            get: ExpressionPropertyInterface(transform.pz)
	        });
	
	        Object.defineProperty(_thisFunction, "anchorPoint", {
	            get: ExpressionPropertyInterface(transform.a)
	        });
	
	        Object.defineProperty(_thisFunction, "opacity", {
	            get: ExpressionPropertyInterface(transform.o)
	        });
	
	        Object.defineProperty(_thisFunction, "skew", {
	            get: ExpressionPropertyInterface(transform.sk)
	        });
	
	        Object.defineProperty(_thisFunction, "skewAxis", {
	            get: ExpressionPropertyInterface(transform.sa)
	        });
	
	        Object.defineProperty(_thisFunction, "orientation", {
	            get: ExpressionPropertyInterface(transform.or)
	        });
	
	        return _thisFunction;
	    };
	}());
	var ProjectInterface = (function (){
	
	    function registerComposition(comp){
	        this.compositions.push(comp);
	    }
	
	    return function(){
	        function _thisProjectFunction(name){
	            var i = 0, len = this.compositions.length;
	            while(i<len){
	                if(this.compositions[i].data && this.compositions[i].data.nm === name){
	                    if(this.compositions[i].prepareFrame && this.compositions[i].data.xt) {
	                        this.compositions[i].prepareFrame(this.currentFrame);
	                    }
	                    return this.compositions[i].compInterface;
	                }
	                i+=1;
	            }
	        }
	
	        _thisProjectFunction.compositions = [];
	        _thisProjectFunction.currentFrame = 0;
	
	        _thisProjectFunction.registerComposition = registerComposition;
	
	
	
	        return _thisProjectFunction;
	    };
	}());
	var EffectsExpressionInterface = (function (){
	    var ob = {
	        createEffectsInterface: createEffectsInterface
	    };
	
	    function createEffectsInterface(elem, propertyGroup){
	        if(elem.effectsManager){
	
	            var effectElements = [];
	            var effectsData = elem.data.ef;
	            var i, len = elem.effectsManager.effectElements.length;
	            for(i=0;i<len;i+=1){
	                effectElements.push(createGroupInterface(effectsData[i],elem.effectsManager.effectElements[i],propertyGroup,elem));
	            }
	
	            return function(name){
	                var effects = elem.data.ef || [], i = 0, len = effects.length;
	                while(i<len) {
	                    if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
	                        return effectElements[i];
	                    }
	                    i += 1;
	                }
	            };
	        }
	    }
	
	    function createGroupInterface(data,elements, propertyGroup, elem){
	        var effectElements = [];
	        var i, len = data.ef.length;
	        for(i=0;i<len;i+=1){
	            if(data.ef[i].ty === 5){
	                effectElements.push(createGroupInterface(data.ef[i],elements.effectElements[i],elements.effectElements[i].propertyGroup, elem));
	            } else {
	                effectElements.push(createValueInterface(elements.effectElements[i],data.ef[i].ty, elem, _propertyGroup));
	            }
	        }
	
	        function _propertyGroup(val) {
	            if(val === 1){
	               return groupInterface;
	            } else{
	               return propertyGroup(val-1);
	            }
	        }
	
	        var groupInterface = function(name){
	            var effects = data.ef, i = 0, len = effects.length;
	            while(i<len) {
	                if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
	                    if(effects[i].ty === 5){
	                        return effectElements[i];
	                    } else {
	                        return effectElements[i]();
	                    }
	                }
	                i += 1;
	            }
	            return effectElements[0]();
	        };
	
	        groupInterface.propertyGroup = _propertyGroup;
	
	        if(data.mn === 'ADBE Color Control'){
	            Object.defineProperty(groupInterface, 'color', {
	                get: function(){
	                    return effectElements[0]();
	                }
	            });
	        }
	        Object.defineProperty(groupInterface, 'numProperties', {
	            get: function(){
	                return data.np;
	            }
	        });
	        groupInterface.active = groupInterface.enabled = data.en !== 0;
	        return groupInterface;
	    }
	
	    function createValueInterface(element, type, elem, propertyGroup){
	        var expressionProperty = ExpressionPropertyInterface(element.p);
	        function interfaceFunction(){
	            if(type === 10){
	                return elem.comp.compInterface(element.p.v);
	            }
	            return expressionProperty();
	        }
	
	        if(element.p.setGroupProperty) {
	            element.p.setGroupProperty(propertyGroup);
	        }
	
	        return interfaceFunction;
	    }
	
	    return ob;
	
	}());
	var MaskManagerInterface = (function(){
	
		function MaskInterface(mask, data){
			this._mask = mask;
			this._data = data;
		}
		Object.defineProperty(MaskInterface.prototype, 'maskPath', {
	        get: function(){
	                if(this._mask.prop.k){
	                    this._mask.prop.getValue();
	                }
	                return this._mask.prop;
	            }
	        });
	
		var MaskManager = function(maskManager, elem){
			var _maskManager = maskManager;
			var _elem = elem;
			var _masksInterfaces = createSizedArray(maskManager.viewData.length);
			var i, len = maskManager.viewData.length;
			for(i = 0; i < len; i += 1) {
				_masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
			}
	
			var maskFunction = function(name){
				i = 0;
			    while(i<len){
			        if(maskManager.masksProperties[i].nm === name){
			            return _masksInterfaces[i];
			        }
			        i += 1;
			    }
			};
			return maskFunction;
		};
		return MaskManager;
	}());
	
	var ExpressionPropertyInterface = (function() {
	
	    var defaultUnidimensionalValue = {pv:0, v:0, mult: 1}
	    var defaultMultidimensionalValue = {pv:[0,0,0], v:[0,0,0], mult: 1}
	
	    function completeProperty(expressionValue, property, type) {
	        Object.defineProperty(expressionValue, 'velocity', {
	            get: function(){
	                return property.getVelocityAtTime(property.comp.currentFrame);
	            }
	        });
	        expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
	        expressionValue.key = function(pos) {
	            if (!expressionValue.numKeys) {
	                return 0;
	            } else {
	                var value = '';
	                if ('s' in property.keyframes[pos-1]) {
	                    value = property.keyframes[pos-1].s;
	                } else if ('e' in property.keyframes[pos-2]) {
	                    value = property.keyframes[pos-2].e;
	                } else {
	                    value = property.keyframes[pos-2].s;
	                }
	                var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value);
	                valueProp.time = property.keyframes[pos-1].t / property.elem.comp.globalData.frameRate;
	                return valueProp;
	            }
	        };
	        expressionValue.valueAtTime = property.getValueAtTime;
	        expressionValue.speedAtTime = property.getSpeedAtTime;
	        expressionValue.velocityAtTime = property.getVelocityAtTime;
	        expressionValue.propertyGroup = property.propertyGroup;
	    }
	
	    function UnidimensionalPropertyInterface(property) {
	        if(!property || !('pv' in property)) {
	            property = defaultUnidimensionalValue;
	        }
	        var mult = 1 / property.mult;
	        var val = property.pv * mult;
	        var expressionValue = new Number(val);
	        expressionValue.value = val;
	        completeProperty(expressionValue, property, 'unidimensional');
	
	        return function() {
	            if (property.k) {
	                property.getValue();
	            }
	            val = property.v * mult;
	            if(expressionValue.value !== val) {
	                expressionValue = new Number(val);
	                expressionValue.value = val;
	                completeProperty(expressionValue, property, 'unidimensional');
	            }
	            return expressionValue;
	        }
	    }
	
	    function MultidimensionalPropertyInterface(property) {
	        if(!property || !('pv' in property)) {
	            property = defaultMultidimensionalValue;
	        }
	        var mult = 1 / property.mult;
	        var len = property.pv.length;
	        var expressionValue = createTypedArray('float32', len);
	        var arrValue = createTypedArray('float32', len);
	        expressionValue.value = arrValue;
	        completeProperty(expressionValue, property, 'multidimensional');
	
	        return function() {
	            if (property.k) {
	                property.getValue();
	            }
	            for (var i = 0; i < len; i += 1) {
	                expressionValue[i] = arrValue[i] = property.v[i] * mult;
	            }
	            return expressionValue;
	        }
	    }
	
	    //TODO: try to avoid using this getter
	    function defaultGetter() {
	        return defaultUnidimensionalValue;
	    }
	    
	    return function(property) {
	        if(!property) {
	            return defaultGetter;
	        } else if (property.propType === 'unidimensional') {
	            return UnidimensionalPropertyInterface(property);
	        } else {
	            return MultidimensionalPropertyInterface(property);
	        }
	    }
	}())
	
	function SliderEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function AngleEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function ColorEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,1,0,container);
	}
	function PointEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,1,0,container);
	}
	function LayerIndexEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function MaskIndexEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function CheckboxEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function NoValueEffect(){
	    this.p = {};
	}
	function EffectsManager(){}
	function EffectsManager(data,element){
	    var effects = data.ef || [];
	    this.effectElements = [];
	    var i,len = effects.length;
	    var effectItem;
	    for(i=0;i<len;i++) {
	        effectItem = new GroupEffect(effects[i],element);
	        this.effectElements.push(effectItem);
	    }
	}
	
	function GroupEffect(data,element){
	    this.init(data,element);
	}
	
	extendPrototype([DynamicPropertyContainer], GroupEffect);
	
	GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
	
	GroupEffect.prototype.init = function(data,element){
	    this.data = data;
	    this.effectElements = [];
	    this.initDynamicPropertyContainer(element);
	    var i, len = this.data.ef.length;
	    var eff, effects = this.data.ef;
	    for(i=0;i<len;i+=1){
	        eff = null;
	        switch(effects[i].ty){
	            case 0:
	                eff = new SliderEffect(effects[i],element,this);
	                break;
	            case 1:
	                eff = new AngleEffect(effects[i],element,this);
	                break;
	            case 2:
	                eff = new ColorEffect(effects[i],element,this);
	                break;
	            case 3:
	                eff = new PointEffect(effects[i],element,this);
	                break;
	            case 4:
	            case 7:
	                eff = new CheckboxEffect(effects[i],element,this);
	                break;
	            case 10:
	                eff = new LayerIndexEffect(effects[i],element,this);
	                break;
	            case 11:
	                eff = new MaskIndexEffect(effects[i],element,this);
	                break;
	            case 5:
	                eff = new EffectsManager(effects[i],element,this);
	                break;
	            //case 6:
	            default:
	                eff = new NoValueEffect(effects[i],element,this);
	                break;
	        }
	        if(eff) {
	            this.effectElements.push(eff);
	        }
	    }
	};
	
	    var lottiejs = {};
	
	    var _isFrozen = false;
	
	    function setLocationHref (href) {
	        locationHref = href;
	    }
	
	    function searchAnimations() {
	        if (standalone === true) {
	            animationManager.searchAnimations(animationData, standalone, renderer);
	        } else {
	            animationManager.searchAnimations();
	        }
	    }
	
	    function setSubframeRendering(flag) {
	        subframeEnabled = flag;
	    }
	
	    function loadAnimation(params) {
	        if (standalone === true) {
	            params.animationData = JSON.parse(animationData);
	        }
	        return animationManager.loadAnimation(params);
	    }
	
	    function setQuality(value) {
	        if (typeof value === 'string') {
	            switch (value) {
	                case 'high':
	                    defaultCurveSegments = 200;
	                    break;
	                case 'medium':
	                    defaultCurveSegments = 50;
	                    break;
	                case 'low':
	                    defaultCurveSegments = 10;
	                    break;
	            }
	        } else if (!isNaN(value) && value > 1) {
	            defaultCurveSegments = value;
	        }
	        if (defaultCurveSegments >= 50) {
	            roundValues(false);
	        } else {
	            roundValues(true);
	        }
	    }
	
	    function inBrowser() {
	        return typeof navigator !== 'undefined';
	    }
	
	    function installPlugin(type, plugin) {
	        if (type === 'expressions') {
	            expressionsPlugin = plugin;
	        }
	    }
	
	    function getFactory(name) {
	        switch (name) {
	            case "propertyFactory":
	                return PropertyFactory;
	            case "shapePropertyFactory":
	                return ShapePropertyFactory;
	            case "matrix":
	                return Matrix;
	        }
	    }
	
	    lottiejs.play = animationManager.play;
	    lottiejs.pause = animationManager.pause;
	    lottiejs.setLocationHref = setLocationHref;
	    lottiejs.togglePause = animationManager.togglePause;
	    lottiejs.setSpeed = animationManager.setSpeed;
	    lottiejs.setDirection = animationManager.setDirection;
	    lottiejs.stop = animationManager.stop;
	    lottiejs.searchAnimations = searchAnimations;
	    lottiejs.registerAnimation = animationManager.registerAnimation;
	    lottiejs.loadAnimation = loadAnimation;
	    lottiejs.setSubframeRendering = setSubframeRendering;
	    lottiejs.resize = animationManager.resize;
	    //lottiejs.start = start;
	    lottiejs.goToAndStop = animationManager.goToAndStop;
	    lottiejs.destroy = animationManager.destroy;
	    lottiejs.setQuality = setQuality;
	    lottiejs.inBrowser = inBrowser;
	    lottiejs.installPlugin = installPlugin;
	    lottiejs.freeze = animationManager.freeze;
	    lottiejs.unfreeze = animationManager.unfreeze;
	    lottiejs.getRegisteredAnimations = animationManager.getRegisteredAnimations;
	    lottiejs.__getFactory = getFactory;
	    lottiejs.version = '5.4.3';
	
	    function checkReady() {
	        if (document.readyState === "complete") {
	            clearInterval(readyStateCheckInterval);
	            searchAnimations();
	        }
	    }
	
	    function getQueryVariable(variable) {
	        var vars = queryString.split('&');
	        for (var i = 0; i < vars.length; i++) {
	            var pair = vars[i].split('=');
	            if (decodeURIComponent(pair[0]) == variable) {
	                return decodeURIComponent(pair[1]);
	            }
	        }
	    }
	    var standalone = '__[STANDALONE]__';
	    var animationData = '__[ANIMATIONDATA]__';
	    var renderer = '';
	    if (standalone) {
	        var scripts = document.getElementsByTagName('script');
	        var index = scripts.length - 1;
	        var myScript = scripts[index] || {
	            src: ''
	        };
	        var queryString = myScript.src.replace(/^[^\?]+\??/, '');
	        renderer = getQueryVariable('renderer');
	    }
	    var readyStateCheckInterval = setInterval(checkReady, 100);
	    return lottiejs;
	}));


/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(86), __webpack_require__(1), __webpack_require__(87)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'mobx', 'react', 'react-dom'], factory) :
	  (factory((global.mobxReact = {}),global.mobx,global.React,global.ReactDOM));
	}(this, (function (exports,mobx,React,reactDom) { 'use strict';
	
	  var React__default = 'default' in React ? React['default'] : React;
	
	  function _typeof(obj) {
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function (obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) _setPrototypeOf(subClass, superClass);
	  }
	
	  function _getPrototypeOf(o) {
	    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	      return o.__proto__ || Object.getPrototypeOf(o);
	    };
	    return _getPrototypeOf(o);
	  }
	
	  function _setPrototypeOf(o, p) {
	    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	      o.__proto__ = p;
	      return o;
	    };
	
	    return _setPrototypeOf(o, p);
	  }
	
	  function _assertThisInitialized(self) {
	    if (self === void 0) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return self;
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (call && (typeof call === "object" || typeof call === "function")) {
	      return call;
	    }
	
	    return _assertThisInitialized(self);
	  }
	
	  // These functions can be stubbed out in specific environments
	
	  function unwrapExports (x) {
	  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
	  }
	
	  function createCommonjsModule(fn, module) {
	  	return module = { exports: {} }, fn(module, module.exports), module.exports;
	  }
	
	  var reactIs_production_min = createCommonjsModule(function (module, exports) {
	  Object.defineProperty(exports,"__esModule",{value:!0});
	  var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,r=b?Symbol.for("react.memo"):
	  60115,t=b?Symbol.for("react.lazy"):60116;function u(a){if("object"===typeof a&&null!==a){var q=a.$$typeof;switch(q){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return q}}case d:return q}}}function v(a){return u(a)===m}exports.typeOf=u;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;
	  exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;exports.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||u(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return u(a)===k};exports.isContextProvider=function(a){return u(a)===h};
	  exports.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return u(a)===n};exports.isFragment=function(a){return u(a)===e};exports.isProfiler=function(a){return u(a)===g};exports.isPortal=function(a){return u(a)===d};exports.isStrictMode=function(a){return u(a)===f};
	  });
	
	  unwrapExports(reactIs_production_min);
	  var reactIs_production_min_1 = reactIs_production_min.typeOf;
	  var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
	  var reactIs_production_min_3 = reactIs_production_min.ConcurrentMode;
	  var reactIs_production_min_4 = reactIs_production_min.ContextConsumer;
	  var reactIs_production_min_5 = reactIs_production_min.ContextProvider;
	  var reactIs_production_min_6 = reactIs_production_min.Element;
	  var reactIs_production_min_7 = reactIs_production_min.ForwardRef;
	  var reactIs_production_min_8 = reactIs_production_min.Fragment;
	  var reactIs_production_min_9 = reactIs_production_min.Profiler;
	  var reactIs_production_min_10 = reactIs_production_min.Portal;
	  var reactIs_production_min_11 = reactIs_production_min.StrictMode;
	  var reactIs_production_min_12 = reactIs_production_min.isValidElementType;
	  var reactIs_production_min_13 = reactIs_production_min.isAsyncMode;
	  var reactIs_production_min_14 = reactIs_production_min.isConcurrentMode;
	  var reactIs_production_min_15 = reactIs_production_min.isContextConsumer;
	  var reactIs_production_min_16 = reactIs_production_min.isContextProvider;
	  var reactIs_production_min_17 = reactIs_production_min.isElement;
	  var reactIs_production_min_18 = reactIs_production_min.isForwardRef;
	  var reactIs_production_min_19 = reactIs_production_min.isFragment;
	  var reactIs_production_min_20 = reactIs_production_min.isProfiler;
	  var reactIs_production_min_21 = reactIs_production_min.isPortal;
	  var reactIs_production_min_22 = reactIs_production_min.isStrictMode;
	
	  var reactIs = createCommonjsModule(function (module) {
	
	  {
	    module.exports = reactIs_production_min;
	  }
	  });
	
	  /**
	   * Copyright 2015, Yahoo! Inc.
	   * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	   */
	
	  var REACT_STATICS = {
	      childContextTypes: true,
	      contextType: true,
	      contextTypes: true,
	      defaultProps: true,
	      displayName: true,
	      getDefaultProps: true,
	      getDerivedStateFromError: true,
	      getDerivedStateFromProps: true,
	      mixins: true,
	      propTypes: true,
	      type: true
	  };
	
	  var KNOWN_STATICS = {
	      name: true,
	      length: true,
	      prototype: true,
	      caller: true,
	      callee: true,
	      arguments: true,
	      arity: true
	  };
	
	  var FORWARD_REF_STATICS = {
	      '$$typeof': true,
	      render: true,
	      defaultProps: true,
	      displayName: true,
	      propTypes: true
	  };
	
	  var TYPE_STATICS = {};
	  TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	
	  var defineProperty = Object.defineProperty;
	  var getOwnPropertyNames = Object.getOwnPropertyNames;
	  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	  var getPrototypeOf = Object.getPrototypeOf;
	  var objectPrototype = Object.prototype;
	
	  function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	      if (typeof sourceComponent !== 'string') {
	          // don't hoist over string (html) components
	
	          if (objectPrototype) {
	              var inheritedComponent = getPrototypeOf(sourceComponent);
	              if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                  hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	              }
	          }
	
	          var keys = getOwnPropertyNames(sourceComponent);
	
	          if (getOwnPropertySymbols) {
	              keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	          }
	
	          var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
	          var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;
	
	          for (var i = 0; i < keys.length; ++i) {
	              var key = keys[i];
	              if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	                  var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                  try {
	                      // Avoid failures from read-only properties
	                      defineProperty(targetComponent, key, descriptor);
	                  } catch (e) {}
	              }
	          }
	
	          return targetComponent;
	      }
	
	      return targetComponent;
	  }
	
	  var hoistNonReactStatics_cjs = hoistNonReactStatics;
	
	  var EventEmitter =
	  /*#__PURE__*/
	  function () {
	    function EventEmitter() {
	      _classCallCheck(this, EventEmitter);
	
	      this.listeners = [];
	    }
	
	    _createClass(EventEmitter, [{
	      key: "on",
	      value: function on(cb) {
	        var _this = this;
	
	        this.listeners.push(cb);
	        return function () {
	          var index = _this.listeners.indexOf(cb);
	
	          if (index !== -1) _this.listeners.splice(index, 1);
	        };
	      }
	    }, {
	      key: "emit",
	      value: function emit(data) {
	        this.listeners.forEach(function (fn) {
	          return fn(data);
	        });
	      }
	    }]);
	
	    return EventEmitter;
	  }();
	
	  function createChainableTypeChecker(validate) {
	    function checkType(isRequired, props, propName, componentName, location, propFullName) {
	      for (var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	        rest[_key - 6] = arguments[_key];
	      }
	
	      return mobx.untracked(function () {
	        componentName = componentName || "<<anonymous>>";
	        propFullName = propFullName || propName;
	
	        if (props[propName] == null) {
	          if (isRequired) {
	            var actual = props[propName] === null ? "null" : "undefined";
	            return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
	          }
	
	          return null;
	        } else {
	          return validate.apply(void 0, [props, propName, componentName, location, propFullName].concat(rest));
	        }
	      });
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	    return chainedCheckType;
	  } // Copied from React.PropTypes
	
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === "symbol") {
	      return true;
	    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	
	
	    if (propValue["@@toStringTag"] === "Symbol") {
	      return true;
	    } // Fallback for non-spec compliant Symbols which are polyfilled.
	
	
	    if (typeof Symbol === "function" && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  } // Copied from React.PropTypes
	
	
	  function getPropType(propValue) {
	    var propType = _typeof(propValue);
	
	    if (Array.isArray(propValue)) {
	      return "array";
	    }
	
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return "object";
	    }
	
	    if (isSymbol(propType, propValue)) {
	      return "symbol";
	    }
	
	    return propType;
	  } // This handles more types than `getPropType`. Only used for error messages.
	  // Copied from React.PropTypes
	
	
	  function getPreciseType(propValue) {
	    var propType = getPropType(propValue);
	
	    if (propType === "object") {
	      if (propValue instanceof Date) {
	        return "date";
	      } else if (propValue instanceof RegExp) {
	        return "regexp";
	      }
	    }
	
	    return propType;
	  }
	
	  function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
	    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
	      return mobx.untracked(function () {
	        if (allowNativeType) {
	          if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
	        }
	
	        var mobxChecker;
	
	        switch (mobxType) {
	          case "Array":
	            mobxChecker = mobx.isObservableArray;
	            break;
	
	          case "Object":
	            mobxChecker = mobx.isObservableObject;
	            break;
	
	          case "Map":
	            mobxChecker = mobx.isObservableMap;
	            break;
	
	          default:
	            throw new Error("Unexpected mobxType: ".concat(mobxType));
	        }
	
	        var propValue = props[propName];
	
	        if (!mobxChecker(propValue)) {
	          var preciseType = getPreciseType(propValue);
	          var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
	          return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
	        }
	
	        return null;
	      });
	    });
	  }
	
	  function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
	    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
	      for (var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	        rest[_key2 - 5] = arguments[_key2];
	      }
	
	      return mobx.untracked(function () {
	        if (typeof typeChecker !== "function") {
	          return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
	        }
	
	        var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
	        if (error instanceof Error) return error;
	        var propValue = props[propName];
	
	        for (var i = 0; i < propValue.length; i++) {
	          error = typeChecker.apply(void 0, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
	          if (error instanceof Error) return error;
	        }
	
	        return null;
	      });
	    });
	  }
	
	  var observableArray = createObservableTypeCheckerCreator(false, "Array");
	  var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
	  var observableMap = createObservableTypeCheckerCreator(false, "Map");
	  var observableObject = createObservableTypeCheckerCreator(false, "Object");
	  var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
	  var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
	  var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");
	
	  var propTypes = /*#__PURE__*/Object.freeze({
	    observableArray: observableArray,
	    observableArrayOf: observableArrayOf,
	    observableMap: observableMap,
	    observableObject: observableObject,
	    arrayOrObservableArray: arrayOrObservableArray,
	    arrayOrObservableArrayOf: arrayOrObservableArrayOf,
	    objectOrObservableObject: objectOrObservableObject
	  });
	
	  function isStateless(component) {
	    // `function() {}` has prototype, but `() => {}` doesn't
	    // `() => {}` via Babel has prototype too.
	    return !(component.prototype && component.prototype.render);
	  }
	  var symbolId = 0;
	  function newSymbol(name) {
	    if (typeof Symbol === "function") {
	      return Symbol(name);
	    }
	
	    var symbol = "__$mobx-react ".concat(name, " (").concat(symbolId, ")");
	    symbolId++;
	    return symbol;
	  }
	  var mobxMixins = newSymbol("patchMixins");
	  var mobxPatchedDefinition = newSymbol("patchedDefinition");
	
	  function getMixins(target, methodName) {
	    var mixins = target[mobxMixins] = target[mobxMixins] || {};
	    var methodMixins = mixins[methodName] = mixins[methodName] || {};
	    methodMixins.locks = methodMixins.locks || 0;
	    methodMixins.methods = methodMixins.methods || [];
	    return methodMixins;
	  }
	
	  function wrapper(realMethod, mixins) {
	    var _this = this;
	
	    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
	    mixins.locks++;
	
	    try {
	      var retVal;
	
	      if (realMethod !== undefined && realMethod !== null) {
	        retVal = realMethod.apply(this, args);
	      }
	
	      return retVal;
	    } finally {
	      mixins.locks--;
	
	      if (mixins.locks === 0) {
	        mixins.methods.forEach(function (mx) {
	          mx.apply(_this, args);
	        });
	      }
	    }
	  }
	
	  function wrapFunction(realMethod, mixins) {
	    var fn = function fn() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      wrapper.call.apply(wrapper, [this, realMethod, mixins].concat(args));
	    };
	
	    return fn;
	  }
	
	  function patch(target, methodName) {
	    var mixins = getMixins(target, methodName);
	
	    for (var _len3 = arguments.length, mixinMethods = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	      mixinMethods[_key3 - 2] = arguments[_key3];
	    }
	
	    for (var _i = 0; _i < mixinMethods.length; _i++) {
	      var mixinMethod = mixinMethods[_i];
	
	      if (mixins.methods.indexOf(mixinMethod) < 0) {
	        mixins.methods.push(mixinMethod);
	      }
	    }
	
	    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
	
	    if (oldDefinition && oldDefinition[mobxPatchedDefinition]) {
	      // already patched definition, do not repatch
	      return;
	    }
	
	    var originalMethod = target[methodName];
	    var newDefinition = createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
	    Object.defineProperty(target, methodName, newDefinition);
	  }
	
	  function createDefinition(target, methodName, enumerable, mixins, originalMethod) {
	    var _ref;
	
	    var wrappedFunc = wrapFunction(originalMethod, mixins);
	    return _ref = {}, _defineProperty(_ref, mobxPatchedDefinition, true), _defineProperty(_ref, "get", function get() {
	      return wrappedFunc;
	    }), _defineProperty(_ref, "set", function set(value) {
	      if (this === target) {
	        wrappedFunc = wrapFunction(value, mixins);
	      } else {
	        // when it is an instance of the prototype/a child prototype patch that particular case again separately
	        // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
	        // e.g. the method for super might not be the same as the method for the prototype which might be not the same
	        // as the method for the instance
	        var newDefinition = createDefinition(this, methodName, enumerable, mixins, value);
	        Object.defineProperty(this, methodName, newDefinition);
	      }
	    }), _defineProperty(_ref, "configurable", true), _defineProperty(_ref, "enumerable", enumerable), _ref;
	  }
	
	  var injectorContextTypes = {
	    mobxStores: objectOrObservableObject
	  };
	  Object.seal(injectorContextTypes);
	  var proxiedInjectorProps = {
	    contextTypes: {
	      get: function get() {
	        return injectorContextTypes;
	      },
	      set: function set(_) {
	        console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
	      },
	      configurable: true,
	      enumerable: false
	    },
	    isMobxInjector: {
	      value: true,
	      writable: true,
	      configurable: true,
	      enumerable: true
	    }
	    /**
	     * Store Injection
	     */
	
	  };
	
	  function createStoreInjector(grabStoresFn, component, injectNames) {
	    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
	    if (injectNames) displayName += "-with-" + injectNames;
	
	    var Injector =
	    /*#__PURE__*/
	    function (_Component) {
	      _inherits(Injector, _Component);
	
	      function Injector() {
	        var _getPrototypeOf2;
	
	        var _this;
	
	        _classCallCheck(this, Injector);
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Injector)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	        _this.storeRef = function (instance) {
	          _this.wrappedInstance = instance;
	        };
	
	        return _this;
	      }
	
	      _createClass(Injector, [{
	        key: "render",
	        value: function render() {
	          // Optimization: it might be more efficient to apply the mapper function *outside* the render method
	          // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
	          // See this test: 'using a custom injector is not too reactive' in inject.js
	          var newProps = {};
	
	          for (var key in this.props) {
	            if (this.props.hasOwnProperty(key)) {
	              newProps[key] = this.props[key];
	            }
	          }
	
	          var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
	
	          for (var _key2 in additionalProps) {
	            newProps[_key2] = additionalProps[_key2];
	          }
	
	          if (!isStateless(component)) {
	            newProps.ref = this.storeRef;
	          }
	
	          return React.createElement(component, newProps);
	        }
	      }]);
	
	      return Injector;
	    }(React.Component); // Static fields from component should be visible on the generated Injector
	
	
	    Injector.displayName = displayName;
	    hoistNonReactStatics_cjs(Injector, component);
	    Injector.wrappedComponent = component;
	    Object.defineProperties(Injector, proxiedInjectorProps);
	    return Injector;
	  }
	
	  function grabStoresByName(storeNames) {
	    return function (baseStores, nextProps) {
	      storeNames.forEach(function (storeName) {
	        if (storeName in nextProps // prefer props over stores
	        ) return;
	        if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
	        nextProps[storeName] = baseStores[storeName];
	      });
	      return nextProps;
	    };
	  }
	  /**
	   * higher order component that injects stores to a child.
	   * takes either a varargs list of strings, which are stores read from the context,
	   * or a function that manually maps the available stores from the context to props:
	   * storesToProps(mobxStores, props, context) => newProps
	   */
	
	
	  function inject()
	  /* fn(stores, nextProps) or ...storeNames */
	  {
	    var grabStoresFn;
	
	    if (typeof arguments[0] === "function") {
	      grabStoresFn = arguments[0];
	      return function (componentClass) {
	        var injected = createStoreInjector(grabStoresFn, componentClass);
	        injected.isMobxInjector = false; // supress warning
	        // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
	        // see #111
	
	        injected = observer(injected);
	        injected.isMobxInjector = true; // restore warning
	
	        return injected;
	      };
	    } else {
	      var storeNames = [];
	
	      for (var i = 0; i < arguments.length; i++) {
	        storeNames[i] = arguments[i];
	      }
	
	      grabStoresFn = grabStoresByName(storeNames);
	      return function (componentClass) {
	        return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
	      };
	    }
	  }
	
	  var mobxAdminProperty = mobx.$mobx || "$mobx";
	  var mobxIsUnmounted = newSymbol("isUnmounted");
	  /**
	   * dev tool support
	   */
	
	  var isDevtoolsEnabled = false;
	  var isUsingStaticRendering = false;
	  var warnedAboutObserverInjectDeprecation = false; // WeakMap<Node, Object>;
	
	  var componentByNodeRegistry = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
	  var renderReporter = new EventEmitter();
	  var skipRenderKey = newSymbol("skipRender");
	  var isForcingUpdateKey = newSymbol("isForcingUpdate"); // Using react-is had some issues (and operates on elements, not on types), see #608 / #609
	
	  var ReactForwardRefSymbol = typeof React.forwardRef === "function" && React.forwardRef(function (_props, _ref) {})["$$typeof"];
	  /**
	   * Helper to set `prop` to `this` as non-enumerable (hidden prop)
	   * @param target
	   * @param prop
	   * @param value
	   */
	
	  function setHiddenProp(target, prop, value) {
	    if (!Object.hasOwnProperty.call(target, prop)) {
	      Object.defineProperty(target, prop, {
	        enumerable: false,
	        configurable: true,
	        writable: true,
	        value: value
	      });
	    } else {
	      target[prop] = value;
	    }
	  }
	
	  function findDOMNode$1(component) {
	    if (reactDom.findDOMNode) {
	      try {
	        return reactDom.findDOMNode(component);
	      } catch (e) {
	        // findDOMNode will throw in react-test-renderer, see:
	        // See https://github.com/mobxjs/mobx-react/issues/216
	        // Is there a better heuristic?
	        return null;
	      }
	    }
	
	    return null;
	  }
	
	  function reportRendering(component) {
	    var node = findDOMNode$1(component);
	    if (node && componentByNodeRegistry) componentByNodeRegistry.set(node, component);
	    renderReporter.emit({
	      event: "render",
	      renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
	      totalTime: Date.now() - component.__$mobRenderStart,
	      component: component,
	      node: node
	    });
	  }
	
	  function trackComponents() {
	    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
	    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
	  }
	  function useStaticRendering(useStaticRendering) {
	    isUsingStaticRendering = useStaticRendering;
	  }
	  /**
	   * Errors reporter
	   */
	
	  var errorsReporter = new EventEmitter();
	  /**
	   * Utilities
	   */
	
	  function patch$1(target, funcName) {
	    patch(target, funcName, reactiveMixin[funcName]);
	  }
	
	  function shallowEqual(objA, objB) {
	    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
	    if (is(objA, objB)) return true;
	
	    if (_typeof(objA) !== "object" || objA === null || _typeof(objB) !== "object" || objB === null) {
	      return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	    if (keysA.length !== keysB.length) return false;
	
	    for (var i = 0; i < keysA.length; i++) {
	      if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  function is(x, y) {
	    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
	    if (x === y) {
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      return x !== x && y !== y;
	    }
	  }
	
	  function makeComponentReactive(render) {
	    var _this2 = this;
	
	    if (isUsingStaticRendering === true) return render.call(this);
	
	    function reactiveRender() {
	      var _this = this;
	
	      isRenderingPending = false;
	      var exception = undefined;
	      var rendering = undefined;
	      reaction.track(function () {
	        if (isDevtoolsEnabled) {
	          _this.__$mobRenderStart = Date.now();
	        }
	
	        try {
	          rendering = mobx._allowStateChanges(false, baseRender);
	        } catch (e) {
	          exception = e;
	        }
	
	        if (isDevtoolsEnabled) {
	          _this.__$mobRenderEnd = Date.now();
	        }
	      });
	
	      if (exception) {
	        errorsReporter.emit(exception);
	        throw exception;
	      }
	
	      return rendering;
	    } // Generate friendly name for debugging
	
	
	    var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
	    var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalInstance && this._reactInternalInstance._debugID || this._reactInternalFiber && this._reactInternalFiber._debugID;
	    /**
	     * If props are shallowly modified, react will render anyway,
	     * so atom.reportChanged() should not result in yet another re-render
	     */
	
	    setHiddenProp(this, skipRenderKey, false);
	    /**
	     * forceUpdate will re-assign this.props. We don't want that to cause a loop,
	     * so detect these changes
	     */
	
	    setHiddenProp(this, isForcingUpdateKey, false); // wire up reactive render
	
	    var baseRender = render.bind(this);
	    var isRenderingPending = false;
	    var reaction = new mobx.Reaction("".concat(initialName, "#").concat(rootNodeID, ".render()"), function () {
	      if (!isRenderingPending) {
	        // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
	        // This unidiomatic React usage but React will correctly warn about this so we continue as usual
	        // See #85 / Pull #44
	        isRenderingPending = true;
	        if (typeof _this2.componentWillReact === "function") _this2.componentWillReact(); // TODO: wrap in action?
	
	        if (_this2[mobxIsUnmounted] !== true) {
	          // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
	          // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
	          // However, people also claim this might happen during unit tests..
	          var hasError = true;
	
	          try {
	            setHiddenProp(_this2, isForcingUpdateKey, true);
	            if (!_this2[skipRenderKey]) React.Component.prototype.forceUpdate.call(_this2);
	            hasError = false;
	          } finally {
	            setHiddenProp(_this2, isForcingUpdateKey, false);
	            if (hasError) reaction.dispose();
	          }
	        }
	      }
	    });
	    reaction.reactComponent = this;
	    reactiveRender[mobxAdminProperty] = reaction;
	    this.render = reactiveRender;
	    return reactiveRender.call(this);
	  }
	  /**
	   * ReactiveMixin
	   */
	
	
	  var reactiveMixin = {
	    componentWillUnmount: function componentWillUnmount() {
	      if (isUsingStaticRendering === true) return;
	      this.render[mobxAdminProperty] && this.render[mobxAdminProperty].dispose();
	      this[mobxIsUnmounted] = true;
	
	      if (isDevtoolsEnabled) {
	        var node = findDOMNode$1(this);
	
	        if (node && componentByNodeRegistry) {
	          componentByNodeRegistry.delete(node);
	        }
	
	        renderReporter.emit({
	          event: "destroy",
	          component: this,
	          node: node
	        });
	      }
	    },
	    componentDidMount: function componentDidMount() {
	      if (isDevtoolsEnabled) {
	        reportRendering(this);
	      }
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      if (isDevtoolsEnabled) {
	        reportRendering(this);
	      }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	      if (isUsingStaticRendering) {
	        console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
	      } // update on any state changes (as is the default)
	
	
	      if (this.state !== nextState) {
	        return true;
	      } // update if props are shallowly not equal, inspired by PureRenderMixin
	      // we could return just 'false' here, and avoid the `skipRender` checks etc
	      // however, it is nicer if lifecycle events are triggered like usually,
	      // so we return true here if props are shallowly modified.
	
	
	      return !shallowEqual(this.props, nextProps);
	    }
	  };
	
	  function makeObservableProp(target, propName) {
	    var valueHolderKey = newSymbol("reactProp_".concat(propName, "_valueHolder"));
	    var atomHolderKey = newSymbol("reactProp_".concat(propName, "_atomHolder"));
	
	    function getAtom() {
	      if (!this[atomHolderKey]) {
	        setHiddenProp(this, atomHolderKey, mobx.createAtom("reactive " + propName));
	      }
	
	      return this[atomHolderKey];
	    }
	
	    Object.defineProperty(target, propName, {
	      configurable: true,
	      enumerable: true,
	      get: function get() {
	        getAtom.call(this).reportObserved();
	        return this[valueHolderKey];
	      },
	      set: function set(v) {
	        if (!this[isForcingUpdateKey] && !shallowEqual(this[valueHolderKey], v)) {
	          setHiddenProp(this, valueHolderKey, v);
	          setHiddenProp(this, skipRenderKey, true);
	          getAtom.call(this).reportChanged();
	          setHiddenProp(this, skipRenderKey, false);
	        } else {
	          setHiddenProp(this, valueHolderKey, v);
	        }
	      }
	    });
	  }
	  /**
	   * Observer function / decorator
	   */
	
	
	  function observer(arg1, arg2) {
	    if (typeof arg1 === "string") {
	      throw new Error("Store names should be provided as array");
	    }
	
	    if (Array.isArray(arg1)) {
	      // TODO: remove in next major
	      // component needs stores
	      if (!warnedAboutObserverInjectDeprecation) {
	        warnedAboutObserverInjectDeprecation = true;
	        console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
	      }
	
	      if (!arg2) {
	        // invoked as decorator
	        return function (componentClass) {
	          return observer(arg1, componentClass);
	        };
	      } else {
	        return inject.apply(null, arg1)(observer(arg2));
	      }
	    }
	
	    var componentClass = arg1;
	
	    if (componentClass.isMobxInjector === true) {
	      console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
	    }
	
	    if (componentClass.__proto__ === React.PureComponent) {
	      console.warn("Mobx observer: You are using 'observer' on React.PureComponent. These two achieve two opposite goals and should not be used together");
	    } // Unwrap forward refs into `<Observer>` component
	    // we need to unwrap the render, because it is the inner render that needs to be tracked,
	    // not the ForwardRef HoC
	
	
	    if (ReactForwardRefSymbol && componentClass["$$typeof"] === ReactForwardRefSymbol) {
	      var _baseRender = componentClass.render;
	      if (typeof _baseRender !== "function") throw new Error("render property of ForwardRef was not a function"); // TODO: do we need to hoist statics from baseRender to the forward ref?
	
	      return React.forwardRef(function ObserverForwardRef() {
	        var _arguments = arguments;
	        return React__default.createElement(Observer, null, function () {
	          return _baseRender.apply(undefined, _arguments);
	        });
	      });
	    } // Stateless function component:
	    // If it is function but doesn't seem to be a react class constructor,
	    // wrap it to a react class automatically
	
	
	    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !React.Component.isPrototypeOf(componentClass)) {
	      var _class, _temp;
	
	      var observerComponent = observer((_temp = _class =
	      /*#__PURE__*/
	      function (_Component) {
	        _inherits(_class, _Component);
	
	        function _class() {
	          _classCallCheck(this, _class);
	
	          return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
	        }
	
	        _createClass(_class, [{
	          key: "render",
	          value: function render() {
	            return componentClass.call(this, this.props, this.context);
	          }
	        }]);
	
	        return _class;
	      }(React.Component), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
	      hoistNonReactStatics_cjs(observerComponent, componentClass);
	      return observerComponent;
	    }
	
	    if (!componentClass) {
	      throw new Error("Please pass a valid component to 'observer'");
	    }
	
	    var target = componentClass.prototype || componentClass;
	    mixinLifecycleEvents(target);
	    componentClass.isMobXReactObserver = true;
	    makeObservableProp(target, "props");
	    makeObservableProp(target, "state");
	    var baseRender = target.render;
	
	    target.render = function () {
	      return makeComponentReactive.call(this, baseRender);
	    };
	
	    return componentClass;
	  }
	
	  function mixinLifecycleEvents(target) {
	    ["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
	      patch$1(target, funcName);
	    });
	
	    if (!target.shouldComponentUpdate) {
	      target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
	    } else {
	      if (target.shouldComponentUpdate !== reactiveMixin.shouldComponentUpdate) {
	        // TODO: make throw in next major
	        console.warn("Use `shouldComponentUpdate` in an `observer` based component breaks the behavior of `observer` and might lead to unexpected results. Manually implementing `sCU` should not be needed when using mobx-react.");
	      }
	    }
	  }
	
	  var Observer = observer(function (_ref2) {
	    var children = _ref2.children,
	        observerInject = _ref2.inject,
	        render = _ref2.render;
	    var component = children || render;
	
	    if (typeof component === "undefined") {
	      return null;
	    }
	
	    if (!observerInject) {
	      return component();
	    } // TODO: remove in next major
	
	
	    console.warn("<Observer inject=.../> is no longer supported. Please use inject on the enclosing component instead");
	    var InjectComponent = inject(observerInject)(component);
	    return React__default.createElement(InjectComponent, null);
	  });
	  Observer.displayName = "Observer";
	
	  var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
	    var extraKey = key === "children" ? "render" : "children";
	
	    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
	      return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
	    }
	
	    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
	      return;
	    }
	
	    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
	  };
	
	  Observer.propTypes = {
	    render: ObserverPropsCheck,
	    children: ObserverPropsCheck
	  };
	
	  /**
	   * Copyright (c) 2013-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   */
	
	  function componentWillMount() {
	    // Call this.constructor.gDSFP to support sub-classes.
	    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	    if (state !== null && state !== undefined) {
	      this.setState(state);
	    }
	  }
	
	  function componentWillReceiveProps(nextProps) {
	    // Call this.constructor.gDSFP to support sub-classes.
	    // Use the setState() updater to ensure state isn't stale in certain edge cases.
	    function updater(prevState) {
	      var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	      return state !== null && state !== undefined ? state : null;
	    }
	    // Binding "this" is important for shallow renderer support.
	    this.setState(updater.bind(this));
	  }
	
	  function componentWillUpdate(nextProps, nextState) {
	    try {
	      var prevProps = this.props;
	      var prevState = this.state;
	      this.props = nextProps;
	      this.state = nextState;
	      this.__reactInternalSnapshotFlag = true;
	      this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	        prevProps,
	        prevState
	      );
	    } finally {
	      this.props = prevProps;
	      this.state = prevState;
	    }
	  }
	
	  // React may warn about cWM/cWRP/cWU methods being deprecated.
	  // Add a flag to suppress these warnings for this special case.
	  componentWillMount.__suppressDeprecationWarning = true;
	  componentWillReceiveProps.__suppressDeprecationWarning = true;
	  componentWillUpdate.__suppressDeprecationWarning = true;
	
	  function polyfill(Component) {
	    var prototype = Component.prototype;
	
	    if (!prototype || !prototype.isReactComponent) {
	      throw new Error('Can only polyfill class components');
	    }
	
	    if (
	      typeof Component.getDerivedStateFromProps !== 'function' &&
	      typeof prototype.getSnapshotBeforeUpdate !== 'function'
	    ) {
	      return Component;
	    }
	
	    // If new component APIs are defined, "unsafe" lifecycles won't be called.
	    // Error if any of these lifecycles are present,
	    // Because they would work differently between older and newer (16.3+) versions of React.
	    var foundWillMountName = null;
	    var foundWillReceivePropsName = null;
	    var foundWillUpdateName = null;
	    if (typeof prototype.componentWillMount === 'function') {
	      foundWillMountName = 'componentWillMount';
	    } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	      foundWillMountName = 'UNSAFE_componentWillMount';
	    }
	    if (typeof prototype.componentWillReceiveProps === 'function') {
	      foundWillReceivePropsName = 'componentWillReceiveProps';
	    } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	      foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	    }
	    if (typeof prototype.componentWillUpdate === 'function') {
	      foundWillUpdateName = 'componentWillUpdate';
	    } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	      foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	    }
	    if (
	      foundWillMountName !== null ||
	      foundWillReceivePropsName !== null ||
	      foundWillUpdateName !== null
	    ) {
	      var componentName = Component.displayName || Component.name;
	      var newApiName =
	        typeof Component.getDerivedStateFromProps === 'function'
	          ? 'getDerivedStateFromProps()'
	          : 'getSnapshotBeforeUpdate()';
	
	      throw Error(
	        'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	          componentName +
	          ' uses ' +
	          newApiName +
	          ' but also contains the following legacy lifecycles:' +
	          (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	          (foundWillReceivePropsName !== null
	            ? '\n  ' + foundWillReceivePropsName
	            : '') +
	          (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	          '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	          'https://fb.me/react-async-component-lifecycle-hooks'
	      );
	    }
	
	    // React <= 16.2 does not support static getDerivedStateFromProps.
	    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	    // Newer versions of React will ignore these lifecycles if gDSFP exists.
	    if (typeof Component.getDerivedStateFromProps === 'function') {
	      prototype.componentWillMount = componentWillMount;
	      prototype.componentWillReceiveProps = componentWillReceiveProps;
	    }
	
	    // React <= 16.2 does not support getSnapshotBeforeUpdate.
	    // As a workaround, use cWU to invoke the new lifecycle.
	    // Newer versions of React will ignore that lifecycle if gSBU exists.
	    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	      if (typeof prototype.componentDidUpdate !== 'function') {
	        throw new Error(
	          'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	        );
	      }
	
	      prototype.componentWillUpdate = componentWillUpdate;
	
	      var componentDidUpdate = prototype.componentDidUpdate;
	
	      prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	        prevProps,
	        prevState,
	        maybeSnapshot
	      ) {
	        // 16.3+ will not execute our will-update method;
	        // It will pass a snapshot value to did-update though.
	        // Older versions will require our polyfilled will-update value.
	        // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	        // Because for <= 15.x versions this might be a "prevContext" object.
	        // We also can't just check "__reactInternalSnapshot",
	        // Because get-snapshot might return a falsy value.
	        // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	        var snapshot = this.__reactInternalSnapshotFlag
	          ? this.__reactInternalSnapshot
	          : maybeSnapshot;
	
	        componentDidUpdate.call(this, prevProps, prevState, snapshot);
	      };
	    }
	
	    return Component;
	  }
	
	  var specialReactKeys = {
	    children: true,
	    key: true,
	    ref: true
	  };
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider(props, context) {
	      var _this;
	
	      _classCallCheck(this, Provider);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Provider).call(this, props, context));
	      _this.state = {};
	      copyStores(props, _this.state);
	      return _this;
	    }
	
	    _createClass(Provider, [{
	      key: "render",
	      value: function render() {
	        return React.Children.only(this.props.children);
	      }
	    }, {
	      key: "getChildContext",
	      value: function getChildContext() {
	        var stores = {}; // inherit stores
	
	        copyStores(this.context.mobxStores, stores); // add own stores
	
	        copyStores(this.props, stores);
	        return {
	          mobxStores: stores
	        };
	      }
	    }], [{
	      key: "getDerivedStateFromProps",
	      value: function getDerivedStateFromProps(nextProps, prevState) {
	        if (!nextProps) return null;
	        if (!prevState) return nextProps; // Maybe this warning is too aggressive?
	
	        if (Object.keys(nextProps).filter(validStoreName).length !== Object.keys(prevState).filter(validStoreName).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
	        if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
	          if (validStoreName(key) && prevState[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
	        }
	        return nextProps;
	      }
	    }]);
	
	    return Provider;
	  }(React.Component);
	
	  Provider.contextTypes = {
	    mobxStores: objectOrObservableObject
	  };
	  Provider.childContextTypes = {
	    mobxStores: objectOrObservableObject.isRequired
	  };
	
	  function copyStores(from, to) {
	    if (!from) return;
	
	    for (var key in from) {
	      if (validStoreName(key)) to[key] = from[key];
	    }
	  }
	
	  function validStoreName(key) {
	    return !specialReactKeys[key] && key !== "suppressChangedStoreWarning";
	  } // TODO: kill in next major
	
	
	  polyfill(Provider);
	
	  var storeKey = newSymbol("disposeOnUnmount");
	
	  function runDisposersOnWillUnmount() {
	    var _this = this;
	
	    if (!this[storeKey]) {
	      // when disposeOnUnmount is only set to some instances of a component it will still patch the prototype
	      return;
	    }
	
	    this[storeKey].forEach(function (propKeyOrFunction) {
	      var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
	
	      if (prop !== undefined && prop !== null) {
	        if (typeof prop !== "function") {
	          throw new Error("[mobx-react] disposeOnUnmount only works on functions such as disposers returned by reactions, autorun, etc.");
	        }
	
	        prop();
	      }
	    });
	    this[storeKey] = [];
	  }
	
	  function disposeOnUnmount(target, propertyKeyOrFunction) {
	    if (Array.isArray(propertyKeyOrFunction)) {
	      return propertyKeyOrFunction.map(function (fn) {
	        return disposeOnUnmount(target, fn);
	      });
	    }
	
	    if (!target instanceof React.Component) {
	      throw new Error("[mobx-react] disposeOnUnmount only works on class based React components.");
	    }
	
	    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function") {
	      throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
	    } // add property key / function we want run (disposed) to the store
	
	
	    var componentWasAlreadyModified = !!target[storeKey];
	    var store = target[storeKey] || (target[storeKey] = []);
	    store.push(propertyKeyOrFunction); // tweak the component class componentWillUnmount if not done already
	
	    if (!componentWasAlreadyModified) {
	      patch(target, "componentWillUnmount", runDisposersOnWillUnmount);
	    } // return the disposer as is if invoked as a non decorator
	
	
	    if (typeof propertyKeyOrFunction !== "string") {
	      return propertyKeyOrFunction;
	    }
	  }
	
	  if (!React.Component) throw new Error("mobx-react requires React to be available");
	  if (!mobx.spy) throw new Error("mobx-react requires mobx to be available");
	  if (typeof reactDom.unstable_batchedUpdates === "function") mobx.configure({
	    reactionScheduler: reactDom.unstable_batchedUpdates
	  });
	  var onError = function onError(fn) {
	    return errorsReporter.on(fn);
	  };
	
	  if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
	    var mobx$1 = {
	      spy: mobx.spy,
	      extras: {
	        getDebugName: mobx.getDebugName
	      }
	    };
	    var mobxReact = {
	      renderReporter: renderReporter,
	      componentByNodeRegistry: componentByNodeRegistry,
	      componentByNodeRegistery: componentByNodeRegistry,
	      trackComponents: trackComponents
	    };
	
	    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
	  }
	
	  exports.propTypes = propTypes;
	  exports.PropTypes = propTypes;
	  exports.onError = onError;
	  exports.observer = observer;
	  exports.Observer = Observer;
	  exports.renderReporter = renderReporter;
	  exports.componentByNodeRegistery = componentByNodeRegistry;
	  exports.componentByNodeRegistry = componentByNodeRegistry;
	  exports.trackComponents = trackComponents;
	  exports.useStaticRendering = useStaticRendering;
	  exports.Provider = Provider;
	  exports.inject = inject;
	  exports.disposeOnUnmount = disposeOnUnmount;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function __read(o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	}
	
	function __spread() {
	    for (var ar = [], i = 0; i < arguments.length; i++)
	        ar = ar.concat(__read(arguments[i]));
	    return ar;
	}
	
	var OBFUSCATED_ERROR$$1 = "An invariant failed, however the error is obfuscated because this is an production build.";
	var EMPTY_ARRAY$$1 = [];
	Object.freeze(EMPTY_ARRAY$$1);
	var EMPTY_OBJECT$$1 = {};
	Object.freeze(EMPTY_OBJECT$$1);
	function getGlobal$$1() {
	    return typeof window !== "undefined" ? window : global;
	}
	function getNextId$$1() {
	    return ++globalState$$1.mobxGuid;
	}
	function fail$1(message) {
	    invariant$$1(false, message);
	    throw "X"; // unreachable
	}
	function invariant$$1(check, message) {
	    if (!check)
	        throw new Error("[mobx] " + (message || OBFUSCATED_ERROR$$1));
	}
	/**
	 * Prints a deprecation message, but only one time.
	 * Returns false if the deprecated message was already printed before
	 */
	var deprecatedMessages = [];
	function deprecated$$1(msg, thing) {
	    if (true)
	        return false;
	    if (thing) {
	        return deprecated$$1("'" + msg + "', use '" + thing + "' instead.");
	    }
	    if (deprecatedMessages.indexOf(msg) !== -1)
	        return false;
	    deprecatedMessages.push(msg);
	    console.error("[mobx] Deprecated: " + msg);
	    return true;
	}
	/**
	 * Makes sure that the provided function is invoked at most once.
	 */
	function once$$1(func) {
	    var invoked = false;
	    return function () {
	        if (invoked)
	            return;
	        invoked = true;
	        return func.apply(this, arguments);
	    };
	}
	var noop$$1 = function () { };
	function unique$$1(list) {
	    var res = [];
	    list.forEach(function (item) {
	        if (res.indexOf(item) === -1)
	            res.push(item);
	    });
	    return res;
	}
	function isObject$$1(value) {
	    return value !== null && typeof value === "object";
	}
	function isPlainObject$$1(value) {
	    if (value === null || typeof value !== "object")
	        return false;
	    var proto = Object.getPrototypeOf(value);
	    return proto === Object.prototype || proto === null;
	}
	function makeNonEnumerable$$1(object, propNames) {
	    for (var i = 0; i < propNames.length; i++) {
	        addHiddenProp$$1(object, propNames[i], object[propNames[i]]);
	    }
	}
	function addHiddenProp$$1(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: true,
	        configurable: true,
	        value: value
	    });
	}
	function addHiddenFinalProp$$1(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: false,
	        configurable: true,
	        value: value
	    });
	}
	function isPropertyConfigurable$$1(object, prop) {
	    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
	    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
	}
	function assertPropertyConfigurable$$1(object, prop) {
	    if (false)
	        fail$1("Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
	}
	function createInstanceofPredicate$$1(name, clazz) {
	    var propName = "isMobX" + name;
	    clazz.prototype[propName] = true;
	    return function (x) {
	        return isObject$$1(x) && x[propName] === true;
	    };
	}
	function areBothNaN$$1(a, b) {
	    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
	}
	/**
	 * Returns whether the argument is an array, disregarding observability.
	 */
	function isArrayLike$$1(x) {
	    return Array.isArray(x) || isObservableArray$$1(x);
	}
	function isES6Map$$1(thing) {
	    if (getGlobal$$1().Map !== undefined && thing instanceof getGlobal$$1().Map)
	        return true;
	    return false;
	}
	function isES6Set$$1(thing) {
	    return thing instanceof Set;
	}
	function getMapLikeKeys$$1(map) {
	    if (isPlainObject$$1(map))
	        return Object.keys(map);
	    if (Array.isArray(map))
	        return map.map(function (_a) {
	            var _b = __read(_a, 1), key = _b[0];
	            return key;
	        });
	    if (isES6Map$$1(map) || isObservableMap$$1(map))
	        return iteratorToArray$$1(map.keys());
	    return fail$1("Cannot get keys from '" + map + "'");
	}
	// use Array.from in Mobx 5
	function iteratorToArray$$1(it) {
	    var res = [];
	    while (true) {
	        var r = it.next();
	        if (r.done)
	            break;
	        res.push(r.value);
	    }
	    return res;
	}
	function primitiveSymbol$$1() {
	    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
	}
	function toPrimitive$$1(value) {
	    return value === null ? null : typeof value === "object" ? "" + value : value;
	}
	
	function iteratorSymbol$$1() {
	    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
	}
	
	function declareIterator$$1(prototType, iteratorFactory) {
	    addHiddenFinalProp$$1(prototType, iteratorSymbol$$1(), iteratorFactory);
	}
	function makeIterable$$1(iterator) {
	    iterator[iteratorSymbol$$1()] = self;
	    return iterator;
	}
	function toStringTagSymbol$$1() {
	    return (typeof Symbol === "function" && Symbol.toStringTag) || "@@toStringTag";
	}
	function self() {
	    return this;
	}
	
	/**
	 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
	 *
	 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
	 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
	 */
	var Atom$$1 = /** @class */ (function () {
	    /**
	     * Create a new atom. For debugging purposes it is recommended to give it a name.
	     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
	     */
	    function Atom$$1(name) {
	        if (name === void 0) { name = "Atom@" + getNextId$$1(); }
	        this.name = name;
	        this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
	        this.isBeingObserved = false;
	        this.observers = [];
	        this.observersIndexes = {};
	        this.diffValue = 0;
	        this.lastAccessedBy = 0;
	        this.lowestObserverState = exports.IDerivationState.NOT_TRACKING;
	    }
	    Atom$$1.prototype.onBecomeUnobserved = function () {
	        // noop
	    };
	    Atom$$1.prototype.onBecomeObserved = function () {
	        /* noop */
	    };
	    /**
	     * Invoke this method to notify mobx that your atom has been used somehow.
	     * Returns true if there is currently a reactive context.
	     */
	    Atom$$1.prototype.reportObserved = function () {
	        return reportObserved$$1(this);
	    };
	    /**
	     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
	     */
	    Atom$$1.prototype.reportChanged = function () {
	        startBatch$$1();
	        propagateChanged$$1(this);
	        endBatch$$1();
	    };
	    Atom$$1.prototype.toString = function () {
	        return this.name;
	    };
	    return Atom$$1;
	}());
	var isAtom$$1 = createInstanceofPredicate$$1("Atom", Atom$$1);
	function createAtom$$1(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
	    if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop$$1; }
	    if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop$$1; }
	    var atom = new Atom$$1(name);
	    onBecomeObserved$$1(atom, onBecomeObservedHandler);
	    onBecomeUnobserved$$1(atom, onBecomeUnobservedHandler);
	    return atom;
	}
	
	function identityComparer(a, b) {
	    return a === b;
	}
	function structuralComparer(a, b) {
	    return deepEqual$$1(a, b);
	}
	function defaultComparer(a, b) {
	    return areBothNaN$$1(a, b) || identityComparer(a, b);
	}
	var comparer$$1 = {
	    identity: identityComparer,
	    structural: structuralComparer,
	    default: defaultComparer
	};
	
	var enumerableDescriptorCache = {};
	var nonEnumerableDescriptorCache = {};
	function createPropertyInitializerDescriptor(prop, enumerable) {
	    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
	    return (cache[prop] ||
	        (cache[prop] = {
	            configurable: true,
	            enumerable: enumerable,
	            get: function () {
	                initializeInstance$$1(this);
	                return this[prop];
	            },
	            set: function (value) {
	                initializeInstance$$1(this);
	                this[prop] = value;
	            }
	        }));
	}
	function initializeInstance$$1(target) {
	    if (target.__mobxDidRunLazyInitializers === true)
	        return;
	    var decorators = target.__mobxDecorators;
	    if (decorators) {
	        addHiddenProp$$1(target, "__mobxDidRunLazyInitializers", true);
	        for (var key in decorators) {
	            var d = decorators[key];
	            d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
	        }
	    }
	}
	function createPropDecorator$$1(propertyInitiallyEnumerable, propertyCreator) {
	    return function decoratorFactory() {
	        var decoratorArguments;
	        var decorator = function decorate$$1(target, prop, descriptor, applyImmediately
	        // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
	        // as the instance to apply the decorator to equals the target
	        ) {
	            if (applyImmediately === true) {
	                propertyCreator(target, prop, descriptor, target, decoratorArguments);
	                return null;
	            }
	            if (false)
	                fail$1("This function is a decorator, but it wasn't invoked like a decorator");
	            if (!Object.prototype.hasOwnProperty.call(target, "__mobxDecorators")) {
	                var inheritedDecorators = target.__mobxDecorators;
	                addHiddenProp$$1(target, "__mobxDecorators", __assign({}, inheritedDecorators));
	            }
	            target.__mobxDecorators[prop] = {
	                prop: prop,
	                propertyCreator: propertyCreator,
	                descriptor: descriptor,
	                decoratorTarget: target,
	                decoratorArguments: decoratorArguments
	            };
	            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
	        };
	        if (quacksLikeADecorator$$1(arguments)) {
	            // @decorator
	            decoratorArguments = EMPTY_ARRAY$$1;
	            return decorator.apply(null, arguments);
	        }
	        else {
	            // @decorator(args)
	            decoratorArguments = Array.prototype.slice.call(arguments);
	            return decorator;
	        }
	    };
	}
	function quacksLikeADecorator$$1(args) {
	    return (((args.length === 2 || args.length === 3) && typeof args[1] === "string") ||
	        (args.length === 4 && args[3] === true));
	}
	
	function deepEnhancer$$1(v, _, name) {
	    // it is an observable already, done
	    if (isObservable$$1(v))
	        return v;
	    // something that can be converted and mutated?
	    if (Array.isArray(v))
	        return observable$$1.array(v, { name: name });
	    if (isPlainObject$$1(v))
	        return observable$$1.object(v, undefined, { name: name });
	    if (isES6Map$$1(v))
	        return observable$$1.map(v, { name: name });
	    if (isES6Set$$1(v))
	        return observable$$1.set(v, { name: name });
	    return v;
	}
	function shallowEnhancer$$1(v, _, name) {
	    if (v === undefined || v === null)
	        return v;
	    if (isObservableObject$$1(v) || isObservableArray$$1(v) || isObservableMap$$1(v) || isObservableSet$$1(v))
	        return v;
	    if (Array.isArray(v))
	        return observable$$1.array(v, { name: name, deep: false });
	    if (isPlainObject$$1(v))
	        return observable$$1.object(v, undefined, { name: name, deep: false });
	    if (isES6Map$$1(v))
	        return observable$$1.map(v, { name: name, deep: false });
	    if (isES6Set$$1(v))
	        return observable$$1.set(v, { name: name, deep: false });
	    return fail$1(("production") !== "production" &&
	        "The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
	}
	function referenceEnhancer$$1(newValue) {
	    // never turn into an observable
	    return newValue;
	}
	function refStructEnhancer$$1(v, oldValue, name) {
	    if (false)
	        throw "observable.struct should not be used with observable values";
	    if (deepEqual$$1(v, oldValue))
	        return oldValue;
	    return v;
	}
	
	function createDecoratorForEnhancer$$1(enhancer) {
	    var decorator = createPropDecorator$$1(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
	        if (false) {
	            invariant$$1(!descriptor || !descriptor.get, "@observable cannot be used on getter (property \"" + propertyName + "\"), use @computed instead.");
	        }
	        var initialValue = descriptor
	            ? descriptor.initializer
	                ? descriptor.initializer.call(target)
	                : descriptor.value
	            : undefined;
	        defineObservableProperty$$1(target, propertyName, initialValue, enhancer);
	    });
	    var res = 
	    // Extra process checks, as this happens during module initialization
	    typeof process !== "undefined" && ({"NODE_ENV":"production","PUBLIC_DIR":"/opt/atlassian/pipelines/agent/build/public"}) && ("production") !== "production"
	        ? function observableDecorator() {
	            // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
	            // and simply return the created prop decorator
	            if (arguments.length < 2)
	                return fail$1("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
	            return decorator.apply(null, arguments);
	        }
	        : decorator;
	    res.enhancer = enhancer;
	    return res;
	}
	
	// Predefined bags of create observable options, to avoid allocating temporarily option objects
	// in the majority of cases
	var defaultCreateObservableOptions$$1 = {
	    deep: true,
	    name: undefined,
	    defaultDecorator: undefined
	};
	var shallowCreateObservableOptions$$1 = {
	    deep: false,
	    name: undefined,
	    defaultDecorator: undefined
	};
	Object.freeze(defaultCreateObservableOptions$$1);
	Object.freeze(shallowCreateObservableOptions$$1);
	function assertValidOption(key) {
	    if (!/^(deep|name|equals|defaultDecorator)$/.test(key))
	        fail$1("invalid option for (extend)observable: " + key);
	}
	function asCreateObservableOptions$$1(thing) {
	    if (thing === null || thing === undefined)
	        return defaultCreateObservableOptions$$1;
	    if (typeof thing === "string")
	        return { name: thing, deep: true };
	    if (false) {
	        if (typeof thing !== "object")
	            return fail$1("expected options object");
	        Object.keys(thing).forEach(assertValidOption);
	    }
	    return thing;
	}
	function getEnhancerFromOptions(options) {
	    return options.defaultDecorator
	        ? options.defaultDecorator.enhancer
	        : options.deep === false
	            ? referenceEnhancer$$1
	            : deepEnhancer$$1;
	}
	var deepDecorator$$1 = createDecoratorForEnhancer$$1(deepEnhancer$$1);
	var shallowDecorator = createDecoratorForEnhancer$$1(shallowEnhancer$$1);
	var refDecorator$$1 = createDecoratorForEnhancer$$1(referenceEnhancer$$1);
	var refStructDecorator = createDecoratorForEnhancer$$1(refStructEnhancer$$1);
	/**
	 * Turns an object, array or function into a reactive structure.
	 * @param v the value which should become observable.
	 */
	function createObservable(v, arg2, arg3) {
	    // @observable someProp;
	    if (typeof arguments[1] === "string") {
	        return deepDecorator$$1.apply(null, arguments);
	    }
	    // it is an observable already, done
	    if (isObservable$$1(v))
	        return v;
	    // something that can be converted and mutated?
	    var res = isPlainObject$$1(v)
	        ? observable$$1.object(v, arg2, arg3)
	        : Array.isArray(v)
	            ? observable$$1.array(v, arg2)
	            : isES6Map$$1(v)
	                ? observable$$1.map(v, arg2)
	                : isES6Set$$1(v)
	                    ? observable$$1.set(v, arg2)
	                    : v;
	    // this value could be converted to a new observable data structure, return it
	    if (res !== v)
	        return res;
	    // otherwise, just box it
	    fail$1(("production") !== "production" &&
	        "The provided value could not be converted into an observable. If you want just create an observable reference to the object use 'observable.box(value)'");
	}
	var observableFactories = {
	    box: function (value, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("box");
	        var o = asCreateObservableOptions$$1(options);
	        return new ObservableValue$$1(value, getEnhancerFromOptions(o), o.name, true, o.equals);
	    },
	    shallowBox: function (value, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowBox");
	        deprecated$$1("observable.shallowBox", "observable.box(value, { deep: false })");
	        return observable$$1.box(value, { name: name, deep: false });
	    },
	    array: function (initialValues, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("array");
	        var o = asCreateObservableOptions$$1(options);
	        return new ObservableArray$$1(initialValues, getEnhancerFromOptions(o), o.name);
	    },
	    shallowArray: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowArray");
	        deprecated$$1("observable.shallowArray", "observable.array(values, { deep: false })");
	        return observable$$1.array(initialValues, { name: name, deep: false });
	    },
	    map: function (initialValues, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("map");
	        var o = asCreateObservableOptions$$1(options);
	        return new ObservableMap$$1(initialValues, getEnhancerFromOptions(o), o.name);
	    },
	    shallowMap: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowMap");
	        deprecated$$1("observable.shallowMap", "observable.map(values, { deep: false })");
	        return observable$$1.map(initialValues, { name: name, deep: false });
	    },
	    set: function (initialValues, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("set");
	        var o = asCreateObservableOptions$$1(options);
	        return new ObservableSet$$1(initialValues, getEnhancerFromOptions(o), o.name);
	    },
	    object: function (props, decorators, options) {
	        if (typeof arguments[1] === "string")
	            incorrectlyUsedAsDecorator("object");
	        var o = asCreateObservableOptions$$1(options);
	        return extendObservable$$1({}, props, decorators, o);
	    },
	    shallowObject: function (props, name) {
	        if (typeof arguments[1] === "string")
	            incorrectlyUsedAsDecorator("shallowObject");
	        deprecated$$1("observable.shallowObject", "observable.object(values, {}, { deep: false })");
	        return observable$$1.object(props, {}, { name: name, deep: false });
	    },
	    ref: refDecorator$$1,
	    shallow: shallowDecorator,
	    deep: deepDecorator$$1,
	    struct: refStructDecorator
	};
	var observable$$1 = createObservable;
	// weird trick to keep our typings nicely with our funcs, and still extend the observable function
	Object.keys(observableFactories).forEach(function (name) { return (observable$$1[name] = observableFactories[name]); });
	function incorrectlyUsedAsDecorator(methodName) {
	    fail$1(
	    // process.env.NODE_ENV !== "production" &&
	    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
	}
	
	var computedDecorator$$1 = createPropDecorator$$1(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
	    var get$$1 = descriptor.get, set$$1 = descriptor.set; // initialValue is the descriptor for get / set props
	    // Optimization: faster on decorator target or instance? Assuming target
	    // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
	    // Forcing instance now, fixes hot reloadig issues on React Native:
	    var options = decoratorArgs[0] || {};
	    defineComputedProperty$$1(instance, propertyName, __assign({ get: get$$1, set: set$$1 }, options));
	});
	var computedStructDecorator = computedDecorator$$1({ equals: comparer$$1.structural });
	/**
	 * Decorator for class properties: @computed get value() { return expr; }.
	 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
	 */
	var computed$$1 = function computed$$1(arg1, arg2, arg3) {
	    if (typeof arg2 === "string") {
	        // @computed
	        return computedDecorator$$1.apply(null, arguments);
	    }
	    if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
	        // @computed({ options })
	        return computedDecorator$$1.apply(null, arguments);
	    }
	    // computed(expr, options?)
	    if (false) {
	        invariant$$1(typeof arg1 === "function", "First argument to `computed` should be an expression.");
	        invariant$$1(arguments.length < 3, "Computed takes one or two arguments if used as function");
	    }
	    var opts = typeof arg2 === "object" ? arg2 : {};
	    opts.get = arg1;
	    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
	    opts.name = opts.name || arg1.name || ""; /* for generated name */
	    return new ComputedValue$$1(opts);
	};
	computed$$1.struct = computedStructDecorator;
	
	function createAction$$1(actionName, fn) {
	    if (false) {
	        invariant$$1(typeof fn === "function", "`action` can only be invoked on functions");
	        if (typeof actionName !== "string" || !actionName)
	            fail$1("actions should have valid names, got: '" + actionName + "'");
	    }
	    var res = function () {
	        return executeAction$$1(actionName, fn, this, arguments);
	    };
	    res.isMobxAction = true;
	    return res;
	}
	function executeAction$$1(actionName, fn, scope, args) {
	    var runInfo = startAction(actionName, fn, scope, args);
	    var shouldSupressReactionError = true;
	    try {
	        var res = fn.apply(scope, args);
	        shouldSupressReactionError = false;
	        return res;
	    }
	    finally {
	        if (shouldSupressReactionError) {
	            globalState$$1.suppressReactionErrors = shouldSupressReactionError;
	            endAction(runInfo);
	            globalState$$1.suppressReactionErrors = false;
	        }
	        else {
	            endAction(runInfo);
	        }
	    }
	}
	function startAction(actionName, fn, scope, args) {
	    var notifySpy = isSpyEnabled$$1() && !!actionName;
	    var startTime = 0;
	    if (notifySpy) {
	        startTime = Date.now();
	        var l = (args && args.length) || 0;
	        var flattendArgs = new Array(l);
	        if (l > 0)
	            for (var i = 0; i < l; i++)
	                flattendArgs[i] = args[i];
	        spyReportStart$$1({
	            type: "action",
	            name: actionName,
	            object: scope,
	            arguments: flattendArgs
	        });
	    }
	    var prevDerivation = untrackedStart$$1();
	    startBatch$$1();
	    var prevAllowStateChanges = allowStateChangesStart$$1(true);
	    return {
	        prevDerivation: prevDerivation,
	        prevAllowStateChanges: prevAllowStateChanges,
	        notifySpy: notifySpy,
	        startTime: startTime
	    };
	}
	function endAction(runInfo) {
	    allowStateChangesEnd$$1(runInfo.prevAllowStateChanges);
	    endBatch$$1();
	    untrackedEnd$$1(runInfo.prevDerivation);
	    if (runInfo.notifySpy)
	        spyReportEnd$$1({ time: Date.now() - runInfo.startTime });
	}
	function allowStateChanges$$1(allowStateChanges$$1, func) {
	    var prev = allowStateChangesStart$$1(allowStateChanges$$1);
	    var res;
	    try {
	        res = func();
	    }
	    finally {
	        allowStateChangesEnd$$1(prev);
	    }
	    return res;
	}
	function allowStateChangesStart$$1(allowStateChanges$$1) {
	    var prev = globalState$$1.allowStateChanges;
	    globalState$$1.allowStateChanges = allowStateChanges$$1;
	    return prev;
	}
	function allowStateChangesEnd$$1(prev) {
	    globalState$$1.allowStateChanges = prev;
	}
	function allowStateChangesInsideComputed$$1(func) {
	    var prev = globalState$$1.computationDepth;
	    globalState$$1.computationDepth = 0;
	    var res;
	    try {
	        res = func();
	    }
	    finally {
	        globalState$$1.computationDepth = prev;
	    }
	    return res;
	}
	
	var ObservableValue$$1 = /** @class */ (function (_super) {
	    __extends(ObservableValue$$1, _super);
	    function ObservableValue$$1(value, enhancer, name, notifySpy, equals) {
	        if (name === void 0) { name = "ObservableValue@" + getNextId$$1(); }
	        if (notifySpy === void 0) { notifySpy = true; }
	        if (equals === void 0) { equals = comparer$$1.default; }
	        var _this = _super.call(this, name) || this;
	        _this.enhancer = enhancer;
	        _this.name = name;
	        _this.equals = equals;
	        _this.hasUnreportedChange = false;
	        _this.value = enhancer(value, undefined, name);
	        if (notifySpy && isSpyEnabled$$1()) {
	            // only notify spy if this is a stand-alone observable
	            spyReport$$1({ type: "create", name: _this.name, newValue: "" + _this.value });
	        }
	        return _this;
	    }
	    ObservableValue$$1.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined)
	            return this.dehancer(value);
	        return value;
	    };
	    ObservableValue$$1.prototype.set = function (newValue) {
	        var oldValue = this.value;
	        newValue = this.prepareNewValue(newValue);
	        if (newValue !== globalState$$1.UNCHANGED) {
	            var notifySpy = isSpyEnabled$$1();
	            if (notifySpy) {
	                spyReportStart$$1({
	                    type: "update",
	                    name: this.name,
	                    newValue: newValue,
	                    oldValue: oldValue
	                });
	            }
	            this.setNewValue(newValue);
	            if (notifySpy)
	                spyReportEnd$$1();
	        }
	    };
	    ObservableValue$$1.prototype.prepareNewValue = function (newValue) {
	        checkIfStateModificationsAreAllowed$$1(this);
	        if (hasInterceptors$$1(this)) {
	            var change = interceptChange$$1(this, {
	                object: this,
	                type: "update",
	                newValue: newValue
	            });
	            if (!change)
	                return globalState$$1.UNCHANGED;
	            newValue = change.newValue;
	        }
	        // apply modifier
	        newValue = this.enhancer(newValue, this.value, this.name);
	        return this.equals(this.value, newValue) ? globalState$$1.UNCHANGED : newValue;
	    };
	    ObservableValue$$1.prototype.setNewValue = function (newValue) {
	        var oldValue = this.value;
	        this.value = newValue;
	        this.reportChanged();
	        if (hasListeners$$1(this)) {
	            notifyListeners$$1(this, {
	                type: "update",
	                object: this,
	                newValue: newValue,
	                oldValue: oldValue
	            });
	        }
	    };
	    ObservableValue$$1.prototype.get = function () {
	        this.reportObserved();
	        return this.dehanceValue(this.value);
	    };
	    ObservableValue$$1.prototype.intercept = function (handler) {
	        return registerInterceptor$$1(this, handler);
	    };
	    ObservableValue$$1.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately)
	            listener({
	                object: this,
	                type: "update",
	                newValue: this.value,
	                oldValue: undefined
	            });
	        return registerListener$$1(this, listener);
	    };
	    ObservableValue$$1.prototype.toJSON = function () {
	        return this.get();
	    };
	    ObservableValue$$1.prototype.toString = function () {
	        return this.name + "[" + this.value + "]";
	    };
	    ObservableValue$$1.prototype.valueOf = function () {
	        return toPrimitive$$1(this.get());
	    };
	    return ObservableValue$$1;
	}(Atom$$1));
	ObservableValue$$1.prototype[primitiveSymbol$$1()] = ObservableValue$$1.prototype.valueOf;
	var isObservableValue$$1 = createInstanceofPredicate$$1("ObservableValue", ObservableValue$$1);
	
	/**
	 * A node in the state dependency root that observes other nodes, and can be observed itself.
	 *
	 * ComputedValue will remember the result of the computation for the duration of the batch, or
	 * while being observed.
	 *
	 * During this time it will recompute only when one of its direct dependencies changed,
	 * but only when it is being accessed with `ComputedValue.get()`.
	 *
	 * Implementation description:
	 * 1. First time it's being accessed it will compute and remember result
	 *    give back remembered result until 2. happens
	 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
	 * 3. When it's being accessed, recompute if any shallow dependency changed.
	 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
	 *    go to step 2. either way
	 *
	 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
	 */
	var ComputedValue$$1 = /** @class */ (function () {
	    /**
	     * Create a new computed value based on a function expression.
	     *
	     * The `name` property is for debug purposes only.
	     *
	     * The `equals` property specifies the comparer function to use to determine if a newly produced
	     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
	     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
	     * Structural comparison can be convenient if you always produce a new aggregated object and
	     * don't want to notify observers if it is structurally the same.
	     * This is useful for working with vectors, mouse coordinates etc.
	     */
	    function ComputedValue$$1(options) {
	        this.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = null; // during tracking it's an array with new observed observers
	        this.isBeingObserved = false;
	        this.isPendingUnobservation = false;
	        this.observers = [];
	        this.observersIndexes = {};
	        this.diffValue = 0;
	        this.runId = 0;
	        this.lastAccessedBy = 0;
	        this.lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId$$1();
	        this.value = new CaughtException$$1(null);
	        this.isComputing = false; // to check for cycles
	        this.isRunningSetter = false;
	        this.isTracing = TraceMode$$1.NONE;
	        if (false)
	            return fail$1("missing option for computed: get");
	        this.derivation = options.get;
	        this.name = options.name || "ComputedValue@" + getNextId$$1();
	        if (options.set)
	            this.setter = createAction$$1(this.name + "-setter", options.set);
	        this.equals =
	            options.equals ||
	                (options.compareStructural || options.struct
	                    ? comparer$$1.structural
	                    : comparer$$1.default);
	        this.scope = options.context;
	        this.requiresReaction = !!options.requiresReaction;
	        this.keepAlive = !!options.keepAlive;
	    }
	    ComputedValue$$1.prototype.onBecomeStale = function () {
	        propagateMaybeChanged$$1(this);
	    };
	    ComputedValue$$1.prototype.onBecomeUnobserved = function () { };
	    ComputedValue$$1.prototype.onBecomeObserved = function () { };
	    /**
	     * Returns the current value of this computed value.
	     * Will evaluate its computation first if needed.
	     */
	    ComputedValue$$1.prototype.get = function () {
	        if (this.isComputing)
	            fail$1("Cycle detected in computation " + this.name + ": " + this.derivation);
	        if (globalState$$1.inBatch === 0 && this.observers.length === 0 && !this.keepAlive) {
	            if (shouldCompute$$1(this)) {
	                this.warnAboutUntrackedRead();
	                startBatch$$1(); // See perf test 'computed memoization'
	                this.value = this.computeValue(false);
	                endBatch$$1();
	            }
	        }
	        else {
	            reportObserved$$1(this);
	            if (shouldCompute$$1(this))
	                if (this.trackAndCompute())
	                    propagateChangeConfirmed$$1(this);
	        }
	        var result = this.value;
	        if (isCaughtException$$1(result))
	            throw result.cause;
	        return result;
	    };
	    ComputedValue$$1.prototype.peek = function () {
	        var res = this.computeValue(false);
	        if (isCaughtException$$1(res))
	            throw res.cause;
	        return res;
	    };
	    ComputedValue$$1.prototype.set = function (value) {
	        if (this.setter) {
	            invariant$$1(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
	            this.isRunningSetter = true;
	            try {
	                this.setter.call(this.scope, value);
	            }
	            finally {
	                this.isRunningSetter = false;
	            }
	        }
	        else
	            invariant$$1(false, ("production") !== "production" &&
	                "[ComputedValue '" + this.name + "'] It is not possible to assign a new value to a computed value.");
	    };
	    ComputedValue$$1.prototype.trackAndCompute = function () {
	        if (isSpyEnabled$$1()) {
	            spyReport$$1({
	                object: this.scope,
	                type: "compute",
	                name: this.name
	            });
	        }
	        var oldValue = this.value;
	        var wasSuspended = 
	        /* see #1208 */ this.dependenciesState === exports.IDerivationState.NOT_TRACKING;
	        var newValue = this.computeValue(true);
	        var changed = wasSuspended ||
	            isCaughtException$$1(oldValue) ||
	            isCaughtException$$1(newValue) ||
	            !this.equals(oldValue, newValue);
	        if (changed) {
	            this.value = newValue;
	        }
	        return changed;
	    };
	    ComputedValue$$1.prototype.computeValue = function (track) {
	        this.isComputing = true;
	        globalState$$1.computationDepth++;
	        var res;
	        if (track) {
	            res = trackDerivedFunction$$1(this, this.derivation, this.scope);
	        }
	        else {
	            if (globalState$$1.disableErrorBoundaries === true) {
	                res = this.derivation.call(this.scope);
	            }
	            else {
	                try {
	                    res = this.derivation.call(this.scope);
	                }
	                catch (e) {
	                    res = new CaughtException$$1(e);
	                }
	            }
	        }
	        globalState$$1.computationDepth--;
	        this.isComputing = false;
	        return res;
	    };
	    ComputedValue$$1.prototype.suspend = function () {
	        if (!this.keepAlive) {
	            clearObserving$$1(this);
	            this.value = undefined; // don't hold on to computed value!
	        }
	    };
	    ComputedValue$$1.prototype.observe = function (listener, fireImmediately) {
	        var _this = this;
	        var firstTime = true;
	        var prevValue = undefined;
	        return autorun$$1(function () {
	            var newValue = _this.get();
	            if (!firstTime || fireImmediately) {
	                var prevU = untrackedStart$$1();
	                listener({
	                    type: "update",
	                    object: _this,
	                    newValue: newValue,
	                    oldValue: prevValue
	                });
	                untrackedEnd$$1(prevU);
	            }
	            firstTime = false;
	            prevValue = newValue;
	        });
	    };
	    ComputedValue$$1.prototype.warnAboutUntrackedRead = function () {
	        if (true)
	            return;
	        if (this.requiresReaction === true) {
	            fail$1("[mobx] Computed value " + this.name + " is read outside a reactive context");
	        }
	        if (this.isTracing !== TraceMode$$1.NONE) {
	            console.log("[mobx.trace] '" + this.name + "' is being read outside a reactive context. Doing a full recompute");
	        }
	        if (globalState$$1.computedRequiresReaction) {
	            console.warn("[mobx] Computed value " + this.name + " is being read outside a reactive context. Doing a full recompute");
	        }
	    };
	    ComputedValue$$1.prototype.toJSON = function () {
	        return this.get();
	    };
	    ComputedValue$$1.prototype.toString = function () {
	        return this.name + "[" + this.derivation.toString() + "]";
	    };
	    ComputedValue$$1.prototype.valueOf = function () {
	        return toPrimitive$$1(this.get());
	    };
	    return ComputedValue$$1;
	}());
	ComputedValue$$1.prototype[primitiveSymbol$$1()] = ComputedValue$$1.prototype.valueOf;
	var isComputedValue$$1 = createInstanceofPredicate$$1("ComputedValue", ComputedValue$$1);
	
	(function (IDerivationState$$1) {
	    // before being run or (outside batch and not being observed)
	    // at this point derivation is not holding any data about dependency tree
	    IDerivationState$$1[IDerivationState$$1["NOT_TRACKING"] = -1] = "NOT_TRACKING";
	    // no shallow dependency changed since last computation
	    // won't recalculate derivation
	    // this is what makes mobx fast
	    IDerivationState$$1[IDerivationState$$1["UP_TO_DATE"] = 0] = "UP_TO_DATE";
	    // some deep dependency changed, but don't know if shallow dependency changed
	    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
	    // currently only ComputedValue will propagate POSSIBLY_STALE
	    //
	    // having this state is second big optimization:
	    // don't have to recompute on every dependency change, but only when it's needed
	    IDerivationState$$1[IDerivationState$$1["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
	    // A shallow dependency has changed since last computation and the derivation
	    // will need to recompute when it's needed next.
	    IDerivationState$$1[IDerivationState$$1["STALE"] = 2] = "STALE";
	})(exports.IDerivationState || (exports.IDerivationState = {}));
	var TraceMode$$1;
	(function (TraceMode$$1) {
	    TraceMode$$1[TraceMode$$1["NONE"] = 0] = "NONE";
	    TraceMode$$1[TraceMode$$1["LOG"] = 1] = "LOG";
	    TraceMode$$1[TraceMode$$1["BREAK"] = 2] = "BREAK";
	})(TraceMode$$1 || (TraceMode$$1 = {}));
	var CaughtException$$1 = /** @class */ (function () {
	    function CaughtException$$1(cause) {
	        this.cause = cause;
	        // Empty
	    }
	    return CaughtException$$1;
	}());
	function isCaughtException$$1(e) {
	    return e instanceof CaughtException$$1;
	}
	/**
	 * Finds out whether any dependency of the derivation has actually changed.
	 * If dependenciesState is 1 then it will recalculate dependencies,
	 * if any dependency changed it will propagate it by changing dependenciesState to 2.
	 *
	 * By iterating over the dependencies in the same order that they were reported and
	 * stopping on the first change, all the recalculations are only called for ComputedValues
	 * that will be tracked by derivation. That is because we assume that if the first x
	 * dependencies of the derivation doesn't change then the derivation should run the same way
	 * up until accessing x-th dependency.
	 */
	function shouldCompute$$1(derivation) {
	    switch (derivation.dependenciesState) {
	        case exports.IDerivationState.UP_TO_DATE:
	            return false;
	        case exports.IDerivationState.NOT_TRACKING:
	        case exports.IDerivationState.STALE:
	            return true;
	        case exports.IDerivationState.POSSIBLY_STALE: {
	            var prevUntracked = untrackedStart$$1(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
	            var obs = derivation.observing, l = obs.length;
	            for (var i = 0; i < l; i++) {
	                var obj = obs[i];
	                if (isComputedValue$$1(obj)) {
	                    if (globalState$$1.disableErrorBoundaries) {
	                        obj.get();
	                    }
	                    else {
	                        try {
	                            obj.get();
	                        }
	                        catch (e) {
	                            // we are not interested in the value *or* exception at this moment, but if there is one, notify all
	                            untrackedEnd$$1(prevUntracked);
	                            return true;
	                        }
	                    }
	                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
	                    // and `derivation` is an observer of `obj`
	                    // invariantShouldCompute(derivation)
	                    if (derivation.dependenciesState === exports.IDerivationState.STALE) {
	                        untrackedEnd$$1(prevUntracked);
	                        return true;
	                    }
	                }
	            }
	            changeDependenciesStateTo0$$1(derivation);
	            untrackedEnd$$1(prevUntracked);
	            return false;
	        }
	    }
	}
	// function invariantShouldCompute(derivation: IDerivation) {
	//     const newDepState = (derivation as any).dependenciesState
	//     if (
	//         process.env.NODE_ENV === "production" &&
	//         (newDepState === IDerivationState.POSSIBLY_STALE ||
	//             newDepState === IDerivationState.NOT_TRACKING)
	//     )
	//         fail("Illegal dependency state")
	// }
	function isComputingDerivation$$1() {
	    return globalState$$1.trackingDerivation !== null; // filter out actions inside computations
	}
	function checkIfStateModificationsAreAllowed$$1(atom) {
	    var hasObservers$$1 = atom.observers.length > 0;
	    // Should never be possible to change an observed observable from inside computed, see #798
	    if (globalState$$1.computationDepth > 0 && hasObservers$$1)
	        fail$1(("production") !== "production" &&
	            "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: " + atom.name);
	    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
	    if (!globalState$$1.allowStateChanges && (hasObservers$$1 || globalState$$1.enforceActions === "strict"))
	        fail$1(("production") !== "production" &&
	            (globalState$$1.enforceActions
	                ? "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: "
	                : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ") +
	                atom.name);
	}
	/**
	 * Executes the provided function `f` and tracks which observables are being accessed.
	 * The tracking information is stored on the `derivation` object and the derivation is registered
	 * as observer of any of the accessed observables.
	 */
	function trackDerivedFunction$$1(derivation, f, context) {
	    // pre allocate array allocation + room for variation in deps
	    // array will be trimmed by bindDependencies
	    changeDependenciesStateTo0$$1(derivation);
	    derivation.newObserving = new Array(derivation.observing.length + 100);
	    derivation.unboundDepsCount = 0;
	    derivation.runId = ++globalState$$1.runId;
	    var prevTracking = globalState$$1.trackingDerivation;
	    globalState$$1.trackingDerivation = derivation;
	    var result;
	    if (globalState$$1.disableErrorBoundaries === true) {
	        result = f.call(context);
	    }
	    else {
	        try {
	            result = f.call(context);
	        }
	        catch (e) {
	            result = new CaughtException$$1(e);
	        }
	    }
	    globalState$$1.trackingDerivation = prevTracking;
	    bindDependencies(derivation);
	    return result;
	}
	/**
	 * diffs newObserving with observing.
	 * update observing to be newObserving with unique observables
	 * notify observers that become observed/unobserved
	 */
	function bindDependencies(derivation) {
	    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
	    var prevObserving = derivation.observing;
	    var observing = (derivation.observing = derivation.newObserving);
	    var lowestNewObservingDerivationState = exports.IDerivationState.UP_TO_DATE;
	    // Go through all new observables and check diffValue: (this list can contain duplicates):
	    //   0: first occurrence, change to 1 and keep it
	    //   1: extra occurrence, drop it
	    var i0 = 0, l = derivation.unboundDepsCount;
	    for (var i = 0; i < l; i++) {
	        var dep = observing[i];
	        if (dep.diffValue === 0) {
	            dep.diffValue = 1;
	            if (i0 !== i)
	                observing[i0] = dep;
	            i0++;
	        }
	        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
	        // not hitting the condition
	        if (dep.dependenciesState > lowestNewObservingDerivationState) {
	            lowestNewObservingDerivationState = dep.dependenciesState;
	        }
	    }
	    observing.length = i0;
	    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
	    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
	    //   0: it's not in new observables, unobserve it
	    //   1: it keeps being observed, don't want to notify it. change to 0
	    l = prevObserving.length;
	    while (l--) {
	        var dep = prevObserving[l];
	        if (dep.diffValue === 0) {
	            removeObserver$$1(dep, derivation);
	        }
	        dep.diffValue = 0;
	    }
	    // Go through all new observables and check diffValue: (now it should be unique)
	    //   0: it was set to 0 in last loop. don't need to do anything.
	    //   1: it wasn't observed, let's observe it. set back to 0
	    while (i0--) {
	        var dep = observing[i0];
	        if (dep.diffValue === 1) {
	            dep.diffValue = 0;
	            addObserver$$1(dep, derivation);
	        }
	    }
	    // Some new observed derivations may become stale during this derivation computation
	    // so they have had no chance to propagate staleness (#916)
	    if (lowestNewObservingDerivationState !== exports.IDerivationState.UP_TO_DATE) {
	        derivation.dependenciesState = lowestNewObservingDerivationState;
	        derivation.onBecomeStale();
	    }
	}
	function clearObserving$$1(derivation) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
	    var obs = derivation.observing;
	    derivation.observing = [];
	    var i = obs.length;
	    while (i--)
	        removeObserver$$1(obs[i], derivation);
	    derivation.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	}
	function untracked$$1(action$$1) {
	    var prev = untrackedStart$$1();
	    var res = action$$1();
	    untrackedEnd$$1(prev);
	    return res;
	}
	function untrackedStart$$1() {
	    var prev = globalState$$1.trackingDerivation;
	    globalState$$1.trackingDerivation = null;
	    return prev;
	}
	function untrackedEnd$$1(prev) {
	    globalState$$1.trackingDerivation = prev;
	}
	/**
	 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
	 *
	 */
	function changeDependenciesStateTo0$$1(derivation) {
	    if (derivation.dependenciesState === exports.IDerivationState.UP_TO_DATE)
	        return;
	    derivation.dependenciesState = exports.IDerivationState.UP_TO_DATE;
	    var obs = derivation.observing;
	    var i = obs.length;
	    while (i--)
	        obs[i].lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	}
	
	/**
	 * These values will persist if global state is reset
	 */
	var persistentKeys = [
	    "mobxGuid",
	    "spyListeners",
	    "enforceActions",
	    "computedRequiresReaction",
	    "disableErrorBoundaries",
	    "runId",
	    "UNCHANGED"
	];
	var MobXGlobals$$1 = /** @class */ (function () {
	    function MobXGlobals$$1() {
	        /**
	         * MobXGlobals version.
	         * MobX compatiblity with other versions loaded in memory as long as this version matches.
	         * It indicates that the global state still stores similar information
	         *
	         * N.B: this version is unrelated to the package version of MobX, and is only the version of the
	         * internal state storage of MobX, and can be the same across many different package versions
	         */
	        this.version = 5;
	        /**
	         * globally unique token to signal unchanged
	         */
	        this.UNCHANGED = {};
	        /**
	         * Currently running derivation
	         */
	        this.trackingDerivation = null;
	        /**
	         * Are we running a computation currently? (not a reaction)
	         */
	        this.computationDepth = 0;
	        /**
	         * Each time a derivation is tracked, it is assigned a unique run-id
	         */
	        this.runId = 0;
	        /**
	         * 'guid' for general purpose. Will be persisted amongst resets.
	         */
	        this.mobxGuid = 0;
	        /**
	         * Are we in a batch block? (and how many of them)
	         */
	        this.inBatch = 0;
	        /**
	         * Observables that don't have observers anymore, and are about to be
	         * suspended, unless somebody else accesses it in the same batch
	         *
	         * @type {IObservable[]}
	         */
	        this.pendingUnobservations = [];
	        /**
	         * List of scheduled, not yet executed, reactions.
	         */
	        this.pendingReactions = [];
	        /**
	         * Are we currently processing reactions?
	         */
	        this.isRunningReactions = false;
	        /**
	         * Is it allowed to change observables at this point?
	         * In general, MobX doesn't allow that when running computations and React.render.
	         * To ensure that those functions stay pure.
	         */
	        this.allowStateChanges = true;
	        /**
	         * If strict mode is enabled, state changes are by default not allowed
	         */
	        this.enforceActions = false;
	        /**
	         * Spy callbacks
	         */
	        this.spyListeners = [];
	        /**
	         * Globally attached error handlers that react specifically to errors in reactions
	         */
	        this.globalReactionErrorHandlers = [];
	        /**
	         * Warn if computed values are accessed outside a reactive context
	         */
	        this.computedRequiresReaction = false;
	        /*
	         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
	         * the stack when an exception occurs while debugging.
	         */
	        this.disableErrorBoundaries = false;
	        /*
	         * If true, we are already handling an exception in an action. Any errors in reactions should be supressed, as
	         * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
	         */
	        this.suppressReactionErrors = false;
	    }
	    return MobXGlobals$$1;
	}());
	var canMergeGlobalState = true;
	var isolateCalled = false;
	var globalState$$1 = (function () {
	    var global = getGlobal$$1();
	    if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals)
	        canMergeGlobalState = false;
	    if (global.__mobxGlobals && global.__mobxGlobals.version !== new MobXGlobals$$1().version)
	        canMergeGlobalState = false;
	    if (!canMergeGlobalState) {
	        setTimeout(function () {
	            if (!isolateCalled) {
	                fail$1("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
	            }
	        }, 1);
	        return new MobXGlobals$$1();
	    }
	    else if (global.__mobxGlobals) {
	        global.__mobxInstanceCount += 1;
	        if (!global.__mobxGlobals.UNCHANGED)
	            global.__mobxGlobals.UNCHANGED = {}; // make merge backward compatible
	        return global.__mobxGlobals;
	    }
	    else {
	        global.__mobxInstanceCount = 1;
	        return (global.__mobxGlobals = new MobXGlobals$$1());
	    }
	})();
	function isolateGlobalState$$1() {
	    if (globalState$$1.pendingReactions.length ||
	        globalState$$1.inBatch ||
	        globalState$$1.isRunningReactions)
	        fail$1("isolateGlobalState should be called before MobX is running any reactions");
	    isolateCalled = true;
	    if (canMergeGlobalState) {
	        if (--getGlobal$$1().__mobxInstanceCount === 0)
	            getGlobal$$1().__mobxGlobals = undefined;
	        globalState$$1 = new MobXGlobals$$1();
	    }
	}
	function getGlobalState$$1() {
	    return globalState$$1;
	}
	/**
	 * For testing purposes only; this will break the internal state of existing observables,
	 * but can be used to get back at a stable state after throwing errors
	 */
	function resetGlobalState$$1() {
	    var defaultGlobals = new MobXGlobals$$1();
	    for (var key in defaultGlobals)
	        if (persistentKeys.indexOf(key) === -1)
	            globalState$$1[key] = defaultGlobals[key];
	    globalState$$1.allowStateChanges = !globalState$$1.enforceActions;
	}
	
	function hasObservers$$1(observable$$1) {
	    return observable$$1.observers && observable$$1.observers.length > 0;
	}
	function getObservers$$1(observable$$1) {
	    return observable$$1.observers;
	}
	// function invariantObservers(observable: IObservable) {
	//     const list = observable.observers
	//     const map = observable.observersIndexes
	//     const l = list.length
	//     for (let i = 0; i < l; i++) {
	//         const id = list[i].__mapid
	//         if (i) {
	//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
	//         } else {
	//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
	//         }
	//     }
	//     invariant(
	//         list.length === 0 || Object.keys(map).length === list.length - 1,
	//         "INTERNAL ERROR there is no junk in map"
	//     )
	// }
	function addObserver$$1(observable$$1, node) {
	    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
	    // invariantObservers(observable);
	    var l = observable$$1.observers.length;
	    if (l) {
	        // because object assignment is relatively expensive, let's not store data about index 0.
	        observable$$1.observersIndexes[node.__mapid] = l;
	    }
	    observable$$1.observers[l] = node;
	    if (observable$$1.lowestObserverState > node.dependenciesState)
	        observable$$1.lowestObserverState = node.dependenciesState;
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
	}
	function removeObserver$$1(observable$$1, node) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
	    // invariantObservers(observable);
	    if (observable$$1.observers.length === 1) {
	        // deleting last observer
	        observable$$1.observers.length = 0;
	        queueForUnobservation$$1(observable$$1);
	    }
	    else {
	        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
	        var list = observable$$1.observers;
	        var map = observable$$1.observersIndexes;
	        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
	        if (filler !== node) {
	            // otherwise node was the last element, which already got removed from array
	            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
	            if (index) {
	                // map store all indexes but 0, see comment in `addObserver`
	                map[filler.__mapid] = index;
	            }
	            else {
	                delete map[filler.__mapid];
	            }
	            list[index] = filler;
	        }
	        delete map[node.__mapid];
	    }
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
	}
	function queueForUnobservation$$1(observable$$1) {
	    if (observable$$1.isPendingUnobservation === false) {
	        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
	        observable$$1.isPendingUnobservation = true;
	        globalState$$1.pendingUnobservations.push(observable$$1);
	    }
	}
	/**
	 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
	 * During a batch `onBecomeUnobserved` will be called at most once per observable.
	 * Avoids unnecessary recalculations.
	 */
	function startBatch$$1() {
	    globalState$$1.inBatch++;
	}
	function endBatch$$1() {
	    if (--globalState$$1.inBatch === 0) {
	        runReactions$$1();
	        // the batch is actually about to finish, all unobserving should happen here.
	        var list = globalState$$1.pendingUnobservations;
	        for (var i = 0; i < list.length; i++) {
	            var observable$$1 = list[i];
	            observable$$1.isPendingUnobservation = false;
	            if (observable$$1.observers.length === 0) {
	                if (observable$$1.isBeingObserved) {
	                    // if this observable had reactive observers, trigger the hooks
	                    observable$$1.isBeingObserved = false;
	                    observable$$1.onBecomeUnobserved();
	                }
	                if (observable$$1 instanceof ComputedValue$$1) {
	                    // computed values are automatically teared down when the last observer leaves
	                    // this process happens recursively, this computed might be the last observabe of another, etc..
	                    observable$$1.suspend();
	                }
	            }
	        }
	        globalState$$1.pendingUnobservations = [];
	    }
	}
	function reportObserved$$1(observable$$1) {
	    var derivation = globalState$$1.trackingDerivation;
	    if (derivation !== null) {
	        /**
	         * Simple optimization, give each derivation run an unique id (runId)
	         * Check if last time this observable was accessed the same runId is used
	         * if this is the case, the relation is already known
	         */
	        if (derivation.runId !== observable$$1.lastAccessedBy) {
	            observable$$1.lastAccessedBy = derivation.runId;
	            derivation.newObserving[derivation.unboundDepsCount++] = observable$$1;
	            if (!observable$$1.isBeingObserved) {
	                observable$$1.isBeingObserved = true;
	                observable$$1.onBecomeObserved();
	            }
	        }
	        return true;
	    }
	    else if (observable$$1.observers.length === 0 && globalState$$1.inBatch > 0) {
	        queueForUnobservation$$1(observable$$1);
	    }
	    return false;
	}
	// function invariantLOS(observable: IObservable, msg: string) {
	//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
	//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
	//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
	//     throw new Error(
	//         "lowestObserverState is wrong for " +
	//             msg +
	//             " because " +
	//             min +
	//             " < " +
	//             observable.lowestObserverState
	//     )
	// }
	/**
	 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
	 * It will propagate changes to observers from previous run
	 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
	 * Hopefully self reruning autoruns aren't a feature people should depend on
	 * Also most basic use cases should be ok
	 */
	// Called by Atom when its value changes
	function propagateChanged$$1(observable$$1) {
	    // invariantLOS(observable, "changed start");
	    if (observable$$1.lowestObserverState === exports.IDerivationState.STALE)
	        return;
	    observable$$1.lowestObserverState = exports.IDerivationState.STALE;
	    var observers = observable$$1.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE) {
	            if (d.isTracing !== TraceMode$$1.NONE) {
	                logTraceInfo(d, observable$$1);
	            }
	            d.onBecomeStale();
	        }
	        d.dependenciesState = exports.IDerivationState.STALE;
	    }
	    // invariantLOS(observable, "changed end");
	}
	// Called by ComputedValue when it recalculate and its value changed
	function propagateChangeConfirmed$$1(observable$$1) {
	    // invariantLOS(observable, "confirmed start");
	    if (observable$$1.lowestObserverState === exports.IDerivationState.STALE)
	        return;
	    observable$$1.lowestObserverState = exports.IDerivationState.STALE;
	    var observers = observable$$1.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.POSSIBLY_STALE)
	            d.dependenciesState = exports.IDerivationState.STALE;
	        else if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
	        )
	            observable$$1.lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	    }
	    // invariantLOS(observable, "confirmed end");
	}
	// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
	function propagateMaybeChanged$$1(observable$$1) {
	    // invariantLOS(observable, "maybe start");
	    if (observable$$1.lowestObserverState !== exports.IDerivationState.UP_TO_DATE)
	        return;
	    observable$$1.lowestObserverState = exports.IDerivationState.POSSIBLY_STALE;
	    var observers = observable$$1.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE) {
	            d.dependenciesState = exports.IDerivationState.POSSIBLY_STALE;
	            if (d.isTracing !== TraceMode$$1.NONE) {
	                logTraceInfo(d, observable$$1);
	            }
	            d.onBecomeStale();
	        }
	    }
	    // invariantLOS(observable, "maybe end");
	}
	function logTraceInfo(derivation, observable$$1) {
	    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable$$1.name + "'");
	    if (derivation.isTracing === TraceMode$$1.BREAK) {
	        var lines = [];
	        printDepTree(getDependencyTree$$1(derivation), lines, 1);
	        // prettier-ignore
	        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable$$1.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue$$1 ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
	    }
	}
	function printDepTree(tree, lines, depth) {
	    if (lines.length >= 1000) {
	        lines.push("(and many more)");
	        return;
	    }
	    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
	    if (tree.dependencies)
	        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
	}
	
	var Reaction$$1 = /** @class */ (function () {
	    function Reaction$$1(name, onInvalidate, errorHandler) {
	        if (name === void 0) { name = "Reaction@" + getNextId$$1(); }
	        this.name = name;
	        this.onInvalidate = onInvalidate;
	        this.errorHandler = errorHandler;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = [];
	        this.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	        this.diffValue = 0;
	        this.runId = 0;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId$$1();
	        this.isDisposed = false;
	        this._isScheduled = false;
	        this._isTrackPending = false;
	        this._isRunning = false;
	        this.isTracing = TraceMode$$1.NONE;
	    }
	    Reaction$$1.prototype.onBecomeStale = function () {
	        this.schedule();
	    };
	    Reaction$$1.prototype.schedule = function () {
	        if (!this._isScheduled) {
	            this._isScheduled = true;
	            globalState$$1.pendingReactions.push(this);
	            runReactions$$1();
	        }
	    };
	    Reaction$$1.prototype.isScheduled = function () {
	        return this._isScheduled;
	    };
	    /**
	     * internal, use schedule() if you intend to kick off a reaction
	     */
	    Reaction$$1.prototype.runReaction = function () {
	        if (!this.isDisposed) {
	            startBatch$$1();
	            this._isScheduled = false;
	            if (shouldCompute$$1(this)) {
	                this._isTrackPending = true;
	                try {
	                    this.onInvalidate();
	                    if (this._isTrackPending && isSpyEnabled$$1()) {
	                        // onInvalidate didn't trigger track right away..
	                        spyReport$$1({
	                            name: this.name,
	                            type: "scheduled-reaction"
	                        });
	                    }
	                }
	                catch (e) {
	                    this.reportExceptionInDerivation(e);
	                }
	            }
	            endBatch$$1();
	        }
	    };
	    Reaction$$1.prototype.track = function (fn) {
	        startBatch$$1();
	        var notify = isSpyEnabled$$1();
	        var startTime;
	        if (notify) {
	            startTime = Date.now();
	            spyReportStart$$1({
	                name: this.name,
	                type: "reaction"
	            });
	        }
	        this._isRunning = true;
	        var result = trackDerivedFunction$$1(this, fn, undefined);
	        this._isRunning = false;
	        this._isTrackPending = false;
	        if (this.isDisposed) {
	            // disposed during last run. Clean up everything that was bound after the dispose call.
	            clearObserving$$1(this);
	        }
	        if (isCaughtException$$1(result))
	            this.reportExceptionInDerivation(result.cause);
	        if (notify) {
	            spyReportEnd$$1({
	                time: Date.now() - startTime
	            });
	        }
	        endBatch$$1();
	    };
	    Reaction$$1.prototype.reportExceptionInDerivation = function (error) {
	        var _this = this;
	        if (this.errorHandler) {
	            this.errorHandler(error, this);
	            return;
	        }
	        if (globalState$$1.disableErrorBoundaries)
	            throw error;
	        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
	        if (globalState$$1.suppressReactionErrors) {
	            console.warn("[mobx] (error in reaction '" + this.name + "' suppressed, fix error of causing action below)"); // prettier-ignore
	        }
	        else {
	            console.error(message, error);
	            /** If debugging brought you here, please, read the above message :-). Tnx! */
	        }
	        if (isSpyEnabled$$1()) {
	            spyReport$$1({
	                type: "error",
	                name: this.name,
	                message: message,
	                error: "" + error
	            });
	        }
	        globalState$$1.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
	    };
	    Reaction$$1.prototype.dispose = function () {
	        if (!this.isDisposed) {
	            this.isDisposed = true;
	            if (!this._isRunning) {
	                // if disposed while running, clean up later. Maybe not optimal, but rare case
	                startBatch$$1();
	                clearObserving$$1(this);
	                endBatch$$1();
	            }
	        }
	    };
	    Reaction$$1.prototype.getDisposer = function () {
	        var r = this.dispose.bind(this);
	        r.$mobx = this;
	        return r;
	    };
	    Reaction$$1.prototype.toString = function () {
	        return "Reaction[" + this.name + "]";
	    };
	    Reaction$$1.prototype.trace = function (enterBreakPoint) {
	        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
	        trace$$1(this, enterBreakPoint);
	    };
	    return Reaction$$1;
	}());
	function onReactionError$$1(handler) {
	    globalState$$1.globalReactionErrorHandlers.push(handler);
	    return function () {
	        var idx = globalState$$1.globalReactionErrorHandlers.indexOf(handler);
	        if (idx >= 0)
	            globalState$$1.globalReactionErrorHandlers.splice(idx, 1);
	    };
	}
	/**
	 * Magic number alert!
	 * Defines within how many times a reaction is allowed to re-trigger itself
	 * until it is assumed that this is gonna be a never ending loop...
	 */
	var MAX_REACTION_ITERATIONS = 100;
	var reactionScheduler = function (f) { return f(); };
	function runReactions$$1() {
	    // Trampolining, if runReactions are already running, new reactions will be picked up
	    if (globalState$$1.inBatch > 0 || globalState$$1.isRunningReactions)
	        return;
	    reactionScheduler(runReactionsHelper);
	}
	function runReactionsHelper() {
	    globalState$$1.isRunningReactions = true;
	    var allReactions = globalState$$1.pendingReactions;
	    var iterations = 0;
	    // While running reactions, new reactions might be triggered.
	    // Hence we work with two variables and check whether
	    // we converge to no remaining reactions after a while.
	    while (allReactions.length > 0) {
	        if (++iterations === MAX_REACTION_ITERATIONS) {
	            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
	                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
	            allReactions.splice(0); // clear reactions
	        }
	        var remainingReactions = allReactions.splice(0);
	        for (var i = 0, l = remainingReactions.length; i < l; i++)
	            remainingReactions[i].runReaction();
	    }
	    globalState$$1.isRunningReactions = false;
	}
	var isReaction$$1 = createInstanceofPredicate$$1("Reaction", Reaction$$1);
	function setReactionScheduler$$1(fn) {
	    var baseScheduler = reactionScheduler;
	    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
	}
	
	function isSpyEnabled$$1() {
	    return !!globalState$$1.spyListeners.length;
	}
	function spyReport$$1(event) {
	    if (!globalState$$1.spyListeners.length)
	        return;
	    var listeners = globalState$$1.spyListeners;
	    for (var i = 0, l = listeners.length; i < l; i++)
	        listeners[i](event);
	}
	function spyReportStart$$1(event) {
	    var change = __assign({}, event, { spyReportStart: true });
	    spyReport$$1(change);
	}
	var END_EVENT = { spyReportEnd: true };
	function spyReportEnd$$1(change) {
	    if (change)
	        spyReport$$1(__assign({}, change, { spyReportEnd: true }));
	    else
	        spyReport$$1(END_EVENT);
	}
	function spy$$1(listener) {
	    globalState$$1.spyListeners.push(listener);
	    return once$$1(function () {
	        globalState$$1.spyListeners = globalState$$1.spyListeners.filter(function (l) { return l !== listener; });
	    });
	}
	
	function dontReassignFields() {
	    fail$1(("production") !== "production" && "@action fields are not reassignable");
	}
	function namedActionDecorator$$1(name) {
	    return function (target, prop, descriptor) {
	        if (descriptor) {
	            if (false) {
	                return fail$1("@action cannot be used with getters");
	            }
	            // babel / typescript
	            // @action method() { }
	            if (descriptor.value) {
	                // typescript
	                return {
	                    value: createAction$$1(name, descriptor.value),
	                    enumerable: false,
	                    configurable: true,
	                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
	                };
	            }
	            // babel only: @action method = () => {}
	            var initializer_1 = descriptor.initializer;
	            return {
	                enumerable: false,
	                configurable: true,
	                writable: true,
	                initializer: function () {
	                    // N.B: we can't immediately invoke initializer; this would be wrong
	                    return createAction$$1(name, initializer_1.call(this));
	                }
	            };
	        }
	        // bound instance methods
	        return actionFieldDecorator$$1(name).apply(this, arguments);
	    };
	}
	function actionFieldDecorator$$1(name) {
	    // Simple property that writes on first invocation to the current instance
	    return function (target, prop, descriptor) {
	        Object.defineProperty(target, prop, {
	            configurable: true,
	            enumerable: false,
	            get: function () {
	                return undefined;
	            },
	            set: function (value) {
	                addHiddenProp$$1(this, prop, action$$1(name, value));
	            }
	        });
	    };
	}
	function boundActionDecorator$$1(target, propertyName, descriptor, applyToInstance) {
	    if (applyToInstance === true) {
	        defineBoundAction$$1(target, propertyName, descriptor.value);
	        return null;
	    }
	    if (descriptor) {
	        // if (descriptor.value)
	        // Typescript / Babel: @action.bound method() { }
	        // also: babel @action.bound method = () => {}
	        return {
	            configurable: true,
	            enumerable: false,
	            get: function () {
	                defineBoundAction$$1(this, propertyName, descriptor.value || descriptor.initializer.call(this));
	                return this[propertyName];
	            },
	            set: dontReassignFields
	        };
	    }
	    // field decorator Typescript @action.bound method = () => {}
	    return {
	        enumerable: false,
	        configurable: true,
	        set: function (v) {
	            defineBoundAction$$1(this, propertyName, v);
	        },
	        get: function () {
	            return undefined;
	        }
	    };
	}
	
	var action$$1 = function action$$1(arg1, arg2, arg3, arg4) {
	    // action(fn() {})
	    if (arguments.length === 1 && typeof arg1 === "function")
	        return createAction$$1(arg1.name || "<unnamed action>", arg1);
	    // action("name", fn() {})
	    if (arguments.length === 2 && typeof arg2 === "function")
	        return createAction$$1(arg1, arg2);
	    // @action("name") fn() {}
	    if (arguments.length === 1 && typeof arg1 === "string")
	        return namedActionDecorator$$1(arg1);
	    // @action fn() {}
	    if (arg4 === true) {
	        // apply to instance immediately
	        arg1[arg2] = createAction$$1(arg1.name || arg2, arg3.value);
	    }
	    else {
	        return namedActionDecorator$$1(arg2).apply(null, arguments);
	    }
	};
	action$$1.bound = boundActionDecorator$$1;
	function runInAction$$1(arg1, arg2) {
	    // TODO: deprecate?
	    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
	    var fn = typeof arg1 === "function" ? arg1 : arg2;
	    if (false) {
	        invariant$$1(typeof fn === "function" && fn.length === 0, "`runInAction` expects a function without arguments");
	        if (typeof actionName !== "string" || !actionName)
	            fail$1("actions should have valid names, got: '" + actionName + "'");
	    }
	    return executeAction$$1(actionName, fn, this, undefined);
	}
	function isAction$$1(thing) {
	    return typeof thing === "function" && thing.isMobxAction === true;
	}
	function defineBoundAction$$1(target, propertyName, fn) {
	    addHiddenProp$$1(target, propertyName, createAction$$1(propertyName, fn.bind(target)));
	}
	
	/**
	 * Creates a named reactive view and keeps it alive, so that the view is always
	 * updated if one of the dependencies changes, even when the view is not further used by something else.
	 * @param view The reactive view
	 * @returns disposer function, which can be used to stop the view from being updated in the future.
	 */
	function autorun$$1(view, opts) {
	    if (opts === void 0) { opts = EMPTY_OBJECT$$1; }
	    if (false) {
	        invariant$$1(typeof view === "function", "Autorun expects a function as first argument");
	        invariant$$1(isAction$$1(view) === false, "Autorun does not accept actions since actions are untrackable");
	    }
	    var name = (opts && opts.name) || view.name || "Autorun@" + getNextId$$1();
	    var runSync = !opts.scheduler && !opts.delay;
	    var reaction$$1;
	    if (runSync) {
	        // normal autorun
	        reaction$$1 = new Reaction$$1(name, function () {
	            this.track(reactionRunner);
	        }, opts.onError);
	    }
	    else {
	        var scheduler_1 = createSchedulerFromOptions(opts);
	        // debounced autorun
	        var isScheduled_1 = false;
	        reaction$$1 = new Reaction$$1(name, function () {
	            if (!isScheduled_1) {
	                isScheduled_1 = true;
	                scheduler_1(function () {
	                    isScheduled_1 = false;
	                    if (!reaction$$1.isDisposed)
	                        reaction$$1.track(reactionRunner);
	                });
	            }
	        }, opts.onError);
	    }
	    function reactionRunner() {
	        view(reaction$$1);
	    }
	    reaction$$1.schedule();
	    return reaction$$1.getDisposer();
	}
	var run = function (f) { return f(); };
	function createSchedulerFromOptions(opts) {
	    return opts.scheduler
	        ? opts.scheduler
	        : opts.delay
	            ? function (f) { return setTimeout(f, opts.delay); }
	            : run;
	}
	function reaction$$1(expression, effect, opts) {
	    if (opts === void 0) { opts = EMPTY_OBJECT$$1; }
	    if (typeof opts === "boolean") {
	        opts = { fireImmediately: opts };
	        deprecated$$1("Using fireImmediately as argument is deprecated. Use '{ fireImmediately: true }' instead");
	    }
	    if (false) {
	        invariant$$1(typeof expression === "function", "First argument to reaction should be a function");
	        invariant$$1(typeof opts === "object", "Third argument of reactions should be an object");
	    }
	    var name = opts.name || "Reaction@" + getNextId$$1();
	    var effectAction = action$$1(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
	    var runSync = !opts.scheduler && !opts.delay;
	    var scheduler = createSchedulerFromOptions(opts);
	    var firstTime = true;
	    var isScheduled = false;
	    var value;
	    var equals = opts.compareStructural
	        ? comparer$$1.structural
	        : opts.equals || comparer$$1.default;
	    var r = new Reaction$$1(name, function () {
	        if (firstTime || runSync) {
	            reactionRunner();
	        }
	        else if (!isScheduled) {
	            isScheduled = true;
	            scheduler(reactionRunner);
	        }
	    }, opts.onError);
	    function reactionRunner() {
	        isScheduled = false; // Q: move into reaction runner?
	        if (r.isDisposed)
	            return;
	        var changed = false;
	        r.track(function () {
	            var nextValue = expression(r);
	            changed = firstTime || !equals(value, nextValue);
	            value = nextValue;
	        });
	        if (firstTime && opts.fireImmediately)
	            effectAction(value, r);
	        if (!firstTime && changed === true)
	            effectAction(value, r);
	        if (firstTime)
	            firstTime = false;
	    }
	    r.schedule();
	    return r.getDisposer();
	}
	function wrapErrorHandler(errorHandler, baseFn) {
	    return function () {
	        try {
	            return baseFn.apply(this, arguments);
	        }
	        catch (e) {
	            errorHandler.call(this, e);
	        }
	    };
	}
	
	function onBecomeObserved$$1(thing, arg2, arg3) {
	    return interceptHook("onBecomeObserved", thing, arg2, arg3);
	}
	function onBecomeUnobserved$$1(thing, arg2, arg3) {
	    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
	}
	function interceptHook(hook, thing, arg2, arg3) {
	    var atom = typeof arg2 === "string" ? getAtom$$1(thing, arg2) : getAtom$$1(thing);
	    var cb = typeof arg2 === "string" ? arg3 : arg2;
	    var orig = atom[hook];
	    if (typeof orig !== "function")
	        return fail$1(("production") !== "production" && "Not an atom that can be (un)observed");
	    atom[hook] = function () {
	        orig.call(this);
	        cb.call(this);
	    };
	    return function () {
	        atom[hook] = orig;
	    };
	}
	
	function configure$$1(options) {
	    var enforceActions = options.enforceActions, computedRequiresReaction = options.computedRequiresReaction, disableErrorBoundaries = options.disableErrorBoundaries, arrayBuffer = options.arrayBuffer, reactionScheduler = options.reactionScheduler;
	    if (options.isolateGlobalState === true) {
	        isolateGlobalState$$1();
	    }
	    if (enforceActions !== undefined) {
	        if (typeof enforceActions === "boolean" || enforceActions === "strict")
	            deprecated$$1("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");
	        var ea = void 0;
	        switch (enforceActions) {
	            case true:
	            case "observed":
	                ea = true;
	                break;
	            case false:
	            case "never":
	                ea = false;
	                break;
	            case "strict":
	            case "always":
	                ea = "strict";
	                break;
	            default:
	                fail$1("Invalid value for 'enforceActions': '" + enforceActions + "', expected 'never', 'always' or 'observed'");
	        }
	        globalState$$1.enforceActions = ea;
	        globalState$$1.allowStateChanges = ea === true || ea === "strict" ? false : true;
	    }
	    if (computedRequiresReaction !== undefined) {
	        globalState$$1.computedRequiresReaction = !!computedRequiresReaction;
	    }
	    if (disableErrorBoundaries !== undefined) {
	        if (disableErrorBoundaries === true)
	            console.warn("WARNING: Debug feature only. MobX will NOT recover from errors if this is on.");
	        globalState$$1.disableErrorBoundaries = !!disableErrorBoundaries;
	    }
	    if (typeof arrayBuffer === "number") {
	        reserveArrayBuffer$$1(arrayBuffer);
	    }
	    if (reactionScheduler) {
	        setReactionScheduler$$1(reactionScheduler);
	    }
	}
	
	function decorate$$1(thing, decorators) {
	    ("production") !== "production" &&
	        invariant$$1(isPlainObject$$1(decorators), "Decorators should be a key value map");
	    var target = typeof thing === "function" ? thing.prototype : thing;
	    var _loop_1 = function (prop) {
	        var propertyDecorators = decorators[prop];
	        if (!Array.isArray(propertyDecorators)) {
	            propertyDecorators = [propertyDecorators];
	        }
	        ("production") !== "production" &&
	            invariant$$1(propertyDecorators.every(function (decorator) { return typeof decorator === "function"; }), "Decorate: expected a decorator function or array of decorator functions for '" + prop + "'");
	        var descriptor = Object.getOwnPropertyDescriptor(target, prop);
	        var newDescriptor = propertyDecorators.reduce(function (accDescriptor, decorator) { return decorator(target, prop, accDescriptor); }, descriptor);
	        if (newDescriptor)
	            Object.defineProperty(target, prop, newDescriptor);
	    };
	    for (var prop in decorators) {
	        _loop_1(prop);
	    }
	    return thing;
	}
	
	function extendShallowObservable$$1(target, properties, decorators) {
	    deprecated$$1("'extendShallowObservable' is deprecated, use 'extendObservable(target, props, { deep: false })' instead");
	    return extendObservable$$1(target, properties, decorators, shallowCreateObservableOptions$$1);
	}
	function extendObservable$$1(target, properties, decorators, options) {
	    if (false) {
	        invariant$$1(arguments.length >= 2 && arguments.length <= 4, "'extendObservable' expected 2-4 arguments");
	        invariant$$1(typeof target === "object", "'extendObservable' expects an object as first argument");
	        invariant$$1(!isObservableMap$$1(target), "'extendObservable' should not be used on maps, use map.merge instead");
	        invariant$$1(!isObservable$$1(properties), "Extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540");
	        if (decorators)
	            for (var key in decorators)
	                if (!(key in properties))
	                    fail$1("Trying to declare a decorator for unspecified property '" + key + "'");
	    }
	    options = asCreateObservableOptions$$1(options);
	    var defaultDecorator = options.defaultDecorator || (options.deep === false ? refDecorator$$1 : deepDecorator$$1);
	    initializeInstance$$1(target);
	    asObservableObject$$1(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
	    startBatch$$1();
	    try {
	        for (var key in properties) {
	            var descriptor = Object.getOwnPropertyDescriptor(properties, key);
	            if (false) {
	                if (Object.getOwnPropertyDescriptor(target, key))
	                    fail$1("'extendObservable' can only be used to introduce new properties. Use 'set' or 'decorate' instead. The property '" + key + "' already exists on '" + target + "'");
	                if (isComputed$$1(descriptor.value))
	                    fail$1("Passing a 'computed' as initial property value is no longer supported by extendObservable. Use a getter or decorator instead");
	            }
	            var decorator = decorators && key in decorators
	                ? decorators[key]
	                : descriptor.get
	                    ? computedDecorator$$1
	                    : defaultDecorator;
	            if (false)
	                return fail$1("Not a valid decorator for '" + key + "', got: " + decorator);
	            var resultDescriptor = decorator(target, key, descriptor, true);
	            if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
	            )
	                Object.defineProperty(target, key, resultDescriptor);
	        }
	    }
	    finally {
	        endBatch$$1();
	    }
	    return target;
	}
	
	function getDependencyTree$$1(thing, property) {
	    return nodeToDependencyTree(getAtom$$1(thing, property));
	}
	function nodeToDependencyTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (node.observing && node.observing.length > 0)
	        result.dependencies = unique$$1(node.observing).map(nodeToDependencyTree);
	    return result;
	}
	function getObserverTree$$1(thing, property) {
	    return nodeToObserverTree(getAtom$$1(thing, property));
	}
	function nodeToObserverTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (hasObservers$$1(node))
	        result.observers = getObservers$$1(node).map(nodeToObserverTree);
	    return result;
	}
	
	var generatorId = 0;
	function flow$$1(generator) {
	    if (arguments.length !== 1)
	        fail$1(("production") && "Flow expects one 1 argument and cannot be used as decorator");
	    var name = generator.name || "<unnamed flow>";
	    // Implementation based on https://github.com/tj/co/blob/master/index.js
	    return function () {
	        var ctx = this;
	        var args = arguments;
	        var runId = ++generatorId;
	        var gen = action$$1(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
	        var rejector;
	        var pendingPromise = undefined;
	        var res = new Promise(function (resolve, reject) {
	            var stepId = 0;
	            rejector = reject;
	            function onFulfilled(res) {
	                pendingPromise = undefined;
	                var ret;
	                try {
	                    ret = action$$1(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
	                }
	                catch (e) {
	                    return reject(e);
	                }
	                next(ret);
	            }
	            function onRejected(err) {
	                pendingPromise = undefined;
	                var ret;
	                try {
	                    ret = action$$1(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
	                }
	                catch (e) {
	                    return reject(e);
	                }
	                next(ret);
	            }
	            function next(ret) {
	                if (ret && typeof ret.then === "function") {
	                    // an async iterator
	                    ret.then(next, reject);
	                    return;
	                }
	                if (ret.done)
	                    return resolve(ret.value);
	                pendingPromise = Promise.resolve(ret.value);
	                return pendingPromise.then(onFulfilled, onRejected);
	            }
	            onFulfilled(undefined); // kick off the process
	        });
	        res.cancel = action$$1(name + " - runid: " + runId + " - cancel", function () {
	            try {
	                if (pendingPromise)
	                    cancelPromise(pendingPromise);
	                // Finally block can return (or yield) stuff..
	                var res_1 = gen.return();
	                // eat anything that promise would do, it's cancelled!
	                var yieldedPromise = Promise.resolve(res_1.value);
	                yieldedPromise.then(noop$$1, noop$$1);
	                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
	                // reject our original promise
	                rejector(new Error("FLOW_CANCELLED"));
	            }
	            catch (e) {
	                rejector(e); // there could be a throwing finally block
	            }
	        });
	        return res;
	    };
	}
	function cancelPromise(promise) {
	    if (typeof promise.cancel === "function")
	        promise.cancel();
	}
	
	function interceptReads$$1(thing, propOrHandler, handler) {
	    var target;
	    if (isObservableMap$$1(thing) || isObservableArray$$1(thing) || isObservableValue$$1(thing)) {
	        target = getAdministration$$1(thing);
	    }
	    else if (isObservableObject$$1(thing)) {
	        if (typeof propOrHandler !== "string")
	            return fail$1(("production") !== "production" &&
	                "InterceptReads can only be used with a specific property, not with an object in general");
	        target = getAdministration$$1(thing, propOrHandler);
	    }
	    else {
	        return fail$1(("production") !== "production" &&
	            "Expected observable map, object or array as first array");
	    }
	    if (target.dehancer !== undefined)
	        return fail$1(("production") !== "production" && "An intercept reader was already established");
	    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
	    return function () {
	        target.dehancer = undefined;
	    };
	}
	
	function intercept$$1(thing, propOrHandler, handler) {
	    if (typeof handler === "function")
	        return interceptProperty(thing, propOrHandler, handler);
	    else
	        return interceptInterceptable(thing, propOrHandler);
	}
	function interceptInterceptable(thing, handler) {
	    return getAdministration$$1(thing).intercept(handler);
	}
	function interceptProperty(thing, property, handler) {
	    return getAdministration$$1(thing, property).intercept(handler);
	}
	
	function _isComputed$$1(value, property) {
	    if (value === null || value === undefined)
	        return false;
	    if (property !== undefined) {
	        if (isObservableObject$$1(value) === false)
	            return false;
	        if (!value.$mobx.values[property])
	            return false;
	        var atom = getAtom$$1(value, property);
	        return isComputedValue$$1(atom);
	    }
	    return isComputedValue$$1(value);
	}
	function isComputed$$1(value) {
	    if (arguments.length > 1)
	        return fail$1(("production") !== "production" &&
	            "isComputed expects only 1 argument. Use isObservableProp to inspect the observability of a property");
	    return _isComputed$$1(value);
	}
	function isComputedProp$$1(value, propName) {
	    if (typeof propName !== "string")
	        return fail$1(("production") !== "production" &&
	            "isComputed expected a property name as second argument");
	    return _isComputed$$1(value, propName);
	}
	
	function _isObservable(value, property) {
	    if (value === null || value === undefined)
	        return false;
	    if (property !== undefined) {
	        if (false)
	            return fail$1("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
	        if (isObservableObject$$1(value)) {
	            var o = value.$mobx;
	            return o.values && !!o.values[property];
	        }
	        return false;
	    }
	    // For first check, see #701
	    return (isObservableObject$$1(value) ||
	        !!value.$mobx ||
	        isAtom$$1(value) ||
	        isReaction$$1(value) ||
	        isComputedValue$$1(value));
	}
	function isObservable$$1(value) {
	    if (arguments.length !== 1)
	        fail$1(("production") !== "production" &&
	            "isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
	    return _isObservable(value);
	}
	function isObservableProp$$1(value, propName) {
	    if (typeof propName !== "string")
	        return fail$1(("production") !== "production" && "expected a property name as second argument");
	    return _isObservable(value, propName);
	}
	
	function keys$$1(obj) {
	    if (isObservableObject$$1(obj)) {
	        return obj.$mobx.getKeys();
	    }
	    if (isObservableMap$$1(obj)) {
	        return obj._keys.slice();
	    }
	    if (isObservableSet$$1(obj)) {
	        return Array.from(obj.keys());
	    }
	    if (isObservableArray$$1(obj)) {
	        return obj.map(function (_, index) { return index; });
	    }
	    return fail$1(("production") !== "production" &&
	        "'keys()' can only be used on observable objects, arrays, sets and maps");
	}
	function values$$1(obj) {
	    if (isObservableObject$$1(obj)) {
	        return keys$$1(obj).map(function (key) { return obj[key]; });
	    }
	    if (isObservableMap$$1(obj)) {
	        return keys$$1(obj).map(function (key) { return obj.get(key); });
	    }
	    if (isObservableSet$$1(obj)) {
	        return Array.from(obj.values());
	    }
	    if (isObservableArray$$1(obj)) {
	        return obj.slice();
	    }
	    return fail$1(("production") !== "production" &&
	        "'values()' can only be used on observable objects, arrays, sets and maps");
	}
	function entries$$1(obj) {
	    if (isObservableObject$$1(obj)) {
	        return keys$$1(obj).map(function (key) { return [key, obj[key]]; });
	    }
	    if (isObservableMap$$1(obj)) {
	        return keys$$1(obj).map(function (key) { return [key, obj.get(key)]; });
	    }
	    if (isObservableSet$$1(obj)) {
	        return Array.from(obj.entries());
	    }
	    if (isObservableArray$$1(obj)) {
	        return obj.map(function (key, index) { return [index, key]; });
	    }
	    return fail$1(("production") !== "production" &&
	        "'entries()' can only be used on observable objects, arrays and maps");
	}
	function set$$1(obj, key, value) {
	    if (arguments.length === 2) {
	        startBatch$$1();
	        var values_1 = key;
	        try {
	            for (var key_1 in values_1)
	                set$$1(obj, key_1, values_1[key_1]);
	        }
	        finally {
	            endBatch$$1();
	        }
	        return;
	    }
	    if (isObservableObject$$1(obj)) {
	        var adm = obj.$mobx;
	        var existingObservable = adm.values[key];
	        if (existingObservable) {
	            adm.write(obj, key, value);
	        }
	        else {
	            defineObservableProperty$$1(obj, key, value, adm.defaultEnhancer);
	        }
	    }
	    else if (isObservableMap$$1(obj)) {
	        obj.set(key, value);
	    }
	    else if (isObservableArray$$1(obj)) {
	        if (typeof key !== "number")
	            key = parseInt(key, 10);
	        invariant$$1(key >= 0, "Not a valid index: '" + key + "'");
	        startBatch$$1();
	        if (key >= obj.length)
	            obj.length = key + 1;
	        obj[key] = value;
	        endBatch$$1();
	    }
	    else {
	        return fail$1(("production") !== "production" &&
	            "'set()' can only be used on observable objects, arrays and maps");
	    }
	}
	function remove$$1(obj, key) {
	    if (isObservableObject$$1(obj)) {
	        
	        obj.$mobx.remove(key);
	    }
	    else if (isObservableMap$$1(obj)) {
	        obj.delete(key);
	    }
	    else if (isObservableSet$$1(obj)) {
	        obj.delete(key);
	    }
	    else if (isObservableArray$$1(obj)) {
	        if (typeof key !== "number")
	            key = parseInt(key, 10);
	        invariant$$1(key >= 0, "Not a valid index: '" + key + "'");
	        obj.splice(key, 1);
	    }
	    else {
	        return fail$1(("production") !== "production" &&
	            "'remove()' can only be used on observable objects, arrays and maps");
	    }
	}
	function has$$1(obj, key) {
	    if (isObservableObject$$1(obj)) {
	        // return keys(obj).indexOf(key) >= 0
	        var adm = getAdministration$$1(obj);
	        adm.getKeys(); // make sure we get notified of key changes, but for performance, use the values map to look up existence
	        return !!adm.values[key];
	    }
	    else if (isObservableMap$$1(obj)) {
	        return obj.has(key);
	    }
	    else if (isObservableSet$$1(obj)) {
	        return obj.has(key);
	    }
	    else if (isObservableArray$$1(obj)) {
	        return key >= 0 && key < obj.length;
	    }
	    else {
	        return fail$1(("production") !== "production" &&
	            "'has()' can only be used on observable objects, arrays and maps");
	    }
	}
	function get$$1(obj, key) {
	    if (!has$$1(obj, key))
	        return undefined;
	    if (isObservableObject$$1(obj)) {
	        return obj[key];
	    }
	    else if (isObservableMap$$1(obj)) {
	        return obj.get(key);
	    }
	    else if (isObservableArray$$1(obj)) {
	        return obj[key];
	    }
	    else {
	        return fail$1(("production") !== "production" &&
	            "'get()' can only be used on observable objects, arrays and maps");
	    }
	}
	
	function observe$$1(thing, propOrCb, cbOrFire, fireImmediately) {
	    if (typeof cbOrFire === "function")
	        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
	    else
	        return observeObservable(thing, propOrCb, cbOrFire);
	}
	function observeObservable(thing, listener, fireImmediately) {
	    return getAdministration$$1(thing).observe(listener, fireImmediately);
	}
	function observeObservableProperty(thing, property, listener, fireImmediately) {
	    return getAdministration$$1(thing, property).observe(listener, fireImmediately);
	}
	
	var defaultOptions = {
	    detectCycles: true,
	    exportMapsAsObjects: true,
	    recurseEverything: false
	};
	function cache(map, key, value, options) {
	    if (options.detectCycles)
	        map.set(key, value);
	    return value;
	}
	function toJSHelper(source, options, __alreadySeen) {
	    if (!options.recurseEverything && !isObservable$$1(source))
	        return source;
	    if (typeof source !== "object")
	        return source;
	    // Directly return null if source is null
	    if (source === null)
	        return null;
	    // Directly return the Date object itself if contained in the observable
	    if (source instanceof Date)
	        return source;
	    if (isObservableValue$$1(source))
	        return toJSHelper(source.get(), options, __alreadySeen);
	    // make sure we track the keys of the object
	    if (isObservable$$1(source))
	        keys$$1(source);
	    var detectCycles = options.detectCycles === true;
	    if (detectCycles && source !== null && __alreadySeen.has(source)) {
	        return __alreadySeen.get(source);
	    }
	    if (isObservableArray$$1(source) || Array.isArray(source)) {
	        var res_1 = cache(__alreadySeen, source, [], options);
	        var toAdd = source.map(function (value) { return toJSHelper(value, options, __alreadySeen); });
	        res_1.length = toAdd.length;
	        for (var i = 0, l = toAdd.length; i < l; i++)
	            res_1[i] = toAdd[i];
	        return res_1;
	    }
	    if (isObservableSet$$1(source) || Object.getPrototypeOf(source) === Set.prototype) {
	        if (options.exportMapsAsObjects === false) {
	            var res_2 = cache(__alreadySeen, source, new Set(), options);
	            source.forEach(function (value) {
	                res_2.add(toJSHelper(value, options, __alreadySeen));
	            });
	            return res_2;
	        }
	        else {
	            var res_3 = cache(__alreadySeen, source, [], options);
	            source.forEach(function (value) {
	                res_3.push(toJSHelper(value, options, __alreadySeen));
	            });
	            return res_3;
	        }
	    }
	    if (isObservableMap$$1(source) || Object.getPrototypeOf(source) === Map.prototype) {
	        if (options.exportMapsAsObjects === false) {
	            var res_4 = cache(__alreadySeen, source, new Map(), options);
	            source.forEach(function (value, key) {
	                res_4.set(key, toJSHelper(value, options, __alreadySeen));
	            });
	            return res_4;
	        }
	        else {
	            var res_5 = cache(__alreadySeen, source, {}, options);
	            source.forEach(function (value, key) {
	                res_5[key] = toJSHelper(value, options, __alreadySeen);
	            });
	            return res_5;
	        }
	    }
	    // Fallback to the situation that source is an ObservableObject or a plain object
	    var res = cache(__alreadySeen, source, {}, options);
	    for (var key in source) {
	        res[key] = toJSHelper(source[key], options, __alreadySeen);
	    }
	    return res;
	}
	function toJS$$1(source, options) {
	    // backward compatibility
	    if (typeof options === "boolean")
	        options = { detectCycles: options };
	    if (!options)
	        options = defaultOptions;
	    options.detectCycles =
	        options.detectCycles === undefined
	            ? options.recurseEverything === true
	            : options.detectCycles === true;
	    var __alreadySeen;
	    if (options.detectCycles)
	        __alreadySeen = new Map();
	    return toJSHelper(source, options, __alreadySeen);
	}
	
	function trace$$1() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var enterBreakPoint = false;
	    if (typeof args[args.length - 1] === "boolean")
	        enterBreakPoint = args.pop();
	    var derivation = getAtomFromArgs(args);
	    if (!derivation) {
	        return fail$1(("production") !== "production" &&
	            "'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
	    }
	    if (derivation.isTracing === TraceMode$$1.NONE) {
	        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
	    }
	    derivation.isTracing = enterBreakPoint ? TraceMode$$1.BREAK : TraceMode$$1.LOG;
	}
	function getAtomFromArgs(args) {
	    switch (args.length) {
	        case 0:
	            return globalState$$1.trackingDerivation;
	        case 1:
	            return getAtom$$1(args[0]);
	        case 2:
	            return getAtom$$1(args[0], args[1]);
	    }
	}
	
	/**
	 * During a transaction no views are updated until the end of the transaction.
	 * The transaction will be run synchronously nonetheless.
	 *
	 * @param action a function that updates some reactive state
	 * @returns any value that was returned by the 'action' parameter.
	 */
	function transaction$$1(action$$1, thisArg) {
	    if (thisArg === void 0) { thisArg = undefined; }
	    startBatch$$1();
	    try {
	        return action$$1.apply(thisArg);
	    }
	    finally {
	        endBatch$$1();
	    }
	}
	
	function when$$1(predicate, arg1, arg2) {
	    if (arguments.length === 1 || (arg1 && typeof arg1 === "object"))
	        return whenPromise(predicate, arg1);
	    return _when(predicate, arg1, arg2 || {});
	}
	function _when(predicate, effect, opts) {
	    var timeoutHandle;
	    if (typeof opts.timeout === "number") {
	        timeoutHandle = setTimeout(function () {
	            if (!disposer.$mobx.isDisposed) {
	                disposer();
	                var error = new Error("WHEN_TIMEOUT");
	                if (opts.onError)
	                    opts.onError(error);
	                else
	                    throw error;
	            }
	        }, opts.timeout);
	    }
	    opts.name = opts.name || "When@" + getNextId$$1();
	    var effectAction = createAction$$1(opts.name + "-effect", effect);
	    var disposer = autorun$$1(function (r) {
	        if (predicate()) {
	            r.dispose();
	            if (timeoutHandle)
	                clearTimeout(timeoutHandle);
	            effectAction();
	        }
	    }, opts);
	    return disposer;
	}
	function whenPromise(predicate, opts) {
	    if (false)
	        return fail$1("the options 'onError' and 'promise' cannot be combined");
	    var cancel;
	    var res = new Promise(function (resolve, reject) {
	        var disposer = _when(predicate, resolve, __assign({}, opts, { onError: reject }));
	        cancel = function () {
	            disposer();
	            reject("WHEN_CANCELLED");
	        };
	    });
	    res.cancel = cancel;
	    return res;
	}
	
	function hasInterceptors$$1(interceptable) {
	    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
	}
	function registerInterceptor$$1(interceptable, handler) {
	    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
	    interceptors.push(handler);
	    return once$$1(function () {
	        var idx = interceptors.indexOf(handler);
	        if (idx !== -1)
	            interceptors.splice(idx, 1);
	    });
	}
	function interceptChange$$1(interceptable, change) {
	    var prevU = untrackedStart$$1();
	    try {
	        var interceptors = interceptable.interceptors;
	        if (interceptors)
	            for (var i = 0, l = interceptors.length; i < l; i++) {
	                change = interceptors[i](change);
	                invariant$$1(!change || change.type, "Intercept handlers should return nothing or a change object");
	                if (!change)
	                    break;
	            }
	        return change;
	    }
	    finally {
	        untrackedEnd$$1(prevU);
	    }
	}
	
	function hasListeners$$1(listenable) {
	    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
	}
	function registerListener$$1(listenable, handler) {
	    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
	    listeners.push(handler);
	    return once$$1(function () {
	        var idx = listeners.indexOf(handler);
	        if (idx !== -1)
	            listeners.splice(idx, 1);
	    });
	}
	function notifyListeners$$1(listenable, change) {
	    var prevU = untrackedStart$$1();
	    var listeners = listenable.changeListeners;
	    if (!listeners)
	        return;
	    listeners = listeners.slice();
	    for (var i = 0, l = listeners.length; i < l; i++) {
	        listeners[i](change);
	    }
	    untrackedEnd$$1(prevU);
	}
	
	var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
	// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
	var safariPrototypeSetterInheritanceBug = (function () {
	    var v = false;
	    var p = {};
	    Object.defineProperty(p, "0", {
	        set: function () {
	            v = true;
	        }
	    });
	    Object.create(p)["0"] = 1;
	    return v === false;
	})();
	/**
	 * This array buffer contains two lists of properties, so that all arrays
	 * can recycle their property definitions, which significantly improves performance of creating
	 * properties on the fly.
	 */
	var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
	// Typescript workaround to make sure ObservableArray extends Array
	var StubArray$$1 = /** @class */ (function () {
	    function StubArray$$1() {
	    }
	    return StubArray$$1;
	}());
	function inherit(ctor, proto) {
	    if (typeof Object["setPrototypeOf"] !== "undefined") {
	        Object["setPrototypeOf"](ctor.prototype, proto);
	    }
	    else if (typeof ctor.prototype.__proto__ !== "undefined") {
	        ctor.prototype.__proto__ = proto;
	    }
	    else {
	        ctor["prototype"] = proto;
	    }
	}
	inherit(StubArray$$1, Array.prototype);
	// Weex freeze Array.prototype
	// Make them writeable and configurable in prototype chain
	// https://github.com/alibaba/weex/pull/1529
	if (Object.isFrozen(Array)) {
	    
	    [
	        "constructor",
	        "push",
	        "shift",
	        "concat",
	        "pop",
	        "unshift",
	        "replace",
	        "find",
	        "findIndex",
	        "splice",
	        "reverse",
	        "sort"
	    ].forEach(function (key) {
	        Object.defineProperty(StubArray$$1.prototype, key, {
	            configurable: true,
	            writable: true,
	            value: Array.prototype[key]
	        });
	    });
	}
	var ObservableArrayAdministration = /** @class */ (function () {
	    function ObservableArrayAdministration(name, enhancer, array, owned) {
	        this.array = array;
	        this.owned = owned;
	        this.values = [];
	        this.lastKnownLength = 0;
	        this.atom = new Atom$$1(name || "ObservableArray@" + getNextId$$1());
	        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
	    }
	    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined)
	            return this.dehancer(value);
	        return value;
	    };
	    ObservableArrayAdministration.prototype.dehanceValues = function (values$$1) {
	        if (this.dehancer !== undefined && values$$1.length > 0)
	            return values$$1.map(this.dehancer);
	        return values$$1;
	    };
	    ObservableArrayAdministration.prototype.intercept = function (handler) {
	        return registerInterceptor$$1(this, handler);
	    };
	    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately === void 0) { fireImmediately = false; }
	        if (fireImmediately) {
	            listener({
	                object: this.array,
	                type: "splice",
	                index: 0,
	                added: this.values.slice(),
	                addedCount: this.values.length,
	                removed: [],
	                removedCount: 0
	            });
	        }
	        return registerListener$$1(this, listener);
	    };
	    ObservableArrayAdministration.prototype.getArrayLength = function () {
	        this.atom.reportObserved();
	        return this.values.length;
	    };
	    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
	        if (typeof newLength !== "number" || newLength < 0)
	            throw new Error("[mobx.array] Out of range: " + newLength);
	        var currentLength = this.values.length;
	        if (newLength === currentLength)
	            return;
	        else if (newLength > currentLength) {
	            var newItems = new Array(newLength - currentLength);
	            for (var i = 0; i < newLength - currentLength; i++)
	                newItems[i] = undefined; // No Array.fill everywhere...
	            this.spliceWithArray(currentLength, 0, newItems);
	        }
	        else
	            this.spliceWithArray(newLength, currentLength - newLength);
	    };
	    // adds / removes the necessary numeric properties to this object
	    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
	        if (oldLength !== this.lastKnownLength)
	            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
	        this.lastKnownLength += delta;
	        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
	            reserveArrayBuffer$$1(oldLength + delta + 1);
	    };
	    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
	        var _this = this;
	        checkIfStateModificationsAreAllowed$$1(this.atom);
	        var length = this.values.length;
	        if (index === undefined)
	            index = 0;
	        else if (index > length)
	            index = length;
	        else if (index < 0)
	            index = Math.max(0, length + index);
	        if (arguments.length === 1)
	            deleteCount = length - index;
	        else if (deleteCount === undefined || deleteCount === null)
	            deleteCount = 0;
	        else
	            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
	        if (newItems === undefined)
	            newItems = EMPTY_ARRAY$$1;
	        if (hasInterceptors$$1(this)) {
	            var change = interceptChange$$1(this, {
	                object: this.array,
	                type: "splice",
	                index: index,
	                removedCount: deleteCount,
	                added: newItems
	            });
	            if (!change)
	                return EMPTY_ARRAY$$1;
	            deleteCount = change.removedCount;
	            newItems = change.added;
	        }
	        newItems =
	            newItems.length === 0 ? newItems : newItems.map(function (v) { return _this.enhancer(v, undefined); });
	        var lengthDelta = newItems.length - deleteCount;
	        this.updateArrayLength(length, lengthDelta); // create or remove new entries
	        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
	        if (deleteCount !== 0 || newItems.length !== 0)
	            this.notifyArraySplice(index, newItems, res);
	        return this.dehanceValues(res);
	    };
	    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
	        var _a;
	        if (newItems.length < MAX_SPLICE_SIZE) {
	            return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
	        }
	        else {
	            var res = this.values.slice(index, index + deleteCount);
	            this.values = this.values
	                .slice(0, index)
	                .concat(newItems, this.values.slice(index + deleteCount));
	            return res;
	        }
	    };
	    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
	        var notifySpy = !this.owned && isSpyEnabled$$1();
	        var notify = hasListeners$$1(this);
	        var change = notify || notifySpy
	            ? {
	                object: this.array,
	                type: "update",
	                index: index,
	                newValue: newValue,
	                oldValue: oldValue
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart$$1(__assign({}, change, { name: this.atom.name }));
	        this.atom.reportChanged();
	        if (notify)
	            notifyListeners$$1(this, change);
	        if (notifySpy)
	            spyReportEnd$$1();
	    };
	    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
	        var notifySpy = !this.owned && isSpyEnabled$$1();
	        var notify = hasListeners$$1(this);
	        var change = notify || notifySpy
	            ? {
	                object: this.array,
	                type: "splice",
	                index: index,
	                removed: removed,
	                added: added,
	                removedCount: removed.length,
	                addedCount: added.length
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart$$1(__assign({}, change, { name: this.atom.name }));
	        this.atom.reportChanged();
	        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
	        if (notify)
	            notifyListeners$$1(this, change);
	        if (notifySpy)
	            spyReportEnd$$1();
	    };
	    return ObservableArrayAdministration;
	}());
	var ObservableArray$$1 = /** @class */ (function (_super) {
	    __extends(ObservableArray$$1, _super);
	    function ObservableArray$$1(initialValues, enhancer, name, owned) {
	        if (name === void 0) { name = "ObservableArray@" + getNextId$$1(); }
	        if (owned === void 0) { owned = false; }
	        var _this = _super.call(this) || this;
	        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
	        addHiddenFinalProp$$1(_this, "$mobx", adm);
	        if (initialValues && initialValues.length) {
	            var prev = allowStateChangesStart$$1(true);
	            _this.spliceWithArray(0, 0, initialValues);
	            allowStateChangesEnd$$1(prev);
	        }
	        if (safariPrototypeSetterInheritanceBug) {
	            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
	            // defined on the instance. After that it works fine, even if this property is deleted.
	            Object.defineProperty(adm.array, "0", ENTRY_0);
	        }
	        return _this;
	    }
	    ObservableArray$$1.prototype.intercept = function (handler) {
	        return this.$mobx.intercept(handler);
	    };
	    ObservableArray$$1.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately === void 0) { fireImmediately = false; }
	        return this.$mobx.observe(listener, fireImmediately);
	    };
	    ObservableArray$$1.prototype.clear = function () {
	        return this.splice(0);
	    };
	    ObservableArray$$1.prototype.concat = function () {
	        var arrays = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            arrays[_i] = arguments[_i];
	        }
	        this.$mobx.atom.reportObserved();
	        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray$$1(a) ? a.peek() : a); }));
	    };
	    ObservableArray$$1.prototype.replace = function (newItems) {
	        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
	    };
	    /**
	     * Converts this array back to a (shallow) javascript structure.
	     * For a deep clone use mobx.toJS
	     */
	    ObservableArray$$1.prototype.toJS = function () {
	        return this.slice();
	    };
	    ObservableArray$$1.prototype.toJSON = function () {
	        // Used by JSON.stringify
	        return this.toJS();
	    };
	    ObservableArray$$1.prototype.peek = function () {
	        this.$mobx.atom.reportObserved();
	        return this.$mobx.dehanceValues(this.$mobx.values);
	    };
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
	    ObservableArray$$1.prototype.find = function (predicate, thisArg, fromIndex) {
	        if (fromIndex === void 0) { fromIndex = 0; }
	        if (arguments.length === 3)
	            deprecated$$1("The array.find fromIndex argument to find will not be supported anymore in the next major");
	        var idx = this.findIndex.apply(this, arguments);
	        return idx === -1 ? undefined : this.get(idx);
	    };
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
	    ObservableArray$$1.prototype.findIndex = function (predicate, thisArg, fromIndex) {
	        if (fromIndex === void 0) { fromIndex = 0; }
	        if (arguments.length === 3)
	            deprecated$$1("The array.findIndex fromIndex argument to find will not be supported anymore in the next major");
	        var items = this.peek(), l = items.length;
	        for (var i = fromIndex; i < l; i++)
	            if (predicate.call(thisArg, items[i], i, this))
	                return i;
	        return -1;
	    };
	    /*
	     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
	     * since these functions alter the inner structure of the array, the have side effects.
	     * Because the have side effects, they should not be used in computed function,
	     * and for that reason the do not call dependencyState.notifyObserved
	     */
	    ObservableArray$$1.prototype.splice = function (index, deleteCount) {
	        var newItems = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            newItems[_i - 2] = arguments[_i];
	        }
	        switch (arguments.length) {
	            case 0:
	                return [];
	            case 1:
	                return this.$mobx.spliceWithArray(index);
	            case 2:
	                return this.$mobx.spliceWithArray(index, deleteCount);
	        }
	        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
	    };
	    ObservableArray$$1.prototype.spliceWithArray = function (index, deleteCount, newItems) {
	        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
	    };
	    ObservableArray$$1.prototype.push = function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this.$mobx;
	        adm.spliceWithArray(adm.values.length, 0, items);
	        return adm.values.length;
	    };
	    ObservableArray$$1.prototype.pop = function () {
	        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
	    };
	    ObservableArray$$1.prototype.shift = function () {
	        return this.splice(0, 1)[0];
	    };
	    ObservableArray$$1.prototype.unshift = function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this.$mobx;
	        adm.spliceWithArray(0, 0, items);
	        return adm.values.length;
	    };
	    ObservableArray$$1.prototype.reverse = function () {
	        // reverse by default mutates in place before returning the result
	        // which makes it both a 'derivation' and a 'mutation'.
	        // so we deviate from the default and just make it an dervitation
	        var clone = this.slice();
	        return clone.reverse.apply(clone, arguments);
	    };
	    ObservableArray$$1.prototype.sort = function (compareFn) {
	        // sort by default mutates in place before returning the result
	        // which goes against all good practices. Let's not change the array in place!
	        var clone = this.slice();
	        return clone.sort.apply(clone, arguments);
	    };
	    ObservableArray$$1.prototype.remove = function (value) {
	        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
	        if (idx > -1) {
	            this.splice(idx, 1);
	            return true;
	        }
	        return false;
	    };
	    ObservableArray$$1.prototype.move = function (fromIndex, toIndex) {
	        deprecated$$1("observableArray.move is deprecated, use .slice() & .replace() instead");
	        function checkIndex(index) {
	            if (index < 0) {
	                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
	            }
	            var length = this.$mobx.values.length;
	            if (index >= length) {
	                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
	            }
	        }
	        checkIndex.call(this, fromIndex);
	        checkIndex.call(this, toIndex);
	        if (fromIndex === toIndex) {
	            return;
	        }
	        var oldItems = this.$mobx.values;
	        var newItems;
	        if (fromIndex < toIndex) {
	            newItems = __spread(oldItems.slice(0, fromIndex), oldItems.slice(fromIndex + 1, toIndex + 1), [
	                oldItems[fromIndex]
	            ], oldItems.slice(toIndex + 1));
	        }
	        else {
	            // toIndex < fromIndex
	            newItems = __spread(oldItems.slice(0, toIndex), [
	                oldItems[fromIndex]
	            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
	        }
	        this.replace(newItems);
	    };
	    // See #734, in case property accessors are unreliable...
	    ObservableArray$$1.prototype.get = function (index) {
	        var impl = this.$mobx;
	        if (impl) {
	            if (index < impl.values.length) {
	                impl.atom.reportObserved();
	                return impl.dehanceValue(impl.values[index]);
	            }
	            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
	        }
	        return undefined;
	    };
	    // See #734, in case property accessors are unreliable...
	    ObservableArray$$1.prototype.set = function (index, newValue) {
	        var adm = this.$mobx;
	        var values$$1 = adm.values;
	        if (index < values$$1.length) {
	            // update at index in range
	            checkIfStateModificationsAreAllowed$$1(adm.atom);
	            var oldValue = values$$1[index];
	            if (hasInterceptors$$1(adm)) {
	                var change = interceptChange$$1(adm, {
	                    type: "update",
	                    object: this,
	                    index: index,
	                    newValue: newValue
	                });
	                if (!change)
	                    return;
	                newValue = change.newValue;
	            }
	            newValue = adm.enhancer(newValue, oldValue);
	            var changed = newValue !== oldValue;
	            if (changed) {
	                values$$1[index] = newValue;
	                adm.notifyArrayChildUpdate(index, newValue, oldValue);
	            }
	        }
	        else if (index === values$$1.length) {
	            // add a new item
	            adm.spliceWithArray(index, 0, [newValue]);
	        }
	        else {
	            // out of bounds
	            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values$$1.length);
	        }
	    };
	    return ObservableArray$$1;
	}(StubArray$$1));
	declareIterator$$1(ObservableArray$$1.prototype, function () {
	    
	    this.$mobx.atom.reportObserved();
	    var self = this;
	    var nextIndex = 0;
	    return makeIterable$$1({
	        next: function () {
	            return nextIndex < self.length
	                ? { value: self[nextIndex++], done: false }
	                : { done: true, value: undefined };
	        }
	    });
	});
	Object.defineProperty(ObservableArray$$1.prototype, "length", {
	    enumerable: false,
	    configurable: true,
	    get: function () {
	        return this.$mobx.getArrayLength();
	    },
	    set: function (newLength) {
	        this.$mobx.setArrayLength(newLength);
	    }
	});
	addHiddenProp$$1(ObservableArray$$1.prototype, toStringTagSymbol$$1(), "Array");
	[
	    "every",
	    "filter",
	    "forEach",
	    "indexOf",
	    "join",
	    "lastIndexOf",
	    "map",
	    "reduce",
	    "reduceRight",
	    "slice",
	    "some",
	    "toString",
	    "toLocaleString"
	].forEach(function (funcName) {
	    var baseFunc = Array.prototype[funcName];
	    invariant$$1(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
	    addHiddenProp$$1(ObservableArray$$1.prototype, funcName, function () {
	        return baseFunc.apply(this.peek(), arguments);
	    });
	});
	/**
	 * We don't want those to show up in `for (const key in ar)` ...
	 */
	makeNonEnumerable$$1(ObservableArray$$1.prototype, [
	    "constructor",
	    "intercept",
	    "observe",
	    "clear",
	    "concat",
	    "get",
	    "replace",
	    "toJS",
	    "toJSON",
	    "peek",
	    "find",
	    "findIndex",
	    "splice",
	    "spliceWithArray",
	    "push",
	    "pop",
	    "set",
	    "shift",
	    "unshift",
	    "reverse",
	    "sort",
	    "remove",
	    "move",
	    "toString",
	    "toLocaleString"
	]);
	// See #364
	var ENTRY_0 = createArrayEntryDescriptor(0);
	function createArrayEntryDescriptor(index) {
	    return {
	        enumerable: false,
	        configurable: false,
	        get: function () {
	            return this.get(index);
	        },
	        set: function (value) {
	            this.set(index, value);
	        }
	    };
	}
	function createArrayBufferItem(index) {
	    Object.defineProperty(ObservableArray$$1.prototype, "" + index, createArrayEntryDescriptor(index));
	}
	function reserveArrayBuffer$$1(max) {
	    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
	        createArrayBufferItem(index);
	    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
	}
	reserveArrayBuffer$$1(1000);
	var isObservableArrayAdministration = createInstanceofPredicate$$1("ObservableArrayAdministration", ObservableArrayAdministration);
	function isObservableArray$$1(thing) {
	    return isObject$$1(thing) && isObservableArrayAdministration(thing.$mobx);
	}
	
	var ObservableMapMarker = {};
	var ObservableMap$$1 = /** @class */ (function () {
	    function ObservableMap$$1(initialData, enhancer, name) {
	        if (enhancer === void 0) { enhancer = deepEnhancer$$1; }
	        if (name === void 0) { name = "ObservableMap@" + getNextId$$1(); }
	        this.enhancer = enhancer;
	        this.name = name;
	        this.$mobx = ObservableMapMarker;
	        this._keys = (new ObservableArray$$1(undefined, referenceEnhancer$$1, this.name + ".keys()", true));
	        if (typeof Map !== "function") {
	            throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
	        }
	        this._data = new Map();
	        this._hasMap = new Map();
	        this.merge(initialData);
	    }
	    ObservableMap$$1.prototype._has = function (key) {
	        return this._data.has(key);
	    };
	    ObservableMap$$1.prototype.has = function (key) {
	        if (this._hasMap.has(key))
	            return this._hasMap.get(key).get();
	        return this._updateHasMapEntry(key, false).get();
	    };
	    ObservableMap$$1.prototype.set = function (key, value) {
	        var hasKey = this._has(key);
	        if (hasInterceptors$$1(this)) {
	            var change = interceptChange$$1(this, {
	                type: hasKey ? "update" : "add",
	                object: this,
	                newValue: value,
	                name: key
	            });
	            if (!change)
	                return this;
	            value = change.newValue;
	        }
	        if (hasKey) {
	            this._updateValue(key, value);
	        }
	        else {
	            this._addValue(key, value);
	        }
	        return this;
	    };
	    ObservableMap$$1.prototype.delete = function (key) {
	        var _this = this;
	        if (hasInterceptors$$1(this)) {
	            var change = interceptChange$$1(this, {
	                type: "delete",
	                object: this,
	                name: key
	            });
	            if (!change)
	                return false;
	        }
	        if (this._has(key)) {
	            var notifySpy = isSpyEnabled$$1();
	            var notify = hasListeners$$1(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "delete",
	                    object: this,
	                    oldValue: this._data.get(key).value,
	                    name: key
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart$$1(__assign({}, change, { name: this.name, key: key }));
	            transaction$$1(function () {
	                _this._keys.remove(key);
	                _this._updateHasMapEntry(key, false);
	                var observable$$1 = _this._data.get(key);
	                observable$$1.setNewValue(undefined);
	                _this._data.delete(key);
	            });
	            if (notify)
	                notifyListeners$$1(this, change);
	            if (notifySpy)
	                spyReportEnd$$1();
	            return true;
	        }
	        return false;
	    };
	    ObservableMap$$1.prototype._updateHasMapEntry = function (key, value) {
	        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
	        var entry = this._hasMap.get(key);
	        if (entry) {
	            entry.setNewValue(value);
	        }
	        else {
	            entry = new ObservableValue$$1(value, referenceEnhancer$$1, this.name + "." + key + "?", false);
	            this._hasMap.set(key, entry);
	        }
	        return entry;
	    };
	    ObservableMap$$1.prototype._updateValue = function (key, newValue) {
	        var observable$$1 = this._data.get(key);
	        newValue = observable$$1.prepareNewValue(newValue);
	        if (newValue !== globalState$$1.UNCHANGED) {
	            var notifySpy = isSpyEnabled$$1();
	            var notify = hasListeners$$1(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "update",
	                    object: this,
	                    oldValue: observable$$1.value,
	                    name: key,
	                    newValue: newValue
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart$$1(__assign({}, change, { name: this.name, key: key }));
	            observable$$1.setNewValue(newValue);
	            if (notify)
	                notifyListeners$$1(this, change);
	            if (notifySpy)
	                spyReportEnd$$1();
	        }
	    };
	    ObservableMap$$1.prototype._addValue = function (key, newValue) {
	        var _this = this;
	        transaction$$1(function () {
	            var observable$$1 = new ObservableValue$$1(newValue, _this.enhancer, _this.name + "." + key, false);
	            _this._data.set(key, observable$$1);
	            newValue = observable$$1.value; // value might have been changed
	            _this._updateHasMapEntry(key, true);
	            _this._keys.push(key);
	        });
	        var notifySpy = isSpyEnabled$$1();
	        var notify = hasListeners$$1(this);
	        var change = notify || notifySpy
	            ? {
	                type: "add",
	                object: this,
	                name: key,
	                newValue: newValue
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart$$1(__assign({}, change, { name: this.name, key: key }));
	        if (notify)
	            notifyListeners$$1(this, change);
	        if (notifySpy)
	            spyReportEnd$$1();
	    };
	    ObservableMap$$1.prototype.get = function (key) {
	        if (this.has(key))
	            return this.dehanceValue(this._data.get(key).get());
	        return this.dehanceValue(undefined);
	    };
	    ObservableMap$$1.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined) {
	            return this.dehancer(value);
	        }
	        return value;
	    };
	    ObservableMap$$1.prototype.keys = function () {
	        return this._keys[iteratorSymbol$$1()]();
	    };
	    ObservableMap$$1.prototype.values = function () {
	        var self = this;
	        var nextIndex = 0;
	        return makeIterable$$1({
	            next: function () {
	                return nextIndex < self._keys.length
	                    ? { value: self.get(self._keys[nextIndex++]), done: false }
	                    : { value: undefined, done: true };
	            }
	        });
	    };
	    ObservableMap$$1.prototype.entries = function () {
	        var self = this;
	        var nextIndex = 0;
	        return makeIterable$$1({
	            next: function () {
	                if (nextIndex < self._keys.length) {
	                    var key = self._keys[nextIndex++];
	                    return {
	                        value: [key, self.get(key)],
	                        done: false
	                    };
	                }
	                return { done: true };
	            }
	        });
	    };
	    ObservableMap$$1.prototype.forEach = function (callback, thisArg) {
	        var _this = this;
	        this._keys.forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
	    };
	    /** Merge another object into this object, returns this. */
	    ObservableMap$$1.prototype.merge = function (other) {
	        var _this = this;
	        if (isObservableMap$$1(other)) {
	            other = other.toJS();
	        }
	        transaction$$1(function () {
	            if (isPlainObject$$1(other))
	                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
	            else if (Array.isArray(other))
	                other.forEach(function (_a) {
	                    var _b = __read(_a, 2), key = _b[0], value = _b[1];
	                    return _this.set(key, value);
	                });
	            else if (isES6Map$$1(other)) {
	                if (other.constructor !== Map)
	                    fail$1("Cannot initialize from classes that inherit from Map: " + other.constructor.name); // prettier-ignore
	                else
	                    other.forEach(function (value, key) { return _this.set(key, value); });
	            }
	            else if (other !== null && other !== undefined)
	                fail$1("Cannot initialize map from " + other);
	        });
	        return this;
	    };
	    ObservableMap$$1.prototype.clear = function () {
	        var _this = this;
	        transaction$$1(function () {
	            untracked$$1(function () {
	                _this._keys.slice().forEach(function (key) { return _this.delete(key); });
	            });
	        });
	    };
	    ObservableMap$$1.prototype.replace = function (values$$1) {
	        var _this = this;
	        transaction$$1(function () {
	            // grab all the keys that are present in the new map but not present in the current map
	            // and delete them from the map, then merge the new map
	            // this will cause reactions only on changed values
	            var newKeys = getMapLikeKeys$$1(values$$1);
	            var oldKeys = _this._keys;
	            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
	            missingKeys.forEach(function (k) { return _this.delete(k); });
	            _this.merge(values$$1);
	        });
	        return this;
	    };
	    Object.defineProperty(ObservableMap$$1.prototype, "size", {
	        get: function () {
	            return this._keys.length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns a plain object that represents this map.
	     * Note that all the keys being stringified.
	     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
	     */
	    ObservableMap$$1.prototype.toPOJO = function () {
	        var _this = this;
	        var res = {};
	        this._keys.forEach(function (key) { return (res["" + key] = _this.get(key)); });
	        return res;
	    };
	    /**
	     * Returns a shallow non observable object clone of this map.
	     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
	     */
	    ObservableMap$$1.prototype.toJS = function () {
	        var _this = this;
	        var res = new Map();
	        this._keys.forEach(function (key) { return res.set(key, _this.get(key)); });
	        return res;
	    };
	    ObservableMap$$1.prototype.toJSON = function () {
	        // Used by JSON.stringify
	        return this.toPOJO();
	    };
	    ObservableMap$$1.prototype.toString = function () {
	        var _this = this;
	        return (this.name +
	            "[{ " +
	            this._keys.map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") +
	            " }]");
	    };
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableMap$$1.prototype.observe = function (listener, fireImmediately) {
	        ("production") !== "production" &&
	            invariant$$1(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with maps.");
	        return registerListener$$1(this, listener);
	    };
	    ObservableMap$$1.prototype.intercept = function (handler) {
	        return registerInterceptor$$1(this, handler);
	    };
	    return ObservableMap$$1;
	}());
	declareIterator$$1(ObservableMap$$1.prototype, function () {
	    return this.entries();
	});
	addHiddenFinalProp$$1(ObservableMap$$1.prototype, toStringTagSymbol$$1(), "Map");
	/* 'var' fixes small-build issue */
	var isObservableMap$$1 = createInstanceofPredicate$$1("ObservableMap", ObservableMap$$1);
	
	var ObservableSetMarker = {};
	var ObservableSet$$1 = /** @class */ (function () {
	    function ObservableSet$$1(initialData, enhancer, name) {
	        if (enhancer === void 0) { enhancer = deepEnhancer$$1; }
	        if (name === void 0) { name = "ObservableSet@" + getNextId$$1(); }
	        this.name = name;
	        this.$mobx = ObservableSetMarker;
	        this._data = new Set();
	        this._atom = createAtom$$1(this.name);
	        if (typeof Set !== "function") {
	            throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");
	        }
	        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name); };
	        if (initialData) {
	            this.replace(initialData);
	        }
	    }
	    ObservableSet$$1.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined) {
	            return this.dehancer(value);
	        }
	        return value;
	    };
	    ObservableSet$$1.prototype.clear = function () {
	        var _this = this;
	        transaction$$1(function () {
	            untracked$$1(function () {
	                _this._data.forEach(function (value) {
	                    _this.delete(value);
	                });
	            });
	        });
	    };
	    ObservableSet$$1.prototype.forEach = function (callbackFn, thisArg) {
	        var _this = this;
	        this._data.forEach(function (value) {
	            callbackFn.call(thisArg, value, value, _this);
	        });
	    };
	    Object.defineProperty(ObservableSet$$1.prototype, "size", {
	        get: function () {
	            this._atom.reportObserved();
	            return this._data.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ObservableSet$$1.prototype.add = function (value) {
	        var _this = this;
	        checkIfStateModificationsAreAllowed$$1(this._atom);
	        if (hasInterceptors$$1(this)) {
	            var change = interceptChange$$1(this, {
	                type: "add",
	                object: this,
	                newValue: value
	            });
	            if (!change)
	                return this;
	            // TODO: ideally, value = change.value would be done here, so that values can be
	            // changed by interceptor. Same applies for other Set and Map api's.
	        }
	        if (!this.has(value)) {
	            transaction$$1(function () {
	                _this._data.add(_this.enhancer(value, undefined));
	                _this._atom.reportChanged();
	            });
	            var notifySpy = isSpyEnabled$$1();
	            var notify = hasListeners$$1(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "add",
	                    object: this,
	                    newValue: value
	                }
	                : null;
	            if (notifySpy && ("production") !== "production")
	                spyReportStart$$1(change);
	            if (notify)
	                notifyListeners$$1(this, change);
	            if (notifySpy && ("production") !== "production")
	                spyReportEnd$$1();
	        }
	        return this;
	    };
	    ObservableSet$$1.prototype.delete = function (value) {
	        var _this = this;
	        if (hasInterceptors$$1(this)) {
	            var change = interceptChange$$1(this, {
	                type: "delete",
	                object: this,
	                oldValue: value
	            });
	            if (!change)
	                return false;
	        }
	        if (this.has(value)) {
	            var notifySpy = isSpyEnabled$$1();
	            var notify = hasListeners$$1(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "delete",
	                    object: this,
	                    oldValue: value
	                }
	                : null;
	            if (notifySpy && ("production") !== "production")
	                spyReportStart$$1(__assign({}, change, { name: this.name }));
	            transaction$$1(function () {
	                _this._atom.reportChanged();
	                _this._data.delete(value);
	            });
	            if (notify)
	                notifyListeners$$1(this, change);
	            if (notifySpy && ("production") !== "production")
	                spyReportEnd$$1();
	            return true;
	        }
	        return false;
	    };
	    ObservableSet$$1.prototype.has = function (value) {
	        this._atom.reportObserved();
	        return this._data.has(this.dehanceValue(value));
	    };
	    ObservableSet$$1.prototype.entries = function () {
	        var nextIndex = 0;
	        var keys$$1 = Array.from(this.keys());
	        var values$$1 = Array.from(this.values());
	        return makeIterable$$1({
	            next: function () {
	                var index = nextIndex;
	                nextIndex += 1;
	                return index < values$$1.length
	                    ? { value: [keys$$1[index], values$$1[index]], done: false }
	                    : { done: true };
	            }
	        });
	    };
	    ObservableSet$$1.prototype.keys = function () {
	        return this.values();
	    };
	    ObservableSet$$1.prototype.values = function () {
	        this._atom.reportObserved();
	        var self = this;
	        var nextIndex = 0;
	        var observableValues = Array.from(this._data.values());
	        return makeIterable$$1({
	            next: function () {
	                return nextIndex < observableValues.length
	                    ? { value: self.dehanceValue(observableValues[nextIndex++]), done: false }
	                    : { done: true };
	            }
	        });
	    };
	    ObservableSet$$1.prototype.replace = function (other) {
	        var _this = this;
	        if (isObservableSet$$1(other)) {
	            other = other.toJS();
	        }
	        transaction$$1(function () {
	            if (Array.isArray(other)) {
	                _this.clear();
	                other.forEach(function (value) { return _this.add(value); });
	            }
	            else if (isES6Set$$1(other)) {
	                _this.clear();
	                other.forEach(function (value) { return _this.add(value); });
	            }
	            else if (other !== null && other !== undefined) {
	                fail$1("Cannot initialize set from " + other);
	            }
	        });
	        return this;
	    };
	    ObservableSet$$1.prototype.observe = function (listener, fireImmediately) {
	        // TODO 'fireImmediately' can be true?
	        ("production") !== "production" &&
	            invariant$$1(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with sets.");
	        return registerListener$$1(this, listener);
	    };
	    ObservableSet$$1.prototype.intercept = function (handler) {
	        return registerInterceptor$$1(this, handler);
	    };
	    ObservableSet$$1.prototype.toJS = function () {
	        return new Set(this);
	    };
	    ObservableSet$$1.prototype.toString = function () {
	        return this.name + "[ " + Array.from(this).join(", ") + " ]";
	    };
	    return ObservableSet$$1;
	}());
	declareIterator$$1(ObservableSet$$1.prototype, function () {
	    return this.values();
	});
	addHiddenFinalProp$$1(ObservableSet$$1.prototype, toStringTagSymbol$$1(), "Set");
	var isObservableSet$$1 = createInstanceofPredicate$$1("ObservableSet", ObservableSet$$1);
	
	var ObservableObjectAdministration$$1 = /** @class */ (function () {
	    function ObservableObjectAdministration$$1(target, name, defaultEnhancer) {
	        this.target = target;
	        this.name = name;
	        this.defaultEnhancer = defaultEnhancer;
	        this.values = {};
	    }
	    ObservableObjectAdministration$$1.prototype.read = function (owner, key) {
	        if (("production") === "production" && this.target !== owner) {
	            this.illegalAccess(owner, key);
	            if (!this.values[key])
	                return undefined;
	        }
	        return this.values[key].get();
	    };
	    ObservableObjectAdministration$$1.prototype.write = function (owner, key, newValue) {
	        var instance = this.target;
	        if (("production") === "production" && instance !== owner) {
	            this.illegalAccess(owner, key);
	        }
	        var observable$$1 = this.values[key];
	        if (observable$$1 instanceof ComputedValue$$1) {
	            observable$$1.set(newValue);
	            return;
	        }
	        // intercept
	        if (hasInterceptors$$1(this)) {
	            var change = interceptChange$$1(this, {
	                type: "update",
	                object: instance,
	                name: key,
	                newValue: newValue
	            });
	            if (!change)
	                return;
	            newValue = change.newValue;
	        }
	        newValue = observable$$1.prepareNewValue(newValue);
	        // notify spy & observers
	        if (newValue !== globalState$$1.UNCHANGED) {
	            var notify = hasListeners$$1(this);
	            var notifySpy = isSpyEnabled$$1();
	            var change = notify || notifySpy
	                ? {
	                    type: "update",
	                    object: instance,
	                    oldValue: observable$$1.value,
	                    name: key,
	                    newValue: newValue
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart$$1(__assign({}, change, { name: this.name, key: key }));
	            observable$$1.setNewValue(newValue);
	            if (notify)
	                notifyListeners$$1(this, change);
	            if (notifySpy)
	                spyReportEnd$$1();
	        }
	    };
	    ObservableObjectAdministration$$1.prototype.remove = function (key) {
	        if (!this.values[key])
	            return;
	        var target = this.target;
	        if (hasInterceptors$$1(this)) {
	            var change = interceptChange$$1(this, {
	                object: target,
	                name: key,
	                type: "remove"
	            });
	            if (!change)
	                return;
	        }
	        try {
	            startBatch$$1();
	            var notify = hasListeners$$1(this);
	            var notifySpy = isSpyEnabled$$1();
	            var oldValue = this.values[key].get();
	            if (this.keys)
	                this.keys.remove(key);
	            delete this.values[key];
	            delete this.target[key];
	            var change = notify || notifySpy
	                ? {
	                    type: "remove",
	                    object: target,
	                    oldValue: oldValue,
	                    name: key
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart$$1(__assign({}, change, { name: this.name, key: key }));
	            if (notify)
	                notifyListeners$$1(this, change);
	            if (notifySpy)
	                spyReportEnd$$1();
	        }
	        finally {
	            endBatch$$1();
	        }
	    };
	    ObservableObjectAdministration$$1.prototype.illegalAccess = function (owner, propName) {
	        /**
	         * This happens if a property is accessed through the prototype chain, but the property was
	         * declared directly as own property on the prototype.
	         *
	         * E.g.:
	         * class A {
	         * }
	         * extendObservable(A.prototype, { x: 1 })
	         *
	         * classB extens A {
	         * }
	         * console.log(new B().x)
	         *
	         * It is unclear whether the property should be considered 'static' or inherited.
	         * Either use `console.log(A.x)`
	         * or: decorate(A, { x: observable })
	         *
	         * When using decorate, the property will always be redeclared as own property on the actual instance
	         */
	        console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
	    };
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableObjectAdministration$$1.prototype.observe = function (callback, fireImmediately) {
	        ("production") !== "production" &&
	            invariant$$1(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
	        return registerListener$$1(this, callback);
	    };
	    ObservableObjectAdministration$$1.prototype.intercept = function (handler) {
	        return registerInterceptor$$1(this, handler);
	    };
	    ObservableObjectAdministration$$1.prototype.getKeys = function () {
	        var _this = this;
	        if (this.keys === undefined) {
	            this.keys = (new ObservableArray$$1(Object.keys(this.values).filter(function (key) { return _this.values[key] instanceof ObservableValue$$1; }), referenceEnhancer$$1, "keys(" + this.name + ")", true));
	        }
	        return this.keys.slice();
	    };
	    return ObservableObjectAdministration$$1;
	}());
	function asObservableObject$$1(target, name, defaultEnhancer) {
	    if (name === void 0) { name = ""; }
	    if (defaultEnhancer === void 0) { defaultEnhancer = deepEnhancer$$1; }
	    var adm = target.$mobx;
	    if (adm)
	        return adm;
	    ("production") !== "production" &&
	        invariant$$1(Object.isExtensible(target), "Cannot make the designated object observable; it is not extensible");
	    if (!isPlainObject$$1(target))
	        name = (target.constructor.name || "ObservableObject") + "@" + getNextId$$1();
	    if (!name)
	        name = "ObservableObject@" + getNextId$$1();
	    adm = new ObservableObjectAdministration$$1(target, name, defaultEnhancer);
	    addHiddenFinalProp$$1(target, "$mobx", adm);
	    return adm;
	}
	function defineObservableProperty$$1(target, propName, newValue, enhancer) {
	    var adm = asObservableObject$$1(target);
	    assertPropertyConfigurable$$1(target, propName);
	    if (hasInterceptors$$1(adm)) {
	        var change = interceptChange$$1(adm, {
	            object: target,
	            name: propName,
	            type: "add",
	            newValue: newValue
	        });
	        if (!change)
	            return;
	        newValue = change.newValue;
	    }
	    var observable$$1 = (adm.values[propName] = new ObservableValue$$1(newValue, enhancer, adm.name + "." + propName, false));
	    newValue = observable$$1.value; // observableValue might have changed it
	    Object.defineProperty(target, propName, generateObservablePropConfig$$1(propName));
	    if (adm.keys)
	        adm.keys.push(propName);
	    notifyPropertyAddition(adm, target, propName, newValue);
	}
	function defineComputedProperty$$1(target, // which objects holds the observable and provides `this` context?
	propName, options) {
	    var adm = asObservableObject$$1(target);
	    options.name = adm.name + "." + propName;
	    options.context = target;
	    adm.values[propName] = new ComputedValue$$1(options);
	    Object.defineProperty(target, propName, generateComputedPropConfig$$1(propName));
	}
	var observablePropertyConfigs = Object.create(null);
	var computedPropertyConfigs = Object.create(null);
	function generateObservablePropConfig$$1(propName) {
	    return (observablePropertyConfigs[propName] ||
	        (observablePropertyConfigs[propName] = {
	            configurable: true,
	            enumerable: true,
	            get: function () {
	                return this.$mobx.read(this, propName);
	            },
	            set: function (v) {
	                this.$mobx.write(this, propName, v);
	            }
	        }));
	}
	function getAdministrationForComputedPropOwner(owner) {
	    var adm = owner.$mobx;
	    if (!adm) {
	        // because computed props are declared on proty,
	        // the current instance might not have been initialized yet
	        initializeInstance$$1(owner);
	        return owner.$mobx;
	    }
	    return adm;
	}
	function generateComputedPropConfig$$1(propName) {
	    return (computedPropertyConfigs[propName] ||
	        (computedPropertyConfigs[propName] = {
	            configurable: false,
	            enumerable: false,
	            get: function () {
	                return getAdministrationForComputedPropOwner(this).read(this, propName);
	            },
	            set: function (v) {
	                getAdministrationForComputedPropOwner(this).write(this, propName, v);
	            }
	        }));
	}
	function notifyPropertyAddition(adm, object, key, newValue) {
	    var notify = hasListeners$$1(adm);
	    var notifySpy = isSpyEnabled$$1();
	    var change = notify || notifySpy
	        ? {
	            type: "add",
	            object: object,
	            name: key,
	            newValue: newValue
	        }
	        : null;
	    if (notifySpy)
	        spyReportStart$$1(__assign({}, change, { name: adm.name, key: key }));
	    if (notify)
	        notifyListeners$$1(adm, change);
	    if (notifySpy)
	        spyReportEnd$$1();
	}
	var isObservableObjectAdministration = createInstanceofPredicate$$1("ObservableObjectAdministration", ObservableObjectAdministration$$1);
	function isObservableObject$$1(thing) {
	    if (isObject$$1(thing)) {
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        initializeInstance$$1(thing);
	        return isObservableObjectAdministration(thing.$mobx);
	    }
	    return false;
	}
	
	function getAtom$$1(thing, property) {
	    if (typeof thing === "object" && thing !== null) {
	        if (isObservableArray$$1(thing)) {
	            if (property !== undefined)
	                fail$1(("production") !== "production" &&
	                    "It is not possible to get index atoms from arrays");
	            return thing.$mobx.atom;
	        }
	        if (isObservableSet$$1(thing)) {
	            return thing.$mobx;
	        }
	        if (isObservableMap$$1(thing)) {
	            var anyThing = thing;
	            if (property === undefined)
	                return getAtom$$1(anyThing._keys);
	            var observable$$1 = anyThing._data.get(property) || anyThing._hasMap.get(property);
	            if (!observable$$1)
	                fail$1(("production") !== "production" &&
	                    "the entry '" + property + "' does not exist in the observable map '" + getDebugName$$1(thing) + "'");
	            return observable$$1;
	        }
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        initializeInstance$$1(thing);
	        if (property && !thing.$mobx)
	            thing[property]; // See #1072
	        if (isObservableObject$$1(thing)) {
	            if (!property)
	                return fail$1(("production") !== "production" && "please specify a property");
	            var observable$$1 = thing.$mobx.values[property];
	            if (!observable$$1)
	                fail$1(("production") !== "production" &&
	                    "no observable property '" + property + "' found on the observable object '" + getDebugName$$1(thing) + "'");
	            return observable$$1;
	        }
	        if (isAtom$$1(thing) || isComputedValue$$1(thing) || isReaction$$1(thing)) {
	            return thing;
	        }
	    }
	    else if (typeof thing === "function") {
	        if (isReaction$$1(thing.$mobx)) {
	            // disposer function
	            return thing.$mobx;
	        }
	    }
	    return fail$1(("production") !== "production" && "Cannot obtain atom from " + thing);
	}
	function getAdministration$$1(thing, property) {
	    if (!thing)
	        fail$1("Expecting some object");
	    if (property !== undefined)
	        return getAdministration$$1(getAtom$$1(thing, property));
	    if (isAtom$$1(thing) || isComputedValue$$1(thing) || isReaction$$1(thing))
	        return thing;
	    if (isObservableMap$$1(thing) || isObservableSet$$1(thing))
	        return thing;
	    // Initializers run lazily when transpiling to babel, so make sure they are run...
	    initializeInstance$$1(thing);
	    if (thing.$mobx)
	        return thing.$mobx;
	    fail$1(("production") !== "production" && "Cannot obtain administration from " + thing);
	}
	function getDebugName$$1(thing, property) {
	    var named;
	    if (property !== undefined)
	        named = getAtom$$1(thing, property);
	    else if (isObservableObject$$1(thing) || isObservableMap$$1(thing) || isObservableSet$$1(thing))
	        named = getAdministration$$1(thing);
	    else
	        named = getAtom$$1(thing); // valid for arrays as well
	    return named.name;
	}
	
	var toString = Object.prototype.toString;
	function deepEqual$$1(a, b) {
	    return eq(a, b);
	}
	// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
	// Internal recursive comparison function for `isEqual`.
	function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b)
	        return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null)
	        return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a)
	        return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== "function" && type !== "object" && typeof b != "object")
	        return false;
	    return deepEq(a, b, aStack, bStack);
	}
	// Internal recursive comparison function for `isEqual`.
	function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    a = unwrap(a);
	    b = unwrap(b);
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b))
	        return false;
	    switch (className) {
	        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	        case "[object RegExp]":
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	        case "[object String]":
	            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	            // equivalent to `new String("5")`.
	            return "" + a === "" + b;
	        case "[object Number]":
	            // `NaN`s are equivalent, but non-reflexive.
	            // Object(NaN) is equivalent to NaN.
	            if (+a !== +a)
	                return +b !== +b;
	            // An `egal` comparison is performed for other numeric values.
	            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	        case "[object Date]":
	        case "[object Boolean]":
	            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	            // millisecond representations. Note that invalid dates with millisecond representations
	            // of `NaN` are not equivalent.
	            return +a === +b;
	        case "[object Symbol]":
	            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
	    }
	    var areArrays = className === "[object Array]";
	    if (!areArrays) {
	        if (typeof a != "object" || typeof b != "object")
	            return false;
	        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	        // from different frames are.
	        var aCtor = a.constructor, bCtor = b.constructor;
	        if (aCtor !== bCtor &&
	            !(typeof aCtor === "function" &&
	                aCtor instanceof aCtor &&
	                typeof bCtor === "function" &&
	                bCtor instanceof bCtor) &&
	            ("constructor" in a && "constructor" in b)) {
	            return false;
	        }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	        // Linear search. Performance is inversely proportional to the number of
	        // unique nested structures.
	        if (aStack[length] === a)
	            return bStack[length] === b;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	        // Compare array lengths to determine if a deep comparison is necessary.
	        length = a.length;
	        if (length !== b.length)
	            return false;
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (length--) {
	            if (!eq(a[length], b[length], aStack, bStack))
	                return false;
	        }
	    }
	    else {
	        // Deep compare objects.
	        var keys$$1 = Object.keys(a), key;
	        length = keys$$1.length;
	        // Ensure that both objects contain the same number of properties before comparing deep equality.
	        if (Object.keys(b).length !== length)
	            return false;
	        while (length--) {
	            // Deep compare each member
	            key = keys$$1[length];
	            if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack)))
	                return false;
	        }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	}
	function unwrap(a) {
	    if (isObservableArray$$1(a))
	        return a.peek();
	    if (isES6Map$$1(a) || isObservableMap$$1(a))
	        return iteratorToArray$$1(a.entries());
	    if (isES6Set$$1(a) || isObservableSet$$1(a))
	        return Array.from(a.entries());
	    return a;
	}
	function has$1(a, key) {
	    return Object.prototype.hasOwnProperty.call(a, key);
	}
	
	/*
	The only reason for this file to exist is pure horror:
	Without it rollup can make the bundling fail at any point in time; when it rolls up the files in the wrong order
	it will cause undefined errors (for example because super classes or local variables not being hosted).
	With this file that will still happen,
	but at least in this file we can magically reorder the imports with trial and error until the build succeeds again.
	*/
	
	/**
	 * (c) Michel Weststrate 2015 - 2019
	 * MIT Licensed
	 *
	 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
	 * this is a good place to start:
	 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
	 *
	 * Source folders:
	 * ===============
	 *
	 * - api/     Most of the public static methods exposed by the module can be found here.
	 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
	 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
	 * - utils/   Utility stuff.
	 *
	 */
	try {
	    // define process.env if needed
	    // if this is not a production build in the first place
	    // (in which case the expression below would be substituted with 'production')
	    ("production");
	}
	catch (e) {
	    var g = typeof window !== "undefined" ? window : global;
	    if (typeof process === "undefined")
	        g.process = {};
	    g.process.env = {};
	}
	
	(function () {
	    function testCodeMinification() { }
	    if (testCodeMinification.name !== "testCodeMinification" &&
	        ("production") !== "production" &&
	        ({"NODE_ENV":"production","PUBLIC_DIR":"/opt/atlassian/pipelines/agent/build/public"}).IGNORE_MOBX_MINIFY_WARNING !== "true") {
	        console.warn(
	        // Template literal(backtick) is used for fix issue with rollup-plugin-commonjs https://github.com/rollup/rollup-plugin-commonjs/issues/344
	        "[mobx] you are running a minified build, but 'process.env.NODE_ENV' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
	    }
	})();
	// forward compatibility with mobx, so that packages can easily support mobx 4 & 5
	var $mobx = "$mobx";
	// Devtools support
	if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
	    // See: https://github.com/andykog/mobx-devtools/
	    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
	        spy: spy$$1,
	        extras: {
	            getDebugName: getDebugName$$1
	        },
	        $mobx: $mobx
	    });
	}
	// TODO: remove in some future build
	if (false) {
	    var warnedAboutDefaultExport_1 = false;
	    Object.defineProperty(module.exports, "default", {
	        enumerable: false,
	        get: function () {
	            if (!warnedAboutDefaultExport_1) {
	                warnedAboutDefaultExport_1 = true;
	                console.warn("The MobX package does not have a default export. Use 'import { thing } from \"mobx\"' (recommended) or 'import * as mobx from \"mobx\"' instead.\"");
	            }
	            return undefined;
	        }
	    });
	    [
	        "extras",
	        "Atom",
	        "BaseAtom",
	        "asFlat",
	        "asMap",
	        "asReference",
	        "asStructure",
	        "autorunAsync",
	        "createTranformer",
	        "expr",
	        "isModifierDescriptor",
	        "isStrictModeEnabled",
	        "map",
	        "useStrict",
	        "whyRun"
	    ].forEach(function (prop) {
	        Object.defineProperty(module.exports, prop, {
	            enumerable: false,
	            get: function () {
	                fail("'" + prop + "' is no longer part of the public MobX api. Please consult the changelog to find out where this functionality went");
	            },
	            set: function () { }
	        });
	    });
	}
	
	exports.$mobx = $mobx;
	exports.Reaction = Reaction$$1;
	exports.untracked = untracked$$1;
	exports.createAtom = createAtom$$1;
	exports.spy = spy$$1;
	exports.comparer = comparer$$1;
	exports.isObservableObject = isObservableObject$$1;
	exports.isBoxedObservable = isObservableValue$$1;
	exports.isObservableArray = isObservableArray$$1;
	exports.ObservableMap = ObservableMap$$1;
	exports.isObservableMap = isObservableMap$$1;
	exports.ObservableSet = ObservableSet$$1;
	exports.isObservableSet = isObservableSet$$1;
	exports.transaction = transaction$$1;
	exports.observable = observable$$1;
	exports.computed = computed$$1;
	exports.isObservable = isObservable$$1;
	exports.isObservableProp = isObservableProp$$1;
	exports.isComputed = isComputed$$1;
	exports.isComputedProp = isComputedProp$$1;
	exports.extendObservable = extendObservable$$1;
	exports.extendShallowObservable = extendShallowObservable$$1;
	exports.observe = observe$$1;
	exports.intercept = intercept$$1;
	exports.autorun = autorun$$1;
	exports.reaction = reaction$$1;
	exports.when = when$$1;
	exports.action = action$$1;
	exports.isAction = isAction$$1;
	exports.runInAction = runInAction$$1;
	exports.keys = keys$$1;
	exports.values = values$$1;
	exports.entries = entries$$1;
	exports.set = set$$1;
	exports.remove = remove$$1;
	exports.has = has$$1;
	exports.get = get$$1;
	exports.decorate = decorate$$1;
	exports.configure = configure$$1;
	exports.onBecomeObserved = onBecomeObserved$$1;
	exports.onBecomeUnobserved = onBecomeUnobserved$$1;
	exports.flow = flow$$1;
	exports.toJS = toJS$$1;
	exports.trace = trace$$1;
	exports.getDependencyTree = getDependencyTree$$1;
	exports.getObserverTree = getObserverTree$$1;
	exports._resetGlobalState = resetGlobalState$$1;
	exports._getGlobalState = getGlobalState$$1;
	exports.getDebugName = getDebugName$$1;
	exports.getAtom = getAtom$$1;
	exports._getAdministration = getAdministration$$1;
	exports._allowStateChanges = allowStateChanges$$1;
	exports._allowStateChangesInsideComputed = allowStateChangesInsideComputed$$1;
	exports.isArrayLike = isArrayLike$$1;
	exports._isComputingDerivation = isComputingDerivation$$1;
	exports.onReactionError = onReactionError$$1;
	exports._interceptReads = interceptReads$$1;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(56)))

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)(module)))

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _context = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var removedIsInitialSSR = false;
	
	var I18n = function (_Component) {
	  _inherits(I18n, _Component);
	
	  function I18n(props, context) {
	    _classCallCheck(this, I18n);
	
	    var _this = _possibleConstructorReturn(this, (I18n.__proto__ || Object.getPrototypeOf(I18n)).call(this, props, context));
	
	    _this.i18n = props.i18n || context.i18n || (0, _context.getI18n)();
	
	    var i18nOptions = _this.i18n && _this.i18n.options && _this.i18n.options.react || {};
	    _this.options = _extends({}, (0, _context.getDefaults)(), i18nOptions, props);
	
	    // nextjs SSR: getting data from next.js or other ssr stack
	    if (props.initialI18nStore) {
	      _this.i18n.services.resourceStore.data = props.initialI18nStore;
	      _this.options.wait = false; // we got all passed down already
	    }
	    if (props.initialLanguage) {
	      _this.i18n.changeLanguage(props.initialLanguage);
	    }
	
	    // provider SSR: data was set in provider and ssr flag was set
	    if (_this.i18n.options && _this.i18n.options.isInitialSSR) {
	      _this.options.wait = false;
	    }
	
	    var language = _this.i18n.languages && _this.i18n.languages[0];
	    var ready = !!language && _this.getNamespaces().every(function (ns) {
	      return _this.i18n.hasResourceBundle(language, ns);
	    });
	
	    _this.state = {
	      i18nLoadedAt: null,
	      ready: ready
	    };
	
	    _this.t = _this.getI18nTranslate();
	
	    _this.onI18nChanged = _this.onI18nChanged.bind(_this);
	    _this.getI18nTranslate = _this.getI18nTranslate.bind(_this);
	    _this.namespaces = _this.getNamespaces.bind(_this);
	    return _this;
	  }
	
	  _createClass(I18n, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        t: this.t,
	        i18n: this.i18n
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadNamespaces();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // Note that dynamically loading additional namespaces after the initial mount will not block rendering – even if the `wait` option is true.
	      if (this.props.ns && prevProps.ns !== this.props.ns) this.loadNamespaces();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this2 = this;
	
	      this.mounted = false;
	      if (this.onI18nChanged) {
	        if (this.options.bindI18n) {
	          var p = this.options.bindI18n.split(' ');
	          p.forEach(function (f) {
	            return _this2.i18n.off(f, _this2.onI18nChanged);
	          });
	        }
	        if (this.options.bindStore) {
	          var _p = this.options.bindStore.split(' ');
	          _p.forEach(function (f) {
	            return _this2.i18n.store && _this2.i18n.store.off(f, _this2.onI18nChanged);
	          });
	        }
	      }
	    }
	  }, {
	    key: 'onI18nChanged',
	    value: function onI18nChanged() {
	      if (!this.mounted) return;
	      if (!this.state.ready && this.options.omitBoundRerender) return;
	
	      this.t = this.getI18nTranslate();
	      this.setState({ i18nLoadedAt: new Date() }); // rerender
	    }
	  }, {
	    key: 'getI18nTranslate',
	    value: function getI18nTranslate() {
	      return this.i18n.getFixedT(null, this.options.nsMode === 'fallback' ? this.getNamespaces() : this.getNamespaces()[0]);
	    }
	  }, {
	    key: 'getNamespaces',
	    value: function getNamespaces() {
	      var ns = this.props.ns || this.i18n.options && this.i18n.options.defaultNS;
	      return typeof ns === 'string' ? [ns] : ns;
	    }
	  }, {
	    key: 'loadNamespaces',
	    value: function loadNamespaces() {
	      var _this3 = this;
	
	      var bind = function bind() {
	        if (_this3.options.bindI18n && _this3.i18n) _this3.i18n.on(_this3.options.bindI18n, _this3.onI18nChanged);
	        if (_this3.options.bindStore && _this3.i18n.store) _this3.i18n.store.on(_this3.options.bindStore, _this3.onI18nChanged);
	      };
	
	      this.mounted = true;
	      this.i18n.loadNamespaces(this.getNamespaces(), function () {
	        var ready = function ready() {
	          if (_this3.mounted && !_this3.state.ready) _this3.setState({ ready: true });
	          if (_this3.options.wait && _this3.mounted) bind();
	        };
	
	        if (_this3.i18n.isInitialized) {
	          ready();
	        } else {
	          var initialized = function initialized() {
	            // due to emitter removing issue in i18next we need to delay remove
	            setTimeout(function () {
	              _this3.i18n.off('initialized', initialized);
	            }, 1000);
	            ready();
	          };
	
	          _this3.i18n.on('initialized', initialized);
	        }
	      });
	
	      if (!this.options.wait) bind();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var children = this.props.children;
	      var ready = this.state.ready;
	
	
	      if (!ready && this.options.wait) return null;
	
	      // remove ssr flag set by provider - first render was done from now on wait if set to wait
	      if (this.i18n.options && this.i18n.options.isInitialSSR && !removedIsInitialSSR) {
	        removedIsInitialSSR = true;
	        setTimeout(function () {
	          delete _this4.i18n.options.isInitialSSR;
	        }, 100);
	      }
	
	      return children(this.t, {
	        i18n: this.i18n,
	        t: this.t,
	        lng: this.i18n.language,
	        ready: ready
	      });
	    }
	  }]);
	
	  return I18n;
	}(_react.Component);
	
	exports.default = I18n;
	
	
	I18n.contextTypes = {
	  i18n: _propTypes2.default.object
	};
	
	I18n.childContextTypes = {
	  t: _propTypes2.default.func.isRequired,
	  i18n: _propTypes2.default.object
	};

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var I18nextProvider = function (_Component) {
	  _inherits(I18nextProvider, _Component);
	
	  function I18nextProvider(props, context) {
	    _classCallCheck(this, I18nextProvider);
	
	    var _this = _possibleConstructorReturn(this, (I18nextProvider.__proto__ || Object.getPrototypeOf(I18nextProvider)).call(this, props, context));
	
	    _this.i18n = props.i18n;
	    _this.defaultNS = props.defaultNS;
	    if (props.initialI18nStore) {
	      _this.i18n.services.resourceStore.data = props.initialI18nStore;
	      _this.i18n.options.isInitialSSR = true; // if set will be deleted on first render in translate hoc
	    }
	    if (props.initialLanguage) {
	      _this.i18n.changeLanguage(props.initialLanguage);
	    }
	    _this.reportNS = props.reportNS;
	    return _this;
	  }
	
	  _createClass(I18nextProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        i18n: this.i18n,
	        defaultNS: this.defaultNS,
	        reportNS: this.reportNS
	      };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.i18n !== nextProps.i18n) {
	        throw new Error('[react-i18next][I18nextProvider]does not support changing the i18n object.');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	      return _react.Children.only(children);
	    }
	  }]);
	
	  return I18nextProvider;
	}(_react.Component);
	
	I18nextProvider.propTypes = {
	  i18n: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.element.isRequired,
	  defaultNS: _propTypes2.default.string,
	  reportNS: _propTypes2.default.func
	};
	
	I18nextProvider.childContextTypes = {
	  i18n: _propTypes2.default.object.isRequired,
	  defaultNS: _propTypes2.default.string,
	  reportNS: _propTypes2.default.func
	};
	
	I18nextProvider.defaultProps = {
	  defaultNS: undefined,
	  reportNS: undefined
	};
	
	exports.default = I18nextProvider;

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Interpolate = function (_Component) {
	  _inherits(Interpolate, _Component);
	
	  function Interpolate(props, context) {
	    _classCallCheck(this, Interpolate);
	
	    var _this = _possibleConstructorReturn(this, (Interpolate.__proto__ || Object.getPrototypeOf(Interpolate)).call(this, props, context));
	
	    _this.i18n = props.i18n || context.i18n;
	    _this.t = props.t || context.t;
	    return _this;
	  }
	
	  _createClass(Interpolate, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var parent = this.props.parent || 'span';
	      var REGEXP = this.props.regexp || this.i18n.services.interpolator.regexp;
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style;
	
	      // Set to true if you want to use raw HTML in translation values
	      // See https://github.com/i18next/react-i18next/issues/189
	
	      var useDangerouslySetInnerHTML = this.props.useDangerouslySetInnerHTML || false;
	      var dangerouslySetInnerHTMLPartElement = this.props.dangerouslySetInnerHTMLPartElement || 'span';
	
	      var tOpts = _extends({}, this.props.options, { interpolation: { prefix: '#$?', suffix: '?$#' } });
	      var format = this.t(this.props.i18nKey, tOpts);
	
	      if (!format || typeof format !== 'string') return _react2.default.createElement('noscript', null);
	
	      var children = [];
	
	      var handleFormat = function handleFormat(key, props) {
	        if (key.indexOf(_this2.i18n.options.interpolation.formatSeparator) < 0) {
	          if (props[key] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + key + ' for interpolating ' + format);
	          return props[key];
	        }
	
	        var p = key.split(_this2.i18n.options.interpolation.formatSeparator);
	        var k = p.shift().trim();
	        var f = p.join(_this2.i18n.options.interpolation.formatSeparator).trim();
	
	        if (props[k] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + k + ' for interpolating ' + format);
	        return _this2.i18n.options.interpolation.format(props[k], f, _this2.i18n.language);
	      };
	
	      format.split(REGEXP).reduce(function (memo, match, index) {
	        var child = void 0;
	
	        if (index % 2 === 0) {
	          if (match.length === 0) return memo;
	          if (useDangerouslySetInnerHTML) {
	            child = _react2.default.createElement(dangerouslySetInnerHTMLPartElement, { dangerouslySetInnerHTML: { __html: match } });
	          } else {
	            child = match;
	          }
	        } else {
	          child = handleFormat(match, _this2.props);
	        }
	
	        memo.push(child);
	        return memo;
	      }, children);
	
	      var additionalProps = {};
	      if (this.i18n.options.react && this.i18n.options.react.exposeNamespace) {
	        var ns = typeof this.t.ns === 'string' ? this.t.ns : this.t.ns[0];
	        if (this.props.i18nKey && this.i18n.options.nsSeparator && this.props.i18nKey.indexOf(this.i18n.options.nsSeparator) > -1) {
	          var parts = this.props.i18nKey.split(this.i18n.options.nsSeparator);
	          ns = parts[0];
	        }
	        if (this.t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
	      }
	
	      if (className) additionalProps.className = className;
	      if (style) additionalProps.style = style;
	
	      return _react2.default.createElement.apply(this, [parent, additionalProps].concat(children));
	    }
	  }]);
	
	  return Interpolate;
	}(_react.Component);
	
	Interpolate.propTypes = {
	  className: _propTypes2.default.string
	};
	
	Interpolate.defaultProps = {
	  className: ''
	};
	
	Interpolate.contextTypes = {
	  i18n: _propTypes2.default.object.isRequired,
	  t: _propTypes2.default.func.isRequired
	};
	
	exports.default = Interpolate;

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _htmlParseStringify = __webpack_require__(82);
	
	var _htmlParseStringify2 = _interopRequireDefault(_htmlParseStringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function hasChildren(node) {
	  return node && (node.children || node.props && node.props.children);
	}
	
	function getChildren(node) {
	  return node && node.children ? node.children : node.props && node.props.children;
	}
	
	function nodesToString(mem, children, index) {
	  if (!children) return '';
	  if (Object.prototype.toString.call(children) !== '[object Array]') children = [children];
	
	  children.forEach(function (child, i) {
	    // const isElement = React.isValidElement(child);
	    // const elementKey = `${index !== 0 ? index + '-' : ''}${i}:${typeof child.type === 'function' ? child.type.name : child.type || 'var'}`;
	    var elementKey = '' + i;
	
	    if (typeof child === 'string') {
	      mem = '' + mem + child;
	    } else if (hasChildren(child)) {
	      mem = mem + '<' + elementKey + '>' + nodesToString('', getChildren(child), i + 1) + '</' + elementKey + '>';
	    } else if (_react2.default.isValidElement(child)) {
	      mem = mem + '<' + elementKey + '></' + elementKey + '>';
	    } else if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object') {
	      var clone = _extends({}, child);
	      var format = clone.format;
	      delete clone.format;
	
	      var keys = Object.keys(clone);
	      if (format && keys.length === 1) {
	        mem = mem + '<' + elementKey + '>{{' + keys[0] + ', ' + format + '}}</' + elementKey + '>';
	      } else if (keys.length === 1) {
	        mem = mem + '<' + elementKey + '>{{' + keys[0] + '}}</' + elementKey + '>';
	      } else if (console && console.warn) {
	        // not a valid interpolation object (can only contain one value plus format)
	        console.warn('react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.', child);
	      }
	    } else if (console && console.warn) {
	      console.warn('react-i18next: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.', child);
	    }
	  });
	
	  return mem;
	}
	
	function renderNodes(children, targetString, i18n) {
	  if (targetString === "") return [];
	  if (!children) return [targetString];
	
	  // parse ast from string with additional wrapper tag
	  // -> avoids issues in parser removing prepending text nodes
	  var ast = _htmlParseStringify2.default.parse('<0>' + targetString + '</0>');
	
	  function mapAST(reactNodes, astNodes) {
	    if (Object.prototype.toString.call(reactNodes) !== '[object Array]') reactNodes = [reactNodes];
	    if (Object.prototype.toString.call(astNodes) !== '[object Array]') astNodes = [astNodes];
	
	    return astNodes.reduce(function (mem, node, i) {
	      if (node.type === 'tag') {
	        var child = reactNodes[parseInt(node.name, 10)] || {};
	        var isElement = _react2.default.isValidElement(child);
	
	        if (typeof child === 'string') {
	          mem.push(child);
	        } else if (hasChildren(child)) {
	          var inner = mapAST(getChildren(child), node.children);
	          if (child.dummy) child.children = inner; // needed on preact!
	          mem.push(_react2.default.cloneElement(child, _extends({}, child.props, { key: i }), inner));
	        } else if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object' && !isElement) {
	          var content = node.children[0] ? node.children[0].content : null;
	          if (content) {
	            var interpolated = i18n.services.interpolator.interpolate(node.children[0].content, child, i18n.language);
	            mem.push(interpolated);
	          }
	        } else {
	          mem.push(child);
	        }
	      } else if (node.type === 'text') {
	        mem.push(node.content);
	      }
	      return mem;
	    }, []);
	  }
	
	  // call mapAST with having react nodes nested into additional node like
	  // we did for the string ast from translation
	  // return the children of that extra node to get expected result
	  var result = mapAST([{ dummy: true, children: children }], ast);
	  return getChildren(result[0]);
	}
	
	var Trans = function (_React$Component) {
	  _inherits(Trans, _React$Component);
	
	  function Trans() {
	    _classCallCheck(this, Trans);
	
	    return _possibleConstructorReturn(this, (Trans.__proto__ || Object.getPrototypeOf(Trans)).apply(this, arguments));
	  }
	
	  _createClass(Trans, [{
	    key: 'render',
	    value: function render() {
	      var contextAndProps = _extends({ i18n: this.context.i18n, t: this.context.t }, this.props);
	
	      var children = contextAndProps.children,
	          count = contextAndProps.count,
	          parent = contextAndProps.parent,
	          i18nKey = contextAndProps.i18nKey,
	          tOptions = contextAndProps.tOptions,
	          values = contextAndProps.values,
	          defaults = contextAndProps.defaults,
	          components = contextAndProps.components,
	          namespace = contextAndProps.ns,
	          i18n = contextAndProps.i18n,
	          tFromContextAndProps = contextAndProps.t,
	          additionalProps = _objectWithoutProperties(contextAndProps, ['children', 'count', 'parent', 'i18nKey', 'tOptions', 'values', 'defaults', 'components', 'ns', 'i18n', 't']);
	
	      var t = tFromContextAndProps || i18n.t.bind(i18n);
	
	      var reactI18nextOptions = i18n.options && i18n.options.react || {};
	      var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
	
	      var defaultValue = defaults || nodesToString('', children, 0);
	      var hashTransKey = reactI18nextOptions.hashTransKey;
	      var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
	      var interpolationOverride = values ? {} : { interpolation: { prefix: '#$?', suffix: '?$#' } };
	      var translation = key ? t(key, _extends({}, tOptions, values, interpolationOverride, { defaultValue: defaultValue, count: count, ns: namespace })) : defaultValue;
	
	      if (reactI18nextOptions.exposeNamespace) {
	        var ns = typeof t.ns === 'string' ? t.ns : t.ns[0];
	        if (i18nKey && i18n.options && i18n.options.nsSeparator && i18nKey.indexOf(i18n.options.nsSeparator) > -1) {
	          var parts = i18nKey.split(i18n.options.nsSeparator);
	          ns = parts[0];
	        }
	        if (t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
	      }
	
	      if (!useAsParent) return renderNodes(components || children, translation, i18n);
	
	      return _react2.default.createElement(useAsParent, additionalProps, renderNodes(components || children, translation, i18n));
	    }
	  }]);
	
	  return Trans;
	}(_react2.default.Component);
	
	exports.default = Trans;
	
	
	Trans.propTypes = {
	  count: _propTypes2.default.number,
	  parent: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  i18nKey: _propTypes2.default.string,
	  i18n: _propTypes2.default.object,
	  t: _propTypes2.default.func
	};
	
	// Trans.defaultProps = {
	//   parent: 'div'
	// };
	
	Trans.contextTypes = {
	  i18n: _propTypes2.default.object,
	  t: _propTypes2.default.func
	};

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.setDefaults = setDefaults;
	exports.getDefaults = getDefaults;
	exports.setI18n = setI18n;
	exports.getI18n = getI18n;
	var defaultOptions = {
	  wait: false,
	  withRef: false,
	  bindI18n: 'languageChanged loaded',
	  bindStore: 'added removed',
	  translateFuncName: 't',
	  nsMode: 'default',
	  usePureComponent: false,
	  omitBoundRerender: true
	};
	
	var i18n = void 0;
	
	function setDefaults(options) {
	  defaultOptions = _extends({}, defaultOptions, options);
	}
	
	function getDefaults() {
	  return defaultOptions;
	}
	
	function setI18n(instance) {
	  i18n = instance;
	}
	
	function getI18n() {
	  return i18n;
	}
	
	var reactI18nextModule = exports.reactI18nextModule = {
	  type: '3rdParty',
	
	  init: function init(instance) {
	    setDefaults(instance.options.react);
	    setI18n(instance);
	  }
	};

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _translate = __webpack_require__(94);
	
	Object.defineProperty(exports, 'translate', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_translate).default;
	  }
	});
	
	var _I18n = __webpack_require__(48);
	
	Object.defineProperty(exports, 'I18n', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_I18n).default;
	  }
	});
	
	var _Interpolate = __webpack_require__(90);
	
	Object.defineProperty(exports, 'Interpolate', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Interpolate).default;
	  }
	});
	
	var _Trans = __webpack_require__(91);
	
	Object.defineProperty(exports, 'Trans', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Trans).default;
	  }
	});
	
	var _I18nextProvider = __webpack_require__(89);
	
	Object.defineProperty(exports, 'I18nextProvider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_I18nextProvider).default;
	  }
	});
	
	var _loadNamespaces = __webpack_require__(92);
	
	Object.defineProperty(exports, 'loadNamespaces', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_loadNamespaces).default;
	  }
	});
	
	var _context = __webpack_require__(31);
	
	Object.defineProperty(exports, 'reactI18nextModule', {
	  enumerable: true,
	  get: function get() {
	    return _context.reactI18nextModule;
	  }
	});
	Object.defineProperty(exports, 'setDefaults', {
	  enumerable: true,
	  get: function get() {
	    return _context.setDefaults;
	  }
	});
	Object.defineProperty(exports, 'getDefaults', {
	  enumerable: true,
	  get: function get() {
	    return _context.getDefaults;
	  }
	});
	Object.defineProperty(exports, 'setI18n', {
	  enumerable: true,
	  get: function get() {
	    return _context.setI18n;
	  }
	});
	Object.defineProperty(exports, 'getI18n', {
	  enumerable: true,
	  get: function get() {
	    return _context.getI18n;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = loadNamespaces;
	var objectEntries = Object.entries || function (obj) {
	  var ownProps = Object.keys(obj),
	      i = ownProps.length,
	      resArray = new Array(i); // preallocate the Array
	  while (i--) {
	    resArray[i] = [ownProps[i], obj[ownProps[i]]];
	  }return resArray;
	};
	
	// Borrowed from https://github.com/Rezonans/redux-async-connect/blob/master/modules/ReduxAsyncConnect.js#L16
	function eachComponents(components, iterator) {
	  for (var i = 0, l = components.length; i < l; i++) {
	    // eslint-disable-line id-length
	    if (_typeof(components[i]) === 'object') {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = objectEntries(components[i])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = _slicedToArray(_step.value, 2),
	              key = _step$value[0],
	              value = _step$value[1];
	
	          iterator(value, i, key);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    } else {
	      iterator(components[i], i);
	    }
	  }
	}
	
	function filterAndFlattenComponents(components) {
	  var flattened = [];
	  eachComponents(components, function (Component) {
	    if (Component && Component.namespaces) {
	
	      Component.namespaces.forEach(function (namespace) {
	        if (flattened.indexOf(namespace) === -1) {
	          flattened.push(namespace);
	        }
	      });
	    }
	  });
	  return flattened;
	}
	
	function loadNamespaces(_ref) {
	  var components = _ref.components,
	      i18n = _ref.i18n;
	
	  var allNamespaces = filterAndFlattenComponents(components);
	
	  return new Promise(function (resolve) {
	    i18n.loadNamespaces(allNamespaces, resolve);
	  });
	}

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = shallowEqual;
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	/* eslint-disable no-self-compare */
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  }
	  // Step 6.a: NaN == NaN
	  return x !== x && y !== y;
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = translate;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(60);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _shallowEqual = __webpack_require__(93);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _context = __webpack_require__(31);
	
	var _I18n = __webpack_require__(48);
	
	var _I18n2 = _interopRequireDefault(_I18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getDisplayName(component) {
	  return component.displayName || component.name || 'Component';
	}
	
	function translate(namespaceArg) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	  return function Wrapper(WrappedComponent) {
	    var Translate = function (_Component) {
	      _inherits(Translate, _Component);
	
	      function Translate(props, context) {
	        _classCallCheck(this, Translate);
	
	        var _this = _possibleConstructorReturn(this, (Translate.__proto__ || Object.getPrototypeOf(Translate)).call(this, props, context));
	
	        _this.i18n = props.i18n || options.i18n || context.i18n || (0, _context.getI18n)();
	        _this.namespaces = typeof namespaceArg === 'function' ? namespaceArg(props) : namespaceArg || context.defaultNS || _this.i18n.options && _this.i18n.options.defaultNS;
	        if (typeof _this.namespaces === 'string') _this.namespaces = [_this.namespaces];
	
	        var i18nOptions = _this.i18n && _this.i18n.options && _this.i18n.options.react || {};
	        _this.options = _extends({}, (0, _context.getDefaults)(), i18nOptions, options);
	
	        if (context.reportNS) {
	          var namespaces = _this.namespaces || [undefined];
	          namespaces.forEach(context.reportNS);
	        }
	
	        _this.getWrappedInstance = _this.getWrappedInstance.bind(_this);
	        return _this;
	      }
	
	      _createClass(Translate, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	          if (!this.options.usePureComponent) {
	            return true;
	          }
	
	          return !(0, _shallowEqual2.default)(this.props, nextProps);
	        }
	      }, {
	        key: 'getWrappedInstance',
	        value: function getWrappedInstance() {
	          if (!this.options.withRef) {
	            // eslint-disable-next-line no-console
	            console.error('To access the wrapped instance, you need to specify ' + '{ withRef: true } as the second argument of the translate() call.');
	          }
	
	          /* eslint react/no-string-refs: 1 */
	          return this.wrappedInstance;
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _this2 = this;
	
	          var extraProps = {};
	
	          if (this.options.withRef) {
	            extraProps.ref = function (c) {
	              _this2.wrappedInstance = c;
	            };
	          }
	
	          return _react2.default.createElement(_I18n2.default, _extends({ ns: this.namespaces }, this.options, this.props, { i18n: this.i18n }), function (t, _ref) {
	            var ready = _ref.ready,
	                context = _objectWithoutProperties(_ref, ['ready']);
	
	            return _react2.default.createElement(WrappedComponent, _extends({
	              tReady: ready
	            }, _this2.props, extraProps, context));
	          });
	        }
	      }]);
	
	      return Translate;
	    }(_react.Component);
	
	    Translate.WrappedComponent = WrappedComponent;
	
	    Translate.contextTypes = {
	      i18n: _propTypes2.default.object,
	      defaultNS: _propTypes2.default.string,
	      reportNS: _propTypes2.default.func
	    };
	
	    Translate.displayName = 'Translate(' + getDisplayName(WrappedComponent) + ')';
	
	    Translate.namespaces = namespaceArg;
	
	    return (0, _hoistNonReactStatics2.default)(Translate, WrappedComponent);
	  };
	}
	
	translate.setDefaults = _context.setDefaults;
	
	translate.setI18n = _context.setI18n;

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

	/** @license React v16.7.0
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
	60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
	exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
	exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
	exports.isSuspense=function(a){return t(a)===p};


/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(95);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, module) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hyphenate = _interopDefault(__webpack_require__(134));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var Stylis = _interopDefault(__webpack_require__(98));
	var _insertRulePlugin = _interopDefault(__webpack_require__(97));
	var PropTypes = _interopDefault(__webpack_require__(6));
	var hoistStatics = _interopDefault(__webpack_require__(60));
	var reactIs = __webpack_require__(96);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	// 
	var isPlainObject = (function (x) {
	  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
	});
	
	// 
	
	
	/**
	 * Parse errors.md and turn it into a simple hash of code: message
	 */
	var ERRORS =  false ? {
	  "1": "Cannot create styled-component for component: %s.\n\n",
	  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
	  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
	  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
	  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
	  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
	  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
	  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
	  "9": "Missing document `<head>`\n\n",
	  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
	  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
	} : {};
	
	/**
	 * super basic version of sprintf
	 */
	function format() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var a = args[0];
	  var b = [];
	  var c = void 0;
	
	  for (c = 1; c < args.length; c += 1) {
	    b.push(args[c]);
	  }
	
	  b.forEach(function (d) {
	    a = a.replace(/%[a-z]/, d);
	  });
	
	  return a;
	}
	
	/**
	 * Create an error file out of errors.md for development and a simple web link to the full errors
	 * in production mode.
	 */
	
	var StyledComponentsError = function (_Error) {
	  inherits(StyledComponentsError, _Error);
	
	  function StyledComponentsError(code) {
	    classCallCheck(this, StyledComponentsError);
	
	    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      interpolations[_key2 - 1] = arguments[_key2];
	    }
	
	    if (true) {
	      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
	    } else {
	      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
	    }
	    return possibleConstructorReturn(_this);
	  }
	
	  return StyledComponentsError;
	}(Error);
	
	// 
	
	var objToCss = function objToCss(obj, prevKey) {
	  var css = Object.keys(obj).filter(function (key) {
	    var chunk = obj[key];
	    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
	  }).map(function (key) {
	    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
	    return hyphenate(key) + ': ' + obj[key] + ';';
	  }).join(' ');
	  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
	};
	
	var flatten = function flatten(chunks, executionContext) {
	  return chunks.reduce(function (ruleSet, chunk) {
	    /* Remove falsey values */
	    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
	      return ruleSet;
	    }
	
	    /* Flatten ruleSet */
	    if (Array.isArray(chunk)) {
	      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
	      return ruleSet;
	    }
	
	    /* Handle other components */
	    if (chunk.hasOwnProperty('styledComponentId')) {
	      // $FlowFixMe not sure how to make this pass
	      ruleSet.push('.' + chunk.styledComponentId);
	      return ruleSet;
	    }
	
	    /* Either execute or defer the function */
	    if (typeof chunk === 'function') {
	      if (executionContext) {
	        var nextChunk = chunk(executionContext);
	        /* Throw if a React Element was given styles */
	        if (React__default.isValidElement(nextChunk)) {
	          var elementName = chunk.displayName || chunk.name;
	          throw new StyledComponentsError(11, elementName);
	        }
	        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
	      } else ruleSet.push(chunk);
	
	      return ruleSet;
	    }
	
	    /* Handle objects */
	    ruleSet.push(
	    // $FlowFixMe have to add %checks somehow to isPlainObject
	    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());
	
	    return ruleSet;
	  }, []);
	};
	
	// 
	
	var COMMENT_REGEX = /^\s*\/\/.*$/gm;
	
	// NOTE: This stylis instance is only used to split rules from SSR'd style tags
	var stylisSplitter = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: false,
	  compress: false,
	  semicolon: true
	});
	
	var stylis = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: true,
	  compress: false,
	  semicolon: false // NOTE: This means "autocomplete missing semicolons"
	});
	
	// Wrap `insertRulePlugin to build a list of rules,
	// and then make our own plugin to return the rules. This
	// makes it easier to hook into the existing SSR architecture
	
	var parsingRules = [];
	// eslint-disable-next-line consistent-return
	var returnRulesPlugin = function returnRulesPlugin(context) {
	  if (context === -2) {
	    var parsedRules = parsingRules;
	    parsingRules = [];
	    return parsedRules;
	  }
	};
	
	var parseRulesPlugin = _insertRulePlugin(function (rule) {
	  parsingRules.push(rule);
	});
	
	stylis.use([parseRulesPlugin, returnRulesPlugin]);
	stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);
	
	var stringifyRules = function stringifyRules(rules, selector, prefix) {
	  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments
	
	  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
	
	  return stylis(prefix || !selector ? '' : selector, cssStr);
	};
	
	var splitByRules = function splitByRules(css) {
	  return stylisSplitter('', css);
	};
	
	// 
	
	function isStyledComponent(target) /* : %checks */{
	  return (
	    // $FlowFixMe TODO: flow for styledComponentId
	    typeof target === 'function' && typeof target.styledComponentId === 'string'
	  );
	}
	
	// 
	
	/* This function is DEPRECATED and will be removed on the next major version release.
	 * It was needed to rehydrate all style blocks prepended to chunks before React
	 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
	 * the use of streamed style tags and will perform the rehydration earlier when needed
	 * this function will not be needed anymore */
	function consolidateStreamedStyles() {
	  if (false) {
	    // eslint-disable-next-line no-console
	    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
	  }
	}
	
	// 
	/* eslint-disable no-bitwise */
	
	/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
	 * counterparts */
	var charsLength = 52;
	
	/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
	var getAlphabeticChar = function getAlphabeticChar(code) {
	  return String.fromCharCode(code + (code > 25 ? 39 : 97));
	};
	
	/* input a number, usually a hash and convert it to base-52 */
	var generateAlphabeticName = function generateAlphabeticName(code) {
	  var name = '';
	  var x = void 0;
	
	  /* get a char and divide by alphabet-length */
	  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
	    name = getAlphabeticChar(x % charsLength) + name;
	  }
	
	  return getAlphabeticChar(x % charsLength) + name;
	};
	
	// 
	
	var interleave = (function (strings, interpolations) {
	  var result = [strings[0]];
	
	  for (var i = 0, len = interpolations.length; i < len; i += 1) {
	    result.push(interpolations[i], strings[i + 1]);
	  }
	
	  return result;
	});
	
	// 
	var EMPTY_ARRAY = Object.freeze([]);
	var EMPTY_OBJECT = Object.freeze({});
	
	// 
	
	var css = (function (styles) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  if (typeof styles === 'function' || isPlainObject(styles)) {
	    // $FlowFixMe
	    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
	  }
	
	  // $FlowFixMe
	  return flatten(interleave(styles, interpolations));
	});
	
	// 
	
	
	var SC_ATTR = typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_DIR":"/opt/atlassian/pipelines/agent/build/public"}).SC_ATTR || 'data-styled-components';
	var SC_STREAM_ATTR = 'data-styled-streamed';
	var CONTEXT_KEY = '__styled-components-stylesheet__';
	
	var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
	
	var DISABLE_SPEEDY = ("production") !== 'production';
	
	// 
	var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
	
	var extractComps = (function (maybeCSS) {
	  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
	  var existingComponents = [];
	  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
	    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
	    return match;
	  });
	  return existingComponents.map(function (_ref, i) {
	    var componentId = _ref.componentId,
	        matchIndex = _ref.matchIndex;
	
	    var nextComp = existingComponents[i + 1];
	    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
	    return { componentId: componentId, cssFromDOM: cssFromDOM };
	  });
	});
	
	// 
	/* eslint-disable camelcase, no-undef */
	
	var getNonce = (function () {
	  return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
	});
	
	// 
	// Helper to call a given function, only once
	var once = (function (cb) {
	  var called = false;
	
	  return function () {
	    if (!called) {
	      called = true;
	      cb();
	    }
	  };
	});
	
	// 
	/* These are helpers for the StyleTags to keep track of the injected
	 * rule names for each (component) ID that they're keeping track of.
	 * They're crucial for detecting whether a name has already been
	 * injected.
	 * (This excludes rehydrated names) */
	
	/* adds a new ID:name pairing to a names dictionary */
	var addNameForId = function addNameForId(names, id, name) {
	  if (name) {
	    // eslint-disable-next-line no-param-reassign
	    var namesForId = names[id] || (names[id] = Object.create(null));
	    namesForId[name] = true;
	  }
	};
	
	/* resets an ID entirely by overwriting it in the dictionary */
	var resetIdNames = function resetIdNames(names, id) {
	  // eslint-disable-next-line no-param-reassign
	  names[id] = Object.create(null);
	};
	
	/* factory for a names dictionary checking the existance of an ID:name pairing */
	var hasNameForId = function hasNameForId(names) {
	  return function (id, name) {
	    return names[id] !== undefined && names[id][name];
	  };
	};
	
	/* stringifies names for the html/element output */
	var stringifyNames = function stringifyNames(names) {
	  var str = '';
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    str += Object.keys(names[id]).join(' ') + ' ';
	  }
	  return str.trim();
	};
	
	/* clones the nested names dictionary */
	var cloneNames = function cloneNames(names) {
	  var clone = Object.create(null);
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    clone[id] = _extends({}, names[id]);
	  }
	  return clone;
	};
	
	// 
	
	/* These are helpers that deal with the insertRule (aka speedy) API
	 * They are used in the StyleTags and specifically the speedy tag
	 */
	
	/* retrieve a sheet for a given style tag */
	var sheetForTag = function sheetForTag(tag) {
	  // $FlowFixMe
	  if (tag.sheet) return tag.sheet;
	
	  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
	  var size = document.styleSheets.length;
	  for (var i = 0; i < size; i += 1) {
	    var sheet = document.styleSheets[i];
	    // $FlowFixMe
	    if (sheet.ownerNode === tag) return sheet;
	  }
	
	  /* we should always be able to find a tag */
	  throw new StyledComponentsError(10);
	};
	
	/* insert a rule safely and return whether it was actually injected */
	var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
	  /* abort early if cssRule string is falsy */
	  if (!cssRule) return false;
	
	  var maxIndex = sheet.cssRules.length;
	
	  try {
	    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
	    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
	  } catch (err) {
	    /* any error indicates an invalid rule */
	    return false;
	  }
	
	  return true;
	};
	
	/* deletes `size` rules starting from `removalIndex` */
	var deleteRules = function deleteRules(sheet, removalIndex, size) {
	  var lowerBound = removalIndex - size;
	  for (var i = removalIndex; i > lowerBound; i -= 1) {
	    sheet.deleteRule(i);
	  }
	};
	
	// 
	
	/* this marker separates component styles and is important for rehydration */
	var makeTextMarker = function makeTextMarker(id) {
	  return '\n/* sc-component-id: ' + id + ' */\n';
	};
	
	/* add up all numbers in array up until and including the index */
	var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
	  var totalUpToIndex = 0;
	  for (var i = 0; i <= index; i += 1) {
	    totalUpToIndex += sizes[i];
	  }
	
	  return totalUpToIndex;
	};
	
	/* create a new style tag after lastEl */
	var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
	  var el = document.createElement('style');
	  el.setAttribute(SC_ATTR, '');
	
	  var nonce = getNonce();
	  if (nonce) {
	    el.setAttribute('nonce', nonce);
	  }
	
	  /* Work around insertRule quirk in EdgeHTML */
	  el.appendChild(document.createTextNode(''));
	
	  if (target && !tagEl) {
	    /* Append to target when no previous element was passed */
	    target.appendChild(el);
	  } else {
	    if (!tagEl || !target || !tagEl.parentNode) {
	      throw new StyledComponentsError(6);
	    }
	
	    /* Insert new style tag after the previous one */
	    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
	  }
	
	  return el;
	};
	
	/* takes a css factory function and outputs an html styled tag factory */
	var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
	  return function (additionalAttrs) {
	    var nonce = getNonce();
	    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];
	
	    var htmlAttr = attrs.filter(Boolean).join(' ');
	    return '<style ' + htmlAttr + '>' + css() + '</style>';
	  };
	};
	
	/* takes a css factory function and outputs an element factory */
	var wrapAsElement = function wrapAsElement(css, names) {
	  return function () {
	    var _props;
	
	    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);
	
	    var nonce = getNonce();
	    if (nonce) {
	      // $FlowFixMe
	      props.nonce = nonce;
	    }
	
	    // eslint-disable-next-line react/no-danger
	    return React__default.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
	  };
	};
	
	var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
	  return function () {
	    return Object.keys(markers);
	  };
	};
	
	/* speedy tags utilise insertRule */
	var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	  var sizes = [];
	
	  var extractImport = getImportRuleTag !== undefined;
	  /* indicates whther getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = sizes.length;
	    sizes.push(0);
	    resetIdNames(names, id);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var sheet = sheetForTag(el);
	    var insertIndex = addUpUntilIndex(sizes, marker);
	
	    var injectedRules = 0;
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var cssRule = cssRules[i];
	      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
	      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
	        importRules.push(cssRule);
	      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
	        mayHaveImport = false;
	        injectedRules += 1;
	      }
	    }
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	
	    sizes[marker] += injectedRules; /* add up no of injected rules */
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	
	    var size = sizes[marker];
	    var sheet = sheetForTag(el);
	    var removalIndex = addUpUntilIndex(sizes, marker);
	    deleteRules(sheet, removalIndex, size);
	    sizes[marker] = 0;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var _sheetForTag = sheetForTag(el),
	        cssRules = _sheetForTag.cssRules;
	
	    var str = '';
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += makeTextMarker(id);
	      var marker = markers[id];
	      var end = addUpUntilIndex(sizes, marker);
	      var size = sizes[marker];
	      for (var i = end - size; i < end; i += 1) {
	        var rule = cssRules[i];
	        if (rule !== undefined) {
	          str += rule.cssText;
	        }
	      }
	    }
	
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeTextNode = function makeTextNode(id) {
	  return document.createTextNode(makeTextMarker(id));
	};
	
	var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	
	  var extractImport = getImportRuleTag !== undefined;
	
	  /* indicates whther getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = makeTextNode(id);
	    el.appendChild(markers[id]);
	    names[id] = Object.create(null);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var rule = cssRules[i];
	      var mayHaveImport = extractImport;
	      if (mayHaveImport && rule.indexOf('@import') !== -1) {
	        importRules.push(rule);
	      } else {
	        mayHaveImport = false;
	        var separator = i === cssRulesSize - 1 ? '' : ' ';
	        marker.appendData('' + rule + separator);
	      }
	    }
	
	    addNameForId(names, id, name);
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	
	    /* create new empty text node and replace the current one */
	    var newMarker = makeTextNode(id);
	    el.replaceChild(newMarker, marker);
	    markers[id] = newMarker;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var str = '';
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += markers[id].data;
	    }
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
	  var names = namesArg === undefined ? Object.create(null) : namesArg;
	  var markers = markersArg === undefined ? Object.create(null) : markersArg;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    return markers[id] = [''];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    marker[0] += cssRules.join(' ');
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	    marker[0] = '';
	    resetIdNames(names, id);
	  };
	
	  var css = function css() {
	    var str = '';
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      var cssForId = markers[id][0];
	      if (cssForId) {
	        str += makeTextMarker(id) + cssForId;
	      }
	    }
	    return str;
	  };
	
	  var clone = function clone() {
	    var namesClone = cloneNames(names);
	    var markersClone = Object.create(null);
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      markersClone[id] = [markers[id][0]];
	    }
	
	    return makeServerTagInternal(namesClone, markersClone);
	  };
	
	  var tag = {
	    clone: clone,
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: null,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	
	  return tag;
	};
	
	var makeServerTag = function makeServerTag() {
	  return makeServerTagInternal();
	};
	
	var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
	  if (IS_BROWSER && !forceServer) {
	    var el = makeStyleTag(target, tagEl, insertBefore);
	
	    if (DISABLE_SPEEDY) {
	      return makeBrowserTag(el, getImportRuleTag);
	    } else {
	      return makeSpeedyTag(el, getImportRuleTag);
	    }
	  }
	
	  return makeServerTag();
	};
	
	/* wraps a given tag so that rehydration is performed once when necessary */
	var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
	  /* rehydration function that adds all rules to the new tag */
	  var rehydrate = once(function () {
	    /* add all extracted components to the new tag */
	    for (var i = 0, len = extracted.length; i < len; i += 1) {
	      var _extracted$i = extracted[i],
	          componentId = _extracted$i.componentId,
	          cssFromDOM = _extracted$i.cssFromDOM;
	
	      var cssRules = splitByRules(cssFromDOM);
	      tag.insertRules(componentId, cssRules);
	    }
	
	    /* remove old HTMLStyleElements, since they have been rehydrated */
	    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
	      var el = els[_i];
	      if (el.parentNode) {
	        el.parentNode.removeChild(el);
	      }
	    }
	  });
	
	  if (immediateRehydration) rehydrate();
	
	  return _extends({}, tag, {
	    /* add rehydration hook to insertion methods */
	    insertMarker: function insertMarker(id) {
	      rehydrate();
	      return tag.insertMarker(id);
	    },
	    insertRules: function insertRules(id, cssRules, name) {
	      rehydrate();
	      return tag.insertRules(id, cssRules, name);
	    }
	  });
	};
	
	// 
	
	var SPLIT_REGEX = /\s+/;
	
	/* determine the maximum number of components before tags are sharded */
	var MAX_SIZE = void 0;
	if (IS_BROWSER) {
	  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
	  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
	} else {
	  /* for servers we do not need to shard at all */
	  MAX_SIZE = -1;
	}
	
	var sheetRunningId = 0;
	var master = void 0;
	
	var StyleSheet = function () {
	  /* a map from ids to tags */
	  /* deferred rules for a given id */
	  /* this is used for not reinjecting rules via hasNameForId() */
	  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
	  /* a list of tags belonging to this StyleSheet */
	  /* a tag for import rules */
	  /* current capacity until a new tag must be created */
	  /* children (aka clones) of this StyleSheet inheriting all and future injections */
	
	  function StyleSheet() {
	    var _this = this;
	
	    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
	    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    classCallCheck(this, StyleSheet);
	
	    this.getImportRuleTag = function () {
	      var importRuleTag = _this.importRuleTag;
	
	      if (importRuleTag !== undefined) {
	        return importRuleTag;
	      }
	
	      var firstTag = _this.tags[0];
	      var insertBefore = true;
	
	      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
	    };
	
	    sheetRunningId += 1;
	    this.id = sheetRunningId;
	    this.forceServer = forceServer;
	    this.target = forceServer ? null : target;
	    this.tagMap = {};
	    this.deferred = {};
	    this.rehydratedNames = {};
	    this.ignoreRehydratedNames = {};
	    this.tags = [];
	    this.capacity = 1;
	    this.clones = [];
	  }
	
	  /* rehydrate all SSR'd style tags */
	
	
	  StyleSheet.prototype.rehydrate = function rehydrate() {
	    if (!IS_BROWSER || this.forceServer) {
	      return this;
	    }
	
	    var els = [];
	    var extracted = [];
	    var isStreamed = false;
	
	    /* retrieve all of our SSR style elements from the DOM */
	    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
	    var nodesSize = nodes.length;
	
	    /* abort rehydration if no previous style tags were found */
	    if (nodesSize === 0) {
	      return this;
	    }
	
	    for (var i = 0; i < nodesSize; i += 1) {
	      // $FlowFixMe: We can trust that all elements in this query are style elements
	      var el = nodes[i];
	
	      /* check if style tag is a streamed tag */
	      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);
	
	      /* retrieve all component names */
	      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
	      var elNamesSize = elNames.length;
	      for (var j = 0; j < elNamesSize; j += 1) {
	        var name = elNames[j];
	        /* add rehydrated name to sheet to avoid readding styles */
	        this.rehydratedNames[name] = true;
	      }
	
	      /* extract all components and their CSS */
	      extracted.push.apply(extracted, extractComps(el.textContent));
	
	      /* store original HTMLStyleElement */
	      els.push(el);
	    }
	
	    /* abort rehydration if nothing was extracted */
	    var extractedSize = extracted.length;
	    if (extractedSize === 0) {
	      return this;
	    }
	
	    /* create a tag to be used for rehydration */
	    var tag = this.makeTag(null);
	    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);
	
	    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
	    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
	    this.tags.push(rehydrationTag);
	
	    /* retrieve all component ids */
	    for (var _j = 0; _j < extractedSize; _j += 1) {
	      this.tagMap[extracted[_j].componentId] = rehydrationTag;
	    }
	
	    return this;
	  };
	
	  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
	   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
	    * StyleSheetManager's context */
	
	
	  /* reset the internal "master" instance */
	  StyleSheet.reset = function reset() {
	    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    master = new StyleSheet(undefined, forceServer).rehydrate();
	  };
	
	  /* adds "children" to the StyleSheet that inherit all of the parents' rules
	   * while their own rules do not affect the parent */
	
	
	  StyleSheet.prototype.clone = function clone() {
	    var sheet = new StyleSheet(this.target, this.forceServer);
	
	    /* add to clone array */
	    this.clones.push(sheet);
	
	    /* clone all tags */
	    sheet.tags = this.tags.map(function (tag) {
	      var ids = tag.getIds();
	      var newTag = tag.clone();
	
	      /* reconstruct tagMap */
	      for (var i = 0; i < ids.length; i += 1) {
	        sheet.tagMap[ids[i]] = newTag;
	      }
	
	      return newTag;
	    });
	
	    /* clone other maps */
	    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
	    sheet.deferred = _extends({}, this.deferred);
	
	    return sheet;
	  };
	
	  /* force StyleSheet to create a new tag on the next injection */
	
	
	  StyleSheet.prototype.sealAllTags = function sealAllTags() {
	    this.capacity = 1;
	
	    this.tags.forEach(function (tag) {
	      // eslint-disable-next-line no-param-reassign
	      tag.sealed = true;
	    });
	  };
	
	  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
	    var lastEl = tag ? tag.styleTag : null;
	    var insertBefore = false;
	
	    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
	  };
	
	  /* get a tag for a given componentId, assign the componentId to one, or shard */
	  StyleSheet.prototype.getTagForId = function getTagForId(id) {
	    /* simply return a tag, when the componentId was already assigned one */
	    var prev = this.tagMap[id];
	    if (prev !== undefined && !prev.sealed) {
	      return prev;
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
	    this.capacity -= 1;
	
	    if (this.capacity === 0) {
	      this.capacity = MAX_SIZE;
	      tag = this.makeTag(tag);
	      this.tags.push(tag);
	    }
	
	    return this.tagMap[id] = tag;
	  };
	
	  /* mainly for injectGlobal to check for its id */
	
	
	  StyleSheet.prototype.hasId = function hasId(id) {
	    return this.tagMap[id] !== undefined;
	  };
	
	  /* caching layer checking id+name to already have a corresponding tag and injected rules */
	
	
	  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
	    /* exception for rehydrated names which are checked separately */
	    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
	      return true;
	    }
	
	    var tag = this.tagMap[id];
	    return tag !== undefined && tag.hasNameForId(id, name);
	  };
	
	  /* registers a componentId and registers it on its tag */
	
	
	  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
	    /* don't inject when the id is already registered */
	    if (this.tagMap[id] !== undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].deferredInject(id, cssRules);
	    }
	
	    this.getTagForId(id).insertMarker(id);
	    this.deferred[id] = cssRules;
	  };
	
	  /* injects rules for a given id with a name that will need to be cached */
	
	
	  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
	    var clones = this.clones;
	
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].inject(id, cssRules, name);
	    }
	
	    var tag = this.getTagForId(id);
	
	    /* add deferred rules for component */
	    if (this.deferred[id] !== undefined) {
	      // Combine passed cssRules with previously deferred CSS rules
	      // NOTE: We cannot mutate the deferred array itself as all clones
	      // do the same (see clones[i].inject)
	      var rules = this.deferred[id].concat(cssRules);
	      tag.insertRules(id, rules, name);
	
	      this.deferred[id] = undefined;
	    } else {
	      tag.insertRules(id, cssRules, name);
	    }
	  };
	
	  /* removes all rules for a given id, which doesn't remove its marker but resets it */
	
	
	  StyleSheet.prototype.remove = function remove(id) {
	    var tag = this.tagMap[id];
	    if (tag === undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].remove(id);
	    }
	
	    /* remove all rules from the tag */
	    tag.removeRules(id);
	    /* ignore possible rehydrated names */
	    this.ignoreRehydratedNames[id] = true;
	    /* delete possible deferred rules */
	    this.deferred[id] = undefined;
	  };
	
	  StyleSheet.prototype.toHTML = function toHTML() {
	    return this.tags.map(function (tag) {
	      return tag.toHTML();
	    }).join('');
	  };
	
	  StyleSheet.prototype.toReactElements = function toReactElements() {
	    var id = this.id;
	
	
	    return this.tags.map(function (tag, i) {
	      var key = 'sc-' + id + '-' + i;
	      return React.cloneElement(tag.toElement(), { key: key });
	    });
	  };
	
	  createClass(StyleSheet, null, [{
	    key: 'master',
	    get: function get$$1() {
	      return master || (master = new StyleSheet().rehydrate());
	    }
	
	    /* NOTE: This is just for backwards-compatibility with jest-styled-components */
	
	  }, {
	    key: 'instance',
	    get: function get$$1() {
	      return StyleSheet.master;
	    }
	  }]);
	  return StyleSheet;
	}();
	
	var _StyleSheetManager$ch;
	
	var StyleSheetManager = function (_Component) {
	  inherits(StyleSheetManager, _Component);
	
	  function StyleSheetManager() {
	    classCallCheck(this, StyleSheetManager);
	    return possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  StyleSheetManager.prototype.getChildContext = function getChildContext() {
	    var _ref;
	
	    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
	  };
	
	  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.sheet) {
	      this.sheetInstance = this.props.sheet;
	    } else if (this.props.target) {
	      this.sheetInstance = new StyleSheet(this.props.target);
	    } else {
	      throw new StyledComponentsError(4);
	    }
	  };
	
	  StyleSheetManager.prototype.render = function render() {
	    /* eslint-disable react/prop-types */
	    // Flow v0.43.1 will report an error accessing the `children` property,
	    // but v0.47.0 will not. It is necessary to use a type cast instead of
	    // a "fixme" comment to satisfy both Flow versions.
	    return React__default.Children.only(this.props.children);
	  };
	
	  return StyleSheetManager;
	}(React.Component);
	
	StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
	 false ? StyleSheetManager.propTypes = {
	  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
	  target: PropTypes.shape({
	    appendChild: PropTypes.func.isRequired
	  })
	} : void 0;
	
	// 
	
	var ServerStyleSheet = function () {
	  function ServerStyleSheet() {
	    classCallCheck(this, ServerStyleSheet);
	
	    /* The master sheet might be reset, so keep a reference here */
	    this.masterSheet = StyleSheet.master;
	    this.instance = this.masterSheet.clone();
	    this.closed = false;
	  }
	
	  ServerStyleSheet.prototype.complete = function complete() {
	    if (!this.closed) {
	      /* Remove closed StyleSheets from the master sheet */
	      var index = this.masterSheet.clones.indexOf(this.instance);
	      this.masterSheet.clones.splice(index, 1);
	      this.closed = true;
	    }
	  };
	
	  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
	    if (this.closed) {
	      throw new StyledComponentsError(2);
	    }
	
	    return React__default.createElement(
	      StyleSheetManager,
	      { sheet: this.instance },
	      children
	    );
	  };
	
	  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
	    this.complete();
	    return this.instance.toHTML();
	  };
	
	  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
	    this.complete();
	    return this.instance.toReactElements();
	  };
	
	  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
	    var _this = this;
	
	    {
	      throw new StyledComponentsError(3);
	    }
	
	    /* the tag index keeps track of which tags have already been emitted */
	    var instance = this.instance;
	
	    var instanceTagIndex = 0;
	
	    var streamAttr = SC_STREAM_ATTR + '="true"';
	
	    var transformer = new stream.Transform({
	      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
	        var tags = instance.tags;
	
	        var html = '';
	
	        /* retrieve html for each new style tag */
	        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
	          var tag = tags[instanceTagIndex];
	          html += tag.toHTML(streamAttr);
	        }
	
	        /* force our StyleSheets to emit entirely new tags */
	        instance.sealAllTags();
	
	        /* prepend style html to chunk */
	        this.push(html + chunk);
	        callback();
	      }
	    });
	
	    readableStream.on('end', function () {
	      return _this.complete();
	    });
	    readableStream.on('error', function (err) {
	      _this.complete();
	
	      // forward the error to the transform stream
	      transformer.emit('error', err);
	    });
	
	    return readableStream.pipe(transformer);
	  };
	
	  return ServerStyleSheet;
	}();
	
	// 
	
	var LIMIT = 200;
	
	var createWarnTooManyClasses = (function (displayName) {
	  var generatedClasses = {};
	  var warningSeen = false;
	
	  return function (className) {
	    if (!warningSeen) {
	      generatedClasses[className] = true;
	      if (Object.keys(generatedClasses).length >= LIMIT) {
	        // Unable to find latestRule in test environment.
	        /* eslint-disable no-console, prefer-template */
	        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
	        warningSeen = true;
	        generatedClasses = {};
	      }
	    }
	  };
	});
	
	// 
	
	var determineTheme = (function (props, fallbackTheme, defaultProps) {
	  // Props should take precedence over ThemeProvider, which should take precedence over
	  // defaultProps, but React automatically puts defaultProps on props.
	
	  /* eslint-disable react/prop-types */
	  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
	  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
	  /* eslint-enable */
	
	  return theme;
	});
	
	// 
	var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
	var dashesAtEnds = /(^-|-$)/g;
	
	/**
	 * TODO: Explore using CSS.escape when it becomes more available
	 * in evergreen browsers.
	 */
	function escape(str) {
	  return str
	  // Replace all possible CSS selectors
	  .replace(escapeRegex, '-')
	
	  // Remove extraneous hyphens at the start and end
	  .replace(dashesAtEnds, '');
	}
	
	// 
	
	function getComponentName(target) {
	  return target.displayName || target.name || 'Component';
	}
	
	// 
	
	function isTag(target) /* : %checks */{
	  return typeof target === 'string';
	}
	
	// 
	
	function generateDisplayName(target) {
	  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
	}
	
	// 
	/* eslint-disable max-len */
	/**
	 * Trying to avoid the unknown-prop errors on styled components by filtering by
	 * React's attribute whitelist.
	 *
	 * To regenerate this regex:
	 *
	 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
	 * 2. Run `regexgen` with the list of space-separated words below as input
	 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
	 *    and no false positives from partials
	 * */
	/*
	children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
	*/
	/* eslint-enable max-len */
	
	var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
	/* From DOMProperty */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
	var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
	
	var validAttr = (function (name) {
	  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
	});
	
	// 
	
	function hasInInheritanceChain(child, parent) {
	  var target = child;
	
	  while (target) {
	    target = Object.getPrototypeOf(target);
	
	    if (target && target === parent) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	// 
	/**
	 * Creates a broadcast that can be listened to, i.e. simple event emitter
	 *
	 * @see https://github.com/ReactTraining/react-broadcast
	 */
	
	var createBroadcast = function createBroadcast(initialState) {
	  var listeners = {};
	  var id = 0;
	  var state = initialState;
	
	  function publish(nextState) {
	    state = nextState;
	
	    // eslint-disable-next-line guard-for-in, no-restricted-syntax
	    for (var key in listeners) {
	      var listener = listeners[key];
	      if (listener === undefined) {
	        // eslint-disable-next-line no-continue
	        continue;
	      }
	
	      listener(state);
	    }
	  }
	
	  function subscribe(listener) {
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    listener(state);
	    return currentId;
	  }
	
	  function unsubscribe(unsubID) {
	    listeners[unsubID] = undefined;
	  }
	
	  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
	};
	
	var _contextShape, _ThemeProvider$contex;
	
	// NOTE: DO NOT CHANGE, changing this is a semver major change!
	var CHANNEL = '__styled-components__';
	var CHANNEL_NEXT = CHANNEL + 'next__';
	
	var CONTEXT_CHANNEL_SHAPE = PropTypes.shape({
	  getTheme: PropTypes.func,
	  subscribe: PropTypes.func,
	  unsubscribe: PropTypes.func
	});
	
	var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = PropTypes.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);
	
	var warnChannelDeprecated = void 0;
	if (false) {
	  warnChannelDeprecated = once(function () {
	    // eslint-disable-next-line no-console
	    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
	  });
	}
	
	var isFunction = function isFunction(test) {
	  return typeof test === 'function';
	};
	
	/**
	 * Provide a theme to an entire react component tree via context and event listeners (have to do
	 * both context and event emitter as pure components block context updates)
	 */
	
	var ThemeProvider = function (_Component) {
	  inherits(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    classCallCheck(this, ThemeProvider);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this));
	
	    _this.unsubscribeToOuterId = -1;
	
	    _this.getTheme = _this.getTheme.bind(_this);
	    return _this;
	  }
	
	  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
	    // with the outer theme
	    var outerContext = this.context[CHANNEL_NEXT];
	    if (outerContext !== undefined) {
	      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
	        _this2.outerTheme = theme;
	
	        if (_this2.broadcast !== undefined) {
	          _this2.publish(_this2.props.theme);
	        }
	      });
	    }
	
	    this.broadcast = createBroadcast(this.getTheme());
	  };
	
	  ThemeProvider.prototype.getChildContext = function getChildContext() {
	    var _this3 = this,
	        _babelHelpers$extends;
	
	    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
	      getTheme: this.getTheme,
	      subscribe: this.broadcast.subscribe,
	      unsubscribe: this.broadcast.unsubscribe
	    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
	      if (false) {
	        warnChannelDeprecated();
	      }
	
	      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
	      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
	      return function () {
	        return _this3.broadcast.unsubscribe(unsubscribeId);
	      };
	    }, _babelHelpers$extends));
	  };
	
	  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.theme !== nextProps.theme) {
	      this.publish(nextProps.theme);
	    }
	  };
	
	  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribeToOuterId !== -1) {
	      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
	    }
	  };
	
	  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
	
	
	  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
	    var theme = passedTheme || this.props.theme;
	
	    if (isFunction(theme)) {
	      var mergedTheme = theme(this.outerTheme);
	
	      if (false) {
	        throw new StyledComponentsError(7);
	      }
	
	      return mergedTheme;
	    }
	
	    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
	      throw new StyledComponentsError(8);
	    }
	
	    return _extends({}, this.outerTheme, theme);
	  };
	
	  ThemeProvider.prototype.publish = function publish(theme) {
	    this.broadcast.publish(this.getTheme(theme));
	  };
	
	  ThemeProvider.prototype.render = function render() {
	    if (!this.props.children) {
	      return null;
	    }
	
	    return React__default.Children.only(this.props.children);
	  };
	
	  return ThemeProvider;
	}(React.Component);
	
	ThemeProvider.childContextTypes = contextShape;
	ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);
	
	var _babelHelpers$extends;
	
	// HACK for generating all static styles without needing to allocate
	// an empty execution context every single time...
	var STATIC_EXECUTION_CONTEXT = {};
	
	var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));
	
	var identifiers = {};
	
	/* We depend on components having unique IDs */
	var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
	  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);
	
	  /**
	   * This ensures uniqueness if two components happen to share
	   * the same displayName.
	   */
	  var nr = (identifiers[displayName] || 0) + 1;
	  identifiers[displayName] = nr;
	
	  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
	
	  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
	};
	
	var warnExtendDeprecated = function warnExtendDeprecated() {};
	if (false) {
	  warnExtendDeprecated = once(function () {
	    // eslint-disable-next-line no-console
	    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
	  });
	}
	
	// $FlowFixMe
	
	var BaseStyledComponent = function (_Component) {
	  inherits(BaseStyledComponent, _Component);
	
	  function BaseStyledComponent() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, BaseStyledComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
	      theme: null,
	      generatedClassName: ''
	    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
	    if (this.unsubscribeId !== -1) {
	      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	    }
	  };
	
	  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
	    var attrs = this.constructor.attrs;
	
	    var context = _extends({}, props, { theme: theme });
	    if (attrs === undefined) {
	      return context;
	    }
	
	    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
	      var attr = attrs[key];
	
	      // eslint-disable-next-line no-param-reassign
	      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, React.Component) ? attr(context) : attr;
	      return acc;
	    }, {});
	
	    return _extends({}, context, this.attrs);
	  };
	
	  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
	    var _constructor = this.constructor,
	        attrs = _constructor.attrs,
	        componentStyle = _constructor.componentStyle,
	        warnTooManyClasses = _constructor.warnTooManyClasses;
	
	    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;
	
	    // statically styled-components don't need to build an execution context object,
	    // and shouldn't be increasing the number of class names
	    if (componentStyle.isStatic && attrs === undefined) {
	      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
	    } else {
	      var executionContext = this.buildExecutionContext(theme, props);
	      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);
	
	      if (false) {
	        warnTooManyClasses(className);
	      }
	
	      return className;
	    }
	  };
	
	  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var componentStyle = this.constructor.componentStyle;
	
	    var styledContext = this.context[CHANNEL_NEXT];
	
	    // If this is a statically-styled component, we don't need to the theme
	    // to generate or build styles.
	    if (componentStyle.isStatic) {
	      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
	      this.setState({ generatedClassName: generatedClassName });
	      // If there is a theme in the context, subscribe to the event emitter. This
	      // is necessary due to pure components blocking context updates, this circumvents
	      // that by updating when an event is emitted
	    } else if (styledContext !== undefined) {
	      var subscribe = styledContext.subscribe;
	
	      this.unsubscribeId = subscribe(function (nextTheme) {
	        // This will be called once immediately
	        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
	
	        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
	
	        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
	      });
	    } else {
	      // eslint-disable-next-line react/prop-types
	      var theme = this.props.theme || EMPTY_OBJECT;
	      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
	      this.setState({ theme: theme, generatedClassName: _generatedClassName });
	    }
	  };
	
	  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this3 = this;
	
	    // If this is a statically-styled component, we don't need to listen to
	    // props changes to update styles
	    var componentStyle = this.constructor.componentStyle;
	
	    if (componentStyle.isStatic) {
	      return;
	    }
	
	    this.setState(function (prevState) {
	      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
	      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
	
	      return { theme: theme, generatedClassName: generatedClassName };
	    });
	  };
	
	  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unsubscribeFromContext();
	  };
	
	  BaseStyledComponent.prototype.render = function render() {
	    // eslint-disable-next-line react/prop-types
	    var innerRef = this.props.innerRef;
	    var generatedClassName = this.state.generatedClassName;
	    var _constructor2 = this.constructor,
	        styledComponentId = _constructor2.styledComponentId,
	        target = _constructor2.target;
	
	
	    var isTargetTag = isTag(target);
	
	    var className = [
	    // eslint-disable-next-line react/prop-types
	    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');
	
	    var baseProps = _extends({}, this.attrs, {
	      className: className
	    });
	
	    if (isStyledComponent(target)) {
	      baseProps.innerRef = innerRef;
	    } else {
	      baseProps.ref = innerRef;
	    }
	
	    var propsForElement = baseProps;
	    var key = void 0;
	
	    for (key in this.props) {
	      // Don't pass through non HTML tags through to HTML elements
	      // always omit innerRef
	      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
	        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
	      }
	    }
	
	    return React.createElement(target, propsForElement);
	  };
	
	  return BaseStyledComponent;
	}(React.Component);
	
	var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
	  var createStyledComponent = function createStyledComponent(target, options, rules) {
	    var _options$isClass = options.isClass,
	        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
	        _options$displayName = options.displayName,
	        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
	        _options$componentId = options.componentId,
	        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
	        _options$ParentCompon = options.ParentComponent,
	        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
	        extendingRules = options.rules,
	        attrs = options.attrs;
	
	
	    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;
	
	    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);
	
	    var StyledComponent = function (_ParentComponent) {
	      inherits(StyledComponent, _ParentComponent);
	
	      function StyledComponent() {
	        classCallCheck(this, StyledComponent);
	        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
	      }
	
	      StyledComponent.withComponent = function withComponent(tag) {
	        var previousComponentId = options.componentId,
	            optionsToCopy = objectWithoutProperties(options, ['componentId']);
	
	
	        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));
	
	        var newOptions = _extends({}, optionsToCopy, {
	          componentId: newComponentId,
	          ParentComponent: StyledComponent
	        });
	
	        return createStyledComponent(tag, newOptions, rules);
	      };
	
	      createClass(StyledComponent, null, [{
	        key: 'extend',
	        get: function get$$1() {
	          var rulesFromOptions = options.rules,
	              parentComponentId = options.componentId,
	              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);
	
	
	          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);
	
	          var newOptions = _extends({}, optionsToCopy, {
	            rules: newRules,
	            parentComponentId: parentComponentId,
	            ParentComponent: StyledComponent
	          });
	
	          warnExtendDeprecated();
	
	          return constructWithOptions(createStyledComponent, target, newOptions);
	        }
	      }]);
	      return StyledComponent;
	    }(ParentComponent);
	
	    StyledComponent.attrs = attrs;
	    StyledComponent.componentStyle = componentStyle;
	    StyledComponent.contextTypes = modifiedContextShape;
	    StyledComponent.displayName = displayName;
	    StyledComponent.styledComponentId = styledComponentId;
	    StyledComponent.target = target;
	
	
	    if (false) {
	      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
	    }
	
	    if (isClass) {
	      hoistStatics(StyledComponent, target, {
	        // all SC-specific things should not be hoisted
	        attrs: true,
	        componentStyle: true,
	        displayName: true,
	        extend: true,
	        styledComponentId: true,
	        target: true,
	        warnTooManyClasses: true,
	        withComponent: true
	      });
	    }
	
	    return StyledComponent;
	  };
	
	  return createStyledComponent;
	});
	
	// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash(str) {
	  var l = str.length | 0,
	      h = l | 0,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	
	  return h >>> 0;
	}
	
	// 
	
	var areStylesCacheable = IS_BROWSER;
	
	var isStaticRules = function isStaticRules(rules, attrs) {
	  for (var i = 0, len = rules.length; i < len; i += 1) {
	    var rule = rules[i];
	
	    // recursive case
	    if (Array.isArray(rule) && !isStaticRules(rule)) {
	      return false;
	    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
	      // functions are allowed to be static if they're just being
	      // used to get the classname of a nested styled component
	      return false;
	    }
	  }
	
	  if (attrs !== undefined) {
	    // eslint-disable-next-line guard-for-in, no-restricted-syntax
	    for (var key in attrs) {
	      if (typeof attrs[key] === 'function') {
	        return false;
	      }
	    }
	  }
	
	  return true;
	};
	
	var isHMREnabled = typeof module !== 'undefined' && module.hot && ("production") !== 'production';
	
	/*
	 ComponentStyle is all the CSS-specific stuff, not
	 the React-specific stuff.
	 */
	var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
	  /* combines hashStr (murmurhash) and nameGenerator for convenience */
	  var generateRuleHash = function generateRuleHash(str) {
	    return nameGenerator(murmurhash(str));
	  };
	
	  var ComponentStyle = function () {
	    function ComponentStyle(rules, attrs, componentId) {
	      classCallCheck(this, ComponentStyle);
	
	      this.rules = rules;
	      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
	      this.componentId = componentId;
	
	      if (!StyleSheet.master.hasId(componentId)) {
	        var placeholder =  false ? ['.' + componentId + ' {}'] : [];
	
	        StyleSheet.master.deferredInject(componentId, placeholder);
	      }
	    }
	
	    /*
	     * Flattens a rule set into valid CSS
	     * Hashes it, wraps the whole chunk in a .hash1234 {}
	     * Returns the hash to be injected on render()
	     * */
	
	
	    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
	      var isStatic = this.isStatic,
	          componentId = this.componentId,
	          lastClassName = this.lastClassName;
	
	      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
	        return lastClassName;
	      }
	
	      var flatCSS = flatten(this.rules, executionContext);
	      var name = generateRuleHash(this.componentId + flatCSS.join(''));
	
	      if (!styleSheet.hasNameForId(componentId, name)) {
	        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
	      }
	
	      this.lastClassName = name;
	      return name;
	    };
	
	    ComponentStyle.generateName = function generateName(str) {
	      return generateRuleHash(str);
	    };
	
	    return ComponentStyle;
	  }();
	
	  return ComponentStyle;
	});
	
	// 
	// Thanks to ReactDOMFactories for this handy list!
	
	var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
	
	// SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	
	// 
	
	var _styled = (function (styledComponent, constructWithOptions) {
	  var styled = function styled(tag) {
	    return constructWithOptions(styledComponent, tag);
	  };
	
	  // Shorthands for all valid HTML Elements
	  domElements.forEach(function (domElement) {
	    styled[domElement] = styled(domElement);
	  });
	
	  return styled;
	});
	
	// 
	
	var replaceWhitespace = function replaceWhitespace(str) {
	  return str.replace(/\s|\\n/g, '');
	};
	
	var _keyframes = (function (nameGenerator, stringifyRules, css) {
	  return function () {
	    var styleSheet = StyleSheet.master;
	    var rules = css.apply(undefined, arguments);
	    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
	    var id = 'sc-keyframes-' + name;
	
	    if (!styleSheet.hasNameForId(id, name)) {
	      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
	    }
	
	    return name;
	  };
	});
	
	// 
	
	var _injectGlobal = (function (stringifyRules, css) {
	  var injectGlobal = function injectGlobal() {
	    var styleSheet = StyleSheet.master;
	    var rules = css.apply(undefined, arguments);
	    var hash = murmurhash(JSON.stringify(rules));
	    var id = 'sc-global-' + hash;
	
	    if (!styleSheet.hasId(id)) {
	      styleSheet.inject(id, stringifyRules(rules));
	    }
	  };
	
	  return injectGlobal;
	});
	
	// 
	
	var _constructWithOptions = (function (css) {
	  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
	
	    if (!reactIs.isValidElementType(tag)) {
	      throw new StyledComponentsError(1, String(tag));
	    }
	
	    /* This is callable directly as a template function */
	    // $FlowFixMe: Not typed to avoid destructuring arguments
	    var templateFunction = function templateFunction() {
	      return componentConstructor(tag, options, css.apply(undefined, arguments));
	    };
	
	    /* If config methods are called, wrap up a new template function and merge options */
	    templateFunction.withConfig = function (config) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
	    };
	    templateFunction.attrs = function (attrs) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
	        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
	      }));
	    };
	
	    return templateFunction;
	  };
	
	  return constructWithOptions;
	});
	
	// 
	
	var withTheme = (function (Component) {
	  var isStatelessFunctionalComponent = typeof Component === 'function' &&
	  // $FlowFixMe TODO: flow for prototype
	  !(Component.prototype && 'isReactComponent' in Component.prototype);
	
	  // NOTE: We can't pass a ref to a stateless functional component
	  var shouldSetInnerRef = isStyledComponent(Component) || isStatelessFunctionalComponent;
	
	  var WithTheme = function (_React$Component) {
	    inherits(WithTheme, _React$Component);
	
	    function WithTheme() {
	      var _temp, _this, _ret;
	
	      classCallCheck(this, WithTheme);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
	    }
	
	    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping
	
	
	    WithTheme.prototype.componentWillMount = function componentWillMount() {
	      var _this2 = this;
	
	      var defaultProps = this.constructor.defaultProps;
	
	      var styledContext = this.context[CHANNEL_NEXT];
	      var themeProp = determineTheme(this.props, undefined, defaultProps);
	      if (styledContext === undefined && themeProp === undefined && ("production") !== 'production') {
	        // eslint-disable-next-line no-console
	        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
	      } else if (styledContext === undefined && themeProp !== undefined) {
	        this.setState({ theme: themeProp });
	      } else {
	        var subscribe = styledContext.subscribe;
	
	        this.unsubscribeId = subscribe(function (nextTheme) {
	          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
	          _this2.setState({ theme: theme });
	        });
	      }
	    };
	
	    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var defaultProps = this.constructor.defaultProps;
	
	      this.setState(function (oldState) {
	        var theme = determineTheme(nextProps, oldState.theme, defaultProps);
	
	        return { theme: theme };
	      });
	    };
	
	    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.unsubscribeId !== -1) {
	        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	      }
	    };
	
	    WithTheme.prototype.render = function render() {
	      var props = _extends({
	        theme: this.state.theme
	      }, this.props);
	
	      if (!shouldSetInnerRef) {
	        props.ref = props.innerRef;
	        delete props.innerRef;
	      }
	
	      return React__default.createElement(Component, props);
	    };
	
	    return WithTheme;
	  }(React__default.Component);
	
	  WithTheme.contextTypes = contextShape;
	  WithTheme.displayName = 'WithTheme(' + getComponentName(Component) + ')';
	  WithTheme.styledComponentId = 'withTheme';
	
	
	  return hoistStatics(WithTheme, Component);
	});
	
	// 
	
	/* eslint-disable */
	var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
	  StyleSheet: StyleSheet
	};
	
	// 
	
	/* Warning if you've imported this file on React Native */
	if (false) {
	  // eslint-disable-next-line no-console
	  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
	}
	
	/* Warning if there are several instances of styled-components */
	if (false) {
	  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;
	
	  if (window['__styled-components-init__'] === 1) {
	    // eslint-disable-next-line no-console
	    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
	  }
	
	  window['__styled-components-init__'] += 1;
	}
	
	/* Instantiate singletons */
	var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
	var constructWithOptions = _constructWithOptions(css);
	var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);
	
	/* Instantiate exported singletons */
	var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
	var injectGlobal = _injectGlobal(stringifyRules, css);
	var styled = _styled(StyledComponent, constructWithOptions);
	
	exports.default = styled;
	exports.css = css;
	exports.keyframes = keyframes;
	exports.injectGlobal = injectGlobal;
	exports.isStyledComponent = isStyledComponent;
	exports.consolidateStreamedStyles = consolidateStreamedStyles;
	exports.ThemeProvider = ThemeProvider;
	exports.withTheme = withTheme;
	exports.ServerStyleSheet = ServerStyleSheet;
	exports.StyleSheetManager = StyleSheetManager;
	exports.__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS;
	//# sourceMappingURL=styled-components.browser.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56), __webpack_require__(26)(module)))

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							return insertRule(content+';'), ''
						break
					// selector
					case 2:
						if (ns === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (ns) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + (at === 0 ? delimiter : '')
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)(module)))

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	 *          __        ___
	 *    _____/ /___  __/ (_)____
	 *   / ___/ __/ / / / / / ___/
	 *  (__  ) /_/ /_/ / / (__  )
	 * /____/\__/\__, /_/_/____/
	 *          /____/
	 *
	 * light - weight css preprocessor @licence MIT
	 */
	(function (factory) {/* eslint-disable */
		 true ? (module['exports'] = factory(null)) :
			typeof define === 'function' && define['amd'] ? define(factory(null)) :
				(window['stylis'] = factory(null))
	}(/** @param {*=} options */function factory (options) {/* eslint-disable */
	
		'use strict'
	
		/**
		 * Notes
		 *
		 * The ['<method name>'] pattern is used to support closure compiler
		 * the jsdoc signatures are also used to the same effect
		 *
		 * ----
		 *
		 * int + int + int === n4 [faster]
		 *
		 * vs
		 *
		 * int === n1 && int === n2 && int === n3
		 *
		 * ----
		 *
		 * switch (int) { case ints...} [faster]
		 *
		 * vs
		 *
		 * if (int == 1 && int === 2 ...)
		 *
		 * ----
		 *
		 * The (first*n1 + second*n2 + third*n3) format used in the property parser
		 * is a simple way to hash the sequence of characters
		 * taking into account the index they occur in
		 * since any number of 3 character sequences could produce duplicates.
		 *
		 * On the other hand sequences that are directly tied to the index of the character
		 * resolve a far more accurate measure, it's also faster
		 * to evaluate one condition in a switch statement
		 * than three in an if statement regardless of the added math.
		 *
		 * This allows the vendor prefixer to be both small and fast.
		 */
	
		var nullptn = /^\0+/g /* matches leading null characters */
		var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
		var colonptn = /: */g /* splits animation rules */
		var cursorptn = /zoo|gra/ /* assert cursor varient */
		var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
		var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
		var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
		var elementptn = / *[\0] */g /* selector elements */
		var selectorptn = /,\r+?/g /* splits selectors */
		var andptn = /([\t\r\n ])*\f?&/g /* match & */
		var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
		var invalidptn = /\W+/g /* removes invalid characters from keyframes */
		var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
		var plcholdrptn = /::(place)/g /* match ::placeholder varient */
		var readonlyptn = /:(read-only)/g /* match :read-only varient */
		var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
		var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
		var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
		var whiteptn = /\s{2,}/g /* matches repeating whitespace */
		var pseudoptn = /([^\(])(:+) */g /* pseudo element */
		var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
		var gradientptn = /([\w-]+t\()/g /* match *gradient property */
		var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
		var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
		var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
		var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
		var trimptn = /[ \t]+$/ /* match tail whitspace */
		var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
		var imgsrcptn = /([^-])(image-set\()/
	
		/* vendors */
		var webkit = '-webkit-'
		var moz = '-moz-'
		var ms = '-ms-'
	
		/* character codes */
		var SEMICOLON = 59 /* ; */
		var CLOSEBRACES = 125 /* } */
		var OPENBRACES = 123 /* { */
		var OPENPARENTHESES = 40 /* ( */
		var CLOSEPARENTHESES = 41 /* ) */
		var OPENBRACKET = 91 /* [ */
		var CLOSEBRACKET = 93 /* ] */
		var NEWLINE = 10 /* \n */
		var CARRIAGE = 13 /* \r */
		var TAB = 9 /* \t */
		var AT = 64 /* @ */
		var SPACE = 32 /*   */
		var AND = 38 /* & */
		var DASH = 45 /* - */
		var UNDERSCORE = 95 /* _ */
		var STAR = 42 /* * */
		var COMMA = 44 /* , */
		var COLON = 58 /* : */
		var SINGLEQUOTE = 39 /* ' */
		var DOUBLEQUOTE = 34 /* " */
		var FOWARDSLASH = 47 /* / */
		var GREATERTHAN = 62 /* > */
		var PLUS = 43 /* + */
		var TILDE = 126 /* ~ */
		var NULL = 0 /* \0 */
		var FORMFEED = 12 /* \f */
		var VERTICALTAB = 11 /* \v */
	
		/* special identifiers */
		var KEYFRAME = 107 /* k */
		var MEDIA = 109 /* m */
		var SUPPORTS = 115 /* s */
		var PLACEHOLDER = 112 /* p */
		var READONLY = 111 /* o */
		var IMPORT = 105 /* <at>i */
		var CHARSET = 99 /* <at>c */
		var DOCUMENT = 100 /* <at>d */
		var PAGE = 112 /* <at>p */
	
		var column = 1 /* current column */
		var line = 1 /* current line numebr */
		var pattern = 0 /* :pattern */
	
		var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
		var prefix = 1 /* vendor prefix */
		var escape = 1 /* escape :global() pattern */
		var compress = 0 /* compress output */
		var semicolon = 0 /* no/semicolon option */
		var preserve = 0 /* preserve empty selectors */
	
		/* empty reference */
		var array = []
	
		/* plugins */
		var plugins = []
		var plugged = 0
		var should = null
	
		/* plugin context */
		var POSTS = -2
		var PREPS = -1
		var UNKWN = 0
		var PROPS = 1
		var BLCKS = 2
		var ATRUL = 3
	
		/* plugin newline context */
		var unkwn = 0
	
		/* keyframe animation */
		var keyed = 1
		var key = ''
	
		/* selector namespace */
		var nscopealt = ''
		var nscope = ''
	
		/**
		 * Compile
		 *
		 * @param {Array<string>} parent
		 * @param {Array<string>} current
		 * @param {string} body
		 * @param {number} id
		 * @param {number} depth
		 * @return {string}
		 */
		function compile (parent, current, body, id, depth) {
			var bracket = 0 /* brackets [] */
			var comment = 0 /* comments /* // or /* */
			var parentheses = 0 /* functions () */
			var quote = 0 /* quotes '', "" */
	
			var first = 0 /* first character code */
			var second = 0 /* second character code */
			var code = 0 /* current character code */
			var tail = 0 /* previous character code */
			var trail = 0 /* character before previous code */
			var peak = 0 /* previous non-whitespace code */
	
			var counter = 0 /* count sequence termination */
			var context = 0 /* track current context */
			var atrule = 0 /* track @at-rule context */
			var pseudo = 0 /* track pseudo token index */
			var caret = 0 /* current character index */
			var format = 0 /* control character formating context */
			var insert = 0 /* auto semicolon insertion */
			var invert = 0 /* inverted selector pattern */
			var length = 0 /* generic length address */
			var eof = body.length /* end of file(length) */
			var eol = eof - 1 /* end of file(characters) */
	
			var char = '' /* current character */
			var chars = '' /* current buffer of characters */
			var child = '' /* next buffer of characters */
			var out = '' /* compiled body */
			var children = '' /* compiled children */
			var flat = '' /* compiled leafs */
			var selector /* generic selector address */
			var result /* generic address */
	
			// ...build body
			while (caret < eof) {
				code = body.charCodeAt(caret)
	
				// eof varient
				if (caret === eol) {
					// last character + noop context, add synthetic padding for noop context to terminate
					if (comment + quote + parentheses + bracket !== 0) {
						if (comment !== 0) {
							code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
						}
	
						quote = parentheses = bracket = 0
						eof++
						eol++
					}
				}
	
				if (comment + quote + parentheses + bracket === 0) {
					// eof varient
					if (caret === eol) {
						if (format > 0) {
							chars = chars.replace(formatptn, '')
						}
	
						if (chars.trim().length > 0) {
							switch (code) {
								case SPACE:
								case TAB:
								case SEMICOLON:
								case CARRIAGE:
								case NEWLINE: {
									break
								}
								default: {
									chars += body.charAt(caret)
								}
							}
	
							code = SEMICOLON
						}
					}
	
					// auto semicolon insertion
					if (insert === 1) {
						switch (code) {
							// false flags
							case OPENBRACES:
							case CLOSEBRACES:
							case SEMICOLON:
							case DOUBLEQUOTE:
							case SINGLEQUOTE:
							case OPENPARENTHESES:
							case CLOSEPARENTHESES:
							case COMMA: {
								insert = 0
							}
							// ignore
							case TAB:
							case CARRIAGE:
							case NEWLINE:
							case SPACE: {
								break
							}
							// valid
							default: {
								insert = 0
								length = caret
								first = code
								caret--
								code = SEMICOLON
	
								while (length < eof) {
									switch (body.charCodeAt(length++)) {
										case NEWLINE:
										case CARRIAGE:
										case SEMICOLON: {
											++caret
											code = first
											length = eof
											break
										}
										case COLON: {
											if (format > 0) {
												++caret
												code = first
											}
										}
										case OPENBRACES: {
											length = eof
										}
									}
								}
							}
						}
					}
	
					// token varient
					switch (code) {
						case OPENBRACES: {
							chars = chars.trim()
							first = chars.charCodeAt(0)
							counter = 1
							length = ++caret
	
							while (caret < eof) {
								switch (code = body.charCodeAt(caret)) {
									case OPENBRACES: {
										counter++
										break
									}
									case CLOSEBRACES: {
										counter--
										break
									}
									case FOWARDSLASH: {
										switch (second = body.charCodeAt(caret + 1)) {
											// /*, //
											case STAR:
											case FOWARDSLASH: {
												caret = delimited(second, caret, eol, body)
											}
										}
										break
									}
									// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
									case OPENBRACKET: {
										code++
									}
									// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
									case OPENPARENTHESES: {
										code++
									}
									// quote tail delimiter is identical to the head delimiter hence noop,
									// fallthrough clauses have been shifted to the correct tail delimiter
									case DOUBLEQUOTE:
									case SINGLEQUOTE: {
										while (caret++ < eol) {
											if (body.charCodeAt(caret) === code) {
												break
											}
										}
									}
								}
	
								if (counter === 0) {
									break
								}
	
								caret++
							}
	
							child = body.substring(length, caret)
	
							if (first === NULL) {
								first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
							}
	
							switch (first) {
								// @at-rule
								case AT: {
									if (format > 0) {
										chars = chars.replace(formatptn, '')
									}
	
									second = chars.charCodeAt(1)
	
									switch (second) {
										case DOCUMENT:
										case MEDIA:
										case SUPPORTS:
										case DASH: {
											selector = current
											break
										}
										default: {
											selector = array
										}
									}
	
									child = compile(current, selector, child, second, depth+1)
									length = child.length
	
									// preserve empty @at-rule
									if (preserve > 0 && length === 0) {
										length = chars.length
									}
	
									// execute plugins, @at-rule context
									if (plugged > 0) {
										selector = select(array, chars, invert)
										result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
										chars = selector.join('')
	
										if (result !== void 0) {
											if ((length = (child = result.trim()).length) === 0) {
												second = 0
												child = ''
											}
										}
									}
	
									if (length > 0) {
										switch (second) {
											case SUPPORTS: {
												chars = chars.replace(supportsptn, supports)
											}
											case DOCUMENT:
											case MEDIA:
											case DASH: {
												child = chars + '{' + child + '}'
												break
											}
											case KEYFRAME: {
												chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
												child = chars + '{' + child + '}'
	
												if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
													child = '@' + webkit + child + '@' + child
												} else {
													child = '@' + child
												}
												break
											}
											default: {
												child = chars + child
	
												if (id === PAGE) {
													child = (out += child, '')
												}
											}
										}
									} else {
										child = ''
									}
	
									break
								}
								// selector
								default: {
									child = compile(current, select(current, chars, invert), child, id, depth+1)
								}
							}
	
							children += child
	
							// reset
							context = 0
							insert = 0
							pseudo = 0
							format = 0
							invert = 0
							atrule = 0
							chars = ''
							child = ''
							code = body.charCodeAt(++caret)
							break
						}
						case CLOSEBRACES:
						case SEMICOLON: {
							chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()
	
							if ((length = chars.length) > 1) {
								// monkey-patch missing colon
								if (pseudo === 0) {
									first = chars.charCodeAt(0)
	
									// first character is a letter or dash, buffer has a space character
									if ((first === DASH || first > 96 && first < 123)) {
										length = (chars = chars.replace(' ', ':')).length
									}
								}
	
								// execute plugins, property context
								if (plugged > 0) {
									if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
										if ((length = (chars = result.trim()).length) === 0) {
											chars = '\0\0'
										}
									}
								}
	
								first = chars.charCodeAt(0)
								second = chars.charCodeAt(1)
	
								switch (first) {
									case NULL: {
										break
									}
									case AT: {
										if (second === IMPORT || second === CHARSET) {
											flat += chars + body.charAt(caret)
											break
										}
									}
									default: {
										if (chars.charCodeAt(length-1) === COLON) {
											break
										}
	
										out += property(chars, first, second, chars.charCodeAt(2))
									}
								}
							}
	
							// reset
							context = 0
							insert = 0
							pseudo = 0
							format = 0
							invert = 0
							chars = ''
							code = body.charCodeAt(++caret)
							break
						}
					}
				}
	
				// parse characters
				switch (code) {
					case CARRIAGE:
					case NEWLINE: {
						// auto insert semicolon
						if (comment + quote + parentheses + bracket + semicolon === 0) {
							// valid non-whitespace characters that
							// may precede a newline
							switch (peak) {
								case CLOSEPARENTHESES:
								case SINGLEQUOTE:
								case DOUBLEQUOTE:
								case AT:
								case TILDE:
								case GREATERTHAN:
								case STAR:
								case PLUS:
								case FOWARDSLASH:
								case DASH:
								case COLON:
								case COMMA:
								case SEMICOLON:
								case OPENBRACES:
								case CLOSEBRACES: {
									break
								}
								default: {
									// current buffer has a colon
									if (pseudo > 0) {
										insert = 1
									}
								}
							}
						}
	
						// terminate line comment
						if (comment === FOWARDSLASH) {
							comment = 0
						} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
							format = 1
							chars += '\0'
						}
	
						// execute plugins, newline context
						if (plugged * unkwn > 0) {
							proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
						}
	
						// next line, reset column position
						column = 1
						line++
						break
					}
					case SEMICOLON:
					case CLOSEBRACES: {
						if (comment + quote + parentheses + bracket === 0) {
							column++
							break
						}
					}
					default: {
						// increment column position
						column++
	
						// current character
						char = body.charAt(caret)
	
						// remove comments, escape functions, strings, attributes and prepare selectors
						switch (code) {
							case TAB:
							case SPACE: {
								if (quote + bracket + comment === 0) {
									switch (tail) {
										case COMMA:
										case COLON:
										case TAB:
										case SPACE: {
											char = ''
											break
										}
										default: {
											if (code !== SPACE) {
												char = ' '
											}
										}
									}
								}
								break
							}
							// escape breaking control characters
							case NULL: {
								char = '\\0'
								break
							}
							case FORMFEED: {
								char = '\\f'
								break
							}
							case VERTICALTAB: {
								char = '\\v'
								break
							}
							// &
							case AND: {
								// inverted selector pattern i.e html &
								if (quote + comment + bracket === 0 && cascade > 0) {
									invert = 1
									format = 1
									char = '\f' + char
								}
								break
							}
							// ::p<l>aceholder, l
							// :read-on<l>y, l
							case 108: {
								if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
									switch (caret - pseudo) {
										// ::placeholder
										case 2: {
											if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
												pattern = tail
											}
										}
										// :read-only
										case 8: {
											if (trail === READONLY) {
												pattern = trail
											}
										}
									}
								}
								break
							}
							// :<pattern>
							case COLON: {
								if (quote + comment + bracket === 0) {
									pseudo = caret
								}
								break
							}
							// selectors
							case COMMA: {
								if (comment + parentheses + quote + bracket === 0) {
									format = 1
									char += '\r'
								}
								break
							}
							// quotes
							case DOUBLEQUOTE:
							case SINGLEQUOTE: {
								if (comment === 0) {
									quote = quote === code ? 0 : (quote === 0 ? code : quote)
								}
								break
							}
							// attributes
							case OPENBRACKET: {
								if (quote + comment + parentheses === 0) {
									bracket++
								}
								break
							}
							case CLOSEBRACKET: {
								if (quote + comment + parentheses === 0) {
									bracket--
								}
								break
							}
							// functions
							case CLOSEPARENTHESES: {
								if (quote + comment + bracket === 0) {
									parentheses--
								}
								break
							}
							case OPENPARENTHESES: {
								if (quote + comment + bracket === 0) {
									if (context === 0) {
										switch (tail*2 + trail*3) {
											// :matches
											case 533: {
												break
											}
											// :global, :not, :nth-child etc...
											default: {
												counter = 0
												context = 1
											}
										}
									}
	
									parentheses++
								}
								break
							}
							case AT: {
								if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
									atrule = 1
								}
								break
							}
							// block/line comments
							case STAR:
							case FOWARDSLASH: {
								if (quote + bracket + parentheses > 0) {
									break
								}
	
								switch (comment) {
									// initialize line/block comment context
									case 0: {
										switch (code*2 + body.charCodeAt(caret+1)*3) {
											// //
											case 235: {
												comment = FOWARDSLASH
												break
											}
											// /*
											case 220: {
												length = caret
												comment = STAR
												break
											}
										}
										break
									}
									// end block comment context
									case STAR: {
										if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
											// /*<!> ... */, !
											if (body.charCodeAt(length+2) === 33) {
												out += body.substring(length, caret+1)
											}
											char = ''
											comment = 0
										}
									}
								}
							}
						}
	
						// ignore comment blocks
						if (comment === 0) {
							// aggressive isolation mode, divide each individual selector
							// including selectors in :not function but excluding selectors in :global function
							if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
								switch (code) {
									case COMMA:
									case TILDE:
									case GREATERTHAN:
									case PLUS:
									case CLOSEPARENTHESES:
									case OPENPARENTHESES: {
										if (context === 0) {
											// outside of an isolated context i.e nth-child(<...>)
											switch (tail) {
												case TAB:
												case SPACE:
												case NEWLINE:
												case CARRIAGE: {
													char = char + '\0'
													break
												}
												default: {
													char = '\0' + char + (code === COMMA ? '' : '\0')
												}
											}
											format = 1
										} else {
											// within an isolated context, sleep untill it's terminated
											switch (code) {
												case OPENPARENTHESES: {
													// :globa<l>(
													if (pseudo + 7 === caret && tail === 108) {
														pseudo = 0
													}
													context = ++counter
													break
												}
												case CLOSEPARENTHESES: {
													if ((context = --counter) === 0) {
														format = 1
														char += '\0'
													}
													break
												}
											}
										}
										break
									}
									case TAB:
									case SPACE: {
										switch (tail) {
											case NULL:
											case OPENBRACES:
											case CLOSEBRACES:
											case SEMICOLON:
											case COMMA:
											case FORMFEED:
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												break
											}
											default: {
												// ignore in isolated contexts
												if (context === 0) {
													format = 1
													char += '\0'
												}
											}
										}
									}
								}
							}
	
							// concat buffer of characters
							chars += char
	
							// previous non-whitespace character code
							if (code !== SPACE && code !== TAB) {
								peak = code
							}
						}
					}
				}
	
				// tail character codes
				trail = tail
				tail = code
	
				// visit every character
				caret++
			}
	
			length = out.length
	
			// preserve empty selector
	 		if (preserve > 0) {
	 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
	 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
						length = current.join(',').length + 2
	 				}
	 			}
			}
	
			if (length > 0) {
				// cascade isolation mode?
				selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current
	
				// execute plugins, block context
				if (plugged > 0) {
					result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)
	
					if (result !== void 0 && (out = result).length === 0) {
						return flat + out + children
					}
				}
	
				out = selector.join(',') + '{' + out + '}'
	
				if (prefix*pattern !== 0) {
					if (prefix === 2 && !vendor(out, 2))
						pattern = 0
	
					switch (pattern) {
						// ::read-only
						case READONLY: {
							out = out.replace(readonlyptn, ':'+moz+'$1')+out
							break
						}
						// ::placeholder
						case PLACEHOLDER: {
							out = (
								out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
								out.replace(plcholdrptn, '::' + moz + '$1') +
								out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
							)
							break
						}
					}
	
					pattern = 0
				}
			}
	
			return flat + out + children
		}
	
		/**
		 * Select
		 *
		 * @param {Array<string>} parent
		 * @param {string} current
		 * @param {number} invert
		 * @return {Array<string>}
		 */
		function select (parent, current, invert) {
			var selectors = current.trim().split(selectorptn)
			var out = selectors
	
			var length = selectors.length
			var l = parent.length
	
			switch (l) {
				// 0-1 parent selectors
				case 0:
				case 1: {
					for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
						out[i] = scope(selector, out[i], invert, l).trim()
					}
					break
				}
				// >2 parent selectors, nested
				default: {
					for (var i = 0, j = 0, out = []; i < length; ++i) {
						for (var k = 0; k < l; ++k) {
							out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
						}
					}
				}
			}
	
			return out
		}
	
		/**
		 * Scope
		 *
		 * @param {string} parent
		 * @param {string} current
		 * @param {number} invert
		 * @param {number} level
		 * @return {string}
		 */
		function scope (parent, current, invert, level) {
			var selector = current
			var code = selector.charCodeAt(0)
	
			// trim leading whitespace
			if (code < 33) {
				code = (selector = selector.trim()).charCodeAt(0)
			}
	
			switch (code) {
				// &
				case AND: {
					switch (cascade + level) {
						case 0:
						case 1: {
							if (parent.trim().length === 0) {
								break
							}
						}
						default: {
							return selector.replace(andptn, '$1'+parent.trim())
						}
					}
					break
				}
				// :
				case COLON: {
					switch (selector.charCodeAt(1)) {
						// g in :global
						case 103: {
							if (escape > 0 && cascade > 0) {
								return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
							}
							break
						}
						default: {
							// :hover
							return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
						}
					}
				}
				default: {
					// html &
					if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
						return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
					}
				}
			}
	
			return parent + selector
		}
	
		/**
		 * Property
		 *
		 * @param {string} input
		 * @param {number} first
		 * @param {number} second
		 * @param {number} third
		 * @return {string}
		 */
		function property (input, first, second, third) {
			var index = 0
			var out = input + ';'
			var hash = (first*2) + (second*3) + (third*4)
			var cache
	
			// animation: a, n, i characters
			if (hash === 944) {
				return animation(out)
			} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
				return out
			}
	
			// vendor prefix
			switch (hash) {
				// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
				case 1015: {
					// text-shadow/text-align/text-transform, a
					return out.charCodeAt(10) === 97 ? webkit + out + out : out
				}
				// filter/fill f, i, l
				case 951: {
					// filter, t
					return out.charCodeAt(3) === 116 ? webkit + out + out : out
				}
				// color/column, c, o, l
				case 963: {
					// column, n
					return out.charCodeAt(5) === 110 ? webkit + out + out : out
				}
				// box-decoration-break, b, o, x
				case 1009: {
					if (out.charCodeAt(4) !== 100) {
						break
					}
				}
				// mask, m, a, s
				// clip-path, c, l, i
				case 969:
				case 942: {
					return webkit + out + out
				}
				// appearance: a, p, p
				case 978: {
					return webkit + out + moz + out + out
				}
				// hyphens: h, y, p
				// user-select: u, s, e
				case 1019:
				case 983: {
					return webkit + out + moz + out + ms + out + out
				}
				// background/backface-visibility, b, a, c
				case 883: {
					// backface-visibility, -
					if (out.charCodeAt(8) === DASH) {
						return webkit + out + out
					}
	
					// image-set(...)
					if (out.indexOf('image-set(', 11) > 0) {
						return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
					}
	
					return out
				}
				// flex: f, l, e
				case 932: {
					if (out.charCodeAt(4) === DASH) {
						switch (out.charCodeAt(5)) {
							// flex-grow, g
							case 103: {
								return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
							}
							// flex-shrink, s
							case 115: {
								return webkit + out + ms + out.replace('shrink', 'negative') + out
							}
							// flex-basis, b
							case 98: {
								return webkit + out + ms + out.replace('basis', 'preferred-size') + out
							}
						}
					}
	
					return webkit + out + ms + out + out
				}
				// order: o, r, d
				case 964: {
					return webkit + out + ms + 'flex' + '-' + out + out
				}
				// justify-items/justify-content, j, u, s
				case 1023: {
					// justify-content, c
					if (out.charCodeAt(8) !== 99) {
						break
					}
	
					cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
					return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
				}
				// cursor, c, u, r
				case 1005: {
					return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
				}
				// writing-mode, w, r, i
				case 1000: {
					cache = out.substring(13).trim()
					index = cache.indexOf('-') + 1
	
					switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
						// vertical-lr
						case 226: {
							cache = out.replace(writingptn, 'tb')
							break
						}
						// vertical-rl
						case 232: {
							cache = out.replace(writingptn, 'tb-rl')
							break
						}
						// horizontal-tb
						case 220: {
							cache = out.replace(writingptn, 'lr')
							break
						}
						default: {
							return out
						}
					}
	
					return webkit + out + ms + cache + out
				}
				// position: sticky
				case 1017: {
					if (out.indexOf('sticky', 9) === -1) {
						return out
					}
				}
				// display(flex/inline-flex/inline-box): d, i, s
				case 975: {
					index = (out = input).length - 10
					cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()
	
					switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
						// inline-
						case 203: {
							// inline-box
							if (cache.charCodeAt(8) < 111) {
								break
							}
						}
						// inline-box/sticky
						case 115: {
							out = out.replace(cache, webkit+cache)+';'+out
							break
						}
						// inline-flex
						// flex
						case 207:
						case 102: {
							out = (
								out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
								out.replace(cache, webkit+cache)+';'+
								out.replace(cache, ms+cache+'box')+';'+
								out
							)
						}
					}
	
					return out + ';'
				}
				// align-items, align-center, align-self: a, l, i, -
				case 938: {
					if (out.charCodeAt(5) === DASH) {
						switch (out.charCodeAt(6)) {
							// align-items, i
							case 105: {
								cache = out.replace('-items', '')
								return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
							}
							// align-self, s
							case 115: {
								return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
							}
							// align-content
							default: {
								return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
							}
						}
					}
					break
				}
				// min/max
				case 973:
				case 989: {
					// min-/max- height/width/block-size/inline-size
					if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
						break
					}
				}
				// height/width: min-content / width: max-content
				case 931:
				case 953: {
					if (dimensionptn.test(input) === true) {
						// stretch
						if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
							return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
						else
							return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
					}
					break
				}
				// transform, transition: t, r, a
				case 962: {
					out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out
	
					// transitions
					if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
						return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
					}
	
					break
				}
			}
	
			return out
		}
	
		/**
		 * Vendor
		 *
		 * @param {string} content
		 * @param {number} context
		 * @return {boolean}
		 */
		function vendor (content, context) {
			var index = content.indexOf(context === 1 ? ':' : '{')
			var key = content.substring(0, context !== 3 ? index : 10)
			var value = content.substring(index + 1, content.length - 1)
	
			return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
		}
	
		/**
		 * Supports
		 *
		 * @param {string} match
		 * @param {string} group
		 * @return {string}
		 */
		function supports (match, group) {
			var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))
	
			return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
		}
	
		/**
		 * Animation
		 *
		 * @param {string} input
		 * @return {string}
		 */
		function animation (input) {
			var length = input.length
			var index = input.indexOf(':', 9) + 1
			var declare = input.substring(0, index).trim()
			var out = input.substring(index, length-1).trim()
	
			switch (input.charCodeAt(9)*keyed) {
				case 0: {
					break
				}
				// animation-*, -
				case DASH: {
					// animation-name, n
					if (input.charCodeAt(10) !== 110) {
						break
					}
				}
				// animation/animation-name
				default: {
					// split in case of multiple animations
					var list = out.split((out = '', animationptn))
	
					for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
						var value = list[i]
						var items = value.split(propertiesptn)
	
						while (value = items[index]) {
							var peak = value.charCodeAt(0)
	
							if (keyed === 1 && (
								// letters
								(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
								// dash but not in sequence i.e --
								(peak === DASH && value.charCodeAt(1) !== DASH)
							)) {
								// not a number/function
								switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
									case 1: {
										switch (value) {
											// not a valid reserved keyword
											case 'infinite': case 'alternate': case 'backwards': case 'running':
											case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
											case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
											case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
											case 'initial': case 'unset': case 'step-start': case 'step-end': {
												break
											}
											default: {
												value += key
											}
										}
									}
								}
							}
	
							items[index++] = value
						}
	
						out += (i === 0 ? '' : ',') + items.join(' ')
					}
				}
			}
	
			out = declare + out + ';'
	
			if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
				return webkit + out + out
	
			return out
		}
	
		/**
		 * Isolate
		 *
		 * @param {Array<string>} current
		 */
		function isolate (current) {
			for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
				// split individual elements in a selector i.e h1 h2 === [h1, h2]
				var elements = current[i].split(elementptn)
				var out = ''
	
				for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
					// empty element
					if ((size = (element = elements[j]).length) === 0 && l > 1) {
						continue
					}
	
					tail = out.charCodeAt(out.length-1)
					code = element.charCodeAt(0)
					padding = ''
	
					if (j !== 0) {
						// determine if we need padding
						switch (tail) {
							case STAR:
							case TILDE:
							case GREATERTHAN:
							case PLUS:
							case SPACE:
							case OPENPARENTHESES:  {
								break
							}
							default: {
								padding = ' '
							}
						}
					}
	
					switch (code) {
						case AND: {
							element = padding + nscopealt
						}
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case CLOSEPARENTHESES:
						case OPENPARENTHESES: {
							break
						}
						case OPENBRACKET: {
							element = padding + element + nscopealt
							break
						}
						case COLON: {
							switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
								// :global
								case 530: {
									if (escape > 0) {
										element = padding + element.substring(8, size - 1)
										break
									}
								}
								// :hover, :nth-child(), ...
								default: {
									if (j < 1 || elements[j-1].length < 1) {
										element = padding + nscopealt + element
									}
								}
							}
							break
						}
						case COMMA: {
							padding = ''
						}
						default: {
							if (size > 1 && element.indexOf(':') > 0) {
								element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
							} else {
								element = padding + element + nscopealt
							}
						}
					}
	
					out += element
				}
	
				selector[i] = out.replace(formatptn, '').trim()
			}
	
			return selector
		}
	
		/**
		 * Proxy
		 *
		 * @param {number} context
		 * @param {string} content
		 * @param {Array<string>} selectors
		 * @param {Array<string>} parents
		 * @param {number} line
		 * @param {number} column
		 * @param {number} length
		 * @param {number} id
		 * @param {number} depth
		 * @param {number} at
		 * @return {(string|void|*)}
		 */
		function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
			for (var i = 0, out = content, next; i < plugged; ++i) {
				switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
					case void 0:
					case false:
					case true:
					case null: {
						break
					}
					default: {
						out = next
					}
				}
			}
			if (out !== content) {
			  return out
			}
		}
	
		/**
		 * @param {number} code
		 * @param {number} index
		 * @param {number} length
		 * @param {string} body
		 * @return {number}
		 */
		function delimited (code, index, length, body) {
			for (var i = index + 1; i < length; ++i) {
				switch (body.charCodeAt(i)) {
					// /*
					case FOWARDSLASH: {
						if (code === STAR) {
							if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
								return i + 1
							}
						}
						break
					}
					// //
					case NEWLINE: {
						if (code === FOWARDSLASH) {
							return i + 1
						}
					}
				}
			}
	
			return i
		}
	
		/**
		 * @param {number} type
		 * @param {number} index
		 * @param {number} length
		 * @param {number} find
		 * @param {string} body
		 * @return {number}
		 */
		function match (type, index, length, body) {
			for (var i = index + 1; i < length; ++i) {
				switch (body.charCodeAt(i)) {
					case type: {
						return i
					}
				}
			}
	
			return i
		}
	
		/**
		 * Minify
		 *
		 * @param {(string|*)} output
		 * @return {string}
		 */
		function minify (output) {
			return output
				.replace(formatptn, '')
				.replace(beforeptn, '')
				.replace(afterptn, '$1')
				.replace(tailptn, '$1')
				.replace(whiteptn, ' ')
		}
	
		/**
		 * Use
		 *
		 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
		 */
		function use (plugin) {
			switch (plugin) {
				case void 0:
				case null: {
					plugged = plugins.length = 0
					break
				}
				default: {
					if (typeof plugin === 'function') {
						plugins[plugged++] = plugin
					}	else if (typeof plugin === 'object') {
						for (var i = 0, length = plugin.length; i < length; ++i) {
							use(plugin[i])
						}
					} else {
						unkwn = !!plugin|0
					}
				}
	 		}
	
	 		return use
		}
	
		/**
		 * Set
		 *
		 * @param {*} options
		 */
		function set (options) {
			for (var name in options) {
				var value = options[name]
				switch (name) {
					case 'keyframe': keyed = value|0; break
					case 'global': escape = value|0; break
					case 'cascade': cascade = value|0; break
					case 'compress': compress = value|0; break
					case 'semicolon': semicolon = value|0; break
					case 'preserve': preserve = value|0; break
					case 'prefix':
						should = null
	
						if (!value) {
							prefix = 0
						} else if (typeof value !== 'function') {
							prefix = 1
						} else {
							prefix = 2
							should = value
						}
				}
			}
	
			return set
		}
	
		/**
		 * Stylis
		 *
		 * @param {string} selector
		 * @param {string} input
		 * @return {*}
		 */
		function stylis (selector, input) {
			if (this !== void 0 && this.constructor === stylis) {
				return factory(selector)
			}
	
			// setup
			var ns = selector
			var code = ns.charCodeAt(0)
	
			// trim leading whitespace
			if (code < 33) {
				code = (ns = ns.trim()).charCodeAt(0)
			}
	
			// keyframe/animation namespace
			if (keyed > 0) {
				key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
			}
	
			// reset, used to assert if a plugin is moneky-patching the return value
			code = 1
	
			// cascade/isolate
			if (cascade === 1) {
				nscope = ns
			} else {
				nscopealt = ns
			}
	
			var selectors = [nscope]
			var result
	
			// execute plugins, pre-process context
			if (plugged > 0) {
				result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)
	
				if (result !== void 0 && typeof result === 'string') {
					input = result
				}
			}
	
			// build
			var output = compile(array, selectors, input, 0, 0)
	
			// execute plugins, post-process context
			if (plugged > 0) {
				result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)
	
				// bypass minification
				if (result !== void 0 && typeof(output = result) !== 'string') {
					code = 0
				}
			}
	
			// reset
			key = ''
			nscope = ''
			nscopealt = ''
			pattern = 0
			line = 1
			column = 1
	
			return compress*code === 0 ? output : minify(output)
		}
	
		stylis['use'] = use
		stylis['set'] = set
	
		if (options !== void 0) {
			set(options)
		}
	
		return stylis
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)(module)))

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

	/**
	 * This file automatically generated from `pre-publish.js`.
	 * Do not manually edit.
	 */
	
	module.exports = {
	  "area": true,
	  "base": true,
	  "br": true,
	  "col": true,
	  "embed": true,
	  "hr": true,
	  "img": true,
	  "input": true,
	  "keygen": true,
	  "link": true,
	  "menuitem": true,
	  "meta": true,
	  "param": true,
	  "source": true,
	  "track": true,
	  "wbr": true
	};


/***/ }),

/***/ 26:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(3);
	
	var _surveyor = __webpack_require__(305);
	
	var _surveyor2 = _interopRequireDefault(_surveyor);
	
	var _styledComponents = __webpack_require__(175);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RepeatingElements = function (_Component) {
	  _inherits(RepeatingElements, _Component);
	
	  function RepeatingElements(props) {
	    _classCallCheck(this, RepeatingElements);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      bodyHeight: 0,
	      stamps: []
	    };
	    _this.stamps = null;
	    _this.shuffle = _this.shuffle.bind(_this);
	    return _this;
	  }
	
	  RepeatingElements.prototype.componentDidMount = function componentDidMount() {
	    var stamps = this.props.stamps;
	
	    var bodyHeight = this.mainContainer.offsetHeight;
	    this.setState({
	      bodyHeight: bodyHeight,
	      stamps: stamps
	    });
	  };
	
	  RepeatingElements.prototype.shuffle = function shuffle(a) {
	    for (var i = a.length - 1; i > 0; i--) {
	      var j = Math.floor(Math.random() * (i + 1));
	      var _ref = [a[j], a[i]];
	      a[i] = _ref[0];
	      a[j] = _ref[1];
	    }
	    return a;
	  };
	
	  RepeatingElements.prototype.createSurveyorBackground = function createSurveyorBackground() {
	    var surveyorBackgrounds = [];
	    var surveyorBackgroundsLeft = true;
	    for (var i = 0; i < this.state.bodyHeight - 1250; i += 1250) {
	      var background = _react2.default.createElement(
	        'div',
	        { key: i, style: {
	            position: 'absolute',
	            top: i + 50 + 'px',
	            left: surveyorBackgroundsLeft ? 'auto' : '-500px',
	            right: surveyorBackgroundsLeft ? '-500px' : 'auto',
	            textAlign: surveyorBackgroundsLeft ? 'left' : 'right',
	            width: '100%'
	          }
	        },
	        _react2.default.createElement(_surveyor2.default, { style: {
	            transform: 'rotate(' + Math.random() * 360 + 'deg)'
	          } })
	      );
	      surveyorBackgrounds.push(background);
	      surveyorBackgroundsLeft = !surveyorBackgroundsLeft;
	    }
	    return surveyorBackgrounds;
	  };
	
	  RepeatingElements.prototype.createStamps = function createStamps(stamps) {
	    var stampLoop = 0;
	    var stampsArray = [];
	    var stampsLeft = true;
	    var stampRed = true;
	    var stamp = '';
	    stamps = this.shuffle(stamps);
	    for (var i = 0; i < this.state.bodyHeight - 1000; i += 550 + Math.random() * 400) {
	      if (stamps[stampLoop % stamps.length] === 'stripes') {
	        var colorRandomizer = Math.random();
	        stamp = _react2.default.createElement(
	          'div',
	          { key: i, style: {
	              position: 'absolute',
	              top: i + 1000 + 'px',
	              left: stampsLeft ? '10px' : 'auto',
	              right: stampsLeft ? 'auto' : '10px',
	              textAlign: stampsLeft ? 'left' : 'right',
	              width: '100%'
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { style: {
	                display: 'inline-block',
	                width: '20px',
	                height: '170px',
	                position: 'relative',
	                overflow: 'hidden'
	              } },
	            _react2.default.createElement('div', { style: {
	                width: '20px',
	                height: '197px',
	                textAlign: 'left',
	                background: 'repeating-linear-gradient(45deg, ' + (colorRandomizer > 0.5 ? _colors2.default['lipstick'] : _colors2.default['peacock-blue']) + ', ' + (colorRandomizer > 0.5 ? _colors2.default['lipstick'] : _colors2.default['peacock-blue']) + ' 20px, rgba(255, 255, 255, 0.5) 20px, rgba(255, 255, 255, 0.5) 40px)'
	              } })
	          )
	        );
	      } else {
	        var stampPhrase = stamps[stampLoop % stamps.length].map(function (element, index) {
	          return _react2.default.createElement(
	            'span',
	            { key: index },
	            element,
	            _react2.default.createElement('br', null)
	          );
	        });
	        stamp = _react2.default.createElement(
	          'div',
	          { key: i, style: {
	              position: 'absolute',
	              top: i + 1000 + 'px',
	              left: stampsLeft ? '10px' : 'auto',
	              right: stampsLeft ? 'auto' : '50px',
	              textAlign: stampsLeft ? 'left' : 'right',
	              width: '100%'
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { style: {
	                transform: 'rotate(-90deg)',
	                transformOrigin: 'center center',
	                display: 'inline-block',
	                width: '10px',
	                height: '10px',
	                position: 'relative',
	                overflow: 'visible'
	              } },
	            _react2.default.createElement(
	              'div',
	              { style: { width: '1000px', textAlign: 'left' } },
	              _react2.default.createElement(
	                'div',
	                { style: {
	                    border: 'solid 4px ' + (stampRed ? _colors2.default['lipstick'] : _colors2.default['peacock-blue']),
	                    color: '' + (stampRed ? _colors2.default['lipstick'] : _colors2.default['peacock-blue']),
	                    display: 'inline-block',
	                    textAlign: 'center',
	                    fontFamily: '"OneDotExt", sans-serif',
	                    fontSize: '10px',
	                    fontWeight: 'bold',
	                    textTransform: 'uppercase',
	                    padding: '3px 2px',
	                    marginRight: '10px'
	                  }
	                },
	                stampPhrase
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: {
	                    border: 'solid 4px ' + (stampRed ? _colors2.default['lipstick'] : _colors2.default['peacock-blue']),
	                    color: '' + (stampRed ? _colors2.default['lipstick'] : _colors2.default['peacock-blue']),
	                    display: 'inline-block',
	                    textAlign: 'center',
	                    fontFamily: '"OneDotExt", sans-serif',
	                    fontSize: '10px',
	                    fontWeight: 'bold',
	                    textTransform: 'uppercase',
	                    padding: '3px 2px',
	                    marginRight: '10px'
	                  }
	                },
	                stampPhrase
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: {
	                    border: 'solid 4px ' + (stampRed ? _colors2.default['lipstick'] : _colors2.default['peacock-blue']),
	                    color: '' + (stampRed ? _colors2.default['lipstick'] : _colors2.default['peacock-blue']),
	                    display: 'inline-block',
	                    textAlign: 'center',
	                    fontFamily: '"OneDotExt", sans-serif',
	                    fontSize: '10px',
	                    fontWeight: 'bold',
	                    textTransform: 'uppercase',
	                    padding: '3px 2px',
	                    marginRight: '10px'
	                  }
	                },
	                stampPhrase
	              )
	            )
	          )
	        );
	      }
	      stampsArray.push(stamp);
	      stampsLeft = !stampsLeft;
	      stampRed = !stampRed;
	      stampLoop++;
	    }
	    return stampsArray;
	  };
	
	  RepeatingElements.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { style: { position: 'absolute', width: '100%', zIndex: '-999', top: 0, left: 0, right: 0, bottom: '-120px', overflow: 'hidden' }, ref: function ref(div) {
	          _this2.mainContainer = div;
	        } },
	      _react2.default.createElement(
	        _grid.Container,
	        { style: { position: 'relative' } },
	        _react2.default.createElement(
	          _styledComponents.RepeatingElementsWrapper,
	          null,
	          this.createSurveyorBackground(),
	          this.createStamps(this.state.stamps)
	        )
	      )
	    );
	  };
	
	  return RepeatingElements;
	}(_react.Component);
	
	exports.default = RepeatingElements;
	module.exports = exports['default'];

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.RepeatingElementsWrapper = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RepeatingElementsWrapper = exports.RepeatingElementsWrapper = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__RepeatingElementsWrapper',
	    componentId: 'qntswp-0'
	})(['svg{animation-name:lavaLamp;animation-timing-function:linear;animation-iteration-count:infinite;animation-duration:180s;animation-play-state:running;@keyframes lavaLamp{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}}']);

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Column = exports.Row = exports.Container = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _gutters = __webpack_require__(12);
	
	var _gutters2 = _interopRequireDefault(_gutters);
	
	var _moduleMargins = __webpack_require__(70);
	
	var _moduleMargins2 = _interopRequireDefault(_moduleMargins);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = exports.Container = _styledComponents2.default.div.withConfig({
	    displayName: 'grid__Container',
	    componentId: 'sc-27ztpi-0'
	})(['max-width:1440px;padding:0 ', ';margin:0 auto;box-sizing:content-box;@media (max-width:', '){max-width:930px;padding:0 ', ';}@media (max-width:', '){max-width:700px;padding:0 ', ';}@media (max-width:', '){padding:0 ', ';max-width:100%;overflow:hidden;}'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile']);
	
	var Row = exports.Row = _styledComponents2.default.div.withConfig({
	    displayName: 'grid__Row',
	    componentId: 'sc-27ztpi-1'
	})(['display:flex;flex-wrap:wrap;margin-left:', ';margin-right:', ';margin-top:', 'px;@media (max-width:', '){margin-left:', ';margin-right:', ';margin-top:', 'px;}@media (max-width:', '){margin-left:', ';margin-right:', ';margin-top:', 'px;}@media (max-width:', '){margin-left:', ';margin-right:', ';margin-top:', 'px;}', ''], _gutters2.default['row-gutters-desktop-l'], _gutters2.default['row-gutters-desktop-l'], function (props) {
	    return props.margins !== false ? function (props) {
	        return props.margins && props.margins[0] !== undefined ? function (props) {
	            return props.margins[0];
	        } : _moduleMargins2.default['desktop-l'];
	    } : '0';
	}, _breakpoints2.default['bp-desktop'], _gutters2.default['row-gutters-desktop'], _gutters2.default['row-gutters-desktop'], function (props) {
	    return props.margins !== false ? function (props) {
	        return props.margins && props.margins[1] !== undefined ? function (props) {
	            return props.margins[1];
	        } : _moduleMargins2.default['desktop'];
	    } : '0';
	}, _breakpoints2.default['bp-tablet'], _gutters2.default['row-gutters-tablet'], _gutters2.default['row-gutters-tablet'], function (props) {
	    return props.margins !== false ? function (props) {
	        return props.margins && props.margins[2] !== undefined ? function (props) {
	            return props.margins[2];
	        } : _moduleMargins2.default['tablet'];
	    } : '0';
	}, _breakpoints2.default['bp-mobile'], _gutters2.default['row-gutters-mobile'], _gutters2.default['row-gutters-mobile'], function (props) {
	    return props.margins !== false ? function (props) {
	        return props.margins && props.margins[3] !== undefined ? function (props) {
	            return props.margins[3];
	        } : _moduleMargins2.default['mobile'];
	    } : '0';
	}, function (props) {
	    return props.cblockPaddingTop && (0, _styledComponents.css)(['padding-top:calc(', ' * 0.7);@media (max-width:', '){padding-top:calc(', ' * 0.7);}@media (max-width:', '){padding-top:calc(', ' * 0.7);}@media (max-width:', '){padding-top:calc(', ' * 0.7);}'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile']);
	});
	
	var Column = exports.Column = _styledComponents2.default.div.withConfig({
	    displayName: 'grid__Column',
	    componentId: 'sc-27ztpi-2'
	})(['', '     flex:', ';max-width:', ';margin-left:', ';box-sizing:border-box;padding-left:', ';padding-right:', ';@media (max-width:', '){padding-left:', ';padding-right:', ';}@media (max-width:', '){padding-left:', ';padding-right:', ';', ' ', '}@media (max-width:', '){max-width:100%;padding-left:', ';padding-right:', ';flex:', ';margin-left:', ';}'], function (props) {
	    return props.flex && (0, _styledComponents.css)(['display:flex;']);
	}, function (props) {
	    return props.cw ? '0 0 ' + props.cw / 12 * 100 + '%' : '1 1 auto';
	}, function (props) {
	    return props.cw ? props.cw / 12 * 100 + '%' : 'none';
	}, function (props) {
	    return props.offset ? 'calc((' + props.offset / 12 + ') * 100%)' : '0';
	}, _gutters2.default['column-gutters-desktop-l'], _gutters2.default['column-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['column-gutters-desktop'], _gutters2.default['column-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['column-gutters-tablet'], _gutters2.default['column-gutters-tablet'], function (props) {
	    return props.tcw && (0, _styledComponents.css)(['flex:', ';max-width:', ';'], function (props) {
	        return props.tcw ? '0 0 ' + props.tcw / 12 * 100 + '%' : '1 1 auto';
	    }, function (props) {
	        return props.tcw ? props.tcw / 12 * 100 + '%' : 'none';
	    });
	}, function (props) {
	    return props.tOffset && (0, _styledComponents.css)(['margin-left:', ';'], function (props) {
	        return props.tOffset ? 'calc((' + props.tOffset / 12 + ') * 100%)' : '0';
	    });
	}, _breakpoints2.default['bp-mobile'], _gutters2.default['column-gutters-mobile'], _gutters2.default['column-gutters-mobile'], function (props) {
	    return props.mcw ? '0 0 ' + props.mcw / 4 * 100 + '%' : '0 0 100%';
	}, function (props) {
	    return props.mobileOffset ? 'calc((' + props.mobileOffset / 4 + ') * 100%)' : '0';
	});

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(42);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Image = function Image(_ref) {
	    var aspectHeight = _ref.aspectHeight,
	        aspectWidth = _ref.aspectWidth,
	        sizes = _ref.sizes;
	
	    return _react2.default.createElement(
	        'div',
	        { style: { width: '100%', position: 'relative', overflow: 'hidden' } },
	        _react2.default.createElement('div', { style: { width: '100%', paddingTop: 'calc((' + aspectHeight + '/' + aspectWidth + ') * 100%)' } }),
	        _react2.default.createElement(
	            'div',
	            { style: {
	                    position: 'absolute',
	                    width: '100%',
	                    top: 0,
	                    bottom: 0,
	                    left: '50%',
	                    transform: 'translate(-50%, 0)'
	                } },
	            _react2.default.createElement(_gatsbyImage2.default, {
	                sizes: sizes,
	                style: {
	                    position: "absolute",
	                    left: 0,
	                    top: 0,
	                    width: "100%",
	                    height: "100%"
	                }
	            })
	        )
	    );
	};
	
	exports.default = Image;
	module.exports = exports['default'];

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(22);
	
	var _grid = __webpack_require__(3);
	
	var _styledComponents = __webpack_require__(176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Video = (_dec = (0, _mobxReact.inject)("store"), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
	    _inherits(Video, _Component);
	
	    function Video(props) {
	        _classCallCheck(this, Video);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	            playing: false
	        };
	
	        _this.video = null;
	        _this.handleClick = _this.handleClick.bind(_this);
	        _this.videoEnded = _this.videoEnded.bind(_this);
	        _this.onTimeUpdate = _this.onTimeUpdate.bind(_this);
	
	        _this.quarterComplete = false;
	        _this.halfComplete = false;
	        _this.threeQuartersComplete = false;
	        return _this;
	    }
	
	    Video.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        var store = this.props.store;
	
	        this.video.addEventListener('ended', this.videoEnded);
	        if (store.os.name === 'ios') {
	            setTimeout(function () {
	                var playPromise = _this2.video.play();
	                if (playPromise !== undefined) {
	                    playPromise.then(function () {
	                        _this2.video.pause();
	                    }).catch(function (error) {
	                        // Automatic playback failed.
	                        // Show a UI element to let the user manually start playback.
	                    });
	                } else {
	                    _this2.video.pause();
	                }
	            }, 1);
	        }
	    };
	
	    Video.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.video.removeEventListener('ended', this.videoEnded);
	    };
	
	    Video.prototype.videoEnded = function videoEnded() {
	        var _props = this.props,
	            srcMp4 = _props.srcMp4,
	            srcWebM = _props.srcWebM;
	
	        this.setState({
	            playing: false
	        });
	        window.dataLayer.push({
	            'event': 'video:complete',
	            /* 'videoName': '<name of video>', */
	            'videoLength': this.video.duration,
	            'videoLocation': srcMp4
	        });
	    };
	
	    Video.prototype.handleClick = function handleClick() {
	        var _props2 = this.props,
	            srcMp4 = _props2.srcMp4,
	            srcWebM = _props2.srcWebM;
	
	        if (this.video.paused || this.video.ended) {
	            // console.log('bing');
	            this.video.play();
	            this.setState({
	                playing: true
	            });
	            window.dataLayer.push({
	                'event': 'video:play',
	                /* 'videoName': '<name of video>', */
	                'videoLength': this.video.duration,
	                'videoLocation': srcMp4
	            });
	        } else {
	            this.video.pause();
	            this.setState({
	                playing: false
	            });
	            window.dataLayer.push({
	                'event': 'video:pause',
	                /* 'videoName': '<name of video>', */
	                'videoLength': this.video.duration,
	                'videoLocation': srcMp4
	            });
	        }
	    };
	
	    Video.prototype.onTimeUpdate = function onTimeUpdate(e) {
	        var _props3 = this.props,
	            srcMp4 = _props3.srcMp4,
	            srcWebM = _props3.srcWebM;
	
	        var videoFrame = Math.round(e.target.currentTime);
	        var videoProgress = videoFrame / this.video.duration;
	        if (videoProgress > 0.25 && videoProgress < 0.5) {
	            if (!this.quarterComplete) {
	                window.dataLayer.push({
	                    'event': 'video:progress',
	                    'videoCompletion': '25',
	                    'videoDuration': this.video.duration,
	                    'videoLocation': srcMp4
	                });
	                this.quarterComplete = true;
	            }
	        } else if (videoProgress > 0.5 && videoProgress < 0.75) {
	            if (!this.halfComplete) {
	                window.dataLayer.push({
	                    'event': 'video:progress',
	                    'videoCompletion': '50',
	                    'videoDuration': this.video.duration,
	                    'videoLocation': srcMp4
	                });
	                this.halfComplete = true;
	            }
	        } else if (videoProgress > 0.75 && videoProgress < 1) {
	            if (!this.threeQuartersComplete) {
	                window.dataLayer.push({
	                    'event': 'video:progress',
	                    'videoCompletion': '75',
	                    'videoDuration': this.video.duration,
	                    'videoLocation': srcMp4
	                });
	                this.threeQuartersComplete = true;
	            }
	        } else {
	            this.quarterComplete = false;
	            this.halfComplete = false;
	            this.threeQuartersComplete = false;
	        }
	    };
	
	    Video.prototype.render = function render() {
	        var _this3 = this;
	
	        var _props4 = this.props,
	            srcMp4 = _props4.srcMp4,
	            srcWebM = _props4.srcWebM,
	            tall = _props4.tall;
	
	        if (!tall) {
	            return _react2.default.createElement(
	                _styledComponents.VideoPlayer,
	                null,
	                _react2.default.createElement('div', { style: { width: '100%', paddingBottom: 'calc((9/16) * 100%)' } }),
	                _react2.default.createElement(
	                    'video',
	                    {
	                        ref: function ref(video) {
	                            _this3.video = video;
	                        },
	                        width: '100%',
	                        height: 'auto',
	                        playsInline: 'true',
	                        onTimeUpdate: this.onTimeUpdate,
	                        style: {
	                            position: 'absolute',
	                            top: 0,
	                            bottom: 0,
	                            right: 0,
	                            left: 0
	                        }
	                    },
	                    _react2.default.createElement('source', { src: srcWebM, type: 'video/webm' }),
	                    _react2.default.createElement('source', { src: srcMp4, type: 'video/mp4' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        onClick: this.handleClick,
	                        className: 'ui-holder ' + (this.state.playing ? 'playing' : ''),
	                        style: {
	                            position: 'absolute',
	                            top: 0,
	                            bottom: 0,
	                            right: 0,
	                            left: 0,
	                            display: 'flex',
	                            alignItems: 'center',
	                            justifyContent: 'center'
	                        }
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: 'ui-button',
	                            style: {
	                                height: '120px',
	                                width: '120px',
	                                boxSizing: 'border-box',
	                                borderRadius: '60px',
	                                border: 'solid 5px white',
	                                display: 'flex',
	                                alignItems: 'center',
	                                justifyContent: 'center',
	                                cursor: 'pointer'
	                            } },
	                        this.state.playing === false && _react2.default.createElement(
	                            'svg',
	                            { width: '34px', height: '31px', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	                            _react2.default.createElement(
	                                'g',
	                                { id: 'Desktop', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	                                _react2.default.createElement(
	                                    'g',
	                                    { id: 'dominos-casestudy-desktop', transform: 'translate(-709.000000, -523.000000)', fill: '#FFFFFF' },
	                                    _react2.default.createElement(
	                                        'g',
	                                        { id: 'Hero' },
	                                        _react2.default.createElement(
	                                            'g',
	                                            { id: 'Video', transform: 'translate(200.000000, 197.000000)' },
	                                            _react2.default.createElement(
	                                                'g',
	                                                { id: 'ICON', transform: 'translate(459.000000, -127.000000)' },
	                                                _react2.default.createElement(
	                                                    'g',
	                                                    { id: 'PLAY-ICON', transform: 'translate(8.000000, 407.000000)' },
	                                                    _react2.default.createElement('polygon', { id: 'Triangle', points: '75 61.5 50 77 50 46' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        this.state.playing && _react2.default.createElement(
	                            'svg',
	                            { width: '34px', height: '31px', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	                            _react2.default.createElement(
	                                'g',
	                                { id: 'Desktop', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	                                _react2.default.createElement(
	                                    'g',
	                                    { id: 'dominos-casestudy-desktop', transform: 'translate(-709.000000, -523.000000)', fill: '#FFFFFF' },
	                                    _react2.default.createElement(
	                                        'g',
	                                        { id: 'Hero' },
	                                        _react2.default.createElement(
	                                            'g',
	                                            { id: 'Video', transform: 'translate(200.000000, 197.000000)' },
	                                            _react2.default.createElement(
	                                                'g',
	                                                { id: 'ICON', transform: 'translate(459.000000, -127.000000)' },
	                                                _react2.default.createElement(
	                                                    'g',
	                                                    { id: 'PLAY-ICON', transform: 'translate(5.000000, 407.000000)' },
	                                                    _react2.default.createElement('rect', { width: '10', height: '40', x: '50', y: '46' }),
	                                                    _react2.default.createElement('rect', { width: '10', height: '40', x: '65', y: '46' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        } else {
	            return _react2.default.createElement(
	                _styledComponents.VideoPlayer,
	                null,
	                _react2.default.createElement('div', { style: { width: '100%', paddingTop: 'calc((10/7) * 100%)' } }),
	                _react2.default.createElement(
	                    'video',
	                    {
	                        ref: function ref(video) {
	                            _this3.video = video;
	                        },
	                        width: 'auto',
	                        height: '100%',
	                        playsInline: 'true',
	                        onTimeUpdate: this.onTimeUpdate,
	                        style: {
	                            position: 'absolute',
	                            top: 0,
	                            bottom: 0,
	                            right: 0,
	                            left: '-50%'
	                        }
	                    },
	                    _react2.default.createElement('source', { src: srcWebM, type: 'video/webm' }),
	                    _react2.default.createElement('source', { src: srcMp4, type: 'video/mp4' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        onClick: this.handleClick,
	                        className: 'ui-holder ' + (this.state.playing ? 'playing' : ''),
	                        style: {
	                            position: 'absolute',
	                            top: 0,
	                            bottom: 0,
	                            right: 0,
	                            left: 0,
	                            display: 'flex',
	                            alignItems: 'center',
	                            justifyContent: 'center'
	                        }
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: 'ui-button',
	                            style: {
	                                height: '120px',
	                                width: '120px',
	                                boxSizing: 'border-box',
	                                borderRadius: '60px',
	                                border: 'solid 5px white',
	                                display: 'flex',
	                                alignItems: 'center',
	                                justifyContent: 'center',
	                                cursor: 'pointer'
	                            } },
	                        this.state.playing === false && _react2.default.createElement(
	                            'svg',
	                            { width: '34px', height: '31px', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	                            _react2.default.createElement(
	                                'g',
	                                { id: 'Desktop', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	                                _react2.default.createElement(
	                                    'g',
	                                    { id: 'dominos-casestudy-desktop', transform: 'translate(-709.000000, -523.000000)', fill: '#FFFFFF' },
	                                    _react2.default.createElement(
	                                        'g',
	                                        { id: 'Hero' },
	                                        _react2.default.createElement(
	                                            'g',
	                                            { id: 'Video', transform: 'translate(200.000000, 197.000000)' },
	                                            _react2.default.createElement(
	                                                'g',
	                                                { id: 'ICON', transform: 'translate(459.000000, -127.000000)' },
	                                                _react2.default.createElement(
	                                                    'g',
	                                                    { id: 'PLAY-ICON', transform: 'translate(8.000000, 407.000000)' },
	                                                    _react2.default.createElement('polygon', { id: 'Triangle', points: '75 61.5 50 77 50 46' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        this.state.playing && _react2.default.createElement(
	                            'svg',
	                            { width: '34px', height: '31px', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	                            _react2.default.createElement(
	                                'g',
	                                { id: 'Desktop', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	                                _react2.default.createElement(
	                                    'g',
	                                    { id: 'dominos-casestudy-desktop', transform: 'translate(-709.000000, -523.000000)', fill: '#FFFFFF' },
	                                    _react2.default.createElement(
	                                        'g',
	                                        { id: 'Hero' },
	                                        _react2.default.createElement(
	                                            'g',
	                                            { id: 'Video', transform: 'translate(200.000000, 197.000000)' },
	                                            _react2.default.createElement(
	                                                'g',
	                                                { id: 'ICON', transform: 'translate(459.000000, -127.000000)' },
	                                                _react2.default.createElement(
	                                                    'g',
	                                                    { id: 'PLAY-ICON', transform: 'translate(5.000000, 407.000000)' },
	                                                    _react2.default.createElement('rect', { width: '10', height: '40', x: '50', y: '46' }),
	                                                    _react2.default.createElement('rect', { width: '10', height: '40', x: '65', y: '46' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    };
	
	    return Video;
	}(_react.Component)) || _class) || _class);
	exports.default = Video;
	module.exports = exports['default'];

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.VideoPlayer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import gutters from '../../../vars/gutters';
	
	
	var VideoPlayer = exports.VideoPlayer = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__VideoPlayer',
	    componentId: 'sc-1hd1mjt-0'
	})(['.ui-holder{cursor:pointer;.ui-button{opacity:1;transition:opacity 300ms ease-in-out;}&.playing{.ui-button{opacity:0;}&:hover{.ui-button{opacity:1;}}@media (max-width:', '){&:hover{.ui-button{opacity:0;}}}}}'], _breakpoints2.default['bp-mobile']);
	// import colors from '../../../vars/colors';

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BODY = exports.H2 = exports.H1 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _typography = __webpack_require__(125);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var H1 = exports.H1 = _styledComponents2.default.h1.withConfig({
	    displayName: 'typography__H1',
	    componentId: 'sc-1uxgk65-0'
	})(['font-size:62px;font-family:\'OneDotCd\',sans-serif;font-weight:bold;color:', ';letter-spacing:2px;text-transform:uppercase;@media (max-width:', '){font-size:45px;letter-spacing:normal;}@media (max-width:', '){font-size:36px;letter-spacing:normal;}'], function (props) {
	    return props.color === 'blue' ? _colors2.default['peacock-blue'] : _colors2.default['lipstick'];
	}, _breakpoints2.default['bp-tablet'], _breakpoints2.default['bp-mobile']);
	
	var H2 = exports.H2 = _styledComponents2.default.h2.withConfig({
	    displayName: 'typography__H2',
	    componentId: 'sc-1uxgk65-1'
	})(['font-size:50px;font-family:\'OneDotCd\',sans-serif;font-weight:bold;color:', ';letter-spacing:3px;margin-bottom:20px;text-transform:uppercase;@media (max-width:', '){font-size:44px;letter-spacing:normal;}@media (max-width:', '){font-size:36px;letter-spacing:normal;}'], function (props) {
	    return props.color === 'blue' ? _colors2.default['peacock-blue'] : _colors2.default['lipstick'];
	}, _breakpoints2.default['bp-tablet'], _breakpoints2.default['bp-mobile']);
	
	var BODY = exports.BODY = _styledComponents2.default.div.withConfig({
	    displayName: 'typography__BODY',
	    componentId: 'sc-1uxgk65-2'
	})(['font-family:\'OneDot\',sans-serif;']);

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(19);
	
	var _grid = __webpack_require__(3);
	
	var _typography = __webpack_require__(29);
	
	var _Image = __webpack_require__(24);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _styledComponents = __webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CampaignSumamry = function CampaignSumamry(_ref) {
	    var data = _ref.data,
	        imageDictionary = _ref.imageDictionary,
	        t = _ref.t;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _grid.Row,
	            { style: { position: 'relative' } },
	            _react2.default.createElement(
	                _grid.Column,
	                { cw: 11, offset: 1 },
	                _react2.default.createElement(
	                    'div',
	                    { style: { width: '100%', position: 'relative' } },
	                    _react2.default.createElement(_styledComponents.ColorBlock, null),
	                    _react2.default.createElement(_Image2.default, { aspectWidth: 5, aspectHeight: 2, sizes: imageDictionary[data.image].sizes }),
	                    _react2.default.createElement('div', { style: {
	                            position: 'absolute',
	                            top: 0,
	                            bottom: 0,
	                            left: 0,
	                            right: 0,
	                            zIndex: 1,
	                            background: 'white',
	                            opacity: 0.5
	                        } })
	                )
	            ),
	            _react2.default.createElement(
	                _styledComponents.CardHolder,
	                null,
	                _react2.default.createElement(
	                    _grid.Row,
	                    { margins: false, style: { position: 'relative', marginBottom: '300px' } },
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { cw: 3, style: { position: 'relative' } },
	                        _react2.default.createElement(
	                            _styledComponents.Tile,
	                            { style: { marginTop: '60%' } },
	                            _react2.default.createElement(
	                                _styledComponents.ContentWrapper,
	                                null,
	                                _react2.default.createElement(
	                                    _styledComponents.Content,
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'label' },
	                                        t('campaignSummary.tile1.label')
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'dataPoint' },
	                                        t('campaignSummary.tile1.dataPoint')
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { cw: 3 },
	                        _react2.default.createElement(
	                            _styledComponents.Tile,
	                            { style: { marginTop: '40%' } },
	                            _react2.default.createElement(
	                                _styledComponents.ContentWrapper,
	                                null,
	                                _react2.default.createElement(
	                                    _styledComponents.Content,
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'label' },
	                                        t('campaignSummary.tile2.label')
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'dataPoint' },
	                                        t('campaignSummary.tile2.dataPoint')
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { cw: 3 },
	                        _react2.default.createElement(
	                            _styledComponents.Tile,
	                            { style: { marginTop: '20%' } },
	                            _react2.default.createElement(
	                                _styledComponents.ContentWrapper,
	                                null,
	                                _react2.default.createElement(
	                                    _styledComponents.Content,
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'label' },
	                                        t('campaignSummary.tile3.label')
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'dataPoint' },
	                                        t('campaignSummary.tile3.dataPoint')
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { cw: 3 },
	                        _react2.default.createElement(
	                            _styledComponents.Tile,
	                            { style: { marginTop: '0%' } },
	                            _react2.default.createElement(
	                                _styledComponents.ContentWrapper,
	                                null,
	                                _react2.default.createElement(
	                                    _styledComponents.Content,
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'label' },
	                                        t('campaignSummary.tile4.label')
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'dataPoint' },
	                                        t('campaignSummary.tile4.dataPoint')
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = (0, _reactI18next.translate)()(CampaignSumamry);
	module.exports = exports['default'];

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CardHolder = exports.ColorBlock = exports.ImageRow = exports.Content = exports.ContentWrapper = exports.Tile = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _grid = __webpack_require__(3);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _gutters = __webpack_require__(12);
	
	var _gutters2 = _interopRequireDefault(_gutters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tile = exports.Tile = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__Tile',
	    componentId: 'sc-1lxu0lm-0'
	})(['width:100%;']);
	
	var ContentWrapper = exports.ContentWrapper = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__ContentWrapper',
	    componentId: 'sc-1lxu0lm-1'
	})(['width:100%;padding-top:100%;position:relative;border:solid 5px ', ';box-sizing:border-box;background:white;'], _colors2.default['peacock-blue']);
	
	var Content = exports.Content = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__Content',
	    componentId: 'sc-1lxu0lm-2'
	})(['position:absolute;top:0;bottom:0;left:0;right:0;display:flex;flex-direction:column;align-items:center;justify-content:center;.label{font-family:\'OneDotExt\',sans-serif;font-weight:bold;font-size:15px;color:', ';text-transform:uppercase;}.dataPoint{font-family:\'OneDotCd\',sans-serif;font-weight:bold;font-size:130px;color:', ';}'], _colors2.default['peacock-blue'], _colors2.default['lipstick']);
	
	var ImageRow = exports.ImageRow = (0, _styledComponents2.default)(_grid.Row).withConfig({
	    displayName: 'styled-components__ImageRow',
	    componentId: 'sc-1lxu0lm-3'
	})(['position:absolute;width:100%;left:0;right:0;z-index:-1;']);
	
	var ColorBlock = exports.ColorBlock = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__ColorBlock',
	    componentId: 'sc-1lxu0lm-4'
	})(['position:absolute;width:50%;bottom:50%;background:repeating-linear-gradient(-45deg,', ',', ' 25px,rgba(255,255,255,0.5) 25px,rgba(255,255,255,0.5) 50px);top:calc(', ' * -0.7);left:calc(', ' * -0.8);@media (max-width:', '){top:calc(', ' * -0.7);left:calc(', ' * -0.8);}@media (max-width:', '){top:calc(', ' * -0.7);left:calc(', ' * -0.8);}@media (max-width:', '){top:calc(', ' * -0.7);left:calc(', ' * -0.8);}'], _colors2.default['peacock-blue'], _colors2.default['peacock-blue'], _gutters2.default['container-gutters-desktop-l'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-mobile']);
	
	var CardHolder = exports.CardHolder = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__CardHolder',
	    componentId: 'sc-1lxu0lm-5'
	})(['z-index:3;position:absolute;width:95%;top:25%;right:calc(', ' * -0.3);@media (max-width:', '){right:calc(', ' * -0.3);}@media (max-width:', '){right:calc(', ' * -0.3);}@media (max-width:', '){right:calc(', ' * -0.3);}'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile']);

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(3);
	
	var _Image = __webpack_require__(24);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _StatCircle = __webpack_require__(103);
	
	var _StatCircle2 = _interopRequireDefault(_StatCircle);
	
	var _styledComponents = __webpack_require__(180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Carousel = function (_Component) {
	    _inherits(Carousel, _Component);
	
	    function Carousel(props) {
	        _classCallCheck(this, Carousel);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	            slideIndex: 0,
	            numberOfSlides: _this.props.data.images.length,
	            positioningValue: 0
	        };
	        _this.incrementSlides = _this.incrementSlides.bind(_this);
	        _this.decrementSlides = _this.decrementSlides.bind(_this);
	        _this.handleScroll = _this.handleScroll.bind(_this);
	        _this.setVanishingPoint = _this.setVanishingPoint.bind(_this);
	        return _this;
	    }
	
	    Carousel.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        document.addEventListener('scroll', this.handleScroll);
	        window.addEventListener('resize', this.setVanishingPoint);
	        setTimeout(function () {
	            _this2.setVanishingPoint();
	        }, 100);
	    };
	
	    Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	        document.removeEventListener('scroll', this.handleScroll);
	        window.removeEventListener('resize', this.setVanishingPoint);
	    };
	
	    Carousel.prototype.handleScroll = function handleScroll(e) {
	        this.latestKnownScrollY = window.scrollY ? window.scrollY : window.pageYOffset;
	        this.requestTick();
	    };
	
	    Carousel.prototype.requestTick = function requestTick() {
	        if (!this.ticking) {
	            requestAnimationFrame(this.update.bind(this));
	        }
	        this.ticking = true;
	    };
	
	    Carousel.prototype.setVanishingPoint = function setVanishingPoint() {
	        var scrollTop = document.documentElement ? document.documentElement.scrollTop : document.body.scrollTop;
	        var carouselTop = this.carouselHolder.getBoundingClientRect().top;
	        var carouselHeight = this.carouselHolder.getBoundingClientRect().height;
	        this.vanishingPoint = scrollTop + carouselTop + carouselHeight / 2;
	    };
	
	    Carousel.prototype.update = function update() {
	        this.ticking = false;
	        var posValCalc = 1 - (window.innerHeight - (this.vanishingPoint - this.latestKnownScrollY)) / window.innerHeight;
	        var positioningValue = 0;
	        if (posValCalc < 1 && posValCalc > 0) {
	            positioningValue = Math.round((1 - posValCalc) * 100) / 100;
	        } else if (posValCalc < 0) {
	            positioningValue = 1;
	        } else {
	            positioningValue = 0;
	        }
	        if (positioningValue !== this.state.positioningValue) {
	            this.setState({
	                positioningValue: positioningValue
	            });
	        }
	    };
	
	    Carousel.prototype.incrementSlides = function incrementSlides() {
	        var currentSlide = this.state.slideIndex;
	        var numberOfSlides = this.state.numberOfSlides - 1;
	        if (currentSlide !== numberOfSlides) {
	            this.setState({
	                slideIndex: currentSlide + 1
	            });
	        } else {
	            this.setState({
	                slideIndex: 0
	            });
	        }
	    };
	
	    Carousel.prototype.decrementSlides = function decrementSlides() {
	        var currentSlide = this.state.slideIndex;
	        var numberOfSlides = this.state.numberOfSlides - 1;
	        if (currentSlide !== 0) {
	            this.setState({
	                slideIndex: currentSlide - 1
	            });
	        } else {
	            this.setState({
	                slideIndex: numberOfSlides
	            });
	        }
	    };
	
	    Carousel.prototype.buildSlides = function buildSlides(images, imageDictionary, slideIndex) {
	        var slides = images.map(function (imageKey, index) {
	            return _react2.default.createElement(
	                'div',
	                { key: index, style: {
	                        position: 'absolute',
	                        top: 0,
	                        bottom: 0,
	                        left: 0,
	                        right: 0,
	                        transition: 'opacity 0.3s ease-in-out',
	                        opacity: slideIndex === index ? '1' : '0'
	                    }
	                },
	                _react2.default.createElement(_Image2.default, { aspectHeight: 4, aspectWidth: 5, sizes: imageDictionary[imageKey].sizes })
	            );
	        });
	        return slides;
	    };
	
	    Carousel.prototype.render = function render() {
	        var _this3 = this;
	
	        var _props = this.props,
	            data = _props.data,
	            imageDictionary = _props.imageDictionary;
	
	        if (data.direction === 'left') {
	            return _react2.default.createElement(
	                'div',
	                { ref: function ref(div) {
	                        return _this3.carouselHolder = div;
	                    } },
	                _react2.default.createElement(
	                    _grid.Row,
	                    { cblockPaddingTop: true },
	                    _react2.default.createElement(
	                        _styledComponents.CarouselHolder,
	                        { cw: 5, offset: 1 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { width: '100%', position: 'relative', background: 'white' } },
	                            _react2.default.createElement(
	                                _styledComponents.DataCounter,
	                                { direction: data.direction },
	                                _react2.default.createElement(_StatCircle2.default, { data: data.datapoint, imageDictionary: imageDictionary })
	                            ),
	                            _react2.default.createElement('div', { style: { paddingTop: 'calc((4/5) * 100%)', width: '100%' } }),
	                            this.buildSlides(data.images, imageDictionary, this.state.slideIndex),
	                            this.state.numberOfSlides > 0 && _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    _styledComponents.IncrementButton,
	                                    { onClick: this.incrementSlides, color: data.color },
	                                    _react2.default.createElement('div', null)
	                                ),
	                                _react2.default.createElement(
	                                    _styledComponents.DecrementButton,
	                                    { onClick: this.decrementSlides, color: data.color },
	                                    _react2.default.createElement('div', null)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _styledComponents.ColorBlock,
	                                { color: data.color, direction: data.direction },
	                                _react2.default.createElement('div', { className: 'stripes' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _styledComponents.CopyHolder,
	                        { cw: 4, offset: 1 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { width: '100%', position: 'relative', height: '100%' } },
	                            _react2.default.createElement(
	                                _styledComponents.Copy,
	                                { color: data.color },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'city' },
	                                    data.city
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'state' },
	                                    data.state
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'initialsHolder' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        { style: { transform: 'translate3d(0, ' + (-30 + 30 * (this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3)) + 'px, 0) rotate(' + (-20 + 20 * (this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2)) + 'deg)' } },
	                                        data.initials[0]
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { style: { transform: 'translate3d(0, ' + (120 + -120 * (this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3)) + 'px, 0) rotate(' + (15 + -15 * (this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2)) + 'deg)' } },
	                                        data.initials[1]
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        } else {
	            return _react2.default.createElement(
	                'div',
	                { ref: function ref(div) {
	                        return _this3.carouselHolder = div;
	                    } },
	                _react2.default.createElement(
	                    _grid.Row,
	                    { cblockPaddingTop: true },
	                    _react2.default.createElement(
	                        _styledComponents.CopyHolder,
	                        { cw: 4, offset: 1 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { width: '100%', position: 'relative', height: '100%' } },
	                            _react2.default.createElement(
	                                _styledComponents.Copy,
	                                { color: data.color },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'city' },
	                                    data.city
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'state' },
	                                    data.state
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'initialsHolder' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        { style: { transform: 'translate3d(0, ' + (-30 + 30 * (this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3)) + 'px, 0) rotate(' + (-20 + 20 * (this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2)) + 'deg)' } },
	                                        data.initials[0]
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { style: { transform: 'translate3d(0, ' + (120 + -120 * (this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3)) + 'px, 0) rotate(' + (15 + -15 * (this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2)) + 'deg)' } },
	                                        data.initials[1]
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _styledComponents.CarouselHolder,
	                        { cw: 5, offset: 1 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { width: '100%', position: 'relative', background: 'white' } },
	                            _react2.default.createElement(
	                                _styledComponents.DataCounter,
	                                { direction: data.direction },
	                                _react2.default.createElement(_StatCircle2.default, { data: data.datapoint, imageDictionary: imageDictionary })
	                            ),
	                            _react2.default.createElement('div', { style: { paddingTop: 'calc((4/5) * 100%)', width: '100%' } }),
	                            this.buildSlides(data.images, imageDictionary, this.state.slideIndex),
	                            this.state.numberOfSlides > 0 && _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    _styledComponents.IncrementButton,
	                                    { onClick: this.incrementSlides, color: data.color },
	                                    _react2.default.createElement('div', null)
	                                ),
	                                _react2.default.createElement(
	                                    _styledComponents.DecrementButton,
	                                    { onClick: this.decrementSlides, color: data.color },
	                                    _react2.default.createElement('div', null)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _styledComponents.ColorBlock,
	                                { color: data.color, direction: data.direction },
	                                _react2.default.createElement('div', { className: 'stripes' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    };
	
	    return Carousel;
	}(_react.Component);
	
	exports.default = Carousel;
	module.exports = exports['default'];

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CopyHolder = exports.CarouselHolder = exports.DataCounter = exports.Copy = exports.ColorBlock = exports.DecrementButton = exports.IncrementButton = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _grid = __webpack_require__(3);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _gutters = __webpack_require__(12);
	
	var _gutters2 = _interopRequireDefault(_gutters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CarouselButton = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__CarouselButton',
	    componentId: 'sc-5taxue-0'
	})(['position:absolute;width:90px;height:70px;background-color:', ';display:flex;align-items:center;justify-content:center;cursor:pointer;transition:background-color 0.3s;div{border:solid white;border-width:0 5px 5px 0;display:inline-block;padding:10px;transform-origin:center center;}&:hover{background-color:', '}@media (max-width:', '){width:60px;height:46px;}'], function (props) {
	    return props.color === 'red' ? _colors2.default['lipstick'] : _colors2.default['peacock-blue'];
	}, function (props) {
	    return props.color === 'red' ? '#e5334b' : '#0076ab';
	}, _breakpoints2.default['bp-tablet']);
	
	var IncrementButton = exports.IncrementButton = (0, _styledComponents2.default)(CarouselButton).withConfig({
	    displayName: 'styled-components__IncrementButton',
	    componentId: 'sc-5taxue-1'
	})(['right:-25px;top:calc(50% - 35px);@media (max-width:', '){top:calc(60%);}div{margin-right:5px;transform:rotate(-45deg);@media (max-width:', '){padding:7px;}}'], _breakpoints2.default['bp-mobile'], _breakpoints2.default['bp-tablet']);
	
	var DecrementButton = exports.DecrementButton = (0, _styledComponents2.default)(CarouselButton).withConfig({
	    displayName: 'styled-components__DecrementButton',
	    componentId: 'sc-5taxue-2'
	})(['left:-25px;top:calc(50% - 35px);@media (max-width:', '){top:calc(60%);}div{margin-left:5px;transform:rotate(135deg);@media (max-width:', '){padding:7px;}}'], _breakpoints2.default['bp-mobile'], _breakpoints2.default['bp-tablet']);
	
	var ColorBlock = exports.ColorBlock = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__ColorBlock',
	    componentId: 'sc-5taxue-3'
	})(['position:absolute;bottom:25%;overflow:hidden;', ' ', ' top:calc(', ' * -0.7);z-index:-1;width:80%;@media (max-width:', '){', ' ', ' top:calc(', ' * -0.7);}@media (max-width:', '){', ' ', '         top:calc(', ' * -0.7);}@media (max-width:', '){', ' ', '         top:calc(', ' * -0.7);}.stripes{background:repeating-linear-gradient(-45deg,', ',', ' 25px,rgba(255,255,255,0.5) 25px,rgba(255,255,255,0.5) 50px);position:absolute;top:-75px;left:-75px;right:-75px;bottom:-75px;animation-name:barbersPole;animation-timing-function:linear;animation-iteration-count:infinite;animation-duration:1200ms;animation-play-state:running;@keyframes barbersPole{0%{transform:translate3d(0,0,0)}100%{transform:translate3d(0,72px,0)}}}'], function (props) {
	    return props.direction === 'left' && (0, _styledComponents.css)(['left:calc(', ' * -0.8);'], _gutters2.default['container-gutters-desktop-l']);
	}, function (props) {
	    return props.direction === 'right' && (0, _styledComponents.css)(['right:calc(', ' * -0.8);'], _gutters2.default['container-gutters-desktop-l']);
	}, _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], function (props) {
	    return props.direction === 'left' && (0, _styledComponents.css)(['left:calc(', ' * -0.8);'], _gutters2.default['container-gutters-desktop']);
	}, function (props) {
	    return props.direction === 'right' && (0, _styledComponents.css)(['right:calc(', ' * -0.8);'], _gutters2.default['container-gutters-desktop']);
	}, _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], function (props) {
	    return props.direction === 'left' && (0, _styledComponents.css)(['left:calc(', ' * -0.8);'], _gutters2.default['container-gutters-tablet']);
	}, function (props) {
	    return props.direction === 'right' && (0, _styledComponents.css)(['right:calc(', ' * -0.8);'], _gutters2.default['container-gutters-tablet']);
	}, _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], function (props) {
	    return props.direction === 'left' && (0, _styledComponents.css)(['left:calc(', ' * -0.8);'], _gutters2.default['container-gutters-mobile']);
	}, function (props) {
	    return props.direction === 'right' && (0, _styledComponents.css)(['right:calc(', ' * -0.8);'], _gutters2.default['container-gutters-mobile']);
	}, _gutters2.default['container-gutters-mobile'], function (props) {
	    return props.color === 'red' ? _colors2.default['lipstick'] : _colors2.default['peacock-blue'];
	}, function (props) {
	    return props.color === 'red' ? _colors2.default['lipstick'] : _colors2.default['peacock-blue'];
	});
	
	var Copy = exports.Copy = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__Copy',
	    componentId: 'sc-5taxue-4'
	})(['display:flex;flex-direction:column;width:100%;height:100%;position:absolute;.city{font-family:\'OneDotExt\',sans-serif;font-weight:bold;font-size:40px;color:', ';text-transform:uppercase;margin-top:40px;@media (max-width:', '){font-size:30px;}}.state{font-family:\'OneDot\',sans-serif;font-size:25px;font-weight:bold;letter-spacing:3px;text-transform:uppercase;margin-top:10px;@media (max-width:', '){font-size:16px;}}.initialsHolder{font-family:\'OneDotCd\',sans-serif;font-weight:bold;color:', ';position:absolute;top:0;width:100%;font-size:400px;display:flex;align-items:center;justify-content:center;letter-spacing:10px;z-index:-1;text-transform:uppercase;margin-top:-10%;@media (max-width:', '){font-size:300px;}@media (max-width:', '){font-size:250px;}@media (max-width:', '){display:none;}}@media (max-width:', '){position:relative;margin-bottom:30px;}'], function (props) {
	    return props.color === 'red' ? _colors2.default['lipstick'] : _colors2.default['peacock-blue'];
	}, _breakpoints2.default['bp-mobile'], _breakpoints2.default['bp-mobile'], _colors2.default['white-two'], _breakpoints2.default['bp-desktop'], _breakpoints2.default['bp-tablet'], _breakpoints2.default['bp-mobile'], _breakpoints2.default['bp-mobile']);
	
	var DataCounter = exports.DataCounter = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__DataCounter',
	    componentId: 'sc-5taxue-5'
	})(['z-index:3;position:absolute;bottom:-55px;', '        ', ' @media (max-width:', '){bottom:-40px;}.circleLabel{animation-name:spinCircle;animation-timing-function:linear;animation-iteration-count:infinite;animation-duration:10000ms;animation-play-state:running;@keyframes spinCircle{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}}'], function (props) {
	    return props.direction === 'left' && (0, _styledComponents.css)(['left:40px;']);
	}, function (props) {
	    return props.direction === 'right' && (0, _styledComponents.css)(['right:40px;']);
	}, _breakpoints2.default['bp-mobile']);
	
	var CarouselHolder = exports.CarouselHolder = (0, _styledComponents2.default)(_grid.Column).withConfig({
	    displayName: 'styled-components__CarouselHolder',
	    componentId: 'sc-5taxue-6'
	})(['@media (max-width:', '){order:2;}&:hover{.circleLabel{animation-play-state:paused;}.stripes{animation-play-state:paused;}}'], _breakpoints2.default['bp-mobile']);
	
	var CopyHolder = exports.CopyHolder = (0, _styledComponents2.default)(_grid.Column).withConfig({
	    displayName: 'styled-components__CopyHolder',
	    componentId: 'sc-5taxue-7'
	})(['@media (max-width:', '){order:1;}'], _breakpoints2.default['bp-mobile']);

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _mobxReact = __webpack_require__(22);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _grid = __webpack_require__(3);
	
	var _Image = __webpack_require__(24);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _StatCircle = __webpack_require__(103);
	
	var _StatCircle2 = _interopRequireDefault(_StatCircle);
	
	var _styledComponents = __webpack_require__(182);
	
	var _arrowCtaRed = __webpack_require__(100);
	
	var _arrowCtaRed2 = _interopRequireDefault(_arrowCtaRed);
	
	var _arrowCtaBlue = __webpack_require__(99);
	
	var _arrowCtaBlue2 = _interopRequireDefault(_arrowCtaBlue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CaseStudyThumb = (_dec = (0, _mobxReact.inject)("store"), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
	    _inherits(CaseStudyThumb, _Component);
	
	    function CaseStudyThumb(props) {
	        _classCallCheck(this, CaseStudyThumb);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	            ctaHovered: false,
	            positioningValue: 0
	        };
	
	        // bind events to context
	        _this.ctaEntered = _this.ctaEntered.bind(_this);
	        _this.ctaExited = _this.ctaExited.bind(_this);
	        _this.handleScroll = _this.handleScroll.bind(_this);
	        _this.setVanishingPoint = _this.setVanishingPoint.bind(_this);
	        _this.gaCityClicked = _this.gaCityClicked.bind(_this);
	        return _this;
	    }
	
	    CaseStudyThumb.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        document.addEventListener('scroll', this.handleScroll);
	        window.addEventListener('resize', this.setVanishingPoint);
	        setTimeout(function () {
	            _this2.setVanishingPoint();
	        }, 100);
	    };
	
	    CaseStudyThumb.prototype.componentWillUnmount = function componentWillUnmount() {
	        document.removeEventListener('scroll', this.handleScroll);
	        window.removeEventListener('resize', this.setVanishingPoint);
	    };
	
	    CaseStudyThumb.prototype.handleScroll = function handleScroll(e) {
	        this.latestKnownScrollY = window.scrollY ? window.scrollY : window.pageYOffset;
	        this.requestTick();
	    };
	
	    CaseStudyThumb.prototype.requestTick = function requestTick() {
	        if (!this.ticking) {
	            requestAnimationFrame(this.update.bind(this));
	        }
	        this.ticking = true;
	    };
	
	    CaseStudyThumb.prototype.setVanishingPoint = function setVanishingPoint() {
	        var scrollTop = document.documentElement ? document.documentElement.scrollTop : document.body.scrollTop;
	        var thumbTop = this.thumbHolder.getBoundingClientRect().top;
	        var thumbHeight = this.thumbHolder.getBoundingClientRect().height;
	        this.vanishingPoint = scrollTop + thumbTop + thumbHeight / 2;
	    };
	
	    CaseStudyThumb.prototype.update = function update() {
	        var data = this.props.data;
	
	        this.ticking = false;
	        var posValCalc = 1 - (window.innerHeight - (this.vanishingPoint - this.latestKnownScrollY)) / window.innerHeight;
	        var positioningValue = 0;
	        if (posValCalc < 1 && posValCalc > 0) {
	            positioningValue = Math.round((1 - posValCalc) * 100) / 100;
	        } else if (posValCalc < 0) {
	            positioningValue = 1;
	        } else {
	            positioningValue = 0;
	        }
	        if (positioningValue !== this.state.positioningValue) {
	            this.setState({
	                positioningValue: positioningValue
	            });
	        }
	    };
	
	    CaseStudyThumb.prototype.ctaEntered = function ctaEntered() {
	        if (this.state.ctaHovered === false) {
	            this.setState({
	                ctaHovered: true
	            });
	        }
	    };
	
	    CaseStudyThumb.prototype.ctaExited = function ctaExited() {
	        if (this.state.ctaHovered === true) {
	            this.setState({
	                ctaHovered: false
	            });
	        }
	    };
	
	    CaseStudyThumb.prototype.gaCityClicked = function gaCityClicked() {
	        var data = this.props.data;
	
	        window.dataLayer.push({
	            'event': 'homepage-explore:click',
	            'city': data.city + ',' + data.state
	        });
	    };
	
	    CaseStudyThumb.prototype.render = function render() {
	        var _this3 = this;
	
	        var _props = this.props,
	            data = _props.data,
	            imageDictionary = _props.imageDictionary,
	            store = _props.store;
	
	        if (data.direction === 'left') {
	            return _react2.default.createElement(
	                'div',
	                { ref: function ref(div) {
	                        return _this3.thumbHolder = div;
	                    } },
	                _react2.default.createElement(
	                    _styledComponents.CaseStudyThumbWrapper,
	                    { color: data.color, direction: data.direction, thumbStyle: data.style },
	                    store.isMobile && _react2.default.createElement(
	                        'span',
	                        { className: 'mobileWrapper' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'thumbTextHolder' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'rotatedText' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'city' },
	                                    data.city
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'state' },
	                                    data.state
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                className: 'ctaHolder',
	                                onMouseEnter: this.ctaEntered,
	                                onMouseLeave: this.ctaExited
	                            },
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: data.ctaLink, onClick: this.gaCityClicked },
	                                data.color === 'red' ? _react2.default.createElement(_arrowCtaRed2.default, null) : _react2.default.createElement(_arrowCtaBlue2.default, null),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'ctaText left' },
	                                    data.cta
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'initialsHolder' },
	                            _react2.default.createElement(
	                                'span',
	                                { style: { transform: 'translate3d(0, ' + (-30 + 30 * (this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3)) + 'px, 0) rotate(' + (-20 + 20 * (this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2)) + 'deg)' } },
	                                data.initials[0]
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { style: { transform: 'translate3d(0, ' + (120 + -120 * (this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3)) + 'px, 0) rotate(' + (15 + -15 * (this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2)) + 'deg)' } },
	                                data.initials[1]
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { cw: 5, offset: 1 },
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: data.ctaLink, onClick: this.gaCityClicked },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'thumbImageWrapper' },
	                                _react2.default.createElement(_Image2.default, { aspectHeight: 6, aspectWidth: 5, sizes: imageDictionary[data.image].sizes }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'colorBlock ' + (data.style === 'main' ? 'main' : 'alternate') + ' ' + (data.direction === 'left' ? 'left' : 'right') },
	                                    _react2.default.createElement('div', { className: 'stripes ' + (this.state.ctaHovered ? 'ctaHovered' : '') })
	                                ),
	                                _react2.default.createElement('div', {
	                                    className: 'frameHolder',
	                                    style: {
	                                        transform: 'translate3d(' + (-25 + 50 * (this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2)) + 'px, ' + (30 + -60 * (this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2)) + 'px, 0)'
	                                    }
	                                }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'dataCounter ' + (this.state.ctaHovered ? 'ctaHovered' : '') },
	                                    _react2.default.createElement(_StatCircle2.default, { data: data.datapoint, imageDictionary: imageDictionary })
	                                )
	                            )
	                        )
	                    ),
	                    !store.isMobile && _react2.default.createElement(
	                        _grid.Column,
	                        { cw: 4, offset: 1, style: {
	                                display: 'flex',
	                                flexDirection: 'column',
	                                alignItems: 'center',
	                                justifyContent: 'space-evenly',
	                                position: 'relative'
	                            } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'thumbTextHolder' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'rotatedText' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'city' },
	                                    data.city
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'state' },
	                                    data.state
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                className: 'ctaHolder',
	                                onMouseEnter: this.ctaEntered,
	                                onMouseLeave: this.ctaExited
	                            },
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: data.ctaLink, onClick: this.gaCityClicked },
	                                data.color === 'red' ? _react2.default.createElement(_arrowCtaRed2.default, null) : _react2.default.createElement(_arrowCtaBlue2.default, null),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'ctaText left' },
	                                    data.cta
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'initialsHolder' },
	                            _react2.default.createElement(
	                                'span',
	                                { style: { transform: 'translate3d(0, ' + (-30 + 30 * (this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3)) + 'px, 0) rotate(' + (-20 + 20 * (this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2)) + 'deg)' } },
	                                data.initials[0]
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { style: { transform: 'translate3d(0, ' + (120 + -120 * (this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3)) + 'px, 0) rotate(' + (15 + -15 * (this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2)) + 'deg)' } },
	                                data.initials[1]
	                            )
	                        )
	                    )
	                )
	            );
	        } else {
	            return _react2.default.createElement(
	                'div',
	                { ref: function ref(div) {
	                        return _this3.thumbHolder = div;
	                    } },
	                _react2.default.createElement(
	                    _styledComponents.CaseStudyThumbWrapper,
	                    { color: data.color, direction: data.direction, thumbStyle: data.style },
	                    store.isMobile && _react2.default.createElement(
	                        'span',
	                        { className: 'mobileWrapper' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'thumbTextHolder' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'rotatedText' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'city' },
	                                    data.city
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'state' },
	                                    data.state
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                className: 'ctaHolder',
	                                onMouseEnter: this.ctaEntered,
	                                onMouseLeave: this.ctaExited
	                            },
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: data.ctaLink, onClick: this.gaCityClicked },
	                                data.color === 'red' ? _react2.default.createElement(_arrowCtaRed2.default, { style: { transform: 'scaleX(-1)' } }) : _react2.default.createElement(_arrowCtaBlue2.default, { style: { transform: 'scaleX(-1)' } }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'ctaText right' },
	                                    data.cta
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'initialsHolder' },
	                            _react2.default.createElement(
	                                'span',
	                                { style: { transform: 'translate3d(0, ' + (-30 + 30 * (this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3)) + 'px, 0) rotate(' + (-20 + 20 * (this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2)) + 'deg)' } },
	                                data.initials[0]
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { style: { transform: 'translate3d(0, ' + (120 + -120 * (this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3)) + 'px, 0) rotate(' + (15 + -15 * (this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2)) + 'deg)' } },
	                                data.initials[1]
	                            )
	                        )
	                    ),
	                    !store.isMobile && _react2.default.createElement(
	                        _grid.Column,
	                        { cw: 4, offset: 1, style: {
	                                display: 'flex',
	                                flexDirection: 'column',
	                                alignItems: 'center',
	                                justifyContent: 'space-evenly',
	                                position: 'relative'
	                            } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'thumbTextHolder' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'rotatedText' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'city' },
	                                    data.city
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'state' },
	                                    data.state
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                className: 'ctaHolder',
	                                onMouseEnter: this.ctaEntered,
	                                onMouseLeave: this.ctaExited
	                            },
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: data.ctaLink, onClick: this.gaCityClicked },
	                                data.color === 'red' ? _react2.default.createElement(_arrowCtaRed2.default, { style: { transform: 'scaleX(-1)' } }) : _react2.default.createElement(_arrowCtaBlue2.default, { style: { transform: 'scaleX(-1)' } }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'ctaText right' },
	                                    data.cta
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'initialsHolder' },
	                            _react2.default.createElement(
	                                'span',
	                                { style: { transform: 'translate3d(0, ' + (-30 + 30 * (this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3)) + 'px, 0) rotate(' + (-20 + 20 * (this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2)) + 'deg)' } },
	                                data.initials[0]
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { style: { transform: 'translate3d(0, ' + (120 + -120 * (this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3)) + 'px, 0) rotate(' + (15 + -15 * (this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2)) + 'deg)' } },
	                                data.initials[1]
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { cw: 5, offset: 1 },
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: data.ctaLink, onClick: this.gaCityClicked },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'thumbImageWrapper' },
	                                _react2.default.createElement(_Image2.default, { aspectHeight: 6, aspectWidth: 5, sizes: imageDictionary[data.image].sizes }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'colorBlock ' + (data.style === 'main' ? 'main' : 'alternate') + ' ' + (data.direction === 'left' ? 'left' : 'right') },
	                                    _react2.default.createElement('div', { className: 'stripes ' + (this.state.ctaHovered ? 'ctaHovered' : '') })
	                                ),
	                                _react2.default.createElement('div', {
	                                    className: 'frameHolder',
	                                    style: {
	                                        transform: 'translate3d(' + (25 + -50 * (this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2)) + 'px, ' + (30 + -60 * (this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2)) + 'px, 0)'
	                                    }
	                                }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'dataCounter ' + (this.state.ctaHovered ? 'ctaHovered' : '') },
	                                    _react2.default.createElement(_StatCircle2.default, { data: data.datapoint, imageDictionary: imageDictionary })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    };
	
	    return CaseStudyThumb;
	}(_react.Component)) || _class) || _class);
	;
	
	exports.default = CaseStudyThumb;
	module.exports = exports['default'];

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CaseStudyThumbWrapper = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _gutters = __webpack_require__(12);
	
	var _gutters2 = _interopRequireDefault(_gutters);
	
	var _grid = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CaseStudyThumbWrapper = exports.CaseStudyThumbWrapper = (0, _styledComponents2.default)(_grid.Row).withConfig({
	    displayName: 'styled-components__CaseStudyThumbWrapper',
	    componentId: 'jm24yb-0'
	})(['position:relative;padding-bottom:calc(', ' * 0.7);@media (max-width:', '){padding-bottom:calc(', ' * 0.7);}@media (max-width:', '){padding-bottom:calc(', ' * 0.7);}@media (max-width:', '){padding-bottom:calc(', ' * 2);}', ' .thumbImageWrapper{position:relative;width:100%;', ' ', ' &:hover{.stripes{animation-play-state:paused;}.circleLabel{animation-play-state:paused;}}}.frameHolder{position:absolute;top:0;left:0;right:0;bottom:0;box-sizing:border-box;border:solid 8px #ffffff;@media (max-width:', '){display:none;}}.dataCounter{position:absolute;top:80px;', '        ', ' @media (max-width:', '){display:none;}.circleLabel{animation-name:spinCircle;animation-timing-function:linear;animation-iteration-count:infinite;animation-duration:10000ms;animation-play-state:running;@keyframes spinCircle{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}}&.ctaHovered{.circleLabel{animation-play-state:paused;}}}.colorBlock{position:absolute;overflow:hidden;&.main{top:55%;left:calc(', ' * -0.8);right:calc(', ' * -0.8);bottom:calc(', ' * -0.7);z-index:-1;@media (max-width:', '){left:calc(', ' * -0.8);right:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}@media (max-width:', '){left:calc(', ' * -0.8);right:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}@media (max-width:', '){top:20%;left:calc(', ' * -5);right:calc(', ' * -5);bottom:calc(', ' * -2);}}&.alternate{z-index:-1;', ' ', '}.stripes{position:absolute;top:-75px;left:-75px;right:-75px;bottom:-75px;background:repeating-linear-gradient(-45deg,', ',', ' 25px,rgba(255,255,255,0.5) 25px,rgba(255,255,255,0.5) 50px);animation-name:barbersPole;animation-timing-function:linear;animation-iteration-count:infinite;animation-duration:1200ms;animation-play-state:running;@keyframes barbersPole{0%{transform:translate3d(0,0,0)}100%{transform:translate3d(0,72px,0)}}&.ctaHovered{animation-play-state:paused;}}}.thumbTextHolder{width:100%;flex:1 1 auto;display:flex;align-items:flex-end;justify-content:center;position:relative;.rotatedText{position:absolute;top:0;bottom:0;left:0;right:0;transform:rotate(-90deg);display:flex;flex-direction:column;justify-content:center;transform-origin:center center;.city{font-family:\'OneDotExt\',sans-serif;font-weight:bold;font-size:40px;text-transform:uppercase;color:', ';@media (max-width:', '){font-size:30px;}}.state{margin-top:15px;font-family:\'OneDotExt\',sans-serif;font-weight:bold;font-size:24px;text-transform:uppercase;color:', ';}}@media (max-width:', '){.rotatedText{position:relative;width:100%;transform:none;margin:0 15%;margin-bottom:10px;.city{font-size:30px;}.state{font-size:16px;margin-top:5px;}}}}.initialsHolder{font-family:\'OneDotCd\',sans-serif;font-weight:bold;color:', ';position:absolute;top:0;left:0;width:100%;font-size:400px;display:flex;align-items:center;justify-content:center;letter-spacing:10px;z-index:-2;text-transform:uppercase;@media (max-width:', '){font-size:250px;}}.ctaHolder{width:150px;position:relative;flex:0 0 30%;transition:transform 300ms ease-in-out;display:flex;flex-direction:column;justify-content:center;.ctaText{position:absolute;top:0;left:0;right:0;bottom:0;display:flex;justify-content:center;align-items:center;font-family:\'OneDotCd\',sans-serif;font-style:italic;text-transform:uppercase;font-size:18px;color:white;&.left{left:20%;}&.right{right:20%;}}&:hover{transform:translate3d(0,-5px,0) scale(1.02);}}.mobileWrapper{.ctaHolder{position:absolute;', ' ', '             z-index:4;bottom:60px;background:', ';display:inline-block;height:50px;width:100px;border-radius:3px;.ctaText{left:0;top:0;width:100%;}svg{display:none;}}.initialsHolder{position:absolute;top:-175px;font-size:250px;@media (max-width:', '){display:none;}}}'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile'], function (props) {
	    return props.thumbStyle === 'alternate' && (0, _styledComponents.css)(['padding-top:calc(', ' * 0.7);@media (max-width:', '){padding-top:calc(', ' * 0.7);}@media (max-width:', '){padding-top:calc(', ' * 0.7);}@media (max-width:', '){padding-top:calc(', ' * 0.7);}'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile']);
	}, function (props) {
	    return props.direction === 'left' && (0, _styledComponents.css)(['@media (max-width:', '){margin-left:calc(', ' * -1);}'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile']);
	}, function (props) {
	    return props.direction === 'right' && (0, _styledComponents.css)(['@media (max-width:', '){margin-left:calc(', ' * 1);}'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile']);
	}, _breakpoints2.default['bp-mobile'], function (props) {
	    return props.direction === 'left' && (0, _styledComponents.css)(['right:-30px;']);
	}, function (props) {
	    return props.direction === 'right' && (0, _styledComponents.css)(['left:-30px;']);
	}, _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-desktop-l'], _gutters2.default['container-gutters-desktop-l'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _gutters2.default['container-gutters-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _gutters2.default['container-gutters-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-mobile'], function (props) {
	    return props.direction === 'right' && (0, _styledComponents.css)(['left:55%;top:calc(', ' * -0.7);right:calc(', ' * -0.8);bottom:calc(', ' * -0.7);@media (max-width:', '){top:calc(', ' * -0.7);right:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}@media (max-width:', '){top:calc(', ' * -0.7);right:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}@media (max-width:', '){top:20%;left:calc(', ' * -5);right:calc(', ' * -5);bottom:calc(', ' * -2);}'], _gutters2.default['container-gutters-desktop-l'], _gutters2.default['container-gutters-desktop-l'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _gutters2.default['container-gutters-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _gutters2.default['container-gutters-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-mobile']);
	}, function (props) {
	    return props.direction === 'left' && (0, _styledComponents.css)(['right:55%;top:calc(', ' * -0.7);left:calc(', ' * -0.8);bottom:calc(', ' * -0.7);@media (max-width:', '){top:calc(', ' * -0.7);left:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}@media (max-width:', '){top:calc(', ' * -0.7);left:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}@media (max-width:', '){top:20%;left:calc(', ' * -5);right:calc(', ' * -5);bottom:calc(', ' * -2);}'], _gutters2.default['container-gutters-desktop-l'], _gutters2.default['container-gutters-desktop-l'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _gutters2.default['container-gutters-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _gutters2.default['container-gutters-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-mobile']);
	}, function (props) {
	    return props.color === 'blue' ? _colors2.default['peacock-blue'] : _colors2.default['lipstick'];
	}, function (props) {
	    return props.color === 'blue' ? _colors2.default['peacock-blue'] : _colors2.default['lipstick'];
	}, function (props) {
	    return props.color === 'red' ? _colors2.default['lipstick'] : _colors2.default['peacock-blue'];
	}, _breakpoints2.default['bp-tablet'], _colors2.default['black'], _breakpoints2.default['bp-mobile'], _colors2.default['white-two'], _breakpoints2.default['bp-tablet'], function (props) {
	    return props.direction === 'left' && (0, _styledComponents.css)(['right:55px;']);
	}, function (props) {
	    return props.direction === 'right' && (0, _styledComponents.css)(['left:55px;']);
	}, function (props) {
	    return props.color === 'red' ? _colors2.default['lipstick'] : _colors2.default['peacock-blue'];
	}, _breakpoints2.default['bp-mobile']);

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(19);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _mobxReact = __webpack_require__(22);
	
	var _iconCamera = __webpack_require__(303);
	
	var _iconCamera2 = _interopRequireDefault(_iconCamera);
	
	var _grid = __webpack_require__(3);
	
	var _typography = __webpack_require__(29);
	
	var _styledComponents = __webpack_require__(184);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CitiesLists = (0, _reactI18next.translate)()((0, _mobxReact.inject)('store')((0, _mobxReact.observer)(function (_ref) {
	  var data = _ref.data,
	      store = _ref.store,
	      t = _ref.t,
	      lng = _ref.lng;
	
	  var gaCitySelected = function gaCitySelected(city, state) {
	    window.dataLayer.push({
	      'event': 'cities-completed:select',
	      'city': city + ',' + state
	    });
	  };
	
	  return _react2.default.createElement(
	    _styledComponents.CitiesWrapper,
	    null,
	    _react2.default.createElement(
	      _grid.Row,
	      { margins: [100, 100, 100], id: 'cities-completed' },
	      _react2.default.createElement(
	        _grid.Column,
	        { cw: 6 },
	        _react2.default.createElement(
	          _styledComponents.CitiesCompletedWrapper,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            _react2.default.createElement(
	              _typography.H2,
	              { color: 'blue' },
	              t('citiesLists.completed.title')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_iconCamera2.default, null),
	              ' = state with a story'
	            )
	          ),
	          _react2.default.createElement(
	            _grid.Row,
	            { style: { marginTop: 0 } },
	            _react2.default.createElement(
	              _grid.Column,
	              { cw: 12 },
	              _react2.default.createElement(
	                'ul',
	                { className: 'completed-cities__list' },
	                data.completed.cities.map(function (city, index) {
	                  return city.link && _react2.default.createElement(
	                    'li',
	                    { key: index, className: 'completed-cities__item' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'cityAndState' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'city ' + (city.link === store.csSlug ? 'current' : '') },
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { to: (0, _gatsbyLink.withPrefix)(city.link), onClick: function onClick() {
	                              gaCitySelected(city.city, city.state);
	                            } },
	                          _react2.default.createElement(_iconCamera2.default, null),
	                          ' ',
	                          city.city
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'state' },
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { to: (0, _gatsbyLink.withPrefix)(city.link), onClick: function onClick() {
	                              gaCitySelected(city.city, city.state);
	                            } },
	                          city.state
	                        )
	                      )
	                    )
	                  );
	                }),
	                data.completed.cities.map(function (city, index) {
	                  return !city.link && _react2.default.createElement(
	                    'li',
	                    { key: index, className: 'completed-cities__item' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'cityAndState' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'city' },
	                        city.city
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'state' },
	                        city.state
	                      )
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      ),
	      data.upcoming.cities.length > 0 && _react2.default.createElement(
	        _grid.Column,
	        { cw: 6 },
	        _react2.default.createElement(
	          _styledComponents.CitiesUpcomingWrapper,
	          { lang: lng },
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            _react2.default.createElement(
	              _typography.H2,
	              { color: 'blue', style: { marginBottom: '5px' } },
	              t('citiesLists.upcoming.title')
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'teaser-text' },
	            t('citiesLists.upcoming.teaserText')
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'upcoming-cities__list' },
	            data.upcoming.cities.map(function (city, index) {
	              return _react2.default.createElement(
	                'li',
	                { key: index, className: 'upcoming-cities__item' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'cityAndState' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'city' },
	                    city.city
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'state' },
	                    city.state
	                  )
	                )
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	})));
	
	exports.default = CitiesLists;
	module.exports = exports['default'];

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CitiesUpcomingWrapper = exports.CitiesCompletedWrapper = exports.CitiesWrapper = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _gutters = __webpack_require__(12);
	
	var _gutters2 = _interopRequireDefault(_gutters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CitiesWrapper = exports.CitiesWrapper = _styledComponents2.default.section.withConfig({
	    displayName: 'styled-components__CitiesWrapper',
	    componentId: 'sc-17dx86n-0'
	})(['margin-bottom:80px;@media (min-width:', '){display:none;}'], _breakpoints2.default['bp-desktop']);
	
	var CitiesCompletedWrapper = exports.CitiesCompletedWrapper = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__CitiesCompletedWrapper',
	    componentId: 'sc-17dx86n-1'
	})(['position:relative;.title{h2{margin-bottom:5px;}p{color:', ';font-family:\'OneDot\',sans-serif;font-size:12px;font-weight:bold;letter-spacing:2.9px;margin-bottom:20px;text-transform:uppercase;}svg{fill:', ';height:.75rem;}}.completed-cities__list{display:flex;flex-wrap:wrap;justify-content:space-between;padding:0 16px;}.completed-cities__item{flex-basis:50%;margin-bottom:20px;}.cityAndState{text-transform:uppercase;a{transition:color 300ms ease-in;}.city,.state{font-size:15px;a{color:', ';display:inline-block;text-decoration:none;}}.city{color:', ';font-family:\'OneDotCd\',sans-serif;font-weight:bold;letter-spacing:2px;line-height:1.35;text-align:left;a{color:', ';transition:transform .33s ease-out;}&.current{a{color:', ';}}svg{fill:#e11d38;height:.75rem;margin-left:-20px;margin-right:0px;}}.state{color:', ';font-family:\'OneDotCd\',sans-serif;font-weight:bold;line-height:2.16;letter-spacing:2px;a{transition:transform .5s ease-out;}}&:hover{.city{a{color:', ';transform:translateX(1rem);}}.state{a{transform:translateX(1rem);}}}}'], _colors2.default['medium-grey'], _colors2.default['lipstick'], _colors2.default['medium-grey'], _colors2.default['lipstick'], _colors2.default['lipstick'], _colors2.default['lipstick'], _colors2.default['medium-grey'], _colors2.default['grey-brown']);
	
	var CitiesUpcomingWrapper = exports.CitiesUpcomingWrapper = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__CitiesUpcomingWrapper',
	    componentId: 'sc-17dx86n-2'
	})(['@media (max-width:', '){margin-top:40px;}@media (min-width:', ' and max-width:', '){margin-top:85px;}.upcoming-cities__list{display:flex;flex-wrap:wrap;justify-content:space-between;padding:0 16px;}.upcoming-cities__item{flex-basis:50%;margin-bottom:20px;}.cityAndState{font-size:15px;text-transform:uppercase;.city{color:', ';display:block;font-family:\'OneDotCd\',sans-serif;font-weight:bold;letter-spacing:2px;line-height:1.35;text-align:left;}.state{color:', ';font-family:\'OneDotCd\',sans-serif;font-weight:bold;line-height:2.16;letter-spacing:2px;}}.teaser-text{color:', ';font-family:\'OneDot\',sans-serif;font-size:12px;font-weight:bold;line-height:1.2;letter-spacing:2.9px;margin-bottom:20px;text-transform:uppercase;}'], _breakpoints2.default['bp-mobile'], _breakpoints2.default['bp-mobile'], _breakpoints2.default['bp-tablet'], _colors2.default['lipstick'], _colors2.default['medium-grey'], _colors2.default['medium-grey']);

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(3);
	
	var _Image = __webpack_require__(24);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Video = __webpack_require__(145);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _styledComponents = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FullWidthAsset = function (_Component) {
	  _inherits(FullWidthAsset, _Component);
	
	  function FullWidthAsset(props) {
	    _classCallCheck(this, FullWidthAsset);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  FullWidthAsset.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        imageDictionary = _props.imageDictionary,
	        videoDictionary = _props.videoDictionary;
	
	    if (data.assetType === 'image') {
	      return _react2.default.createElement(
	        _styledComponents.FWAWrapper,
	        null,
	        _react2.default.createElement(
	          _grid.Row,
	          { margins: true },
	          _react2.default.createElement(
	            _grid.Column,
	            { className: 'assetHolder', cw: 10, offset: 1, style: { position: 'relative' } },
	            _react2.default.createElement(_Image2.default, { aspectHeight: 9, aspectWidth: 16, sizes: imageDictionary[data.asset].sizes }),
	            _react2.default.createElement(
	              _styledComponents.ColorBlock,
	              { color: data.color },
	              _react2.default.createElement('div', { className: 'stripes' })
	            )
	          )
	        )
	      );
	    } else if (data.assetType === 'video') {
	      return _react2.default.createElement(
	        _styledComponents.FWAWrapper,
	        null,
	        _react2.default.createElement(
	          _grid.Row,
	          { margins: true },
	          _react2.default.createElement(
	            _grid.Column,
	            { className: 'assetHolder', cw: 10, offset: 1, style: { position: 'relative' } },
	            _react2.default.createElement(_Video2.default, { srcMp4: videoDictionary[data.assetMp4], srcWebM: videoDictionary[data.assetWebM] }),
	            _react2.default.createElement(
	              _styledComponents.ColorBlock,
	              { color: data.color },
	              _react2.default.createElement('div', { className: 'stripes' })
	            )
	          )
	        )
	      );
	    }
	  };
	
	  return FullWidthAsset;
	}(_react.Component);
	
	exports.default = FullWidthAsset;
	module.exports = exports['default'];

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ColorBlock = exports.FWAWrapper = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _gutters = __webpack_require__(12);
	
	var _gutters2 = _interopRequireDefault(_gutters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FWAWrapper = exports.FWAWrapper = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__FWAWrapper',
	    componentId: 'sc-30kohw-0'
	})(['.assetHolder:hover{.stripes{animation-play-state:paused;}}']);
	
	var ColorBlock = exports.ColorBlock = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__ColorBlock',
	    componentId: 'sc-30kohw-1'
	})(['position:absolute;top:50%;overflow:hidden;bottom:calc(', ' * -0.7);left:calc(', ' * -0.8);right:calc(', ' * -0.8);z-index:-1;@media (max-width:', '){bottom:calc(', ' * -0.7);left:calc(', ' * -0.8);right:calc(', ' * -0.8);}@media (max-width:', '){bottom:calc(', ' * -0.7);left:calc(', ' * -0.8);right:calc(', ' * -0.8);}@media (max-width:', '){bottom:calc(', ' * -2);left:calc(', ' * -1);right:calc(', ' * -1);}.stripes{position:absolute;top:-75px;left:-75px;right:-75px;bottom:-75px;background:repeating-linear-gradient(-45deg,', ',', ' 25px,rgba(255,255,255,0.5) 25px,rgba(255,255,255,0.5) 50px);animation-name:barbersPole;animation-timing-function:linear;animation-iteration-count:infinite;animation-duration:1200ms;animation-play-state:running;@keyframes barbersPole{0%{transform:translate3d(0,0,0)}100%{transform:translate3d(0,72px,0)}}}'], _gutters2.default['container-gutters-desktop-l'], _gutters2.default['container-gutters-desktop-l'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _gutters2.default['container-gutters-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _gutters2.default['container-gutters-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-mobile'], function (props) {
	    return props.color === 'blue' ? _colors2.default['peacock-blue'] : _colors2.default['lipstick'];
	}, function (props) {
	    return props.color === 'blue' ? _colors2.default['peacock-blue'] : _colors2.default['lipstick'];
	});

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(3);
	
	var _d3Scale = __webpack_require__(697);
	
	var _d3Shape = __webpack_require__(698);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bumpometer = function (_Component) {
	  _inherits(Bumpometer, _Component);
	
	  function Bumpometer(props) {
	    _classCallCheck(this, Bumpometer);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      pathData: null,
	      translateData: 0
	    };
	
	    _this.defaultTranslateData = 10;
	    _this.lineData = [0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5];
	    _this.fps = 50;
	    _this.speed = 45;
	    _this.now;
	    _this.then = Date.now();
	    _this.interval = 1000 / _this.fps;
	    _this.delta;
	
	    _this.valley = false;
	    _this.oldLineData = null;
	    _this.moveLine = _this.moveLine.bind(_this);
	    _this.drawLine = _this.drawLine.bind(_this);
	    _this.lineDataBuild = _this.lineDataBuild.bind(_this);
	
	    _this.xScale = null;
	    _this.yScale = null;
	    /* this.xScale = scaleLinear()
	      .domain([0, 20 - 1])
	      .range([0, 180]);
	     this.yScale = scaleLinear()
	      .domain([0, 1])
	      .range([100, 0]); */
	    return _this;
	  }
	
	  Bumpometer.prototype.newLineDataArray = function newLineDataArray(newPoint) {
	    var lineData = this.lineData;
	    lineData.shift();
	    lineData.push(newPoint);
	    return lineData;
	  };
	
	  Bumpometer.prototype.componentDidMount = function componentDidMount() {
	    this.xScale = (0, _d3Scale.scaleLinear)().domain([0, 20 - 1]).range([0, 180]);
	
	    this.yScale = (0, _d3Scale.scaleLinear)().domain([0, 1]).range([100, 0]);
	
	    this.drawLine();
	  };
	
	  Bumpometer.prototype.lineDataBuild = function lineDataBuild() {
	    var _props = this.props,
	        currentStage = _props.currentStage,
	        lineData = _props.lineData;
	
	    var limiter = 0.6;
	    if (lineData && !this.valley && this.oldLineData !== lineData) {
	      this.lineData = this.newLineDataArray(lineData);
	      this.oldLineData = lineData;
	      this.valley = true;
	    } else if (this.valley) {
	      this.lineData = this.newLineDataArray(1 - this.oldLineData);
	      this.valley = false;
	    } else {
	      this.lineData = this.newLineDataArray(limiter - Math.random() * 0.2 /*  - (currentStage/4) */);
	      this.oldLineData = null;
	    }
	    this.drawLine();
	  };
	
	  Bumpometer.prototype.drawLine = function drawLine() {
	    var _this2 = this;
	
	    var lineData = this.lineData;
	    var path = (0, _d3Shape.line)().x(function (d, i) {
	      return _this2.xScale(i);
	    }).y(function (d, i) {
	      return _this2.yScale(d);
	    }).curve(_d3Shape.curveBasis);
	
	    this.setState({
	      pathData: path(lineData),
	      translateData: 10
	    });
	    this.moveLine();
	  };
	
	  Bumpometer.prototype.moveLine = function moveLine() {
	    this.now = Date.now();
	    this.delta = this.now - this.then;
	
	    if (this.delta > this.interval && this.refs.bumpPath) {
	      this.then = this.now - this.delta % this.interval;
	      this.setState({
	        translateData: this.state.translateData + Math.round(this.speed / this.fps * 100) / 100
	      });
	    }
	    if (this.state.translateData < 10 + this.defaultTranslateData) {
	      requestAnimationFrame(this.moveLine);
	    } else {
	      this.lineDataBuild();
	    }
	  };
	
	  Bumpometer.prototype.render = function render() {
	    var _props2 = this.props,
	        label = _props2.label,
	        isMobile = _props2.isMobile;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'bumpometer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'bumpometerCopy' },
	        label
	      ),
	      _react2.default.createElement(
	        'svg',
	        {
	          id: 'first',
	          width: '150',
	          height: '150',
	          fill: 'none'
	        },
	        _react2.default.createElement(
	          'g',
	          { transform: 'translate(-' + (this.state.translateData + 10) + ', 0)' },
	          _react2.default.createElement('path', { ref: 'bumpPath', id: 'bumpPath', d: this.state.pathData, stroke: '#fff', strokeWidth: '' + (isMobile ? '5px' : '3px'), fill: 'none' })
	        ),
	        _react2.default.createElement('rect', { width: '150', height: '10', x: '0', y: '45', fill: 'white', style: { opacity: '0.3' } })
	      )
	    );
	  };
	
	  return Bumpometer;
	}(_react.Component);
	
	exports.default = Bumpometer;
	module.exports = exports['default'];

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Controls = function Controls(_ref) {
	    var stageClick = _ref.stageClick,
	        currentStage = _ref.currentStage,
	        oldStage = _ref.oldStage,
	        isMobile = _ref.isMobile,
	        t = _ref.t;
	
	    var multipliers = [0, 0, 0, 0];
	    if (oldStage <= currentStage) {
	        var duration = 0;
	        for (var i = oldStage - 1; i < 4; i++) {
	            multipliers[i] = duration;
	            duration += 300;
	        }
	    }
	    if (oldStage >= currentStage) {
	        var _duration = 0;
	        for (var _i = oldStage - 1; _i >= 0; _i--) {
	            multipliers[_i] = _duration;
	            _duration += 300;
	        }
	    }
	    if (!isMobile) {
	        return _react2.default.createElement(
	            'div',
	            { className: 'controlsWrapper' },
	            _react2.default.createElement(
	                'svg',
	                { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 303.62 161.73' },
	                _react2.default.createElement(
	                    'g',
	                    { id: 'Layer_2', 'data-name': 'Layer 2', transform: 'translate(0, 10)' },
	                    _react2.default.createElement('circle', { r: '151', fill: 'white', cx: '50%', cy: '96%', transform: 'scale(1, 1.1)', style: { opacity: '0.4' } }),
	                    _react2.default.createElement(
	                        'g',
	                        { className: 'whiteStrokes' },
	                        _react2.default.createElement('path', { fill: 'none', stroke: '#fff', strokeWidth: '5px', d: 'M4,151.73A147.15,147.15,0,0,1,18.24,88.37,M33.29,63.41A148.25,148.25,0,0,1,93.25,16, M101.09,12.91a148.44,148.44,0,0,1,98.23-1.07, M208.19,15.36A148.28,148.28,0,0,1,276,71.78, M280.17,78.66a147.05,147.05,0,0,1,19.45,73' })
	                    ),
	                    _react2.default.createElement(
	                        'g',
	                        { className: 'redStrokes' },
	                        _react2.default.createElement('path', { fill: 'none', stroke: '#e11d38', strokeWidth: '8px', d: 'M4,151.73A147.15,147.15,0,0,1,18.24,88.37' }),
	                        _react2.default.createElement('path', { className: 'redStroke ' + (currentStage > 1 ? 'active' : 'inactive'), style: { transitionDuration: '300ms', transitionDelay: multipliers[0] + 'ms' }, fill: 'none', stroke: '#e11d38', strokeWidth: '8px', d: 'M33.29,63.41A148.25,148.25,0,0,1,93.25,16' }),
	                        _react2.default.createElement('path', { className: 'redStroke ' + (currentStage > 2 ? 'active' : 'inactive'), style: { transitionDuration: '300ms', transitionDelay: multipliers[1] + 'ms' }, fill: 'none', stroke: '#e11d38', strokeWidth: '8px', d: 'M101.09,12.91a148.44,148.44,0,0,1,98.23-1.07' }),
	                        _react2.default.createElement('path', { className: 'redStroke ' + (currentStage > 3 ? 'active' : 'inactive'), style: { transitionDuration: '300ms', transitionDelay: multipliers[2] + 'ms' }, fill: 'none', stroke: '#e11d38', strokeWidth: '8px', d: 'M208.19,15.36A148.28,148.28,0,0,1,276,71.78' }),
	                        _react2.default.createElement('path', { className: 'redStroke ' + (currentStage > 3 ? 'active' : 'inactive'), style: { transitionDuration: '300ms', transitionDelay: multipliers[3] + 'ms' }, fill: 'none', stroke: '#e11d38', strokeWidth: '8px', d: 'M280.17,78.66a147.05,147.05,0,0,1,19.45,73' })
	                    ),
	                    _react2.default.createElement('circle', { onClick: stageClick, 'data-stage': '1', className: 'stageKnob', cx: '26', cy: '75', r: '14', stroke: 'white', strokeWidth: '3', fill: '#e11d38' }),
	                    _react2.default.createElement('circle', { onClick: stageClick, 'data-stage': '2', className: 'stageKnob', cx: '95', cy: '14', r: '' + (currentStage > 1 ? '15' : '7.5'), stroke: 'white', strokeWidth: '3', fill: '#e11d38' }),
	                    _react2.default.createElement('circle', { onClick: stageClick, 'data-stage': '3', className: 'stageKnob', cx: '208', cy: '14', r: '' + (currentStage > 2 ? '15' : '7.5'), stroke: 'white', strokeWidth: '3', fill: '#e11d38' }),
	                    _react2.default.createElement('circle', { onClick: stageClick, 'data-stage': '4', className: 'stageKnob', cx: '278', cy: '75', r: '' + (currentStage > 3 ? '15' : '7.5'), stroke: 'white', strokeWidth: '3', fill: '#e11d38' })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'label one' },
	                t('homeHero.roadConditionDegrees.0.degree')
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'label two' },
	                t('homeHero.roadConditionDegrees.1.degree')
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'label three' },
	                t('homeHero.roadConditionDegrees.2.degree')
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'label four' },
	                t('homeHero.roadConditionDegrees.3.degree')
	            )
	        );
	    } else {
	        return _react2.default.createElement(
	            'div',
	            { className: 'controlsWrapper mobile' },
	            _react2.default.createElement(
	                'svg',
	                { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 303.62 161.73' },
	                _react2.default.createElement(
	                    'g',
	                    { id: 'Layer_2', 'data-name': 'Layer 2', transform: 'translate(0, 10)' },
	                    _react2.default.createElement(
	                        'g',
	                        { className: 'whiteStrokes' },
	                        _react2.default.createElement('path', { fill: 'none', stroke: '#fdfdfd', opacity: '0.3', strokeWidth: '5px', d: 'M22 75, H282' })
	                    ),
	                    _react2.default.createElement(
	                        'g',
	                        { className: 'redStrokes' },
	                        _react2.default.createElement('path', { className: 'redStroke ' + (currentStage > 1 ? 'active' : 'inactive'), style: { transitionDuration: '300ms', transitionDelay: multipliers[0] + 'ms' }, fill: 'none', stroke: '#e11d38', strokeWidth: '8px', d: 'M22 75, H109' }),
	                        _react2.default.createElement('path', { className: 'redStroke ' + (currentStage > 2 ? 'active' : 'inactive'), style: { transitionDuration: '300ms', transitionDelay: multipliers[1] + 'ms' }, fill: 'none', stroke: '#e11d38', strokeWidth: '8px', d: 'M107 75, H196' }),
	                        _react2.default.createElement('path', { className: 'redStroke ' + (currentStage > 3 ? 'active' : 'inactive'), style: { transitionDuration: '300ms', transitionDelay: multipliers[2] + 'ms' }, fill: 'none', stroke: '#e11d38', strokeWidth: '8px', d: 'M197 75, H282' })
	                    ),
	                    _react2.default.createElement('circle', { onClick: stageClick, 'data-stage': '1', className: 'stageKnob', cx: '22', cy: '75', r: '18', stroke: 'white', strokeWidth: '5', fill: '#e11d38' }),
	                    _react2.default.createElement('circle', { onClick: stageClick, 'data-stage': '2', className: 'stageKnob', cx: '109', cy: '75', r: '' + (currentStage > 1 ? '18' : '10'), stroke: 'white', strokeWidth: '5', fill: '#e11d38' }),
	                    _react2.default.createElement('circle', { onClick: stageClick, 'data-stage': '3', className: 'stageKnob', cx: '196', cy: '75', r: '' + (currentStage > 2 ? '18' : '10'), stroke: 'white', strokeWidth: '5', fill: '#e11d38' }),
	                    _react2.default.createElement('circle', { onClick: stageClick, 'data-stage': '4', className: 'stageKnob', cx: '282', cy: '75', r: '' + (currentStage > 3 ? '18' : '10'), stroke: 'white', strokeWidth: '5', fill: '#e11d38' }),
	                    _react2.default.createElement('circle', { onClick: stageClick, 'data-stage': '1', opacity: '0', cx: '22', cy: '75', r: '40', stroke: 'none', strokeWidth: '5', fill: '#e11d38' }),
	                    _react2.default.createElement('circle', { onClick: stageClick, 'data-stage': '2', opacity: '0', cx: '109', cy: '75', r: '40', stroke: 'none', strokeWidth: '5', fill: '#e11d38' }),
	                    _react2.default.createElement('circle', { onClick: stageClick, 'data-stage': '3', opacity: '0', cx: '196', cy: '75', r: '40', stroke: 'none', strokeWidth: '5', fill: '#e11d38' }),
	                    _react2.default.createElement('circle', { onClick: stageClick, 'data-stage': '4', opacity: '0', cx: '282', cy: '75', r: '40', stroke: 'none', strokeWidth: '5', fill: '#e11d38' })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'label one ' + (currentStage === 1 ? 'active' : 'inactive') },
	                t('homeHero.roadConditionDegrees.0.degree')
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'label two ' + (currentStage === 2 ? 'active' : 'inactive') },
	                t('homeHero.roadConditionDegrees.1.degree')
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'label three ' + (currentStage === 3 ? 'active' : 'inactive') },
	                t('homeHero.roadConditionDegrees.2.degree')
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'label four ' + (currentStage === 4 ? 'active' : 'inactive') },
	                t('homeHero.roadConditionDegrees.3.degree')
	            )
	        );
	    }
	};
	
	exports.default = (0, _reactI18next.translate)()(Controls);
	module.exports = exports['default'];

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _moment = __webpack_require__(376);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mobxReact = __webpack_require__(22);
	
	var _reactI18next = __webpack_require__(19);
	
	var _i18n = __webpack_require__(104);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _Bumpometer = __webpack_require__(438);
	
	var _Bumpometer2 = _interopRequireDefault(_Bumpometer);
	
	var _PizzaMess = __webpack_require__(441);
	
	var _PizzaMess2 = _interopRequireDefault(_PizzaMess);
	
	var _Controls = __webpack_require__(439);
	
	var _Controls2 = _interopRequireDefault(_Controls);
	
	var _TimeStamp = __webpack_require__(442);
	
	var _TimeStamp2 = _interopRequireDefault(_TimeStamp);
	
	var _styledComponents3 = __webpack_require__(443);
	
	var _typography = __webpack_require__(29);
	
	var _blackPizza = __webpack_require__(935);
	
	var _blackPizza2 = _interopRequireDefault(_blackPizza);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var heroVideoMp4 = __webpack_require__(945);
	var heroVideoWebM = __webpack_require__(946);
	
	var HomeHero = (_dec = (0, _mobxReact.inject)("store"), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
	  _inherits(HomeHero, _Component);
	
	  function HomeHero(props) {
	    _classCallCheck(this, HomeHero);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.stage1Frame = 6;
	    _this.stage2Frame = 24;
	    _this.stage3Frame = 34;
	    _this.stage4Frame = 42;
	
	    _this.numberOfTicks = 0;
	
	    _this.state = {
	      currentStage: 0,
	      timeDate: null,
	      timeTime: null,
	      interaction: false,
	      controls: false,
	      loading: true,
	      lineData: 0
	    };
	
	    _this.readyStateInterval = null;
	    _this.loading = false;
	    _this.oldFrame = null;
	    _this.oldStage = 1;
	    _this.stageClick = _this.stageClick.bind(_this);
	    _this.onTimeUpdate = _this.onTimeUpdate.bind(_this);
	    _this.jumpTo = _this.jumpTo.bind(_this);
	    _this.startVideo = _this.startVideo.bind(_this);
	    return _this;
	  }
	
	  HomeHero.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.setState({
	      timeDate: this.props.lng === 'en' ? (0, _moment2.default)().format("MMM.DD.YY") : (0, _moment2.default)().locale('es').format("MMMDD.YY"),
	      timeTime: (0, _moment2.default)().format("h:mm a")
	    });
	    setInterval(function () {
	      var timeTime = (0, _moment2.default)().format("h:mm a");
	      _this2.setState({
	        timeTime: timeTime
	      });
	    }, 30000);
	    this.homeHeroVideo.addEventListener('canplaythrough', this.startVideo);
	    this.readyStateInterval = setInterval(function () {
	      if (_this2.homeHeroVideo.readyState === 1 && !_this2.loading) {
	        _this2.homeHeroVideo.load();
	        _this2.loading = true;
	      }
	    }, 300);
	    if (this.homeHeroVideo.readyState > 3) {
	      this.homeHeroVideo.pause();
	      this.startVideo();
	    }
	  };
	
	  HomeHero.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.lng !== prevProps.lng) {
	      this.setState({
	        timeDate: this.props.lng === 'en' ? (0, _moment2.default)().format("MMM.DD.YY") : (0, _moment2.default)().locale('es').format("MMMDD.YY")
	      });
	    }
	  };
	
	  HomeHero.prototype.startVideo = function startVideo() {
	    clearInterval(this.readyStateInterval);
	    this.setState({
	      loading: false
	    });
	    var vidPromise = this.homeHeroVideo.play();
	  };
	
	  HomeHero.prototype.onTimeUpdate = function onTimeUpdate(e) {
	    var videoFrame = Math.round(e.target.currentTime);
	    if (videoFrame === 24) {
	      this.setState({
	        lineData: 1.3
	      });
	    } else if (videoFrame === 34) {
	      this.setState({
	        lineData: 1.3
	      });
	    } else if (videoFrame === 36) {
	      this.setState({
	        lineData: 1.3
	      });
	    } else if (videoFrame === 42) {
	      this.setState({
	        lineData: 1.3
	      });
	    } else if (videoFrame === 43) {
	      this.setState({
	        lineData: 1.35
	      });
	    } /* else if(videoFrame === 45) {
	      this.setState({
	        lineData: 1.3
	      });
	      } */else {
	        if (this.state.lineData !== null) {
	          this.setState({
	            lineData: null
	          });
	        }
	      }
	    switch (this.state.currentStage) {
	      case 0:
	        if (videoFrame >= this.stage1Frame) {
	          this.setState({
	            currentStage: 1,
	            controls: true
	          });
	        }
	        break;
	      case 1:
	        if (videoFrame >= this.stage2Frame) {
	          this.homeHeroVideo.currentTime = this.stage1Frame;
	        }
	        break;
	      case 2:
	        if (videoFrame >= this.stage3Frame) {
	          this.homeHeroVideo.currentTime = this.stage2Frame;
	        }
	        break;
	      case 3:
	        if (videoFrame >= this.stage4Frame) {
	          this.homeHeroVideo.currentTime = this.stage3Frame;
	        }
	        break;
	      case 4:
	        if (videoFrame >= Math.round(this.homeHeroVideo.duration)) {
	          this.homeHeroVideo.currentTime = this.stage4Frame;
	        }
	        break;
	    }
	  };
	
	  HomeHero.prototype.jumpTo = function jumpTo(stage) {
	    this.oldStage = this.state.currentStage;
	    this.setState({
	      currentStage: stage
	    });
	    switch (stage) {
	      case 1:
	        this.homeHeroVideo.currentTime = this.stage1Frame;
	        break;
	      case 2:
	        this.homeHeroVideo.currentTime = this.stage2Frame;
	        break;
	      case 3:
	        this.homeHeroVideo.currentTime = this.stage3Frame;
	        break;
	      case 4:
	        this.homeHeroVideo.currentTime = this.stage4Frame;
	        break;
	    }
	  };
	
	  HomeHero.prototype.stageClick = function stageClick(e) {
	    var stage = parseInt(e.currentTarget.getAttribute('data-stage'));
	    if (this.state.interaction === false) {
	      this.setState({
	        interaction: true
	      });
	    }
	    this.jumpTo(stage);
	    var conditions = ['mild', 'moderate', 'critical', 'catastrophic'];
	    window.dataLayer.push({
	      'event': 'road-condition:click',
	      'condition': conditions[stage - 1]
	    });
	  };
	
	  HomeHero.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        data = _props.data,
	        store = _props.store,
	        t = _props.t,
	        lng = _props.lng;
	
	
	    console.log('currentStage', this.state.currentStage);
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: {
	            width: '100%',
	            paddingTop: '' + (store.isMobile ? 'calc((10/7) * 100%)' : 'calc((9/16) * 100%)'),
	            position: 'relative',
	            overflow: 'hidden'
	          } },
	        this.state.loading && _react2.default.createElement(
	          _styledComponents3.LoadingWrapper,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'pizzaHolder' },
	            _react2.default.createElement(_blackPizza2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'loading' },
	            t('homeHero.loadingText')
	          )
	        ),
	        _react2.default.createElement(
	          _styledComponents3.FakeZoomer,
	          { className: '' + (this.state.interaction ? 'zoomed' : '') },
	          _react2.default.createElement('div', { className: 'top' }),
	          _react2.default.createElement('div', { className: 'left' }),
	          _react2.default.createElement('div', { className: 'right' }),
	          _react2.default.createElement('div', { className: 'bottom' })
	        ),
	        _react2.default.createElement(
	          'video',
	          {
	            ref: function ref(video) {
	              _this3.homeHeroVideo = video;
	            },
	            width: '' + (store.isMobile ? '255%' : '100%)'),
	            height: 'auto',
	            muted: true,
	            playsInline: true,
	            preload: true,
	            style: {
	              position: 'absolute',
	              top: 0,
	              bottom: 0,
	              right: 0,
	              left: '' + (store.isMobile ? '-84%' : '0')
	            },
	            onTimeUpdate: this.onTimeUpdate
	          },
	          _react2.default.createElement('source', { src: heroVideoMp4, type: 'video/mp4' })
	        ),
	        _react2.default.createElement(
	          _styledComponents3.HeroUILayout,
	          { lang: lng, interaction: this.state.interaction, controls: this.state.controls },
	          !store.isMobile && _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_TimeStamp2.default, { timeValue: this.state.timeDate, direction: 'left' }),
	            _react2.default.createElement(_TimeStamp2.default, { timeValue: this.state.timeTime, direction: 'right' })
	          ),
	          !store.isMobile && _react2.default.createElement(_Bumpometer2.default, { currentStage: this.state.currentStage, label: t('homeHero.impactMeterLabel'), lineData: this.state.lineData, isMobile: store.isMobile }),
	          !store.isMobile && _react2.default.createElement(_PizzaMess2.default, { currentStage: this.state.currentStage, label: t('homeHero.pizzaDamageLabel') }),
	          _react2.default.createElement(_Controls2.default, { currentStage: this.state.currentStage, stageClick: this.stageClick, oldStage: this.oldStage, isMobile: store.isMobile }),
	          _react2.default.createElement(
	            'div',
	            { className: 'controlLabel' },
	            t('homeHero.controlLabel')
	          )
	        ),
	        _react2.default.createElement(
	          _styledComponents3.HeroHeaderCopy,
	          { 'in': this.state.controls && !this.state.interaction },
	          _react2.default.createElement(
	            _typography.H1,
	            { color: 'red' },
	            t('homeHero.introCopy')
	          )
	        ),
	        _react2.default.createElement(
	          _styledComponents3.HeroStamp,
	          { 'in': this.state.controls && !this.state.interaction },
	          t('homeHero.stamp')
	        )
	      )
	    );
	  };
	
	  return HomeHero;
	}(_react.Component)) || _class) || _class);
	exports.default = (0, _reactI18next.translate)()(HomeHero);
	module.exports = exports['default'];

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lottieWeb = __webpack_require__(825);
	
	var LOTTIE = _interopRequireWildcard(_lottieWeb);
	
	var _PizzaMess = __webpack_require__(794);
	
	var _PizzaMess2 = _interopRequireDefault(_PizzaMess);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PizzaMess = function (_Component) {
	  _inherits(PizzaMess, _Component);
	
	  function PizzaMess(props) {
	    _classCallCheck(this, PizzaMess);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.animation = null;
	
	    _this.state = {
	      currentStage: 1
	    };
	    return _this;
	  }
	
	  PizzaMess.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.animation = LOTTIE.loadAnimation({
	      container: this.refs.mainCanvas, // Required
	      animationData: _PizzaMess2.default,
	      renderer: 'svg',
	      loop: false,
	      autoplay: false,
	      name: "Hello World" // Name for future reference. Optional.
	    });
	    window.onkeydown = this.checkKey.bind(this);
	    this.animation.addEventListener('DOMLoaded', function () {
	      _this2.animation.playSegments([[0, 100]], true);
	      // this.animation.goToAndStop(100,true);
	    });
	  };
	
	  PizzaMess.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var currentStage = nextProps.currentStage;
	
	    if (currentStage !== this.state.currentStage) {
	      this.setState({
	        currentStage: currentStage
	      });
	    }
	  };
	
	  PizzaMess.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.state.currentStage === 1 && this.state.currentStage !== prevProps.currentStage) {
	      this.animation.playSegments([[0, 150]], true);
	    }
	    if (this.state.currentStage === 2 && this.state.currentStage !== prevProps.currentStage) {
	      this.animation.playSegments([[180, 250]], true);
	    }
	    if (this.state.currentStage === 3 && this.state.currentStage !== prevProps.currentStage) {
	      this.animation.playSegments([[330, 400]], true);
	    }
	    if (this.state.currentStage === 4 && this.state.currentStage !== prevProps.currentStage) {
	      this.animation.playSegments([[490, 600]], true);
	    }
	  };
	
	  PizzaMess.prototype.checkKey = function checkKey(e) {
	    // console.log(e);
	    if (e.key === '1') {}
	    if (e.key === '2') {
	      this.animation.playSegments([150, 250], true);
	    }
	    if (e.key === '3') {
	      this.animation.playSegments([300, 400], true);
	    }
	    if (e.key === '4') {
	      this.animation.playSegments([450, 600], true);
	    }
	  };
	
	  PizzaMess.prototype.componentWillUpdate = function componentWillUpdate() {};
	
	  PizzaMess.prototype.render = function render() {
	    var label = this.props.label;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'pizzaMessWrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'pizzamessCopy' },
	        label
	      ),
	      _react2.default.createElement('div', { className: 'pizzamess', ref: 'mainCanvas', style: { height: '120px', width: '120px' } })
	    );
	  };
	
	  return PizzaMess;
	}(_react.Component);
	
	exports.default = PizzaMess;
	module.exports = exports['default'];

/***/ }),

/***/ 794:
/***/ (function(module, exports) {

	module.exports = {"v":"5.1.15","fr":60,"ip":0,"op":721,"w":3000,"h":2970,"nm":"Master","ddd":0,"assets":[{"id":"comp_0","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Pepperoni Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[72.929,72.906,0],"ix":2},"a":{"a":0,"k":[2316.929,672.906,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trim Path (START)","np":3,"mn":"ADBE Slider Control","ix":1,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":0,"k":0,"ix":1}}]},{"ty":5,"nm":"Trim Path (END)","np":3,"mn":"ADBE Slider Control","ix":2,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":1,"k":[{"i":{"x":[0.58],"y":[1]},"o":{"x":[0.42],"y":[0]},"n":["0p58_1_0p42_0"],"t":0,"s":[0],"e":[100]},{"t":30}],"ix":1}}]}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-31.59],[31.59,0],[0,31.59],[-31.59,0]],"o":[[0,31.59],[-31.591,0],[0,-31.59],[31.59,0]],"v":[[57.198,-0.001],[0,57.199],[-57.199,-0.001],[0,-57.199]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[2316.929,672.906],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (START)')('Slider');"},"e":{"a":0,"k":100,"ix":2,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (END)')('Slider');"},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":9037.03703703704,"st":0,"bm":0}]},{"id":"comp_1","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Mushroom Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[89.49,89.786,0],"ix":2},"a":{"a":0,"k":[2242.49,487.786,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trim Path (START)","np":3,"mn":"ADBE Slider Control","ix":1,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":0,"k":0,"ix":1}}]},{"ty":5,"nm":"Trim Path (END)","np":3,"mn":"ADBE Slider Control","ix":2,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":1,"k":[{"i":{"x":[0.58],"y":[1]},"o":{"x":[0.42],"y":[0]},"n":["0p58_1_0p42_0"],"t":0,"s":[0],"e":[100]},{"t":30}],"ix":1}}]}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[19.253,-8.109],[9.683,9.683],[-57.767,57.768],[-9.684,-9.683],[5.603,-13.312],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-13.312,5.604],[-9.684,-9.684],[57.769,-57.768],[9.684,9.684],[-8.108,19.253],[0,0]],"v":[[50.149,11.089],[82.776,43.837],[63.307,63.306],[43.837,82.776],[13.067,52.005],[11.385,50.18],[-10.652,82.068],[-47.624,73.897],[-29.905,-29.904],[73.896,-47.624],[82.069,-10.652],[50.179,11.385]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[2232.322,477.618],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (START)')('Slider');"},"e":{"a":0,"k":100,"ix":2,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (END)')('Slider');"},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":9037.03703703704,"st":0,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Controller","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.46],"y":[1]},"o":{"x":[0.001],"y":[0.373]},"n":["0p46_1_0p001_0p373"],"t":20,"s":[180],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":80,"s":[0],"e":[0]},{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.88],"y":[0]},"n":["0p12_1_0p88_0"],"t":180,"s":[0],"e":[2]},{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.88],"y":[0]},"n":["0p12_1_0p88_0"],"t":190,"s":[2],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":210,"s":[0],"e":[0]},{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.88],"y":[0]},"n":["0p12_1_0p88_0"],"t":360,"s":[0],"e":[4]},{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.88],"y":[0]},"n":["0p12_1_0p88_0"],"t":370,"s":[4],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":390,"s":[0],"e":[0]},{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.88],"y":[0]},"n":["0p12_1_0p88_0"],"t":540,"s":[0],"e":[4]},{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.88],"y":[0]},"n":["0p12_1_0p88_0"],"t":550,"s":[4],"e":[0]},{"t":570}],"ix":10},"p":{"a":0,"k":[1500,1485,0],"ix":2},"a":{"a":0,"k":[1338,1324.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.25,1.25,1]},"o":{"x":[0.68,0.68,0.68],"y":[0,0,0]},"n":["0p27_1p25_0p68_0","0p27_1p25_0p68_0","0p27_1_0p68_0"],"t":20,"s":[50,50,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.68,0.68,0.68],"y":[0,0,0]},"n":["0p833_1_0p68_0","0p833_1_0p68_0","0p833_1_0p68_0"],"t":60,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[0.953,0.953,1]},"o":{"x":[0.88,0.88,0.88],"y":[0.047,0.047,0]},"n":["0p12_0p953_0p88_0p047","0p12_0p953_0p88_0p047","0p12_1_0p88_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.183,1.183,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.183,-0.183,0]},"n":["0p27_1p183_0p68_-0p183","0p27_1p183_0p68_-0p183","0p27_1_0p68_0"],"t":190,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":210,"s":[100,100,100],"e":[103,103,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[103,103,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":230,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[0.972,0.972,1]},"o":{"x":[0.88,0.88,0.88],"y":[0.028,0.028,0]},"n":["0p12_0p972_0p88_0p028","0p12_0p972_0p88_0p028","0p12_1_0p88_0"],"t":360,"s":[100,100,100],"e":[150,150,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.11,1.11,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.11,-0.11,0]},"n":["0p27_1p11_0p68_-0p11","0p27_1p11_0p68_-0p11","0p27_1_0p68_0"],"t":370,"s":[150,150,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":390,"s":[100,100,100],"e":[103,103,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[103,103,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":410,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[0.972,0.972,1]},"o":{"x":[0.88,0.88,0.88],"y":[0.028,0.028,0]},"n":["0p12_0p972_0p88_0p028","0p12_0p972_0p88_0p028","0p12_1_0p88_0"],"t":540,"s":[100,100,100],"e":[150,150,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.11,1.11,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.11,-0.11,0]},"n":["0p27_1p11_0p68_-0p11","0p27_1p11_0p68_-0p11","0p27_1_0p68_0"],"t":550,"s":[150,150,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":570,"s":[100,100,100],"e":[103,103,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":580,"s":[103,103,100],"e":[100,100,100]},{"t":590}],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Strength","np":3,"mn":"ADBE Slider Control","ix":1,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":0,"k":5,"ix":1}}]}],"ip":20,"op":9057.03703703704,"st":20,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Slice_01 Outlines","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":190,"s":[0],"e":[0]},{"i":{"x":[0.12],"y":[0.888]},"o":{"x":[0.88],"y":[0.112]},"n":["0p12_0p888_0p88_0p112"],"t":360,"s":[0],"e":[12]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":400,"s":[12],"e":[12]},{"i":{"x":[0.12],"y":[0.86]},"o":{"x":[0.88],"y":[0.14]},"n":["0p12_0p86_0p88_0p14"],"t":540,"s":[12],"e":[2]},{"t":580}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":190,"s":[1662.337,903.362,0],"e":[1662.337,903.362,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.888},"o":{"x":0.88,"y":0.112},"n":"0p12_0p888_0p88_0p112","t":360,"s":[1662.337,903.362,0],"e":[1914.337,533.362,0],"to":[42,-61.6666679382324,0],"ti":[-42,61.6666679382324,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.167,"y":0.167},"n":"0p12_0p12_0p167_0p167","t":400,"s":[1914.337,533.362,0],"e":[1914.337,533.362,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":540,"s":[1914.337,533.362,0],"e":[1811.425,609.091,0],"to":[-17.1521034240723,12.62135887146,0],"ti":[17.1521034240723,-12.62135887146,0]},{"t":580}],"ix":2},"a":{"a":0,"k":[1662.337,903.362,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.12,0.12,0.12],"y":[1,1,1]},"o":{"x":[0.88,0.88,0.88],"y":[0,0,0]},"n":["0p12_1_0p88_0","0p12_1_0p88_0","0p12_1_0p88_0"],"t":360,"s":[100,100,100],"e":[100,100,100]},{"t":540}],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trim Path (START)","np":3,"mn":"ADBE Slider Control","ix":1,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":0,"k":0,"ix":1}}]},{"ty":5,"nm":"Trim Path (END)","np":3,"mn":"ADBE Slider Control","ix":2,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":1,"k":[{"i":{"x":[0.58],"y":[1]},"o":{"x":[0.42],"y":[0]},"n":["0p58_1_0p42_0"],"t":20,"s":[0],"e":[100]},{"t":50}],"ix":1}}]}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-174.47,-168.919],[0,0]],"o":[[0,0],[243.33,3.936],[0,0],[0,0]],"v":[[-324.727,-76.357],[-323.229,-166.348],[324.726,101.676],[262.091,166.348]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[1662.337,609.954],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[212.262,3.431]],"o":[[0,0],[-163.621,-158.395],[0,0]],"v":[[-293.409,414.761],[293.409,-172.056],[-293.409,-414.761]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[1631.02,948.358],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (START)')('Slider');"},"e":{"a":0,"k":100,"ix":2,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (END)')('Slider');"},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":3,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":20,"op":9057.03703703704,"st":20,"bm":0},{"ddd":0,"ind":6,"ty":0,"nm":"S1_Pepperoni","parent":5,"refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.12],"y":[0.93]},"o":{"x":[0.88],"y":[0.07]},"n":["0p12_0p93_0p88_0p07"],"t":540,"s":[100],"e":[0]},{"t":560}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p833_1_0p68_0"],"t":230,"s":[0],"e":[0]},{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p12_1_0p167_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":180,"s":[1504,995,0],"e":[1504,995,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":360,"s":[1504,995,0],"e":[1504,995,0],"to":[0,0,0],"ti":[0,0,0]},{"t":540}],"ix":2},"a":{"a":0,"k":[73,73,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[0.93,0.93,1]},"o":{"x":[0.88,0.88,0.88],"y":[0.07,0.07,0]},"n":["0p12_0p93_0p88_0p07","0p12_0p93_0p88_0p07","0p12_1_0p88_0"],"t":540,"s":[100,100,100],"e":[150,150,100]},{"t":560}],"ix":6}},"ao":0,"w":146,"h":146,"ip":30,"op":9067,"st":30,"bm":0},{"ddd":0,"ind":7,"ty":0,"nm":"S1_Pepperoni 2","parent":5,"refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p833_1_0p68_0"],"t":230,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":180,"s":[1476,702,0],"e":[1476,702,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":360,"s":[1476,702,0],"e":[1476,702,0],"to":[0,0,0],"ti":[0,0,0]},{"t":540}],"ix":2},"a":{"a":0,"k":[73,73,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"t":540}],"ix":6}},"ao":0,"w":146,"h":146,"ip":36,"op":9073,"st":36,"bm":0},{"ddd":0,"ind":8,"ty":0,"nm":"S1_Mushroom","parent":5,"refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[180],"e":[180]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p833_1_0p68_0"],"t":230,"s":[180],"e":[180]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":360,"s":[180],"e":[180]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":180,"s":[1663.5,830,0],"e":[1663.5,830,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":360,"s":[1663.5,830,0],"e":[1663.5,830,0],"to":[0,0,0],"ti":[0,0,0]},{"t":540}],"ix":2},"a":{"a":0,"k":[89.5,90,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"t":540}],"ix":6}},"ao":0,"w":179,"h":180,"ip":42,"op":9079,"st":42,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Slice_02 Outlines","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":190,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":360,"s":[0],"e":[0]},{"i":{"x":[0.12],"y":[0.86]},"o":{"x":[0.88],"y":[0.14]},"n":["0p12_0p86_0p88_0p14"],"t":540,"s":[0],"e":[-40]},{"t":580}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":190,"s":[1798.119,1035.68,0],"e":[1798.119,1035.68,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[1798.119,1035.68,0],"e":[1871.906,954.126,0],"to":[12.2977342605591,-13.5922327041626,0],"ti":[-12.2977342605591,13.5922327041626,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.167,"y":0.167},"n":"0p12_0p12_0p167_0p167","t":400,"s":[1871.906,954.126,0],"e":[1871.906,954.126,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":540,"s":[1871.906,954.126,0],"e":[1869.964,1072.573,0],"to":[-0.32362458109856,19.7411003112793,0],"ti":[0.32362458109856,-19.7411003112793,0]},{"t":580}],"ix":2},"a":{"a":0,"k":[1798.119,1035.68,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.12,0.12,0.12],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p12_1_0p167_0","0p12_1_0p167_0","0p12_1_0p167_0"],"t":360,"s":[100,100,100],"e":[100,100,100]},{"t":540}],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trim Path (START)","np":3,"mn":"ADBE Slider Control","ix":1,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":0,"k":0,"ix":1}}]},{"ty":5,"nm":"Trim Path (END)","np":3,"mn":"ADBE Slider Control","ix":2,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":1,"k":[{"i":{"x":[0.58],"y":[1]},"o":{"x":[0.42],"y":[0]},"n":["0p58_1_0p42_0"],"t":20,"s":[0],"e":[100]},{"t":50}],"ix":1}}]}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[190.241,-325.097],[-459.953,325.097],[459.953,325.097]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 2","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[1798.119,1035.818],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-3.925,-242.812]],"o":[[169.277,174.844],[0,0]],"v":[[-134.326,-323.848],[134.326,323.848]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[2123.746,1035.627],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[147.666,152.518]],"o":[[0,0],[-3.695,-227.699],[0,0]],"v":[[-414.943,293.281],[414.943,293.281],[171.618,-293.28]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[1753.109,1067.635],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-325.235,325.235],[325.235,-325.235]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 2","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[1663.402,1035.68],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":3,"cix":2,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (START)')('Slider');"},"e":{"a":0,"k":100,"ix":2,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (END)')('Slider');"},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":5,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":20,"op":9057.03703703704,"st":20,"bm":0},{"ddd":0,"ind":10,"ty":0,"nm":"S2_Pepperoni","parent":9,"refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.12],"y":[0.86]},"o":{"x":[0.88],"y":[0.14]},"n":["0p12_0p86_0p88_0p14"],"t":540,"s":[100],"e":[0]},{"t":560}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p833_1_0p68_0"],"t":230,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.16,"y":1},"o":{"x":0.84,"y":0},"n":"0p16_1_0p84_0","t":180,"s":[1685,1195,0],"e":[1618,1391,0],"to":[-11.1666669845581,32.6666679382324,0],"ti":[11.1666669845581,-32.6666679382324,0]},{"i":{"x":0.16,"y":0.16},"o":{"x":0.167,"y":0.167},"n":"0p16_0p16_0p167_0p167","t":230,"s":[1618,1391,0],"e":[1618,1391,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[1618,1391,0],"e":[1685,1195,0],"to":[11.1666669845581,-32.6666679382324,0],"ti":[-11.1666669845581,32.6666679382324,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.84,"y":0.84},"n":"0p12_0p12_0p84_0p84","t":400,"s":[1685,1195,0],"e":[1685,1195,0],"to":[0,0,0],"ti":[0,0,0]},{"t":540}],"ix":2},"a":{"a":0,"k":[73,73,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[0.86,0.86,1]},"o":{"x":[0.88,0.88,0.88],"y":[0.14,0.14,0]},"n":["0p12_0p86_0p88_0p14","0p12_0p86_0p88_0p14","0p12_1_0p88_0"],"t":540,"s":[100,100,100],"e":[150,150,100]},{"t":560}],"ix":6}},"ao":0,"w":146,"h":146,"ip":30,"op":9067,"st":30,"bm":0},{"ddd":0,"ind":11,"ty":0,"nm":"S2_Pepperoni 2","parent":9,"refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.12],"y":[0.86]},"o":{"x":[0.88],"y":[0.14]},"n":["0p12_0p86_0p88_0p14"],"t":540,"s":[100],"e":[0]},{"t":560}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p833_1_0p68_0"],"t":230,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.16,"y":1},"o":{"x":0.84,"y":0},"n":"0p16_1_0p84_0","t":180,"s":[1904,1227,0],"e":[1758,1341,0],"to":[-24.3333339691162,19,0],"ti":[24.3333339691162,-19,0]},{"i":{"x":0.16,"y":0.16},"o":{"x":0.167,"y":0.167},"n":"0p16_0p16_0p167_0p167","t":230,"s":[1758,1341,0],"e":[1758,1341,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[1758,1341,0],"e":[1904,1227,0],"to":[24.3333339691162,-19,0],"ti":[-24.3333339691162,19,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.84,"y":0.84},"n":"0p12_0p12_0p84_0p84","t":400,"s":[1904,1227,0],"e":[1904,1227,0],"to":[0,0,0],"ti":[0,0,0]},{"t":540}],"ix":2},"a":{"a":0,"k":[73,73,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[0.86,0.86,1]},"o":{"x":[0.88,0.88,0.88],"y":[0.14,0.14,0]},"n":["0p12_0p86_0p88_0p14","0p12_0p86_0p88_0p14","0p12_1_0p88_0"],"t":540,"s":[100,100,100],"e":[150,150,100]},{"t":560}],"ix":6}},"ao":0,"w":146,"h":146,"ip":36,"op":9073,"st":36,"bm":0},{"ddd":0,"ind":12,"ty":0,"nm":"S2_Mushroom","parent":9,"refId":"comp_1","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.12],"y":[0.86]},"o":{"x":[0.88],"y":[0.14]},"n":["0p12_0p86_0p88_0p14"],"t":540,"s":[100],"e":[0]},{"t":560}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[270],"e":[270]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p833_1_0p68_0"],"t":230,"s":[270],"e":[270]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":360,"s":[270],"e":[270]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":180,"s":[1913.5,1014,0],"e":[1913.5,1014,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":360,"s":[1913.5,1014,0],"e":[1913.5,1014,0],"to":[0,0,0],"ti":[0,0,0]},{"t":540}],"ix":2},"a":{"a":0,"k":[89.5,90,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[0.86,0.86,1]},"o":{"x":[0.88,0.88,0.88],"y":[0.14,0.14,0]},"n":["0p12_0p86_0p88_0p14","0p12_0p86_0p88_0p14","0p12_1_0p88_0"],"t":540,"s":[100,100,100],"e":[150,150,100]},{"t":560}],"ix":6}},"ao":0,"w":179,"h":180,"ip":42,"op":9079,"st":42,"bm":0},{"ddd":0,"ind":13,"ty":4,"nm":"Slice_03 Outlines","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":190,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":190,"s":[1797.826,1688.079,0],"e":[1797.826,1688.079,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[1797.826,1688.079,0],"e":[1865.787,1598.759,0],"to":[11.3268604278564,-14.8867311477661,0],"ti":[-11.3268604278564,14.8867311477661,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.167,"y":0.167},"n":"0p12_0p12_0p167_0p167","t":400,"s":[1865.787,1598.759,0],"e":[1865.787,1598.759,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":540,"s":[1865.787,1598.759,0],"e":[2178.409,1928.856,0],"to":[52.1035614013672,55.0161819458008,0],"ti":[-52.1035614013672,-55.0161819458008,0]},{"t":580}],"ix":2},"a":{"a":0,"k":[1797.826,1688.079,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":360,"s":[100,100,100],"e":[100,100,100]},{"t":540}],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trim Path (START)","np":3,"mn":"ADBE Slider Control","ix":1,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":0,"k":0,"ix":1}}]},{"ty":5,"nm":"Trim Path (END)","np":3,"mn":"ADBE Slider Control","ix":2,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":1,"k":[{"i":{"x":[0.58],"y":[1]},"o":{"x":[0.42],"y":[0]},"n":["0p58_1_0p42_0"],"t":20,"s":[0],"e":[100]},{"t":50}],"ix":1}}]}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[459.757,-325.236],[-459.756,-325.236],[190.715,325.236]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[1797.826,1688.079],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[168.918,-174.471]],"o":[[-3.936,243.331],[0,0]],"v":[[134.011,-323.978],[-134.012,323.978]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[2123.571,1688.318],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-3.432,212.262]],"o":[[0,0],[158.393,-163.621],[0,0]],"v":[[-414.761,-293.408],[172.057,293.409],[414.761,-293.408]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[1752.831,1656.252],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (START)')('Slider');"},"e":{"a":0,"k":100,"ix":2,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (END)')('Slider');"},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":4,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":20,"op":9057.03703703704,"st":20,"bm":0},{"ddd":0,"ind":14,"ty":0,"nm":"S3_Pepperoni","parent":13,"refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.12],"y":[0.86]},"o":{"x":[0.88],"y":[0.14]},"n":["0p12_0p86_0p88_0p14"],"t":540,"s":[100],"e":[0]},{"t":560}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p833_1_0p68_0"],"t":230,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.16,"y":1},"o":{"x":0.84,"y":0},"n":"0p16_1_0p84_0","t":180,"s":[1913,1708,0],"e":[1681,1512,0],"to":[-38.6666679382324,-32.6666679382324,0],"ti":[38.6666679382324,32.6666679382324,0]},{"i":{"x":0.16,"y":0.16},"o":{"x":0.167,"y":0.167},"n":"0p16_0p16_0p167_0p167","t":230,"s":[1681,1512,0],"e":[1681,1512,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[1681,1512,0],"e":[1915.951,1698.408,0],"to":[39.158576965332,31.0679607391357,0],"ti":[-39.158576965332,-31.0679607391357,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.167,"y":0.167},"n":"0p12_0p12_0p167_0p167","t":400,"s":[1915.951,1698.408,0],"e":[1915.951,1698.408,0],"to":[0,0,0],"ti":[0,0,0]},{"t":540}],"ix":2},"a":{"a":0,"k":[73,73,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[0.86,0.86,1]},"o":{"x":[0.88,0.88,0.88],"y":[0.14,0.14,0]},"n":["0p12_0p86_0p88_0p14","0p12_0p86_0p88_0p14","0p12_1_0p88_0"],"t":540,"s":[100,100,100],"e":[150,150,100]},{"t":560}],"ix":6}},"ao":0,"w":146,"h":146,"ip":30,"op":9067,"st":30,"bm":0},{"ddd":0,"ind":15,"ty":0,"nm":"S3_Mushroom","parent":13,"refId":"comp_1","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.12],"y":[0.86]},"o":{"x":[0.88],"y":[0.14]},"n":["0p12_0p86_0p88_0p14"],"t":540,"s":[100],"e":[0]},{"t":560}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[90],"e":[90]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p833_1_0p68_0"],"t":230,"s":[90],"e":[90]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":360,"s":[90],"e":[90]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.16,"y":1},"o":{"x":0.84,"y":0},"n":"0p16_1_0p84_0","t":180,"s":[1758,1516,0],"e":[1587,1408,0],"to":[-28.5,-18,0],"ti":[28.5,18,0]},{"i":{"x":0.16,"y":0.16},"o":{"x":0.167,"y":0.167},"n":"0p16_0p16_0p167_0p167","t":230,"s":[1587,1408,0],"e":[1587,1408,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[1587,1408,0],"e":[1767.583,1508.971,0],"to":[30.0970878601074,16.8284797668457,0],"ti":[-30.0970878601074,-16.8284797668457,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.167,"y":0.167},"n":"0p12_0p12_0p167_0p167","t":400,"s":[1767.583,1508.971,0],"e":[1767.583,1508.971,0],"to":[0,0,0],"ti":[0,0,0]},{"t":540}],"ix":2},"a":{"a":0,"k":[89.5,90,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[0.86,0.86,1]},"o":{"x":[0.88,0.88,0.88],"y":[0.14,0.14,0]},"n":["0p12_0p86_0p88_0p14","0p12_0p86_0p88_0p14","0p12_1_0p88_0"],"t":540,"s":[100,100,100],"e":[150,150,100]},{"t":560}],"ix":6}},"ao":0,"w":179,"h":180,"ip":36,"op":9073,"st":36,"bm":0},{"ddd":0,"ind":16,"ty":4,"nm":"Slice_04 Outlines","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":190,"s":[0],"e":[0]},{"i":{"x":[0.27],"y":[1.183]},"o":{"x":[0.68],"y":[-0.917]},"n":["0p27_1p183_0p68_-0p917"],"t":360,"s":[0],"e":[-18]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":400,"s":[-18],"e":[-18]},{"i":{"x":[0.12],"y":[0.86]},"o":{"x":[0.88],"y":[0.14]},"n":["0p12_0p86_0p88_0p14"],"t":540,"s":[-18],"e":[0]},{"t":580}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":190,"s":[1662.526,1824.493,0],"e":[1662.526,1824.493,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[1662.526,1824.493,0],"e":[1998.448,2067.212,0],"to":[55.9870567321777,40.4530754089355,0],"ti":[-55.9870567321777,-40.4530754089355,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.167,"y":0.167},"n":"0p12_0p12_0p167_0p167","t":400,"s":[1998.448,2067.212,0],"e":[1998.448,2067.212,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":540,"s":[1998.448,2067.212,0],"e":[1883.885,2119.639,0],"to":[-19.0938510894775,8.73786449432373,0],"ti":[19.0938510894775,-8.73786449432373,0]},{"t":580}],"ix":2},"a":{"a":0,"k":[1662.526,1824.493,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.825,1.825,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.825,-0.825,0]},"n":["0p27_1p825_0p68_-0p825","0p27_1p825_0p68_-0p825","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[110,110,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.825,1.825,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.825,-0.825,0]},"n":["0p27_1p825_0p68_-0p825","0p27_1p825_0p68_-0p825","0p27_1_0p68_0"],"t":380,"s":[110,110,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[1,1,1]},"o":{"x":[0.68,0.68,0.68],"y":[0,0,0]},"n":["0p12_1_0p68_0","0p12_1_0p68_0","0p12_1_0p68_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"t":540}],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trim Path (START)","np":3,"mn":"ADBE Slider Control","ix":1,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":0,"k":0,"ix":1}}]},{"ty":5,"nm":"Trim Path (END)","np":3,"mn":"ADBE Slider Control","ix":2,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":1,"k":[{"i":{"x":[0.58],"y":[1]},"o":{"x":[0.42],"y":[0]},"n":["0p58_1_0p42_0"],"t":20,"s":[0],"e":[100]},{"t":50}],"ix":1}}]}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-174.843,169.278],[0,0]],"o":[[0,0],[242.812,-3.926],[0,0],[0,0]],"v":[[-324.568,76.651],[-323.128,166.672],[324.568,-101.981],[261.993,-166.673]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[1662.526,2117.774],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-152.518,147.667]],"o":[[0,0],[227.699,-3.696],[0,0]],"v":[[-293.281,-414.943],[-293.281,414.943],[293.28,171.618]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[1631.239,1779.483],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (START)')('Slider');"},"e":{"a":0,"k":100,"ix":2,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (END)')('Slider');"},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":3,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":20,"op":9057.03703703704,"st":20,"bm":0},{"ddd":0,"ind":17,"ty":0,"nm":"S4_Pepperoni","parent":16,"refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.12],"y":[0.86]},"o":{"x":[0.88],"y":[0.14]},"n":["0p12_0p86_0p88_0p14"],"t":540,"s":[100],"e":[0]},{"t":560}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[0],"e":[0]},{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p12_1_0p68_0"],"t":230,"s":[0],"e":[0]},{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.88],"y":[0]},"n":["0p12_1_0p88_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.16,"y":1},"o":{"x":0.84,"y":0},"n":"0p16_1_0p84_0","t":180,"s":[1477,1680,0],"e":[1530,1584,0],"to":[8.83333301544189,-16,0],"ti":[-8.83333301544189,16,0]},{"i":{"x":0.16,"y":0.16},"o":{"x":0.167,"y":0.167},"n":"0p16_0p16_0p167_0p167","t":230,"s":[1530,1584,0],"e":[1530,1584,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[1530,1584,0],"e":[1477,1680,0],"to":[-8.83333301544189,16,0],"ti":[8.83333301544189,-16,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.84,"y":0.84},"n":"0p12_0p12_0p84_0p84","t":400,"s":[1477,1680,0],"e":[1477,1680,0],"to":[0,0,0],"ti":[0,0,0]},{"t":540}],"ix":2},"a":{"a":0,"k":[73,73,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p12_1_0p167_0","0p12_1_0p167_0","0p12_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[0.86,0.86,1]},"o":{"x":[0.88,0.88,0.88],"y":[0.14,0.14,0]},"n":["0p12_0p86_0p88_0p14","0p12_0p86_0p88_0p14","0p12_1_0p88_0"],"t":540,"s":[100,100,100],"e":[150,150,100]},{"t":560}],"ix":6}},"ao":0,"w":146,"h":146,"ip":30,"op":9067,"st":30,"bm":0},{"ddd":0,"ind":18,"ty":0,"nm":"S4_Pepperoni 2","parent":16,"refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.12],"y":[0.86]},"o":{"x":[0.88],"y":[0.14]},"n":["0p12_0p86_0p88_0p14"],"t":540,"s":[100],"e":[0]},{"t":560}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p833_1_0p68_0"],"t":230,"s":[0],"e":[0]},{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p12_1_0p167_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.16,"y":1},"o":{"x":0.84,"y":0},"n":"0p16_1_0p84_0","t":180,"s":[1490,2021,0],"e":[1559,1907,0],"to":[11.5,-19,0],"ti":[-11.5,19,0]},{"i":{"x":0.16,"y":0.16},"o":{"x":0.167,"y":0.167},"n":"0p16_0p16_0p167_0p167","t":230,"s":[1559,1907,0],"e":[1559,1907,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[1559,1907,0],"e":[1490,2021,0],"to":[-11.5,19,0],"ti":[11.5,-19,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.84,"y":0.84},"n":"0p12_0p12_0p84_0p84","t":400,"s":[1490,2021,0],"e":[1490,2021,0],"to":[0,0,0],"ti":[0,0,0]},{"t":540}],"ix":2},"a":{"a":0,"k":[73,73,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[0.86,0.86,1]},"o":{"x":[0.88,0.88,0.88],"y":[0.14,0.14,0]},"n":["0p12_0p86_0p88_0p14","0p12_0p86_0p88_0p14","0p12_1_0p88_0"],"t":540,"s":[100,100,100],"e":[150,150,100]},{"t":560}],"ix":6}},"ao":0,"w":146,"h":146,"ip":36,"op":9073,"st":36,"bm":0},{"ddd":0,"ind":19,"ty":0,"nm":"S4_Mushroom","parent":16,"refId":"comp_1","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.12],"y":[0.86]},"o":{"x":[0.88],"y":[0.14]},"n":["0p12_0p86_0p88_0p14"],"t":540,"s":[100],"e":[0]},{"t":560}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p833_1_0p68_0"],"t":230,"s":[0],"e":[0]},{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p12_1_0p167_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":180,"s":[1616.5,1834,0],"e":[1616.5,1834,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.167,"y":0.167},"n":"0p12_0p12_0p167_0p167","t":360,"s":[1616.5,1834,0],"e":[1616.5,1834,0],"to":[0,0,0],"ti":[0,0,0]},{"t":540}],"ix":2},"a":{"a":0,"k":[89.5,90,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[0.86,0.86,1]},"o":{"x":[0.88,0.88,0.88],"y":[0.14,0.14,0]},"n":["0p12_0p86_0p88_0p14","0p12_0p86_0p88_0p14","0p12_1_0p88_0"],"t":540,"s":[100,100,100],"e":[150,150,100]},{"t":560}],"ix":6}},"ao":0,"w":179,"h":180,"ip":42,"op":9079,"st":42,"bm":0},{"ddd":0,"ind":20,"ty":4,"nm":"Slice_05 Outlines","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p12_1_0p167_0"],"t":190,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.88],"y":[0]},"n":["0p833_1_0p88_0"],"t":360,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":540,"s":[0],"e":[22]},{"t":580}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":190,"s":[1013.697,1823.906,0],"e":[1013.697,1823.906,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[1013.697,1823.906,0],"e":[1099.133,1719.051,0],"to":[14.2394819259644,-17.4757289886475,0],"ti":[-14.2394819259644,17.4757289886475,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.167,"y":0.167},"n":"0p12_0p12_0p167_0p167","t":400,"s":[1099.133,1719.051,0],"e":[1099.133,1719.051,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.885},"o":{"x":0.167,"y":0},"n":"0p12_0p885_0p167_0","t":540,"s":[1099.133,1719.051,0],"e":[1095.25,1554.003,0],"to":[-0.64724916219711,-27.5080909729004,0],"ti":[0.64724916219711,27.5080909729004,0]},{"t":580}],"ix":2},"a":{"a":0,"k":[1013.697,1823.906,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.88,0.88,0.88],"y":[0,0,0]},"n":["0p833_1_0p88_0","0p833_1_0p88_0","0p833_1_0p88_0"],"t":360,"s":[100,100,100],"e":[100,100,100]},{"t":540}],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trim Path (START)","np":3,"mn":"ADBE Slider Control","ix":1,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":0,"k":0,"ix":1}}]},{"ty":5,"nm":"Trim Path (END)","np":3,"mn":"ADBE Slider Control","ix":2,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":1,"k":[{"i":{"x":[0.58],"y":[1]},"o":{"x":[0.42],"y":[0]},"n":["0p58_1_0p42_0"],"t":20,"s":[0],"e":[100]},{"t":50}],"ix":1}}]}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[174.47,168.918],[0,0]],"o":[[0,0],[-243.33,-3.935],[0,0],[0,0]],"v":[[324.727,76.358],[323.228,166.348],[-324.727,-101.675],[-262.091,-166.348]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[1013.697,2117.314],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-212.262,-3.431]],"o":[[0,0],[163.62,158.395],[0,0]],"v":[[293.408,-414.761],[-293.409,172.056],[293.408,414.761]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[1045.015,1778.91],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (START)')('Slider');"},"e":{"a":0,"k":100,"ix":2,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (END)')('Slider');"},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":3,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":20,"op":9057.03703703704,"st":20,"bm":0},{"ddd":0,"ind":21,"ty":0,"nm":"S5_Pepperoni","parent":20,"refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[0],"e":[0]},{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p12_1_0p68_0"],"t":230,"s":[0],"e":[0]},{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.88],"y":[0]},"n":["0p12_1_0p88_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.16,"y":1},"o":{"x":0.84,"y":0},"n":"0p16_1_0p84_0","t":180,"s":[983.5,1940,0],"e":[1108.5,1966,0],"to":[20.8333339691162,4.33333349227905,0],"ti":[-20.8333339691162,-4.33333349227905,0]},{"i":{"x":0.16,"y":0.16},"o":{"x":0.167,"y":0.167},"n":"0p16_0p16_0p167_0p167","t":230,"s":[1108.5,1966,0],"e":[1108.5,1966,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[1108.5,1966,0],"e":[983.5,1940,0],"to":[-20.8333339691162,-4.33333349227905,0],"ti":[20.8333339691162,4.33333349227905,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.84,"y":0.84},"n":"0p12_0p12_0p84_0p84","t":400,"s":[983.5,1940,0],"e":[983.5,1940,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":540,"s":[983.5,1940,0],"e":[1193.003,2774.728,0],"to":[34.917179107666,139.12126159668,0],"ti":[-34.917179107666,-139.12126159668,0]},{"t":580}],"ix":2},"a":{"a":0,"k":[73,73,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p12_1_0p167_0","0p12_1_0p167_0","0p12_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":540,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":560,"s":[130,130,100],"e":[100,100,100]},{"t":580}],"ix":6}},"ao":0,"w":146,"h":146,"ip":30,"op":9067,"st":30,"bm":0},{"ddd":0,"ind":22,"ty":0,"nm":"S5_Pepperoni 2","parent":20,"refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[0],"e":[0]},{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p12_1_0p68_0"],"t":230,"s":[0],"e":[0]},{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.88],"y":[0]},"n":["0p12_1_0p88_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.12,"y":0.12},"o":{"x":0.167,"y":0.167},"n":"0p12_0p12_0p167_0p167","t":180,"s":[1183,1940,0],"e":[1183,1940,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.88,"y":0.88},"n":"0p12_0p12_0p88_0p88","t":360,"s":[1183,1940,0],"e":[1183,1940,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":540,"s":[1183,1940,0],"e":[1370.991,2705.932,0],"to":[31.3317756652832,127.655372619629,0],"ti":[-31.3317756652832,-127.655372619629,0]},{"t":580}],"ix":2},"a":{"a":0,"k":[73,73,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p12_1_0p167_0","0p12_1_0p167_0","0p12_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":540,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":560,"s":[130,130,100],"e":[100,100,100]},{"t":580}],"ix":6}},"ao":0,"w":146,"h":146,"ip":36,"op":9073,"st":36,"bm":0},{"ddd":0,"ind":23,"ty":0,"nm":"S5_Mushroom","parent":20,"refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[-90],"e":[-90]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p833_1_0p68_0"],"t":230,"s":[-90],"e":[-90]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":360,"s":[-90],"e":[-90]},{"i":{"x":[0.12],"y":[0.86]},"o":{"x":[0.88],"y":[0.14]},"n":["0p12_0p86_0p88_0p14"],"t":540,"s":[-90],"e":[-111]},{"t":580}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.16,"y":1},"o":{"x":0.84,"y":0},"n":"0p16_1_0p84_0","t":180,"s":[1196.25,1725.5,0],"e":[958.25,1687.5,0],"to":[-39.6666679382324,-6.33333349227905,0],"ti":[39.6666679382324,6.33333349227905,0]},{"i":{"x":0.16,"y":0.16},"o":{"x":0.167,"y":0.167},"n":"0p16_0p16_0p167_0p167","t":230,"s":[958.25,1687.5,0],"e":[958.25,1687.5,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[958.25,1687.5,0],"e":[1196.25,1725.5,0],"to":[39.6666679382324,6.33333349227905,0],"ti":[-39.6666679382324,-6.33333349227905,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.84,"y":0.84},"n":"0p12_0p12_0p84_0p84","t":400,"s":[1196.25,1725.5,0],"e":[1196.25,1725.5,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":540,"s":[1196.25,1725.5,0],"e":[1308.935,2507.198,0],"to":[18.7808322906494,130.283004760742,0],"ti":[-18.7808322906494,-130.283004760742,0]},{"t":580}],"ix":2},"a":{"a":0,"k":[89.5,90,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":540,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":560,"s":[130,130,100],"e":[100,100,100]},{"t":580}],"ix":6}},"ao":0,"w":179,"h":180,"ip":42,"op":9079,"st":42,"bm":0},{"ddd":0,"ind":24,"ty":4,"nm":"Slice_06 Outlines","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":190,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":190,"s":[880.005,1688.552,0],"e":[880.005,1688.552,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[880.005,1688.552,0],"e":[759.617,1678.843,0],"to":[-20.0647239685059,-1.6181229352951,0],"ti":[20.0647239685059,1.6181229352951,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.167,"y":0.167},"n":"0p12_0p12_0p167_0p167","t":400,"s":[759.617,1678.843,0],"e":[759.617,1678.843,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":540,"s":[759.617,1678.843,0],"e":[613.985,1527.387,0],"to":[-24.2718448638916,-25.2427177429199,0],"ti":[24.2718448638916,25.2427177429199,0]},{"t":580}],"ix":2},"a":{"a":0,"k":[880.005,1688.552,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":360,"s":[100,100,100],"e":[100,100,100]},{"t":540}],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trim Path (START)","np":3,"mn":"ADBE Slider Control","ix":1,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":0,"k":0,"ix":1}}]},{"ty":5,"nm":"Trim Path (END)","np":3,"mn":"ADBE Slider Control","ix":2,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":1,"k":[{"i":{"x":[0.58],"y":[1]},"o":{"x":[0.42],"y":[0]},"n":["0p58_1_0p42_0"],"t":20,"s":[0],"e":[100]},{"t":50}],"ix":1}}]}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-190.241,325.097],[459.952,-325.097],[-459.952,-325.097]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[880.005,1688.552],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[3.925,242.812]],"o":[[-169.277,-174.844],[0,0]],"v":[[134.326,323.848],[-134.326,-323.848]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[554.378,1688.743],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-147.666,-152.518]],"o":[[0,0],[3.696,227.699],[0,0]],"v":[[414.943,-293.281],[-414.943,-293.281],[-171.618,293.281]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[925.015,1656.735],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (START)')('Slider');"},"e":{"a":0,"k":100,"ix":2,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (END)')('Slider');"},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":4,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":20,"op":9057.03703703704,"st":20,"bm":0},{"ddd":0,"ind":25,"ty":0,"nm":"S6_Pepperoni","parent":24,"refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p833_1_0p68_0"],"t":230,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":180,"s":[961.5,1542,0],"e":[961.5,1542,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":360,"s":[961.5,1542,0],"e":[961.5,1542,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":540,"s":[961.5,1542,0],"e":[825.578,2140.058,0],"to":[-22.6537208557129,99.6763763427734,0],"ti":[22.6537208557129,-99.6763763427734,0]},{"t":580}],"ix":2},"a":{"a":0,"k":[73,73,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":540,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":560,"s":[130,130,100],"e":[100,100,100]},{"t":580}],"ix":6}},"ao":0,"w":146,"h":146,"ip":30,"op":9067,"st":30,"bm":0},{"ddd":0,"ind":26,"ty":0,"nm":"S6_Mushroom","parent":24,"refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p833_1_0p68_0"],"t":230,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.16,"y":1},"o":{"x":0.84,"y":0},"n":"0p16_1_0p84_0","t":180,"s":[732.75,1544,0],"e":[923.75,1683,0],"to":[31.8333339691162,23.1666660308838,0],"ti":[-31.8333339691162,-23.1666660308838,0]},{"i":{"x":0.16,"y":0.16},"o":{"x":0.167,"y":0.167},"n":"0p16_0p16_0p167_0p167","t":230,"s":[923.75,1683,0],"e":[923.75,1683,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[923.75,1683,0],"e":[732.75,1544,0],"to":[-31.8333339691162,-23.1666660308838,0],"ti":[31.8333339691162,23.1666660308838,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.84,"y":0.84},"n":"0p12_0p12_0p84_0p84","t":400,"s":[732.75,1544,0],"e":[732.75,1544,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":540,"s":[732.75,1544,0],"e":[610.42,2140.117,0],"to":[-20.3883495330811,99.3527526855469,0],"ti":[20.3883495330811,-99.3527526855469,0]},{"t":580}],"ix":2},"a":{"a":0,"k":[89.5,90,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":540,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":560,"s":[130,130,100],"e":[100,100,100]},{"t":580}],"ix":6}},"ao":0,"w":179,"h":180,"ip":36,"op":9073,"st":36,"bm":0},{"ddd":0,"ind":27,"ty":4,"nm":"Slice_07 Outlines","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":190,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":190,"s":[881.229,1037.157,0],"e":[881.229,1037.157,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[881.229,1037.157,0],"e":[984.142,951.72,0],"to":[17.1521034240723,-14.2394819259644,0],"ti":[-17.1521034240723,14.2394819259644,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.167,"y":0.167},"n":"0p12_0p12_0p167_0p167","t":400,"s":[984.142,951.72,0],"e":[984.142,951.72,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":540,"s":[984.142,951.72,0],"e":[551.132,771.137,0],"to":[-72.1682815551758,-30.0970878601074,0],"ti":[72.1682815551758,30.0970878601074,0]},{"t":580}],"ix":2},"a":{"a":0,"k":[881.229,1037.157,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":360,"s":[100,100,100],"e":[100,100,100]},{"t":540}],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trim Path (START)","np":3,"mn":"ADBE Slider Control","ix":1,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":0,"k":0,"ix":1}}]},{"ty":5,"nm":"Trim Path (END)","np":3,"mn":"ADBE Slider Control","ix":2,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":1,"k":[{"i":{"x":[0.58],"y":[1]},"o":{"x":[0.42],"y":[0]},"n":["0p58_1_0p42_0"],"t":20,"s":[0],"e":[100]},{"t":50}],"ix":1}}]}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[3.936,-243.331],[0,0]],"o":[[-168.918,174.471],[0,0],[0,0]],"v":[[134.012,-324.727],[-134.012,323.229],[-44.021,324.726]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[555.484,1037.527],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-325.097,-325.097],[325.097,325.097]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 2","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[1015.889,1037.156],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":3,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[3.432,-212.262]],"o":[[0,0],[-158.395,163.62],[0,0]],"v":[[414.761,293.408],[-172.056,-293.409],[-414.762,293.408]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[926.225,1068.845],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (START)')('Slider');"},"e":{"a":0,"k":100,"ix":2,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (END)')('Slider');"},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":4,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":20,"op":9057.03703703704,"st":20,"bm":0},{"ddd":0,"ind":28,"ty":0,"nm":"S7_Pepperoni","parent":27,"refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p833_1_0p68_0"],"t":230,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.16,"y":1},"o":{"x":0.84,"y":0},"n":"0p16_1_0p84_0","t":180,"s":[1018.5,1222,0],"e":[849.5,1017,0],"to":[-28.1666660308838,-34.1666679382324,0],"ti":[28.1666660308838,34.1666679382324,0]},{"i":{"x":0.16,"y":0.16},"o":{"x":0.167,"y":0.167},"n":"0p16_0p16_0p167_0p167","t":230,"s":[849.5,1017,0],"e":[849.5,1017,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[849.5,1017,0],"e":[1018.5,1222,0],"to":[28.1666660308838,34.1666679382324,0],"ti":[-28.1666660308838,-34.1666679382324,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.84,"y":0.84},"n":"0p12_0p12_0p84_0p84","t":400,"s":[1018.5,1222,0],"e":[1018.5,1222,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.919},"o":{"x":0.84,"y":0},"n":"0p12_0p919_0p84_0","t":540,"s":[1018.5,1222,0],"e":[649.568,1499.67,0],"to":[-61.4886741638184,46.2783164978027,0],"ti":[61.4886741638184,-46.2783164978027,0]},{"t":580}],"ix":2},"a":{"a":0,"k":[73,73,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":540,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":560,"s":[130,130,100],"e":[100,100,100]},{"t":580}],"ix":6}},"ao":0,"w":146,"h":146,"ip":30,"op":9067,"st":30,"bm":0},{"ddd":0,"ind":29,"ty":0,"nm":"S7_Mushroom","parent":27,"refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[90],"e":[90]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p833_1_0p68_0"],"t":230,"s":[90],"e":[90]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":360,"s":[90],"e":[90]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.16,"y":1},"o":{"x":0.84,"y":0},"n":"0p16_1_0p84_0","t":180,"s":[805.75,1030,0],"e":[882.75,908,0],"to":[12.8333330154419,-20.3333339691162,0],"ti":[-12.8333330154419,20.3333339691162,0]},{"i":{"x":0.16,"y":0.16},"o":{"x":0.167,"y":0.167},"n":"0p16_0p16_0p167_0p167","t":230,"s":[882.75,908,0],"e":[882.75,908,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[882.75,908,0],"e":[805.75,1030,0],"to":[-12.8333330154419,20.3333339691162,0],"ti":[12.8333330154419,-20.3333339691162,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.84,"y":0.84},"n":"0p12_0p12_0p84_0p84","t":400,"s":[805.75,1030,0],"e":[805.75,1030,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.957},"o":{"x":0.84,"y":0},"n":"0p12_0p957_0p84_0","t":540,"s":[805.75,1030,0],"e":[442.643,1325.146,0],"to":[-60.5177993774414,49.1909370422363,0],"ti":[60.5177993774414,-49.1909370422363,0]},{"t":580}],"ix":2},"a":{"a":0,"k":[89.5,90,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":540,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":560,"s":[130,130,100],"e":[100,100,100]},{"t":580}],"ix":6}},"ao":0,"w":179,"h":180,"ip":36,"op":9073,"st":36,"bm":0},{"ddd":0,"ind":30,"ty":4,"nm":"Slice_08 Outlines","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":190,"s":[0],"e":[0]},{"i":{"x":[0.12],"y":[0.86]},"o":{"x":[0.88],"y":[0.14]},"n":["0p12_0p86_0p88_0p14"],"t":360,"s":[0],"e":[-11]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":400,"s":[-11],"e":[-11]},{"i":{"x":[0.12],"y":[0.86]},"o":{"x":[0.88],"y":[0.14]},"n":["0p12_0p86_0p88_0p14"],"t":540,"s":[-11],"e":[1]},{"t":580}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":190,"s":[1016.816,903.086,0],"e":[1016.816,903.086,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[1016.816,903.086,0],"e":[1049.826,588.523,0],"to":[5.50161790847778,-52.4271850585938,0],"ti":[-5.50161790847778,52.4271850585938,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.167,"y":0.167},"n":"0p12_0p12_0p167_0p167","t":400,"s":[1049.826,588.523,0],"e":[1049.826,588.523,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.274},"o":{"x":0.167,"y":0},"n":"0p12_0p274_0p167_0","t":540,"s":[1049.826,588.523,0],"e":[1040.117,648.717,0],"to":[-1.6181229352951,10.0323619842529,0],"ti":[1.6181229352951,-10.0323619842529,0]},{"t":580}],"ix":2},"a":{"a":0,"k":[1016.816,903.086,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":360,"s":[100,100,100],"e":[100,100,100]},{"t":540}],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trim Path (START)","np":3,"mn":"ADBE Slider Control","ix":1,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":0,"k":0,"ix":1}}]},{"ty":5,"nm":"Trim Path (END)","np":3,"mn":"ADBE Slider Control","ix":2,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":1,"k":[{"i":{"x":[0.58],"y":[1]},"o":{"x":[0.42],"y":[0]},"n":["0p58_1_0p42_0"],"t":20,"s":[0],"e":[100]},{"t":50}],"ix":1}}]}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-242.812,3.925]],"o":[[174.844,-169.277],[0,0]],"v":[[-323.847,134.326],[323.847,-134.326]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[1016.626,577.46],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-325.097,-190.242],[325.097,459.952],[325.097,-459.952]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[1016.816,903.086],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-242.812,3.925]],"o":[[174.844,-169.277],[0,0]],"v":[[-323.847,134.326],[323.847,-134.326]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[1016.626,577.46],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[152.519,-147.666]],"o":[[0,0],[-227.699,3.696],[0,0]],"v":[[293.281,414.943],[293.281,-414.943],[-293.28,-171.618]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[1048.633,948.097],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (START)')('Slider');"},"e":{"a":0,"k":100,"ix":2,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (END)')('Slider');"},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":5,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":20,"op":9057.03703703704,"st":20,"bm":0},{"ddd":0,"ind":31,"ty":0,"nm":"S8_Pepperoni","parent":30,"refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.12],"y":[0.86]},"o":{"x":[0.88],"y":[0.14]},"n":["0p12_0p86_0p88_0p14"],"t":540,"s":[100],"e":[0]},{"t":560}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p833_1_0p68_0"],"t":230,"s":[0],"e":[0]},{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p12_1_0p167_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.16,"y":1},"o":{"x":0.84,"y":0},"n":"0p16_1_0p84_0","t":180,"s":[1198.5,1017,0],"e":[1053.5,1032,0],"to":[-24.1666660308838,2.5,0],"ti":[24.1666660308838,-2.5,0]},{"i":{"x":0.16,"y":0.16},"o":{"x":0.167,"y":0.167},"n":"0p16_0p16_0p167_0p167","t":230,"s":[1053.5,1032,0],"e":[1053.5,1032,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[1053.5,1032,0],"e":[1198.5,1017,0],"to":[24.1666660308838,-2.5,0],"ti":[-24.1666660308838,2.5,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.84,"y":0.84},"n":"0p12_0p12_0p84_0p84","t":400,"s":[1198.5,1017,0],"e":[1198.5,1017,0],"to":[0,0,0],"ti":[0,0,0]},{"t":540}],"ix":2},"a":{"a":0,"k":[73,73,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[0.86,0.86,1]},"o":{"x":[0.88,0.88,0.88],"y":[0.14,0.14,0]},"n":["0p12_0p86_0p88_0p14","0p12_0p86_0p88_0p14","0p12_1_0p88_0"],"t":540,"s":[100,100,100],"e":[150,150,100]},{"t":560}],"ix":6}},"ao":0,"w":146,"h":146,"ip":30,"op":9067,"st":30,"bm":0},{"ddd":0,"ind":32,"ty":0,"nm":"S8_Mushroom","parent":30,"refId":"comp_1","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.12],"y":[0.86]},"o":{"x":[0.88],"y":[0.14]},"n":["0p12_0p86_0p88_0p14"],"t":540,"s":[100],"e":[0]},{"t":560}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.27],"y":[-76]},"o":{"x":[0.68],"y":[-51.333]},"n":["0p27_-76_0p68_-51p333"],"t":180,"s":[0],"e":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.68],"y":[0]},"n":["0p833_1_0p68_0"],"t":230,"s":[0],"e":[0]},{"i":{"x":[0.12],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p12_1_0p167_0"],"t":360,"s":[0],"e":[0]},{"t":540}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.16,"y":1},"o":{"x":0.84,"y":0},"n":"0p16_1_0p84_0","t":180,"s":[1110.75,758,0],"e":[929.75,836,0],"to":[-30.1666660308838,13,0],"ti":[30.1666660308838,-13,0]},{"i":{"x":0.16,"y":0.16},"o":{"x":0.167,"y":0.167},"n":"0p16_0p16_0p167_0p167","t":230,"s":[929.75,836,0],"e":[929.75,836,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.12,"y":0.86},"o":{"x":0.88,"y":0.14},"n":"0p12_0p86_0p88_0p14","t":360,"s":[929.75,836,0],"e":[1110.75,758,0],"to":[30.1666660308838,-13,0],"ti":[-30.1666660308838,13,0]},{"i":{"x":0.12,"y":0.12},"o":{"x":0.84,"y":0.84},"n":"0p12_0p12_0p84_0p84","t":400,"s":[1110.75,758,0],"e":[1110.75,758,0],"to":[0,0,0],"ti":[0,0,0]},{"t":540}],"ix":2},"a":{"a":0,"k":[89.5,90,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":180,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.275,1.275,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.275,-0.275,0]},"n":["0p27_1p275_0p68_-0p275","0p27_1p275_0p68_-0p275","0p27_1_0p68_0"],"t":200,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":220,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":360,"s":[100,100,100],"e":[130,130,100]},{"i":{"x":[0.27,0.27,0.27],"y":[1.55,1.55,1]},"o":{"x":[0.68,0.68,0.68],"y":[-0.55,-0.55,0]},"n":["0p27_1p55_0p68_-0p55","0p27_1p55_0p68_-0p55","0p27_1_0p68_0"],"t":380,"s":[130,130,100],"e":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0","0p833_1_0p167_0"],"t":400,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.12,0.12,0.12],"y":[0.86,0.86,1]},"o":{"x":[0.88,0.88,0.88],"y":[0.14,0.14,0]},"n":["0p12_0p86_0p88_0p14","0p12_0p86_0p88_0p14","0p12_1_0p88_0"],"t":540,"s":[100,100,100],"e":[150,150,100]},{"t":560}],"ix":6}},"ao":0,"w":179,"h":180,"ip":36,"op":9073,"st":36,"bm":0},{"ddd":0,"ind":33,"ty":4,"nm":"S1_Border","parent":1,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":20,"s":[0],"e":[25]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":50,"s":[25],"e":[25]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":180,"s":[25],"e":[0]},{"t":200}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1338,1364,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trim Path (START)","np":3,"mn":"ADBE Slider Control","ix":1,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":0,"k":100,"ix":1}}]},{"ty":5,"nm":"Trim Path (END)","np":3,"mn":"ADBE Slider Control","ix":2,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":0,"k":0,"ix":1}}]}],"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[1869,1869],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.270599365234,0.270599365234,0.278442382813,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":257,"ix":5},"lc":1,"lj":1,"ml":4,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (START)')('Slider');"},"e":{"a":0,"k":100,"ix":2,"x":"var $bm_rt;\n$bm_rt = effect('Trim Path (END)')('Slider');"},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":20,"op":9037,"st":0,"bm":0}],"markers":[{"tm":180,"cm":"Stage 02","dr":0},{"tm":360,"cm":"Stage 03","dr":0},{"tm":540,"cm":"Stage 04","dr":0}]}

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeStamp = function TimeStamp(_ref) {
	    var timeValue = _ref.timeValue,
	        direction = _ref.direction;
	
	    return _react2.default.createElement(
	        "div",
	        { className: "timeStampWrapper " + direction },
	        _react2.default.createElement(
	            "div",
	            { className: "timeStamp" },
	            timeValue,
	            _react2.default.createElement("div", { className: "corner topLeft" }),
	            _react2.default.createElement("div", { className: "corner topRight" }),
	            _react2.default.createElement("div", { className: "corner bottomLeft" }),
	            _react2.default.createElement("div", { className: "corner bottomRight" })
	        )
	    );
	};
	
	exports.default = TimeStamp;
	module.exports = exports["default"];

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LangToggles = exports.HeroStamp = exports.HeroHeaderCopy = exports.LoadingWrapper = exports.FakeZoomer = exports.HeroUILayout = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _gutters = __webpack_require__(12);
	
	var _gutters2 = _interopRequireDefault(_gutters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeroUILayout = exports.HeroUILayout = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__HeroUILayout',
	    componentId: 'nfwdop-0'
	})(['position:absolute;top:0;bottom:0;left:0;right:0;overflow:hidden;.bumpometer{overflow:hidden;position:absolute;bottom:20px;left:50px;transition:transform 400ms ease-in-out;transition-delay:150ms;transform:', ';@media (max-width:', '){top:0px;left:0px;bottom:auto;transform-origin:center;transform:', ';}.bumpometerCopy{font-family:\'OneDotExt\',sans-serif;color:white;font-size:13px;width:100px;text-transform:uppercase;line-height:1.38;margin-bottom:-30px;@media (max-width:', '){display:none;}}svg{width:150px;height:100px;}}.pizzaMessWrapper{position:absolute;right:30px;bottom:20px;text-align:right;transition:transform 400ms ease-in-out;transition-delay:300ms;transform:', ';.pizzamessCopy{font-family:\'OneDotExt\',sans-serif;color:white;font-size:13px;width:100px;text-transform:uppercase;line-height:1.38;margin-bottom:-10px;@media (max-width:', '){display:none;}}.pizzamess{display:inline-block;svg{transform-origin:center center;transform:scale(1.1);}}@media (max-width:', '){display:none;}}.controlsWrapper{width:300px;position:absolute;transition:all 400ms ease-in-out;bottom:', ';left:calc(50% - 150px);right:calc(50% - 150px);transform:', ';@media (max-width:', '){width:200px;left:calc(50% - 100px);right:calc(50% - 100px);}@media (max-width:', '){width:230px;left:calc(50% - 115px);right:calc(50% - 115px);}.stageKnob{cursor:pointer;transition:all 300ms ease-out;&:hover{stroke-width:8px;fill:#E4334B;}}path.redStroke{stroke-dasharray:100;stroke-dashoffset:100;transition-property:stroke-dashoffset;transition-timing-function:linear;&.active{stroke-dashoffset:0;}}&.mobile{bottom:', ';path.redStroke{stroke-dasharray:90;stroke-dashoffset:90;transition-property:stroke-dashoffset;transition-timing-function:linear;&.active{stroke-dashoffset:0;}}.label{opacity:0;transition:opacity 300ms ease-in-out;transform:translate(-50%,0);&.active{opacity:1;}&.one{transition-delay:0ms;bottom:85px;left:', ';}&.two{transition-delay:0ms;bottom:85px;left:84px;}&.three{transition-delay:0ms;bottom:85px;left:151px;}&.four{transition-delay:0ms;bottom:85px;left:218px;}}}.label{position:absolute;font-family:\'OneDotCd\',sans-serif;font-size:18px;text-transform:uppercase;color:white;transition:all 300ms ease-in-out;transform:', ';opacity:', ';letter-spacing:1px;&.one{transition-delay:420ms;left:', ';bottom:72px;@media (max-width:', '){bottom:50px;}}&.two{transition-delay:520ms;left:', ';bottom:145px;@media (max-width:', '){left:-16px;bottom:100px;}}&.three{transition-delay:620ms;left:223px;bottom:145px;@media (max-width:', '){left:145px;bottom:100px;}}&.four{transition-delay:720ms;left:295px;bottom:72px;@media (max-width:', '){left:195px;bottom:50px;}}}}.timeStampWrapper{position:absolute;top:50px;transition:transform 400ms ease-in-out;transition-delay:500ms;transform:', ';&.left{left:50px;}&.right{right:50px;}}.timeStamp{padding:8px;text-transform:uppercase;color:white;font-size:13px;font-family:\'OneDotExt\',sans-serif;font-weight:bold;position:relative;.corner{position:absolute;width:6px;height:6px;border-color:white;border-width:2px;border-style:solid;&.bottomLeft{left:0;bottom:0;border-right:none;border-top:none;}&.bottomRight{right:0;bottom:0;border-left:none;border-top:none;}&.topLeft{left:0;top:0;border-bottom:none;border-right:none;}&.topRight{right:0;top:0;border-bottom:none;border-left:none;}}}.controlLabel{font-family:\'OneDotExt\',sans-serif;font-size:16px;line-height:1.13;letter-spacing:1.8px;text-align:center;position:absolute;bottom:40px;width:150px;left:calc(50% - 75px);right:calc(50% - 75px);text-transform:uppercase;color:white;transition:all 400ms ease-in-out;transform:', ';bottom:', ';@media (max-width:', '){bottom:', ';font-size:14px;}@media (max-width:', '){display:none;}}'], function (props) {
	    return props.interaction ? 'translate3d(0,0,0)' : 'translate3d(-200%, 0, 0)';
	}, _breakpoints2.default['bp-mobile'], function (props) {
	    return props.interaction ? 'translate3d(0,0,0) scale(0.6)' : 'translate3d(-200%, 0, 0) scale(0.6)';
	}, _breakpoints2.default['bp-mobile'], function (props) {
	    return props.interaction ? 'translate3d(0,0,0)' : 'translate3d(200%, 0, 0)';
	}, _breakpoints2.default['bp-mobile'], _breakpoints2.default['bp-mobile'], function (props) {
	    return props.interaction ? '-10px' : 'calc(100% * (1/12) - 10px)';
	}, function (props) {
	    return props.controls ? 'scale(1)' : 'scale(0)';
	}, _breakpoints2.default['bp-tablet'], _breakpoints2.default['bp-mobile'], function (props) {
	    return props.interaction ? '-35px' : 'calc(100% * (1/12) - 35px)';
	}, function (props) {
	    return props.lang.match(/^en/) ? '17px' : '22px';
	}, function (props) {
	    return props.controls ? 'translate3d(0, 0, 0)' : 'translate3d(0, -15px, 0)';
	}, function (props) {
	    return props.controls ? '1' : '0';
	}, function (props) {
	    return props.lang.match(/^en/) ? '-30px' : '-48px';
	}, _breakpoints2.default['bp-tablet'], function (props) {
	    return props.lang.match(/^en/) ? '4x' : '0';
	}, _breakpoints2.default['bp-tablet'], _breakpoints2.default['bp-tablet'], _breakpoints2.default['bp-tablet'], function (props) {
	    return props.interaction ? 'translate3d(0,0,0) scale(1)' : 'translate3d(0, -300%, 0) scale(0.1)';
	}, function (props) {
	    return props.controls ? 'scale(1)' : 'scale(0)';
	}, function (props) {
	    return props.interaction ? '40px' : 'calc(100% * (1/12) + 40px)';
	}, _breakpoints2.default['bp-tablet'], function (props) {
	    return props.interaction ? '20px' : 'calc(100% * (1/12) + 20px)';
	}, _breakpoints2.default['bp-mobile']);
	
	var FakeZoomer = exports.FakeZoomer = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__FakeZoomer',
	    componentId: 'nfwdop-1'
	})(['position:absolute;top:0;left:0;right:0;bottom:0;z-index:2;overflow:hidden;pointer-events:none;.top,.bottom,.left,.right{transition:transform 400ms ease-in-out;position:absolute;background:white;}.top,.bottom{left:0;right:0;height:calc(100% * (1/12));}.top{top:calc(-100% * (1/11));transform:translate3d(0,100%,0);}.bottom{bottom:calc(-100% * (1/12));transform:translate3d(0,-100%,0);}.left,.right{width:calc(100% * (1/12));top:0;bottom:0;}.left{left:calc(-100% * (1/12));transform:translate3d(100%,0,0);}.right{right:calc(-100% * (1/12));transform:translate3d(-100%,0,0);}&.zoomed{.top,.bottom,.left,.right{transform:translate3d(0,0,0);}}']);
	
	var LoadingWrapper = exports.LoadingWrapper = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__LoadingWrapper',
	    componentId: 'nfwdop-2'
	})(['position:absolute;top:0;left:0;right:0;bottom:0;z-index:2;overflow:hidden;pointer-events:none;display:flex;flex-direction:column;align-items:center;justify-content:center;background:rgba(255,255,255,0.5);opacity:0;animation:loadEaseIn 1s forwards;animation-delay:500ms;@keyframes loadEaseIn{0%{opacity:0}100%{opacity:1}}.pizzaHolder{width:100px;height:100px;transform-origin:center center;animation:pizzaAnimation 2s infinite;animation-timing-function:linear;@keyframes pizzaAnimation{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}}.loading{font-family:\'OneDotCd\',sans-serif;font-weight:bold;text-transform:uppercase;margin-top:10px;margin-left:11px;}']);
	
	var HeroHeaderCopy = exports.HeroHeaderCopy = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__HeroHeaderCopy',
	    componentId: 'nfwdop-3'
	})(['pointer-events:none;position:absolute;width:40%;z-index:5;top:2px;transition:all 400ms ease-in-out;opacity:', ';transform:', ';@media (max-width:', '){width:66%;}'], function (props) {
	    return props.in ? '1' : '0';
	}, function (props) {
	    return props.in ? 'translate3d(0,0,0)' : 'translate3d(0,40px,0)';
	}, _breakpoints2.default['bp-tablet']);
	
	var HeroStamp = exports.HeroStamp = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__HeroStamp',
	    componentId: 'nfwdop-4'
	})(['pointer-events:none;position:absolute;top:55%;@media (max-width:', '){top:', ';}left:calc(85% - 250px);font-family:\'OneDotExt\',sans-serif;width:250px;color:white;font-size:19px;line-height:1;text-align:center;padding:10px;border:solid 6px white;box-sizing:border-box;text-transform:uppercase;transform-origin:center;transform:rotate(25deg);transition:all 400ms ease-in-out;opacity:', ';transform:', ';@media (max-width:', '){font-size:10px;width:180px;transform:', ';top:50%;left:20%;}'], _breakpoints2.default['bp-desktop'], function (props) {
	    return props.lang === 'en' ? '35%' : '30%';
	}, function (props) {
	    return props.in ? '1' : '0';
	}, function (props) {
	    return props.in ? 'rotate(25deg)' : 'rotate(-10deg)';
	}, _breakpoints2.default['bp-mobile'], function (props) {
	    return props.in ? 'rotate(-10deg)' : 'rotate(-25deg)';
	});
	
	var LangToggles = exports.LangToggles = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__LangToggles',
	    componentId: 'nfwdop-5'
	})(['margin-bottom:20px;margin-top:70px;position:relative;text-align:right;z-index:5;@media (min-width:', '){margin-right:1rem;margin-top:90px;}p{display:inline-block;font:400 13.3333px Arial;font-size:12px;margin-right:10px;}button{background-color:transparent;border:none;color:', ';margin-right:16px;outline:none;padding:0;&:hover,&:focus{text-decoration:underline;}}'], _breakpoints2.default['bp-mobile'], _colors2.default['lipstick']);

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(19);
	
	var _mobxReact = __webpack_require__(22);
	
	var _Image = __webpack_require__(24);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _arrowCtaRed = __webpack_require__(100);
	
	var _arrowCtaRed2 = _interopRequireDefault(_arrowCtaRed);
	
	var _arrowCtaBlue = __webpack_require__(99);
	
	var _arrowCtaBlue2 = _interopRequireDefault(_arrowCtaBlue);
	
	var _styledComponents = __webpack_require__(188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageGallery = (_dec = (0, _mobxReact.inject)("store"), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
	  _inherits(ImageGallery, _Component);
	
	  function ImageGallery(props) {
	    _classCallCheck(this, ImageGallery);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      scrollAmount: 0,
	      scrollWidth: 0
	    };
	
	    _this.gaGalleryPrevClicked = _this.gaGalleryPrevClicked.bind(_this);
	    _this.gaGalleryNextClicked = _this.gaGalleryNextClicked.bind(_this);
	    _this.horizontalScroll = _this.horizontalScroll.bind(_this);
	    return _this;
	  }
	
	  ImageGallery.prototype.gaGalleryPrevClicked = function gaGalleryPrevClicked() {
	    window.dataLayer.push({
	      'event': 'image-gallery:click',
	      'nav': 'carousel',
	      'navItem': 'previous'
	    });
	  };
	
	  ImageGallery.prototype.gaGalleryNextClicked = function gaGalleryNextClicked() {
	    window.dataLayer.push({
	      'event': 'image-gallery:click',
	      'nav': 'carousel',
	      'navItem': 'next'
	    });
	  };
	
	  ImageGallery.prototype.horizontalScroll = function horizontalScroll(direction) {
	    var container = document.querySelector('#image-gallery-container');
	    var containerWidth = container.getBoundingClientRect().width;
	    var listItem = document.querySelector('.image-gallery__item');
	    var imageWidth = listItem.getBoundingClientRect().width;
	    var imagesCount = this.props.data.images.length;
	    var scrollWidth = imagesCount * imageWidth - imageWidth;
	    console.log("scrollWidth", scrollWidth);
	    console.log("-scrollWidth", -scrollWidth);
	    var scrollAmount = Math.round(this.state.scrollAmount);
	    console.log("scrollAmount", scrollAmount);
	
	    if (direction == 'next') {
	      -scrollWidth < this.state.scrollAmount && this.setState({
	        scrollAmount: this.state.scrollAmount - (containerWidth - (containerWidth - imageWidth)),
	        scrollWidth: scrollWidth
	      });
	      this.gaGalleryNextClicked();
	    } else {
	      this.setState({ scrollAmount: this.state.scrollAmount + (containerWidth - (containerWidth - imageWidth)) });
	      this.gaGalleryPrevClicked();
	    }
	  };
	
	  ImageGallery.prototype.render = function render() {
	    var horizontalScroll = this.horizontalScroll;
	    var _state = this.state,
	        scrollAmount = _state.scrollAmount,
	        scrollWidth = _state.scrollWidth;
	    var _props = this.props,
	        data = _props.data,
	        imageDictionary = _props.imageDictionary,
	        store = _props.store,
	        t = _props.t;
	
	
	    return _react2.default.createElement(
	      _styledComponents.ImageGalleryWrapper,
	      { id: 'image-gallery-container' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        t('imageGallery.title')
	      ),
	      _react2.default.createElement(
	        _styledComponents.ImageGalleryList,
	        { id: 'image-gallery-list' },
	        data.images.map(function (image, index) {
	          return _react2.default.createElement(
	            'li',
	            { className: 'image-gallery__item', key: index, style: { transform: 'translateX(' + scrollAmount.toFixed(3) + 'px)' } },
	            _react2.default.createElement(
	              _styledComponents.ImageGalleryItemWrapper,
	              null,
	              _react2.default.createElement(_Image2.default, { aspectHeight: 10, aspectWidth: 7, sizes: imageDictionary[image.asset].sizes }),
	              _react2.default.createElement(
	                _styledComponents.ImageGalleryCity,
	                null,
	                image.city
	              ),
	              _react2.default.createElement(
	                _styledComponents.ImageGalleryState,
	                null,
	                image.state
	              )
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        _styledComponents.ButtonsWrapper,
	        null,
	        _react2.default.createElement(
	          _styledComponents.PrevButton,
	          { disabled: scrollAmount >= 0 ? true : false, onClick: function onClick() {
	              return horizontalScroll('prev');
	            } },
	          _react2.default.createElement(_arrowCtaBlue2.default, null),
	          _react2.default.createElement(
	            'span',
	            null,
	            t('imageGallery.prev')
	          )
	        ),
	        _react2.default.createElement(
	          _styledComponents.NextButton,
	          { disabled: scrollWidth > 1 && scrollAmount === -scrollWidth ? true : false, onClick: function onClick() {
	              return horizontalScroll('next');
	            } },
	          _react2.default.createElement(_arrowCtaRed2.default, null),
	          _react2.default.createElement(
	            'span',
	            null,
	            t('imageGallery.next')
	          )
	        )
	      )
	    );
	  };
	
	  return ImageGallery;
	}(_react.Component)) || _class) || _class);
	exports.default = (0, _reactI18next.translate)()(ImageGallery);
	module.exports = exports['default'];

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NextButton = exports.PrevButton = exports.ButtonsWrapper = exports.ImageGalleryState = exports.ImageGalleryCity = exports.ImageGalleryItemWrapper = exports.ImageGalleryList = exports.ImageGalleryWrapper = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageGalleryWrapper = exports.ImageGalleryWrapper = _styledComponents2.default.section.withConfig({
	  displayName: 'styled-components__ImageGalleryWrapper',
	  componentId: 'sc-1re39ku-0'
	})(['margin-bottom:20px;margin-top:20px;position:relative;h2{font-family:"OneDotExt",sans-serif;font-weight:bold;max-width:200px;text-transform:uppercase;@media (min-width:', '){margin-bottom:40px;}}'], _breakpoints2.default['bp-desktop']);
	
	var ImageGalleryList = exports.ImageGalleryList = _styledComponents2.default.ul.withConfig({
	  displayName: 'styled-components__ImageGalleryList',
	  componentId: 'sc-1re39ku-1'
	})(['display:flex;margin-bottom:20px;overflow-x:scroll;overflow-y:visible;padding-top:30px;scroll-snap-type:x mandatory;-ms-overflow-style:-ms-autohiding-scrollbar;li{flex-shrink:0;max-width:280px;padding-right:30px;transition:transform .2s ease;width:85%;&:nth-child(odd){margin-top:40px;@media (min-width:', '){margin-top:80px;}}}img{border-radius:10px;scroll-snap-align:center;@include mq($M){padding:0 20px;}}'], _breakpoints2.default['bp-desktop']);
	
	var ImageGalleryItemWrapper = exports.ImageGalleryItemWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'styled-components__ImageGalleryItemWrapper',
	  componentId: 'sc-1re39ku-2'
	})(['position:relative;']);
	
	var ImageGalleryCity = exports.ImageGalleryCity = _styledComponents2.default.span.withConfig({
	  displayName: 'styled-components__ImageGalleryCity',
	  componentId: 'sc-1re39ku-3'
	})(['bottom:30px;color:', ';font-family:\'OneDotCd\',sans-serif;font-size:2rem;font-weight:bold;left:20px;position:absolute;text-transform:uppercase;'], _colors2.default['white']);
	
	var ImageGalleryState = exports.ImageGalleryState = _styledComponents2.default.span.withConfig({
	  displayName: 'styled-components__ImageGalleryState',
	  componentId: 'sc-1re39ku-4'
	})(['color:', ';font-family:\'OneDotCd\',sans-serif;font-size:4rem;font-weight:bold;left:20px;position:absolute;top:-30px;'], _colors2.default['lipstick']);
	
	var ButtonsWrapper = exports.ButtonsWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'styled-components__ButtonsWrapper',
	  componentId: 'sc-1re39ku-5'
	})(['align-items:center;display:flex;justify-content:center;@media (min-width:', '){position:absolute;right:0;top:0;}'], _breakpoints2.default['bp-desktop']);
	
	var PrevButton = exports.PrevButton = _styledComponents2.default.button.withConfig({
	  displayName: 'styled-components__PrevButton',
	  componentId: 'sc-1re39ku-6'
	})(['background-color:transparent;border:none;position:relative;transition:transform .1s ease-out;width:5rem;-webkit-appearance:none;&:active{transform:scale(.9)}svg{height:auto;width:100%;}&[disabled] svg path{fill:', ';fill-opacity:.5;}span{color:#fff;position:absolute;right:15%;text-transform:uppercase;top:48%;transform:translateY(-50%);}'], _colors2.default['light-grey']);
	
	var NextButton = exports.NextButton = _styledComponents2.default.button.withConfig({
	  displayName: 'styled-components__NextButton',
	  componentId: 'sc-1re39ku-7'
	})(['background-color:transparent;border:none;position:relative;transition:transform .1s ease-out;width:5rem;-webkit-appearance:none;&:active{transform:scale(.9)}svg{height:auto;transform:rotate(180deg);width:100%;}&[disabled] svg path{fill:', ';fill-opacity:.5;}span{color:#fff;left:15%;position:absolute;text-transform:uppercase;top:48%;transform:translateY(-50%);}'], _colors2.default['light-grey']);

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(3);
	
	var _Image = __webpack_require__(24);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _styledComponents = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InProgress = function InProgress(_ref) {
	    var data = _ref.data,
	        imageDictionary = _ref.imageDictionary;
	
	    return _react2.default.createElement(
	        _styledComponents.InProgressWrapper,
	        null,
	        _react2.default.createElement(
	            _grid.Column,
	            { cw: 12, style: { textAlign: 'center' } },
	            _react2.default.createElement(
	                _styledComponents.Title,
	                null,
	                data.title,
	                _react2.default.createElement('span', { className: 'carrot' })
	            )
	        ),
	        data.cities.map(function (city, index) {
	            return _react2.default.createElement(
	                _grid.Column,
	                { key: index, className: 'inProgressItem', cw: 4, offset: index === 0 ? 2 : 0, style: { position: 'relative', display: 'flex', flexDirection: 'column' } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'city' },
	                    city.city
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'state' },
	                    city.state
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { width: '100%', background: 'white', position: 'relative' } },
	                    _react2.default.createElement(_Image2.default, { aspectHeight: 5, aspectWidth: 4, sizes: imageDictionary[city.image].sizes, style: { opacity: '0.5' } }),
	                    _react2.default.createElement('div', { className: 'whiteMask' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'colorBlock ' + (index === 0 ? 'left' : 'right') },
	                        _react2.default.createElement('div', { className: 'stripes' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'initialsHolder' },
	                    _react2.default.createElement(
	                        'span',
	                        { style: { transform: 'translate3d(0, -30px, 0) rotate(-20deg)' } },
	                        city.initials[0]
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { style: { transform: 'translate3d(0, 120px, 0) rotate(15deg)' } },
	                        city.initials[1]
	                    )
	                )
	            );
	        })
	    );
	};
	
	exports.default = InProgress;
	module.exports = exports['default'];

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Title = exports.InProgressWrapper = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _grid = __webpack_require__(3);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _gutters = __webpack_require__(12);
	
	var _gutters2 = _interopRequireDefault(_gutters);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InProgressWrapper = exports.InProgressWrapper = (0, _styledComponents2.default)(_grid.Row).withConfig({
	    displayName: 'styled-components__InProgressWrapper',
	    componentId: 'sc-1ax94cu-0'
	})(['.inProgressItem{&:last-child{margin-top:200px;@media (max-width:', '){margin-top:inherit;}}.city{font-family:\'OneDotExt\',sans-serif;font-size:38px;font-weight:bold;color:', ';opacity:0.8;text-transform:uppercase;margin-bottom:5px;@media (max-width:', '){font-size:30px;}}.state{font-family:\'OneDot\',sans-serif;font-size:25px;letter-spacing:2.9px;font-weight:bold;color:', ';opacity:0.8;text-transform:uppercase;margin-bottom:30px;@media (max-width:', '){font-size:16px;}}&:hover{.stripes{animation-play-state:paused;}}}.initialsHolder{font-family:\'OneDotCd\',sans-serif;font-weight:bold;color:', ';position:absolute;right:10%;top:-140px;width:100%;font-size:250px;display:flex;align-items:center;justify-content:flex-end;letter-spacing:10px;z-index:-1;text-transform:uppercase;@media (max-width:', '){transform:scale(0.8);}@media (max-width:', '){display:none;}}.whiteMask{position:absolute;top:0;bottom:0;left:0;right:0;background:white;opacity:0.5;}.colorBlock{overflow:hidden;position:absolute;z-index:-1;width:80%;&.left{top:55%;left:calc(', ' * -0.8);bottom:calc(', ' * -0.7);@media (max-width:', '){left:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}@media (max-width:', '){left:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}@media (max-width:', '){left:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}}&.right{top:55%;right:calc(', ' * -0.8);bottom:calc(', ' * -0.7);@media (max-width:', '){right:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}@media (max-width:', '){right:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}@media (max-width:', '){right:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}}.stripes{background:repeating-linear-gradient(-45deg,', ',', ' 25px,rgba(255,255,255,0.5) 25px,rgba(255,255,255,0.5) 50px);position:absolute;top:-75px;left:-75px;right:-75px;bottom:-75px;animation-name:barbersPole;animation-timing-function:linear;animation-iteration-count:infinite;animation-duration:1200ms;animation-play-state:running;@keyframes barbersPole{0%{transform:translate3d(0,0,0)}100%{transform:translate3d(0,72px,0)}}}}'], _breakpoints2.default['bp-mobile'], _colors2.default['black'], _breakpoints2.default['bp-mobile'], _colors2.default['black'], _breakpoints2.default['bp-mobile'], _colors2.default['white-two'], _breakpoints2.default['bp-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-desktop-l'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-desktop-l'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-mobile'], _colors2.default['faint-grey'], _colors2.default['faint-grey']);
	
	var Title = exports.Title = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__Title',
	    componentId: 'sc-1ax94cu-1'
	})(['display:inline-block;font-family:\'OneDot\';font-size:25px;font-weight:bold;line-height:1.4;letter-spacing:3px;text-align:center;text-transform:uppercase;color:', ';border-bottom:solid 15px ', ';margin-bottom:100px;.carrot{margin-left:5px;display:inline-block;height:15px;width:15px;box-sizing:border-box;transform-origin:center center;border-bottom:5px solid ', ';border-left:5px solid ', ';border-radius:2px;transform:translate(0,-5px) rotate(-45deg);}'], _colors2.default['peacock-blue'], _colors2.default['white-two'], _colors2.default['peacock-blue'], _colors2.default['peacock-blue']);

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(3);
	
	var _styledComponents = __webpack_require__(192);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ItemizedList = function ItemizedList(_ref) {
	    var data = _ref.data;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _grid.Row,
	            { margins: true, style: { alignItems: 'center' } },
	            _react2.default.createElement(
	                _grid.Column,
	                { cw: 12, style: { textAlign: 'center' } },
	                _react2.default.createElement(
	                    _styledComponents.Title,
	                    null,
	                    data.title
	                )
	            ),
	            data.list.map(function (item, index) {
	                return _react2.default.createElement(
	                    _grid.Column,
	                    { key: index, cw: 10, offset: 1, style: { textAlign: 'center' } },
	                    _react2.default.createElement(
	                        _styledComponents.ItemWrapper,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'number' },
	                            item.number
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'label' },
	                            item.label
	                        )
	                    )
	                );
	            })
	        )
	    );
	};
	
	exports.default = ItemizedList;
	module.exports = exports['default'];

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Title = exports.ItemWrapper = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ItemWrapper = exports.ItemWrapper = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__ItemWrapper',
	    componentId: 'sc-13k45j6-0'
	})(['font-size:45px;font-family:\'OneDotCd\',sans-serif;font-weight:bold;justify-content:flex-start;margin-bottom:20px;text-transform:uppercase;@media (max-width:', '){font-size:35px;}.number{color:', ';display:inline-block;margin-right:20px;@media (max-width:', '){display:block;margin-right:0;}}.label{color:', ';display:inline-block;}'], _breakpoints2.default['bp-mobile'], _colors2.default['lipstick'], _breakpoints2.default['bp-mobile'], _colors2.default['peacock-blue']);
	
	var Title = exports.Title = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__Title',
	    componentId: 'sc-13k45j6-1'
	})(['display:inline-block;font-family:\'OneDot\';font-size:25px;font-weight:bold;line-height:1.4;letter-spacing:3px;text-align:center;text-transform:uppercase;color:', ';border-bottom:solid 15px ', ';margin-bottom:20px;'], _colors2.default['peacock-blue'], _colors2.default['white-two']);

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(3);
	
	var _typography = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LargeText = function LargeText(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _grid.Row,
	      { margins: true, style: { alignItems: 'center' } },
	      _react2.default.createElement(
	        _grid.Column,
	        { cw: 4, offset: 1 },
	        _react2.default.createElement(
	          _typography.H1,
	          null,
	          data.text
	        )
	      )
	    )
	  );
	};
	
	exports.default = LargeText;
	module.exports = exports['default'];

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactI18next = __webpack_require__(19);
	
	var _moment = __webpack_require__(376);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// spread props for paths that should be data-paved = true.
	// override existing data-not-paved and a few other props.
	// not exhaustive; sorta minimal needed for changes made jan 2020.
	var getPavedPathProps = function getPavedPathProps(t, _ref) {
	  var cityName = _ref.cityName,
	      stat1Number = _ref.stat1Number,
	      stat1Text = _ref.stat1Text,
	      stat2Number = _ref.stat2Number,
	      stat2Text = _ref.stat2Text,
	      month = _ref.month,
	      date = _ref.date,
	      dateText = _ref.dateText,
	      tooltipCopy = _ref.tooltipCopy;
	
	  return {
	    fill: '#e6e6e6',
	    className: 'paved',
	    'data-not-paved': false,
	    'data-paved': true,
	    'data-coming-soon-text': '',
	    'data-coming-soon': false,
	    'data-city': cityName,
	    'data-stat1number': stat1Number || '', // eg '$5,000'
	    'data-stat1text': stat1Text || '', // eg `${t('mapHero.stats.grantUsed') 10/18/2018`
	    'data-stat2number': stat2Number || '',
	    'data-stat2text': stat2Text || '',
	    'data-month': month || '',
	    'data-date': date || '',
	    'data-date-text': dateText || '',
	    'data-tooltip-copy': tooltipCopy || t('mapHero.tooltip.paved')
	  };
	};
	
	var tShortDate = function tShortDate(i18n, dateStr) {
	  var result = void 0;
	  switch (i18n.language) {
	    case 'es':
	      result = (0, _moment2.default)(dateStr).format('D/M/YYYY');
	      console.log({ dateStr: dateStr, result: result });
	      break;
	    case 'en':
	    default:
	      result = (0, _moment2.default)(dateStr).format('M/D/YYYY');
	  }
	  return result;
	};
	
	// assuming dateStr is eg 01/31, just switch em for espanol.
	// super high-tech, should patent.
	var tMonthDayDate = function tMonthDayDate(i18n, dateStr) {
	  var bits = dateStr.split('/');
	  var result = void 0;
	  switch (i18n.language) {
	    case 'es':
	      result = bits[1] + '/' + bits[0];
	      break;
	    case 'en':
	    default:
	      result = dateStr;
	  }
	  return result;
	};
	
	// there are several paths for some states ... avoid duped props
	var getPavedPathHawaiiProps = function getPavedPathHawaiiProps(t) {
	  return getPavedPathProps(t, {
	    cityName: 'Hilo',
	    stat1Number: '$5,000',
	    stat1Text: t('mapHero.stats.grantUsedVague') + ' ' + t('months.december') + ' 2019'
	  });
	};
	
	var getPavedPathAlaskaProps = function getPavedPathAlaskaProps(t) {
	  return getPavedPathProps(t, {
	    cityName: 'Anchorage',
	    stat1Number: '$5,000',
	    stat1Text: t('mapHero.stats.grantUsedVague') + ' ' + t('months.april') + ' 2019'
	  });
	};
	
	var Map = function Map(_ref2) {
	  var t = _ref2.t,
	      i18n = _ref2.i18n,
	      className = _ref2.className,
	      tooltipCopy = _ref2.tooltipCopy,
	      city = _ref2.city,
	      state = _ref2.state,
	      displayPaved = _ref2.displayPaved,
	      displayNotPaved = _ref2.displayNotPaved,
	      displayComingSoon = _ref2.displayComingSoon,
	      getCityData = _ref2.getCityData,
	      clearCityData = _ref2.clearCityData,
	      gaStateClicked = _ref2.gaStateClicked,
	      scrollToElement = _ref2.scrollToElement;
	  return _react2.default.createElement(
	    'div',
	    { className: 'map-wrapper' },
	    _react2.default.createElement(
	      'div',
	      { className: 'tooltip tooltip--paved', style: { display: displayPaved ? 'block' : 'none' } },
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          tooltipCopy
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          city,
	          ', ',
	          state
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'tooltip tooltip--coming-soon', style: { display: displayComingSoon ? 'block' : 'none' } },
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          city,
	          ', ',
	          state
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          tooltipCopy
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'tooltip tooltip--not-paved', style: { display: displayNotPaved ? 'block' : 'none' } },
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          city
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          tooltipCopy
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'svg',
	      { className: className, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 1532.6 1135.23' },
	      _react2.default.createElement('path', { id: 'Mexico', fill: '#f7f7f7', d: 'M953.57,970.43v-.2c.6-3.2,1.4-7.2.3-10.7l-.5-1.4-1.4-.5a6.26,6.26,0,0,1-2-1.5c-1.3-1.2-2.9-2.7-5.2-3a4.24,4.24,0,0,0-1-.1,3.38,3.38,0,0,0-2.7,1.3,3.61,3.61,0,0,0-.6,3.2,3.7,3.7,0,0,1-1.1.1,6.6,6.6,0,0,0-4,1.3c-.2-.4-.3-.7-.5-1.1l-.4-.7-.7-.4c-5.4-3.5-12-4.8-17-5.6-.9-.11-1.8-.18-2.7-.2-3.9,0-7.3,1.3-10.7,2.5-3,1.1-5.8,2.1-8.7,2.1a7.78,7.78,0,0,1-1.6-.1h-.6c-9.8.7-20.9,2.1-28.4,9.7-1.1,1-3,3.3-1.1,7.1a20.32,20.32,0,0,1-.4,4.8c-.1.8-.2,1.5-.3,2.2h0l-1.4-.5-.9,3a30,30,0,0,0-.9,5.8c-.2,2.7-.4,5.1-1.7,6.5-3.2,2.2-4,5.8-4.7,8.7-.5,2-.9,3.9-2,5-3.2,3.5-7.6,5.4-12.6,7.4l-.3.1-.2.1a4.63,4.63,0,0,0-2.1,2.8,5.45,5.45,0,0,0,1.2,4.2c.1.2.3.5.4.7v.3c.1,1.6-2.5,2.9-4.2,3.2l-3.2.6.3,1a4.75,4.75,0,0,0-2.3-.6,4.38,4.38,0,0,0-2.8,1l-.2-.4a5.74,5.74,0,0,0-1.7-1.7l.2-2.2c.3-2.8-2.2-3.3-5-3.8a4.85,4.85,0,0,0-1-.1v.5a3.44,3.44,0,0,0-2-.9,8.18,8.18,0,0,1-1.1-.2l-.6-.1a6.18,6.18,0,0,0-1.9-.3,4.39,4.39,0,0,0-3.6,1.8c0,.1-.1.1-.1.2a4.36,4.36,0,0,0-1.7-.4,5.38,5.38,0,0,0-1.2.2l-.4.1-.3.2a28.12,28.12,0,0,1-11.2,4.6l-.8.1-.6.6a1,1,0,0,1-.4.1l-.4-2.1-2.7.2h-3.3a7.61,7.61,0,0,0-5.7,2.1,19,19,0,0,0-6,2.1,5.69,5.69,0,0,0-2.6-.8,3.06,3.06,0,0,0-1.2.2h0l-7.7-.4a19.73,19.73,0,0,1-3.6-.3h0a10,10,0,0,0-1-1.5,4.7,4.7,0,0,0-.9-2.8c-.1-.2-.5-1-.8-1.8a7.44,7.44,0,0,0-4.8-4.5,9.38,9.38,0,0,1-3.1-2.6c-2.7-3.5-3.9-3.8-8.5-4a14.4,14.4,0,0,1-5.6-1.2,15.09,15.09,0,0,0-2.3-1,7.15,7.15,0,0,0-2.7-2.3,3.1,3.1,0,0,1-.9-1.1,7.39,7.39,0,0,0-3-4.2c-3.7-3.1-5.4-9.8-7.2-16.8-2.2-8.6-4.7-18.3-11.8-23.8a33.89,33.89,0,0,1-2.6-3.9,21.69,21.69,0,0,0-1-4.5c-1.3-3.8-1.3-11-.7-12.3,2.3-3.7,1.6-7.5-2.2-10.4a20.16,20.16,0,0,1-3.5-5.3c-2.5-5.3-3.3-7.1-5-7.5a2.88,2.88,0,0,0-1.7-1.6l.1-.3c1.2-2.8-.5-4.7-1.2-5.6h0a7.23,7.23,0,0,1,2.8-4.2l.8-.5.4-.9c2-4.6,1.8-9.3,1.7-13.8a35.8,35.8,0,0,1,.5-9.3,30.9,30.9,0,0,0,.6-4.3,20.58,20.58,0,0,1,1.2-5.9,7.53,7.53,0,0,0,2.5-5.4,3.64,3.64,0,0,0-1.6-3.2,14.54,14.54,0,0,1,.1-5.5c.1-.5.1-1,.2-1.5a4.26,4.26,0,0,0,2.4-4.7,3.36,3.36,0,0,0,.3-.6,6.12,6.12,0,0,0,1-4.4,9.91,9.91,0,0,0,.1-4.2,7.82,7.82,0,0,0,.4-2.8V837l4.3,7.6,1-8.5a3.83,3.83,0,0,0,2.2.7c1.2,0,2.9-.6,3.7-3.3l.3-.6c1.7-3.3,3.8-7.4,4.1-10.9l.5-5.3-4.8,2.3a9.69,9.69,0,0,0-2.2,1.6,2.66,2.66,0,0,0-.6.5h-.1a6.26,6.26,0,0,1-2-2c-1.4-1.8-3.3-4.2-7.1-4.2h-.1a24,24,0,0,0-2.5-.5c-4-.8-6.5-1.4-7.9-3.6l-.4-.7-.7-.4a18.26,18.26,0,0,0-3.6-1.5c-2.3-.8-3.7-1.4-4.5-2.7l-.1-.2-.1-.2c-1.4-1.9-3.6-2.5-5.2-3a8.2,8.2,0,0,1-1.8-.7v-.1a8,8,0,0,0-1.8-5.1c-.3-.5-.7-1-.7-1.3l-.3-1.6-1-.4V792a7.66,7.66,0,0,0-1-5.1,14.63,14.63,0,0,1-.4-4.8,26.61,26.61,0,0,0-.5-6.1,4.63,4.63,0,0,1,.2-1.1c.3-1.6.7-3.9-.7-5.7a5,5,0,0,0-3.8-1.9l-.7-.1-.7.2a6,6,0,0,1-.8.3,13.1,13.1,0,0,0-3,1.3,3.54,3.54,0,0,0-.7-1.2,8,8,0,0,0,3.1-5,9,9,0,0,0-2.1-7.5,23.5,23.5,0,0,0-2.9-3.9c-1.7-1.9-2.7-3.2-2.8-4.8a15.12,15.12,0,0,0-1.8-5.9,8.68,8.68,0,0,1-1.2-4l.1-.8-.3-.7a36.06,36.06,0,0,1-1.4-4.9l-.9-3.6-.1-.4-.2-.3c-.5-.8-.9-1.7-1.4-2.7-1.6-3.2-3.5-7.2-7.7-8.8a10.6,10.6,0,0,1-2.2-4.9l-.1-1.3-1-.8c-3.5-2.9-7.8-3.6-11.7-4.1a31.78,31.78,0,0,1-5.8-1.2l-.2-.1h-.2c-1.6-.3-3.3-.8-5-1.2-1-.3-2-.6-3-.8l-1.4-.3-1.1.8c-.6.4-1.2.8-1.9,1.2-1.9,1.1-4.4,2.4-5.7,5.3a26.6,26.6,0,0,1-9.3,10.7l-.4.3-.3.4a25.27,25.27,0,0,1-2,2.6l-1.8-.8a10.48,10.48,0,0,1-3.1-2.3,17.78,17.78,0,0,0-4.8-3.5,6.78,6.78,0,0,1-.7-.9,9.81,9.81,0,0,0-4.7-3.5c-1.2-.6-1.9-1.8-2.9-3.6a17.45,17.45,0,0,0-1.9-2.9l-.1-.1-.1-.1-1.6-1.6c-2.7-2.6-4.3-4.4-4.1-6.7v-.6l-.2-.6a13.6,13.6,0,0,1-.4-5c0-2.6.1-5.5-1.3-8.4a20.61,20.61,0,0,0-9.8-15.1c-2.1-3.3-4.3-6.6-6.5-9.8-1.2-1.7-2.3-3.3-3.4-5l-.3-.4-.4-.3c-3.7-2.7-5.5-8.3-6.9-12.8l-.6-1.7-1.8-.3c-7.7-1.3-15.6-3-23.2-4.6-6.2-1.3-12.6-2.6-18.9-3.8l-2.8-.5-.7,2.8c-.7,3-1.1,6-1.5,8.9,0,.4-.1.7-.1,1.1a9.68,9.68,0,0,0-3.7-.9,5,5,0,0,0-1.8.3l-.9.3h0c-1-2-3.2-2.2-4.8-2.4-.3,0-.6-.1-.9-.1l-.2-.2-.7-.2c-6-1.6-12.1-2.9-18.1-4.3-7.5-1.6-15.2-3.4-22.6-5.5-9.3-5.6-18.4-12.3-27.1-18.8-5.1-3.8-10.4-7.8-15.7-11.4-10.3-7.5-21-15.1-30.4-21.8l-.1-.1a5.71,5.71,0,0,0,1.5-2.3l1-3.1-3.2-.7c-19-4.4-33.6-7.3-47.3-9.5a8.57,8.57,0,0,0-1.5-.2,3.44,3.44,0,0,0-3,1.6c-1.2,1.8-.3,3.7.3,5.2.1.3.3.7.4,1v.2l.1.5a18.42,18.42,0,0,1,.6,3.6c.3,2.8.7,5.9,2.8,8.8l.1.1c.2.2.4.5.7.8s.5.6.7.8a4.6,4.6,0,0,0-2.5,2,3.57,3.57,0,0,0-.3,2.4c-.3,2.7.9,4.9,1.9,6.7a7.48,7.48,0,0,1,1.2,2.9l.1.5.2.4c.5,1,.4,2.6.3,4.2a14.49,14.49,0,0,0,.3,5l.1.5.3.4c1.7,2.6,1.3,6.4.9,10,0,.4-.1.9-.1,1.3l-.3,3.5,2.5-.2a6.93,6.93,0,0,0,.9,2.9l.1.1.1.1c.8,1,.3,2.7-.4,5.1a16.68,16.68,0,0,0-.9,3.8l-.2,1.6,1.2,1a4.23,4.23,0,0,1,.2,1.9c-.1,1.9-.1,5.1,2.9,7.1.9,1,1.7,2.1,2.6,3.2,1.8,2.5,3.9,5.3,7.1,6.9,2.2,2.2,3.5,5.3,4.8,8.6.7,1.7,1.4,3.4,2.2,5l.3.5.5.4c1.3,1.1,1.9,2.9,2.7,4.9a17.85,17.85,0,0,0,3.7,6.9c.4.8-.5,2.7-1.1,3.9-.3.5-.5,1.1-.7,1.5l-1,2.5,1.2.6c-.6,1-1.5,2.5-1,4.2l-2.9-.6,1.1,4c-.1,0-.1.1-.2.1a4.84,4.84,0,0,0-1.2.9c-.6-.2-1.2-.7-1.2-1.1l-.4-4.9-4.2,2.5a3.59,3.59,0,0,1-1.8.5c-1.6,0-3.6-1-5.5-2a38.59,38.59,0,0,0-4.2-1.9l-6.2-1.9,2.6,6a9.53,9.53,0,0,0,2.7,3.4c1.1,1,1.2,1.2,1.2,1.5v.7l.3.6a7.51,7.51,0,0,0,3.6,3.5,4.07,4.07,0,0,1,1.2.9v.2l.1.2a10.28,10.28,0,0,1,.1,2c-.1,2.3-.2,6.1,3.5,7.9l.9.4,1-.2h.3c.4,0,1.1,1.2,1.6,2.1a11,11,0,0,0,3.4,4.1l.4.3.5.1c.8.2,1.3.9,2.2,2.6a12.14,12.14,0,0,0,2.7,3.8,3.08,3.08,0,0,0,4.09,1.53,3.19,3.19,0,0,0,1.31-1.13l.6.5a4.8,4.8,0,0,0,3.2,1.4,4,4,0,0,0,3.1-1.5c.06.24.12.47.2.7-1.6,2-.7,4.4-.2,5.6a4.76,4.76,0,0,1,.3.9l-.2.4v.7c.1,3.2,2.9,4.4,4.2,5,.1,0,.2.1.3.1v.1l.2.8c.4,1.6,1.7,2.9,3,4.2l.1,1.7h1.8l.9.7,1.4-.3a5.76,5.76,0,0,1,.9,2.5l.2,1.3,1.1.7c.7.5.8,2.4.9,4a7.78,7.78,0,0,0,.1,1.6l.4,4.4.7-.4c-.1,1-.2,2-.3,2.8a18.42,18.42,0,0,1-3.5,8.8,9.77,9.77,0,0,1-1.2,2.7,4.62,4.62,0,0,0-.9,4.7,3.73,3.73,0,0,0-1.1,3.6A4.26,4.26,0,0,0,365,790a9,9,0,0,0,.9,3.3c.3,1.5,1.1,4,4.4,4.2a1.72,1.72,0,0,1,.2.8,7.58,7.58,0,0,0,2.4,4.3c.7.9,1.5,1.8,2.3,2.8.5.6,1.3,1.5,1.7,2l.1.7,1,.8c3,2.4,6.1,7.4,8.2,10.8,1.1,3.6,3.6,5.9,5.9,7.9.8.7,1.5,1.4,2.1,2,2.2,3.2,2.6,7.1,3.1,11.3.2,1.7.4,3.4.7,5v.2a5.49,5.49,0,0,0,5.3,4.5,6.55,6.55,0,0,0,3.5-1.1c.7-.2,1.4-.4,2.3-.6,2.5-.6,6-1.4,7.8-5a9.92,9.92,0,0,0,1.4-7.3,9.61,9.61,0,0,0-3.6-5.8c-1.1-1.8-1.1-4.4-1-7.1v-2.5l-.1-2.8-2.8-.1h-.2a7.4,7.4,0,0,1-.9-1.8,10.59,10.59,0,0,0-2.5-4.1c-.1-.1-.1-.2-.2-.3-1.1-1.6-2.1-3.2-4.1-3.2a3.2,3.2,0,0,0-2.4,1.1,3.91,3.91,0,0,0-.8,3.4,6.79,6.79,0,0,0-2.6-2.5,6.68,6.68,0,0,1-.8-.6v-.1l-.1-.2a17.91,17.91,0,0,1,0-11.7c2.3-3.1.6-6.8-.4-9a13.9,13.9,0,0,1-.8-2l-.1-.3-.1-.2c-.9-2.1-.9-4.6-1-7.3,0-1.3,0-2.6-.1-3.9l-.1-1-.6-.7c-2-2.3-3.3-6-3.9-10.7a12.32,12.32,0,0,1,.5-1.4c.7-1.6,1.7-4,.4-6.7a17,17,0,0,1,0-3.9,20.1,20.1,0,0,0-.1-4.9l-.2-.9-.7-.7a6.76,6.76,0,0,1-1.1-2.9,13.32,13.32,0,0,0-2.2-5.4,3.2,3.2,0,0,0-2.9-1.8h-1.6a1.25,1.25,0,0,0-.1-.6l-.1-.9-.3-.4c0-.2.1-.4.1-.6.8-3.1.1-5.3-2.3-6.5-1.1-.9-1.4-2.5-1.7-5s-.6-5.2-2.4-7.6l-.1-.1c-2.2-2.7-4.3-5.6-5.1-8.8a6.24,6.24,0,0,0-.7-2.8l1.2.2.7-2.5c.8-2.6.2-5-.2-6.9a12.79,12.79,0,0,1-.5-3.2l.1-2.2-2.1-.8c-.4-.1-3.7-1.4-3.3-4a4.82,4.82,0,0,0-.1-4.1,4.74,4.74,0,0,0-2.1-2.1c-.4-3-2.6-3.2-3.3-3.2a1.36,1.36,0,0,0-.6.1,2.24,2.24,0,0,1,.1-1.2l1.4-1-.2-1.8a11,11,0,0,1-.1-1.9v-.9a20.37,20.37,0,0,0,4.1,5.6l3.6,3.5,1.3-4.9c.3-1.3.9-3.4-.3-5.1a4.3,4.3,0,0,0-2.6-1.7v-.7a6.68,6.68,0,0,0-2-5.9,3.35,3.35,0,0,0-2.6-1.5,3,3,0,0,0-3,2.5,12,12,0,0,0-.2,2.6,5.21,5.21,0,0,0-1.1-1.1c-1.5-2.1-2.9-4.3-4.3-6.7-1.3-2.1-2.6-4.3-4-6.4l-.7-1-1.2-.2a.81.81,0,0,1-.5-.3,1.11,1.11,0,0,1-.1-.8l.6-1.7-1.2-1.3a2.66,2.66,0,0,1-.5-1.3,9.79,9.79,0,0,0-1.4-3,54.63,54.63,0,0,1,1.3-11.1,61.81,61.81,0,0,0,1.5-11.5v-1.1l-.7-.8c-.9-1-.5-2.9.1-5.6.2-1,.5-2.1.6-3.1a18.45,18.45,0,0,1,2.2-5v.6a4.42,4.42,0,0,0,3.75,5h2.05l.9-1.6a3.31,3.31,0,0,0-.1-3.2c.2,0,.3.1.5.1l.5.1h.1a.3.3,0,0,0,.1.2,7.11,7.11,0,0,0,2.8,3v.6a9.34,9.34,0,0,0,.2,2.3l.4,1.4,1.3.5c.5.2,1.1.5,1.6.7a23.78,23.78,0,0,0,8.1,2.5l1.8.1.1.2.2.2a1,1,0,0,1,.3,1l-3.1,1.2,1.7,3a7,7,0,0,1,.5,4c0,2.3,0,5.2,1.8,7.8a20.68,20.68,0,0,1,1.7,5.8,33.25,33.25,0,0,0,1.4,5.2l.4,1,.9.5c1,.6.9,2.1.4,5.3a28.39,28.39,0,0,0-.5,4c-.9,3.6.9,6.3,2.3,8.4a8.38,8.38,0,0,1,1.6,3.3l.1.5.2.4a6,6,0,0,1-.1,1.8,7.42,7.42,0,0,0,.5,4.8l.5.8.8.4h-.2c-3.7.5-4.7,3.7-5.2,5.4a9.06,9.06,0,0,1-.6,1.6l-.2.1-.2.2a3.47,3.47,0,0,0-1.3,3.3c.3,2.4,2.8,3.5,4.6,4.3.1.1.3.1.4.2l2,1,1.5-1.7a11.91,11.91,0,0,0,1.9-2.9,11.54,11.54,0,0,0,3.4,4.1l-2,.5,2.6,3.6a14.48,14.48,0,0,1,1.3,3,19.13,19.13,0,0,0,1.5,3.7l.4.7.7.4q4.2,2.25,3.9,5.1v1.1c.1,1.3.3,5.3,3.9,5.5a4.48,4.48,0,0,0,2.2,3.5l4.7,2.2-.1-.8a5.78,5.78,0,0,0,1.7.4h0l.7.4c1.3.8.5,2.3.4,2.6l-.5.9.1.8c-.1.1-.2.3-.4.5a8.58,8.58,0,0,0-1.3,2.3l-.4,1.5,1,1.2a5.49,5.49,0,0,1,.5,2.9c.1,2.3.3,6,3.9,7.9a13,13,0,0,0,5.7,2.8c1.7.5,2.7.8,3.5,1.6v.1a5.51,5.51,0,0,0,.1,5c.1.3.2.8.3,1.1.4,1.7.9,4.6,3.8,5.5l3,.9-1.8,1.1,4.4,2.6a4,4,0,0,1,1.5,1.3l4.6,3.5a.89.89,0,0,1-.6.2,1.88,1.88,0,0,1-.7-.2v-.3l-.9,4-.2.1.1.3-.1.4h-.2a5.29,5.29,0,0,0-3.7,2,4.06,4.06,0,0,1-.8.7l-.6.2-.2.2a3.24,3.24,0,0,0-2.4,1.9,2.85,2.85,0,0,1,2-.8v2.8h.1v.1h-.1l-1.8,1.8-.1-.1a1,1,0,0,1,.4-.5l-.2.2-.2.2c0-.1-.1-.1-.1-.2,0,.1.1.1.1.2-2.4,3.1.9,6,2,7a7.57,7.57,0,0,1,.9.8l.1.3.3.5a3.84,3.84,0,0,0,.9.9l-1.1.2,2.9,3.9a3.49,3.49,0,0,0,2.9,1.5,4.11,4.11,0,0,0,1.6-.4l.9,1,1.1-1-.1.6.9,1a6,6,0,0,1,.6,1.4,7.49,7.49,0,0,0,3.2,4.3c.3.3.5.6.8.9a9.85,9.85,0,0,0,3.5,3.1,28.34,28.34,0,0,0,2.5,2.4c2,1.7,2.6,2.5,2.5,3.5l-.1,1.1.6.9a5.73,5.73,0,0,1-.7,2.1,12,12,0,0,0-.9,2.6l-.2.8.2.8c.9,3,3.5,3.5,4.7,3.8a1.94,1.94,0,0,1,.7.2l.9,1.1,1.6-.1a4.29,4.29,0,0,1,2.4.9,3.72,3.72,0,0,0-2.6,2.4,4.09,4.09,0,0,0,1.1,3.6,7.5,7.5,0,0,0,3.6,3c.4.2,1.1.5,1.2.7l.7,1.4,1.6.2a1.42,1.42,0,0,1,1,.8,4.56,4.56,0,0,1,1,2.9l-.2,1.8,1.4,1.1c2.6,1.9,3.7,5.7,4.8,9.4.2.5.3,1,.5,1.5a27.88,27.88,0,0,0,3.8,7.3,46.58,46.58,0,0,1,2.7,4.5l.7,1.6,1.7.2c1.2.1,2.1,1.9,3.2,4.4.3.6.5,1.2.8,1.8,1,4.5,3.5,5.5,5.4,5.5h.1a10,10,0,0,1,1.8,4.2l.2.7v.1a6.19,6.19,0,0,0-.9.7c-1.5,1.6-1.2,3.8-1,5.7a7.27,7.27,0,0,1,.1,1.4v.3l.1.3a13.43,13.43,0,0,1,.1,2.1c0,2.1-.1,5.8,3.2,7.4a.8.8,0,0,1,.1.5l-1.9.9.4,2.3a11.89,11.89,0,0,0,3.1,5.5c1.7,1.9,1.8,2.4,1.5,3.1a14.6,14.6,0,0,0-1.3,5.1c-.3,2.3-.5,3.2-1.4,3.8l-.4.3-.3.3c-.2.2-1,.8-1.4,1.1-1.8,1.2-4.7,3.2-3.3,6.2l.4.9.9.5.4.2a10,10,0,0,0,2.1.9c-1.5,1.4-2.7,2.3-4.1,2.3h-.6c-2,.2-5.6.5-6.8,3.3a4.45,4.45,0,0,0,.7,4.5,14.51,14.51,0,0,1,.7,4.8V945l.7.8c1.4,1.6,2,3.7,2.6,6.2.2.7.3,1.4.5,2.1l.1.5.3.4c.7.9,1.4,1.7,2.1,2.5,1.3,1.5,2.5,2.8,2.8,4.4v.2l.1.2c1.3,3.7,4.1,5.6,6.6,7.1a6.5,6.5,0,0,0,4.3,2.1l-2.6,1.5,5.4,2.4c.4.2.8.3,1.3.5s1.2.5,1.6.7l-.4,1.6,1.8,1.4a5.73,5.73,0,0,0,3.6,1.6,6.28,6.28,0,0,0,1.6-.3,7.17,7.17,0,0,0,2,1.8c.1.2.2.5.3.7.6,1.3,1.7,3.8,4.5,4.3a4.8,4.8,0,0,0-.4,1.7,5.24,5.24,0,0,0,1.7,4.2,13.92,13.92,0,0,1,1.3,2.4c1,2.2,2.3,4.8,5.5,6.2,1.7,1,3.5,1.8,5.2,2.6a33.41,33.41,0,0,1,8.6,5.2l.3.3.4.2c2.1,1,4.3,1.8,6.4,2.6,1.6.6,3.2,1.2,4.7,1.9l.7.3.7-.1a3.68,3.68,0,0,0,2.2-.9l1.9.3c2.4.4,3.9,2.3,6,5.3a31.13,31.13,0,0,0,3.3,4.2l.4.5.6.2c2.7,1.1,4.6,2.7,5.1,4.4l.2.9,1.4,1.3c1.7,1.5,3.6,3.3,4.3,4.9l.4.9.8.5c.7.4,1.4.9,2.2,1.3,4,2.5,8,5,12.7,6.5a3.94,3.94,0,0,0,3.1,1.5,4,4,0,0,0,1.6-.3,14.6,14.6,0,0,1,1.9,1.7,17.26,17.26,0,0,0,3.9,3c.1.1.3.2.4.4a6.72,6.72,0,0,0,4.4,2,3.7,3.7,0,0,0,1.1-.1,9.84,9.84,0,0,1,.9.5,7.29,7.29,0,0,0,4.2,1.6,3.7,3.7,0,0,0,1.1-.1,6.38,6.38,0,0,1,.9.9,10.71,10.71,0,0,0,2.2,2l1.7,1,1.2-.8.6.6c1.1,1,2.7,2.6,5.2,2.6h.5c1.5,0,2.6,1.3,4.3,3.4a7.57,7.57,0,0,0,.8.9,5.57,5.57,0,0,0,4.2,2.4c.4,0,.7-.1,1.1-.1a3.58,3.58,0,0,0,2.7,2.6l.2.1h.2c3.1.2,5.3,2.4,7.9,5a37.06,37.06,0,0,0,2.9,2.7l.4.3.4.2a47.19,47.19,0,0,0,8,2.3c4.5,1,8.7,2,11.7,4.9l.2.2.2.2a45.53,45.53,0,0,0,8,3.9c1.1.5,2.2.9,3.2,1.4l.3.1.3.1a15.63,15.63,0,0,0,3.8.4c4.2,0,8-1.3,11.7-2.6.8-.3,1.5-.5,2.3-.8a43.75,43.75,0,0,0,6.5-1.4,30.09,30.09,0,0,1,4.8-1.1l.4-.1.4-.2a38.36,38.36,0,0,0,3.4-2.1c1.5-1.1,2.8-2,4-2a1.89,1.89,0,0,1,.7.1h1c1.5,0,3.4-.7,4.1-3.8,0-.1.1-.2.1-.3l.3-.2.3-.6a1.11,1.11,0,0,1,.9-.4h.1v6.3l4.9-4.2a1.83,1.83,0,0,1,1.3,1.1l-.7,2.6,2.7.9a4.45,4.45,0,0,0,1.1.2,3.77,3.77,0,0,0,3.1-1.8l.1.1c1.1,1,2.5,2.4,4.6,2.4a4.33,4.33,0,0,0,1.9-.4,10.5,10.5,0,0,0,1,3l.8,1.5h0l-1.3,1.1,3,2.2a21.83,21.83,0,0,1,2.2,2.1,16,16,0,0,0,5,3.9l1.1.4.9-.4a1.84,1.84,0,0,1,.7.5l-.6,1.5,1.4,1.4a25.84,25.84,0,0,1,3.4,4.4c2.4,3.5,5.1,7.4,10.1,8.8a7.57,7.57,0,0,1,1.3.8l-1.5,1.3,2,2.3c1.2,1.4,2.4,2.9,3.6,4.6,2.5,3.2,5,6.5,7.9,8.9l2.7,2.2,1.8-3a16.72,16.72,0,0,0,1.8-6.3c.3-1.9.5-3.6,1.4-4.5l.7-.7.1-1a9.4,9.4,0,0,0-1.5-5.4c-.8-1.4-.9-1.7-.7-2a83.28,83.28,0,0,1,5.2-7.1,84.39,84.39,0,0,0,5.5-7.5l.2-.3.1-.3c.5-1.5,1.3-2,3-2,.6,0,1.4.1,2.3.2h.4c6.8.4,13.8,1.1,20.5,1.8l5.5.6,3.1.3.2-3.8c.1-1.7.2-3.5,1-4.3l3.4-3.2-4.3-1.8a6.76,6.76,0,0,1-4.3-5l-.1-.4-.2-.4c-1.7-3.7-5.1-5.6-7.8-7.1a12,12,0,0,0-1.5-.8c-1.9-2.3-3.9-4.6-5.9-6.7a13,13,0,0,0,2.7.4h0a4.52,4.52,0,0,0,3.6-1.5,4.77,4.77,0,0,0,1-3.8c.1-1.5.2-3.2.4-4.9s.3-3.2.4-4.8a4.21,4.21,0,0,0,2,.5,8.57,8.57,0,0,0,1.5-.2c4.8.2,9.8.7,14.6,1.1,6.2.5,12.5,1.1,18.6,1.2H882l1.1.6a5.69,5.69,0,0,0,2.8.9c3,0,3.9-2.9,4.2-3.8.1-.2.1-.4.2-.6l.2-.2a10.27,10.27,0,0,1,2.5,1.9l1.9,1.7,2-1.6a17.33,17.33,0,0,0,3.9-5.2,14.34,14.34,0,0,1,2.5-3.5l.3-.3.2-.3a9.07,9.07,0,0,0,.8-1.3c1.8-2.9,2.9-4.3,4.8-4.3h.8l.7-.4c2.9-1.6,5.2-4.8,5-8.3a7.75,7.75,0,0,0,1.1-.5c-.2.4-.4.9-.6,1.4a12.41,12.41,0,0,0-1.5,5l-.1,2.8,2.8.3s.7.3,1.1,3.2l5.8.6c2.1-6,3.8-12.2,5.4-18.2.4-1.4.7-2.7,1.1-4.1l.7-2.5-2.3-1.1a8.83,8.83,0,0,0-1-.3,2,2,0,0,1,.3-1,.76.76,0,0,1,.6-.4l1.2.2,1-.7s4-2.8,3.1-5.9a3.5,3.5,0,0,0-3.5-2.4,5.31,5.31,0,0,0-1.2.1h-.2a6.74,6.74,0,0,0,2-2.4c.1-.2.3-.5.4-.7l2.1-.3.2-2.3c.2-2.9.7-7.7,3.1-9.5l.7-.5.3-.9c.9-2.5,3.2-4.5,5.5-6.6C949,978.83,952.57,975.63,953.57,970.43Zm-23.7,35.3h0C929.87,1005.63,930,1005.63,929.87,1005.73Zm-295.7-226.3.1-.2v-.1l.8.8h-.2a1.72,1.72,0,0,1-.8-.2Zm-90.5,108.8,3,.2-2.2-3.1a2.36,2.36,0,0,0,.9-.2l2.2,1.2a.8.8,0,0,1,.5.6c.2.6-.1,2.1-1.2,3.7-.2.3-.3.6-.5.9l-3.2-.5A2.75,2.75,0,0,0,543.67,888.23Zm8.9,16.1h.7c-.3.2-.5.3-.8.5C552.47,904.63,552.57,904.53,552.57,904.33Zm87.1-74.8a2,2,0,0,1-1.3.4,9.46,9.46,0,0,1-1.6-.2l.2-.4a2,2,0,0,0,.2-.8,4.16,4.16,0,0,0,1.7.4,1.34,1.34,0,0,1,.8.6Zm-27.4,170.2h.8v.8l-1.9.2c.3-.5.6-1,1.1-1Zm-261.9-402.8-.9.9-.4.4c.3-.5.6-1.1.9-1.6l.4-.7v-.4c.2.4.5.9.7,1.3v.1Zm82.1,156.4.2-1.8h.8a4,4,0,0,1,.5.9Z' }),
	      _react2.default.createElement(
	        'g',
	        { id: 'USA' },
	        _react2.default.createElement(
	          'g',
	          { id: 'US-AK' },
	          _react2.default.createElement('path', _extends({
	            className: 'upcoming',
	            fill: '#e6e6e6',
	            'data-coming-soon': true,
	            'data-city': 'Anchorage',
	            'data-state': 'AK',
	            'data-tooltip-copy': t('mapHero.tooltip.soon'),
	            'data-season': t('mapHero.stats.spring'),
	            'data-year': '2019',
	            'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData
	          }, getPavedPathAlaskaProps(t), {
	            d: 'M194.69,771.4c-1.15-.18-1.27-.46-1.38-3-.06-1.5.05-2.89.28-3a7.67,7.67,0,0,0,.76-3.06,7.92,7.92,0,0,1,1.27-3.76,16.54,16.54,0,0,0,2.08-4c1.33-3.41,1.74-3.88,3.24-3.47.87.23,1,.87.52,3.41a13.67,13.67,0,0,0-.17,4.28c.4,1.21-.7,4.28-2.49,7a12.28,12.28,0,0,0-1.5,3.42C196.89,771.17,196.31,771.63,194.69,771.4Z' })),
	          _react2.default.createElement('path', _extends({
	            className: 'upcoming',
	            fill: '#e6e6e6',
	            'data-coming-soon': true,
	            'data-city': 'Anchorage',
	            'data-state': 'AK',
	            'data-tooltip-copy': t('mapHero.tooltip.soon'),
	            'data-season': t('mapHero.stats.spring'),
	            'data-year': '2019',
	            'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData
	          }, getPavedPathAlaskaProps(t), {
	            d: 'M335.86,839.64c-9.2,1.44-9.49,1.44-11,0-.87-.81-3.12-2.84-5-4.45a40.72,40.72,0,0,1-6.65-7.35c-5.15-7.17-5.78-7.86-7.92-9.19-1.62-1-2.78-2.38-5.38-6.48-1.85-2.83-3.36-5.49-3.36-6,0-.75-5.43-8-8.61-11.62a26.21,26.21,0,0,0-6-3.93c-4-2-4.8-2.66-7.75-6.25-4.39-5.38-5.61-6.48-9.08-7.92-2.72-1.1-3.12-1.51-4.8-4.4s-1.79-3.35-1-4.57c1.62-2.77.58-4.16-1.1-1.56-1,1.56-1.16,1.56-6.24.7s-5.56-1.16-9.95-4.92c-1.68-1.45-9.49-2.78-12.78-2.2a21.53,21.53,0,0,1-5.78.12c-2.55-.35-3.3-.75-5.21-2.89C216,754.3,216,754.3,213.39,755l-2.6.7-1.45-2.61a27.88,27.88,0,0,1-2.14-4.8c-.63-2.08-.69-2.14-2.31-1.67s-1.79.29-3.24-1.8c-2-2.89-3.64-4-4.57-3.35-1.5,1.1-2.83,4.57-2.66,7a7.23,7.23,0,0,1-.63,3.7c-.93,1.21-1.16,2.37-1.22,6.36s-1.73,5-5.72,3.47a16.64,16.64,0,0,1-3.3-1.5c-.11-.18-2.2,1-4.51,2.71s-4.8,3.18-5.44,3.24a21.8,21.8,0,0,0-4.85,2.37c-3.36,2-6,2.78-7.75,2.2-1.1-.35-2.6-2.77-2-3.18.29-.23.76-2.14,1-4.28.41-3.58.64-4,2.95-6.07,2.66-2.31,3.53-3.59,3.65-5.5a4,4,0,0,1,1.62-2.31c.86-.63,1.5-1.44,1.5-1.79s.75-1.27,1.79-2,2.08-1.21,2.43-1,1.33-.23,2.14-.81a6.43,6.43,0,0,1,4.11-.92,32.12,32.12,0,0,0,4.16-.06c1.39-.17,1.16-.35-1.56-1.1-4.8-1.33-4.8-1.33-3.47-3.58l1.21-2-2.14.52a15.78,15.78,0,0,0-5.6,3.3,17.31,17.31,0,0,1-3.71,2.54,4.51,4.51,0,0,0-1.44-.63c-1-.29-1.33-.12-1.79.75A34.85,34.85,0,0,1,158.27,753c-2.72,2.14-2.72,2.2-1.74,3.82l1,1.62-4,3c-4.68,3.41-8.5,7.51-9.48,10.06a5.17,5.17,0,0,0-.47,2.08c.23.41.45.84.64,1.27s.58.81.75.7a3.41,3.41,0,0,1,1.22-.29c.69-.06,1,.52,1.56,2.83.63,2.72.52,3-.93,3.7a5.64,5.64,0,0,1-2.49.75c-.52,0-4.22,2.2-8.26,5-7.06,4.85-9.55,6.24-12.32,7a6.27,6.27,0,0,0-2.61,2.31c-1.79,2.61-15.26,12.38-17.63,12.73-.93.17-4.23,2-7.7,4.28-3.29,2.19-6.65,4.22-7.4,4.56s-1.67.7-2.08.87a3.72,3.72,0,0,1-1.62.18,3.16,3.16,0,0,0-1.85.46c-.58.4-1.44.23-2.43-.41a3.68,3.68,0,0,0-2-.81,20,20,0,0,1-4.23,1.39,12.68,12.68,0,0,1-3.81.64c-1.16-.29-8.45.75-9.14,1.27a2.17,2.17,0,0,1-1.62.12,1.9,1.9,0,0,0-1.79.57c-.52.52-1.45.58-2.72.18a4.22,4.22,0,0,0-2.6-.23,2.38,2.38,0,0,1-1.68.17,3,3,0,0,0-2.14.46,11.88,11.88,0,0,1-3.24,1.27c-1.67.41-2.48.24-3.58-.8a8.91,8.91,0,0,0-2.32-1.51c-1.21-.35-1.79-2.49-.86-3.18.4-.35,1.9-1.62,3.29-2.83s2.89-2.2,3.41-2.2a10.74,10.74,0,0,0,3.24-1.16c3.94-2,7.52-3,10-2.48,1.56.29,4.91-.24,10.12-1.62,7.34-1.91,10.75-2.55,13.88-2.61,1.21,0,2.25-.75,6.13-4.45A33.14,33.14,0,0,1,94.55,799a26.66,26.66,0,0,0,5.15-2.37,29.31,29.31,0,0,1,3.24-3.06c4.62-4,6.82-7.35,9.54-13.94,1.33-3.3,3.06-7.17,3.81-8.5l1.39-2.49-2.89,1.91c-3.35,2.14-5,2.2-7,.23-1.28-1.21-1.51-1.21-2-.11s-.81,1.15-1.79.81c-1.85-.58-4-2.84-5-5.27L98.13,764l-5.73-.81c-5-.7-6.07-.64-8.15.46s-4,1.1-4.8,0a11.72,11.72,0,0,1,.75-3.3c1-3.24,1.45-13.65.69-16.31-.4-1.56-.46-1.56-2.71.06-2.09,1.51-2.49,1.56-4.86.87a28.24,28.24,0,0,0-4.8-1c-2.89-.35-4.8-2.83-5.32-7.06a14,14,0,0,0-1.68-5.14c-.69-1.16-1.44-2.37-1.62-2.61s.52-2.19,1.56-4.28c1.28-2.71,1.74-4.39,1.45-5.89-.35-2-.52-2.14-2.72-3.13s-2.31-1.1-3.41-4.22c-1.27-3.82-1.16-4.34,1.39-6.48,1.44-1.21,2-2.08,2-3.35.06-1.62.29-1.91,3.7-4,2.89-1.79,3.76-2.54,4.17-3.76s1.62-2.31,4.85-4.68l4.34-3.18L79,688.52c1,1.27,2.14,2.66,2.54,3.12a29.18,29.18,0,0,1,2.08,2.49c1.1,1.39,1.33,1.44,1.8.58a24.45,24.45,0,0,1,4-3.94l3.47-2.94,1.79.8c1.5.7,2,.64,3-.4a17.62,17.62,0,0,0,2.25-5.73c.87-3.47.93-4.8.23-5.89-1.61-2.55-1.5-3,1.22-5.15,2-1.68,2.49-2.26,2.08-3s-1-.52-6,3.12l-5.56,4-1.5-1.44a3.76,3.76,0,0,1-1.44-2.49c0-.87-.29-1.1-1.51-1.33a7,7,0,0,1-3-1.5,4.62,4.62,0,0,0-3.52-1c-7,.69-6.89.75-9.14-1.51-2.72-2.77-3-3.06-4.4-6-1.15-2.32-1.15-2.6.18-4.34,1.62-2.14,1.33-2.89-1.74-4.39A16.92,16.92,0,0,1,61.41,648c-2.14-2.37-2.32-2.77-2-4.45s.52-1.91,4.23-3.82a38.94,38.94,0,0,1,9.77-3.12,78.81,78.81,0,0,0,10.87-3c5.67-2.08,8-2.66,8.44-2a12.67,12.67,0,0,1-.34,3.93c-1,5.15.11,6.36,5.78,6.54,4.74.11,5.44-.06,5-1.62a23.24,23.24,0,0,1,.12-5.27c.4-3.87.58-4.28,1.85-4.33,2.37-.18,1.73-1.22-3.87-6.48a13.26,13.26,0,0,0-4.8-2.66c-2.78-.75-2.84-.87-6.71-6.13-2.32-3.18-3.82-5.67-3.76-6.19s-1-2.6-2.32-4.68a18.08,18.08,0,0,1-2.31-4.34,30.34,30.34,0,0,1,2.31-3.76l2.2-3.24,3.7.52c5.09.75,7.52.23,12-2.54,3.53-2.14,3.82-2.43,3.65-3.7-.12-.75.63-3,1.67-5a16.09,16.09,0,0,1,5.15-6.13l3.3-2.54,3.81.58c5.27.81,8.56-.64,12.27-5.38,3.46-4.45,5.89-5.32,12.31-4.51l4.63.58,3.18-2.32c1.74-1.27,3.41-2.25,3.7-2.14.93.41,4.28,3.88,5.84,6.08a15,15,0,0,1,2.26,6.07l.63,3.87,2.66.64a28.48,28.48,0,0,0,5.61.58l3-.06.41,2.2c.4,2.14.46,2.19,2.37,2.71a25.2,25.2,0,0,1,4.62,2c2.2,1.22,2.84,1.33,4,.52,1.74-1.21,8.27.06,11.34,2.2,3.35,2.37,13.07,4,22.15,3.82,4.91-.12,8.56-.52,9.77-1.16a4.64,4.64,0,0,1,2.6-.69c.93.34,3.94,5.55,3.88,6.7a1.24,1.24,0,0,0,.58,1.22,22.16,22.16,0,0,1,3.12,2.77l2.49,2.49.28,9.6c.35,11.39.87,27,1.74,50.78.35,9.6.81,22.61,1,28.91.35,11.22,1.22,34.82,1.8,52.11.34,9.37.57,9.89,4.62,10.06,1.27.06,3,.17,3.7.29,1.22.17,3-.7,6.31-2.89l1.15-.81-.34,2.54c-.52,3.82-.18,5,2.77,9.72a39.21,39.21,0,0,1,2.66,4.62,6.48,6.48,0,0,0,2.14,1.39c2.72,1.39,6.48,5.9,7.93,9.6a23,23,0,0,0,1.5,3.36c.63.92,1.56-.06,2.37-2.55a36.59,36.59,0,0,1,3.82-6.76c1.73-2.49,3-4.69,2.89-4.86a4.89,4.89,0,0,1-.18-1.62c.06-2,3.71-3.12,5.32-1.62.64.58,2.26,1.91,3.59,3a119.15,119.15,0,0,1,17.81,17.69,43.4,43.4,0,0,0,4.63,4.86c1.79,1.5,2,1.79,5,9.2,1.85,4.51,2.43,5.49,4.22,6.93,3.18,2.61,9.66,5.9,12.72,6.54,2.49.46,3,.81,4.23,2.83a7,7,0,0,1,1.15,4.8c-.4,3.53-.11,5.21,1.22,7s1,4.45-.58,7.58C345.86,837.93,345.63,838.08,335.86,839.64Z' })),
	          _react2.default.createElement('path', _extends({
	            className: 'upcoming',
	            fill: '#e6e6e6',
	            'data-coming-soon': true,
	            'data-city': 'Anchorage',
	            'data-state': 'AK',
	            'data-tooltip-copy': t('mapHero.tooltip.soon'),
	            'data-season': t('mapHero.stats.spring'),
	            'data-year': '2019',
	            'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData
	          }, getPavedPathAlaskaProps(t), {
	            d: 'M146.87,808.12a44.88,44.88,0,0,1-7.69-.06c-.35-.17-.93-1.91-1.22-3.7-.4-2.37-1-3.7-2-4.68-1.22-1.22-1.28-1.62-.58-3.3s1.38-2.25,3.87-3.7a39.87,39.87,0,0,0,3.93-2.54c.47-.41,3.18-2.66,6.08-4.92s5.26-4.51,5.32-4.92c.17-.92,3.58-3.47,4-3l1.27,1.27a7.14,7.14,0,0,1,1.44,2.95c.41,1.68.12,2.6-1.44,5a19.44,19.44,0,0,1-2.55,3.36c-.34.23-.46,2.83-.23,5.72.81,10,.87,9.54-1.21,11.11C154.21,807.6,152.65,807.93,146.87,808.12Z' })),
	          _react2.default.createElement('path', _extends({
	            className: 'upcoming',
	            fill: '#e6e6e6',
	            'data-coming-soon': true,
	            'data-city': 'Anchorage',
	            'data-state': 'AK',
	            'data-tooltip-copy': t('mapHero.tooltip.soon'),
	            'data-season': t('mapHero.stats.spring'),
	            'data-year': '2019',
	            'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData
	          }, getPavedPathAlaskaProps(t), {
	            d: 'M20.22,829.87c-3.82-.81-4.8-.76-6.13.17a3,3,0,0,1-3.07.58c-.92-.35-2.77-.12-4.8.52-5.95,2-6,2-6.18.58s0-1.45,7.74-6.13c1.33-.81,2.72-.87,5.56-.47,2.08.35,3.93.35,4,0s1.8-.92,3.65-1.33c3.35-.69,3.41-.69,4.57,1.16,2.31,3.7,2.31,3.53.69,4.68C25.08,830.62,24,830.62,20.22,829.87Z' })),
	          _react2.default.createElement('path', _extends({
	            className: 'upcoming',
	            fill: '#e6e6e6',
	            'data-coming-soon': true,
	            'data-city': 'Anchorage',
	            'data-state': 'AK',
	            'data-tooltip-copy': t('mapHero.tooltip.soon'),
	            'data-season': t('mapHero.stats.spring'),
	            'data-year': '2019',
	            'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData
	          }, getPavedPathAlaskaProps(t), {
	            d: 'M47.8,741.33c-2.71-.47-3.12-.7-3.47-2.14a22.16,22.16,0,0,0-2.54-4.69c-2.66-3.81-2.6-5.78.11-7.46,1.74-1,1.91-1,4.28.87,1.8,1.45,2.66,1.85,3.3,1.39a2.65,2.65,0,0,1,2.43.17c1.33.7,1.62,1.1,2.08,3a20.14,20.14,0,0,1,.46,4.51c-.05,1.91-.34,2.6-1.79,3.64S50.29,741.73,47.8,741.33Z' })),
	          _react2.default.createElement('path', _extends({
	            className: 'upcoming',
	            fill: '#e6e6e6',
	            'data-coming-soon': true,
	            'data-city': 'Anchorage',
	            'data-state': 'AK',
	            'data-tooltip-copy': t('mapHero.tooltip.soon'),
	            'data-season': t('mapHero.stats.spring'),
	            'data-year': '2019',
	            'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData
	          }, getPavedPathAlaskaProps(t), {
	            d: 'M38.61,685.46c-2-1.5-3.24-2.77-6.19-6.36-2.66-3.24-3.59-4.05-4.8-4.16-2.08-.18-3.18-2-2.72-4.57.52-2.78,1-3.12,2.78-2.14a5.54,5.54,0,0,0,3.41.35c3.76-.81,4.51-.58,6.19,2,1.44,2.25,1.44,2.43.11,3.18s-1.38.87.41,3.12c1,1.28,2.08,2.32,2.37,2.26.92-.06,1.5,1.1,1.39,2.77C41.5,683.84,39.48,686.16,38.61,685.46Z' }))
	        ),
	        _react2.default.createElement('path', _extends({
	          id: 'US-AL',
	          className: 'not-paved',
	          fill: '#e6e6e6',
	          'data-not-paved': true,
	          'data-city': 'Alabama',
	          'data-state': 'AL',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Mobile',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsedVague') + ' ' + t('months.december') + ' 2019'
	        }), {
	          d: 'M936.1,708.17c-.4-1.2-1.4-1.4-4.1-.9l-3.5.7.6-37.9c.3-20.8.8-39.9,1-42.4s.8-8.3,1.2-13,.9-9.3,1-10.2.6-5.6,1-10.4.8-9.4.9-10.3c.2-1.1,1.4-1.6,4.1-1.7,2.1-.1,13.2-.4,24.6-.8l20.7-.6,1,3.7c.5,2.1,1.5,6,2.1,8.7s2,7.7,3.1,11c1.8,5.6,3.1,12.8,4.4,24.3a39.68,39.68,0,0,0,3.5,10.5c3.1,6,3.2,6.6,2.8,22.8-.2,8.1.1,10.8,2.1,19.3.5,2.1.6,3.9.2,4.1s-6.7.4-14.1.5-19.6.4-27,.8c-11.9.5-13.7.8-15.2,2.6-2.2,2.5-2.2,2.2.6,9.3a74.47,74.47,0,0,1,3,8.7l.7,2.8h-7.1C938.3,709.67,936.5,709.27,936.1,708.17Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-AR',
	          className: 'not-paved',
	          fill: '#e6e6e6',
	          'data-not-paved': true,
	          'data-city': 'Arkansas',
	          'data-state': 'AR',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Fayetteville',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsedVague') + ' ' + t('months.may') + ' 2019'
	        }), {
	          d: 'M803.5,625.67l-.3-7.5-3.2-.9c-3.8-1.1-3.5,1.3-3.2-28.1.1-11,.2-26.2.1-33.8l-.1-13.8,44,.4c24.2.2,44.3.7,44.6,1s0,2.7-.7,5.2c-1.5,5.2-1.2,5.7,4.8,7.3,2.3.7,4.2,1.7,4.2,2.3s-1.5,3.6-3.4,6.8a45.73,45.73,0,0,0-4.5,10.7,23.52,23.52,0,0,1-5.1,9.4c-2.8,3.2-4.1,5.8-4.6,9a21.7,21.7,0,0,1-4.5,9.6c-5.5,7.2-7.1,12.5-7,22l.1,8h-61Z' })),
	        _react2.default.createElement('path', _extends({
	          className: 'not-paved',
	          id: 'US-AZ',
	          'data-not-paved': true,
	          fill: '#e6e6e6',
	          'data-city': 'Arizona',
	          'data-state': 'AZ',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Kingman',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsedVague') + ' ' + t('months.december') + ' 2019'
	        }), {
	          d: 'M450.7,633.57c-4.9-1.1-10.8-2.6-13.7-3.4s-6.9-3.5-9-3.5c-3.2,0-5-1.9-10.3-6.2-3.6-2.9-7.4-6.1-8.5-7.1s-6.1-4.6-11-7.9c-10.8-7.3-34.6-23.3-39.5-27.7-1.9-1.7,3.9-4.3,2-5.1-3.7-1.5-12.5-2.3-11.6-3.8.3-.5,5-2.9,8.1-4.1,5.1-2.1,5.5-2.5,5.5-5.5a6.88,6.88,0,0,0-2-5c-2.9-2.6-2.5-5,1.5-9.1a36.56,36.56,0,0,0,5.5-7.5c1.2-2.3,2.7-3.9,3.8-3.9s3-1.3,4.6-2.9l2.8-2.9-2.3-4.4c-1.9-3.6-2.3-6-2.3-13.1,0-4.8.3-8.8.6-8.8s1-3.9,1.4-8.8c.5-6.2,1.3-9.6,2.7-11.5,1.9-2.6,2.3-2.7,7.7-2.2l5.7.6,3.2-8.6c1.8-4.7,3.6-8.8,4-9,.8-.5,95.3,22.8,97,23.8.6.4.7,1.5.1,2.9a37.66,37.66,0,0,0-1.4,5.2c-.3,1.6-3.7,16.9-7.6,33.9s-7.3,31.9-7.5,33-2.3,10.1-4.5,20-5.8,25.5-7.8,34.8C463.7,635.17,464.9,636.67,450.7,633.57Z' })),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/burbank-ca', onClick: function onClick() {
	              return gaStateClicked('Burbank', 'CA', 'see the story for');
	            } },
	          _react2.default.createElement('path', {
	            id: 'US-CA',
	            className: 'paved',
	            fill: '#e6e6e6',
	            'data-paved': true,
	            'data-city': 'Burbank',
	            'data-state': 'CA',
	            'data-stat1number': '5',
	            'data-stat1text': t('mapHero.stats.potholesFixed'),
	            'data-stat2number': '8',
	            'data-stat2text': t('mapHero.stats.hoursWorked'),
	            'data-month': tMonthDayDate(i18n, '01/31'),
	            'data-date': '2018',
	            'data-date-text': t('mapHero.stats.datePaved'),
	            'data-tooltip-copy': t('mapHero.tooltip.story'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData,
	            d: 'M344.6,567.67c-1.6-1-25.4-4.1-38.2-7.1-8.9-2.1-6.7-8.8-7.2-21.9-.4-9.6-.6-10.5-4.1-16.2a35.28,35.28,0,0,0-7.5-8.7,18.57,18.57,0,0,1-5-5.3,22,22,0,0,0-4.9-5.8,41.77,41.77,0,0,1-7-7.9c-3.6-5.2-8.5-9.2-11.6-9.2-2.9,0-9-4.1-11.9-7.9s-2.7-8.1.2-11.3c2.2-2.5,1.9-6.5-1.7-18.8-1.7-5.8-3-11.7-3-13.1s-1.5-5-3.3-8c-3.8-6.3-3.8-6.5-1.2-10.4,2.8-4.2,2.6-12.5-.4-16.6-1.9-2.6-2.2-3.8-1.6-8,.4-2.7,1.5-6,2.6-7.4,2.7-3.5,1.7-7.4-2.8-11.3-3.3-2.8-3.8-3.8-3.9-8a31.49,31.49,0,0,0-2.3-9.6,58.43,58.43,0,0,1-3.3-10.5c-1.1-5.4-1-6.3,2.4-16.9l3.5-11.2-2.5-6.2c-2.4-6.1-2.5-6.2-.7-10.1a32.62,32.62,0,0,1,4.1-6.6c1.3-1.5,4.8-6.4,7.8-10.9,4.7-7,5.5-8.9,5.6-13.2.1-3.2.5-4.9,1.2-4.6,1.2.4,29.1,10.5,45.6,16.5,5.8,2.1,15.1,5.5,20.7,7.5,10.1,3.7,10.2,3.7,9.2,6.3-.6,1.4-3.2,8.7-5.8,16.1s-7.1,20-10,28-6.1,17.1-7.2,20.3c-2,5.7-2,12.5,0,15.1.5.6,3.4,5.8,6.4,11.6,18.3,34.7,62.2,116.7,63,117.8.6.7.9,4.4.8,8.2-.2,5.3.3,7.8,1.9,11,2.4,4.8,2.1,5.7-2.3,6.8-2.4.6-3.8,1.9-5.5,5.3a45.22,45.22,0,0,1-5.8,8c-4,4.2-4.6,8.8-1.4,12.2,2.9,3.2,2.5,4-3.3,6.5C346.9,565.57,346.4,568.67,344.6,567.67Z' }),
	          _react2.default.createElement('path', {
	            fill: '#ffffff',
	            'data-paved': true,
	            'data-city': 'Burbank',
	            'data-state': 'CA',
	            'data-stat1number': '5',
	            'data-stat1text': t('mapHero.stats.potholesFixed'),
	            'data-stat2number': '8',
	            'data-stat2text': t('mapHero.stats.hoursWorked'),
	            'data-month': tMonthDayDate(i18n, '01/31'),
	            'data-date': '2018',
	            'data-date-text': t('mapHero.stats.datePaved'),
	            'data-tooltip-copy': t('mapHero.tooltip.story'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData,
	            d: 'M294,488.43h-3.37l-.4-1.24a.67.67,0,0,0-.56-.39h-4.32a.55.55,0,0,0-.51.39l-.45,1.24h-3.36a1.94,1.94,0,0,0-2,1.91v8.25A1.89,1.89,0,0,0,281,500.5h13a1.89,1.89,0,0,0,1.9-1.91v-8.25A1.93,1.93,0,0,0,294,488.43Zm-11.91,3.2h-.56a.79.79,0,0,1-.84-.79.86.86,0,0,1,.84-.84h.62a.86.86,0,0,1,.84.84A.87.87,0,0,1,282.13,491.63Zm5.39,5.67a2.81,2.81,0,1,1,2.81-2.81A2.79,2.79,0,0,1,287.52,497.3Z' })
	        ),
	        _react2.default.createElement('path', _extends({
	          id: 'US-CO',
	          className: 'not-paved',
	          fill: '#e6e6e6',
	          'data-not-paved': true,
	          'data-city': 'Colorado',
	          'data-state': 'CO',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Littleton',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-04-23')
	        }), {
	          d: 'M629.7,507.93c-4.4-1.1-19.7-4.2-33.5-6.9-1.1-.2-4.2-.8-7-1.4s-6.1-1.2-7.5-1.4c-2.4-.4-16.2-3-51-9.7-8.5-1.6-18.4-3.6-22-4.2-4.6-.9-6.4-1.7-6.3-2.7.1-.8,3.6-17,7.9-35.9s7.9-35.4,8.1-36.5,1.7-7.6,3.2-14.5c2.4-10.9,3.1-12.5,4.7-12.3,1.1.1,6.4,1.1,11.8,2.3s10.9,2.3,12.3,2.5a31.83,31.83,0,0,1,4.1,1c1,.3,2.9.7,4.2,1,3.6.6,14.9,3,36.5,7.7,10.4,2.3,20.8,4.3,23,4.5s5.3.6,7,.9,4.6.8,6.5,1.1c18.2,2.9,23.5,4.1,23.3,5.5-1.1,7.7-6.4,46.4-6.8,49.5-.3,2.2-.7,5.1-.9,6.5s-.6,4.1-.9,6-1.4,10-2.5,18-2.2,15.8-2.4,17.5c-.3,2.5-.8,3-3.3,3.1C636.5,509.27,632.7,508.67,629.7,507.93Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-CT',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'New Haven',
	          'data-state': 'CT',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.spring'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'New Haven',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsedVague') + ' ' + t('months.may') + ' 2019'
	        }), {
	          d: 'M1210.9,381.47c.2-.7-.3-3.3-1.3-5.8a21,21,0,0,1-1.4-6.5c.2-1.1.4-3.4.5-5.1l.2-3.1,11.1-2.3c6.1-1.3,11.6-2.4,12.2-2.5.9-.2,5.3,14.6,5.3,17.9,0,.3-2.6,1.3-5.8,2.2-8.7,2.4-15.6,4.8-16.7,5.7C1213.7,383.17,1210.5,382.77,1210.9,381.47Z' })),
	        _react2.default.createElement('path', {
	          id: 'US-DC',
	          fill: '#e6e6e6',
	          d: 'M1150.8,453.27c-.9-1.1-.8-1.7.2-2.5s1.7-.8,2.5.2.8,1.7-.2,2.5C1152.3,454.47,1151.7,454.37,1150.8,453.27Z' }),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/milford-de', onClick: function onClick() {
	              return gaStateClicked('Milford', 'DE', 'see the story for');
	            } },
	          _react2.default.createElement('path', {
	            id: 'US-DE',
	            className: 'paved',
	            fill: '#e6e6e6',
	            'data-paved': true,
	            'data-city': 'Milford',
	            'data-state': 'DE',
	            'data-stat1number': '40',
	            'data-stat1text': t('mapHero.stats.potholesFixed'),
	            'data-stat2number': '10',
	            'data-stat2text': t('mapHero.stats.roadsRepaired'),
	            'data-month': tMonthDayDate(i18n, '04/09'),
	            'data-date': '2018',
	            'data-date-text': t('mapHero.stats.datePaved'),
	            'data-tooltip-copy': t('mapHero.tooltip.story'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData,
	            d: 'M1282,443.21a4.39,4.39,0,0,1,1.51,3.57v.4a4.42,4.42,0,0,1-1.5,3.59,6.39,6.39,0,0,1-4.21,1.25h-4.48V441.94h4.46A6.33,6.33,0,0,1,1282,443.21Zm28-9.31v26.4h-75.9V447.7H1187c3.5,3.34,6.68,8,6.68,10.3,0,.9-2,1.4-6.9,1.5l-6.9.2-2-7.8c-1.1-4.3-2.6-10.9-3.3-14.6-1.1-5.8-1.1-7,.2-7.7,2.5-1.6,2.9-1.1,2.9,2.9,0,7.6.9,9.5,5.9,12.5a18.12,18.12,0,0,1,2.31,1.7h48.19V433.9Zm-24.85,12.83a6.4,6.4,0,0,0-.81-3.25,5.61,5.61,0,0,0-2.45-2.23,9.18,9.18,0,0,0-4.06-.81h-6.18v13.07h6.18a9.18,9.18,0,0,0,4.06-.81,5.59,5.59,0,0,0,2.45-2.22,6.4,6.4,0,0,0,.81-3.25ZM1299.7,452h-10.19v-4.61h9V446h-9v-4.05h10v-1.48h-11.67v13.07h11.85ZM1259,441.43h-3.37l-.4-1.24a.67.67,0,0,0-.56-.39h-4.32a.55.55,0,0,0-.51.39l-.45,1.24h-3.36a1.94,1.94,0,0,0-2,1.91v8.25a1.89,1.89,0,0,0,1.91,1.91h13a1.89,1.89,0,0,0,1.9-1.91v-8.25A1.93,1.93,0,0,0,1259,441.43Zm-11.91,3.2h-.56a.79.79,0,0,1-.84-.79.86.86,0,0,1,.84-.84h.62a.86.86,0,0,1,.84.84A.87.87,0,0,1,1247.13,444.63Zm5.39,5.67a2.81,2.81,0,1,1,2.81-2.81A2.79,2.79,0,0,1,1252.52,450.3Z' })
	        ),
	        _react2.default.createElement('path', _extends({
	          id: 'US-FL',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'Miami-Dade County',
	          'data-state': 'FL',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.spring'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Miami-Dade County',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-05-21')
	        }), {
	          d: 'M1082.4,686.77a12,12,0,0,0-1.8.1l-4.1.3-.3,5.3c-.4,6.1-.3,6.1-3.7,6.7-1.9.3-2.9-.2-4.1-2s-2.4-2.4-5.4-2.4h-29.4l-25.7-.1-.7-3.1-.7-3.1-26.1.7c-14.4.4-27.1.8-28.2,1s-2.3.4-2.8.5c-1.2.1-.9,2.5,1.2,7.7a50.87,50.87,0,0,1,2.5,7.7c.4,2,1.1,2.7,2.3,2.3a102.51,102.51,0,0,1,12-1.1l10.2-.7,5.8,3.5a60.77,60.77,0,0,0,9.2,4.6,13,13,0,0,1,5.9,4.6c2.2,3.2,2.7,3.5,6,2.9,2-.4,7.2-2.5,11.6-4.7,12.2-6.1,14.4-6.7,18-5a16.57,16.57,0,0,1,5.4,4.9c1.3,1.9,6.1,6.9,10.7,11,9.6,8.7,10.2,10,11,24.8a83.14,83.14,0,0,0,3,17.8,67.76,67.76,0,0,1,2.4,9.5c0,.9,1.6,3,3.5,4.7a21.39,21.39,0,0,1,5.6,9c1.7,4.6,3.1,6.7,6,8.8a27.45,27.45,0,0,1,6.6,7.6c1.5,2.7,3.9,5.4,5.4,6s5.2,4.1,8.3,7.6c5.9,6.6,13.7,11.9,16.5,11.1,4-1.2,10.1-1.6,10.1-.7,0,3.4-11,11.8-18.5,14.1a17.08,17.08,0,0,0-5,2.3c-.7.7-.5.8.5.5.8-.3,3.8-1.2,6.5-2.2,5.6-1.9,13.7-7.4,15.9-10.9.8-1.2,1.7-5.6,2.1-9.7s1.3-8.7,2.1-10.2c1.1-2.1,1.4-6.1,1.2-16.6-.3-13.2-.4-14.1-3.3-19.8-1.7-3.3-4.9-9.6-7.2-14.1a70.55,70.55,0,0,1-5.2-13c-2.1-9.7-4.3-14.8-9.6-21.8-8.3-10.9-19.6-35.4-19.6-42.3C1088.5,688.27,1086.4,686.87,1082.4,686.77Z' })),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/athens-ga', onClick: function onClick() {
	              return gaStateClicked('Athens', 'GA', 'see the story for');
	            } },
	          _react2.default.createElement('path', {
	            id: 'US-GA',
	            className: 'paved',
	            fill: '#e6e6e6',
	            'data-paved': true,
	            'data-city': 'Athens',
	            'data-state': 'GA',
	            'data-stat1number': '150',
	            'data-stat1text': t('mapHero.stats.squareYards'),
	            'data-stat2number': '12',
	            'data-stat2text': t('mapHero.stats.crew'),
	            'data-month': tMonthDayDate(i18n, '05/24'),
	            'data-date': '2018',
	            'data-date-text': t('mapHero.stats.datePaved'),
	            'data-tooltip-copy': t('mapHero.tooltip.story'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData,
	            d: 'M1070.6,693.87c-1.4-2.2-1.5-2.2-30.6-2.2h-29.2l-.9-3.2c-.5-1.8-1.4-3.1-2-3s-1.1.1-1.1-.1-.7-4.2-1.6-8.8a76.4,76.4,0,0,1-1.3-15.4c.6-15.2.3-18.4-2.4-22.5-2.4-3.7-3.9-9.9-5.3-22a97.61,97.61,0,0,0-2.9-12.5c-3.8-13.1-5.7-21.4-5-22.5.3-.6,1.6-.9,2.8-.9,2.1.1,15.1-.8,22.7-1.7,1.9-.2,7.4-.7,12.2-1l8.7-.6-.9,3c-.7,2.5-.5,3.4,1.8,5.5a14.11,14.11,0,0,0,4.8,3.1c1.2.4,4.7,3.8,7.9,7.6a87,87,0,0,0,10.8,11c6.1,4.8,15.5,16.4,19.1,23.7,1.4,2.9,3.4,5.4,4.3,5.7s2.6,2,3.6,3.8c2.6,4.5,6.7,8.8,8.4,8.8.9,0,1.2.6.8,1.8-.3,1-2.2,6.2-4.1,11.8-2.4,7-3.5,11.8-3.5,15.8,0,4.2-.3,5.6-1.2,5.1-1.2-.8-10.2-.7-12.9.2-1.3.4-1.5,1.3-.9,4.3a13.36,13.36,0,0,1,0,5.7C1072,696.07,1071.9,696.07,1070.6,693.87Z' }),
	          _react2.default.createElement('path', {
	            fill: '#ffffff',
	            'data-paved': true,
	            'data-city': 'Athens',
	            'data-state': 'GA',
	            'data-stat1number': '150',
	            'data-stat1text': t('mapHero.stats.squareYards'),
	            'data-stat2number': '12',
	            'data-stat2text': t('mapHero.stats.crew'),
	            'data-month': tMonthDayDate(i18n, '05/24'),
	            'data-date': '2018',
	            'data-tooltip-copy': t('mapHero.tooltip.story'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData,
	            d: 'M1035,595.43h-3.37l-.4-1.24a.67.67,0,0,0-.56-.39h-4.32a.55.55,0,0,0-.51.39l-.45,1.24h-3.36a1.94,1.94,0,0,0-2,1.91v8.25a1.89,1.89,0,0,0,1.91,1.91h13a1.89,1.89,0,0,0,1.9-1.91v-8.25A1.93,1.93,0,0,0,1035,595.43Zm-11.91,3.2h-.56a.79.79,0,0,1-.84-.79.86.86,0,0,1,.84-.84h.62a.86.86,0,0,1,.84.84A.87.87,0,0,1,1023.13,598.63Zm5.39,5.67a2.81,2.81,0,1,1,2.81-2.81A2.79,2.79,0,0,1,1028.52,604.3Z' })
	        ),
	        _react2.default.createElement(
	          'g',
	          { id: 'US-HI' },
	          _react2.default.createElement('path', _extends({
	            className: 'not-paved',
	            fill: '#e6e6e6',
	            'data-not-paved': true,
	            'data-city': 'Hawaii',
	            'data-state': 'HI',
	            'data-tooltip-copy': t('mapHero.tooltip.soon'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData
	          }, getPavedPathHawaiiProps(t), {
	            d: 'M208.5,528.93c-1.4.2-3.7.4-5.1.5s-6.1,1.9-10.5,4c-7.4,3.6-8,3.6-10.1.4-1.2-1.9-2.4-7.2-2.7-11.7a45.92,45.92,0,0,0-3.8-15.1c-3.5-7-3.2-10.1,1.4-13.5,1.4-1.1,2.9-4.6,3.2-7.9s1.4-6.4,2.3-6.9c1.9-1,21.6,6.6,22.9,8.9a38.68,38.68,0,0,0,2.5,3.7c.9,1.2,2.5,5.2,3.5,8.9,1.4,5.1,2.7,7.2,5.1,8.1,7.8,3.1,6.9,14.3-1.4,18.2A40,40,0,0,1,208.5,528.93Z' })),
	          _react2.default.createElement('path', _extends({
	            className: 'not-paved',
	            fill: '#e6e6e6',
	            'data-not-paved': true,
	            'data-city': 'Hawaii',
	            'data-state': 'HI',
	            'data-tooltip-copy': t('mapHero.tooltip.soon'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData
	          }, getPavedPathHawaiiProps(t), {
	            d: 'M154.9,455.17a5.14,5.14,0,0,1-5.4-3c-2-4.2.8-14.6,4.1-15.5,3.1-.8,15.2,7.7,15.5,10.9C169.3,450.27,161,454.67,154.9,455.17Z' })),
	          _react2.default.createElement('path', _extends({
	            className: 'not-paved',
	            fill: '#e6e6e6',
	            'data-not-paved': true,
	            'data-city': 'Hawaii',
	            'data-state': 'HI',
	            'data-tooltip-copy': t('mapHero.tooltip.soon'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData
	          }, getPavedPathHawaiiProps(t), {
	            d: 'M131.8,429.93c-7-4.3-8.3-6.6-5.6-10.3,1.7-2.4,2.8-2.5,6-.6a29,29,0,0,1,7.3,7.1c2.9,4.1,3,4.9.7,6C138.7,432.87,134.9,431.87,131.8,429.93Z' })),
	          _react2.default.createElement('path', _extends({
	            className: 'not-paved',
	            fill: '#e6e6e6',
	            'data-not-paved': true,
	            'data-city': 'Hawaii',
	            'data-state': 'HI',
	            'data-tooltip-copy': t('mapHero.tooltip.soon'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData
	          }, getPavedPathHawaiiProps(t), {
	            d: 'M95.4,412.37c-10.8-2.1-12.9-5.1-9.9-13.9,2.6-7.7,4.7-8.8,11.9-6.4,6.1,2.1,11.3,9.9,11,16.7C108.3,413.77,105.9,414.47,95.4,412.37Z' })),
	          _react2.default.createElement('path', _extends({
	            className: 'not-paved',
	            fill: '#e6e6e6',
	            'data-not-paved': true,
	            'data-city': 'Hawaii',
	            'data-state': 'HI',
	            'data-tooltip-copy': t('mapHero.tooltip.soon'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData
	          }, getPavedPathHawaiiProps(t), {
	            d: 'M32.7,369.37c-6,.6-9.3-7.8-6-15.3,3.2-7.2,3.5-7.4,10.3-5.3,6.2,1.9,10.4,8.3,8.4,12.9C43.7,365.17,37.6,368.87,32.7,369.37Z' })),
	          _react2.default.createElement('path', _extends({
	            className: 'not-paved',
	            fill: '#e6e6e6',
	            'data-not-paved': true,
	            'data-city': 'Hawaii',
	            'data-state': 'HI',
	            'data-tooltip-copy': t('mapHero.tooltip.soon'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData
	          }, getPavedPathHawaiiProps(t), {
	            d: 'M2.4,364.87a2.45,2.45,0,0,1-.5-3.4c2-3.3,7.3-4.7,8.5-2.2S5,366.47,2.4,364.87Z' }))
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: 'des-moines-ia', onClick: function onClick() {
	              return gaStateClicked('Des Moines', 'IA', 'see the story for');
	            } },
	          _react2.default.createElement('path', {
	            id: 'US-IA',
	            className: 'paved',
	            fill: '#e6e6e6',
	            'data-paved': true,
	            'data-city': 'Des Moines',
	            'data-state': 'IA',
	            'data-stat1number': '200',
	            'data-stat1text': t('mapHero.stats.potholesFixed'),
	            'data-stat2number': '40',
	            'data-stat2text': t('mapHero.stats.roadsRepaired'),
	            'data-month': tMonthDayDate(i18n, '08/28'),
	            'data-date': '2018',
	            'data-date-text': t('mapHero.stats.datePaved'),
	            'data-tooltip-copy': t('mapHero.tooltip.story'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData,
	            d: 'M858.1,432.67c-1.8-1.8-4.1-2-27.4-2.6l-31.5-.9c-3.3-.2-8.8-.3-12.1-.4l-6.1-.1-2-4.2a37.89,37.89,0,0,1-2.6-10.8c-.6-6.4-1.3-12.3-2.2-18.8a28.53,28.53,0,0,0-2.9-8.1c-2.2-4.3-2.5-6.2-2.6-17.2-.1-6.8-.1-13-.1-13.7.1-1,10.1-1.2,48.3-1l48.2.3.8,3.5c.4,1.9,1.1,6.2,1.4,9.5.7,6.6,3.2,11.2,6.8,12.1a6.05,6.05,0,0,1,3.4,3.3,23,23,0,0,0,3.4,5.4c3.8,4.6,2,16.1-2.9,18.6a28.43,28.43,0,0,1-6,1.6c-4.2.7-4.3.8-4.3,4.9-.3,15.2-.4,15.4-4.8,18.6C860.1,434.57,860,434.57,858.1,432.67Z' }),
	          _react2.default.createElement('path', {
	            fill: '#ffffff',
	            'data-paved': true,
	            'data-city': 'Des Moines',
	            'data-state': 'IA',
	            'data-stat1number': '200',
	            'data-stat1text': t('mapHero.stats.potholesFixed'),
	            'data-stat2number': '40',
	            'data-stat2text': t('mapHero.stats.roadsRepaired'),
	            'data-month': tMonthDayDate(i18n, '08/28'),
	            'data-date': '2018',
	            'data-date-text': t('mapHero.stats.datePaved'),
	            'data-tooltip-copy': t('mapHero.tooltip.story'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData,
	            d: 'M822,390.43h-3.37l-.4-1.24a.67.67,0,0,0-.56-.39h-4.32a.55.55,0,0,0-.51.39l-.45,1.24h-3.36a1.94,1.94,0,0,0-2,1.91v8.25A1.89,1.89,0,0,0,809,402.5h13a1.89,1.89,0,0,0,1.9-1.91v-8.25A1.93,1.93,0,0,0,822,390.43Zm-11.91,3.2h-.56a.79.79,0,0,1-.84-.79.86.86,0,0,1,.84-.84h.62a.86.86,0,0,1,.84.84A.87.87,0,0,1,810.13,393.63Zm5.39,5.67a2.81,2.81,0,1,1,2.81-2.81A2.79,2.79,0,0,1,815.52,399.3Z' })
	        ),
	        _react2.default.createElement('path', {
	          id: 'US-ID',
	          className: 'paved',
	          fill: '#e6e6e6',
	          'data-paved': true,
	          'data-city': 'Rexburg',
	          'data-state': 'ID',
	          'data-stat1number': '$5,000',
	          'data-stat1text': t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2018-10-17'),
	          'data-stat2number': '',
	          'data-stat2text': '',
	          'data-month': '',
	          'data-date': '',
	          'data-date-text': '',
	          'data-tooltip-copy': t('mapHero.tooltip.paved'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData,
	          d: 'M484.17,342.07c-2.2-.7-17.3-5.3-33.5-10.4s-33.8-10.5-39-12.1-14.2-4.4-19.8-6.1c-12-3.6-11.5-1.4-4.9-19.8,2.5-6.9,4.8-14.8,5.2-17.5a13.38,13.38,0,0,1,3.7-8.2c2.9-3,3-3.4,2.4-9-.4-3.2-.7-6.1-.7-6.3-.2-2.1.6-3.2,3.4-4.7,3.5-1.8,8.7-7.2,8.7-9,0-.6,1.8-2.9,4-5l3.9-3.9-1.5-8c-2.4-13.1-1.7-21,2.8-33.8,2.2-6.1,6.8-19.5,10.4-29.6s6.6-18.7,6.9-18.9c.7-.7,12.5,3,12.5,3.9,0,.4-1.1,5.2-2.5,10.6a71.12,71.12,0,0,0-2.5,17.4c0,4.1.1,8.4.1,9.5s1.7,5.1,3.8,9,4.2,8.6,4.6,10.5c.7,3.4,4.1,9.1,5.7,9.8,1.4.6.8,4.6-1.2,7.7a13.28,13.28,0,0,0-2,6.2c0,2.3-.6,3.4-2.1,3.8-2.3.7-3.9,4.2-3.9,8.5,0,2.4.5,3,3.4,3.8a18,18,0,0,0,5.9.5c2.1-.4,2.7,0,3.6,2.9a63.62,63.62,0,0,1,1.7,8.3,28.47,28.47,0,0,0,1,5.5,19.26,19.26,0,0,1,.9,4.1c1.3,7.8,2.5,11.3,4.7,13.6,2,2.1,2.8,2.3,7.8,1.8a35.69,35.69,0,0,1,12.3,1.1c3.7.9,7.5,1.4,8.5,1.1,2.9-.9,4.6.8,4,4-.3,1.6-2.6,11.6-5.2,22.4s-5.7,23.6-6.9,28.5l-2.2,9Z' }),
	        _react2.default.createElement('path', _extends({
	          id: 'US-IL',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'Richton Park',
	          'data-state': 'IL',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.spring'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Richton Park',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-06-05')
	        }), {
	          d: 'M904.6,522.57c-.4-11.3-1.1-12.5-11.4-19.9-7-5.1-7.5-5.7-7-8.5.3-1.7.8-5.3,1.1-8.2.6-5.7-.3-7.4-6.3-10.8-3.1-1.8-5.3-5.1-5.3-7.9,0-.7-2.8-4.4-6.2-8.1-6.6-7.1-7.1-8-8-16l-.6-5,4.8-3.7,4.8-3.7.1-8.8c.1-4.8.3-8.9.4-9a13.06,13.06,0,0,1,2.9-.7c7.7-1.4,11.7-6.7,12.4-16.1.3-4.3-.1-5.6-2.6-9.2a46.51,46.51,0,0,1-3-4.6c0-.3,5.7-.3,12.8-.2s18.7.3,26,.4l13.2.1v2.5a10.64,10.64,0,0,0,1.4,4.8c2.6,4.1,3.2,12,3.4,47.7.1,19.5.5,37.4.8,39.6.5,3.6,0,5-3.9,11.1s-4.5,7.8-5,14.1c-.7,8.5-2.7,13.8-5.6,14.7a5.76,5.76,0,0,0-3.1,2.6c-.8,1.6-2.1,1.9-6.7,1.9-3.8,0-6.2.5-7.5,1.7C904.8,524.87,904.7,524.87,904.6,522.57Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-IN',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'South Bend',
	          'data-state': 'IN',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.fall'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'South Bend',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-06-11')
	        }), {
	          d: 'M932.9,499.87c.3-2.1,2.3-6.6,4.5-10l4-6.3-.4-39.2c-.2-21.6-.5-40-.8-41-.3-1.3.3-1.8,2.3-1.8a6.55,6.55,0,0,0,3.7-1c.6-.6,9.4-1.1,21.9-1.2,17.9-.2,20.9,0,21.1,1.3,1.2,8.1,3.6,73.4,2.8,75.5-.3.8-1.7,1.5-3.2,1.5-3.5,0-3.9.4-9.7,8-6.7,8.9-7.3,9.4-10.8,9.5-1.7.1-5.6,1.6-8.6,3.3-4.9,2.9-6.3,3.2-12.5,3.1-3.8-.1-8.3.3-9.8,1C932.9,504.37,932.4,503.93,932.9,499.87Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-KS',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'McPherson',
	          'data-state': 'KS',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.spring'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'McPherson',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-05-02')
	        }), {
	          d: 'M786.4,523.07c-.1-.1-4.7-.5-10.2-.9s-10.7-.8-11.5-1-5.8-.7-11-1-10.2-.8-11-1-6-.6-11.5-1-10.7-.8-11.5-1-5.8-.6-11-1-10.2-.8-11-1-5.8-.6-11-1-10.2-.9-11-1-6-.6-11.5-1-10.7-.9-11.5-1a45.9,45.9,0,0,0-5.1-.4l-3.6-.1,1.8-12.8c1-7,2-14.8,2.4-17.2s.8-5.6,1-7,.7-4.1.9-6,1-7.1,1.6-11.5,1.3-9.6,1.6-11.5.7-5.2,1-7.4l.6-3.9,6.6.6c6.4.5,21.8,2.2,29.1,3.1l10,1.1c3.6.3,7.6.8,9,1s5.4.6,9,1,7.6.8,9,1,5.9.7,10,1,8.2.8,9,1,4.9.6,9,1,8.4.9,9.4,1.1,5.8.6,10.5,1c7.7.5,8.9.9,11.5,3.5,2.9,2.8,2.9,2.9,1.1,5.6-1.5,2.3-1.6,3.3-.6,6.6.6,2.1,1.8,3.9,2.6,3.9a3.23,3.23,0,0,1,2.4,1.8c1.7,3.2,2.3,30.6,1,43.9l-1.2,12.3-2.9-.2C787.9,523.37,786.5,523.17,786.4,523.07Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-KY',
	          className: 'not-paved',
	          fill: '#e6e6e6',
	          'data-not-paved': true,
	          'data-city': 'Kentucky',
	          'data-state': 'KY',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Lexington',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-06-14')
	        }), {
	          d: 'M907.8,532.47c.1-2.9.7-5.9,1.2-6.5.6-.8,3.3-1.2,6.8-1.2,4.2,0,6.1-.4,6.5-1.5.3-.8,2-2.3,3.8-3.4,2.6-1.5,3.6-3,4.6-7,1.2-4.8,1.5-5.1,5.9-6.5a48.34,48.34,0,0,1,11.8-1.4c6.4,0,7.8-.3,12.3-3.1,3-1.8,6.4-3.1,8.3-3.1,3.5,0,7-3.1,13.7-12,1.9-2.5,3.5-4.7,3.7-4.9a18.09,18.09,0,0,1,4.6-1l4.2-.6.3-4.8.3-4.8,3.4.5a21.13,21.13,0,0,1,7.4,3.4c4.6,3.3,11,4.6,22.1,4.3,6.6-.2,7.8.1,9.5,1.9a6.88,6.88,0,0,1,1.6,5.6c-.3,4,1.8,8.1,8.1,15.5l4.2,4.9-2.4,1.7c-2.8,2-4,3.2-13.6,13.9-6.2,6.9-7.6,8-10.5,8-9.3.1-70,1.7-73.9,1.9-2.5.1-7.8.3-11.8.3-5.9.1-7.4.4-8,1.9-.8,2.1.1,1.9-13.5,2.7l-10.8.7Z' })),
	        _react2.default.createElement('path', {
	          id: 'US-LA',
	          className: 'paved',
	          fill: '#e6e6e6',
	          'data-paved': true,
	          'data-city': 'New Orleans',
	          'data-state': 'LA',
	          'data-stat1number': '$5,000',
	          'data-stat1text': t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2018-11-27'),
	          'data-stat2number': '',
	          'data-stat2text': '',
	          'data-month': '',
	          'data-date': '',
	          'data-date-text': '',
	          'data-tooltip-copy': t('mapHero.tooltip.paved'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData,
	          d: 'M906.17,742.47c-1.7-.5-5.1-1.9-7.8-3-4.3-1.8-5.1-1.8-8-.5-3.6,1.6-6.2,2.3-12.7,3.1-6.1.8-12.3-2-17.7-8.3a33.36,33.36,0,0,0-8.8-7.1l-4.6-2.3-2.2,2c-4.1,3.8-12.7,3.2-20.8-1.3-3.3-1.8-17.9-2.1-19.6-.3-2.2,2.2-2.1.3.2-6.7a69.91,69.91,0,0,0,2.9-11.5c1.1-8,1.6-9.9,3.5-13.2,1.7-3,1.8-3.8.6-9.8a67.14,67.14,0,0,0-4-12.5c-2.5-5.4-2.8-7.3-3.2-20.2l-.4-14.2h30.6c23.8,0,30.6.3,30.6,1.2a40,40,0,0,0,2.1,11.1c1.6,3.8.1,8.6-6.8,21.5-6.4,12.2-7.7,18.7-4.1,20.1,1.2.5,6.5.9,11.7,1.1,8.3.2,17.3.6,24.6.9,1.9.1,2.2.9,2.7,7.8.6,8.6,1.4,9.7,9.5,13.4,3.9,1.8,4.2,2.3,4.2,5.8,0,2.4-.7,4.4-1.8,5.4-3,2.7-2.6,6.3.8,7.7s8,6.4,8,8.6c0,.8-.9,1.4-1.9,1.4a14.31,14.31,0,0,0-3.2.4A9.69,9.69,0,0,1,906.17,742.47Z' }),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/fitchburg-ma', onClick: function onClick() {
	              return gaStateClicked('Fitchburg', 'MA', 'see the story for');
	            } },
	          _react2.default.createElement('path', {
	            id: 'US-MA',
	            className: 'paved',
	            fill: '#e6e6e6',
	            'data-paved': true,
	            'data-city': 'Fitchburg',
	            'data-state': 'MA',
	            'data-stat1number': '60',
	            'data-stat1text': t('mapHero.stats.tonsAsphalt'),
	            'data-stat2number': '56',
	            'data-stat2text': t('mapHero.stats.hoursWorked'),
	            'data-month': tMonthDayDate(i18n, '09/14') + ' - ' + tMonthDayDate(i18n, '10/05'),
	            'data-date': '2018',
	            'data-date-text': t('mapHero.stats.datePaved'),
	            'data-tooltip-copy': t('mapHero.tooltip.story'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData,
	            d: 'M1303.33,339.49a2.81,2.81,0,1,1-2.81-2.81A2.79,2.79,0,0,1,1303.33,339.49Zm38.57,1.61h6.8l-3.4-7Zm19.1-15.2v26.4h-75.9V339.6h-30.8c-.2,1.4.2,2.1,1.2,3.4a22.09,22.09,0,0,0,5.5,4.6c2.1,1.3,3.8,2.6,3.8,2.9,0,1.3,6,3.9,7.5,3.3,2-.8,1.3-5.2-1.2-7.1-1.5-1.1-1.4-1.2.5-1.2,1.2,0,3,1.3,4.3,3.1,2.2,3.1,2.2,3.1.3,5.7-1.1,1.4-4.1,3.3-6.9,4.3a61.27,61.27,0,0,0-8,3.3c-5.2,2.8-6.8,2.2-11-4.3-2.1-3.3-4.4-6-5-6.1s-1.9-.2-2.8-.4c-1.3-.3-21.5,3.6-31.4,5.9-1.9.5-2.1,0-2.3-5.2a81.15,81.15,0,0,0-.7-8.5c-.5-2.6-.4-2.8,3.3-2.8a44.57,44.57,0,0,0,6.3-.5c1.4-.2,7.2-1.2,12.9-2.1,9.9-1.6,10.5-1.8,13.9-5.5,2.7-3,4.2-3.9,6.7-3.9,4.8,0,5.7,1.7,4,7.4-.3,1.1-.5,2-.7,2.7h30.6V325.9Zm-52.06,9.44a1.93,1.93,0,0,0-1.9-1.91h-3.37l-.4-1.24a.67.67,0,0,0-.56-.39h-4.32a.55.55,0,0,0-.51.39l-.45,1.24h-3.36a1.94,1.94,0,0,0-2,1.91v8.25a1.89,1.89,0,0,0,1.91,1.91h13a1.89,1.89,0,0,0,1.9-1.91Zm26.26-2.94h-2l-5.8,11.3-5.8-11.3h-2v13.1h1.5V334.7l5.5,10.8h1.5l5.6-10.8v10.8h1.5Zm17.4,13.1-6.5-13.1h-1.7l-6.5,13.1h1.8l1.5-3.1h8.2l1.5,3.1ZM1295.19,335h-.62a.86.86,0,0,0-.84.84.79.79,0,0,0,.84.79h.56a.87.87,0,0,0,.9-.79A.86.86,0,0,0,1295.19,335Z' })
	        ),
	        _react2.default.createElement('path', _extends({
	          id: 'US-MD',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'Cumberland',
	          'data-state': 'MD',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.spring'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Cumberland',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-05-09')
	        }), {
	          d: 'M1178.8,471.07c-.8-1.8-1.7-2.4-3.1-2.1-3.7,1-7.7-6.2-8-14.3-.1-1.9-.4-5.2-.7-7.3-.4-2.3-.2-4.3.6-5.2a3.06,3.06,0,0,0,.6-3c-.8-2.2-4.2-.3-6.2,3.6-2.1,4.2-1.1,19.7,1.8,25.3l2,3.9-2.3-.7c-1.3-.4-3.6-.9-5.1-1.3-3.8-.8-7.8-4.8-7.8-7.6,0-1.3,1.5-4.1,3.4-6.3l3.4-3.9-2.6-2.7-2.6-2.7-3,2.5c-3.2,2.7-6.4,2.6-8.2-.3a45.42,45.42,0,0,0-4.3-4.9c-2.8-2.8-4-3.3-8-3.3a32.65,32.65,0,0,0-19.1,6.5c-2.8,2-5.4,3.5-5.7,3.2a12.86,12.86,0,0,1-1.1-4c-.6-3.5-.6-3.5,3.8-4,2.4-.3,12.5-2,22.4-3.7,18.6-3.3,18.9-3.3,26.5-4.6,2.5-.4,5.4-.9,6.5-1.1l5.1-.9,3.1-.5,1.7,9.3c1,5.1,2.7,12.1,3.8,15.5l2,6.2h15.8l-.2,4.4a18.83,18.83,0,0,1-.7,4.9,35.21,35.21,0,0,1-6.6,1C1180.17,473.57,1179.9,473.47,1178.8,471.07Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-ME',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'Sanford',
	          'data-state': 'ME',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.spring'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Sanford',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-09-19')
	        }), {
	          d: 'M1248.17,314.17c-3.4-4.4-10.7-27-13.2-40.5a33.73,33.73,0,0,0-1-4.2,2,2,0,0,1,.5-2.3c1.6-1,5.3-11.7,5.8-16.6.2-2.5.9-7,1.4-10s1.2-8.2,1.6-11.4a89.8,89.8,0,0,1,3.2-14l2.6-8.1,6.8-.7c3.7-.4,7.3-1.1,8-1.6a6,6,0,0,1,3.4-.7c1.2.1,2.9.2,3.7.3s3,1.5,4.9,3.1c2.8,2.4,3.4,3.7,3.4,6.8-.1,9.3,7.1,27.3,11.8,29.4,1.4.6,2.5,1.6,2.5,2.2s1.3,2.7,3,4.7c2.2,2.7,4.3,3.9,8,4.8,6.2,1.5,7.8,3.2,6.2,6.3-2.8,5.2-7.8,9.7-12.2,11-3.4,1-6.8,3.5-13.5,9.9-4.9,4.7-11,10.1-13.5,12a61.2,61.2,0,0,0-8.5,8.3c-2.2,2.7-5.7,6.9-7.9,9.4s-4,4.7-4.1,4.8S1249.7,316.07,1248.17,314.17Z' })),
	        _react2.default.createElement('path', {
	          fill: '#e6e6e6',
	          className: 'paved',
	          'data-paved': true,
	          'data-city': 'Hamtramck',
	          'data-state': 'MI',
	          'data-stat1number': '$5,000',
	          'data-stat1text': t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2018-09-05'),
	          'data-stat2number': '',
	          'data-stat2text': '',
	          'data-month': '',
	          'data-date': '',
	          'data-date-text': '',
	          'data-tooltip-copy': t('mapHero.tooltip.paved'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData,
	          d: 'M1026.4,373.27c-2.5,2.5-4.5,5.1-4.5,5.8a9.92,9.92,0,0,1-1.6,3.8c-.9,1.3-1.6,4.5-1.7,7l-.1,4.5-5.6.1a56.84,56.84,0,0,0-7.6.5c-1.8.4-15.4.5-21.5.2-1.4-.1-8.5.2-15.8.6-9.83.9-13.3.7-13.3-.1a5.16,5.16,0,0,1,1.5-2.6,6.41,6.41,0,0,0,1.5-3.9,49.83,49.83,0,0,1,2.1-9c1.8-5.3,1.9-7,1-9.1a22.18,22.18,0,0,1-1.1-7c0-2.4-.4-4.5-.8-4.5s-1.9-2.3-3.2-5.2c-2.8-6-3-15.3-.3-19.4a17.66,17.66,0,0,0,2-7.1c.2-2.5,1.1-5.3,1.9-6.1a6.09,6.09,0,0,0,1.5-3.7,3.8,3.8,0,0,1,2.5-3.4c1.4-.6,2.5-1.6,2.5-2.2,0-2.2,2-.9,2.6,1.7.9,3.8,1.2,4.2,2.9,3.6.8-.3,1.5-1.8,1.5-3.2a8,8,0,0,1,1.4-4.4,6.55,6.55,0,0,0,.9-4.2c-.4-1.9,0-2.5,1.9-2.7s2.4-.9,2.5-4.3c.3-9-.1-8.4,4.5-7.8,2.6.3,4.4.1,4.8-.6.15-.26.49-.29,1-.1v0a15.15,15.15,0,0,1,3.9,2.9c2.3,2.2,5.9,4.5,8.1,5,6.9,1.9,9.6,5.8,10.6,15.5,1,9.5.8,11.2-1.6,14.6a13,13,0,0,0-2.8,7.1c0,.4-.8.8-1.6.8-1,0-1.5,1-1.5,3.4,0,1.9.7,3.9,1.5,4.6,1.8,1.5,2.5,1,10.2-6.4l5.2-5,3.4,3.7c3.3,3.6,5.5,8.8,6.4,15.1a42.77,42.77,0,0,0,1.2,5.5C1034.2,361.57,1031.5,368.27,1026.4,373.27Zm-67-83.67a23.45,23.45,0,0,0,7.1-1.1c1.5-.6,7.5-1.2,13.3-1.4,10-.3,12.7-.6,17.1-2,2.4-.7,2.4-1.7.4-5.6-1.8-3.4-10.8-8.2-13.7-7.3l-.16.07h0a1.66,1.66,0,0,1-2.14-1c-1.6-4.2-13.2-4.5-26.9-.8-13.9,3.9-14.8,3.8-20.5-1.3-2.8-2.5-6.1-4.6-7.3-4.6-3.9-.1-6-.7-6.8-2-1-1.6,1.4-6.3,4.1-8.2,1.1-.8,1.7-1.7,1.2-2-1.5-.9-10.2,4-18.5,10.4-3.4,2.7-12.1,5.9-15.8,5.9a7.08,7.08,0,0,0-4,2c-2,1.9-2,2-.2,5.2,1.5,2.8,2.8,3.5,8.7,5a175.49,175.49,0,0,1,27.1,9.4c4.3,2.1,5.8,3.5,9.4,9.3s4.5,6.7,5.6,5.53a4.33,4.33,0,0,0,1.3-2c0-1.6,7.6-7.5,9.7-7.5,1.4,0,3.2-1.2,4.5-3C954.8,290.1,955.8,289.6,959.4,289.6Zm30.4.87.22-3.81m-.22,3.81v.1' }),
	        _react2.default.createElement('path', _extends({
	          id: 'US-MN',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'Duluth',
	          'data-state': 'MN',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.summer'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Duluth',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-06-05')
	        }), {
	          d: 'M770.3,344.67c.5-13.8,1.4-28.8,2-34.4a27.93,27.93,0,0,0-1.2-11.8c-1.7-5.6-1.7-6,0-8.9,1.5-2.6,1.7-4.6,1.1-15.7-.4-7-.8-14.7-1-17.2s-.7-14.9-1-27.6l-.7-23.1,6.9.4c21.9,1.2,22.5,1.2,23.9-.3a5.47,5.47,0,0,0,1.5-3.4c0-2.2.4-2.3,3-.9,1.3.7,2.1,2.7,2.6,6.7.8,6.7,2.5,8.8,7.9,9.8a14.33,14.33,0,0,1,5.6,2.1c1.1.9,4.5,1.5,10.8,1.6,9,.2,9.4.3,12.9,3.5,2,1.8,4.3,3.3,5.2,3.3s3.5,1.4,6,3.1c4,2.7,5.2,3,11,2.9,6.6-.2,19.1,1.3,22.3,2.6,1.6.7,1.5.9-.8,3.1a8.9,8.9,0,0,1-4.8,2.4c-4.1,0-10.3,3.7-12.6,7.3a16.36,16.36,0,0,1-5.2,5.3c-1.6,1-2.9,2.1-2.9,2.5s-.6.8-1.4.8-2.1,1-2.9,2.3-3.6,3.9-6.1,5.8c-5.2,4-5.6,4.7-6.3,11.4-.3,2.8-.7,5.9-.8,7s-.4,2.2-.4,2.5-1.7,1.4-3.7,2.4c-4,2.2-6.4,6-5.6,9s.7,15.7-.1,18.2c-.6,1.7-.2,2.8,1.5,4.5,6,5.8,20.2,18.4,22.2,19.7s4.5,6.1,4.5,9c0,1-9.6,1.2-46.8.9l-46.8-.3Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-MO',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'St. Claire',
	          'data-state': 'MO',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.spring'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'St. Claire',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-04-12')
	        }), {
	          d: 'M890.7,552.37c-1.4-.6-2.6-1.2-2.8-1.3a24.34,24.34,0,0,1,.6-4.8c1.5-8,3.8-7.6-47.4-7.9l-44.9-.3-.1-2.5c-.7-11.9-.3-20,1.3-27,.6-2.6.5-23.5-.1-32.5-.2-2.8-.4-6-.4-7.2s-1.7-3.8-3.7-5.8c-3.4-3.4-3.5-3.7-2.1-5.9,2.8-4.3,2.4-7-1.5-10.5a14.35,14.35,0,0,1-4.7-7.5c-.6-2.4-1.4-5.1-1.7-5.9-.5-1.3.4-1.5,5.7-1.2,3.5.2,19.6.6,35.8,1s30.3,1.1,31.2,1.6a3.34,3.34,0,0,1,1.6,2.7c-.1,1.9,1,10.3,1.8,14.2.3,1.4,3.2,5.2,6.5,8.5,3.8,3.8,6.3,7.3,7,9.7a13.07,13.07,0,0,0,4.6,6.5c8.3,6.4,7.6,4.9,6.1,13.5-.7,4.3-1.1,8.1-.8,8.6s4.1,3.4,8.3,6.6,8.2,6.5,8.6,7.4a39.53,39.53,0,0,1,1.6,7.6c.8,6.6,1.1,7.5,2.9,7.5q1.2,0,.9,4.2a9.38,9.38,0,0,1-3.5,7.1c-2.4,2.2-3.4,4.1-4.2,8.5C896.1,553.57,895,554.37,890.7,552.37Z' })),
	        _react2.default.createElement('path', {
	          id: 'US-MS',
	          className: 'paved',
	          fill: '#e6e6e6',
	          'data-paved': true,
	          'data-city': 'Jackson',
	          'data-state': 'MS',
	          'data-stat1number': '2',
	          'data-stat1text': t('mapHero.stats.potholesFixed'),
	          'data-stat2number': '12',
	          'data-stat2text': t('mapHero.stats.crew'),
	          'data-month': tMonthDayDate(i18n, '10/30'),
	          'data-date': '2018',
	          'data-date-text': t('mapHero.stats.datePaved'),
	          'data-tooltip-copy': t('mapHero.tooltip.paved'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData,
	          d: 'M902.4,709.27c-3.7-3.1-3.8-3.4-4.2-10.9-.2-4.2-.6-8-.9-8.5s-6.5-1-13.8-1.2-15.1-.5-17.3-.6-5-.3-6.2-.4c-3.6-.2-2.9-5,2.3-14.3a121,121,0,0,0,7-15c2.3-6.3,2.3-6.9.9-9.7-1.1-2.1-1.7-7.2-2.1-16.3-.7-15.7.3-19.8,6.4-27.9,2.5-3.3,4.4-7,4.7-9.4.8-4.9,1.5-6.2,5.2-9.7l2.9-2.8L909,582l21.7-.6v2.8c0,1.6-.4,6.7-.9,11.3s-1.2,11.9-1.6,16-.8,8.6-1,10c-1,7.3-1.8,34.7-1.6,58.8l.2,27.2-2.3.1c-8.6.2-14.3,1.3-15.7,2.9C906.17,712.37,906,712.27,902.4,709.27Z' }),
	        _react2.default.createElement('path', {
	          id: 'US-MT',
	          className: 'paved',
	          fill: '#e6e6e6',
	          'data-paved': true,
	          'data-city': 'Havre',
	          'data-state': 'MT',
	          'data-stat1number': '150+',
	          'data-stat1text': t('mapHero.stats.potholesFixed'),
	          'data-stat2number': '70',
	          'data-stat2text': t('mapHero.stats.tonsAsphalt'),
	          'data-month': tMonthDayDate(i18n, '09/13'),
	          'data-date': '2018',
	          'data-date-text': t('mapHero.stats.datePaved'),
	          'data-tooltip-copy': t('mapHero.tooltip.paved'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData,
	          d: 'M630.6,292.27a14.34,14.34,0,0,0-3.4-.9c-3.2-.6-19.9-4-51.5-10.7-10.7-2.3-27.8-5.8-38-8s-20.5-4.3-23-4.9c-6.6-1.6-6.8-1.5-9,3.6-2,4.7-2.1,4.7-6.5,4.6a38.6,38.6,0,0,1-8-1.3,56.08,56.08,0,0,0-11.1-1.3c-9.4-.1-9.6-.3-12.4-15.8-2.8-15.2-4.1-20-5.4-20.1-.6,0-3.3,0-6,.1-4.9.2-4.9.2-4.2-2.6.6-2.6,3.1-5.3,4.8-5.4.4,0,.8-1.6.8-3.6a12.53,12.53,0,0,1,2-6.3c3-4.3,2.9-9-.3-12.5a25.55,25.55,0,0,1-4.3-8.4,52.39,52.39,0,0,0-4.5-10.3c-4.5-7.3-4.9-17.5-1.3-32.8l2.7-11.74,12.1,3.9c11.3,3.6,58.4,16.7,65.1,18.1,1.7.3,8.2,2,14.5,3.7,9.9,2.6,75,17.5,87.8,20.1a27,27,0,0,1,5,1.3,56.38,56.38,0,0,0,7.2,1.1c3.6.4,6.6.8,6.7,1a37.61,37.61,0,0,1-.7,5.7c-1,5.8-1.6,9.1-2.6,15.3-.3,2.1-.8,4.8-1,6-.4,2-.8,4.1-1.9,11.1-1.8,10.9-9.7,56.5-10.1,58.8S631.9,293.47,630.6,292.27Z' }),
	        _react2.default.createElement('path', {
	          id: 'US-NC',
	          className: 'paved',
	          fill: '#e6e6e6',
	          'data-paved': true,
	          'data-city': 'Kinston',
	          'data-state': 'NC',
	          'data-stat1number': '135',
	          'data-stat1text': t('mapHero.stats.potholesFixed'),
	          'data-stat2number': '30',
	          'data-stat2text': t('mapHero.stats.tonsAsphalt'),
	          'data-month': tMonthDayDate(i18n, '10/09') + ' - ' + tMonthDayDate(i18n, '10/30'),
	          'data-date': '2018',
	          'data-date-text': t('mapHero.stats.datePaved'),
	          'data-tooltip-copy': t('mapHero.tooltip.paved'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData,
	          d: 'M1142.6,591.07a54.34,54.34,0,0,0-6.4-4c-1.7-.8-7.5-5.1-12.9-9.4l-9.9-8-11.3.4c-9.6.4-11.6.2-13.6-1.3-3.8-2.9-5.8-3.3-16.9-3.1s-18.8,1.8-28.2,6c-5.2,2.3-6.2,2.5-20.2,3.5-4.9.3-9.9.9-11,1.1-1.8.4-1.8.3.3-1.3a76.4,76.4,0,0,0,6.5-6.1,42.83,42.83,0,0,1,9.2-6.9,63.29,63.29,0,0,0,10-6.9,77.46,77.46,0,0,1,13-8.3c8.2-4,12.7-7.8,14-11.8,1-3.2,2.9-3.9,12.9-4.7,4.9-.4,9.8-.9,11-1s4.8-.6,8-1,6.8-.8,8-1,10.7-1.5,21.1-2.9,19.9-2.7,21-2.9,4.1-.7,6.6-1c7.1-1,20.7-3.5,27.5-5.1,1.7-.4,2.4.2,3.4,2.6,1.2,2.9,1.1,3.2-1.4,5.4l-2.7,2.3,4.9.7c3.7.5,5.6,1.4,7.5,3.6,3.4,3.8,3.3,5.1-.9,9.6-1.9,2.1-3.8,4.6-4.1,5.6-.5,1.5-4.9,2.4-9.5,1.9-.3,0-.5,1.9-.5,4.4l.1,4.4h3.8c4.3,0,4.6.9,1.5,4.6-4.5,5.3-6.1,6.4-9.6,6.4-3.1,0-4.5,1-11.3,8.1s-7.8,8.6-7.8,11.8-.4,3.8-4,5.4a30.5,30.5,0,0,1-4.3,1.7C1146.17,593.87,1144.5,592.47,1142.6,591.07Z' }),
	        _react2.default.createElement('path', {
	          id: 'US-ND',
	          className: 'paved',
	          fill: '#e6e6e6',
	          'data-state': 'ND',
	          'data-paved': true,
	          'data-city': 'Grand Forks',
	          'data-stat1number': '248',
	          'data-stat1text': t('mapHero.stats.potholesFixed'),
	          'data-stat2number': '',
	          'data-stat2text': '',
	          'data-month': tMonthDayDate(i18n, '09/17') + ' - ' + tMonthDayDate(i18n, '09/21'),
	          'data-date': '2018',
	          'data-date-text': t('mapHero.stats.datePaved'),
	          'data-tooltip-copy': t('mapHero.tooltip.paved'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData,
	          d: 'M762.5,285.17c-.1-.1-3-.5-6.3-.9s-7.1-.8-8.5-1.1-4.5-.7-7-1-6.1-.8-8-1c-5.6-.7-10.1-1.3-16-2-3-.4-6.6-.8-8-1.1s-11.5-1.5-22.5-2.9-21.3-2.7-23-3c-4.2-.7-9-1.3-16.1-2.1l-6.1-.7,2.7-16.1c1.5-8.9,3-17.6,3.3-19.4s.8-4.5,1-6,1.6-9.6,3-17.9,2.5-15.5,2.5-15.9c0-.6,12.9,0,17.7.9,1,.2,4.9.6,8.8,1s8.1.8,9.5,1,5.2.6,8.5,1,7.6.8,9.5,1.1c6.2.8,29.4,3.5,34.5,4l8.5.9c1.9.2,6,.7,9,1.1s5.8,1.1,6.1,1.6.7,8.2.8,17.2.4,17.8.6,19.7c.3,3,1.5,27.7,1.9,38,.1,3.3-.1,3.5-3.1,3.6A10.74,10.74,0,0,1,762.5,285.17Z' }),
	        _react2.default.createElement('path', _extends({
	          id: 'US-NE',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'Bellevue',
	          'data-state': 'NE',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.summer'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Bellevue',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-05-20')
	        }), {
	          d: 'M772.17,442.47c-3.8-.4-9.7-1-13-1.3s-12.1-1.3-19.5-2.1l-18.5-2c-2.7-.3-6.6-.7-8.5-.9-4.5-.6-9.9-1.2-23-2.5-5.8-.6-11.6-1.3-13-1.5-2.1-.3-16.5-1.8-19.5-2-1.4-.1-1-8.3,1.1-21,.8-5.1,2.3-4.7-31.6-10.1-1.4-.2-3.6-.6-5.1-.9l-2.6-.5,4-23.7c2.2-13,4.1-23.9,4.3-24.1s23.4,2.5,36.9,4.4c1.7.2,8.8,1.1,16,2s14.1,1.8,15.5,2,4.9.7,7.9,1,6.1.8,7,1,4.5.6,8.1,1c9.8,1,13.3,2.2,16.5,5.6,2.9,3,3.1,3.1,9.8,2.5,5.7-.5,7.5-.3,11,1.6a44.7,44.7,0,0,0,6.7,2.8c2.1.6,2.5,1.3,2.6,4.7a28.12,28.12,0,0,0,2.7,9.1,41.74,41.74,0,0,1,3.3,11.4c.4,3.5.8,7,1,7.8s.6,4.7,1,8.5a36.83,36.83,0,0,0,3.3,12c1.9,3.8,6,14.5,6.1,16.2C782.7,443.57,782.6,443.57,772.17,442.47Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-NH',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'Berlin',
	          'data-state': 'NH',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.fall'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Berlin',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-06-27')
	        }), {
	          d: 'M1223.9,334.93c-1.2-.2-2.3-.7-2.3-1.1s-.3-8.7-.6-18.5l-.5-17.8,3.6-4c2.6-2.8,3.4-4.6,3.1-6.2-2.4-10.8-2.4-11-.4-13.9,3.1-4.3,4.3-3.8,5.2,2.2.7,4.1,3.4,13.9,7.3,26.6,2.6,8.3,6.8,15.7,10,17.7.7.4,1.3,2,1.3,3.4,0,1.9-.4,2.4-1.6,1.9s-3.1.9-6.1,3.8c-3.6,3.6-5.5,4.6-9.2,5.1-2.5.3-5.3.7-6.1.9A11.49,11.49,0,0,1,1223.9,334.93Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-NJ',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'Berkeley Heights',
	          'data-state': 'NJ',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.spring'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Berkeley Heights',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsedVague') + ' ' + t('mapHero.stats.spring') + ' 2019'
	        }), {
	          d: 'M1187.9,443.57c-5.5-2.7-7.2-5.4-7.1-11a26,26,0,0,0-.2-5.5c-.2-.6,2-3.6,4.9-6.7s5.2-6,5.2-6.5-1.8-2.4-4-4.2c-5-3.9-6.5-6.6-5-8.5,1.1-1.4,1.4-2.6,2.4-10.5.3-2.4.9-4.8,1.4-5.3,1.2-1.2,15.4,3.9,17.4,6.3,1.2,1.5,1.5,2.7.8,4.3-1,2.6,0,8.5,2.3,13.9a15,15,0,0,1,1.2,6.5c-.2,1.5-.6,4.1-.9,5.7-.7,5-8.3,20-11,21.8C1192.17,446.07,1193,446.07,1187.9,443.57Z' })),
	        _react2.default.createElement('path', {
	          id: 'US-NM',
	          className: 'paved',
	          fill: '#e6e6e6',
	          'data-paved': true,
	          'data-city': 'Albuquerque',
	          'data-state': 'NM',
	          'data-stat1number': '$5,000',
	          'data-stat1text': t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2018-10-18'),
	          'data-stat2number': '',
	          'data-stat2text': '',
	          'data-month': '',
	          'data-date': '',
	          'data-date-text': '',
	          'data-tooltip-copy': t('mapHero.tooltip.paved'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData,
	          d: 'M590.17,635.57c-5.5-1-11.6-2.1-13.5-2.4-5.2-.8-26-4.5-30-5.2a101.51,101.51,0,0,0-13.5-.7l-8.7-.4-1.3,6.06c-.4,3.2-1,.2-8.5,0-4.2-.1-8.4-1.7-12-2a89.85,89.85,0,0,1-9.8-1.5c-4.4-1.1-7.1-4.3-8.4,0-1.2,3.9-.7,10.3-5,10.3-5.7,0-13.5-2.3-11.9-6.6.5-1.3,6.7-31.6,12.2-54.9,1.7-7.2,3.2-14.1,3.5-15.4s1.1-5.3,2-9,1.7-7.5,2-8.6,3.3-14.6,6.8-30l6.4-28,2.9.1a53.06,53.06,0,0,1,6.4.7c11.7,2.1,56.8,10.8,58,11.2a41.86,41.86,0,0,0,5,.9c4.6.7,39.2,7.3,45.3,8.7,4.6,1,4.8,1.2,4.3,4.2-.3,1.7-.7,4.3-.9,5.6s-.7,4.1-1,6c-.9,5.3-1.5,8.8-2.6,16-1.3,7.9-1.7,10.6-2.4,14.5-.3,1.7-3.2,19.4-6.5,39.5-7.5,45.6-7,43-7.8,42.8C600.5,637.47,595.7,636.57,590.17,635.57Z' }),
	        _react2.default.createElement('path', _extends({
	          id: 'US-NV',
	          className: 'not-paved',
	          fill: '#e6e6e6',
	          'data-not-paved': true,
	          'data-city': 'Nevada',
	          'data-state': 'NV',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Carson City',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-05-14')
	        }), {
	          d: 'M367.9,494.37c-1.8-3.4-5.4-10.3-8-15.2s-8.1-15.3-12.1-23-7.7-14.4-8.1-15-3.5-6.4-7-13-7.6-14.5-9.3-17.5-5-9.3-7.5-14-6.3-11.9-8.5-16c-6.8-12.7-7.2-9.8,6.8-49.4,6.8-19.3,12.8-35.4,13.3-35.9.9-.9,9.9,2,37.6,12.3,7.7,2.9,21.2,7.4,30,10.2s20.9,6.5,26.9,8.4,11,3.5,11.2,3.7-32.7,114.8-35.5,123.3a47.65,47.65,0,0,0-1.4,5.5,72.7,72.7,0,0,1-3.3,10c-3.1,8-2.7,7.7-9.9,6.7-5.7-.8-10.2,7.5-10.4,18.8C372.6,501.07,371.4,501.07,367.9,494.37Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-NY',
	          className: 'not-paved',
	          fill: '#e6e6e6',
	          'data-not-paved': true,
	          'data-city': 'New York',
	          'data-state': 'NY',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Lockport',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-08-23')
	        }), {
	          d: 'M1207.4,399.27a11.86,11.86,0,0,1,.1-4.2c.8-4.9-2.7-7.7-14-11.4-10.1-3.3-11.1-4-19.6-13.9l-3.8-4.4-16.93,2.56c-9.3,1.4-18.1,2.8-19.4,3.1s-11.5,1.8-22.5,3.5-20.7,3.3-21.6,3.6c-1.1.3-1.8-.3-2.2-1.7-.6-2.2,2.3-6.2,11.1-15.5,1.8-1.9,3.2-3.9,3.2-4.5a29.45,29.45,0,0,0-2.5-5.9c-3-5.8-3.1-7-.8-7a6.69,6.69,0,0,0,3.6-1.4c1.3-1,5.7-1.4,15.8-1.5,15.2-.2,16.9-.5,21.7-4.6,5.1-4.3,6.4-8.4,4.7-15.4l-1.4-5.8,5.8-6.8c3.2-3.7,6.8-8.2,8-9.9a52.46,52.46,0,0,1,7.5-7.4l5.3-4.2,8.3.2c4.6.1,9.3-.1,10.5-.5,1.8-.6,2.3-.2,3.2,2.6,1.6,5.1,2.3,9.7,2.5,17.4.2,6,.6,7.5,2.8,10.2,5.1,6,9.4,28.4,8.6,44.5-.3,7.1-.1,11.7.9,14.8a34.73,34.73,0,0,1,1.4,7.2c0,1.5.4,2.8,1,2.8s.6.9,0,2.5-.6,2.7,0,3.1,1,.2,1-.3c0-1.3,4.8-3.4,9-3.9a18.14,18.14,0,0,0,6.5-2.7c4.4-3.3,9.7-4.9,10.6-3.3.5.8-.2,2.2-1.9,3.7-1.5,1.3-4.3,3.9-6.3,5.8C1223.5,394.17,1208,401.07,1207.4,399.27Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-OH',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'Toledo',
	          'data-state': 'OH',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.spring'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Toledo',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsedVague') + ' ' + tMonthDayDate(i18n, '06/25') + '-' + tShortDate(i18n, '2019-06-28')
	        }), {
	          d: 'M1039.17,477.17c-1.9-2.2-2.4-2.3-10.1-1.8-10.1.7-18-.9-21.6-4.4a12.63,12.63,0,0,0-7.3-3.1c-4.5-.5-4.6-.6-4.6-4.1,0-2-.2-7.2-.5-11.6s-.6-13.5-.9-20.2-.8-16.7-1.1-22.2c-.5-8.1-.3-10.1.8-10.2.7-.1,2.5-.2,3.9-.4s7-.6,12.5-1,10.2-.8,10.5-.8a57.82,57.82,0,0,1,6.4,2.7c6.3,3,11.8,3.5,14.5,1.2a30.07,30.07,0,0,1,6.2-3,27.22,27.22,0,0,0,6.5-3.4c6.5-5.9,16.3-12.1,16.5-10.5a265.62,265.62,0,0,1-.5,54.3,61.45,61.45,0,0,1-2.1,6.8c-1.6,4.3-2.7,5.8-6.2,7.8-4.9,2.9-7.7,6.4-8.7,11-.5,2.5-1.3,3.3-3.6,3.8-2.1.5-3.1,1.4-3.5,3.3-.7,3.5-2.7,7.4-4,7.8C1041.6,479.47,1040.3,478.47,1039.17,477.17Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-OK',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'Durant',
	          'data-state': 'OK',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.spring'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Durant',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-05-13')
	        }), {
	          d: 'M785.1,609.57c-4.3-2.3-8.4-3.8-10.5-3.8-1.9,0-10.6.3-19.4.6-13.5.5-16.7.3-20.5-1.1a55.39,55.39,0,0,0-8-2.2c-2.1-.3-5.2-2.1-7.8-4.3-3.3-2.9-5.5-4-9-4.4-9.4-1.1-13.6-2.6-16.3-5.5-1.6-1.7-5-3.6-8.3-4.7l-5.7-1.8.6-5c.3-2.8.8-8.2,1.1-12s.8-8.6,1-10.5.7-7.1,1-11.5.8-9.2,1.1-10.7c.6-3-.1-3.6-4.7-4.3-5.4-.8-33.6-4.5-43.4-5.7-12.5-1.5-11.9-1.1-11.1-6.6a45.83,45.83,0,0,1,.9-4.9,45.06,45.06,0,0,1,7.2,1.1c3.8.7,10.6,1.6,15,2s10,.8,12.5,1.1,7.4.7,11,1,8.5.8,11,1,7.4.7,11,1,8.5.8,11,1,7.9.7,12,1,9.1.8,11,1,6.9.7,11,1,9.1.8,11,1,7.3.7,12,1,9.6.8,11,1,6.3.7,11,1,8.6.7,8.6.8c.5.6,1.5,29.7,1.4,40.6-.3,26.6-.7,45.1-1.1,45.4C792.4,613.27,789,611.67,785.1,609.57Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-OR',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'Coos Bay',
	          'data-state': 'OR',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.spring'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Coos Bay',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-05-13')
	        }), {
	          d: 'M351.17,299.07c-14.3-5.2-30.7-11.2-36.5-13.4-15.9-5.9-55.3-20.2-63-22.8a40.72,40.72,0,0,1-4.8-1.8,11.12,11.12,0,0,1,.7-3.6,40.46,40.46,0,0,0,1.5-7.4c1.1-9.7,3.4-14.7,10.4-22.4a108.64,108.64,0,0,0,11-14.5c4.8-7.9,24.1-46.9,24.1-48.6,0-.7.7-.8,1.8-.4s3.2,1.1,4.9,1.6c3.1.9,8.2,5.8,8.5,8.2.1.6.3,1.6.4,2.2a35.53,35.53,0,0,1,.3,4.6c.2,5.1,2.8,7.4,10.3,8.9a97,97,0,0,1,14.9,5c4.7,2.1,10.5,4.1,13,4.5s5.2.9,6,1,6,.6,11.4,1c11.4.8,14.4,1.6,32,7.9,7.1,2.5,13,4.6,13.1,4.6s.2.6.3,1.2.7,4.1,1.3,7.5l1.2,6.2-3.6,4c-2,2.2-3.6,4.4-3.6,4.9,0,1.6-5.4,6.9-8.6,8.5-3.7,1.9-4.6,4.5-3.6,11.2s1,6.7-2.2,9.8c-2.2,2.1-3,3.8-3.3,7.4-.4,4.5-10.2,34.3-11.3,34.2C377.4,308.57,365.5,304.37,351.17,299.07Z' })),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/wilkes-barre-pa', onClick: function onClick() {
	              return gaStateClicked('Wilkes-Barre', 'PA', 'see the story for');
	            } },
	          _react2.default.createElement('path', {
	            id: 'US-PA',
	            className: 'paved',
	            fill: '#e6e6e6',
	            'data-paved': true,
	            'data-city': 'Wilkes-Barre',
	            'data-state': 'PA',
	            'data-stat1number': '3,200',
	            'data-stat1text': t('mapHero.stats.squareFeet'),
	            'data-stat2number': '4',
	            'data-stat2text': t('mapHero.stats.crew'),
	            'data-month': tMonthDayDate(i18n, '08/28'),
	            'data-date': '2018',
	            'data-date-text': t('mapHero.stats.datePaved'),
	            'data-tooltip-copy': t('mapHero.tooltip.story'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData,
	            d: 'M1080.9,439.93a63.16,63.16,0,0,1-2.3-9.3c-1.5-8.4-1.6-8.9-1.9-9.2-.5-.4-.7-4-1.5-18.2-.4-7.7-.8-15.6-1-17.5-.2-2.9.2-3.8,2.3-5.2,1.4-.9,3.6-2.4,4.9-3.3,2.2-1.6,2.3-1.6,2.9,1.6l.6,3.2,5.5-.7c3-.4,6.4-.8,7.6-1.1s5.1-.8,8.6-1.4,8.3-1.3,10.5-1.7,14.7-2.3,27.8-4.4l23.8-3.7,3.5,3.8c1.9,2.1,3.5,4.3,3.5,4.8s1.6,2,3.5,3.3,3.3,2.6,3.1,2.8c-.5.5-1.3,4.4-2.2,11.2-.4,2.6-1,5-1.5,5.3-2.3,1.4-.7,5.9,3.6,9.8l4.5,4.1-6,6.1c-3.3,3.4-7.2,6.6-8.7,7.2s-8.6,2-15.7,3.2-13.9,2.3-15,2.5-10.1,1.7-20,3.4c-23.4,4-21.8,3.8-31.2,4.5C1082.8,441.77,1081.7,441.57,1080.9,439.93Z' }),
	          _react2.default.createElement('path', {
	            fill: '#ffffff',
	            'data-paved': true,
	            'data-city': 'Wilkes-Barre',
	            'data-state': 'PA',
	            'data-stat1number': '3,200',
	            'data-stat1text': t('mapHero.stats.squareFeet'),
	            'data-stat2number': '4',
	            'data-stat2text': t('mapHero.stats.crew'),
	            'data-month': tMonthDayDate(i18n, '08/28'),
	            'data-date': '2018',
	            'data-date-text': t('mapHero.stats.datePaved'),
	            'data-tooltip-copy': t('mapHero.tooltip.story'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData,
	            d: 'M1168,379.43h-3.37l-.4-1.24a.67.67,0,0,0-.56-.39h-4.32a.55.55,0,0,0-.51.39l-.45,1.24h-3.36a1.94,1.94,0,0,0-2,1.91v8.25a1.89,1.89,0,0,0,1.91,1.91h13a1.89,1.89,0,0,0,1.9-1.91v-8.25A1.93,1.93,0,0,0,1168,379.43Zm-11.91,3.2h-.56a.79.79,0,0,1-.84-.79.86.86,0,0,1,.84-.84h.62a.86.86,0,0,1,.84.84A.87.87,0,0,1,1156.13,382.63Zm5.39,5.67a2.81,2.81,0,1,1,2.81-2.81A2.79,2.79,0,0,1,1161.52,388.3Z' })
	        ),
	        _react2.default.createElement('path', _extends({
	          id: 'US-RI',
	          className: 'not-paved',
	          fill: '#e6e6e6',
	          'data-not-paved': true,
	          'data-city': 'Rhode Island',
	          'data-state': 'RI',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Woonsocket',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-10-22')
	        }), {
	          d: 'M1239.4,365.87c-1-3.7-2-7.8-2.3-9-.5-2.1-.3-2.2,3.4-2.2s4.2.4,7.3,5.1c2.5,3.9,3,5.5,2.3,6.8-1,1.6-7.1,6.1-8.3,6.1C1241.4,372.67,1240.4,369.67,1239.4,365.87Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-SC',
	          className: 'not-paved',
	          fill: '#e6e6e6',
	          'data-not-paved': true,
	          'data-city': 'South Carolina',
	          'data-state': 'SC',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Simpsonville',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsedVague') + ' ' + t('mapHero.stats.between') + ' ' + t('months.april') + ' - ' + t('months.june') + ' 2019'
	        }), {
	          d: 'M1094.6,646.07c-1.4-.7-3.6-3.4-5-5.9s-2.7-4.6-3-4.6c-1.4,0-5.9-5.4-5.9-7.1,0-1-1.7-3.8-3.8-6.3s-5.1-6.3-6.7-8.4a61.6,61.6,0,0,0-8.5-8.2,71.5,71.5,0,0,1-10.5-10.8c-2.8-3.5-6.6-7.2-8.6-8.2-4.7-2.4-6-4.1-5.3-6.8.6-2.4,5.4-4.9,16.9-8.7,12.1-4,33.4-3,33.4,1.6,0,.7,4.2,1,12.4.8,9.7-.2,12.8,0,14.2,1.2,1,.8,2.5,2,3.4,2.6s4.2,3.4,7.5,6.1a75.34,75.34,0,0,0,10.5,7.2,47.81,47.81,0,0,1,4.9,2.6c.2.2-1.4,2.5-3.6,5.1-4.9,5.8-5.9,7.6-6.8,12.8a13.74,13.74,0,0,1-4.4,7.5c-2,1.9-5.5,5.7-7.7,8.3s-7.8,8.3-12.5,12.6C1097.5,647.07,1097,647.37,1094.6,646.07Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-SD',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'Rapid City',
	          'data-state': 'SD',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.spring'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Rapid City',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-05-14')
	        }), {
	          d: 'M757.3,368.07c-4.1-2.1-5.9-2.5-11-2.1-5.7.4-6.4.2-10.2-2.9-4.2-3.4-7.4-4.2-22.4-5.9-3-.3-6.2-.8-7-1s-4.2-.7-7.5-1-7.1-.8-8.5-1-4.5-.6-7-.9-6.3-.8-8.5-1.1-8.9-1.2-15-2-13.7-1.8-17-2.2c-13.8-1.6-15-1.9-14.8-4s5.9-36,6.8-40.4c.3-1.4.7-4.1,1-6s1.3-8.3,2.3-14c1.7-10,1.9-10.5,4.2-10.4,2.7.1,15,1.4,17.8,1.9,2.5.4,10,1.4,15.7,2.1,2.8.3,6.1.8,7.5,1s5.2.7,8.5,1,6.7.8,7.5,1,7.3,1.1,14.5,2c13.2,1.6,39.5,5.1,45,5.9,1.7.2,4.3.5,5.8.5,2.4.1,2.7.3,1.8,2-.8,1.4-.5,3.6,1,8.2,1.3,4.2,1.8,7.7,1.5,10.3-.9,6.4-1.5,15.1-2,28.9-.3,7.1-.9,13.2-1.4,13.5s-.9,4.8-.8,9.8C765.3,372.07,765.17,372.17,757.3,368.07Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-TN',
	          className: 'not-paved',
	          fill: '#e6e6e6',
	          'data-not-paved': true,
	          'data-city': 'Tennessee',
	          'data-state': 'TN',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Chattanooga',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsedVague') + ' ' + t('months.december') + ' 2019'
	        }), {
	          d: 'M888.7,578.37c0-2.8,2.2-8.6,4.8-12.7,3.6-5.7,6.2-12.2,6.9-17.4.6-4.7,2.4-7,5.6-7.2,1.2-.1,7.9-.5,14.8-.9,10.4-.6,12.7-1,14-2.6s3.8-1.9,26.5-2.5c66.5-1.6,81.5-2.1,94.8-3.2,3.7-.3,6.8-.3,6.8.1,0,1.4-2.4,5-4.4,6.7a63.38,63.38,0,0,1-9.4,5.2,72.91,72.91,0,0,0-13,8.4c-3.2,2.7-7.8,5.9-10.3,6.9a22.11,22.11,0,0,0-7.5,5.6,36.38,36.38,0,0,1-8,6.8,46.29,46.29,0,0,0-5.5,3.9c-1.1,1.4-12.3,1.9-59,2.4-26.7.3-50.4.8-52.8,1C890.1,579.47,888.7,579.17,888.7,578.37Z' })),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/bartonville-tx', onClick: function onClick() {
	              return gaStateClicked('Bartonville', 'TX', 'see the story for');
	            } },
	          _react2.default.createElement('path', {
	            id: 'TX-north',
	            className: 'paved',
	            fill: '#e6e6e6',
	            'data-paved': true,
	            'data-city': 'Bartonville',
	            'data-state': 'TX',
	            'data-stat1number': '8',
	            'data-stat1text': t('mapHero.stats.potholesFixed'),
	            'data-stat2number': '3',
	            'data-stat2text': t('mapHero.stats.roadsRepaired'),
	            'data-month': tMonthDayDate(i18n, '12/12'),
	            'data-date': '2017',
	            'data-date-text': t('mapHero.stats.datePaved'),
	            'data-tooltip-copy': t('mapHero.tooltip.story'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData,
	            d: 'M604.36,641.54c0-.11.38-1.66.44-2.11.22-1.56.78-4.89,1.4-8.53.8-4.7,1.7-9.8,1.9-11.5s2.5-15.6,5-31,4.8-29.5,5.1-31.4.7-4.3.9-5.5.6-3.7.9-5.7.7-4.7,1-6,.7-4.2,1.1-6.5.8-4.7.9-5.5a11.71,11.71,0,0,0,.4-2.6c.1-.8,2.6-.7,8.6.2,4.7.7,11.3,1.5,14.8,1.9s6.9.8,7.7,1,4,.7,7,1,8.2,1,11.5,1.5,6.4.9,6.9.9.6,3.5.2,7.8c-1.3,16.4-3.6,40.8-4,42.5-.5,2.2.8,3.2,7.4,5.3,3.3,1.1,6.4,2.8,7.7,4.5,2.3,2.9,8.1,4.9,16.1,5.6,4.8.4,10,3.2,11.9,6.4a4.88,4.88,0,0,0,4,2.1,29.12,29.12,0,0,1,8.2,2.1c5,1.9,7.2,2.1,26,1.8,22.5-.3,21.9-.4,31.8,6.4a35.56,35.56,0,0,0,7.8,3.9l3.4.9v43.6l.23.51' }),
	          _react2.default.createElement('path', {
	            fill: '#ffffff',
	            'data-paved': true,
	            'data-city': 'Bartonville',
	            'data-state': 'TX',
	            'data-stat1number': '8',
	            'data-stat1text': t('mapHero.stats.potholesFixed'),
	            'data-stat2number': '3',
	            'data-stat2text': t('mapHero.stats.roadsRepaired'),
	            'data-month': tMonthDayDate(i18n, '12/12'),
	            'data-date': '2017',
	            'data-date-text': t('mapHero.stats.datePaved'),
	            'data-tooltip-copy': t('mapHero.tooltip.story'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData,
	            d: 'M748,622.43h-3.37l-.4-1.24a.67.67,0,0,0-.56-.39h-4.32a.55.55,0,0,0-.51.39l-.45,1.24h-3.36a1.94,1.94,0,0,0-2,1.91v8.25A1.89,1.89,0,0,0,735,634.5h13a1.89,1.89,0,0,0,1.9-1.91v-8.25A1.93,1.93,0,0,0,748,622.43Zm-11.91,3.2h-.56a.79.79,0,0,1-.84-.79.86.86,0,0,1,.84-.84h.62a.86.86,0,0,1,.84.84A.87.87,0,0,1,736.13,625.63Zm5.39,5.67a2.81,2.81,0,1,1,2.81-2.81A2.79,2.79,0,0,1,741.52,631.3Z' })
	        ),
	        _react2.default.createElement('path', {
	          id: 'TX-south',
	          className: 'paved',
	          fill: '#e6e6e6',
	          'data-paved': true,
	          'data-city': 'Marion',
	          'data-state': 'TX',
	          'data-stat1number': '6',
	          'data-stat1text': t('mapHero.stats.potholesFixed'),
	          'data-stat2number': '9',
	          'data-stat2text': t('mapHero.stats.roadsRepaired'),
	          'data-month': tMonthDayDate(i18n, '10/31') + ' - ' + tMonthDayDate(i18n, '11/01'),
	          'data-date': '2018',
	          'data-date-text': t('mapHero.stats.datePaved'),
	          'data-tooltip-copy': t('mapHero.tooltip.paved'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData,
	          d: 'M800.4,664.57l2.9,6.4a69.78,69.78,0,0,1,4.1,12.5c1.1,5.5,1,6.5-.8,10a36.43,36.43,0,0,0-2.7,10.4,61,61,0,0,1-2.5,11.5c-1,2.8-2.1,6.5-2.5,8.3-.5,2.5-1.2,3.2-3,3.2-3.9,0-9.3,2.8-13.1,6.9s-14.2,10.4-26.5,16.1c-6.7,3.1-12.6,6.4-14,8-.3.3-2.8,2.3-5.5,4.5-6.3,4.9-9.4,8.3-15.2,16.8-4.5,6.5-4.6,6.9-4.4,13.5a51.17,51.17,0,0,0,1.1,9.8c1.1,3.4-.7,14.6-1.4,16.6-.4,1.7.7,5.8-5.1,1.6-4.5-3.3-6.2-4-10.3-4-3.8,0-6-.7-10.1-3.4a48.06,48.06,0,0,0-9.2-4.7,13.45,13.45,0,0,1-5.3-3c-.85-1.08-1.75-2.11-2.7-3.1-1.3-1.3-4-10-3.1-10.3.2-.1.2,1.4-.6-4.3-.4-3.2-1.1-.8-1.7-8.2s-3.8-9.2-7.5-15.4c-6.6-11.1-11.4-25.6-12.2-29.5-1-5.4-6.1-13.9-11.6-17.7-1.9-1.3-.3-2.4-1.3-4.4-1.5-3-6.3-5.8-9.3-6.3-2.1-.4-6.2-1.2-9.3-1.9-8.3-1.8-14.7-.2-17.1,4.4-1,1.9-3.2,2.4-3.2,3s-2.8,3.8-4.7,5.8c-2.6,2.8-1.5,4.2-4.1,4.2-4.8-.1-5.8-.7-13.4-7.4-10.1-9-13.9-16.1-14.2-21.6-.1-2.4-2.1-13.6-3.1-16.2s-7.4-7.5-8.5-8.7c-1.7-2,3.7,1.4-5.2-7.5a19.47,19.47,0,0,1-4.1-6.4,15.29,15.29,0,0,0-4.6-5c-1-.5-1.4-3.8-2-5.6a15.69,15.69,0,0,0-3.3-5.5c-1.6-1.7-4.4-3.4-4.1-5,.3-2.3.8-2.4,6.5-2.5a134.85,134.85,0,0,1,16.4,1.7c10.9,1.9,14.6,2.5,20.5,3.4,2.1.3,5.6,1,7.8,1.4s6.2,1.2,9,1.5a28.85,28.85,0,0,1,5.6,1c1.4.9,12.9,1.6,12.9.8' }),
	        _react2.default.createElement('path', _extends({
	          id: 'US-UT',
	          className: 'not-paved',
	          fill: '#e6e6e6',
	          'data-not-paved': true,
	          'data-city': 'Utah',
	          'data-state': 'UT',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Ogden',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsedVague') + ' ' + tShortDate(i18n, '2019-07-19') + '-' + tShortDate(i18n, '2019-07-30')
	        }), {
	          d: 'M437.6,331.27c-.8,0-1.1.4-1.3,1.2s-2.5,8.6-5,17.2-6.2,21.1-8.2,28-5.2,17.9-7.1,24.5-5.1,17.4-7,24-3.9,13.3-4.4,15-1.7,6.2-2.8,10a62,62,0,0,0-1.8,7.1c.1.1,21.8,5.5,48.2,12.2,47.2,11.8,50.5,12.6,50.5,11.9,0-.2,3.2-14.5,7.1-31.8s7.3-32.5,7.6-33.9,1.8-8.5,3.5-15.8,3.2-14.5,3.5-15.9a23.68,23.68,0,0,1,.9-3.3c.2-.4-1.5-1-3.8-1.4-8.2-1.4-34.6-7.3-35.8-8a2,2,0,0,1-.6-2.2c.8-2.2,5.8-20.7,6-22.2.1-1.1-16.7-6.9-47.6-16.2A5.66,5.66,0,0,0,437.6,331.27Z' })),
	        _react2.default.createElement(
	          'g',
	          { id: 'US-VA' },
	          _react2.default.createElement('path', _extends({
	            className: 'upcoming',
	            fill: '#e6e6e6',
	            'data-coming-soon': true,
	            'data-city': 'Buena Vista',
	            'data-state': 'VA',
	            'data-tooltip-copy': t('mapHero.tooltip.soon'),
	            'data-season': t('mapHero.stats.fall'),
	            'data-year': '2019',
	            'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData
	          }, getPavedPathProps(t, {
	            cityName: 'Buena Vista',
	            stat1Number: '$5,000',
	            stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-06-12')
	          }), {
	            d: 'M1040.7,522.37c8.1-9.7,13.2-13.9,15.5-13.1.9.3,1.6,1,1.6,1.4s1.6,1.1,3.5,1.4c2.6.5,6.3-.3,14.6-3,10-3.3,11.3-4,12.4-6.8a34.9,34.9,0,0,1,3.2-5.6c1.1-1.4,3.4-6.3,5.2-11a98.66,98.66,0,0,1,3.9-9.2c.3-.4,2.4-.9,4.6-1.3,6.7-1,7.2-1.4,7.9-5.8.5-3.4,1.7-5.1,6.1-9,3-2.7,5.4-5.2,5.3-5.5-.4-2.6.3-3.1,2.7-2.2,4.1,1.5,7.3,1.2,8.4-1,1.1-2,1.1-2,3,0a6.86,6.86,0,0,0,2.9,2,25.56,25.56,0,0,1,4.5,1.5c3.6,1.5,3.6,1.5,2,4-1.5,2.3-1.5,2.8.1,6.5,1.4,3.2,2.9,4.5,7.9,6.9a59.18,59.18,0,0,0,8.9,3.6c3.1.8,5.2,3.6,3.7,5.1-.6.6.1,2.2,2,4.4a10.41,10.41,0,0,1,3,8.1c0,3.9.5,5.1,3.2,7.5,6.4,5.8,6.9,6.4,6.9,8.3,0,1.1-.6,2-1.2,2.1-1.8.1-5.4.8-13.2,2.4-7,1.5-35.1,5.8-45.5,7-3,.3-6.2.8-7,1s-4,.6-7.1,1-6.5.8-7.5,1c-3.3.6-10.6,1.5-21.9,2.6-6.1.6-12.8,1.3-15,1.5s-9.4.7-16,1a132.5,132.5,0,0,0-13.8,1.1C1034.3,530.67,1036.6,527.27,1040.7,522.37Z' })),
	          _react2.default.createElement('path', _extends({
	            className: 'upcoming',
	            fill: '#e6e6e6',
	            'data-coming-soon': true,
	            'data-city': 'Buena Vista',
	            'data-state': 'VA',
	            'data-tooltip-copy': t('mapHero.tooltip.soon'),
	            'data-season': t('mapHero.stats.fall'),
	            'data-year': '2019',
	            'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	            onMouseEnter: getCityData,
	            onMouseLeave: clearCityData
	          }, getPavedPathProps(t, {
	            cityName: 'Buena Vista',
	            stat1Number: '$5,000',
	            stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-06-12')
	          }), {
	            d: 'M1179.17,498.67c-.9-1.4.5-9.7,2.2-14.3.8-2.1,1.3-4.6,1-5.7-.5-2,1.5-3,6.1-3.1,1.9,0,2.2.4,1.6,1.7-.4,1-1.5,3.8-2.4,6.2s-2.4,5.3-3.4,6.2c-2,2.1-2.2,3.5-.6,4,.8.3.6,1.2-.6,3.1C1181.4,499.87,1180.17,500.27,1179.17,498.67Z' }))
	        ),
	        _react2.default.createElement('path', _extends({
	          id: 'US-VT',
	          className: 'not-paved',
	          fill: '#e6e6e6',
	          'data-not-paved': true,
	          'data-city': 'Vermont',
	          'data-state': 'VT',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Rutland',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-10-23')
	        }), {
	          d: 'M1206.7,335.47c0-4.1-4.9-19-7-21.2-1.5-1.6-2.1-3.9-2.4-9.6a88.18,88.18,0,0,0-1-10c-.3-1.4-.9-4.1-1.2-6.1l-.6-3.6,9.4-2.1c5.1-1.2,11.4-2.4,14-2.8l4.6-.6.7,4.7c.6,4.3.4,5-2.4,8.2l-3.1,3.6.3,20.4c.3,17.6.1,20.4-1.2,20.4-.8,0-3.4.3-5.8.6C1207,337.87,1206.7,337.67,1206.7,335.47Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-WA',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'Walla Walla',
	          'data-state': 'WA',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.spring'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Walla Walla',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-06-20')
	        }), {
	          d: 'M396.5,204.93c-14.5-5.2-21.4-6.7-35.3-7.7-10.5-.7-16.3-2.1-24.6-5.9a76.59,76.59,0,0,0-13.9-4.7c-3.6-.7-7-2.1-7.7-2.9s-1.2-3.8-1.2-6.6c0-4.6-.5-5.5-4.3-9.6-3.1-3.3-5.5-4.8-8.9-5.7l-4.6-1.2.8-3.8c1-4.6,5.6-33,6.9-43.2.5-4.1,1.5-7.8,2.3-8.2,1.5-.9,4.2.6,11.3,6.6,4.3,3.6,16.1,8.9,20,9,.6,0,.9-1.4.7-3.1-.2-2.4,2.6-11.6,4.4-14.1.1-.2,2.9.8,6.1,2.1s23.4,9.1,44.9,17.2,39.2,14.9,39.4,15.1-1.7,6.1-4.2,13.1-7.1,20-10.3,28.8c-3.9,11-5.9,18.2-6.3,23.1l-.6,7.1Z' })),
	        _react2.default.createElement('path', {
	          id: 'US-WI',
	          className: 'paved',
	          fill: '#e6e6e6',
	          'data-paved': true,
	          'data-city': 'Milwaukee',
	          'data-state': 'WI',
	          'data-stat1number': '200',
	          'data-stat1text': t('mapHero.stats.potholesFixed'),
	          'data-stat2number': '',
	          'data-stat2text': '',
	          'data-month': tMonthDayDate(i18n, '09/17'),
	          'data-date': '2018',
	          'data-date-text': t('mapHero.stats.datePaved'),
	          'data-tooltip-copy': t('mapHero.tooltip.paved'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData,
	          d: 'M892.1,378.67c-20-.7-20.4-.9-21.9-13.5-1.5-12.9-5.5-24.7-8.9-26.3-1.2-.6-6.6-5.1-12.1-10.1l-9.9-9.1v-12.2c0-10.6.3-12.4,1.8-13.3,5.8-3.4,7.5-5.7,7.6-10.4.2-7.4,1.1-10.5,3.4-10.8,3.6-.5,18.9-5.4,19.9-6.4,1.6-1.6,2.4-1.1,2.1,1.6-.2,2,.3,2.8,2.3,3.5,3.2,1.2,6.7,4.7,7.6,7.5.5,1.7,2.7,2.7,10.4,4.9,11.8,3.3,26,8.3,28.9,10.2,3.2,2,9,12.2,9.8,17,.4,2.3,1.3,4.2,1.9,4.2,1.9,0,5.7-4,7.2-7.6,1.7-4.1,3.9-4.6,2.8-.6a18.4,18.4,0,0,0-.6,5c.1,1.2-.3,2.2-.8,2.2-2.1,0-4,3.3-5,8.8-1.4,7.5-3,13.3-4.2,15.6-2.7,5.1-3.6,18.3-2.3,32.9l.7,7.8-12.9-.3C913,379.27,900.4,378.93,892.1,378.67Z' }),
	        _react2.default.createElement('path', _extends({
	          id: 'US-WV',
	          className: 'upcoming',
	          fill: '#e6e6e6',
	          'data-coming-soon': true,
	          'data-city': 'Parkersburg',
	          'data-state': 'WV',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          'data-season': t('mapHero.stats.summer'),
	          'data-year': '2019',
	          'data-coming-soon-text': t('mapHero.stats.estimatedDate'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Parkersburg',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-08-12')
	        }), {
	          d: 'M1061.8,508.47c-6.4-2.4-17.9-15.1-18.6-20.7-.3-2.2.4-4.1,2.5-6.9,1.6-2.1,2.9-4.9,2.9-6.1,0-1.7,1-2.7,3.4-3.7,2.7-1.1,3.5-2.2,4-4.9.8-4.3,3.8-7.9,8.9-10.8,4.9-2.8,8.7-11.4,8.7-19.9,0-7.7,1.6-8.2,2.4-.7,1,9.1,2.5,10.1,13.8,9.7l9.1-.3,1.1,5c1,4.5,1.3,5,3.6,4.7,1.4-.1,5-2,8.1-4.2,6.7-4.7,16.2-7.2,20.3-5.3,2.9,1.3,3.1,2.1,1.2,4.7-1.3,1.8-1.5,1.8-5.6-.4-4.8-2.5-5.6-2.1-6.5,2.7-.6,3.2-4.8,7.9-8.6,9.3-1.1.4-2,2.3-2.4,5.3-.8,5-1,5.2-7.3,5.8a15.26,15.26,0,0,0-4.5.8c-.1.2-2,4.7-4.1,9.9a101.57,101.57,0,0,1-6.7,13.9,26,26,0,0,0-2.9,5.1c0,.7-5.6,2.8-16,6.2C1065.7,508.87,1063.4,509.07,1061.8,508.47Z' })),
	        _react2.default.createElement('path', _extends({
	          id: 'US-WY',
	          className: 'not-paved',
	          fill: '#e6e6e6',
	          'data-not-paved': true,
	          'data-city': 'Wyoming',
	          'data-state': 'WY',
	          'data-tooltip-copy': t('mapHero.tooltip.soon'),
	          onMouseEnter: getCityData,
	          onMouseLeave: clearCityData
	        }, getPavedPathProps(t, {
	          cityName: 'Laramie',
	          stat1Number: '$5,000',
	          stat1Text: t('mapHero.stats.grantUsed') + ' ' + tShortDate(i18n, '2019-04-30')
	        }), {
	          d: 'M605.7,395.67c-4.7-1-11.7-2.5-15.5-3.4s-14.7-3.1-24-5.1c-19.6-4.1-60.5-12.8-71.5-15.2q-4.36-1-8.8-1.6c-.7,0-1.1-.7-.8-1.6s1.2-4.5,2.1-8.1,2-7.6,2.5-9a30.6,30.6,0,0,0,1.4-5.6c.5-3.1,3.5-16,10.5-44.9,2.1-8.8,4.4-18.5,5-21.6a26.5,26.5,0,0,1,2.4-7.4c1.4-1.9,1.2-1.9,50.6,8.5,15.2,3.2,39.2,8.2,49.5,10.4.6.1,6.1,1.3,12.3,2.6l11.3,2.4-.5,3.6c-.3,2-3.2,19.8-6.6,39.6s-6.3,37.1-6.6,38.5c-.7,4.5-1.4,8.4-2.5,13.9-.6,3-1,5.6-1,5.8C615.7,397.77,615.3,397.77,605.7,395.67Z' }))
	      ),
	      _react2.default.createElement('path', { fill: '#f7f7f7', d: 'M1075.37,7.73a41.3,41.3,0,0,1-7.2,12.4c-2.5,2.7-6,6.7-7.8,8.9a36.48,36.48,0,0,1-6.9,5.8c-5.9,3.7-13,9-12.9,13.7,0,2.2,1.7,4.7,3,6.5a4.84,4.84,0,0,1,.9,2.2,9.09,9.09,0,0,0,4.6,8.1c1.7.9,3.5,4.7,3.3,8.2-.2,4.5.5,7.8,2.4,10.4a19.89,19.89,0,0,1,2,4.9,100.82,100.82,0,0,0,5.5,13.4,55.75,55.75,0,0,1,3.5,8.9,15.66,15.66,0,0,1-1.9,3.9c-2.2,3.3-3.4,5.9-3.1,9.2a6.82,6.82,0,0,0-4,2.8,7.13,7.13,0,0,0-.8,5.5l-6.5.5-.7-2c-1.4-4.2-7.4-14.3-13-16.5a160.56,160.56,0,0,1-15-18.7c-1.9-3-2.1-3.8-1.9-6.3,0-.6.4-6-1.1-9-.5-1.1-.6-1.3-1.7-9.1a27.91,27.91,0,0,0-3.2-9.6,2,2,0,0,0-.3-.5,44.44,44.44,0,0,0,1.5-10l.9-12-7.1-3.6c-4.7-2.4-8.6-2.7-25-3.3l-16.9-.6-4.1-3.6c-2.5-2.3-7.3-6.1-10.6-6.2-3.7-.1-4.9-.7-6.8-2.5-2.8-2.6-6.4-4.3-11.5-5.2-3.8-.7-5.2-1.6-6.7-3a13.7,13.7,0,0,1-2-2.3c-1-3-4.54-6.43-7.74-9H287.66c-.08,1.45-.12,3.12-.16,5.13-.2,11.3-.1,13.1.6,16.3a23.64,23.64,0,0,1,.4,2.5c.2,2.7,2.4,5.1,7.3,8a40.3,40.3,0,0,1,3.7,2.4,9.13,9.13,0,0,0,1.8,1.6v.3c-.9,7,.3,8.5,6.2,14.4,5.1,5.2,8,10.8,8.8,17.1.6,4.8,3.6,10.6,7.5,13.1.7,3.5,3.9,6.6,9.5,11.3.3.2.3,1.4.3,1.7,0,6.7,1.9,9.6,7.8,11.7,1.6.6,6.3,2.4,10.4,4,24.1,9.4,82.8,31.4,88.3,33.1,16.3,5.1,36.7,11.4,37.6,11.7a9,9,0,0,0,2.2.3,6.9,6.9,0,0,0,2.2-.4,19.12,19.12,0,0,0,4.1,2.1c4.9,1.9,14,4.3,32.1,9.1,0,0,9,2.4,13.5,3.5,3.9,1,11.6,3.1,14.1,3.7a5.54,5.54,0,0,0,4.1.2c1.8,1.1,4.5,1.8,8.2,2.7,4.5,1,8.8,2,10,2.2.9.2,4.5.9,8.2,1.8,5.9,1.4,8.5,2,13.1,3,.7.2,11.1,2.5,25.9,5.8,13.9,3.1,27.8,5.9,31.6,6.3,3.5.4,7.5.8,8.8,1s5.5.7,9.2,1c3.5.3,7.5.8,8.8,1,1.5.2,6.2.7,10.8,1.1,3.3.3,5.6.6,6.7.7a6.11,6.11,0,0,0,3.2.9,4.43,4.43,0,0,0,1.2-.1l9.8,1c9.2.9,18.6,2,21.3,2.4,1.5.2,5.4.7,8.2,1,5.8.6,9.2,1,18,2.1,3.2.4,10,1,15.3,1.3,5.1.3,14,.8,19.8.9l14.7.5.8-6.2c.2.1.3.2.5.3s.5.2.7.3a20.93,20.93,0,0,1,.5,3.6c.9,7.9,2.2,11.5,10.9,13.1a11.35,11.35,0,0,1,2.9.9c2.5,2.3,6.4,2.7,13.9,2.7,3.8,0,5.9,0,7,.3.6.2,1,.4,2.4,1.8,2.9,2.8,6.1,4.5,8.8,4.8,4.3,5.2,16.2,5.5,16.7,5.6a113.81,113.81,0,0,1,13.9,1.4c6.3,1,10,1.6,12.9,1.6,5.2,0,7.7-2.1,10.5-5.2a70.76,70.76,0,0,1,9.4-7.5c5.1-3.3,7.7-5,8-8.4a6.4,6.4,0,0,0-.1-1.9l1.4-.9,3.3,1.6c4.3,2.2,6.7,3.1,11.3,3.1,1.4,0,3-.1,5.2-.2l3.9-.3a37.52,37.52,0,0,1,.6,4.7c.1,1,.5,5.9,3.2,8.4,3.3,3.1,14.9,8.7,19.7,9.5.4.1.8.1,1.1.2a8.27,8.27,0,0,1,.9,1.9,55.3,55.3,0,0,0,4.5,8.2c.1.1.2.3.3.4a5.1,5.1,0,0,0-1.6,2.8c-.7,3.2,1.5,5.5,3.4,7.5a7.21,7.21,0,0,1,1.6,2.6c.3,5.1,3.7,7.2,8.1,9.5a27.21,27.21,0,0,1,5,3.3c2.9,4.1,6,4.1,20.2,4.1,9.8,0,15.4.4,18.8,1.4a91,91,0,0,0,12.9,2.5,41.2,41.2,0,0,1,6.3,1.3c2.5,2,12.6,12.9,15,16.4a6,6,0,0,1,.5,5.7c-4.4-1.3-8.8-4.3-13.3-8.9-6.7-6.8-8.2-7.5-10.2-7.5a5.74,5.74,0,0,0-5.4,3.7c-1.3,3.4.8,7.3,3.4,9.7a16,16,0,0,1,2.7,4.2l.8,1.7-2.4,4.2c-3.8,6.8-4.2,8.6-4.1,17.1.1,4.6.3,9.9.5,11.9.1,1.3-1.8,5.6-4.3,7.3s-4,5.3-4.5,8.2a18.37,18.37,0,0,1-1.2,4.2c-1.7,3.4-1,6.1.5,7.9a16.16,16.16,0,0,1-.3,2.2c-.85.24-1.72.44-2.6.6-4.3.7-7.1,2.6-8.9,6.1l-5.7,11,12.4-1.3c1.7-.2,4.5-.4,6.3-.4,5.3-.1,8.3-3,14.5-9.5,8.2-8.5,10.7-10.5,13.6-10.5a23.21,23.21,0,0,1,5.1.9,26.21,26.21,0,0,0,6.3.8,15.3,15.3,0,0,0,3.3-.3l12.9-3.2-7.7-5.8c3.7-1.7,8.8-3.3,10.7-3.3,4.1,0,8.3,0,10.4-3.4,2-3.2.4-6.6-.5-8.4s-2.8-5.9-7.4-5.9a9.46,9.46,0,0,0-1.6.2,7.18,7.18,0,0,1-1.6-.3c.3-.5.7-1.3,1.2-2.2,2.1-3.5,16.4-10.7,28.7-11.1,4.6-.1,15.1-2,17.7-6.9a6.1,6.1,0,0,0,.7-2.2,10.76,10.76,0,0,1,1.1-.9c1.8-.3,3.8-1.7,10.9-10.5,7.2-9,12.2-14.2,18.2-19.3a18.72,18.72,0,0,0,2.9-2.8c2.2,1.6,4.8,1.7,8.3,1.7,3.8,0,14.5-1.9,22.6-3.7,8.7-1.9,17.1-3.7,18.2-4,3-.6,5.9-3.5,7.5-5.8a23,23,0,0,1,4.7-4.6c5.2-3.7,8.9-11.4,9.8-20.7.2-2.3.8-7.1,1.4-10.6s1.2-8.6,1.6-11.1c.7-5.9,4.5-17.6,5.9-20.2a23.81,23.81,0,0,0,2.8.2,24.18,24.18,0,0,0,4.8-.4l8.4-1.3-.1-.9h.9c1.2,0,5.3,1.5,9,5,.4.3.7.6.7,3,.1,8.1,5.6,29.4,13.9,32.1.2.2.4.4.4.5,2.3,5.4,6.2,9.4,10,10.4a21.87,21.87,0,0,0,5.7.7c6.8,0,12.5-3.1,14.7-7.8,2.7-.2,6-2.2,9.4-5.1-4.4,5.5-9.4,13.2-10.9,16.9-1.3,3.4-.7,7,.5,11.3,2.9,10.1,7,14.7,14.8,16.4,1.9.4,3.2.7,4,.9l.6.4h1.5c2.4,0,3.3-.9,10.3-8.1,5.3-5.5,8.1-9.5,10.6-15.5,2.9-6.9,3.3-8.9,3.4-9.7a2.46,2.46,0,0,1,.3-.9,6.84,6.84,0,0,0,1.5.1c4.8,0,6.8-3.5,8.9-7.1a13.42,13.42,0,0,1,2.6-3.4c4.3-1.5,13.5-9.3,16.3-12.2.8-.8,4.5-4.5,7.8-7.9,5.5-5.5,8.3-8.3,6.9-13a16.25,16.25,0,0,0,2.7-3.2,4,4,0,0,1,.8-.9c4.4-.2,7-3.8,9.2-7.1.9-1.4,3.9-6.3,3.9-9.5,0-5.5-7-11.3-11.7-12.6a18.57,18.57,0,0,1-.3-3.8c0-5.4-3.5-13-9-13-3.5,0-6.4,1.5-12.8,20.7-1.7,5-3,8.4-3.4,9.2-2.3,3.1-.9,6.5,1.2,9.3-.6-.1-1-.2-1.2-.2a7,7,0,0,0-2.6-.5,12.13,12.13,0,0,0-5.3,1.5v-.2a17.56,17.56,0,0,1,1.1-5.1c1.8-3.5,2-6.3.7-8.4a5.56,5.56,0,0,0-4.9-2.5c-3.2,0-10.9,2.2-14.1,3.8a24.29,24.29,0,0,1-4.5.4,18.49,18.49,0,0,0-6.8,1.1c-.4-.3-.8-.8-1.4-1.3-5.3-5.1-7.8-5.7-9.3-5.7-3,0-5.5,2.4-8,7.5a18,18,0,0,0-2.9-5.4c-.9-1.3-1.2-7.4,0-9.6.5-.8,2.1-3.8,2.1-6.1a5.68,5.68,0,0,0-1.7-4.3,7,7,0,0,0-5-2c6.3-8.1,7-15.2,2.2-24.2-2.3-4.4-5.3-6-10.6-7.7a25.71,25.71,0,0,0-7.6-1.5,35.87,35.87,0,0,0-7.5,1.2,48.4,48.4,0,0,0-15.7,7.5c-4.1,2.8-10,6.7-13.3,8.7-.5.3-1.1.7-1.7,1.1.6-1.4,1-2.9,1.5-4.4a121.74,121.74,0,0,0,3.1-12.2,15.74,15.74,0,0,1,1.9-5.3c1.2-1.6,7.2-5.1,31.5-13a7.51,7.51,0,0,0-.9,5.4c1.3,5.3,7.9,6.8,10.4,7.3a25.13,25.13,0,0,1,6.4,2.2,18.37,18.37,0,0,0,7,2.9,26.8,26.8,0,0,0,4.2.3c2.8,0,7.1-.3,14.5-.9,10.7-.9,16.1-1.4,16.1-9.9,0-6.8-3.2-7.9-12.7-11.1a62.38,62.38,0,0,0-20.9-3.7c.8-.2,1.6-.5,2.4-.7,6.6-1.9,15.2-4.4,19-5.5,6.4-1.9,28.4-11.1,30.9-17.9.3-.9,2.5-5.5,5.2-11,1.9-3.9,5-10.9,5.5-14,.2-1.5,3.3-6.5,13.3-14.1.7-.5,1.2-.9,1.8-1.4,0,.3-.1.5-.1.8-.4,4.4-.9,8.9-1,9.9a274.21,274.21,0,0,0-.9,47.6c.5,7.1.4,7.3-.7,9.1-1.9,3-3.6,6.6-2.3,10.1a6.46,6.46,0,0,0,3.2,3.7,9.68,9.68,0,0,1-1.5,3.2c-4.2,5.7-4.2,12.5-.1,17.8,1.2,1.6,3.8,4.2,7,4.2a5.07,5.07,0,0,0,2.1-.4l11.2-4.5a96.54,96.54,0,0,1,12.5-4.3c1.9-.3,4.6-.8,6.1-1,2.9-.5,7.9-3.1,10.1-4.4,2.4-1.4,7-4.2,9.1-5.2a9.26,9.26,0,0,0,3,.5,13.57,13.57,0,0,0,2.1-.2c-2.4,2.3-5.5,5.8-3.9,9.9,1.7,4.4,7,4.4,9.2,4.4h1.1c10.4-.3,14.7-4.7,16.4-16.8.8-5.5.8-5.6,3.4-8.1l.7-.7c.9,6.6,2.7,12.9,8.4,12.9a6.48,6.48,0,0,0,4.3-1.7,8.42,8.42,0,0,0,5.3,1.7,5.7,5.7,0,0,0,1.3-.1c6.8-.5,13-8.7,12.6-16.8.47-2.4.27-7.1.17-10.7-.3-8-1.4-9.7-2.4-10.8a5.6,5.6,0,0,0-4-1.6,10.92,10.92,0,0,0-5.8,2.2c-1.5-4.1-4-6.5-7-6.5a5.48,5.48,0,0,0-1.8.3,14.84,14.84,0,0,0,2.3-7.5c0-7.4-5.5-8.2-7.9-8.2a33.6,33.6,0,0,0-5.3.6q-1,.15-1.8.3a14,14,0,0,0,0-7.6c-.8-2.9-2.4-5.2-4.5-6.2a18.68,18.68,0,0,0-8.6-2.1,23.71,23.71,0,0,0-9.4,2.2,74.62,74.62,0,0,1-9,3.3,19.57,19.57,0,0,0-6.5,2.7,14.66,14.66,0,0,1-2.8.2c.1-4.9-1-7.4-6.9-9.6a19.1,19.1,0,0,0-5.8-1,8.5,8.5,0,0,0-1.6.1c.3-1.9.6-5.4.9-12.4.4-11.9,0-18-5.9-22.9a6.71,6.71,0,0,0-3.4-1.6,11.19,11.19,0,0,0,1.6-4.7c0-3.62-3.67-9.66-6.74-13.53h-352A46.34,46.34,0,0,1,1075.37,7.73Zm-346,115.9v-.3l.3.6Zm.2-24.8a24.1,24.1,0,0,0-3.6-2.5,7.92,7.92,0,0,1-2.8-2.1,8,8,0,0,0,5-4.2c1.3-2.6,1-5.7-.7-8.6h.1a14.7,14.7,0,0,1,3.2,2.9,11.13,11.13,0,0,0,2.8,5.6C731.57,91.33,729.77,93.83,729.57,98.83Zm32,19.7a20.07,20.07,0,0,1-2.2-4.8,36.14,36.14,0,0,0-4.8-9.4c-1.2-1.6-1.1-2.2-1.1-2.5.7-6-2.4-8.1-7.2-10.7h0c-.3-.2-.7-.3-1-.5l1.1-3c2-5.5,5.1-8.6,6-8.9a14.63,14.63,0,0,1,3.1-.4c1.7,0,2.7.5,4,2.9,2.2,4.3,3.3,5.6,4,6.1,1.1,1.5,3.6,8.2,4,10.2-.8,4.5,3.2,12.1,3.7,13.1a16.55,16.55,0,0,1,.5,5,35.86,35.86,0,0,0,.3,4.4A10.91,10.91,0,0,0,761.57,118.53Zm14.9,40.7a9.57,9.57,0,0,1,1-3.3,21.11,21.11,0,0,0,2.3-5.7,8.55,8.55,0,0,0,.1,1.6c.1,1.7.1,3.8.1,5.3A14.28,14.28,0,0,0,776.47,159.23Zm496.4-146.7a36,36,0,0,1,6.5-5.3c.3-.2.5-.4.8-.6a16.38,16.38,0,0,0,7.1,1.1,12,12,0,0,0,3.8-.6c-.07.26-.21.53-.3.8-1.1,2.4-2.2,2.4-2.8,2.4a4.83,4.83,0,0,1-1.6-.3,11.93,11.93,0,0,0-3.8-.5,15.72,15.72,0,0,0-10,3.6Zm-7.2,143.4c-.7.6-1.3,1.1-1.9,1.6-1,1-2.1,2-3.2,3A23.53,23.53,0,0,1,1265.67,155.93Z' })
	    )
	  );
	};
	
	exports.default = (0, _reactI18next.translate)()(Map);
	module.exports = exports['default'];

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(22);
	
	var _reactI18next = __webpack_require__(19);
	
	var _i18n = __webpack_require__(104);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _typography = __webpack_require__(29);
	
	var _p4paaLogo = __webpack_require__(939);
	
	var _p4paaLogo2 = _interopRequireDefault(_p4paaLogo);
	
	var _p4paaLogoEs = __webpack_require__(938);
	
	var _p4paaLogoEs2 = _interopRequireDefault(_p4paaLogoEs);
	
	var _legendPartnerStates = __webpack_require__(937);
	
	var _legendPartnerStates2 = _interopRequireDefault(_legendPartnerStates);
	
	var _legendPartnerStatesStories = __webpack_require__(936);
	
	var _legendPartnerStatesStories2 = _interopRequireDefault(_legendPartnerStatesStories);
	
	var _mapMobile = __webpack_require__(944);
	
	var _mapMobile2 = _interopRequireDefault(_mapMobile);
	
	var _Map = __webpack_require__(444);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _styledComponents = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// allow for non-empty but falsy attributes to register as false
	var attributeIsFalsy = function attributeIsFalsy(value) {
	  return value === 'false' || value === '' || !!value === false;
	};
	var boolifyAttributeValue = function boolifyAttributeValue(value) {
	  return attributeIsFalsy(value) ? false : true;
	};
	
	var Stats = function Stats(_ref) {
	  var stat1number = _ref.stat1number,
	      stat1text = _ref.stat1text,
	      stat2number = _ref.stat2number,
	      stat2text = _ref.stat2text,
	      month = _ref.month,
	      date = _ref.date,
	      dateText = _ref.dateText;
	  return _react2.default.createElement(
	    'ul',
	    { className: 'map-stats' },
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: 'map-stats__number' },
	        stat1number
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'map-stats__text' },
	        stat1text
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: 'map-stats__number' },
	        stat2number
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'map-stats__text' },
	        stat2text
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: 'map-stats__date' },
	        month
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'map-stats__date' },
	        date
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'map-stats__text' },
	        dateText
	      )
	    )
	  );
	};
	
	var ComingSoonContent = function ComingSoonContent(_ref2) {
	  var season = _ref2.season,
	      year = _ref2.year,
	      comingSoonText = _ref2.comingSoonText;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: 'map-stats__date' },
	        season
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'map-stats__date' },
	        year
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'map-stats__text' },
	        comingSoonText
	      )
	    )
	  );
	};
	
	var NotPavedContent = function NotPavedContent(_ref3) {
	  var t = _ref3.t;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: 'map-stats__date' },
	        t('mapHero.tooltip.soon')
	      )
	    )
	  );
	};
	
	var MapHero = (_dec = (0, _mobxReact.inject)("store"), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
	  _inherits(MapHero, _Component);
	
	  function MapHero(props) {
	    _classCallCheck(this, MapHero);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      city: '',
	      state: '',
	      stat1number: '',
	      stat1text: '',
	      stat2number: '',
	      stat2text: '',
	      month: '',
	      date: '',
	      dateText: '',
	      season: '',
	      year: '',
	      comingSoonText: '',
	      tooltipCopy: '',
	      displayIntroText: true,
	      displayPaved: false,
	      displayNotPaved: false,
	      displayComingSoon: false,
	      displayStateInfo: false
	    };
	
	    _this.scrollToElement = _this.scrollToElement.bind(_this);
	    _this.gaLangClicked = _this.gaLangClicked.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.langToggle = _this.langToggle.bind(_this);
	    _this.getCityData = _this.getCityData.bind(_this);
	    _this.clearCityData = _this.clearCityData.bind(_this);
	    _this.gaStateClicked = _this.gaStateClicked.bind(_this);
	    _this.positionTooltips = _this.positionTooltips.bind(_this);
	
	    _this.tooltips = [];
	
	    _this.handleMouseMove = function (e) {
	      _this.positionTooltips({
	        x: e.clientX,
	        y: e.clientY + window.pageYOffset
	      });
	    };
	    return _this;
	  }
	
	  MapHero.prototype.componentDidMount = function componentDidMount() {
	    this.tooltips = [document.querySelector('.tooltip--paved'), document.querySelector('.tooltip--not-paved'), document.querySelector('.tooltip--coming-soon')];
	    window.addEventListener('mousemove', this.handleMouseMove);
	  };
	
	  MapHero.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.tooltips = [];
	    window.removeEventListener('mousemove', this.handleMouseMove);
	  };
	
	  MapHero.prototype.getCityData = function getCityData(e) {
	    var city = e.target.getAttribute('data-city');
	    var state = e.target.getAttribute('data-state');
	    var stat1number = e.target.getAttribute('data-stat1number');
	    var stat1text = e.target.getAttribute('data-stat1text');
	    var stat2number = e.target.getAttribute('data-stat2number');
	    var stat2text = e.target.getAttribute('data-stat2text');
	    var month = e.target.getAttribute('data-month');
	    var date = e.target.getAttribute('data-date');
	    var dateText = e.target.getAttribute('data-date-text');
	    var season = e.target.getAttribute('data-season');
	    var year = e.target.getAttribute('data-year');
	    var comingSoonText = e.target.getAttribute('data-coming-soon-text');
	    var tooltipCopy = e.target.getAttribute('data-tooltip-copy');
	    var paved = boolifyAttributeValue(e.target.getAttribute('data-paved'));
	    var notPaved = boolifyAttributeValue(e.target.getAttribute('data-not-paved'));
	    var comingSoon = boolifyAttributeValue(e.target.getAttribute('data-coming-soon'));
	
	    this.setState({
	      city: city,
	      state: state,
	      stat1number: stat1number,
	      stat1text: stat1text,
	      stat2number: stat2number,
	      stat2text: stat2text,
	      month: month,
	      date: date,
	      dateText: dateText,
	      season: season,
	      year: year,
	      comingSoonText: comingSoonText,
	      tooltipCopy: tooltipCopy,
	      displayIntroText: false,
	      displayPaved: paved,
	      displayNotPaved: notPaved,
	      displayComingSoon: comingSoon,
	      displayStateInfo: paved || notPaved || comingSoon
	    });
	
	    if (e.target.getAttribute('class') === 'paved') {
	      e.target.setAttribute('class', 'paved hovered');
	    } else if (e.target.getAttribute('class') === 'upcoming') {
	      e.target.setAttribute('class', 'upcoming hovered');
	    } else if (e.target.getAttribute('class') === 'tag') {
	      e.target.setAttribute('class', 'tag hovered');
	    } else if (e.target.getAttribute('class') === 'not-paved') {
	      e.target.setAttribute('class', 'not-paved hovered');
	    }
	
	    if (e.target.getAttribute('data-state') === 'TX') {
	      document.querySelector('#TX-north').classList.add('hovered');
	      document.querySelector('#TX-south').classList.add('hovered');
	    }
	  };
	
	  MapHero.prototype.positionTooltips = function positionTooltips(_ref4) {
	    var x = _ref4.x,
	        y = _ref4.y;
	
	    var nudge = { x: 26, y: 58 // ?? mystery amounts
	    };for (var _iterator = this.tooltips, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref5;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref5 = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref5 = _i.value;
	      }
	
	      var tooltip = _ref5;
	
	      tooltip.style.left = x - tooltip.offsetWidth / 2 - nudge.x + 'px';
	      tooltip.style.top = y - tooltip.offsetHeight - nudge.y + 'px';
	    }
	  };
	
	  MapHero.prototype.clearCityData = function clearCityData(e) {
	    this.setState({
	      city: '',
	      state: '',
	      stat1number: '',
	      stat1text: '',
	      stat2number: '',
	      stat2text: '',
	      month: '',
	      date: '',
	      dateText: '',
	      season: '',
	      year: '',
	      comingSoonText: '',
	      tooltipCopy: '',
	      displayIntroText: true,
	      displayPaved: false,
	      displayNotPaved: false,
	      displayComingSoon: false,
	      displayStateInfo: false
	    });
	
	    if (e.target.getAttribute('class') === 'paved hovered') {
	      e.target.setAttribute('class', 'paved');
	    }
	
	    if (e.target.getAttribute('class') === 'upcoming hovered') {
	      e.target.setAttribute('class', 'upcoming');
	    }
	
	    if (e.target.getAttribute('class') === 'tag hovered') {
	      e.target.setAttribute('class', 'tag');
	    }
	
	    if (e.target.getAttribute('data-state') === 'TX') {
	      document.querySelector('#TX-north').classList.remove('hovered');
	      document.querySelector('#TX-south').classList.remove('hovered');
	    }
	  };
	
	  MapHero.prototype.scrollToElement = function scrollToElement(element) {
	    var target = document.querySelector(element);
	    target.scrollIntoView({ behavior: 'smooth' });
	  };
	
	  MapHero.prototype.gaStateClicked = function gaStateClicked(city, state, status) {
	    window.dataLayer.push({
	      'event': 'map:click',
	      'city': city + ', ' + state,
	      'digital state': status
	    });
	  };
	
	  MapHero.prototype.gaLangClicked = function gaLangClicked(lng) {
	    window.dataLayer.push({
	      'event': 'lang:click',
	      'langSelect': 'header',
	      'langSelectItem': lng
	    });
	  };
	
	  MapHero.prototype.toggle = function toggle(lng) {
	    _i18n2.default.changeLanguage(lng);
	  };
	
	  MapHero.prototype.langToggle = function langToggle(lng) {
	    this.toggle(lng);
	    this.gaLangClicked(lng);
	  };
	
	  MapHero.prototype.render = function render() {
	    var scrollToElement = this.scrollToElement,
	        langToggle = this.langToggle,
	        _getCityData = this.getCityData,
	        clearCityData = this.clearCityData,
	        gaStateClicked = this.gaStateClicked;
	    var _state = this.state,
	        city = _state.city,
	        state = _state.state,
	        stat1number = _state.stat1number,
	        stat1text = _state.stat1text,
	        stat2number = _state.stat2number,
	        stat2text = _state.stat2text,
	        month = _state.month,
	        date = _state.date,
	        dateText = _state.dateText,
	        season = _state.season,
	        year = _state.year,
	        comingSoonText = _state.comingSoonText,
	        tooltipCopy = _state.tooltipCopy,
	        displayIntroText = _state.displayIntroText,
	        displayPaved = _state.displayPaved,
	        displayNotPaved = _state.displayNotPaved,
	        displayComingSoon = _state.displayComingSoon,
	        displayStateInfo = _state.displayStateInfo;
	    var _props = this.props,
	        data = _props.data,
	        t = _props.t,
	        lng = _props.lng;
	
	
	    return _react2.default.createElement(
	      _styledComponents.MapHeroWrapper,
	      null,
	      _react2.default.createElement(
	        _styledComponents.LangToggles,
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Language:'
	        ),
	        ' ',
	        _react2.default.createElement(
	          'button',
	          { onClick: function onClick() {
	              return langToggle('en');
	            } },
	          'EN'
	        ),
	        ' ',
	        _react2.default.createElement(
	          'button',
	          { onClick: function onClick() {
	              return langToggle('es');
	            } },
	          'ES'
	        )
	      ),
	      lng.match(/^en/) ? _react2.default.createElement(_p4paaLogo2.default, null) : _react2.default.createElement(_p4paaLogoEs2.default, null),
	      _react2.default.createElement('img', {
	        className: 'map-hero__mobile-map',
	        src: _mapMobile2.default,
	        alt: 'Unites States map indicates states we\'ve paved',
	        onClick: function onClick() {
	          return scrollToElement('#cities-completed');
	        },
	        onKeyDown: function onKeyDown() {
	          return scrollToElement('#cities-completed');
	        },
	        role: 'button',
	        tabIndex: 0
	      }),
	      _react2.default.createElement(_Map2.default, {
	        className: 'map-hero__desktop-map',
	        city: city,
	        state: state,
	        displayPaved: displayPaved,
	        displayNotPaved: displayNotPaved,
	        displayComingSoon: displayComingSoon,
	        tooltipCopy: tooltipCopy,
	        getCityData: function getCityData(e) {
	          return _getCityData(e);
	        },
	        clearCityData: clearCityData,
	        gaStateClicked: gaStateClicked,
	        scrollToElement: scrollToElement
	      }),
	      _react2.default.createElement(
	        _styledComponents.StateInfo,
	        { displayStateInfo: displayStateInfo },
	        _react2.default.createElement(
	          _styledComponents.MapLocation,
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'map-data-city' },
	            city
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'map-data-state' },
	            state
	          )
	        ),
	        _react2.default.createElement(
	          _styledComponents.MapLocationStats,
	          null,
	          _react2.default.createElement(Stats, {
	            stat1number: stat1number,
	            stat1text: stat1text,
	            stat2number: stat2number,
	            stat2text: stat2text,
	            month: month,
	            date: date,
	            dateText: dateText
	          }),
	          _react2.default.createElement(
	            _styledComponents.ComingSoon,
	            { style: { display: displayComingSoon ? 'block' : 'none' } },
	            _react2.default.createElement(ComingSoonContent, { season: season, year: year, comingSoonText: comingSoonText })
	          ),
	          _react2.default.createElement(
	            _styledComponents.NotPaved,
	            { style: { display: displayNotPaved ? 'block' : 'none' } },
	            _react2.default.createElement(NotPavedContent, { state: city, t: t })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _styledComponents.CampaignIntroWrapper,
	        { lang: lng, margins: [140, 140, 120], style: { display: displayIntroText ? 'block' : 'none' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'eyebrow' },
	          _react2.default.createElement(
	            _typography.H1,
	            { color: data.eyebrowColor },
	            t('mapHero.campaignIntro.eyebrow')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'copy' },
	          _react2.default.createElement(
	            'p',
	            null,
	            t('mapHero.campaignIntro.text')
	          )
	        )
	      )
	    );
	  };
	
	  return MapHero;
	}(_react.Component)) || _class) || _class);
	exports.default = (0, _reactI18next.translate)()(MapHero);
	module.exports = exports['default'];

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CampaignIntroWrapper = exports.ComingSoon = exports.NotPaved = exports.MapLocationStats = exports.MapLocation = exports.StateInfo = exports.LangToggles = exports.MapHeroWrapper = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _gutters = __webpack_require__(12);
	
	var _gutters2 = _interopRequireDefault(_gutters);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapHeroWrapper = exports.MapHeroWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'styled-components__MapHeroWrapper',
	  componentId: 'j9b0qu-0'
	})(['padding:0 20px;position:relative;.p4paa-logo{display:block;margin-left:auto;margin-right:auto;position:relative;width:50%;z-index:10;@media (min-width:', '){width:50%;}@media (min-width:', '){width:20%;margin-left:auto;margin-right:20px;position:relative;top:40px;}.across-america{display:none;}}.map-hero__mobile-map{margin-top:-40%;max-width:100%;outline:none;&:focus{box-shadow:0px 0px 15px 5px ', ';}@media (min-width:', '){display:none;}}.map-wrapper{height:0;margin-top:-16%;padding:0;padding-bottom:66.66666%;position:relative;width:100%;.tooltip{background-color:', ';color:', ';display:none;padding:10px;pointer-events:none;position:absolute;text-align:center;text-transform:uppercase;z-index:10;@media (min-width:', '){display:block;}&:after{content:\'\';position:absolute;left:calc(50% - 5px);top:100%;width:0;height:0;border-left:10px solid transparent;border-right:10px solid transparent;border-top:10px solid ', ';}span{display:block;}}.tooltip--paved{span{&:nth-of-type(1){font-family:"OneDotExt";font-size:.5rem;margin-bottom:5px;}&:nth-of-type(2){font-family:"OneDotCd";font-size:1rem;letter-spacing:1px;}}}.tooltip--not-paved,.tooltip--coming-soon{max-width:140px;span{&:nth-of-type(1){font-family:"OneDotCd";font-size:1rem;letter-spacing:1px;margin-bottom:5px;}&:nth-of-type(2){font-family:"OneDotExt";font-size:.5rem;line-height:1.25;}}}}.map-hero__desktop-map{display:none;@media (min-width:', '){display:block;height:100%;left:0;position:absolute;top:0;width:90%;}#USA{&:hover{.paved,.upcoming,.tag{fill:', ';&.hovered{fill:', ';}}}.paved{fill:', ';position:relative;&:hover{&.hovered{fill:', ';}}}.upcoming{fill:', ';&:hover{&.hovered{fill:', ';}}}.not-paved{cursor:pointer;&:hover{&.hovered{fill:', ';}}}}}'], _breakpoints2.default['bp-mobile'], _breakpoints2.default['bp-desktop'], _colors2.default['faint-grey'], _breakpoints2.default['bp-desktop'], _colors2.default['peacock-blue'], _colors2.default['white'], _breakpoints2.default['bp-tablet'], _colors2.default['peacock-blue'], _breakpoints2.default['bp-desktop'], _colors2.default['light-grey'], _colors2.default['lipstick'], _colors2.default['lipstick'], _colors2.default['lipstick'], _colors2.default['dark-red'], _colors2.default['lipstick'], _colors2.default['medium-grey']);
	
	var LangToggles = exports.LangToggles = _styledComponents2.default.div.withConfig({
	  displayName: 'styled-components__LangToggles',
	  componentId: 'j9b0qu-1'
	})(['margin-bottom:10px;margin-top:60px;position:relative;text-align:right;z-index:5;@media (min-width:', '){margin-right:1rem;margin-top:90px;}p{display:inline-block;font:400 13.3333px Arial;font-size:12px;margin-right:5px;}button{background-color:transparent;border:none;color:', ';outline:none;padding:15px 10px;&:hover,&:focus{text-decoration:underline;}}'], _breakpoints2.default['bp-mobile'], _colors2.default['lipstick']);
	
	var StateInfo = exports.StateInfo = _styledComponents2.default.div.withConfig({
	  displayName: 'styled-components__StateInfo',
	  componentId: 'j9b0qu-2'
	})(['opacity:', ';position:absolute;right:40px;top:41%;transform:', ';transition:opacity .5s ease-out,transform .5s ease-out;'], function (props) {
	  return props.displayStateInfo ? 1 : 0;
	}, function (props) {
	  return props.displayStateInfo ? 'translateY(0)' : 'translateY(1rem)';
	});
	
	var MapLocation = exports.MapLocation = _styledComponents2.default.p.withConfig({
	  displayName: 'styled-components__MapLocation',
	  componentId: 'j9b0qu-3'
	})(['font-family:\'OneDotCd\';font-size:4rem;font-weight:bold;margin-bottom:15px;max-width:360px;text-transform:uppercase;text-align:right;.map-data-city{color:', ';left:-10px;position:relative;z-index:1;}.map-data-state{color:', ';font-size:6rem;position:absolute;right:-10px;top:-40px;}'], _colors2.default['lipstick'], _colors2.default['faint-grey']);
	
	var MapLocationStats = exports.MapLocationStats = _styledComponents2.default.div.withConfig({
	  displayName: 'styled-components__MapLocationStats',
	  componentId: 'j9b0qu-4'
	})(['font-family:\'OneDotExt\';text-align:right;text-transform:uppercase;.map-stats__number{color:', ';display:block;font-size:3rem;margin-bottom:3px;opacity:1;transition:opacity .2s ease-out;&:empty{opacity:0;}}.map-stats__text{color:', ';display:block;font-size:.625rem;font-weight:bold;margin-bottom:15px;opacity:1;transition:opacity .2s ease-out;&:empty{opacity:0;}}.map-stats__date{color:', ';display:block;font-size:1.5rem;margin-bottom:5px;opacity:1;transition:opacity .2s ease-out;&:empty{opacity:0;}}'], _colors2.default['peacock-blue'], _colors2.default['medium-grey'], _colors2.default['peacock-blue']);
	
	var NotPaved = exports.NotPaved = _styledComponents2.default.div.withConfig({
	  displayName: 'styled-components__NotPaved',
	  componentId: 'j9b0qu-5'
	})(['font-family:\'OneDotExt\';font-size:.875rem;line-height:1.25;position:absolute;right:0;text-align:center;text-transform:uppercase;width:250px;p{margin-bottom:20px;span{text-align:right;}}strong{color:', ';display:block;margin-bottom:10px;}'], _colors2.default['peacock-blue']);
	
	var ComingSoon = exports.ComingSoon = _styledComponents2.default.div.withConfig({
	  displayName: 'styled-components__ComingSoon',
	  componentId: 'j9b0qu-6'
	})(['font-family:\'OneDotExt\';font-size:.875rem;line-height:1.25;position:absolute;right:0;text-align:right;text-transform:uppercase;width:260px;.map-stats__date{color:', ';display:block;font-size:1.5rem;margin-bottom:0;}.map-stats__text{color:', ';display:block;font-size:.75rem;font-weight:bold;margin-bottom:15px;}'], _colors2.default['peacock-blue'], _colors2.default['medium-grey']);
	
	var CampaignIntroWrapper = exports.CampaignIntroWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'styled-components__CampaignIntroWrapper',
	  componentId: 'j9b0qu-7'
	})(['align-items:center;display:flex;flex-direction:column;margin-top:-60%;padding:0 20px;position:relative;@media (min-width:', '){max-width:45%;margin-left:auto;margin-top:-70%;text-align:right;}@media (min-width:', '){max-width:33.33333%}@media (min-width:', '){bottom:20%;margin:0;padding:0;max-width:270px;position:absolute;right:20px;}@media (min-width:', '){bottom:25%;}.copy{color:', ';font-family:\'OneDotExt\';font-size:.625rem;font-weight:bold;line-height:1.5;position:relative;margin-bottom:40px;max-width:700px;text-transform:uppercase;z-index:1;@media (max-width:', '){font-size:14px;margin-top:5px;}}.eyebrow{bottom:100%;line-height:1;width:100%;z-index:2;h1{font-size:', ';letter-spacing:1.5px;margin-bottom:10px;max-width:320px;width:100%;@media (min-width:', '){margin-left:auto;}@media (min-width:', '){font-size:40px;max-width:none;}@media (min-width:', '){max-width:520px;}}}'], _breakpoints2.default['bp-mobile'], _breakpoints2.default['bp-tablet'], _breakpoints2.default['bp-desktop'], _breakpoints2.default['bp-desktop-l'], _colors2.default['medium-grey'], _breakpoints2.default['bp-mobile'], function (props) {
	  return props.lang.match(/^en/) ? '36px' : '30px';
	}, _breakpoints2.default['bp-mobile'], _breakpoints2.default['bp-tablet'], _breakpoints2.default['bp-desktop']);

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _grid = __webpack_require__(3);
	
	var _Image = __webpack_require__(24);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _styledComponents = __webpack_require__(195);
	
	var _arrowCtaRed = __webpack_require__(100);
	
	var _arrowCtaRed2 = _interopRequireDefault(_arrowCtaRed);
	
	var _arrowCtaBlue = __webpack_require__(99);
	
	var _arrowCtaBlue2 = _interopRequireDefault(_arrowCtaBlue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MoreCities = function MoreCities(_ref) {
	    var data = _ref.data,
	        imageDictionary = _ref.imageDictionary;
	
	    var gaCityClicked = function gaCityClicked(city, state) {
	        window.dataLayer.push({
	            'event': 'citypage-explore:click',
	            'city': city + "," + state
	        });
	    };
	    return _react2.default.createElement(
	        _styledComponents.MoreCitiesWrapper,
	        null,
	        _react2.default.createElement(
	            _grid.Column,
	            { cw: 12, style: { textAlign: 'center' } },
	            _react2.default.createElement(
	                _styledComponents.Title,
	                null,
	                data.title,
	                _react2.default.createElement('span', { className: 'carrot' })
	            )
	        ),
	        data.cities.map(function (city, index) {
	            return _react2.default.createElement(
	                _grid.Column,
	                { key: index, className: 'moreCitiesItem', cw: 4, offset: index === 0 ? 2 : 0, style: { position: 'relative', display: 'flex', flexDirection: 'column' } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'city ' + (index === 0 ? 'left' : 'right') },
	                    city.city
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'state ' + (index === 0 ? 'left' : 'right') },
	                    city.state
	                ),
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: city.link, onClick: function onClick() {
	                            gaCityClicked(city.city, city.state);
	                        } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'imageHolder', style: { width: '100%', background: 'white', position: 'relative' } },
	                        _react2.default.createElement(_Image2.default, { aspectHeight: 5, aspectWidth: 4, sizes: imageDictionary[city.image].sizes, style: { opacity: '0.5' } }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'colorBlock ' + (index === 0 ? 'left' : 'right') },
	                            _react2.default.createElement('div', { className: 'stripes' })
	                        ),
	                        index === 0 && _react2.default.createElement(
	                            'div',
	                            { className: 'arrowCtaHolder left' },
	                            _react2.default.createElement(_arrowCtaRed2.default, null),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'ctaCopy' },
	                                data.cta
	                            )
	                        ),
	                        index === 1 && _react2.default.createElement(
	                            'div',
	                            { className: 'arrowCtaHolder right' },
	                            _react2.default.createElement(_arrowCtaBlue2.default, null),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'ctaCopy' },
	                                data.cta
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'initialsHolder' },
	                    _react2.default.createElement(
	                        'span',
	                        { style: { transform: 'translate3d(0, -30px, 0) rotate(-20deg)' } },
	                        city.initials[0]
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { style: { transform: 'translate3d(0, 120px, 0) rotate(15deg)' } },
	                        city.initials[1]
	                    )
	                )
	            );
	        })
	    );
	};
	
	exports.default = MoreCities;
	module.exports = exports['default'];

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Title = exports.MoreCitiesWrapper = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _grid = __webpack_require__(3);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _gutters = __webpack_require__(12);
	
	var _gutters2 = _interopRequireDefault(_gutters);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MoreCitiesWrapper = exports.MoreCitiesWrapper = (0, _styledComponents2.default)(_grid.Row).withConfig({
	    displayName: 'styled-components__MoreCitiesWrapper',
	    componentId: 'o5z6zp-0'
	})(['.moreCitiesItem{&:last-child{margin-top:200px;padding-bottom:50px;@media (max-width:', '){margin-top:100px;}}.city{font-family:\'OneDotExt\',sans-serif;font-size:33px;font-weight:bold;text-transform:uppercase;margin-bottom:5px;&.left{color:', ';}&.right{color:', ';}}.state{font-family:\'OneDot\',sans-serif;font-size:25px;letter-spacing:2.9px;font-weight:bold;text-transform:uppercase;margin-bottom:30px;}.imageHolder{&:hover{.colorBlock{.stripes{animation-play-state:paused;}}}}}.initialsHolder{font-family:\'OneDotCd\',sans-serif;font-weight:bold;color:', ';position:absolute;right:10%;top:-140px;width:100%;font-size:250px;display:flex;align-items:center;justify-content:flex-end;letter-spacing:10px;z-index:-1;text-transform:uppercase;@media (max-width:', '){display:none;}}.colorBlock{position:absolute;z-index:-1;width:80%;overflow:hidden;&.left{top:33%;left:calc(', ' * -0.8);bottom:calc(', ' * -0.7);@media (max-width:', '){left:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}@media (max-width:', '){left:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}@media (max-width:', '){left:calc(', ' * -1);bottom:calc(', ' * -1);}.arrowCtaHolder{transform:rotate(180deg);transform-origin:center center;}.stripes{background:repeating-linear-gradient(-45deg,', ',', ' 25px,rgba(255,255,255,0.5) 25px,rgba(255,255,255,0.5) 50px);}}&.right{top:33%;right:calc(', ' * -0.8);bottom:calc(', ' * -0.7);@media (max-width:', '){right:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}@media (max-width:', '){right:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}@media (max-width:', '){right:calc(', ' * -1);bottom:calc(', ' * -1);}.stripes{background:repeating-linear-gradient(-45deg,', ',', ' 25px,rgba(255,255,255,0.5) 25px,rgba(255,255,255,0.5) 50px);}}.stripes{position:absolute;top:-75px;left:-75px;right:-75px;bottom:-75px;animation-name:barbersPole;animation-timing-function:linear;animation-iteration-count:infinite;animation-duration:1200ms;animation-play-state:running;@keyframes barbersPole{0%{transform:translate3d(0,0,0)}100%{transform:translate3d(0,72px,0)}}}}.arrowCtaHolder{position:absolute;top:calc(33% - 43px);width:130px;z-index:3;svg{width:100%;}&.left{left:calc(', ' * -0.8);svg{transform-origin:center center;transform:rotate(180deg);}.ctaCopy{right:20%;left:0;}@media (max-width:', '){left:calc(', ' * -0.8);}@media (max-width:', '){left:calc(', ' * -0.8);}@media (max-width:', '){left:calc(', ' * -1);}}&.right{transform-origin:center center;right:calc(', ' * -0.8);.ctaCopy{left:20%;right:0;}@media (max-width:', '){right:calc(', ' * -0.8);}@media (max-width:', '){right:calc(', ' * -0.8);}@media (max-width:', '){right:calc(', ' * -1);}}.ctaCopy{position:absolute;top:0;bottom:0;display:flex;align-items:center;justify-content:center;color:white;font-family:\'OneDotCd\',sans-serif;font-size:18px;font-weight:bold;font-style:italic;text-transform:uppercase;}@media (max-width:', '){position:absolute;&.left{left:25px;background:', ';}&.right{right:25px;background:', ';}z-index:4;bottom:60px;display:inline-block;height:50px;width:100px;border-radius:3px;&.left,&.right{top:auto;bottom:20px;.ctaCopy{left:0;top:0;width:100%;}}svg{display:none;}}}'], _breakpoints2.default['bp-mobile'], _colors2.default['lipstick'], _colors2.default['peacock-blue'], _colors2.default['white-two'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-desktop-l'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-mobile'], _colors2.default['lipstick'], _colors2.default['lipstick'], _gutters2.default['container-gutters-desktop-l'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-mobile'], _colors2.default['peacock-blue'], _colors2.default['peacock-blue'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile'], _breakpoints2.default['bp-mobile'], _colors2.default['lipstick'], _colors2.default['peacock-blue']);
	
	var Title = exports.Title = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__Title',
	    componentId: 'o5z6zp-1'
	})(['display:inline-block;font-family:\'OneDot\';font-size:25px;font-weight:bold;line-height:1.4;letter-spacing:3px;text-align:center;text-transform:uppercase;color:', ';border-bottom:solid 15px ', ';margin-bottom:100px;.carrot{margin-left:5px;display:inline-block;height:15px;width:15px;box-sizing:border-box;transform-origin:center center;border-bottom:5px solid ', ';border-left:5px solid ', ';border-radius:2px;transform:translate(0,-5px) rotate(-45deg);}'], _colors2.default['peacock-blue'], _colors2.default['white-two'], _colors2.default['peacock-blue'], _colors2.default['peacock-blue']);

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(42);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactI18next = __webpack_require__(19);
	
	var _grid = __webpack_require__(3);
	
	var _typography = __webpack_require__(29);
	
	var _nominateBackground = __webpack_require__(304);
	
	var _nominateBackground2 = _interopRequireDefault(_nominateBackground);
	
	var _styledComponents = __webpack_require__(197);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Image from '../../global/media/Image';
	
	var PizzaAd = function (_Component) {
	  _inherits(PizzaAd, _Component);
	
	  function PizzaAd(props) {
	    _classCallCheck(this, PizzaAd);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.scrollTrigger = 0;
	    _this.latestKnownScrollY = 0;
	    _this.ticking = false;
	
	    // bind events to context
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    _this.setScrollTrigger = _this.setScrollTrigger.bind(_this);
	
	    _this.state = {
	      animateIn: false
	    };
	    return _this;
	  }
	
	  PizzaAd.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    document.addEventListener('scroll', this.handleScroll);
	    window.addEventListener('resize', this.setScrollTrigger);
	    setTimeout(function () {
	      _this2.setScrollTrigger();
	    }, 1);
	  };
	
	  PizzaAd.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.removeEventListener('scroll', this.handleScroll);
	    window.removeEventListener('resize', this.setScrollTrigger);
	  };
	
	  PizzaAd.prototype.setScrollTrigger = function setScrollTrigger() {
	    var scrollTop = document.documentElement ? document.documentElement.scrollTop : document.body.scrollTop;
	    var pizzaAdTop = this.pizzaAdHolder.getBoundingClientRect().top;
	    this.scrollTrigger = pizzaAdTop + scrollTop;
	  };
	
	  PizzaAd.prototype.handleScroll = function handleScroll(e) {
	    this.latestKnownScrollY = window.scrollY ? window.scrollY : window.pageYOffset;
	    this.requestTick();
	  };
	
	  PizzaAd.prototype.requestTick = function requestTick() {
	    if (!this.ticking) {
	      requestAnimationFrame(this.update.bind(this));
	    }
	    this.ticking = true;
	  };
	
	  PizzaAd.prototype.update = function update() {
	    this.ticking = false;
	    // const animateInCalc = (this.latestKnownScrollY + window.innerHeight - 200) > this.scrollTrigger;
	    var animateInCalc = this.scrollTrigger - this.latestKnownScrollY < window.innerHeight - window.innerHeight * 0.2;
	    // console.log(animateInCalc);
	    if (animateInCalc !== this.state.animateIn && animateInCalc === true) {
	      this.setState({
	        animateIn: true
	      });
	    }
	  };
	
	  PizzaAd.prototype.gaOrderNowCLicked = function gaOrderNowCLicked() {
	    window.dataLayer.push({
	      'event': 'ordernow:click',
	      'nav': 'body',
	      'navItem': 'Order Now'
	    });
	  };
	
	  PizzaAd.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        data = _props.data,
	        imageDictionary = _props.imageDictionary,
	        t = _props.t;
	
	    return _react2.default.createElement(
	      'div',
	      { ref: function ref(div) {
	          return _this3.pizzaAdHolder = div;
	        } },
	      _react2.default.createElement(
	        _grid.Row,
	        null,
	        _react2.default.createElement(
	          _grid.Column,
	          { cw: 10, offset: 1 },
	          _react2.default.createElement(
	            _styledComponents.Intro,
	            null,
	            t('pizzaAd.intro')
	          )
	        ),
	        _react2.default.createElement(
	          _grid.Column,
	          { cw: 4, offset: 1, style: { position: 'relative', alignItems: 'flex-start' } },
	          _react2.default.createElement(
	            _styledComponents.ColorBlock,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'stripesHolder' },
	              _react2.default.createElement('div', { className: 'stripes' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'imageHolder ' + (this.state.animateIn ? '' : 'passive') },
	              _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/pizza-paddle.png'), alt: 'Pizza Paddle' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _grid.Column,
	          { cw: 5, offset: 2, style: { display: 'flex', flexDirection: 'column' } },
	          _react2.default.createElement(
	            _typography.H1,
	            null,
	            t('pizzaAd.copy')
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: t('pizzaAd.link'), target: '_blank', onClick: this.gaOrderNowCLicked },
	            _react2.default.createElement(
	              _styledComponents.NominateCityButton,
	              null,
	              _react2.default.createElement(_nominateBackground2.default, null),
	              _react2.default.createElement(
	                'div',
	                { className: 'buttonText' },
	                t('pizzaAd.orderCTA')
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return PizzaAd;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.translate)()(PizzaAd);
	module.exports = exports['default'];

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Intro = exports.NominateCityButton = exports.ColorBlock = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _gutters = __webpack_require__(12);
	
	var _gutters2 = _interopRequireDefault(_gutters);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ColorBlock = exports.ColorBlock = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__ColorBlock',
	    componentId: 'sc-1r2f9g5-0'
	})(['position:relative;width:100%;padding-top:60%;margin-bottom:50%;@media (max-width:', '){}@media (max-width:', '){padding-top:100%;}@media (max-width:', '){padding-top:50%;margin-bottom:50px;}&:hover{.stripesHolder{.stripes{animation-play-state:paused;}}}.stripesHolder{position:absolute;top:0;bottom:0;right:0;overflow:hidden;left:calc(', ' * -0.8);@media (max-width:', '){left:calc(', ' * -0.8);}@media (max-width:', '){left:calc(', ' * -0.8);}@media (max-width:', '){left:calc(', ' * -1);right:calc(', ' * -1);}.stripes{position:absolute;top:-75px;left:-75px;right:-75px;bottom:-75px;animation-name:barbersPole;animation-timing-function:linear;animation-iteration-count:infinite;animation-duration:1200ms;animation-play-state:running;@keyframes barbersPole{0%{transform:translate3d(0,0,0)}100%{transform:translate3d(0,72px,0)}}background:repeating-linear-gradient(-45deg,', ',', ' 25px,rgba(255,255,255,0.5) 25px,rgba(255,255,255,0.5) 50px);}}.imageHolder{position:absolute;width:140%;right:0;top:80%;transform-origin:center center;transition:transform 500ms ease-in-out;transform:translate3d(0,0,0);&.passive{transform:translate3d(-200%,0,0);}img{width:100%;height:auto;}@media (max-width:', '){top:20%;width:100%;left:calc(', ' * -1);}}'], _breakpoints2.default['bp-desktop'], _breakpoints2.default['bp-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-mobile'], _colors2.default['peacock-blue'], _colors2.default['peacock-blue'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile']);
	
	var NominateCityButton = exports.NominateCityButton = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__NominateCityButton',
	    componentId: 'sc-1r2f9g5-1'
	})(['overflow:hidden;display:flex;width:100%;cursor:pointer;margin-top:40px;max-width:350px;margin-right:calc(-', ' + ', ' );height:70px;background:', ';color:', ';font-size:18px;text-transform:uppercase;font-family:\'OneDotExt\';flex-direction:column;position:relative;@media (max-width:', '){}@media (max-width:', '){}@media (max-width:', '){width:45%;height:54px;font-size:12px;text-align:center;line-height:1.5;margin:0 auto;margin-top:20px;}.buttonText{position:absolute;color:white;top:0;bottom:0;right:0;left:0;display:flex;align-items:center;justify-content:center;}svg{#dominos-homepage-desktop-state2{fill:#D51A35;}}'], _gutters2.default['container-gutters-desktop-l'], _gutters2.default['column-gutters-desktop-l'], _colors2.default['lipstick'], _colors2.default['white'], _breakpoints2.default['bp-desktop'], _breakpoints2.default['bp-tablet'], _breakpoints2.default['bp-mobile']);
	
	var Intro = exports.Intro = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__Intro',
	    componentId: 'sc-1r2f9g5-2'
	})(['font-family:\'OneDotExt\',sans-serif;text-align:center;width:100%;font-size:16px;line-height:2;letter-spacing:1.8px;font-weight:bold;color:', ';text-transform:uppercase;z-index:1;position:relative;margin-bottom:20px;@media (max-width:', '){font-size:14px;margin-top:20px;}'], _colors2.default['peacock-blue'], _breakpoints2.default['bp-mobile']);

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(3);
	
	var _Image = __webpack_require__(24);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _styledComponents = __webpack_require__(199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Link from 'gatsby-link';
	// import { inject, observer } from 'mobx-react';
	// import styled from 'styled-components';
	// import ReactMapboxGl, { Marker, Feature } from "react-mapbox-gl";
	// import 'mapbox-gl/dist/mapbox-gl.css';
	
	// import StorePin from '../../../static/svgs/pothole-pin.svg';
	
	var MapComponent = null;
	
	/*
	@inject("store")
	@observer class PotholeMap extends Component {
	  constructor(props) {
	    super(props);
	    this.bounds = null;
	    this.state = {
	      bounds: null,
	      markers: null,
	      center: [-98.579439, 39.828409],
	      zoom: [3],
	    }
	    this.onStyleLoad = this.onStyleLoad.bind(this);
	    this.map = null;
	    this.createMarkers = this.createMarkers.bind(this);
	  }
	  componentWillMount() {
	    if (typeof window !== `undefined`) {
	      MapComponent = ReactMapboxGl({
	        accessToken: "pk.eyJ1IjoieW8tZG9taW5vcy1kZXZob3BzIiwiYSI6ImNqaDZzNnh4ejAwZnUyeHBjMDlkOTcxenoifQ.6Y76_f8tj1x6JcxeqJP8oA"
	      });
	    }
	  }
	  componentDidMount() {
	    const { data } = this.props;
	    this.createMarkers(data.potholes);
	  }
	  shouldComponentUpdate() {
	    return true
	  }
	  createMarkers(markersData) {
	    // console.log(markersData);
	    let lats = []; let lngs = [];
	    const markers = markersData.map( (marker, index) => {
	      const latitude = marker[0];
	      const longitude = marker[1];
	      lats.push(latitude);
	      lngs.push(longitude);
	      return (
	        <Marker
	          key={index}
	          coordinates={[longitude, latitude]}
	          anchor="bottom"
	          style={{height:'52px', width:'43px', pointerEvents: 'none', zIndex: '1'}}
	        >
	          <StorePin />
	        </Marker>
	      )
	    });
	    const minLats = Math.min(...lats);
	    const maxLats = Math.max(...lats);
	    const minLongs = Math.min(...lngs);
	    const maxLongs = Math.max(...lngs);
	    const bounds = [[minLongs, minLats],[maxLongs, maxLats]];
	    setTimeout( () => {
	      this.setState({
	        bounds: bounds,
	        markers: markers
	      });
	    }, 500);
	  }
	  onStyleLoad(e) {
	    if(this.map) {
	      this.map.scrollZoom.disable();
	      this.map.doubleClickZoom.disable();
	    }
	  }
	  render() {
	      const { data, store } = this.props;
	        return (
	        <PotholeMapWrapper>
	          <Row margins={true}>
	              <Column cw={12} style={{textAlign: 'center'}}>
	                  <Title>{data.title}</Title>
	              </Column>
	              <Column cw={10} offset={1} style={{position: 'relative'}}>
	                  <div style={{paddingTop: '56.25%', width: '100%'}}></div>
	                  <div style={{
	                      position: 'absolute',
	                      top: 0,
	                      bottom: 0,
	                      right: 0,
	                      left: 0
	                  }}>
	                  { this.state.bounds &&
	                      <MapComponent
	                          // style="mapbox://styles/mapbox/streets-v9"
	                          style="mapbox://styles/yo-dominos-devhops/cjibzx6bj00bz2smc03qtv6c5"
	                          containerStyle={{
	                          height: '100%',
	                          width: '100%'
	                          }}
	                          onStyleLoad={ (el) => {this.map = el; this.onStyleLoad();} }
	                          fitBounds={this.state.bounds}
	                          fitBoundsOptions={{padding: store.isMobile ? 35 : 80}}
	                          scrollZoom={false}
	                          doubleClickZoom={false}
	                      >
	                          { this.state.markers }
	                      </MapComponent>
	                  }
	                  </div>
	              </Column>
	          </Row>
	        </PotholeMapWrapper>
	        )
	  }
	}
	*/
	/**
	 * To avoid mapbox, use a static asset instead.
	 */
	
	var PotholeMap = function (_Component) {
	  _inherits(PotholeMap, _Component);
	
	  function PotholeMap() {
	    _classCallCheck(this, PotholeMap);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PotholeMap.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        imageDictionary = _props.imageDictionary;
	
	    return _react2.default.createElement(
	      _styledComponents.PotholeMapWrapper,
	      null,
	      _react2.default.createElement(
	        _grid.Row,
	        { margins: true },
	        _react2.default.createElement(
	          _grid.Column,
	          { cw: 12, style: { textAlign: 'center' } },
	          _react2.default.createElement(
	            _styledComponents.Title,
	            null,
	            data.title
	          )
	        ),
	        _react2.default.createElement(
	          _grid.Column,
	          { cw: 10, offset: 1, style: { position: 'relative' } },
	          _react2.default.createElement('div', { style: { paddingTop: '56.25%', width: '100%' } }),
	          _react2.default.createElement(
	            'div',
	            { style: {
	                position: 'absolute',
	                top: 0,
	                bottom: 0,
	                right: 0,
	                left: 0
	              } },
	            _react2.default.createElement(_Image2.default, { aspectHeight: 9, aspectWidth: 16, sizes: imageDictionary[data.asset].sizes })
	          )
	        )
	      )
	    );
	  };
	
	  return PotholeMap;
	}(_react.Component);
	
	exports.default = PotholeMap;
	module.exports = exports['default'];

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PotholeMapWrapper = exports.MapEdge = exports.Title = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = exports.Title = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__Title',
	    componentId: 'ob4yf9-0'
	})(['display:inline-block;font-family:\'OneDot\';font-size:25px;font-weight:bold;line-height:1.4;letter-spacing:3px;text-align:center;text-transform:uppercase;color:', ';border-bottom:solid 15px ', ';margin-bottom:100px;'], _colors2.default['peacock-blue'], _colors2.default['white-two']);
	/* import gutters from '../../../vars/gutters'; */
	var MapEdge = exports.MapEdge = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__MapEdge',
	    componentId: 'ob4yf9-1'
	})(['position:absolute;pointer-events:none;', ' ', ' ', ' ', ''], function (props) {
	    return props.left && (0, _styledComponents.css)(['         left:0;top:0;bottom:0;width:120px;background:linear-gradient(to left,rgba(255,255,255,0),rgba(255,255,255,0.05) 10%,rgba(255,255,255,1) 90%,rgba(255,255,255,1));@media (max-width:', '){width:40px;}'], _breakpoints2.default['bp-mobile']);
	}, function (props) {
	    return props.top && (0, _styledComponents.css)(['         left:0;top:0;right:0;height:120px;background:linear-gradient(to top,rgba(255,255,255,0),rgba(255,255,255,0.05) 10%,rgba(255,255,255,1) 90%,rgba(255,255,255,1));@media (max-width:', '){height:40px;}'], _breakpoints2.default['bp-mobile']);
	}, function (props) {
	    return props.right && (0, _styledComponents.css)(['         right:0;top:0;bottom:0;width:120px;background:linear-gradient(to right,rgba(255,255,255,0),rgba(255,255,255,0.05) 10%,rgba(255,255,255,1) 90%,rgba(255,255,255,1));@media (max-width:', '){width:40px;}'], _breakpoints2.default['bp-mobile']);
	}, function (props) {
	    return props.bottom && (0, _styledComponents.css)(['         left:0;right:0;bottom:0;height:120px;background:linear-gradient(to bottom,rgba(255,255,255,0),rgba(255,255,255,0.05) 10%,rgba(255,255,255,1) 90%,rgba(255,255,255,1));@media (max-width:', '){height:40px;}'], _breakpoints2.default['bp-mobile']);
	});
	
	var PotholeMapWrapper = exports.PotholeMapWrapper = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__PotholeMapWrapper',
	    componentId: 'ob4yf9-2'
	})(['']);

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(3);
	
	var _styledComponents = __webpack_require__(201);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProcessCards = function ProcessCards(_ref) {
	    var data = _ref.data;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _grid.Row,
	            { margins: true },
	            _react2.default.createElement(
	                _grid.Column,
	                { cw: 12, style: { textAlign: 'center' } },
	                _react2.default.createElement(
	                    _styledComponents.Title,
	                    null,
	                    data.title
	                )
	            ),
	            _react2.default.createElement(
	                _grid.Column,
	                { cw: 4, style: { display: 'flex', textAlign: 'center', justifyContent: 'center' } },
	                _react2.default.createElement(
	                    _styledComponents.ProcessCard,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'eyebrow' },
	                        data.card1.eyebrow
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'emphasis' },
	                        data.card1.emphasis
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'copy' },
	                        data.card1.copy
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _grid.Column,
	                { cw: 4, style: { display: 'flex', textAlign: 'center', justifyContent: 'center' } },
	                _react2.default.createElement(
	                    _styledComponents.ProcessCard,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'eyebrow' },
	                        data.card2.eyebrow
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'emphasis' },
	                        data.card2.emphasis
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'copy' },
	                        data.card2.copy
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _grid.Column,
	                { cw: 4, style: { display: 'flex', textAlign: 'center', justifyContent: 'center' } },
	                _react2.default.createElement(
	                    _styledComponents.ProcessCard,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'eyebrow' },
	                        data.card3.eyebrow
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'emphasis' },
	                        data.card3.emphasis
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'copy' },
	                        data.card3.copy
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = ProcessCards;
	module.exports = exports['default'];

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Title = exports.ProcessCard = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProcessCard = exports.ProcessCard = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__ProcessCard',
	    componentId: 'sc-13g6lr7-0'
	})(['width:75%;display:inline-block;padding:35px 0;border-top:solid 8px ', ';border-bottom:solid 8px ', ';.eyebrow{font-family:\'OneDotExt\',sans-serif;font-weight:bold;font-size:15px;color:', ';text-transform:uppercase;}.emphasis{font-family:\'OneDotCd\',sans-serif;font-size:45px;font-weight:bold;font-style:italic;color:', ';margin:10px 0;text-transform:uppercase;}.copy{font-family:\'OneDot\';font-weight:300;font-size:16px;line-height:1.44;text-align:center;}'], _colors2.default['peacock-blue'], _colors2.default['peacock-blue'], _colors2.default['peacock-blue'], _colors2.default['lipstick']);
	/* import breakpoints from '../../../vars/breakpoints';
	import gutters from '../../../vars/gutters'; */
	var Title = exports.Title = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__Title',
	    componentId: 'sc-13g6lr7-1'
	})(['display:inline-block;font-family:\'OneDot\';font-size:25px;font-weight:bold;line-height:1.4;letter-spacing:3px;text-align:center;text-transform:uppercase;color:', ';border-bottom:solid 15px ', ';margin-bottom:100px;'], _colors2.default['peacock-blue'], _colors2.default['white-two']);

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(42);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _grid = __webpack_require__(3);
	
	var _styledComponents = __webpack_require__(203);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Quote = function Quote(_ref) {
	  var data = _ref.data,
	      imageDictionary = _ref.imageDictionary;
	
	  if (!data.withImage) {
	    return _react2.default.createElement(
	      _styledComponents.QuoteModule,
	      null,
	      _react2.default.createElement(
	        _grid.Row,
	        { style: { alignItems: 'center' } },
	        _react2.default.createElement(
	          _styledComponents.QuoteWrapper,
	          { cw: 8, offset: 2, color: data.color },
	          _react2.default.createElement(
	            _styledComponents.Statement,
	            { color: data.color },
	            data.quote
	          ),
	          _react2.default.createElement(
	            _styledComponents.Attribution,
	            null,
	            data.attribution
	          )
	        )
	      )
	    );
	  } else {
	    if (data.direction === 'left') {
	      return _react2.default.createElement(
	        _styledComponents.QuoteModule,
	        null,
	        _react2.default.createElement(
	          _grid.Row,
	          null,
	          _react2.default.createElement(
	            _styledComponents.QuoteWrapper,
	            { cw: 7, offset: 1, color: data.color },
	            _react2.default.createElement(
	              _styledComponents.Statement,
	              { color: data.color },
	              data.quote
	            ),
	            _react2.default.createElement(
	              _styledComponents.Attribution,
	              null,
	              data.attribution
	            )
	          ),
	          _react2.default.createElement(
	            _grid.Column,
	            { className: 'imageColumn', cw: 4 },
	            _react2.default.createElement(_gatsbyImage2.default, { sizes: imageDictionary[data.image].sizes })
	          )
	        )
	      );
	    } else {
	      return _react2.default.createElement(
	        _styledComponents.QuoteModule,
	        null,
	        _react2.default.createElement(
	          _grid.Row,
	          null,
	          _react2.default.createElement(
	            _grid.Column,
	            { className: 'imageColumn', cw: 4 },
	            _react2.default.createElement(_gatsbyImage2.default, { sizes: imageDictionary[data.image].sizes })
	          ),
	          _react2.default.createElement(
	            _styledComponents.QuoteWrapper,
	            { cw: 7, offset: 1, color: data.color },
	            _react2.default.createElement(
	              _styledComponents.Statement,
	              { color: data.color },
	              data.quote
	            ),
	            _react2.default.createElement(
	              _styledComponents.Attribution,
	              null,
	              data.attribution
	            )
	          )
	        )
	      );
	    }
	  }
	};
	// import Image from '../../global/media/Image';
	
	exports.default = Quote;
	module.exports = exports['default'];

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Attribution = exports.Statement = exports.QuoteWrapper = exports.QuoteModule = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _grid = __webpack_require__(3);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuoteModule = exports.QuoteModule = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__QuoteModule',
	    componentId: 'immhke-0'
	})(['@media (max-width:', '){.imageColumn{order:2;}}'], _breakpoints2.default['bp-mobile']);
	
	var QuoteWrapper = exports.QuoteWrapper = (0, _styledComponents2.default)(_grid.Column).withConfig({
	    displayName: 'styled-components__QuoteWrapper',
	    componentId: 'immhke-1'
	})(['display:flex;flex-direction:column;align-items:flex-start;position:relative;@media (max-width:', '){margin-bottom:30px;.imageColumn{order:1;}}'], _breakpoints2.default['bp-mobile']);
	
	var Statement = exports.Statement = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__Statement',
	    componentId: 'immhke-2'
	})(['font-family:\'OneDotCd\',sans-serif;font-size:50px;font-weight:bold;color:', ';text-transform:uppercase;font-style:italic;font-weight:bold;width:100%;@media (max-width:', '){font-size:28px;}&::before{font-family:\'OneDotCd\',sans-serif;content:"\\201C";font-weight:bold;color:', ';text-transform:uppercase;font-style:italic;font-weight:bold;position:relative;display:inline-block;}&::after{content:"\\201D";}'], function (props) {
	    return props.color === 'red' ? _colors2.default['lipstick'] : _colors2.default['peacock-blue'];
	}, _breakpoints2.default['bp-mobile'], function (props) {
	    return props.color === 'red' ? _colors2.default['lipstick'] : _colors2.default['peacock-blue'];
	});
	
	var Attribution = exports.Attribution = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__Attribution',
	    componentId: 'immhke-3'
	})(['font-family:\'OneDotExt\',sans-serif;font-size:15px;font-weight:bold;font-style:italic;color:', ';text-transform:uppercase;margin-top:10px;&::before{content:\'\u2014 \';}'], _colors2.default['black']);

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(19);
	
	var _gatsbyImage = __webpack_require__(42);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _styledComponents = __webpack_require__(204);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatCircle = function StatCircle(_ref) {
	  var data = _ref.data,
	      imageDictionary = _ref.imageDictionary,
	      lng = _ref.lng;
	
	  return _react2.default.createElement(
	    _styledComponents.StatCircleElement,
	    { circleColor: data.circleColor },
	    _react2.default.createElement(
	      'div',
	      { className: 'circleLabel' },
	      lng.match(/^en/) && _react2.default.createElement(_gatsbyImage2.default, { sizes: imageDictionary['' + data.image].sizes }),
	      lng === 'es' && _react2.default.createElement(_gatsbyImage2.default, { sizes: imageDictionary[data.image + '-es'].sizes })
	    ),
	    data.number
	  );
	};
	
	exports.default = (0, _reactI18next.translate)()(StatCircle);
	module.exports = exports['default'];

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.StatCircleElement = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _gutters = __webpack_require__(12);
	
	var _gutters2 = _interopRequireDefault(_gutters);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatCircleElement = exports.StatCircleElement = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__StatCircleElement',
	    componentId: 'cqs9eg-0'
	})(['background:', ';height:140px;width:140px;box-sizing:border-box;border-style:solid;border-width:4px;border-radius:75px;border-color:', ';display:flex;align-items:center;justify-content:space-around;font-size:80px;color:', ';font-family:\'OneDotCd\',sans-serif;font-weight:bold;position:relative;.circleLabel{position:absolute;top:-20px;bottom:-20px;left:-20px;right:-20px;}@media (max-width:', '){height:85px;width:85px;font-size:46px;}'], function (props) {
	    return props.circleColor === 'black' ? _colors2.default['black'] : _colors2.default['white'];
	}, function (props) {
	    return props.circleColor === 'black' ? _colors2.default['black'] : props.circleColor === 'red' ? _colors2.default['lipstick'] : _colors2.default['peacock-blue'];
	}, function (props) {
	    return props.circleColor === 'black' ? _colors2.default['white'] : props.circleColor === 'red' ? _colors2.default['lipstick'] : _colors2.default['peacock-blue'];
	}, _breakpoints2.default['bp-mobile']);

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(3);
	
	var _styledComponents = __webpack_require__(206);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextBlock = function TextBlock(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _grid.Row,
	      { margins: true },
	      _react2.default.createElement(
	        _grid.Column,
	        { cw: 6, offset: 3, tcw: 8, tOffset: 2 },
	        _react2.default.createElement(
	          _styledComponents.Text,
	          null,
	          data.text
	        )
	      )
	    )
	  );
	};
	
	exports.default = TextBlock;
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Text = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Text = exports.Text = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__Text',
	    componentId: 'sc-1xqkg8n-0'
	})(['color:', ';font-size:20px;font-family:\'OneDot\',sans-serif;line-height:1.75;font-weight:300;'], _colors2.default['black']);
	/* import breakpoints from '../../../vars/breakpoints';
	import gutters from '../../../vars/gutters'; */

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(22);
	
	var _grid = __webpack_require__(3);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _styledComponents = __webpack_require__(208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Ticker = (_dec = (0, _mobxReact.inject)("store"), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
	  _inherits(Ticker, _Component);
	
	  function Ticker(props) {
	    _classCallCheck(this, Ticker);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      dials: null,
	      active: false
	    };
	
	    _this.scrollPoint = null;
	    _this.tickerRow = null;
	
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    _this.setScrollPoint = _this.setScrollPoint.bind(_this);
	    _this.getPosition = _this.getPosition.bind(_this);
	    _this.setTickerRow = _this.setTickerRow.bind(_this);
	    return _this;
	  }
	
	  Ticker.prototype.componentDidMount = function componentDidMount() {
	    var store = this.props.store;
	    var number = this.props.data.number;
	
	    if (store.os.name === 'ios') {
	      this.setState({
	        dials: _react2.default.createElement(
	          'span',
	          null,
	          number
	        )
	      });
	    } else {
	      this.getDialNumbers(number);
	    }
	    document.addEventListener('scroll', this.handleScroll);
	    window.addEventListener('resize', this.setScrollPoint);
	  };
	
	  Ticker.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.removeEventListener('scroll', this.handleScroll);
	    window.removeEventListener('resize', this.setScrollPoint);
	  };
	
	  Ticker.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	    return true;
	  };
	
	  Ticker.prototype.setTickerRow = function setTickerRow(el) {
	    if (el) {
	      this.tickerRow = el;
	      this.setScrollPoint();
	    }
	  };
	
	  Ticker.prototype.setScrollPoint = function setScrollPoint() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      var scrollTop = document.documentElement ? document.documentElement.scrollTop : document.body.scrollTop;
	      // const tickerTop = this.tickerRow.getBoundingClientRect().top;
	      var tickerTop = _this2.getPosition(_this2.tickerRow);
	      var tickerHeight = _this2.tickerRow.getBoundingClientRect().height;
	      _this2.scrollPoint = tickerTop.y - window.innerHeight + tickerHeight / 4;
	    }, 300);
	  };
	
	  Ticker.prototype.handleScroll = function handleScroll(e) {
	    var scrollY = window.scrollY ? window.scrollY : window.pageYOffset;
	    if (this.scrollPoint < scrollY && !this.state.active) {
	      this.setState({
	        active: true
	      });
	    }
	  };
	
	  Ticker.prototype.getPosition = function getPosition(element) {
	    var xPosition = 0;
	    var yPosition = 0;
	
	    while (element) {
	      xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft;
	      yPosition += element.offsetTop - element.scrollTop + element.clientTop;
	      element = element.offsetParent;
	    }
	
	    return { x: xPosition, y: yPosition };
	  };
	
	  Ticker.prototype.getDialNumbers = function getDialNumbers(number) {
	    var numberArray = number.split('');
	    var dialNumbers = numberArray.map(function (element, index) {
	      var dial = [];
	      var numberAsInt = parseInt(element);
	      if (index !== 0) {
	        for (var i = 0; i < 10 * index + 1; i++) {
	          var displayNum = numberAsInt + i;
	          if (displayNum >= 10) {
	            var stringNum = displayNum.toString();
	            displayNum = stringNum[stringNum.length - 1];
	          }
	          dial.push(displayNum);
	        }
	      } else {
	        for (var _i = 0; _i <= numberAsInt; _i++) {
	          dial.push(_i);
	        }
	      }
	      return dial;
	    });
	    var dials = this.buildDials(dialNumbers);
	    this.setState({
	      dials: dials
	    });
	  };
	
	  Ticker.prototype.buildDials = function buildDials(dialNumbers) {
	    var _this3 = this;
	
	    var dials = dialNumbers.map(function (element, index) {
	      var comma = index + 1 !== dialNumbers.length && (dialNumbers.length - (index + 1)) % 3 === 0;
	      return _react2.default.createElement(
	        'span',
	        { key: index },
	        _react2.default.createElement(
	          'div',
	          { className: 'dialWrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'dial', style: {
	                transitionDuration: 1000 + 300 * (index + 1) + 'ms'
	              } },
	            _this3.buildDial(element)
	          )
	        ),
	        comma && _react2.default.createElement(
	          'div',
	          { className: 'comma' },
	          ','
	        )
	      );
	    });
	    return dials;
	  };
	
	  Ticker.prototype.buildDial = function buildDial(numbers) {
	    var dial = numbers.map(function (number, index) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'dialNumber', key: index },
	        number
	      );
	    });
	    return dial.reverse();
	  };
	
	  Ticker.prototype.render = function render() {
	    var data = this.props.data;
	
	
	    return _react2.default.createElement(
	      'div',
	      { ref: this.setTickerRow },
	      _react2.default.createElement(
	        _grid.Row,
	        { margins: true },
	        _react2.default.createElement(
	          _grid.Column,
	          { cw: 8, offset: 2 },
	          _react2.default.createElement(
	            _styledComponents.TickerWrapper,
	            { active: this.state.active, className: '' + (this.state.active ? 'active' : '') },
	            data.numberType === 'money' && _react2.default.createElement(
	              'span',
	              null,
	              '$'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'fullText' },
	              _react2.default.createElement(
	                'span',
	                { className: 'number', style: { color: '' + _colors2.default['lipstick'] } },
	                this.state.dials
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                data.label
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Ticker;
	}(_react.Component)) || _class) || _class);
	exports.default = Ticker;
	module.exports = exports['default'];

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TickerWrapper = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TickerWrapper = exports.TickerWrapper = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__TickerWrapper',
	    componentId: 'sc-8ofcxc-0'
	})(['font-size:80px;font-family:\'OneDotCd\',sans-serif;font-weight:bold;color:', ';line-height:1;display:flex;justify-content:center;flex-wrap:wrap;@media (max-width:', '){font-size:60px;}> span{display:flex;}.dialWrapper,.comma{display:inline-block;height:69px;overflow:hidden;position:relative;opacity:', ';@media (max-width:', '){height:52px;transform:translate(0,1px);}}&.active{.dial{transform:translate3d(0,0,0);}}.dial{display:inline-block;transition-property:transform;transition-timing-function:linear;transform:translate3d(0,-100%,0);}@keyframes dialanimation{0%{transform:translate3d(0,calc(-100% * ( 10/11 )),0)}100%{transform:translate3d(0,0,0)}}.fullText{text-align:center;display:inline-block;text-transform:uppercase;.label{color:', ';}@media (max-width:', '){.number{display:block;}.label{font-size:42px;}}}'], _colors2.default['lipstick'], _breakpoints2.default['bp-desktop'], function (props) {
	    return props.active ? '1' : '0';
	}, _breakpoints2.default['bp-desktop'], _colors2.default['peacock-blue'], _breakpoints2.default['bp-mobile']);
	/* import gutters from '../../../vars/gutters'; */

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(42);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _grid = __webpack_require__(3);
	
	var _Image = __webpack_require__(24);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _styledComponents = __webpack_require__(210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TwoUp = function (_Component) {
	  _inherits(TwoUp, _Component);
	
	  function TwoUp(props) {
	    _classCallCheck(this, TwoUp);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.vanishingPoint = 0;
	    _this.latestKnownScrollY = 0;
	    _this.ticking = false;
	
	    // bind events to context
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    _this.setVanishingPoint = _this.setVanishingPoint.bind(_this);
	
	    _this.state = {
	      positioningValue: 0
	    };
	    return _this;
	  }
	
	  TwoUp.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    document.addEventListener('scroll', this.handleScroll);
	    window.addEventListener('resize', this.setVanishingPoint);
	    setTimeout(function () {
	      _this2.setVanishingPoint();
	    }, 1);
	  };
	
	  TwoUp.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.removeEventListener('scroll', this.handleScroll);
	    window.removeEventListener('resize', this.setVanishingPoint);
	  };
	
	  TwoUp.prototype.setVanishingPoint = function setVanishingPoint() {
	    var scrollTop = document.documentElement ? document.documentElement.scrollTop : document.body.scrollTop;
	    var twoUpTop = this.twoUpHolder.getBoundingClientRect().top;
	    var twoUpHeight = this.twoUpHolder.getBoundingClientRect().height;
	    this.vanishingPoint = scrollTop + twoUpTop + twoUpHeight / 2;
	  };
	
	  TwoUp.prototype.handleScroll = function handleScroll(e) {
	    this.latestKnownScrollY = window.scrollY ? window.scrollY : window.pageYOffset;
	    // this.requestTick();
	  };
	
	  TwoUp.prototype.requestTick = function requestTick() {
	    if (!this.ticking) {
	      requestAnimationFrame(this.update.bind(this));
	    }
	    this.ticking = true;
	  };
	
	  TwoUp.prototype.update = function update() {
	    this.ticking = false;
	    var posValCalc = 1 - (window.innerHeight - (this.vanishingPoint - this.latestKnownScrollY)) / window.innerHeight;
	    var positioningValue = 0;
	    if (posValCalc < 1 && posValCalc > 0) {
	      positioningValue = Math.round((1 - posValCalc) * 100) / 100;
	    } else if (posValCalc < 0) {
	      positioningValue = 1;
	    } else {
	      positioningValue = 0;
	    }
	    if (positioningValue !== this.state.positioningValue) {
	      this.setState({
	        positioningValue: positioningValue
	      });
	    }
	  };
	
	  TwoUp.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        data = _props.data,
	        imageDictionary = _props.imageDictionary;
	
	    return _react2.default.createElement(
	      'div',
	      { ref: function ref(div) {
	          return _this3.twoUpHolder = div;
	        } },
	      _react2.default.createElement(
	        _grid.Row,
	        { margins: [160, 150, 150], style: { alignItems: 'flex-start' } },
	        data.images.map(function (imageKey, index) {
	          return _react2.default.createElement(
	            _grid.Column,
	            { offset: index === 0 ? 1 : 0, cw: 5, key: index },
	            _react2.default.createElement(
	              _styledComponents.TwoUpImage,
	              { imageIndex: index, color: data.color },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_Image2.default, { aspectHeight: 5, aspectWidth: 4, sizes: imageDictionary[imageKey].sizes })
	              ),
	              data.direction === 'left' && index === 0 && _react2.default.createElement(
	                'div',
	                { className: 'twoUpBackground left' },
	                _react2.default.createElement('div', { className: 'colorBlock' })
	              ),
	              data.direction === 'right' && index === 1 && _react2.default.createElement(
	                'div',
	                { className: 'twoUpBackground right' },
	                _react2.default.createElement('div', { className: 'colorBlock' })
	              )
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return TwoUp;
	}(_react.Component);
	
	exports.default = TwoUp;
	module.exports = exports['default'];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TwoUpImage = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _breakpoints = __webpack_require__(7);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _gutters = __webpack_require__(12);
	
	var _gutters2 = _interopRequireDefault(_gutters);
	
	var _colors = __webpack_require__(5);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TwoUpImage = exports.TwoUpImage = _styledComponents2.default.div.withConfig({
	    displayName: 'styled-components__TwoUpImage',
	    componentId: 'sc-1hxt40n-0'
	})(['position:relative;width:100%;', ' @media (max-width:', '){', '}@media (max-width:', '){', '}@media (max-width:', '){margin-top:20px;margin-bottom:40px;}.twoUpBackground{position:absolute;z-index:-1;width:80%;overflow:hidden;&.left{top:55%;left:calc(', ' * -0.8);bottom:calc(', ' * -0.7);@media (max-width:', '){left:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}@media (max-width:', '){left:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}@media (max-width:', '){top:25%;left:calc(', ' * -0.8);bottom:calc(', ' * -0.7);}}&.right{bottom:55%;right:calc(', ' * -0.8);top:calc(', ' * -0.7);@media (max-width:', '){right:calc(', ' * -0.8);top:calc(', ' * -0.7);}@media (max-width:', '){right:calc(', ' * -0.8);top:calc(', ' * -0.7);}@media (max-width:', '){right:calc(', ' * -0.8);top:calc(', ' * -0.7);}}.colorBlock{position:absolute;top:-75px;left:-75px;right:-75px;bottom:-75px;background:repeating-linear-gradient(-45deg,', ',', ' 25px,rgba(255,255,255,0.5) 25px,rgba(255,255,255,0.5) 50px);animation-name:barbersPole;animation-timing-function:linear;animation-iteration-count:infinite;animation-duration:1200ms;animation-play-state:running;@keyframes barbersPole{0%{transform:translate3d(0,0,0)}100%{transform:translate3d(0,72px,0)}}}}&:hover{.colorBlock{animation-play-state:paused;}}'], function (props) {
	    return props.imageIndex % 2 === 1 && (0, _styledComponents.css)(['margin-top:140px;']);
	}, _breakpoints2.default['bp-desktop'], function (props) {
	    return props.imageIndex % 2 === 1 && (0, _styledComponents.css)(['margin-top:100px;']);
	}, _breakpoints2.default['bp-tablet'], function (props) {
	    return props.imageIndex % 2 === 1 && (0, _styledComponents.css)(['margin-top:80px;']);
	}, _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-desktop-l'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-desktop-l'], _gutters2.default['container-gutters-desktop-l'], _breakpoints2.default['bp-desktop'], _gutters2.default['container-gutters-desktop'], _gutters2.default['container-gutters-desktop'], _breakpoints2.default['bp-tablet'], _gutters2.default['container-gutters-tablet'], _gutters2.default['container-gutters-tablet'], _breakpoints2.default['bp-mobile'], _gutters2.default['container-gutters-mobile'], _gutters2.default['container-gutters-mobile'], function (props) {
	    return props.color === 'blue' ? _colors2.default['peacock-blue'] : _colors2.default['lipstick'];
	}, function (props) {
	    return props.color === 'blue' ? _colors2.default['peacock-blue'] : _colors2.default['lipstick'];
	});

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TwoUp = __webpack_require__(209);
	
	var _TwoUp2 = _interopRequireDefault(_TwoUp);
	
	var _LargeText = __webpack_require__(193);
	
	var _LargeText2 = _interopRequireDefault(_LargeText);
	
	var _CaseStudyThumb = __webpack_require__(181);
	
	var _CaseStudyThumb2 = _interopRequireDefault(_CaseStudyThumb);
	
	var _Quote = __webpack_require__(202);
	
	var _Quote2 = _interopRequireDefault(_Quote);
	
	var _Carousel = __webpack_require__(179);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _CampaignSummary = __webpack_require__(177);
	
	var _CampaignSummary2 = _interopRequireDefault(_CampaignSummary);
	
	var _InProgress = __webpack_require__(189);
	
	var _InProgress2 = _interopRequireDefault(_InProgress);
	
	var _TextBlock = __webpack_require__(205);
	
	var _TextBlock2 = _interopRequireDefault(_TextBlock);
	
	var _PizzaAd = __webpack_require__(196);
	
	var _PizzaAd2 = _interopRequireDefault(_PizzaAd);
	
	var _FullWidthAsset = __webpack_require__(185);
	
	var _FullWidthAsset2 = _interopRequireDefault(_FullWidthAsset);
	
	var _ProcessCards = __webpack_require__(200);
	
	var _ProcessCards2 = _interopRequireDefault(_ProcessCards);
	
	var _PotholeMap = __webpack_require__(198);
	
	var _PotholeMap2 = _interopRequireDefault(_PotholeMap);
	
	var _Ticker = __webpack_require__(207);
	
	var _Ticker2 = _interopRequireDefault(_Ticker);
	
	var _MoreCities = __webpack_require__(194);
	
	var _MoreCities2 = _interopRequireDefault(_MoreCities);
	
	var _ItemizedList = __webpack_require__(191);
	
	var _ItemizedList2 = _interopRequireDefault(_ItemizedList);
	
	var _CitiesLists = __webpack_require__(183);
	
	var _CitiesLists2 = _interopRequireDefault(_CitiesLists);
	
	var _ImageGallery = __webpack_require__(187);
	
	var _ImageGallery2 = _interopRequireDefault(_ImageGallery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageBuilder = function (_Component) {
	  _inherits(PageBuilder, _Component);
	
	  function PageBuilder(props) {
	    _classCallCheck(this, PageBuilder);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = { prettier: true };
	    return _this;
	  }
	
	  PageBuilder.prototype.render = function render() {
	    var _props = this.props,
	        modules = _props.modules,
	        imageDictionary = _props.imageDictionary,
	        videoDictionary = _props.videoDictionary;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      modules.map(function (module, index) {
	        switch (module.type) {
	          case 'two-up':
	            return _react2.default.createElement(_TwoUp2.default, {
	              data: module,
	              imageDictionary: imageDictionary,
	              key: index
	            });
	            break;
	          case 'large-text':
	            return _react2.default.createElement(_LargeText2.default, { data: module, key: index });
	            break;
	          case 'case-study-thumb':
	            return _react2.default.createElement(_CaseStudyThumb2.default, {
	              data: module,
	              key: index,
	              imageDictionary: imageDictionary
	            });
	            break;
	          case 'quote':
	            return _react2.default.createElement(_Quote2.default, {
	              data: module,
	              imageDictionary: imageDictionary,
	              key: index
	            });
	            break;
	          case 'carousel':
	            return _react2.default.createElement(_Carousel2.default, {
	              data: module,
	              key: index,
	              imageDictionary: imageDictionary
	            });
	            break;
	          case 'campaign-summary':
	            return _react2.default.createElement(_CampaignSummary2.default, {
	              data: module,
	              key: index,
	              imageDictionary: imageDictionary
	            });
	            break;
	          case 'in-progress':
	            return _react2.default.createElement(_InProgress2.default, {
	              data: module,
	              key: index,
	              imageDictionary: imageDictionary
	            });
	            break;
	          case 'textblock':
	            return _react2.default.createElement(_TextBlock2.default, { data: module, key: index });
	            break;
	          case 'pizza-ad':
	            return _react2.default.createElement(_PizzaAd2.default, {
	              data: module,
	              imageDictionary: imageDictionary,
	              key: index
	            });
	            break;
	          case 'full-width-asset':
	            return _react2.default.createElement(_FullWidthAsset2.default, {
	              data: module,
	              imageDictionary: imageDictionary,
	              key: index,
	              videoDictionary: videoDictionary
	            });
	            break;
	          case 'process-cards':
	            return _react2.default.createElement(_ProcessCards2.default, { data: module, key: index });
	            break;
	          case 'pothole-map':
	            return _react2.default.createElement(_PotholeMap2.default, { data: module, key: index, imageDictionary: imageDictionary });
	            break;
	          case 'ticker':
	            return _react2.default.createElement(_Ticker2.default, { data: module, key: index });
	            break;
	          case 'more-cities':
	            return _react2.default.createElement(_MoreCities2.default, {
	              data: module,
	              key: index,
	              imageDictionary: imageDictionary
	            });
	            break;
	          case 'itemized-list':
	            return _react2.default.createElement(_ItemizedList2.default, { data: module, key: index });
	            break;
	          case 'cities-lists':
	            return _react2.default.createElement(_CitiesLists2.default, { data: module, key: index });
	            break;
	          case 'image-gallery':
	            return _react2.default.createElement(_ImageGallery2.default, {
	              data: module,
	              key: index,
	              imageDictionary: imageDictionary
	            });
	            break;
	        }
	      })
	    );
	  };
	
	  return PageBuilder;
	}(_react.Component);
	
	exports.default = PageBuilder;
	module.exports = exports['default'];

/***/ }),

/***/ 137:
/***/ (function(module, exports) {

	module.exports = {"siteTitle":"Domino's Paving for Pizza","siteDescription":"Bad roads shouldn't happen to good pizza, no matter where you carry out. So we're paving in all 50 states. See where we've been and where we're going next.","header":{"nominateCta":"Nominate your town","closeModalCta":"Close"},"footer":{"offerDisclaimer":"Carryout only. You must ask for this limited time offer. Prices, participation and charges may vary.","copyright":"©2018 Domino’s IP Holder LLC. Domino’s®, Domino’s Pizza® and the modular logo are registered trademarks of Domino’s IP Holder LLC.","message":"Domino's is donating funds to select municipalities to improve road conditions, but is not responsible for coordinating or conducting actual repairs."},"stamps":["stripes","stripes","stripes","stripes"],"home":{"slug":"homepage","hero":{"impactMeterLabel":"Pothole impact meter","pizzaDamageLabel":"Pizza Damage Report","roadConditionDegrees":["Mild","Moderate","Critical","Catastrophic"],"controlLabel":"Road Condition","introCopy":"BAD ROADS SHOULDN'T HAPPEN TO GOOD PIZZA.","stamp":"Choose a road condition to see what happens."},"campaignIntro":{"eyebrow":"We're not done 'til this map says we are.","eyebrowColor":"blue","type":"campaign-intro","text":"Bad roads shouldn’t happen to good pizza, no matter where you carry out. So we’re paving all 50 states. See where we’ve been, and nominate your town for a chance to be next."},"modules":[{"type":"cities-lists","completed":{"title":"Where We've Been","cities":[{"city":"Bartonville,","state":"Texas","link":"/bartonville-tx"},{"city":"Athens,","state":"Georgia","link":"/athens-ga"},{"city":"Burbank,","state":"California","link":"/burbank-ca"},{"city":"Milford,","state":"Delaware","link":"/milford-de"},{"city":"Des Moines,","state":"Iowa","link":"/des-moines-ia"},{"city":"Wilkes-Barre,","state":"Pennsylvania","link":"/wilkes-barre-pa"},{"city":"Fitchburg,","state":"Massachusetts","link":"/fitchburg-ma"},{"city":"Anchorage","state":"Alaska"},{"city":"Mobile","state":"Alabama"},{"city":"Fayetteville","state":"Arkansas"},{"city":"Kingman","state":"Arizona"},{"city":"Littleton","state":"Colorado"},{"city":"New Haven","state":"Connecticut"},{"city":"Miami-Dade County","state":"Florida"},{"city":"Hilo","state":"Hawaii"},{"city":"Rexburg","state":"Idaho"},{"city":"Richton Park","state":"Illinois"},{"city":"South Bend","state":"Indiana"},{"city":"McPherson","state":"Kansas"},{"city":"Lexington","state":"Kentucky"},{"city":"New Orleans","state":"Louisiana"},{"city":"Cumberland","state":"Maryland"},{"city":"Sanford","state":"Maine"},{"city":"Hamtramck","state":"Michigan"},{"city":"Duluth","state":"Minnesota"},{"city":"St. Claire","state":"Missouri"},{"city":"Jackson","state":"Mississippi"},{"city":"Havre","state":"Montana"},{"city":"Kinston","state":"North Carolina"},{"city":"Grand Forks","state":"North Dakota"},{"city":"Bellevue","state":"Nebraska"},{"city":"Berlin","state":"New Hampshire"},{"city":"Berkeley Heights","state":"New Jersey"},{"city":"Albuquerque","state":"New Mexico"},{"city":"Carson City","state":"Nevada"},{"city":"Lockport","state":"New York"},{"city":"Toledo","state":"Ohio"},{"city":"Durant","state":"Oklahoma"},{"city":"Coos Bay","state":"Oregon"},{"city":"Woonsocket","state":"Rhode Island"},{"city":"Simpsonville","state":"South Carolina"},{"city":"Rapid City","state":"South Dakota"},{"city":"Chattanooga","state":"Tennessee"},{"city":"Marion","state":"Texas"},{"city":"Ogden","state":"Utah"},{"city":"Buena Vista","state":"Virginia"},{"city":"Rutland","state":"Vermont"},{"city":"Walla Walla","state":"Washington"},{"city":"Milwaukee","state":"Wisconsin"},{"city":"Parkersburg","state":"West Virginia"},{"city":"Laramie","state":"Wyoming"}]},"upcoming":{"title":"Where We're Going","teaserText":"Check back for updates on our progress toward all 50 states.","cities":[]}},{"type":"image-gallery","title":"See pizza lovers at work:","images":[{"asset":"gallery-albuquerque-nm-1","city":"Albuquerque","state":"NM"},{"asset":"gallery-hamtramck-mi-3","city":"Hamtramck","state":"MI"},{"asset":"gallery-marion-tx-2","city":"Marion","state":"TX"},{"asset":"gallery-havre-mt-1","city":"Havre","state":"MT"},{"asset":"gallery-grand-forks-nd-1","city":"Grand Forks","state":"ND"},{"asset":"gallery-kinston-nc-1","city":"Kinston","state":"NC"},{"asset":"gallery-milwaukee-wi-1","city":"Milwaukee","state":"WI"},{"asset":"gallery-hamtramck-mi-1","city":"Hamtramck","state":"MI"},{"asset":"gallery-hamtramck-mi-2","city":"Hamtramck","state":"MI"},{"asset":"gallery-jackson-ms-1","city":"Jackson","state":"MS"},{"asset":"gallery-kinston-nc-2","city":"Kinston","state":"NC"},{"asset":"gallery-marion-tx-1","city":"Marion","state":"TX"},{"asset":"gallery-havre-mt-2","city":"Havre","state":"MT"},{"asset":"gallery-grand-forks-nd-2","city":"Grand Forks","state":"ND"},{"asset":"gallery-anchorage-ak","city":"Anchorage","state":"AK"},{"asset":"gallery-coos-bay-or","city":"Coos Bay","state":"OR"},{"asset":"gallery-laramie-wy","city":"Laramie","state":"WY"},{"asset":"gallery-lexington-ky","city":"Lexington","state":"KY"},{"asset":"gallery-littleton-co","city":"Littleton","state":"CO"},{"asset":"gallery-ogden-ut","city":"Ogden","state":"UT"},{"asset":"gallery-southbend-in","city":"South Bend","state":"IN"},{"asset":"gallery-st-claire-mo","city":"St. Claire","state":"MO"}]},{"type":"pizza-ad","intro":"Is all this talk of pizza making you hungry?","copy":"Carry out Large 3‑topping Pizzas $7.99 each","orderCTA":"order now","image":"pizza-paddle","link":"https://www.dominos.com/en/pages/order/?clearOrder=1&couponCode=9174#!/locations/search/"}]},"pages":[{"slug":"bartonville-tx","hero":{"city":"Bartonville","state":"Texas","initials":"TX","assetType":"image","asset":"bart_header","datapoint":{"image":"potholesfixed-black","number":"8","circleColor":"black"}},"modules":[{"type":"two-up","direction":"left","color":"blue","images":["bartonville_street_sign","bartonville_road_spray"]},{"type":"ticker","numberType":"stat","number":"75","label":"tons of asphalt"},{"type":"itemized-list","title":"paving report","list":[{"number":"8","label":"Potholes Fixed"},{"number":"3","label":"roads repaired"},{"number":"8","label":"Hours Worked"}]},{"type":"full-width-asset","assetType":"video","color":"blue","assetMp4":"bartonville_yes_we_did-1","assetWebM":"bartonville_yes_we_did-2"},{"type":"more-cities","title":"Explore More Towns","cta":"Explore","cities":[{"city":"Wilkes-Barre","state":"Pennsylvania","initials":"PA","image":"wilkes-barre-hero","link":"/wilkes-barre-pa"},{"city":"Milford","state":"Delaware","initials":"DE","image":"de_header","link":"/milford-de"}]}]},{"slug":"burbank-ca","hero":{"city":"Burbank","state":"California","initials":"CA","assetType":"image","asset":"ca-burbank","datapoint":{"image":"potholesfixed-black","number":"5","circleColor":"black"}},"modules":[{"type":"two-up","direction":"left","color":"red","images":["ca_1","ca_2"]},{"type":"itemized-list","title":"paving report","list":[{"number":"5","label":"Potholes Fixed"},{"number":"1","label":"road repaired"},{"number":"8","label":"Hours Worked"},{"number":"5","label":"crewmembers"}]},{"type":"full-width-asset","assetType":"image","color":"blue","asset":"ca_5"},{"type":"more-cities","title":"Explore More Towns","cta":"Explore","cities":[{"city":"Bartonville","state":"Texas","initials":"TX","image":"bart_header","link":"/bartonville-tx"},{"city":"Athens","state":"Georgia","initials":"GA","image":"athens_header","link":"/athens-ga"}]}]},{"slug":"athens-ga","hero":{"city":"Athens","state":"Georgia","initials":"GA","assetType":"image","asset":"ga_header","datapoint":{"image":"square-yards-fixed","number":"150","circleColor":"black"}},"modules":[{"type":"two-up","direction":"left","color":"blue","images":["athens_road_sign-1","athens_road_sign-2"]},{"type":"quote","withImage":false,"color":"red","quote":"We were intrigued by this unique public-private partnership. This was certainly a new type of opportunity for us.","attribution":"Stephen Bailey, Program Development Coordinator, Athens, GA"},{"type":"ticker","numberType":"stat","number":"150","label":"square yards of failing roadway repaved"},{"type":"itemized-list","title":"paving report","list":[{"number":"3","label":"Hours Worked"},{"number":"12","label":"crewmembers"}]},{"type":"more-cities","title":"Explore More Towns","cta":"Explore","cities":[{"city":"Burbank","state":"California","initials":"CA","image":"ca-burbank","link":"/burbank-ca"},{"city":"Des Moines","state":"Iowa","initials":"IA","image":"des-moines-ia-hero","link":"/des-moines-ia"}]}]},{"slug":"milford-de","hero":{"city":"Milford","state":"Delaware","initials":"DE","assetType":"image","asset":"de_header","datapoint":{"image":"potholesfixed-black","number":"40","circleColor":"black"}},"modules":[{"type":"two-up","direction":"left","color":"blue","images":["de_image_1","de_image_2"]},{"type":"ticker","numberType":"stat","number":"40","label":"Potholes fixed"},{"type":"itemized-list","title":"paving report","list":[{"number":"10","label":"Roads repaired"},{"number":"10","label":"Hours Worked"},{"number":"4","label":"crewmembers"}]},{"type":"pothole-map","title":"Where They Paved","asset":"MilfordDEPotholeMap","potholes":[[38.931175,-75.455078],[38.931698,-75.45492],[38.931097,-75.45507],[38.898572,-75.422964],[38.903425,-75.424397],[38.917656,-75.445365],[38.915047,-75.437925]]},{"type":"more-cities","title":"Explore More Towns","cta":"Explore","cities":[{"city":"Burbank","state":"California","initials":"CA","image":"ca-burbank","link":"/burbank-ca"},{"city":"Bartonville","state":"Texas","initials":"TX","image":"bart_header","link":"/bartonville-tx"}]}]},{"slug":"wilkes-barre-pa","hero":{"city":"Wilkes-Barre","state":"Pennsylvania","initials":"PA","assetType":"image","asset":"wilkes-barre-hero","datapoint":{"image":"stamp-tons-of-asphalt","number":"3","circleColor":"black"}},"modules":[{"type":"two-up","direction":"left","color":"blue","images":["wilkes-barre-2","wilkes-barre-1"]},{"type":"quote","withImage":false,"color":"red","quote":"From an Operational standpoint, I am extremely pleased that the city was able to secure the Domino’s pothole grant. Considering the difficult winters we experience, potholes are a part of our lives here in northeastern Pennsylvania. This money will add to what is an almost depleted pothole patching budget for 2018.","attribution":"Butch Frati, Director of Operations, City of Wilkes-Barre, PA"},{"type":"itemized-list","title":"paving report","list":[{"number":"3","label":"tons of material"},{"number":"4","label":"crewmembers"},{"number":"3,200","label":"square feet of pothole coverage"}]},{"type":"more-cities","title":"Explore More Towns","cta":"Explore","cities":[{"city":"Fitchburg","state":"Massachusetts","initials":"MA","image":"fitchburg-ma-hero","link":"/fitchburg-ma"},{"city":"Bartonville","state":"Texas","initials":"TX","image":"bart_header","link":"/bartonville-tx"}]}]},{"slug":"fitchburg-ma","hero":{"city":"Fitchburg","state":"Massachusetts","initials":"MA","assetType":"image","asset":"fitchburg-ma-hero","datapoint":{"image":"stamp-tons-of-asphalt","number":"60","circleColor":"black"}},"modules":[{"type":"two-up","direction":"left","color":"blue","images":["fitchburg-ma-1","fitchburg-ma-2"]},{"type":"quote","withImage":false,"color":"red","quote":"With over 240 miles of road in our City, our DPW makes every effort to address our road infrastructure, including potholes. Domino’s Paving for Pizza is a great opportunity for Fitchburg to participate in. Thank you Domino’s Pizza!","attribution":"Mayor Stephen L. DiNatale, Fitchburg, Ma"},{"type":"itemized-list","title":"paving report","list":[{"number":"56","label":"hours worked"},{"number":"3","label":"crewmembers"}]},{"type":"full-width-asset","assetType":"image","color":"blue","asset":"fitchburg-ma-3"},{"type":"more-cities","title":"Explore More Towns","cta":"Explore","cities":[{"city":"Milford","state":"Delaware","initials":"DE","image":"de_header","link":"/milford-de"},{"city":"Des Moines","state":"Iowa","initials":"IA","image":"des-moines-ia-hero","link":"/des-moines-ia"}]}]},{"slug":"des-moines-ia","hero":{"city":"Des Moines","state":"Iowa","initials":"IA","assetType":"image","asset":"des-moines-ia-hero","datapoint":{"image":"potholesfixed-black","number":"200","circleColor":"black"}},"modules":[{"type":"two-up","direction":"left","color":"blue","images":["des-moines-ia-1","des-moines-ia-2"]},{"type":"itemized-list","title":"paving report","list":[{"number":"40","label":"roads repaired"},{"number":"11","label":"tons of asphalt"},{"number":"270","label":"hours worked"},{"number":"12","label":"crewmembers"},{"number":"25","label":"pizzas eaten"}]},{"type":"more-cities","title":"Explore More Towns","cta":"Explore","cities":[{"city":"Burbank","state":"California","initials":"CA","image":"ca-burbank","link":"/burbank-ca"},{"city":"Fitchburg","state":"Massachusetts","initials":"MA","image":"fitchburg-ma-hero","link":"/fitchburg-ma"}]}]}]}

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _i18next = __webpack_require__(280);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _i18nextXhrBackend = __webpack_require__(270);
	
	var _i18nextXhrBackend2 = _interopRequireDefault(_i18nextXhrBackend);
	
	var _i18nextBrowserLanguagedetector = __webpack_require__(266);
	
	var _i18nextBrowserLanguagedetector2 = _interopRequireDefault(_i18nextBrowserLanguagedetector);
	
	var _reactI18next = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_i18next2.default.use(_i18nextXhrBackend2.default).use(_i18nextBrowserLanguagedetector2.default).use(_reactI18next.reactI18nextModule).init({
	  fallbackLng: "en",
	
	  // have a common namespace used around the full app
	  ns: ["translations"],
	  defaultNS: "translations",
	
	  debug: false,
	  load: 'languageOnly',
	  interpolation: {
	    escapeValue: false // not needed for react!!
	  },
	
	  react: {
	    wait: true
	  }
	});
	
	exports.default = _i18next2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _mobxReact = __webpack_require__(22);
	
	var _data = __webpack_require__(137);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _grid = __webpack_require__(3);
	
	var _pagebuilder = __webpack_require__(211);
	
	var _pagebuilder2 = _interopRequireDefault(_pagebuilder);
	
	var _MapHero = __webpack_require__(445);
	
	var _MapHero2 = _interopRequireDefault(_MapHero);
	
	var _HomeHero = __webpack_require__(440);
	
	var _HomeHero2 = _interopRequireDefault(_HomeHero);
	
	var _RepeatingElements = __webpack_require__(174);
	
	var _RepeatingElements2 = _interopRequireDefault(_RepeatingElements);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = (_dec = (0, _mobxReact.inject)("store"), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage(props) {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    var store = this.props.store;
	
	    store.setCSPage(false);
	  };
	
	  IndexPage.prototype.render = function render() {
	    var _props = this.props,
	        store = _props.store,
	        imageDictionary = _props.imageDictionary,
	        videoDictionary = _props.videoDictionary;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_RepeatingElements2.default, { stamps: _data2.default.stamps }),
	      _react2.default.createElement(_MapHero2.default, { data: _data2.default.home.campaignIntro }),
	      _react2.default.createElement(
	        _grid.Container,
	        { style: { position: 'relative' } },
	        _react2.default.createElement(
	          _grid.Row,
	          { margins: false },
	          _react2.default.createElement(
	            _grid.Column,
	            null,
	            _react2.default.createElement(_HomeHero2.default, { data: _data2.default.home.hero })
	          )
	        ),
	        _react2.default.createElement(_pagebuilder2.default, { modules: _data2.default.home.modules, imageDictionary: imageDictionary, videoDictionary: videoDictionary })
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react.Component)) || _class) || _class);
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/map-mobile.5c6f8081.png";

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ArrowCtaBlue (props) {
	    return React.createElement("svg",props,React.createElement("path",{"fill":"#006491","d":"M111.847843,0.446116206 C111.445386,0.0128185165 110.832953,-0.119054693 110.296345,0.113293343 C109.783067,0.351921056 109.433105,0.910812278 109.433105,1.52622059 L109.433105,30.5383267 L1.41151324,30.5383267 C0.641596928,30.5383267 0,31.2228115 0,32.0642882 L0,75.9341093 C0,76.775586 0.641596928,77.4600707 1.41151324,77.4600707 L109.433105,77.4600707 L109.433105,106.478457 C109.433105,107.093865 109.783067,107.646476 110.296345,107.885104 C110.832953,108.117452 111.445386,107.991859 111.847843,107.558561 L160.580046,55.0793031 C161.139985,54.4827338 161.139985,53.5219433 160.580046,52.925374 L111.847843,0.446116206 Z","id":"Fill-1","transform":"translate(80.500000, 54.000000) rotate(-180.000000) translate(-80.500000, -54.000000) "}));
	}
	
	ArrowCtaBlue.defaultProps = {"width":"161px","height":"108px","viewBox":"0 0 161 108"};
	
	module.exports = ArrowCtaBlue;
	
	ArrowCtaBlue.default = ArrowCtaBlue;


/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ArrowCtaRed (props) {
	    return React.createElement("svg",props,React.createElement("g",{"id":"Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"dominos-homepage-desktop-state2","fill":"#D51A35"},React.createElement("g",{"id":"CALIFORNIA"},React.createElement("g",{"id":"CTA-arrow"},React.createElement("path",{"d":"M111.847843,0.446116206 C111.445386,0.0128185165 110.832953,-0.119054693 110.296345,0.113293343 C109.783067,0.351921056 109.433105,0.910812278 109.433105,1.52622059 L109.433105,30.5383267 L1.41151324,30.5383267 C0.641596928,30.5383267 0,31.2228115 0,32.0642882 L0,75.9341093 C0,76.775586 0.641596928,77.4600707 1.41151324,77.4600707 L109.433105,77.4600707 L109.433105,106.478457 C109.433105,107.093865 109.783067,107.646476 110.296345,107.885104 C110.832953,108.117452 111.445386,107.991859 111.847843,107.558561 L160.580046,55.0793031 C161.139985,54.4827338 161.139985,53.5219433 160.580046,52.925374 L111.847843,0.446116206 Z","id":"Fill-1","transform":"translate(80.500000, 54.000000) rotate(-180.000000) translate(-80.500000, -54.000000) "}))))));
	}
	
	ArrowCtaRed.defaultProps = {"width":"161px","height":"108px","viewBox":"0 0 161 108","version":"1.1"};
	
	module.exports = ArrowCtaRed;
	
	ArrowCtaRed.default = ArrowCtaRed;


/***/ }),

/***/ 935:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function BlackPizza (props) {
	    return React.createElement("svg",props,React.createElement("g",{"id":"Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"dominos-homepage-desktop-state3-copy-2","transform":"translate(-1206.000000, -654.000000)","fill":"#2b2b2b","fillRule":"nonzero"},React.createElement("g",{"id":"pizza-symbol","transform":"translate(1206.000000, 654.000000)"},React.createElement("g",{"id":"Group","transform":"translate(7.000000, 6.000000)"},[React.createElement("g",{"transform":"translate(9.826224, 44.787293)","id":"Shape","key":0},[React.createElement("path",{"d":"M2.83740468,7.79010374 C2.31971435,7.79010374 1.80202401,7.52977034 1.28433367,7.26943695 C0.766643334,6.74877016 -0.786427678,4.66610301 2.06086918,2.06276906 C4.90816603,-0.800898277 6.72008221,0.761102089 7.23777255,1.28176888 C7.75546289,1.80243567 8.01430805,2.84376924 7.75546289,3.62476943 C7.23777255,4.66610301 5.94354671,4.9264364 5.94354671,4.9264364 L5.68470154,3.88510282 L5.68470154,4.40576961 L5.68470154,3.88510282 C5.68470154,3.88510282 6.46123704,3.88510282 6.72008221,3.36443603 C6.97892738,3.10410264 6.72008221,2.58343585 6.46123704,2.32310246 C5.42585637,1.28176888 4.13163053,1.54210227 2.83740468,3.10410264 C1.54317884,4.14543622 1.28433367,5.44710319 2.06086918,6.48843677 C2.31971435,6.74877016 2.83740468,6.74877016 3.09624985,6.74877016 C3.61394019,6.48843677 3.61394019,5.70743658 3.61394019,5.70743658 L4.64932086,5.96776998 C4.64932086,5.96776998 4.39047569,7.26943695 3.35509502,7.79010374 C3.35509502,7.79010374 3.09624985,7.79010374 2.83740468,7.79010374 Z","key":0}),React.createElement("polygon",{"points":"5.68470154 8.05043713 3.87278536 6.22810337 4.64932086 5.44710319 5.68470154 6.48843677 6.46123704 5.44710319 5.68470154 4.66610301 6.46123704 3.88510282 8.27315322 5.44710319","key":1})]),React.createElement("path",{"d":"M24.0528163,51.7963964 C22.4997453,51.7963964 20.9466743,50.4947295 20.9466743,48.6723957 C20.9466743,46.850062 22.2409002,45.548395 24.0528163,45.548395 C25.8647325,45.548395 27.1589584,46.850062 27.1589584,48.6723957 C27.1589584,50.4947295 25.8647325,51.7963964 24.0528163,51.7963964 Z M24.0528163,46.850062 C23.0174357,46.850062 22.2409002,47.6310621 22.2409002,48.6723957 C22.2409002,49.7137293 23.0174357,50.4947295 24.0528163,50.4947295 C25.088197,50.4947295 25.8647325,49.7137293 25.8647325,48.6723957 C25.8647325,47.6310621 25.088197,46.850062 24.0528163,46.850062 Z","id":"Shape","key":1}),React.createElement("g",{"transform":"translate(12.942258, 22.418519)","id":"Shape","key":2},[React.createElement("path",{"d":"M5.67480936,8.03053904 C5.4159642,8.03053904 5.15711903,8.03053904 4.89827386,7.77020565 C3.86289318,7.24953886 3.60404802,5.94787188 3.60404802,5.94787188 L4.63942869,5.68753849 C4.63942869,5.68753849 4.63942869,6.46853867 5.15711903,6.72887207 C5.4159642,6.98920546 5.93365453,6.72887207 6.1924997,6.46853867 C6.45134487,6.20820528 6.71019004,5.68753849 6.71019004,5.1668717 C6.71019004,4.38587152 6.1924997,3.60487133 5.4159642,2.82387115 C3.86289318,1.26187078 2.56866734,1.00153739 1.79213184,2.04287097 C1.79213184,2.30320436 1.53328667,2.56353776 1.79213184,3.08420455 C2.050977,3.60487133 2.82751251,3.60487133 2.82751251,3.60487133 L2.56866734,4.64620491 C2.56866734,4.64620491 1.2744415,4.38587152 0.756751162,3.34453794 C0.497905993,2.56353776 0.497905993,1.78253757 1.2744415,1.00153739 C1.79213184,0.480870601 3.86289318,-1.08112977 6.45134487,1.78253757 C7.48672555,2.82387115 8.00441588,3.86520473 8.00441588,4.90653831 C8.00441588,5.68753849 7.74557071,6.46853867 7.22788038,6.98920546 C6.71019004,7.77020565 6.1924997,8.03053904 5.67480936,8.03053904 Z","key":0}),React.createElement("polygon",{"points":"2.82751251 8.03053904 0.497905993 5.68753849 2.050977 3.86520473 2.82751251 4.64620491 2.050977 5.68753849 2.82751251 6.46853867 3.86289318 5.4272051 4.63942869 6.46853867","key":1})]),React.createElement("path",{"d":"M26.641268,37.9987265 C25.088197,37.9987265 23.535126,36.6970596 23.535126,34.8747258 C23.535126,33.052392 24.8293518,31.7507251 26.641268,31.7507251 C28.4531842,31.7507251 29.74741,33.052392 29.74741,34.8747258 C29.74741,36.6970596 28.194339,37.9987265 26.641268,37.9987265 Z M26.641268,33.052392 C25.6058873,33.052392 24.8293518,33.8333922 24.8293518,34.8747258 C24.8293518,35.9160594 25.6058873,36.6970596 26.641268,36.6970596 C27.6766487,36.6970596 28.4531842,35.9160594 28.4531842,34.8747258 C28.4531842,33.8333922 27.6766487,33.052392 26.641268,33.052392 Z","id":"Shape","key":3}),React.createElement("path",{"d":"M28.9708745,18.473722 C28.4531842,18.473722 27.9354939,18.2133886 27.4178035,17.9530552 C26.9001132,17.4323884 26.641268,16.6513882 26.641268,15.870388 C26.641268,14.8290544 27.1589584,13.7877209 28.194339,12.7463873 C31.0416359,9.88271994 32.8535521,11.4447203 33.3712424,11.9653871 C33.8889327,12.4860539 34.1477779,13.5273875 33.8889327,14.3083876 C33.3712424,15.3497212 32.0770166,15.6100546 32.0770166,15.6100546 L31.8181714,14.568721 C31.8181714,14.568721 32.5947069,14.568721 32.8535521,14.0480543 C33.1123972,13.7877209 32.8535521,13.2670541 32.5947069,13.0067207 C31.5593262,11.9653871 30.2651004,12.2257205 28.9708745,13.7877209 C28.194339,14.568721 27.6766487,15.6100546 27.6766487,16.1307214 C27.6766487,16.6513882 27.9354939,17.172055 28.194339,17.4323884 C28.4531842,17.6927218 28.7120294,17.6927218 29.2297197,17.6927218 C30.0062552,17.172055 30.0062552,16.3910548 30.0062552,16.3910548 L31.0416359,16.6513882 C31.0416359,16.6513882 30.7827907,17.9530552 29.74741,18.473722 C29.4885649,18.473722 29.2297197,18.473722 28.9708745,18.473722 Z","id":"Shape","key":4}),React.createElement("polygon",{"id":"Shape","points":"32.0770166 18.7340554 30.2651004 16.9117216 31.0416359 16.1307214 32.0770166 17.172055 32.8535521 16.1307214 31.8181714 15.3497212 32.8535521 14.3083876 34.4066231 16.1307214","key":5}),React.createElement("path",{"d":"M34.4066231,28.8870577 C32.8535521,28.8870577 31.3004811,27.5853908 31.3004811,25.763057 C31.3004811,23.9407232 32.5947069,22.6390563 34.4066231,22.6390563 C36.2185393,22.6390563 37.5127651,23.9407232 37.5127651,25.763057 C37.5127651,27.5853908 35.9596941,28.8870577 34.4066231,28.8870577 Z M34.4066231,23.9407232 C33.3712424,23.9407232 32.5947069,24.7217234 32.5947069,25.763057 C32.5947069,26.8043906 33.3712424,27.5853908 34.4066231,27.5853908 C35.4420038,27.5853908 36.2185393,26.8043906 36.2185393,25.763057 C36.2185393,24.7217234 35.4420038,23.9407232 34.4066231,23.9407232 Z","id":"Shape","key":6}),React.createElement("g",{"transform":"translate(50.713869, 13.547286)","id":"Shape","key":7},[React.createElement("path",{"d":"M2.84729685,8.05043713 C2.84729685,8.05043713 2.58845169,8.05043713 2.58845169,8.05043713 C1.81191618,8.05043713 1.03538067,7.52977034 0.776535506,7.26943695 C0.258845169,6.74877016 -2.1649349e-15,5.70743658 0.258845169,4.9264364 C0.776535506,3.88510282 2.07076135,3.62476943 2.07076135,3.62476943 L2.32960652,4.66610301 C2.32960652,4.66610301 1.55307101,4.66610301 1.29422584,5.18676979 C1.03538067,5.44710319 1.29422584,5.96776998 1.55307101,6.22810337 C1.81191618,6.48843677 2.07076135,6.74877016 2.58845169,6.74877016 C3.36498719,6.74877016 4.1415227,6.48843677 5.17690337,5.44710319 C6.72997438,3.88510282 6.98881955,2.58343585 5.95343888,1.80243567 C5.69459371,1.54210227 5.17690337,1.54210227 4.9180582,1.80243567 C4.40036787,2.06276906 4.40036787,2.84376924 4.40036787,2.84376924 L3.36498719,2.58343585 C3.36498719,2.58343585 3.62383236,1.28176888 4.65921303,0.761102089 C5.43574854,0.500768695 6.21228405,0.500768695 6.98881955,1.28176888 C7.50650989,1.80243567 9.0595809,3.88510282 6.21228405,6.48843677 C4.9180582,7.52977034 3.88267753,8.05043713 2.84729685,8.05043713 Z","key":0}),React.createElement("polygon",{"points":"1.55307101 4.66610301 0 2.84376924 2.32960652 0.240435301 4.1415227 2.06276906 3.36498719 2.84376924 2.32960652 2.06276906 1.55307101 2.84376924 2.32960652 3.88510282","key":1})]),React.createElement("path",{"d":"M47.6077267,28.1060576 C46.0546557,28.1060576 44.5015847,26.8043906 44.5015847,24.9820568 C44.5015847,23.1597231 45.7958105,21.8580561 47.6077267,21.8580561 C49.4196429,21.8580561 50.7138687,23.1597231 50.7138687,24.9820568 C50.7138687,26.8043906 49.1607977,28.1060576 47.6077267,28.1060576 Z M47.6077267,23.1597231 C46.572346,23.1597231 45.7958105,23.9407232 45.7958105,24.9820568 C45.7958105,26.0233904 46.572346,26.8043906 47.6077267,26.8043906 C48.6431074,26.8043906 49.4196429,26.0233904 49.4196429,24.9820568 C49.4196429,23.9407232 48.6431074,23.1597231 47.6077267,23.1597231 Z","id":"Shape","key":8}),React.createElement("path",{"d":"M46.3135008,15.3497212 C44.7604298,15.3497212 43.2073588,14.0480543 43.2073588,12.2257205 C43.2073588,10.4033867 44.5015847,9.10171976 46.3135008,9.10171976 C48.125417,9.10171976 49.4196429,10.4033867 49.4196429,12.2257205 C49.4196429,14.0480543 48.125417,15.3497212 46.3135008,15.3497212 Z M46.3135008,10.4033867 C45.2781202,10.4033867 44.5015847,11.1843869 44.5015847,12.2257205 C44.5015847,13.2670541 45.2781202,14.0480543 46.3135008,14.0480543 C47.3488815,14.0480543 48.125417,13.2670541 48.125417,12.2257205 C48.125417,11.1843869 47.3488815,10.4033867 46.3135008,10.4033867 Z","id":"Shape","key":9}),React.createElement("path",{"d":"M55.3730817,36.957393 C53.8200107,36.957393 52.2669397,35.655726 52.2669397,33.8333922 C52.2669397,32.0110585 53.5611656,30.7093915 55.3730817,30.7093915 C57.1849979,30.7093915 58.4792238,32.0110585 58.4792238,33.8333922 C58.4792238,35.655726 57.1849979,36.957393 55.3730817,36.957393 Z M55.3730817,31.7507251 C54.3377011,31.7507251 53.5611656,32.5317253 53.5611656,33.5730588 C53.5611656,34.6143924 54.3377011,35.3953926 55.3730817,35.3953926 C56.4084624,35.3953926 57.1849979,34.6143924 57.1849979,33.5730588 C57.1849979,32.5317253 56.4084624,31.7507251 55.3730817,31.7507251 Z","id":"Shape","key":10}),React.createElement("path",{"d":"M66.503424,29.6680579 C65.4680433,29.6680579 64.4326626,29.1473911 63.397282,28.1060576 C60.5499851,25.2423902 62.1030561,23.4200565 62.6207465,22.8993897 C63.1384368,22.3787229 64.1738175,22.1183895 64.950353,22.3787229 C65.9857336,22.8993897 66.2445788,24.2010566 66.2445788,24.2010566 L65.2091981,24.46139 C65.2091981,24.46139 65.2091981,23.6803898 64.6915078,23.4200565 C64.4326626,23.1597231 63.9149723,23.4200565 63.6561271,23.6803898 C62.6207465,24.7217234 62.8795916,26.0233904 64.4326626,27.3250574 C65.2091981,28.1060576 66.2445788,28.6267243 66.7622692,28.6267243 C66.7622692,28.6267243 66.7622692,28.6267243 66.7622692,28.6267243 C67.2799595,28.6267243 67.7976498,28.3663909 68.056495,28.1060576 C68.3153402,27.8457242 68.3153402,27.5853908 68.3153402,27.064724 C68.056495,26.5440572 67.2799595,26.5440572 67.2799595,26.5440572 L67.5388047,25.5027236 C67.5388047,25.5027236 68.8330305,25.763057 69.3507208,26.8043906 C69.609566,27.5853908 69.609566,28.3663909 68.8330305,29.1473911 C67.7976498,29.4077245 67.2799595,29.6680579 66.503424,29.6680579 Z","id":"Shape","key":11}),React.createElement("polygon",{"id":"Shape","points":"67.5388047 26.0233904 66.7622692 25.2423902 67.7976498 24.46139 66.7622692 23.4200565 65.9857336 24.46139 64.950353 23.6803898 66.7622692 21.8580561 69.3507208 24.46139","key":12}),React.createElement("path",{"d":"M64.950353,38.2590599 C63.397282,38.2590599 61.8442109,36.957393 61.8442109,35.1350592 C61.8442109,33.3127254 63.1384368,32.0110585 64.950353,32.0110585 C66.7622692,32.0110585 68.056495,33.3127254 68.056495,35.1350592 C68.056495,36.957393 66.503424,38.2590599 64.950353,38.2590599 Z M64.950353,33.3127254 C63.9149723,33.3127254 63.1384368,34.0937256 63.1384368,35.1350592 C63.1384368,36.1763928 63.9149723,36.957393 64.950353,36.957393 C65.9857336,36.957393 66.7622692,36.1763928 66.7622692,35.1350592 C66.7622692,34.0937256 65.9857336,33.3127254 64.950353,33.3127254 Z","id":"Shape","key":13}),React.createElement("g",{"transform":"translate(54.357485, 43.726061)","id":"Shape","key":14},[React.createElement("path",{"d":"M5.67480936,7.81000183 C5.4159642,7.81000183 5.15711903,7.81000183 4.89827386,7.54966844 C3.86289318,7.02900165 3.60404802,5.72733468 3.60404802,5.72733468 L4.63942869,5.46700128 C4.63942869,5.46700128 4.63942869,6.24800147 5.15711903,6.50833486 C5.4159642,6.76866826 5.93365453,6.50833486 6.1924997,6.24800147 C7.22788038,5.20666789 6.96903521,3.90500092 5.4159642,2.60333394 C4.63942869,1.82233376 3.60404802,1.30166697 3.08635768,1.30166697 C3.08635768,1.30166697 3.08635768,1.30166697 3.08635768,1.30166697 C2.56866734,1.30166697 2.050977,1.56200037 1.79213184,1.82233376 C1.53328667,2.08266716 1.53328667,2.34300055 1.53328667,2.86366734 C1.79213184,3.38433413 2.56866734,3.38433413 2.56866734,3.38433413 L2.30982217,4.42566771 C2.30982217,4.42566771 1.01559633,4.16533431 0.497905993,3.12400073 C0.239060824,2.34300055 0.239060824,1.56200037 1.01559633,0.781000183 C1.53328667,0.260333394 2.30982217,-7.10542736e-15 3.08635768,-7.10542736e-15 C4.12173835,-7.10542736e-15 5.15711903,0.520666789 6.1924997,1.56200037 C9.03979656,4.42566771 7.48672555,6.24800147 6.96903521,6.76866826 C6.71019004,7.54966844 6.1924997,7.81000183 5.67480936,7.81000183 Z","key":0}),React.createElement("polygon",{"points":"2.82751251 7.81000183 0.497905993 5.46700128 2.050977 3.64466752 2.82751251 4.42566771 2.050977 5.46700128 2.82751251 6.24800147 3.86289318 5.46700128 4.63942869 6.24800147","key":1})]),React.createElement("path",{"d":"M65.2091981,59.3460649 C63.6561271,59.3460649 62.1030561,58.0443979 62.1030561,56.2220641 C62.1030561,54.3997304 63.397282,53.0980634 65.2091981,53.0980634 C67.0211143,53.0980634 68.3153402,54.3997304 68.3153402,56.2220641 C68.3153402,58.0443979 67.0211143,59.3460649 65.2091981,59.3460649 Z M65.2091981,54.139397 C64.1738175,54.139397 63.397282,54.9203972 63.397282,55.9617308 C63.397282,57.0030643 64.1738175,57.7840645 65.2091981,57.7840645 C66.2445788,57.7840645 67.0211143,57.0030643 67.0211143,55.9617308 C67.0211143,54.9203972 66.503424,54.139397 65.2091981,54.139397 Z","id":"Shape","key":15}),React.createElement("g",{"transform":"translate(48.125417, 57.803963)","id":"Shape","key":16},[React.createElement("path",{"d":"M2.84729685,7.52977034 C2.32960652,7.52977034 1.81191618,7.26943695 1.29422584,7.00910356 C0.776535506,6.48843677 -0.776535506,4.40576961 2.07076135,1.80243567 C3.10614202,0.761102089 4.1415227,0.240435301 5.17690337,0.240435301 C5.95343888,0.240435301 6.72997438,0.500768695 7.24766472,1.02143548 C7.76535506,1.54210227 8.02420023,2.58343585 7.76535506,3.36443603 C7.24766472,4.40576961 5.95343888,4.66610301 5.95343888,4.66610301 L5.69459371,3.62476943 L5.69459371,4.14543622 L5.69459371,3.62476943 C5.69459371,3.62476943 6.47112921,3.62476943 6.72997438,3.10410264 C6.98881955,2.84376924 6.72997438,2.32310246 6.47112921,2.06276906 C6.21228405,1.80243567 5.69459371,1.54210227 5.17690337,1.54210227 C5.17690337,1.54210227 5.17690337,1.54210227 5.17690337,1.54210227 C4.40036787,1.54210227 3.62383236,2.06276906 2.84729685,2.84376924 C1.29422584,4.40576961 1.03538067,5.70743658 2.07076135,6.48843677 C2.32960652,6.74877016 2.58845169,6.74877016 3.10614202,6.74877016 C3.62383236,6.48843677 3.62383236,5.70743658 3.62383236,5.70743658 L4.65921303,5.96776998 C4.65921303,5.96776998 4.40036787,7.26943695 3.36498719,7.79010374 C3.36498719,7.52977034 3.10614202,7.52977034 2.84729685,7.52977034 Z","key":0}),React.createElement("polygon",{"points":"5.69459371 7.79010374 3.88267753 5.96776998 4.65921303 5.18676979 5.69459371 6.22810337 6.47112921 5.18676979 5.69459371 4.40576961 6.47112921 3.62476943 8.02420023 5.18676979","key":1})]),React.createElement("path",{"d":"M47.0900363,72.8834014 C45.5369653,72.8834014 43.9838943,71.5817344 43.9838943,69.7594007 C43.9838943,67.9370669 45.2781202,66.6353999 47.0900363,66.6353999 C48.9019525,66.6353999 50.1961784,67.9370669 50.1961784,69.7594007 C50.1961784,71.5817344 48.6431074,72.8834014 47.0900363,72.8834014 Z M47.0900363,67.9370669 C46.0546557,67.9370669 45.2781202,68.7180671 45.2781202,69.7594007 C45.2781202,70.8007342 46.0546557,71.5817344 47.0900363,71.5817344 C48.125417,71.5817344 48.9019525,70.8007342 48.9019525,69.7594007 C48.9019525,68.7180671 48.125417,67.9370669 47.0900363,67.9370669 Z","id":"Shape","key":17}),React.createElement("path",{"d":"M46.3135008,58.0443979 C44.7604298,58.0443979 43.2073588,56.7427309 43.2073588,54.9203972 C43.2073588,53.0980634 44.5015847,51.7963964 46.3135008,51.7963964 C48.125417,51.7963964 49.4196429,53.0980634 49.4196429,54.9203972 C49.4196429,56.7427309 48.125417,58.0443979 46.3135008,58.0443979 Z M46.3135008,53.0980634 C45.2781202,53.0980634 44.5015847,53.8790636 44.5015847,54.9203972 C44.5015847,55.9617308 45.2781202,56.7427309 46.3135008,56.7427309 C47.3488815,56.7427309 48.125417,55.9617308 48.125417,54.9203972 C48.125417,53.8790636 47.3488815,53.0980634 46.3135008,53.0980634 Z","id":"Shape","key":18}),React.createElement("g",{"transform":"translate(30.006255, 52.597295)","id":"Shape","key":19},[React.createElement("path",{"d":"M5.17690337,8.05043713 C4.1415227,8.05043713 3.10614202,7.52977034 2.07076135,6.48843677 C-0.776535506,3.62476943 0.776535506,1.80243567 1.29422584,1.28176888 C1.81191618,0.761102089 2.84729685,0.500768695 3.62383236,0.761102089 C4.65921303,1.28176888 4.9180582,2.58343585 4.9180582,2.58343585 L3.88267753,2.84376924 C3.88267753,2.84376924 3.88267753,2.06276906 3.36498719,1.80243567 C3.10614202,1.54210227 2.58845169,1.80243567 2.32960652,2.06276906 C1.29422584,3.10410264 1.55307101,4.40576961 3.10614202,5.70743658 C4.65921303,7.00910356 5.95343888,7.52977034 6.72997438,6.48843677 C6.98881955,6.22810337 6.98881955,5.70743658 6.98881955,5.44710319 C6.72997438,4.9264364 5.95343888,4.9264364 5.95343888,4.9264364 L6.21228405,3.88510282 C6.21228405,3.88510282 7.50650989,4.14543622 8.02420023,5.18676979 C8.28304539,5.96776998 8.28304539,6.74877016 7.50650989,7.52977034 C7.24766472,7.79010374 6.47112921,8.31077053 5.69459371,8.31077053 C5.43574854,8.05043713 5.43574854,8.05043713 5.17690337,8.05043713 Z","key":0}),React.createElement("polygon",{"points":"6.47112921 4.40576961 5.69459371 3.62476943 6.47112921 2.84376924 5.69459371 1.80243567 4.65921303 2.84376924 3.88267753 2.06276906 5.69459371 0.240435301 8.02420023 2.84376924","key":1})]),React.createElement("path",{"d":"M33.6300876,69.2387339 C32.0770166,69.2387339 30.5239455,67.9370669 30.5239455,66.1147331 C30.5239455,64.2923994 31.8181714,62.9907324 33.6300876,62.9907324 C35.4420038,62.9907324 36.7362296,64.2923994 36.7362296,66.1147331 C36.7362296,67.9370669 35.4420038,69.2387339 33.6300876,69.2387339 Z M33.6300876,64.2923994 C32.5947069,64.2923994 31.8181714,65.0733996 31.8181714,66.1147331 C31.8181714,67.1560667 32.5947069,67.9370669 33.6300876,67.9370669 C34.6654682,67.9370669 35.4420038,67.1560667 35.4420038,66.1147331 C35.4420038,65.0733996 34.6654682,64.2923994 33.6300876,64.2923994 Z","id":"Shape","key":20}),React.createElement("path",{"d":"M25.088197,69.2387339 C23.535126,69.2387339 21.982055,67.9370669 21.982055,66.1147331 C21.982055,64.2923994 23.2762808,62.9907324 25.088197,62.9907324 C26.9001132,62.9907324 28.194339,64.2923994 28.194339,66.1147331 C28.194339,67.9370669 26.641268,69.2387339 25.088197,69.2387339 Z M25.088197,64.2923994 C24.0528163,64.2923994 23.2762808,65.0733996 23.2762808,66.1147331 C23.2762808,67.1560667 24.0528163,67.9370669 25.088197,67.9370669 C26.1235777,67.9370669 26.9001132,67.1560667 26.9001132,66.1147331 C26.9001132,65.0733996 26.1235777,64.2923994 25.088197,64.2923994 Z","id":"Shape","key":21}),React.createElement("g",{"transform":"translate(11.408972, 0.000000)","id":"Shape","key":22},[React.createElement("g",{"key":0},[React.createElement("path",{"d":"M28.4333999,41.6433941 L3.3254185,16.1307214 L3.3254185,15.0893878 C10.3142381,8.32071957 19.373819,4.67605205 28.9510902,4.41571866 L29.7276257,4.93638545 L29.7276257,41.1227273 L28.4333999,41.6433941 Z M4.61964435,15.6100546 L28.4333999,39.5607269 L28.4333999,5.71738563 C19.373819,5.97771902 11.0907736,9.62238655 4.61964435,15.6100546 Z","key":0}),React.createElement("path",{"d":"M0.995811986,13.5273875 C0.736966818,13.5273875 0.736966818,13.5273875 0.478121649,13.2670541 C0.21927648,13.0067207 0.21927648,12.4860539 0.478121649,12.2257205 C8.24347671,4.67605205 18.3384383,0.510717742 28.9510902,0.510717742 C29.2099354,0.510717742 29.7276257,0.771051136 29.7276257,1.03138453 C29.7276257,1.29171793 29.4687805,1.81238471 29.2099354,1.81238471 C18.5972835,2.07271811 8.76116704,5.97771902 1.51350232,13.2670541 C1.25465715,13.2670541 1.25465715,13.5273875 0.995811986,13.5273875 Z","key":1})]),React.createElement("path",{"d":"M28.9510902,41.6433941 C28.692245,41.6433941 28.692245,41.6433941 28.4333999,41.3830607 L0.478121649,13.2670541 C0.21927648,13.0067207 0.21927648,12.7463873 0.478121649,12.4860539 C0.736966818,12.2257205 1.25465715,12.2257205 1.51350232,12.4860539 L28.4333999,39.5607269 L28.4333999,1.03138453 C28.4333999,0.771051136 28.692245,0.510717742 28.9510902,0.510717742 C29.2099354,0.510717742 29.4687805,0.771051136 29.4687805,1.03138453 L29.4687805,41.1227273 C29.7276257,41.3830607 29.4687805,41.6433941 28.9510902,41.6433941 C29.2099354,41.6433941 28.9510902,41.6433941 28.9510902,41.6433941 Z","key":1}),React.createElement("path",{"d":"M0.995811986,13.5273875 C0.736966818,13.5273875 0.736966818,13.5273875 0.478121649,13.2670541 C0.21927648,13.0067207 0.21927648,12.4860539 0.478121649,12.2257205 C8.24347671,4.67605205 18.3384383,0.510717742 28.9510902,0.510717742 C29.2099354,0.510717742 29.7276257,0.771051136 29.7276257,1.03138453 C29.7276257,1.29171793 29.4687805,1.81238471 29.2099354,1.81238471 C18.5972835,2.07271811 8.76116704,5.97771902 1.51350232,13.2670541 C1.25465715,13.2670541 1.25465715,13.5273875 0.995811986,13.5273875 Z","key":2})]),React.createElement("path",{"d":"M40.360062,41.6433941 C40.1012168,41.6433941 40.1012168,41.6433941 39.8423716,41.3830607 L11.8870934,13.2670541 C11.6282482,13.0067207 11.6282482,12.7463873 11.8870934,12.4860539 C12.1459386,12.2257205 12.6636289,12.2257205 12.9224741,12.4860539 L39.8423716,39.5607269 L39.8423716,1.03138453 C39.8423716,0.771051136 40.1012168,0.510717742 40.360062,0.510717742 C40.6189071,0.510717742 40.8777523,0.771051136 40.8777523,1.03138453 L40.8777523,41.1227273 C41.1365975,41.3830607 40.8777523,41.6433941 40.360062,41.6433941 C40.6189071,41.6433941 40.360062,41.6433941 40.360062,41.6433941 Z","id":"Shape","key":23}),React.createElement("g",{"transform":"translate(39.354358, 0.000000)","id":"Shape","key":24},[React.createElement("path",{"d":"M1.5233945,41.6433941 L0.488013821,41.1227273 L0.488013821,5.19671884 L1.00570416,4.41571866 C10.8418206,4.67605205 19.9014015,8.32071957 26.890221,15.0893878 L26.890221,16.1307214 L1.5233945,41.6433941 Z M1.78223966,5.71738563 L1.78223966,39.5607269 L25.5959952,15.6100546 C18.8660208,9.62238655 10.5829754,5.97771902 1.78223966,5.71738563 Z","key":0}),React.createElement("path",{"d":"M28.9609824,13.5273875 C28.7021372,13.5273875 28.7021372,13.5273875 28.443292,13.2670541 C21.1956273,5.97771902 11.3595109,2.07271811 1.00570416,1.81238471 C0.74685899,1.81238471 0.488013821,1.55205132 0.488013821,1.03138453 C0.488013821,0.771051136 0.74685899,0.510717742 1.26454933,0.510717742 C11.8772012,0.771051136 21.9721628,4.93638545 29.7375179,12.2257205 C29.996363,12.4860539 29.996363,13.0067207 29.7375179,13.2670541 C29.4786727,13.2670541 29.2198275,13.5273875 28.9609824,13.5273875 Z","key":1})]),React.createElement("path",{"d":"M40.360062,41.6433941 C40.360062,41.6433941 40.360062,41.6433941 40.360062,41.6433941 C39.8423716,41.3830607 39.8423716,41.3830607 39.8423716,41.1227273 L39.8423716,1.81238471 C39.8423716,1.55205132 40.1012168,1.29171793 40.360062,1.29171793 C40.6189071,1.29171793 40.8777523,1.55205132 40.8777523,1.81238471 L40.8777523,39.5607269 L67.5388047,12.7463873 C67.7976498,12.4860539 68.3153402,12.4860539 68.5741853,12.7463873 C68.8330305,13.0067207 68.8330305,13.5273875 68.5741853,13.7877209 L40.8777523,41.6433941 C40.6189071,41.6433941 40.6189071,41.6433941 40.360062,41.6433941 Z","id":"Shape","key":25}),React.createElement("g",{"transform":"translate(39.354358, 12.005183)","id":"Shape","key":26},[React.createElement("path",{"d":"M36.7263374,29.6382108 L1.00570416,29.6382108 L0.488013821,28.5968772 L25.8548403,3.08420455 L26.890221,3.08420455 C33.6201954,10.1132062 37.5028729,19.224875 37.5028729,28.8572106 L36.7263374,29.6382108 Z M2.55877517,28.3365438 L36.2086471,28.3365438 C35.9498019,19.4852084 32.3259696,10.8942064 26.3725307,4.38587152 L2.55877517,28.3365438 Z","key":0}),React.createElement("path",{"d":"M40.609015,29.6382108 C40.3501698,29.6382108 40.0913246,29.3778774 40.0913246,29.117544 C39.8324794,18.7042082 35.9498019,8.81153922 28.7021372,1.52220418 C28.443292,1.26187078 28.443292,0.741203996 28.7021372,0.480870601 C28.9609824,0.220537207 29.4786727,0.220537207 29.7375179,0.480870601 C37.2440278,8.29087243 41.3855505,18.4438748 41.3855505,29.117544 C41.3855505,29.3778774 41.1267053,29.6382108 40.609015,29.6382108 C40.8678601,29.6382108 40.8678601,29.6382108 40.609015,29.6382108 Z","key":1})]),React.createElement("path",{"d":"M79.9633728,41.6433941 L40.360062,41.6433941 C40.1012168,41.6433941 39.8423716,41.3830607 39.8423716,41.1227273 C39.8423716,40.8623939 39.8423716,40.6020605 40.1012168,40.3417271 L68.056495,12.4860539 C68.3153402,12.2257205 68.8330305,12.2257205 69.0918757,12.4860539 C69.3507208,12.7463873 69.3507208,13.2670541 69.0918757,13.5273875 L41.913133,40.3417271 L79.9633728,40.3417271 C80.2222179,40.3417271 80.4810631,40.6020605 80.4810631,40.8623939 C80.4810631,41.1227273 80.4810631,41.6433941 79.9633728,41.6433941 Z","id":"Shape","key":27}),React.createElement("path",{"d":"M79.9633728,41.6433941 L40.360062,41.6433941 C40.1012168,41.6433941 39.8423716,41.3830607 39.8423716,41.1227273 C39.8423716,40.8623939 39.8423716,40.6020605 40.1012168,40.3417271 L68.056495,12.4860539 C68.3153402,12.2257205 68.8330305,12.2257205 69.0918757,12.4860539 C69.3507208,12.7463873 69.3507208,13.2670541 69.0918757,13.5273875 L41.913133,40.3417271 L79.9633728,40.3417271 C80.2222179,40.3417271 80.4810631,40.6020605 80.4810631,40.8623939 C80.4810631,41.1227273 80.4810631,41.6433941 79.9633728,41.6433941 Z","id":"Shape","key":28}),React.createElement("g",{"transform":"translate(39.354358, 40.111241)","id":"Shape","key":29},[React.createElement("path",{"d":"M25.8548403,26.7844925 L0.488013821,1.27181983 L1.00570416,0.230486254 L36.7263374,0.230486254 L37.2440278,1.01148644 C36.9851826,10.643822 33.3613502,20.0158242 26.6313758,27.0448259 L25.8548403,26.7844925 Z M2.55877517,1.53215323 L26.3725307,25.4828255 C32.3259696,18.9744907 35.9498019,10.643822 36.2086471,1.53215323 L2.55877517,1.53215323 Z","key":0}),React.createElement("path",{"d":"M29.2198275,29.9084932 C28.9609824,29.9084932 28.9609824,29.9084932 28.7021372,29.6481598 C28.443292,29.3878264 28.443292,28.8671596 28.7021372,28.6068262 C35.9498019,21.3174912 39.8324794,11.4248222 40.0913246,1.01148644 C40.0913246,0.751153043 40.3501698,0.490819648 40.8678601,0.490819648 C41.1267053,0.490819648 41.3855505,0.751153043 41.3855505,1.27181983 C41.1267053,11.945489 36.9851826,22.0984914 29.7375179,29.9084932 C29.4786727,29.6481598 29.2198275,29.9084932 29.2198275,29.9084932 Z","key":1})]),React.createElement("path",{"d":"M68.3153402,69.7594007 C68.056495,69.7594007 68.056495,69.7594007 67.7976498,69.4990673 L39.8423716,41.6433941 C39.5835265,41.3830607 39.5835265,41.1227273 39.5835265,40.8623939 C39.5835265,40.6020605 39.8423716,40.3417271 40.1012168,40.3417271 L79.4456824,40.3417271 C79.7045276,40.3417271 79.9633728,40.6020605 79.9633728,40.8623939 C79.9633728,41.1227273 79.7045276,41.3830607 79.4456824,41.3830607 L41.6542878,41.3830607 L68.8330305,68.7180671 C69.0918757,68.9784005 69.0918757,69.4990673 68.8330305,69.7594007 C68.5741853,69.7594007 68.3153402,69.7594007 68.3153402,69.7594007 Z","id":"Shape","key":30}),React.createElement("g",{"transform":"translate(39.354358, 40.111241)","id":"Shape","key":31},[React.createElement("path",{"d":"M1.00570416,37.7184951 L0.229168652,37.1978283 L0.229168652,1.01148644 L1.26454933,0.490819648 L26.6313758,26.0034923 L26.6313758,27.0448259 C19.9014015,33.5531607 10.5829754,37.4581617 1.00570416,37.7184951 Z M1.78223966,2.5734868 L1.78223966,36.4168281 C10.5829754,36.1564947 19.124866,32.5118272 25.5959952,26.5241591 L1.78223966,2.5734868 Z","key":0}),React.createElement("path",{"d":"M1.00570416,41.623496 C0.74685899,41.623496 0.488013821,41.3631626 0.488013821,41.1028292 C0.488013821,40.8424958 0.74685899,40.321829 1.00570416,40.321829 C11.3595109,40.0614956 21.1956273,36.1564947 28.443292,28.8671596 C28.7021372,28.6068262 29.2198275,28.6068262 29.4786727,28.8671596 C29.7375179,29.127493 29.7375179,29.6481598 29.4786727,29.9084932 C21.7133176,37.1978283 11.8772012,41.3631626 1.00570416,41.623496 C1.00570416,41.623496 1.00570416,41.623496 1.00570416,41.623496 Z","key":1})]),React.createElement("g",{"transform":"translate(11.408972, 40.111241)","id":"Shape","key":32},[React.createElement("path",{"d":"M28.9510902,37.7184951 C19.373819,37.4581617 10.0553929,33.8134941 3.06657333,27.0448259 L3.06657333,26.0034923 L28.4333999,0.490819648 L29.4687805,1.01148644 L29.4687805,36.9374949 L28.9510902,37.7184951 Z M4.61964435,26.5241591 C11.0907736,32.5118272 19.373819,36.1564947 28.4333999,36.4168281 L28.4333999,2.5734868 L4.61964435,26.5241591 Z","key":0}),React.createElement("path",{"d":"M28.9510902,41.623496 C28.9510902,41.623496 28.9510902,41.623496 28.9510902,41.623496 C18.3384383,41.3631626 8.24347671,37.1978283 0.478121649,29.9084932 C0.21927648,29.6481598 0.21927648,29.127493 0.478121649,28.8671596 C0.736966818,28.6068262 1.25465715,28.6068262 1.51350232,28.8671596 C8.76116704,35.8961613 18.5972835,40.0614956 28.9510902,40.321829 C29.2099354,40.321829 29.4687805,40.5821624 29.4687805,41.1028292 C29.4687805,41.1028292 29.2099354,41.623496 28.9510902,41.623496 Z","key":1})]),React.createElement("g",{"transform":"translate(0.000000, 40.111241)","id":"Shape","key":33},[React.createElement("path",{"d":"M15.5109258,26.7844925 L14.4755451,26.7844925 C8.00441588,19.7554908 4.12173835,10.643822 3.86289318,1.01148644 L4.38058352,0.230486254 L40.360062,0.230486254 L40.8777523,1.27181983 L15.5109258,26.7844925 Z M5.15711903,1.53215323 C5.4159642,10.3834886 9.03979656,18.9744907 14.9932354,25.4828255 L38.8069909,1.53215323 L5.15711903,1.53215323 Z","key":0}),React.createElement("path",{"d":"M12.4047837,29.6481598 C12.1459386,29.6481598 11.8870934,29.6481598 11.8870934,29.6481598 C4.38058352,21.838158 0.239060824,11.6851556 0.239060824,1.01148644 C0.239060824,0.751153043 0.497905993,0.230486254 0.756751162,0.230486254 C1.01559633,0.230486254 1.53328667,0.490819648 1.53328667,0.751153043 C1.79213184,11.1644888 5.67480936,21.0571578 12.9224741,28.3464929 C13.1813193,28.6068262 13.1813193,29.127493 12.9224741,29.3878264 C12.6636289,29.6481598 12.4047837,29.6481598 12.4047837,29.6481598 Z","key":1})]),React.createElement("path",{"d":"M12.4047837,70.0197341 C12.1459386,70.0197341 12.1459386,70.0197341 11.8870934,69.7594007 C11.6282482,69.4990673 11.6282482,68.9784005 11.8870934,68.7180671 L38.8069909,41.6433941 L0.756751162,41.6433941 C0.497905993,41.6433941 0.239060824,41.3830607 0.239060824,41.1227273 C0.239060824,40.8623939 0.497905993,40.6020605 0.756751162,40.6020605 L40.360062,40.6020605 C40.6189071,40.6020605 40.8777523,40.8623939 40.8777523,41.1227273 C40.8777523,41.3830607 40.8777523,41.6433941 40.6189071,41.9037275 L12.9224741,69.7594007 C12.6636289,69.7594007 12.4047837,70.0197341 12.4047837,70.0197341 Z","id":"Shape","key":34}),React.createElement("g",{"transform":"translate(0.000000, 12.005183)","id":"Shape","key":35},[React.createElement("path",{"d":"M40.360062,29.6382108 L4.63942869,29.6382108 L3.86289318,29.117544 C4.12173835,19.224875 8.00441588,10.1132062 14.7343903,3.08420455 L15.7697709,3.08420455 L41.1365975,28.5968772 L40.360062,29.6382108 Z M5.15711903,28.3365438 L38.8069909,28.3365438 L14.9932354,4.64620491 C9.03979656,11.1545398 5.67480936,19.4852084 5.15711903,28.3365438 Z","key":0}),React.createElement("path",{"d":"M0.756751162,29.6382108 C0.756751162,29.6382108 0.756751162,29.6382108 0.756751162,29.6382108 C0.497905993,29.6382108 -0.0197843441,29.3778774 0.239060824,28.8572106 C0.497905993,18.1835414 4.63942869,8.03053904 11.8870934,0.220537207 C12.1459386,-0.0397961877 12.6636289,-0.0397961877 12.9224741,0.220537207 C13.1813193,0.480870601 13.1813193,1.00153739 12.9224741,1.26187078 C5.67480936,8.81153922 1.53328667,18.7042082 1.2744415,29.117544 C1.2744415,29.3778774 1.01559633,29.6382108 0.756751162,29.6382108 Z","key":1})])])))));
	}
	
	BlackPizza.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 94 94","version":"1.1"};
	
	module.exports = BlackPizza;
	
	BlackPizza.default = BlackPizza;


/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function IconCamera (props) {
	    return React.createElement("svg",props,React.createElement("path",{"d":"M26.6,2.9h-6l-0.7-2.2C19.7,0.3,19.3,0,18.9,0h-7.7c-0.4,0-0.8,0.3-0.9,0.7L9.5,2.9h-6C1.5,2.9,0,4.5,0,6.3V21\n\tc0,1.9,1.5,3.4,3.4,3.4h23.2c1.9,0,3.4-1.5,3.4-3.4V6.3C30,4.5,28.5,2.9,26.6,2.9z M5.4,8.6H4.4C3.5,8.6,2.9,8,2.9,7.2\n\tc0-0.8,0.7-1.5,1.5-1.5h1.1c0.8,0,1.5,0.7,1.5,1.5C6.9,8,6.3,8.6,5.4,8.6z M15,18.7c-2.8,0-5-2.2-5-5s2.2-5,5-5c2.8,0,5,2.2,5,5\n\tS17.8,18.7,15,18.7z"}));
	}
	
	IconCamera.defaultProps = {"viewBox":"0 0 30 24.4"};
	
	module.exports = IconCamera;
	
	IconCamera.default = IconCamera;


/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function LegendPartnerStatesStories (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"map legend icon for partner states"),React.createElement("rect",{"fill":"#E11D38","x":"0","y":"0","width":"27","height":"16","key":1}),React.createElement("rect",{"stroke":"#A71E22","strokeWidth":"2","fill":"#FFFFFF","transform":"rotate(-45) translate(-9, -17)","x":"10","y":"30","width":"6.13603897","height":"6.13603897","key":2})]);
	}
	
	LegendPartnerStatesStories.defaultProps = {"width":"27px","height":"16px","viewBox":"0 0 27 16"};
	
	module.exports = LegendPartnerStatesStories;
	
	LegendPartnerStatesStories.default = LegendPartnerStatesStories;


/***/ }),

/***/ 937:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function LegendPartnerStates (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"map legend icon for partner states"),React.createElement("rect",{"fill":"#E11D38","x":"0","y":"0","width":"27","height":"16","key":1})]);
	}
	
	LegendPartnerStates.defaultProps = {"width":"27px","height":"16px","viewBox":"0 0 27 16"};
	
	module.exports = LegendPartnerStates;
	
	LegendPartnerStates.default = LegendPartnerStates;


/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function NominateBackground (props) {
	    return React.createElement("svg",props,React.createElement("g",{"id":"Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"dominos-homepage-desktop-state2","fill":"#005781"},React.createElement("g",{"id":"INTRO-EXPERIENCE"},React.createElement("g",{"id":"CTA"},React.createElement("g",{"id":"PATTERN"},[React.createElement("polygon",{"id":"Fill-1","points":"36 0 52.3637314 34.4991315 36 69 55.6362686 69 72 34.4991315 55.6362686 0","key":0}),React.createElement("polygon",{"id":"Fill-1-Copy","points":"181 0 197.363731 34.4991315 181 69 200.636269 69 217 34.4991315 200.636269 0","key":1}),React.createElement("polygon",{"id":"Fill-1-Copy-2","points":"326 0 342.363731 34.4991315 326 69 345.636269 69 362 34.4991315 345.636269 0","key":2}),React.createElement("polygon",{"id":"Fill-2","points":"0 0 16.363161 34.4991315 0 69 19.636839 69 36 34.4991315 19.636839 0","key":3}),React.createElement("polygon",{"id":"Fill-2-Copy","points":"145 0 161.363161 34.4991315 145 69 164.636839 69 181 34.4991315 164.636839 0","key":4}),React.createElement("polygon",{"id":"Fill-2-Copy-2","points":"289 0 305.363161 34.4991315 289 69 308.636839 69 325 34.4991315 308.636839 0","key":5}),React.createElement("polygon",{"id":"Fill-3","points":"109 0 125.363161 34.4991315 109 69 128.636839 69 145 34.4991315 128.636839 0","key":6}),React.createElement("polygon",{"id":"Fill-3-Copy","points":"254 0 270.363161 34.4991315 254 69 273.636839 69 290 34.4991315 273.636839 0","key":7}),React.createElement("polygon",{"id":"Fill-3-Copy-2","points":"396 0 412.363161 34.4991315 396 69 415.636839 69 432 34.4991315 415.636839 0","key":8}),React.createElement("polygon",{"id":"Fill-4","points":"73 0 89.3555581 34.4991315 73 69 73.0167267 69 92.6277152 69 92.6444419 69 109 34.4991315 92.6444419 0","key":9}),React.createElement("polygon",{"id":"Fill-4-Copy","points":"217 0 233.355558 34.4991315 217 69 217.016727 69 236.627715 69 236.644442 69 253 34.4991315 236.644442 0","key":10}),React.createElement("polygon",{"id":"Fill-4-Copy-2","points":"359 0 375.355558 34.4991315 359 69 359.016727 69 378.627715 69 378.644442 69 395 34.4991315 378.644442 0","key":11})]))))));
	}
	
	NominateBackground.defaultProps = {"width":"100%","height":"100%","version":"1.1"};
	
	module.exports = NominateBackground;
	
	NominateBackground.default = NominateBackground;


/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function P4paaLogoEs (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Paving for Pizza logo"),React.createElement("g",{"key":1},[React.createElement("g",{"key":0},[React.createElement("path",{"fill":"#006491","d":"M11.21,34.8h17.2c5.5,0,9.9-.6,13.3-1.9A13.32,13.32,0,0,0,49,27.2a19,19,0,0,0,2.3-9.8c0-5.8-1.8-10-5.3-12.7S36.61.8,28.51.8H.71V53.1h10.6V34.8Zm0-24.6h17.7q6.3,0,9,1.5c1.8,1,2.7,3,2.7,5.9s-.9,5.1-2.7,6.2-4.8,1.6-9,1.6H11.21Z","key":0}),React.createElement("path",{"fill":"#006491","d":"M101.21,53.1h11.2L88.51.8H77.11L53.21,53.1h11.2l4.8-10.7h27.4ZM73,33.5l9.9-22.4,9.7,22.4Z","key":1}),React.createElement("polygon",{"fill":"#006491","points":"168.91 0.8 157.81 0.8 139.31 42.6 120.91 0.8 109.71 0.8 133.61 53.1 145.01 53.1 168.91 0.8","key":2}),React.createElement("rect",{"fill":"#006491","x":"179.91","y":"0.8","width":"10.6","height":"52.3","key":3}),React.createElement("polygon",{"fill":"#006491","points":"259.41 53.1 259.41 0.8 249.61 0.8 249.61 38.1 217.01 0.8 207.41 0.8 207.41 53.1 217.21 53.1 217.21 16.1 250.11 53.1 259.41 53.1","key":4}),React.createElement("path",{"fill":"#006491","d":"M286.11,50.4a33.23,33.23,0,0,0,15.8,3.5c9.1,0,16.2-2.1,21.2-6.4s7.6-10.6,7.6-19V24.3h-28V33h17.1a11.28,11.28,0,0,1-5.3,8.7c-3.1,2-7.3,3-12.7,3-5.6,0-10-1.5-13.3-4.6s-4.9-7.4-4.9-13v-.4c0-5.5,1.7-9.8,5-12.9s7.7-4.7,13.2-4.7a23.24,23.24,0,0,1,10.6,2.1,12.32,12.32,0,0,1,5.9,5.8l.4.7h10.9l-.2-.7a20.81,20.81,0,0,0-9-12.5c-4.5-3-10.7-4.5-18.5-4.5-6.2,0-11.4,1.1-15.7,3.4a23.17,23.17,0,0,0-9.7,9.4,28,28,0,0,0-3.3,13.7v.7a29.15,29.15,0,0,0,3.2,13.7A22.82,22.82,0,0,0,286.11,50.4Z","key":5}),React.createElement("path",{"fill":"#006491","d":"M123.61,69.4c-3.5-2.7-9.4-4.1-17.5-4.1H78.31v52.3h10.6V99.3h17.2c5.5,0,9.9-.6,13.3-1.9a13.32,13.32,0,0,0,7.3-5.7,19,19,0,0,0,2.3-9.8C128.91,76.3,127.11,72.1,123.61,69.4Zm-8,18.9c-1.8,1.1-4.8,1.6-9,1.6H88.91V74.7h17.7q6.3,0,9,1.5c1.8,1,2.7,3,2.7,5.9C118.31,85.2,117.41,87.2,115.61,88.3Z","key":6}),React.createElement("rect",{"fill":"#006491","x":"138.31","y":"65.3","width":"10.6","height":"52.3","key":7}),React.createElement("polygon",{"fill":"#006491","points":"208.41 72.9 208.41 65.3 163.31 65.3 163.31 74.4 194.31 74.4 161.61 110 161.61 117.6 209.81 117.6 209.81 108.4 175.61 108.4 208.41 72.9","key":8}),React.createElement("polygon",{"fill":"#006491","points":"265.81 72.9 265.81 65.3 220.71 65.3 220.71 74.4 251.71 74.4 219.01 110 219.01 117.6 267.11 117.6 267.11 108.4 233.01 108.4 265.81 72.9","key":9}),React.createElement("path",{"fill":"#006491","d":"M309.71,65.3h-11.4l-23.9,52.3h11.2l4.8-10.7h27.4l4.8,10.7h11ZM294.11,98,304,75.6l9.8,22.4Z","key":10}),React.createElement("path",{"fill":"#006491","d":"M65.11,65.2H1.21a.47.47,0,0,0-.5.5V74a.47.47,0,0,0,.5.5h63.9a.47.47,0,0,0,.5-.5V65.6C65.71,65.4,65.41,65.2,65.11,65.2Z","key":11}),React.createElement("path",{"fill":"#006491","d":"M65.11,108.3H1.21a.47.47,0,0,0-.5.5v8.4a.47.47,0,0,0,.5.5h63.9a.47.47,0,0,0,.5-.5v-8.4C65.71,108.5,65.41,108.3,65.11,108.3Z","key":12}),React.createElement("path",{"fill":"#006491","d":"M19.81,86.4a.73.73,0,0,0,.7-.6l.7-3a1.27,1.27,0,0,0-.1-.6.6.6,0,0,0-.6-.3H5.21a.73.73,0,0,0-.7.6L.71,99.7a1.27,1.27,0,0,0,.1.6.6.6,0,0,0,.6.3h3.5a.73.73,0,0,0,.7-.6L7,93.7H17a.73.73,0,0,0,.7-.6l.7-3.1a1.27,1.27,0,0,0-.1-.6.6.6,0,0,0-.6-.3H7.91l.6-2.8h11.3Z","key":13}),React.createElement("path",{"fill":"#006491","d":"M26.41,99.9a11.3,11.3,0,0,0,5.1,1.1,12.54,12.54,0,0,0,5.9-1.4,9.78,9.78,0,0,0,4-3.8,10.25,10.25,0,0,0,1.4-5.5,8.41,8.41,0,0,0-1.2-4.5,8.54,8.54,0,0,0-3.4-3.1,11.17,11.17,0,0,0-5-1.1,11.62,11.62,0,0,0-6,1.5,10.42,10.42,0,0,0-3.9,3.9A10.56,10.56,0,0,0,22,92.2a9.36,9.36,0,0,0,1.1,4.5A7.31,7.31,0,0,0,26.41,99.9Zm6.6-14a5.05,5.05,0,0,1,3.6,1.2,4.24,4.24,0,0,1,1.3,3.4,6.5,6.5,0,0,1-.8,3.1A5.3,5.3,0,0,1,35,95.7a6.6,6.6,0,0,1-3.2.8,4.89,4.89,0,0,1-3.6-1.2A4.46,4.46,0,0,1,27,92a6,6,0,0,1,.7-3,5.52,5.52,0,0,1,2.1-2.2A5.07,5.07,0,0,1,33,85.9Z","key":14}),React.createElement("path",{"fill":"#006491","d":"M65.11,87.4c0-2.5-1.2-5.5-7.2-5.5H49a.73.73,0,0,0-.7.6l-3.8,17.2a1.27,1.27,0,0,0,.1.6.6.6,0,0,0,.6.3h3.5a.73.73,0,0,0,.7-.6l1.2-5.5h3.9l2.9,5.7a.82.82,0,0,0,.6.4h3.9a.55.55,0,0,0,.6-.4.85.85,0,0,0,0-.7l-2.9-5.4a8.63,8.63,0,0,0,3.8-2A6.77,6.77,0,0,0,65.11,87.4Zm-12.7-1h5.4a3.89,3.89,0,0,1,2.1.4c.2.1.4.4.4,1a1.94,1.94,0,0,1-.8,1.6h0a4.74,4.74,0,0,1-3,.7h-4.9Z","key":15})]),React.createElement("g",{"className":"across-america","key":1},[React.createElement("path",{"d":"M0,142.75H10.5v2.05H2.35v2.53H9.68v2.06H2.35v2.93h8.31v2.05H0Z","key":0}),React.createElement("path",{"d":"M24.93,142.75v11.62H22.88l-7.33-8.23v8.23H13.38V142.75h2.14L22.77,151v-8.29Z","key":1}),React.createElement("path",{"d":"M37.55,144.82H32.82v-2.07H44.64v2.07H39.89v9.55H37.55Z","key":2}),React.createElement("path",{"d":"M48.69,153.77a5.06,5.06,0,0,1-2.19-2.1,6.39,6.39,0,0,1-.73-3.07v-.1a6.42,6.42,0,0,1,.73-3.07,5,5,0,0,1,2.19-2.09,7.74,7.74,0,0,1,3.61-.76,7.86,7.86,0,0,1,3.63.76,5.09,5.09,0,0,1,2.21,2.09,6.41,6.41,0,0,1,.72,3.07v.1a6.4,6.4,0,0,1-.72,3.06,5.13,5.13,0,0,1-2.21,2.11,7.73,7.73,0,0,1-3.63.77A7.62,7.62,0,0,1,48.69,153.77Zm6.72-2.31a3.68,3.68,0,0,0,1.1-2.86v-.08a3.68,3.68,0,0,0-1.11-2.85,4.45,4.45,0,0,0-3.1-1,4.39,4.39,0,0,0-3.07,1,3.65,3.65,0,0,0-1.12,2.84v.08a3.62,3.62,0,0,0,1.12,2.85,4.39,4.39,0,0,0,3.07,1A4.46,4.46,0,0,0,55.41,151.46Z","key":3}),React.createElement("path",{"d":"M61.54,142.75h5.53a8.2,8.2,0,0,1,3.66.74,5.08,5.08,0,0,1,2.21,2,5.88,5.88,0,0,1,.74,3v.16a5.9,5.9,0,0,1-.74,3,5.06,5.06,0,0,1-2.21,2,8.2,8.2,0,0,1-3.66.74H61.54Zm5.52,9.54a4.75,4.75,0,0,0,3.16-.94,3.36,3.36,0,0,0,1.12-2.74v-.08a3.37,3.37,0,0,0-1.13-2.74,4.71,4.71,0,0,0-3.15-1H63.89v7.46Z","key":4}),React.createElement("path",{"d":"M78.69,153.77a5.06,5.06,0,0,1-2.19-2.1,6.39,6.39,0,0,1-.73-3.07v-.1a6.42,6.42,0,0,1,.73-3.07,5,5,0,0,1,2.19-2.09,7.74,7.74,0,0,1,3.61-.76,7.86,7.86,0,0,1,3.63.76,5.09,5.09,0,0,1,2.21,2.09,6.41,6.41,0,0,1,.72,3.07v.1a6.4,6.4,0,0,1-.72,3.06,5.13,5.13,0,0,1-2.21,2.11,7.73,7.73,0,0,1-3.63.77A7.62,7.62,0,0,1,78.69,153.77Zm6.72-2.31a3.68,3.68,0,0,0,1.1-2.86v-.08a3.68,3.68,0,0,0-1.11-2.85,4.45,4.45,0,0,0-3.1-1,4.39,4.39,0,0,0-3.07,1,3.65,3.65,0,0,0-1.12,2.84v.08a3.62,3.62,0,0,0,1.12,2.85,4.39,4.39,0,0,0,3.07,1A4.46,4.46,0,0,0,85.41,151.46Z","key":5}),React.createElement("path",{"d":"M92.36,153.67A3.16,3.16,0,0,1,91,151.09v-.32h2.38l0,.21a1.54,1.54,0,0,0,.83,1.24,5.28,5.28,0,0,0,2.3.37c2.09,0,3.14-.52,3.14-1.55a.9.9,0,0,0-.36-.77,2.24,2.24,0,0,0-.88-.41q-.54-.13-1.53-.3l-.5-.08a22.19,22.19,0,0,1-2.66-.55,4,4,0,0,1-1.7-1,2.71,2.71,0,0,1-.73-2,2.75,2.75,0,0,1,1.38-2.48,7.29,7.29,0,0,1,3.84-.85c3.29,0,5,1.14,5.15,3.42l0,.25H99.31l0-.09a1.67,1.67,0,0,0-.8-1.26,4.12,4.12,0,0,0-2-.39q-2.76,0-2.76,1.35a1,1,0,0,0,.31.77,1.79,1.79,0,0,0,.78.39c.32.08.8.17,1.43.27l.64.09.35.05a20.75,20.75,0,0,1,2.49.52,3.66,3.66,0,0,1,1.66,1,2.87,2.87,0,0,1,.7,2,2.92,2.92,0,0,1-1.48,2.65,8,8,0,0,1-4.07.89A7.55,7.55,0,0,1,92.36,153.67Z","key":6}),React.createElement("path",{"d":"M110.54,142.75h2.35v9.55h7.56v2.07h-9.91Z","key":7}),React.createElement("path",{"d":"M124.51,153.77a5.06,5.06,0,0,1-2.19-2.1,6.38,6.38,0,0,1-.72-3.07v-.1a6.41,6.41,0,0,1,.72-3.07,5,5,0,0,1,2.19-2.09,9,9,0,0,1,7.24,0,5,5,0,0,1,2.21,2.09,6.42,6.42,0,0,1,.73,3.07v.1a6.41,6.41,0,0,1-.73,3.06,5.08,5.08,0,0,1-2.21,2.11,8.89,8.89,0,0,1-7.24,0Zm6.72-2.31a3.65,3.65,0,0,0,1.1-2.86v-.08a3.68,3.68,0,0,0-1.11-2.85,5.2,5.2,0,0,0-6.17,0,3.69,3.69,0,0,0-1.12,2.84v.08a3.65,3.65,0,0,0,1.12,2.85,4.4,4.4,0,0,0,3.08,1A4.45,4.45,0,0,0,131.23,151.46Z","key":8}),React.createElement("path",{"d":"M138.18,153.67a3.16,3.16,0,0,1-1.37-2.58v-.32h2.38l0,.21a1.53,1.53,0,0,0,.84,1.24,5.2,5.2,0,0,0,2.29.37c2.09,0,3.14-.52,3.14-1.55a.92.92,0,0,0-.35-.77,2.29,2.29,0,0,0-.89-.41q-.54-.13-1.53-.3l-.49-.08a22.86,22.86,0,0,1-2.67-.55,3.94,3.94,0,0,1-1.69-1,2.68,2.68,0,0,1-.73-2,2.76,2.76,0,0,1,1.37-2.48,7.29,7.29,0,0,1,3.84-.85q4.93,0,5.16,3.42v.25h-2.37l0-.09a1.64,1.64,0,0,0-.8-1.26,4.09,4.09,0,0,0-2-.39c-1.83,0-2.75.45-2.75,1.35a1,1,0,0,0,.3.77,1.83,1.83,0,0,0,.79.39c.32.08.79.17,1.42.27l.64.09.35.05a20.33,20.33,0,0,1,2.49.52,3.61,3.61,0,0,1,1.66,1,2.82,2.82,0,0,1,.7,2,2.9,2.9,0,0,1-1.48,2.65,7.93,7.93,0,0,1-4.07.89A7.55,7.55,0,0,1,138.18,153.67Z","key":9}),React.createElement("path",{"d":"M156.37,142.75h10.49v2.05h-8.14v2.53h7.33v2.06h-7.33v2.93H167v2.05H156.37Z","key":10}),React.createElement("path",{"d":"M170.57,153.67a3.14,3.14,0,0,1-1.37-2.58l0-.32h2.39V151a1.57,1.57,0,0,0,.84,1.24,5.25,5.25,0,0,0,2.3.37c2.09,0,3.13-.52,3.13-1.55a.89.89,0,0,0-.35-.77,2.22,2.22,0,0,0-.89-.41c-.35-.09-.86-.19-1.52-.3l-.5-.08a22.19,22.19,0,0,1-2.66-.55,4,4,0,0,1-1.7-1,2.68,2.68,0,0,1-.73-2,2.75,2.75,0,0,1,1.38-2.48,7.29,7.29,0,0,1,3.84-.85q4.92,0,5.15,3.42l0,.25h-2.37l0-.09a1.69,1.69,0,0,0-.8-1.26,4.13,4.13,0,0,0-2-.39c-1.83,0-2.75.45-2.75,1.35a1,1,0,0,0,.31.77,1.79,1.79,0,0,0,.78.39c.32.08.79.17,1.42.27l.64.09.36.05a20.12,20.12,0,0,1,2.48.52,3.69,3.69,0,0,1,1.67,1,2.86,2.86,0,0,1,.69,2,2.9,2.9,0,0,1-1.48,2.65,7.9,7.9,0,0,1-4.07.89A7.49,7.49,0,0,1,170.57,153.67Z","key":11}),React.createElement("path",{"d":"M186.27,144.82h-4.74v-2.07h11.83v2.07h-4.75v9.55h-2.34Z","key":12}),React.createElement("path",{"d":"M202.45,152h-6.1l-1.06,2.39h-2.48l5.32-11.62h2.54L206,154.37H203.5Zm-.87-2-2.17-5-2.2,5Z","key":13}),React.createElement("path",{"d":"M207.89,142.75h5.53a8.2,8.2,0,0,1,3.66.74,5.08,5.08,0,0,1,2.21,2,5.88,5.88,0,0,1,.74,3v.16a5.9,5.9,0,0,1-.74,3,5.06,5.06,0,0,1-2.21,2,8.2,8.2,0,0,1-3.66.74h-5.53Zm5.52,9.54a4.75,4.75,0,0,0,3.16-.94,3.36,3.36,0,0,0,1.12-2.74v-.08a3.4,3.4,0,0,0-1.12-2.74,4.75,4.75,0,0,0-3.16-1h-3.17v7.46Z","key":14}),React.createElement("path",{"d":"M225,153.77a5.06,5.06,0,0,1-2.19-2.1,6.38,6.38,0,0,1-.72-3.07v-.1a6.41,6.41,0,0,1,.72-3.07,5,5,0,0,1,2.19-2.09,7.74,7.74,0,0,1,3.61-.76,7.86,7.86,0,0,1,3.63.76,5.09,5.09,0,0,1,2.21,2.09,6.41,6.41,0,0,1,.72,3.07v.1a6.4,6.4,0,0,1-.72,3.06,5.13,5.13,0,0,1-2.21,2.11,7.73,7.73,0,0,1-3.63.77A7.62,7.62,0,0,1,225,153.77Zm6.72-2.31a3.68,3.68,0,0,0,1.1-2.86v-.08a3.68,3.68,0,0,0-1.11-2.85,4.45,4.45,0,0,0-3.1-1,4.39,4.39,0,0,0-3.07,1,3.65,3.65,0,0,0-1.12,2.84v.08a3.62,3.62,0,0,0,1.12,2.85,4.39,4.39,0,0,0,3.07,1A4.46,4.46,0,0,0,231.76,151.46Z","key":15}),React.createElement("path",{"d":"M238.71,153.67a3.16,3.16,0,0,1-1.37-2.58v-.32h2.38l0,.21a1.53,1.53,0,0,0,.84,1.24,5.2,5.2,0,0,0,2.29.37c2.09,0,3.14-.52,3.14-1.55a.92.92,0,0,0-.35-.77,2.36,2.36,0,0,0-.89-.41q-.54-.13-1.53-.3l-.5-.08a22.62,22.62,0,0,1-2.66-.55,4,4,0,0,1-1.7-1,2.71,2.71,0,0,1-.72-2,2.74,2.74,0,0,1,1.37-2.48,7.29,7.29,0,0,1,3.84-.85c3.29,0,5,1.14,5.15,3.42l0,.25h-2.37l0-.09a1.67,1.67,0,0,0-.8-1.26,4.09,4.09,0,0,0-2-.39c-1.84,0-2.75.45-2.75,1.35a1,1,0,0,0,.3.77,1.79,1.79,0,0,0,.78.39c.32.08.8.17,1.43.27l.64.09.35.05A20.75,20.75,0,0,1,246,148a3.66,3.66,0,0,1,1.66,1,2.82,2.82,0,0,1,.7,2,2.92,2.92,0,0,1-1.48,2.65,8,8,0,0,1-4.07.89A7.55,7.55,0,0,1,238.71,153.67Z","key":16}),React.createElement("path",{"d":"M258.21,153.13a5.25,5.25,0,0,1-1.49-4v-6.37h2.33v6.32a3.23,3.23,0,0,0,.94,2.59,4.92,4.92,0,0,0,5.38,0,3.23,3.23,0,0,0,.93-2.59v-6.32h2.34v6.37a5.26,5.26,0,0,1-1.5,4,7.77,7.77,0,0,1-8.93,0Z","key":17}),React.createElement("path",{"d":"M283.29,142.75v11.62h-2l-7.33-8.23v8.23h-2.18V142.75h2.15l7.24,8.29v-8.29Z","key":18}),React.createElement("path",{"d":"M286.57,142.75h2.36v11.62h-2.36Z","key":19}),React.createElement("path",{"d":"M292.2,142.75h5.54a8.2,8.2,0,0,1,3.66.74,5.08,5.08,0,0,1,2.21,2,5.88,5.88,0,0,1,.74,3v.16a5.9,5.9,0,0,1-.74,3,5.06,5.06,0,0,1-2.21,2,8.2,8.2,0,0,1-3.66.74H292.2Zm5.53,9.54a4.75,4.75,0,0,0,3.16-.94,3.36,3.36,0,0,0,1.12-2.74v-.08a3.4,3.4,0,0,0-1.12-2.74,4.75,4.75,0,0,0-3.16-1h-3.17v7.46Z","key":20}),React.createElement("path",{"d":"M309.36,153.77a5.14,5.14,0,0,1-2.2-2.1,6.5,6.5,0,0,1-.72-3.07v-.1a6.53,6.53,0,0,1,.72-3.07,5.06,5.06,0,0,1,2.2-2.09,7.74,7.74,0,0,1,3.61-.76,7.86,7.86,0,0,1,3.63.76,5.09,5.09,0,0,1,2.21,2.09,6.41,6.41,0,0,1,.72,3.07v.1a6.4,6.4,0,0,1-.72,3.06,5.13,5.13,0,0,1-2.21,2.11,7.73,7.73,0,0,1-3.63.77A7.62,7.62,0,0,1,309.36,153.77Zm6.72-2.31a3.68,3.68,0,0,0,1.1-2.86v-.08a3.68,3.68,0,0,0-1.11-2.85,4.45,4.45,0,0,0-3.1-1,4.39,4.39,0,0,0-3.07,1,3.65,3.65,0,0,0-1.12,2.84v.08a3.62,3.62,0,0,0,1.12,2.85,4.39,4.39,0,0,0,3.07,1A4.46,4.46,0,0,0,316.08,151.46Z","key":21}),React.createElement("path",{"d":"M323,153.67a3.16,3.16,0,0,1-1.37-2.58v-.32H324l0,.21a1.53,1.53,0,0,0,.84,1.24,5.17,5.17,0,0,0,2.29.37c2.09,0,3.14-.52,3.14-1.55a.92.92,0,0,0-.35-.77,2.36,2.36,0,0,0-.89-.41q-.54-.13-1.53-.3l-.5-.08a22.19,22.19,0,0,1-2.66-.55,4,4,0,0,1-1.7-1,2.71,2.71,0,0,1-.72-2,2.74,2.74,0,0,1,1.37-2.48,7.29,7.29,0,0,1,3.84-.85c3.29,0,5,1.14,5.15,3.42l0,.25H330l0-.09a1.67,1.67,0,0,0-.8-1.26,4.12,4.12,0,0,0-2-.39q-2.76,0-2.76,1.35a1,1,0,0,0,.31.77,1.79,1.79,0,0,0,.78.39c.32.08.8.17,1.43.27l.64.09.35.05a20.75,20.75,0,0,1,2.49.52,3.66,3.66,0,0,1,1.66,1,2.87,2.87,0,0,1,.7,2,2.92,2.92,0,0,1-1.48,2.65,8,8,0,0,1-4.08.89A7.53,7.53,0,0,1,323,153.67Z","key":22})])])]);
	}
	
	P4paaLogoEs.defaultProps = {"className":"p4paa-logo","viewBox":"0 0 333.61 154.54"};
	
	module.exports = P4paaLogoEs;
	
	P4paaLogoEs.default = P4paaLogoEs;


/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function P4paaLogo (props) {
	    return React.createElement("svg",props,[React.createElement("g",{"key":0},[React.createElement("path",{"fill":"#016492","d":"M12.6,34.8h17.2c5.5,0,9.9-0.6,13.3-1.9c3.3-1.2,5.8-3.1,7.3-5.7c1.5-2.5,2.3-5.8,2.3-9.8\n\t\tc0-5.8-1.8-10-5.3-12.7C43.9,2.1,38,0.8,29.9,0.8H2.1v52.3h10.6V34.8z M12.6,10.2h17.7c4.2,0,7.2,0.5,9,1.5c1.8,1,2.7,3,2.7,5.9\n\t\tc0,3-0.9,5.1-2.7,6.2c-1.8,1.1-4.8,1.6-9,1.6H12.6V10.2z","key":0}),React.createElement("path",{"fill":"#016492","d":"M102.6,53.1h11.2L89.9,0.8H78.5L54.6,53.1h11.2l4.8-10.7h27.4L102.6,53.1z M74.4,33.5l9.9-22.4L94,33.5H74.4z\n\t\t","key":1}),React.createElement("polygon",{"fill":"#016492","points":"170.3,0.8 159.2,0.8 140.7,42.6 122.3,0.8 111.1,0.8 135,53.1 146.4,53.1 \t\t","key":2}),React.createElement("rect",{"x":"181.3","y":"0.8","fill":"#016492","width":"10.6","height":"52.3","key":3}),React.createElement("polygon",{"fill":"#016492","points":"260.8,53.1 260.8,0.8 251,0.8 251,38.1 218.4,0.8 208.8,0.8 208.8,53.1 218.6,53.1 218.6,16.1\n\t\t251.5,53.1 \t\t","key":4}),React.createElement("path",{"fill":"#016492","d":"M287.5,50.4c4.3,2.3,9.6,3.5,15.8,3.5c9.1,0,16.2-2.1,21.2-6.4c5.1-4.3,7.6-10.6,7.6-19v-4.2h-28v8.7h17.1\n\t\tc-0.4,3.8-2.2,6.7-5.3,8.7c-3.1,2-7.3,3-12.7,3c-5.6,0-10-1.5-13.3-4.6c-3.3-3.1-4.9-7.4-4.9-13v-0.4c0-5.5,1.7-9.8,5-12.9\n\t\tc3.3-3.1,7.7-4.7,13.2-4.7c4.3,0,7.9,0.7,10.6,2.1c2.8,1.4,4.7,3.3,5.9,5.8l0.4,0.7h10.9l-0.2-0.7c-1.4-5.3-4.4-9.5-9-12.5\n\t\tC317.3,1.5,311.1,0,303.3,0c-6.2,0-11.4,1.1-15.7,3.4c-4.3,2.3-7.5,5.4-9.7,9.4c-2.2,4-3.3,8.6-3.3,13.7v0.7\n\t\tc0,5.1,1.1,9.7,3.2,13.7S283.2,48.1,287.5,50.4z","key":5}),React.createElement("path",{"fill":"#016492","d":"M125,69.4c-3.5-2.7-9.4-4.1-17.5-4.1H79.7v52.3h10.6V99.3h17.2c5.5,0,9.9-0.6,13.3-1.9\n\t\tc3.3-1.2,5.8-3.1,7.3-5.7c1.5-2.5,2.3-5.8,2.3-9.8C130.3,76.3,128.5,72.1,125,69.4z M117,88.3c-1.8,1.1-4.8,1.6-9,1.6H90.3V74.7\n\t\tH108c4.2,0,7.2,0.5,9,1.5c1.8,1,2.7,3,2.7,5.9C119.7,85.2,118.8,87.2,117,88.3z","key":6}),React.createElement("rect",{"x":"139.7","y":"65.3","fill":"#016492","width":"10.6","height":"52.3","key":7}),React.createElement("polygon",{"fill":"#016492","points":"209.8,72.9 209.8,65.3 164.7,65.3 164.7,74.4 195.7,74.4 163,110 163,117.6 211.2,117.6 211.2,108.4\n\t\t177,108.4 \t\t","key":8}),React.createElement("polygon",{"fill":"#016492","points":"267.2,72.9 267.2,65.3 222.1,65.3 222.1,74.4 253.1,74.4 220.4,110 220.4,117.6 268.5,117.6\n\t\t268.5,108.4 234.4,108.4 \t\t","key":9}),React.createElement("path",{"fill":"#016492","d":"M311.1,65.3h-11.4l-23.9,52.3h11.2l4.8-10.7h27.4l4.8,10.7H335L311.1,65.3z M295.5,98l9.9-22.4l9.8,22.4\n\t\tH295.5z","key":10}),React.createElement("path",{"fill":"#016492","d":"M66.5,65.2H2.6c-0.3,0-0.5,0.2-0.5,0.5V74c0,0.3,0.2,0.5,0.5,0.5h63.9c0.3,0,0.5-0.2,0.5-0.5v-8.4\n\t\tC67.1,65.4,66.8,65.2,66.5,65.2z","key":11}),React.createElement("path",{"fill":"#016492","d":"M66.5,108.3H2.6c-0.3,0-0.5,0.2-0.5,0.5v8.4c0,0.3,0.2,0.5,0.5,0.5h63.9c0.3,0,0.5-0.2,0.5-0.5v-8.4\n\t\tC67.1,108.5,66.8,108.3,66.5,108.3z","key":12}),React.createElement("path",{"fill":"#016492","d":"M21.2,86.4c0.3,0,0.6-0.2,0.7-0.6l0.7-3c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.3-0.3-0.6-0.3H6.6\n\t\tc-0.3,0-0.6,0.2-0.7,0.6L2.1,99.7c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.3,0.3,0.6,0.3h3.5c0.3,0,0.6-0.2,0.7-0.6l1.4-6.3h10\n\t\tc0.3,0,0.6-0.2,0.7-0.6l0.7-3.1c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.3-0.3-0.6-0.3H9.3l0.6-2.8H21.2z","key":13}),React.createElement("path",{"fill":"#016492","d":"M27.8,99.9c1.4,0.7,3.1,1.1,5.1,1.1c2.2,0,4.2-0.5,5.9-1.4c1.7-0.9,3.1-2.2,4-3.8c1-1.6,1.4-3.5,1.4-5.5\n\t\tc0-1.7-0.4-3.2-1.2-4.5c-0.8-1.3-1.9-2.3-3.4-3.1c-1.4-0.7-3.1-1.1-5-1.1c-2.3,0-4.3,0.5-6,1.5c-1.7,1-3,2.3-3.9,3.9\n\t\tc-0.9,1.6-1.3,3.4-1.3,5.2c0,1.7,0.4,3.2,1.1,4.5C25.2,98.1,26.3,99.1,27.8,99.9z M34.4,85.9c1.6,0,2.7,0.4,3.6,1.2\n\t\tc0.9,0.8,1.3,1.9,1.3,3.4c0,1.1-0.3,2.2-0.8,3.1c-0.5,0.9-1.2,1.6-2.1,2.1c-0.9,0.5-2,0.8-3.2,0.8c-1.6,0-2.8-0.4-3.6-1.2\n\t\tc-0.8-0.8-1.2-1.9-1.2-3.3c0-1.1,0.2-2.1,0.7-3c0.5-0.9,1.1-1.6,2.1-2.2C31.9,86.2,33.1,85.9,34.4,85.9z","key":14}),React.createElement("path",{"fill":"#016492","d":"M66.5,87.4c0-2.5-1.2-5.5-7.2-5.5h-8.9c-0.3,0-0.6,0.2-0.7,0.6l-3.8,17.2c0,0.2,0,0.4,0.1,0.6\n\t\tc0.1,0.2,0.3,0.3,0.6,0.3h3.5c0.3,0,0.6-0.2,0.7-0.6l1.2-5.5h3.9l2.9,5.7c0.1,0.2,0.4,0.4,0.6,0.4h3.9c0.3,0,0.5-0.1,0.6-0.4\n\t\tc0.1-0.2,0.1-0.5,0-0.7L61,94.1c1.6-0.4,2.8-1.1,3.8-2C65.9,90.9,66.5,89.3,66.5,87.4z M53.8,86.4h5.4c1.2,0,1.8,0.2,2.1,0.4\n\t\tc0.2,0.1,0.4,0.4,0.4,1c0,0.7-0.3,1.2-0.8,1.6h0c-0.6,0.5-1.6,0.7-3,0.7H53L53.8,86.4z","key":15})]),React.createElement("g",{"className":"across-america","key":1},[React.createElement("path",{"d":"M14.7,158.1H5.4l-1.6,3.6H0L8.1,144H12l8.1,17.7h-3.8L14.7,158.1z M13.4,155.1l-3.3-7.6l-3.3,7.6H13.4z","key":0}),React.createElement("path",{"d":"M30.6,160.9c-1.5-0.8-2.6-1.8-3.3-3.2c-0.7-1.4-1.1-2.9-1.1-4.7v-0.2c0-1.7,0.4-3.3,1.1-4.6c0.7-1.4,1.8-2.4,3.3-3.2\n\t\tc1.5-0.8,3.3-1.2,5.4-1.2c2.7,0,4.9,0.5,6.5,1.6c1.6,1.1,2.5,2.5,2.9,4.4l0,0.3h-3.7l-0.1-0.2c-0.3-0.9-1-1.6-1.9-2.1\n\t\tc-1-0.5-2.2-0.8-3.7-0.8c-1.9,0-3.4,0.5-4.5,1.6c-1.1,1-1.6,2.5-1.6,4.3v0.1c0,1.9,0.5,3.3,1.6,4.4c1.1,1,2.6,1.5,4.5,1.5\n\t\tc1.6,0,2.9-0.3,3.8-0.9c1-0.6,1.6-1.4,1.9-2.5l0.1-0.2h3.7l0,0.3c-0.1,1.3-0.6,2.4-1.3,3.4s-1.8,1.8-3.2,2.3\n\t\tc-1.4,0.6-3,0.8-4.9,0.8C33.8,162,32,161.6,30.6,160.9z","key":1}),React.createElement("path",{"d":"M66.8,161.8l-4.6-6.2h-5.1v6.2h-3.6V144h9.6c2.8,0,4.7,0.5,5.9,1.4c1.2,0.9,1.8,2.4,1.8,4.3c0,1.6-0.4,2.9-1.1,3.8\n\t\tc-0.7,0.9-2,1.5-3.6,1.8l5,6.4H66.8z M57.1,152.4h6.2c1.4,0,2.4-0.2,3-0.5c0.6-0.4,0.9-1.1,0.9-2.1c0-1-0.3-1.6-0.9-2\n\t\tc-0.6-0.3-1.6-0.5-3-0.5h-6.2V152.4z","key":2}),React.createElement("path",{"d":"M83,160.8c-1.5-0.8-2.6-1.9-3.3-3.2c-0.7-1.4-1.1-2.9-1.1-4.7v-0.1c0-1.8,0.4-3.3,1.1-4.7c0.7-1.4,1.8-2.4,3.3-3.2\n\t\tc1.5-0.8,3.3-1.2,5.5-1.2c2.2,0,4,0.4,5.5,1.2c1.5,0.8,2.6,1.8,3.4,3.2c0.7,1.4,1.1,2.9,1.1,4.7v0.1c0,1.7-0.4,3.3-1.1,4.7\n\t\tc-0.7,1.4-1.9,2.4-3.4,3.2c-1.5,0.8-3.3,1.2-5.5,1.2C86.4,162,84.5,161.6,83,160.8z M93.3,157.3c1.1-1,1.7-2.5,1.7-4.4v-0.1\n\t\tc0-1.9-0.6-3.3-1.7-4.3c-1.1-1-2.7-1.6-4.7-1.6c-2,0-3.5,0.5-4.7,1.6c-1.1,1-1.7,2.5-1.7,4.3v0.1c0,1.9,0.6,3.3,1.7,4.4\n\t\tc1.1,1,2.7,1.5,4.7,1.5C90.6,158.8,92.2,158.3,93.3,157.3z","key":3}),React.createElement("path",{"d":"M108.5,160.7c-1.3-0.9-2-2.2-2.1-3.9l0-0.5h3.6l0,0.3c0.1,0.9,0.6,1.5,1.3,1.9c0.7,0.4,1.9,0.6,3.5,0.6\n\t\tc3.2,0,4.8-0.8,4.8-2.4c0-0.5-0.2-0.9-0.5-1.2c-0.4-0.3-0.8-0.5-1.4-0.6c-0.5-0.1-1.3-0.3-2.3-0.5l-0.8-0.1\n\t\tc-1.7-0.3-3.1-0.6-4.1-0.8c-1-0.3-1.8-0.8-2.6-1.5c-0.7-0.7-1.1-1.8-1.1-3.1c0-1.6,0.7-2.9,2.1-3.8c1.4-0.9,3.3-1.3,5.9-1.3\n\t\tc5,0,7.6,1.7,7.9,5.2l0,0.4h-3.6l0-0.1c-0.1-0.9-0.6-1.5-1.2-1.9c-0.7-0.4-1.7-0.6-3.1-0.6c-2.8,0-4.2,0.7-4.2,2.1\n\t\tc0,0.5,0.2,0.9,0.5,1.2c0.3,0.3,0.7,0.5,1.2,0.6c0.5,0.1,1.2,0.3,2.2,0.4l1,0.1l0.5,0.1c1.5,0.2,2.8,0.5,3.8,0.8\n\t\tc1,0.3,1.8,0.8,2.5,1.5c0.7,0.7,1.1,1.8,1.1,3.1c0,1.8-0.8,3.1-2.3,4c-1.5,0.9-3.6,1.4-6.2,1.4C111.9,162,109.8,161.6,108.5,160.7\n\t\tz","key":4}),React.createElement("path",{"d":"M133.2,160.7c-1.3-0.9-2-2.2-2.1-3.9l0-0.5h3.6l0,0.3c0.1,0.9,0.6,1.5,1.3,1.9c0.7,0.4,1.9,0.6,3.5,0.6\n\t\tc3.2,0,4.8-0.8,4.8-2.4c0-0.5-0.2-0.9-0.5-1.2c-0.4-0.3-0.8-0.5-1.4-0.6c-0.5-0.1-1.3-0.3-2.3-0.5l-0.8-0.1\n\t\tc-1.7-0.3-3.1-0.6-4.1-0.8c-1-0.3-1.8-0.8-2.6-1.5c-0.7-0.7-1.1-1.8-1.1-3.1c0-1.6,0.7-2.9,2.1-3.8c1.4-0.9,3.3-1.3,5.9-1.3\n\t\tc5,0,7.6,1.7,7.9,5.2l0,0.4h-3.6l0-0.1c-0.1-0.9-0.6-1.5-1.2-1.9c-0.7-0.4-1.7-0.6-3.1-0.6c-2.8,0-4.2,0.7-4.2,2.1\n\t\tc0,0.5,0.2,0.9,0.5,1.2c0.3,0.3,0.7,0.5,1.2,0.6c0.5,0.1,1.2,0.3,2.2,0.4l1,0.1l0.5,0.1c1.5,0.2,2.8,0.5,3.8,0.8\n\t\tc1,0.3,1.8,0.8,2.5,1.5c0.7,0.7,1.1,1.8,1.1,3.1c0,1.8-0.8,3.1-2.3,4s-3.6,1.4-6.2,1.4C136.6,162,134.5,161.6,133.2,160.7z","key":5}),React.createElement("path",{"d":"M182.7,158.1h-9.3l-1.6,3.6H168l8.1-17.7h3.9l8.1,17.7h-3.8L182.7,158.1z M181.4,155.1l-3.3-7.6l-3.3,7.6H181.4z","key":6}),React.createElement("path",{"d":"M216.8,144v17.7h-3.2v-12.5l-5.8,12.5h-3.1l-5.8-12.6v12.6h-3.2V144h4.3l6.3,13.8l6.3-13.8H216.8z","key":7}),React.createElement("path",{"d":"M226.4,144h16v3.1H230v3.9h11.2v3.1H230v4.5h12.7v3.1h-16.2V144z","key":8}),React.createElement("path",{"d":"M264.7,161.8l-4.6-6.2H255v6.2h-3.6V144h9.6c2.8,0,4.7,0.5,5.9,1.4c1.2,0.9,1.8,2.4,1.8,4.3c0,1.6-0.4,2.9-1.1,3.8\n\t\tc-0.7,0.9-2,1.5-3.6,1.8l5,6.4H264.7z M255,152.4h6.2c1.4,0,2.4-0.2,3-0.5c0.6-0.4,0.9-1.1,0.9-2.1c0-1-0.3-1.6-0.9-2\n\t\tc-0.6-0.3-1.6-0.5-3-0.5H255V152.4z","key":9}),React.createElement("path",{"d":"M277.5,144h3.6v17.7h-3.6V144z","key":10}),React.createElement("path",{"d":"M294.1,160.9c-1.5-0.8-2.6-1.8-3.3-3.2c-0.7-1.4-1.1-2.9-1.1-4.7v-0.2c0-1.7,0.4-3.3,1.1-4.6c0.7-1.4,1.8-2.4,3.3-3.2\n\t\tc1.5-0.8,3.3-1.2,5.4-1.2c2.7,0,4.9,0.5,6.5,1.6c1.6,1.1,2.5,2.5,2.9,4.4l0,0.3h-3.7l-0.1-0.2c-0.3-0.9-1-1.6-1.9-2.1\n\t\tc-1-0.5-2.2-0.8-3.7-0.8c-1.9,0-3.4,0.5-4.5,1.6c-1.1,1-1.6,2.5-1.6,4.3v0.1c0,1.9,0.5,3.3,1.6,4.4c1.1,1,2.6,1.5,4.5,1.5\n\t\tc1.6,0,2.9-0.3,3.8-0.9c1-0.6,1.6-1.4,1.9-2.5l0.1-0.2h3.7l0,0.3c-0.1,1.3-0.6,2.4-1.3,3.4s-1.8,1.8-3.2,2.3\n\t\tc-1.4,0.6-3,0.8-4.9,0.8C297.4,162,295.6,161.6,294.1,160.9z","key":11}),React.createElement("path",{"d":"M329.6,158.1h-9.3l-1.6,3.6h-3.8L323,144h3.9l8.1,17.7h-3.8L329.6,158.1z M328.3,155.1l-3.3-7.6l-3.3,7.6H328.3z","key":12})])]);
	}
	
	P4paaLogo.defaultProps = {"className":"p4paa-logo","viewBox":"0 0 335 162"};
	
	module.exports = P4paaLogo;
	
	P4paaLogo.default = P4paaLogo;


/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Surveyor (props) {
	    return React.createElement("svg",props,[React.createElement("desc",{"key":0},"Created with Sketch."),React.createElement("defs",{"key":1}),React.createElement("g",{"id":"Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","opacity":"0.0399999991","strokeLinecap":"round","strokeLinejoin":"round","key":2},React.createElement("g",{"id":"dominos-homepage-desktop-state3-copy-2","transform":"translate(-66.000000, -3582.000000)","stroke":"#000000","strokeWidth":"3"},React.createElement("g",{"id":"MAP-LINES-Copy-5","transform":"translate(608.935587, 4109.409869) rotate(190.000000) translate(-608.935587, -4109.409869) translate(87.935587, 3545.909869)"},[React.createElement("path",{"d":"M860.348252,51.3613535 C661.976583,-94.6928546 284.373884,89.1314902 182.900847,371.187228 C139.278151,492.41395 85.4010465,610.211422 31.4755724,727.400479 C-61.9335202,930.389901 61.1332012,1106.76807 287.428095,1125.42844 C522.491752,1144.79402 621.919436,964.177684 769.551132,847.202955 C890.123351,751.681775 1037.0295,680.573252 1040.91982,499.514431 C1044.80322,318.462524 1008.09742,160.136305 860.348252,51.3613535 Z","id":"Stroke-1","key":0}),React.createElement("path",{"d":"M791.974565,373.638736 C786.230015,341.328265 733.570482,239.314151 617.348495,281.2776 C491.030441,326.883421 429.178249,436.473115 450.294473,571.656358 C460.762934,638.603985 533.980097,631.734721 584.791442,622.441825 C677.876613,605.414083 761.638096,569.156555 785.085242,461.353424 C787.340306,450.959507 797.719116,405.956131 791.974565,373.638736 Z","id":"Stroke-3","key":1}),React.createElement("path",{"d":"M647.25103,175.54231 C459.972561,228.756842 265.640809,493.296855 268.966916,724.36722 C271.30418,886.779241 384.640742,843.478574 466.182215,801.323938 C612.406434,725.72727 800.632256,701.287799 867.569286,516.935485 C926.609406,354.364676 834.5295,122.327779 647.25103,175.54231 Z","id":"Stroke-5","key":2}),React.createElement("path",{"d":"M648.058216,91.8959048 C272.555587,184.798757 259.902705,425.269059 152.699301,715.481587 C109.32096,840.338375 138.523644,938.377916 201.822658,969.474584 C293.272257,1014.38431 390.044649,1016.92155 473.873448,961.27524 C611.899216,869.658288 748.201479,773.706607 874.979473,667.391675 C1013.48284,551.238912 963.023591,399.385127 915.381479,262.187843 C874.84796,145.454351 782.020942,65.5833392 648.058216,91.8959048 Z","id":"Stroke-7","key":3})])))]);
	}
	
	Surveyor.defaultProps = {"width":"1114px","height":"1061px","version":"1.1"};
	
	module.exports = Surveyor;
	
	Surveyor.default = Surveyor;


/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/home-hero.942cc750.mp4";

/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/home-hero.73cdd899.webm";

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  'bp-small': '480px',
	  'bp-mobile': '740px',
	  'bp-tablet': '1080px',
	  'bp-desktop': '1280px',
	  'bp-desktop-l': '1440px'
	};

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  'peacock-blue': '#006491',
	  'dark-blue': '#005781',
	  'light-navy': '#143b62',
	  'half-lipstick': '#f499a9',
	  'lipstick': '#e11d38',
	  'dark-red': '#9d2235',
	  'rouge': '#a71e22',
	  'white': '#ffffff',
	  'white-two': '#f6f5f5',
	  'black': '#000000',
	  'grey-brown': '#555555',
	  'medium-grey': '#767676',
	  'light-grey': '#a6a6a6',
	  'faint-grey': '#DDDDDD'
	};

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    // for the container
	    'container-gutters-mobile': '20px',
	    'container-gutters-tablet': '60px',
	    'container-gutters-desktop': '80px',
	    'container-gutters-desktop-l': '100px',
	    // for columns
	    'column-gutters-mobile': '10px',
	    'column-gutters-tablet': '10px',
	    'column-gutters-desktop': '15px',
	    'column-gutters-desktop-l': '15px',
	    // for rows (negative values to fix margins on columns for first and last)
	    'row-gutters-mobile': '-10px',
	    'row-gutters-tablet': '-10px',
	    'row-gutters-desktop': '-15px',
	    'row-gutters-desktop-l': '-15px'
	};

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    'mobile': '40',
	    'tablet': '90',
	    'desktop': '90',
	    'desktop-l': '100'
	};

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    'h1-mobile': '30px',
	    'h1-tablet': '30px',
	    'h1-desktop': '40px',
	    'h1-desktop-l': '40px'
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-f391f142d2d5246cf334.js